var fC = Object.defineProperty, hC = Object.defineProperties;
var mC = Object.getOwnPropertyDescriptors;
var os = Object.getOwnPropertySymbols;
var Cp = Object.prototype.hasOwnProperty, Sp = Object.prototype.propertyIsEnumerable;
var Nn = Math.pow, Rl = (e, t, n) => t in e ? fC(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, C = (e, t) => {
  for (var n in t || (t = {}))
    Cp.call(t, n) && Rl(e, n, t[n]);
  if (os)
    for (var n of os(t))
      Sp.call(t, n) && Rl(e, n, t[n]);
  return e;
}, L = (e, t) => hC(e, mC(t));
var is = (e) => typeof e == "symbol" ? e : e + "", re = (e, t) => {
  var n = {};
  for (var r in e)
    Cp.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && os)
    for (var r of os(e))
      t.indexOf(r) < 0 && Sp.call(e, r) && (n[r] = e[r]);
  return n;
};
var I = (e, t, n) => (Rl(e, typeof t != "symbol" ? t + "" : t, n), n);
var Ol = (e, t, n) => new Promise((r, o) => {
  var i = (u) => {
    try {
      a(n.next(u));
    } catch (l) {
      o(l);
    }
  }, s = (u) => {
    try {
      a(n.throw(u));
    } catch (l) {
      o(l);
    }
  }, a = (u) => u.done ? r(u.value) : Promise.resolve(u.value).then(i, s);
  a((n = n.apply(e, t)).next());
});
import * as E from "react";
import Ht, { Children as gC, isValidElement as fi, cloneElement as qs, createElement as yC, useMemo as wd, forwardRef as Bi, createContext as vC, useContext as bC, useState as Wt, useLayoutEffect as Ma, useEffect as or, version as CC, useRef as _t, useImperativeHandle as SC, Component as ey, useCallback as wC } from "react";
import { jsx as O, jsxs as fe, Fragment as xo } from "react/jsx-runtime";
import ty from "@emotion/styled";
import { Global as _C, ThemeContext as ny, keyframes as Fi, css as er, CacheProvider as ry } from "@emotion/react";
import oy from "@emotion/cache";
import { serializeStyles as xC } from "@emotion/serialize";
import * as TC from "react-dom";
import ri, { createPortal as EC } from "react-dom";
const RC = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
let OC = class yu {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || RC, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, o) {
    return o && !this.debug ? null : (typeof t[0] == "string" && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new yu(this.logger, C({
      prefix: `${this.prefix}:${t}:`
    }, this.options));
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new yu(this.logger, t);
  }
};
var Cn = new OC();
let ka = class {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] = this.observers[r] || [], this.observers[r].push(n);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t] = this.observers[t].filter((r) => r !== n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    this.observers[t] && [].concat(this.observers[t]).forEach((s) => {
      s(...r);
    }), this.observers["*"] && [].concat(this.observers["*"]).forEach((s) => {
      s.apply(s, [t, ...r]);
    });
  }
};
function Bo() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function wp(e) {
  return e == null ? "" : "" + e;
}
function PC(e, t, n) {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}
function _d(e, t, n) {
  function r(s) {
    return s && s.indexOf("###") > -1 ? s.replace(/###/g, ".") : s;
  }
  function o() {
    return !e || typeof e == "string";
  }
  const i = typeof t != "string" ? [].concat(t) : t.split(".");
  for (; i.length > 1; ) {
    if (o())
      return {};
    const s = r(i.shift());
    !e[s] && n && (e[s] = new n()), Object.prototype.hasOwnProperty.call(e, s) ? e = e[s] : e = {};
  }
  return o() ? {} : {
    obj: e,
    k: r(i.shift())
  };
}
function _p(e, t, n) {
  const {
    obj: r,
    k: o
  } = _d(e, t, Object);
  r[o] = n;
}
function IC(e, t, n, r) {
  const {
    obj: o,
    k: i
  } = _d(e, t, Object);
  o[i] = o[i] || [], r && (o[i] = o[i].concat(n)), r || o[i].push(n);
}
function ra(e, t) {
  const {
    obj: n,
    k: r
  } = _d(e, t);
  if (n)
    return n[r];
}
function NC(e, t, n) {
  const r = ra(e, n);
  return r !== void 0 ? r : ra(t, n);
}
function iy(e, t, n) {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : iy(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function Fr(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var MC = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function kC(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (t) => MC[t]) : e;
}
const AC = [" ", ",", "?", "!", ";"];
function $C(e, t, n) {
  t = t || "", n = n || "";
  const r = AC.filter((s) => t.indexOf(s) < 0 && n.indexOf(s) < 0);
  if (r.length === 0)
    return !0;
  const o = new RegExp(`(${r.map((s) => s === "?" ? "\\?" : s).join("|")})`);
  let i = !o.test(e);
  if (!i) {
    const s = e.indexOf(n);
    s > 0 && !o.test(e.substring(0, s)) && (i = !0);
  }
  return i;
}
function oa(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let o = e;
  for (let i = 0; i < r.length; ++i) {
    if (!o || typeof o[r[i]] == "string" && i + 1 < r.length)
      return;
    if (o[r[i]] === void 0) {
      let s = 2, a = r.slice(i, i + s).join(n), u = o[a];
      for (; u === void 0 && r.length > i + s; )
        s++, a = r.slice(i, i + s).join(n), u = o[a];
      if (u === void 0)
        return;
      if (u === null)
        return null;
      if (t.endsWith(a)) {
        if (typeof u == "string")
          return u;
        if (a && typeof u[a] == "string")
          return u[a];
      }
      const l = r.slice(i + s).join(n);
      return l ? oa(u, l, n) : void 0;
    }
    o = o[r[i]];
  }
  return o;
}
function ia(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class xp extends ka {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, s = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let a = [t, n];
    r && typeof r != "string" && (a = a.concat(r)), r && typeof r == "string" && (a = a.concat(i ? r.split(i) : r)), t.indexOf(".") > -1 && (a = t.split("."));
    const u = ra(this.data, a);
    return u || !s || typeof r != "string" ? u : oa(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, o) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let a = [t, n];
    r && (a = a.concat(s ? r.split(s) : r)), t.indexOf(".") > -1 && (a = t.split("."), o = n, n = a[1]), this.addNamespaces(n), _p(this.data, a, o), i.silent || this.emit("added", t, n, r, o);
  }
  addResources(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (typeof r[i] == "string" || Object.prototype.toString.apply(r[i]) === "[object Array]") && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    o.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, o, i) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1
    }, a = [t, n];
    t.indexOf(".") > -1 && (a = t.split("."), o = r, r = n, n = a[1]), this.addNamespaces(n);
    let u = ra(this.data, a) || {};
    o ? iy(u, r, i) : u = C(C({}, u), r), _p(this.data, a, u), s.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? C({}, this.getResource(t, n)) : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((o) => n[o] && Object.keys(n[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var sy = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, o) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, o));
    }), t;
  }
};
const Tp = {};
class sa extends ka {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), PC(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Cn.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const o = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const s = r && t.indexOf(r) > -1, a = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !$C(t, r, o);
    if (s && !a) {
      const u = t.match(this.interpolator.nestingRegexp);
      if (u && u.length > 0)
        return {
          key: t,
          namespaces: i
        };
      const l = t.split(r);
      (r !== o || r === o && this.options.ns.indexOf(l[0]) > -1) && (i = l.shift()), t = l.join(o);
    }
    return typeof i == "string" && (i = [i]), {
      key: t,
      namespaces: i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = C({}, n)), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const o = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: a
    } = this.extractFromKey(t[t.length - 1], n), u = a[a.length - 1], l = n.lng || this.language, d = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (l && l.toLowerCase() === "cimode") {
      if (d) {
        const b = n.nsSeparator || this.options.nsSeparator;
        return o ? {
          res: `${u}${b}${s}`,
          usedKey: s,
          exactUsedKey: s,
          usedLng: l,
          usedNS: u
        } : `${u}${b}${s}`;
      }
      return o ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: l,
        usedNS: u
      } : s;
    }
    const p = this.resolve(t, n);
    let f = p && p.res;
    const h = p && p.usedKey || s, g = p && p.exactUsedKey || s, m = Object.prototype.toString.apply(f), v = ["[object Number]", "[object Function]", "[object RegExp]"], S = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, _ = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (_ && f && (typeof f != "string" && typeof f != "boolean" && typeof f != "number") && v.indexOf(m) < 0 && !(typeof S == "string" && m === "[object Array]")) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const b = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, f, L(C({}, n), {
          ns: a
        })) : `key '${s} (${this.language})' returned an object instead of string.`;
        return o ? (p.res = b, p) : b;
      }
      if (i) {
        const b = m === "[object Array]", y = b ? [] : {}, w = b ? g : h;
        for (const x in f)
          if (Object.prototype.hasOwnProperty.call(f, x)) {
            const P = `${w}${i}${x}`;
            y[x] = this.translate(P, L(C({}, n), {
              joinArrays: !1,
              ns: a
            })), y[x] === P && (y[x] = f[x]);
          }
        f = y;
      }
    } else if (_ && typeof S == "string" && m === "[object Array]")
      f = f.join(S), f && (f = this.extendTranslation(f, t, n, r));
    else {
      let b = !1, y = !1;
      const w = n.count !== void 0 && typeof n.count != "string", x = sa.hasDefaultValue(n), P = w ? this.pluralResolver.getSuffix(l, n.count, n) : "", N = n.ordinal && w ? this.pluralResolver.getSuffix(l, n.count, {
        ordinal: !1
      }) : "", M = n[`defaultValue${P}`] || n[`defaultValue${N}`] || n.defaultValue;
      !this.isValidLookup(f) && x && (b = !0, f = M), this.isValidLookup(f) || (y = !0, f = s);
      const T = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && y ? void 0 : f, D = x && M !== f && this.options.updateMissing;
      if (y || b || D) {
        if (this.logger.log(D ? "updateKey" : "missingKey", l, u, s, D ? M : f), i) {
          const H = this.resolve(s, L(C({}, n), {
            keySeparator: !1
          }));
          H && H.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let j = [];
        const F = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && F && F[0])
          for (let H = 0; H < F.length; H++)
            j.push(F[H]);
        else
          this.options.saveMissingTo === "all" ? j = this.languageUtils.toResolveHierarchy(n.lng || this.language) : j.push(n.lng || this.language);
        const z = (H, ee, X) => {
          const k = x && X !== f ? X : T;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(H, u, ee, k, D, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(H, u, ee, k, D, n), this.emit("missingKey", H, u, ee, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && w ? j.forEach((H) => {
          this.pluralResolver.getSuffixes(H, n).forEach((ee) => {
            z([H], s + ee, n[`defaultValue${ee}`] || M);
          });
        }) : z(j, s, M));
      }
      f = this.extendTranslation(f, t, n, p, r), y && f === s && this.options.appendNamespaceToMissingKey && (f = `${u}:${s}`), (y || b) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${u}:${s}` : s, b ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
    }
    return o ? (p.res = f, p) : f;
  }
  extendTranslation(t, n, r, o, i) {
    var s = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, C(C({}, this.options.interpolation.defaultVariables), r), o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init(L(C({}, r), {
        interpolation: C(C({}, this.options.interpolation), r.interpolation)
      }));
      const l = typeof t == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (l) {
        const f = t.match(this.interpolator.nestingRegexp);
        d = f && f.length;
      }
      let p = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (p = C(C({}, this.options.interpolation.defaultVariables), p)), t = this.interpolator.interpolate(t, p, r.lng || this.language, r), l) {
        const f = t.match(this.interpolator.nestingRegexp), h = f && f.length;
        d < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && o && o.res && (r.lng = o.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var f = arguments.length, h = new Array(f), g = 0; g < f; g++)
          h[g] = arguments[g];
        return i && i[0] === h[0] && !r.context ? (s.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : s.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const a = r.postProcess || this.options.postProcess, u = typeof a == "string" ? [a] : a;
    return t != null && u && u.length && r.applyPostProcessor !== !1 && (t = sy.handle(u, t, n, this.options && this.options.postProcessPassResolved ? C({
      i18nResolved: o
    }, r) : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, o, i, s, a;
    return typeof t == "string" && (t = [t]), t.forEach((u) => {
      if (this.isValidLookup(r))
        return;
      const l = this.extractFromKey(u, n), d = l.key;
      o = d;
      let p = l.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const f = n.count !== void 0 && typeof n.count != "string", h = f && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), g = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", m = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      p.forEach((v) => {
        this.isValidLookup(r) || (a = v, !Tp[`${m[0]}-${v}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(a) && (Tp[`${m[0]}-${v}`] = !0, this.logger.warn(`key "${o}" for languages "${m.join(", ")}" won't get resolved as namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((S) => {
          if (this.isValidLookup(r))
            return;
          s = S;
          const _ = [d];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, d, S, v, n);
          else {
            let b;
            f && (b = this.pluralResolver.getSuffix(S, n.count, n));
            const y = `${this.options.pluralSeparator}zero`, w = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (_.push(d + b), n.ordinal && b.indexOf(w) === 0 && _.push(d + b.replace(w, this.options.pluralSeparator)), h && _.push(d + y)), g) {
              const x = `${d}${this.options.contextSeparator}${n.context}`;
              _.push(x), f && (_.push(x + b), n.ordinal && b.indexOf(w) === 0 && _.push(x + b.replace(w, this.options.pluralSeparator)), h && _.push(x + y));
            }
          }
          let R;
          for (; R = _.pop(); )
            this.isValidLookup(r) || (i = R, r = this.getResource(S, v, R, n));
        }));
      });
    }), {
      res: r,
      usedKey: o,
      exactUsedKey: i,
      usedLng: s,
      usedNS: a
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, o) : this.resourceStore.getResource(t, n, r, o);
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
function Pl(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class Ep {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Cn.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = ia(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = ia(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (typeof t == "string" && t.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((o) => o.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Pl(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Pl(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = Pl(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const o = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (n = o);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const o = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(o))
        return n = o;
      n = this.options.supportedLngs.find((i) => {
        if (i === o)
          return i;
        if (!(i.indexOf("-") < 0 && o.indexOf("-") < 0) && i.indexOf(o) === 0)
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), typeof t == "string" && (t = [t]), Object.prototype.toString.apply(t) === "[object Array]")
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), o = [], i = (s) => {
      s && (this.isSupportedCode(s) ? o.push(s) : this.logger.warn(`rejecting language code not found in supportedLngs: ${s}`));
    };
    return typeof t == "string" && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : typeof t == "string" && i(this.formatLanguageCode(t)), r.forEach((s) => {
      o.indexOf(s) < 0 && i(this.formatLanguageCode(s));
    }), o;
  }
}
let LC = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], DC = {
  1: function(e) {
    return +(e > 1);
  },
  2: function(e) {
    return +(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  5: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
  },
  6: function(e) {
    return e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2;
  },
  7: function(e) {
    return e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  8: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3;
  },
  9: function(e) {
    return +(e >= 2);
  },
  10: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
  },
  11: function(e) {
    return e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3;
  },
  12: function(e) {
    return +(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return +(e !== 0);
  },
  14: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3;
  },
  15: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  16: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2;
  },
  17: function(e) {
    return e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1;
  },
  18: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : 2;
  },
  19: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3;
  },
  20: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2;
  },
  21: function(e) {
    return e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0;
  },
  22: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3;
  }
};
const BC = ["v1", "v2", "v3"], FC = ["v4"], Rp = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function zC() {
  const e = {};
  return LC.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: DC[t.fc]
      };
    });
  }), e;
}
class jC {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = Cn.create("pluralResolver"), (!this.options.compatibilityJSON || FC.includes(this.options.compatibilityJSON)) && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = zC();
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(ia(t), {
          type: n.ordinal ? "ordinal" : "cardinal"
        });
      } catch (r) {
        return;
      }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((o) => `${n}${o}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((o, i) => Rp[o] - Rp[i]).map((o) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : r.numbers.map((o) => this.getSuffix(t, o, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const o = this.getRule(t, r);
    return o ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(n)}` : this.getSuffixRetroCompatible(o, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let o = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
    const i = () => this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
    return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? `_plural_${o.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !BC.includes(this.options.compatibilityJSON);
  }
}
function Op(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = NC(e, t, n);
  return !i && o && typeof n == "string" && (i = oa(e, n, r), i === void 0 && (i = oa(t, n, r))), i;
}
class HC {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Cn.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const n = t.interpolation;
    this.escape = n.escape !== void 0 ? n.escape : kC, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? Fr(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? Fr(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? Fr(n.nestingPrefix) : n.nestingPrefixEscaped || Fr("$t("), this.nestingSuffix = n.nestingSuffix ? Fr(n.nestingSuffix) : n.nestingSuffixEscaped || Fr(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = `${this.prefix}(.+?)${this.suffix}`;
    this.regexp = new RegExp(t, "g");
    const n = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
    this.regexpUnescape = new RegExp(n, "g");
    const r = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(r, "g");
  }
  interpolate(t, n, r, o) {
    let i, s, a;
    const u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function l(g) {
      return g.replace(/\$/g, "$$$$");
    }
    const d = (g) => {
      if (g.indexOf(this.formatSeparator) < 0) {
        const _ = Op(n, u, g, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(_, void 0, r, L(C(C({}, o), n), {
          interpolationkey: g
        })) : _;
      }
      const m = g.split(this.formatSeparator), v = m.shift().trim(), S = m.join(this.formatSeparator).trim();
      return this.format(Op(n, u, v, this.options.keySeparator, this.options.ignoreJSONStructure), S, r, L(C(C({}, o), n), {
        interpolationkey: v
      }));
    };
    this.resetRegExp();
    const p = o && o.missingInterpolationHandler || this.options.missingInterpolationHandler, f = o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (g) => l(g)
    }, {
      regex: this.regexp,
      safeValue: (g) => this.escapeValue ? l(this.escape(g)) : l(g)
    }].forEach((g) => {
      for (a = 0; i = g.regex.exec(t); ) {
        const m = i[1].trim();
        if (s = d(m), s === void 0)
          if (typeof p == "function") {
            const S = p(t, i, o);
            s = typeof S == "string" ? S : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, m))
            s = "";
          else if (f) {
            s = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), s = "";
        else
          typeof s != "string" && !this.useRawValueToEscape && (s = wp(s));
        const v = g.safeValue(s);
        if (t = t.replace(i[0], v), f ? (g.regex.lastIndex += s.length, g.regex.lastIndex -= i[0].length) : g.regex.lastIndex = 0, a++, a >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, i, s;
    function a(u, l) {
      const d = this.nestingOptionsSeparator;
      if (u.indexOf(d) < 0)
        return u;
      const p = u.split(new RegExp(`${d}[ ]*{`));
      let f = `{${p[1]}`;
      u = p[0], f = this.interpolate(f, s);
      const h = f.match(/'/g), g = f.match(/"/g);
      (h && h.length % 2 === 0 && !g || g.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        s = JSON.parse(f), l && (s = C(C({}, l), s));
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${u}`, m), `${u}${d}${f}`;
      }
      return delete s.defaultValue, u;
    }
    for (; o = this.nestingRegexp.exec(t); ) {
      let u = [];
      s = C({}, r), s = s.replace && typeof s.replace != "string" ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
      let l = !1;
      if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
        const d = o[1].split(this.formatSeparator).map((p) => p.trim());
        o[1] = d.shift(), u = d, l = !0;
      }
      if (i = n(a.call(this, o[1].trim(), s), s), i && o[0] === t && typeof i != "string")
        return i;
      typeof i != "string" && (i = wp(i)), i || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${t}`), i = ""), l && (i = u.reduce((d, p) => this.format(d, p, r.lng, L(C({}, r), {
        interpolationkey: o[1].trim()
      })), i.trim())), t = t.replace(o[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
function WC(e) {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const o = r[1].substring(0, r[1].length - 1);
    t === "currency" && o.indexOf(":") < 0 ? n.currency || (n.currency = o.trim()) : t === "relativetime" && o.indexOf(":") < 0 ? n.range || (n.range = o.trim()) : o.split(";").forEach((s) => {
      if (!s)
        return;
      const [a, ...u] = s.split(":"), l = u.join(":").trim().replace(/^'+|'+$/g, "");
      n[a.trim()] || (n[a.trim()] = l), l === "false" && (n[a.trim()] = !1), l === "true" && (n[a.trim()] = !0), isNaN(l) || (n[a.trim()] = parseInt(l, 10));
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}
function zr(e) {
  const t = {};
  return function(r, o, i) {
    const s = o + JSON.stringify(i);
    let a = t[s];
    return a || (a = e(ia(o), i), t[s] = a), a(r);
  };
}
class VC {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Cn.create("formatter"), this.options = t, this.formats = {
      number: zr((n, r) => {
        const o = new Intl.NumberFormat(n, C({}, r));
        return (i) => o.format(i);
      }),
      currency: zr((n, r) => {
        const o = new Intl.NumberFormat(n, L(C({}, r), {
          style: "currency"
        }));
        return (i) => o.format(i);
      }),
      datetime: zr((n, r) => {
        const o = new Intl.DateTimeFormat(n, C({}, r));
        return (i) => o.format(i);
      }),
      relativetime: zr((n, r) => {
        const o = new Intl.RelativeTimeFormat(n, C({}, r));
        return (i) => o.format(i, r.range || "day");
      }),
      list: zr((n, r) => {
        const o = new Intl.ListFormat(n, C({}, r));
        return (i) => o.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = zr(n);
  }
  format(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return n.split(this.formatSeparator).reduce((a, u) => {
      const {
        formatName: l,
        formatOptions: d
      } = WC(u);
      if (this.formats[l]) {
        let p = a;
        try {
          const f = o && o.formatParams && o.formatParams[o.interpolationkey] || {}, h = f.locale || f.lng || o.locale || o.lng || r;
          p = this.formats[l](a, h, C(C(C({}, d), o), f));
        } catch (f) {
          this.logger.warn(f);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return a;
    }, t);
  }
}
function UC(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
class qC extends ka {
  constructor(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = o, this.logger = Cn.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, o.backend, o);
  }
  queueLoad(t, n, r, o) {
    const i = {}, s = {}, a = {}, u = {};
    return t.forEach((l) => {
      let d = !0;
      n.forEach((p) => {
        const f = `${l}|${p}`;
        !r.reload && this.store.hasResourceBundle(l, p) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? s[f] === void 0 && (s[f] = !0) : (this.state[f] = 1, d = !1, s[f] === void 0 && (s[f] = !0), i[f] === void 0 && (i[f] = !0), u[p] === void 0 && (u[p] = !0)));
      }), d || (a[l] = !0);
    }), (Object.keys(i).length || Object.keys(s).length) && this.queue.push({
      pending: s,
      pendingCount: Object.keys(s).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(s),
      toLoadLanguages: Object.keys(a),
      toLoadNamespaces: Object.keys(u)
    };
  }
  loaded(t, n, r) {
    const o = t.split("|"), i = o[0], s = o[1];
    n && this.emit("failedLoading", i, s, n), r && this.store.addResourceBundle(i, s, r), this.state[t] = n ? -1 : 2;
    const a = {};
    this.queue.forEach((u) => {
      IC(u.loaded, [i], s), UC(u, t), n && u.errors.push(n), u.pendingCount === 0 && !u.done && (Object.keys(u.loaded).forEach((l) => {
        a[l] || (a[l] = {});
        const d = u.loaded[l];
        d.length && d.forEach((p) => {
          a[l][p] === void 0 && (a[l][p] = !0);
        });
      }), u.done = !0, u.errors.length ? u.callback(u.errors) : u.callback());
    }), this.emit("loaded", a), this.queue = this.queue.filter((u) => !u.done);
  }
  read(t, n, r) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, s = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return s(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: o,
        wait: i,
        callback: s
      });
      return;
    }
    this.readingCalls++;
    const a = (l, d) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (l && d && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, o + 1, i * 2, s);
        }, i);
        return;
      }
      s(l, d);
    }, u = this.backend[r].bind(this.backend);
    if (u.length === 2) {
      try {
        const l = u(t, n);
        l && typeof l.then == "function" ? l.then((d) => a(null, d)).catch(a) : a(null, l);
      } catch (l) {
        a(l);
      }
      return;
    }
    return u(t, n, a);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    typeof t == "string" && (t = this.languageUtils.toResolveHierarchy(t)), typeof n == "string" && (n = [n]);
    const i = this.queueLoad(t, n, r, o);
    if (!i.toLoad.length)
      return i.pending.length || o(), null;
    i.toLoad.forEach((s) => {
      this.loadOne(s);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), o = r[0], i = r[1];
    this.read(o, i, "read", void 0, void 0, (s, a) => {
      s && this.logger.warn(`${n}loading namespace ${i} for language ${o} failed`, s), !s && a && this.logger.log(`${n}loaded namespace ${i} for language ${o}`, a), this.loaded(t, s, a);
    });
  }
  saveMissing(t, n, r, o, i) {
    let s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const u = L(C({}, s), {
          isUpdate: i
        }), l = this.backend.create.bind(this.backend);
        if (l.length < 6)
          try {
            let d;
            l.length === 5 ? d = l(t, n, r, o, u) : d = l(t, n, r, o), d && typeof d.then == "function" ? d.then((p) => a(null, p)).catch(a) : a(null, d);
          } catch (d) {
            a(d);
          }
        else
          l(t, n, r, o, a, u);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, o);
    }
  }
}
function Pp() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      let n = {};
      if (typeof t[1] == "object" && (n = t[1]), typeof t[1] == "string" && (n.defaultValue = t[1]), typeof t[2] == "string" && (n.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
        const r = t[3] || t[2];
        Object.keys(r).forEach((o) => {
          n[o] = r[o];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: (e, t, n, r) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function Ip(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function ss() {
}
function GC(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
}
class wi extends ka {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Ip(t), this.services = {}, this.logger = Cn, this.modules = {
      external: []
    }, GC(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const o = Pp();
    this.options = C(C(C({}, o), this.options), Ip(n)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = C(C({}, o.interpolation), this.options.interpolation)), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    function i(d) {
      return d ? typeof d == "function" ? new d() : d : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? Cn.init(i(this.modules.logger), this.options) : Cn.init(null, this.options);
      let d;
      this.modules.formatter ? d = this.modules.formatter : typeof Intl != "undefined" && (d = VC);
      const p = new Ep(this.options);
      this.store = new xp(this.options.resources, this.options);
      const f = this.services;
      f.logger = Cn, f.resourceStore = this.store, f.languageUtils = p, f.pluralResolver = new jC(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), d && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (f.formatter = i(d), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new HC(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new qC(i(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(h) {
        for (var g = arguments.length, m = new Array(g > 1 ? g - 1 : 0), v = 1; v < g; v++)
          m[v - 1] = arguments[v];
        t.emit(h, ...m);
      }), this.modules.languageDetector && (f.languageDetector = i(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = i(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new sa(this.services, this.options), this.translator.on("*", function(h) {
        for (var g = arguments.length, m = new Array(g > 1 ? g - 1 : 0), v = 1; v < g; v++)
          m[v - 1] = arguments[v];
        t.emit(h, ...m);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = ss), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((d) => {
      this[d] = function() {
        return t.store[d](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((d) => {
      this[d] = function() {
        return t.store[d](...arguments), t;
      };
    });
    const u = Bo(), l = () => {
      const d = (p, f) => {
        this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), u.resolve(f), r(p, f);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return d(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, d);
    };
    return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), u;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ss;
    const o = typeof t == "string" ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (o && o.toLowerCase() === "cimode")
        return r();
      const i = [], s = (a) => {
        if (!a)
          return;
        this.services.languageUtils.toResolveHierarchy(a).forEach((l) => {
          i.indexOf(l) < 0 && i.push(l);
        });
      };
      o ? s(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((u) => s(u)), this.options.preload && this.options.preload.forEach((a) => s(a)), this.services.backendConnector.load(i, this.options.ns, (a) => {
        !a && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(a);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const o = Bo();
    return t || (t = this.languages), n || (n = this.options.ns), r || (r = ss), this.services.backendConnector.reload(t, n, (i) => {
      o.resolve(), r(i);
    }), o;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && sy.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const o = Bo();
    this.emit("languageChanging", t);
    const i = (u) => {
      this.language = u, this.languages = this.services.languageUtils.toResolveHierarchy(u), this.resolvedLanguage = void 0, this.setResolvedLanguage(u);
    }, s = (u, l) => {
      l ? (i(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve(function() {
        return r.t(...arguments);
      }), n && n(u, function() {
        return r.t(...arguments);
      });
    }, a = (u) => {
      !t && !u && this.services.languageDetector && (u = []);
      const l = typeof u == "string" ? u : this.services.languageUtils.getBestMatchFromCodes(u);
      l && (this.language || i(l), this.translator.language || this.translator.changeLanguage(l), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(l)), this.loadResources(l, (d) => {
        s(d, l);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? a(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(a) : this.services.languageDetector.detect(a) : a(t), o;
  }
  getFixedT(t, n, r) {
    var o = this;
    const i = function(s, a) {
      let u;
      if (typeof a != "object") {
        for (var l = arguments.length, d = new Array(l > 2 ? l - 2 : 0), p = 2; p < l; p++)
          d[p - 2] = arguments[p];
        u = o.options.overloadTranslationOptionHandler([s, a].concat(d));
      } else
        u = C({}, a);
      u.lng = u.lng || i.lng, u.lngs = u.lngs || i.lngs, u.ns = u.ns || i.ns, u.keyPrefix = u.keyPrefix || r || i.keyPrefix;
      const f = o.options.keySeparator || ".";
      let h;
      return u.keyPrefix && Array.isArray(s) ? h = s.map((g) => `${u.keyPrefix}${f}${g}`) : h = u.keyPrefix ? `${u.keyPrefix}${f}${s}` : s, o.t(h, u);
    };
    return typeof t == "string" ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const s = (a, u) => {
      const l = this.services.backendConnector.state[`${a}|${u}`];
      return l === -1 || l === 2;
    };
    if (n.precheck) {
      const a = n.precheck(this, s);
      if (a !== void 0)
        return a;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || s(r, t) && (!o || s(i, t)));
  }
  loadNamespaces(t, n) {
    const r = Bo();
    return this.options.ns ? (typeof t == "string" && (t = [t]), t.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Bo();
    typeof t == "string" && (t = [t]);
    const o = this.options.preload || [], i = t.filter((s) => o.indexOf(s) < 0);
    return i.length ? (this.options.preload = o.concat(i), this.loadResources((s) => {
      r.resolve(), n && n(s);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Ep(Pp());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new wi(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ss;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const o = L(C(C({}, this.options), t), {
      isClone: !0
    }), i = new wi(o);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((a) => {
      i[a] = this[a];
    }), i.services = C({}, this.services), i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new xp(this.store.data, o), i.services.resourceStore = i.store), i.translator = new sa(i.services, o), i.translator.on("*", function(a) {
      for (var u = arguments.length, l = new Array(u > 1 ? u - 1 : 0), d = 1; d < u; d++)
        l[d - 1] = arguments[d];
      i.emit(a, ...l);
    }), i.init(o, n), i.translator.options = o, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ay = wi.createInstance();
ay.createInstance = wi.createInstance;
const KC = {
  error: "Error"
}, YC = {
  error: "Помилка"
}, Np = "common", XC = {
  en: KC,
  uk: YC
}, gn = ay.createInstance({
  defaultNS: Np,
  resources: JC(XC, Np),
  lng: "en",
  fallbackLng: "en"
}), ly = {
  i18nextInstance: gn,
  initPromise: gn.init().then(() => gn)
}, Gs = /* @__PURE__ */ new Map();
Gs.set("common", ly);
const cy = (e) => {
  if (Gs.has(e.namespace))
    return Gs.get(e.namespace);
  if (e.plugins)
    for (const i of e.plugins)
      gn.use(i);
  Object.keys(e.resource).forEach((i) => {
    gn.addResourceBundle(i, e.namespace, e.resource[i]);
  });
  const t = gn.cloneInstance({
    defaultNS: e.namespace
  });
  let n = ly.initPromise.then(() => t);
  t.on("languageChanged", (i) => {
    gn.language !== i && gn.changeLanguage(i);
  }), gn.on("languageChanged", (i) => {
    t.language !== i && t.changeLanguage(i);
  });
  const r = e.language || "en";
  gn.language !== r && (n = n.then(() => t.changeLanguage(r)).then(() => t));
  const o = { initPromise: n, i18nextInstance: t };
  return Gs.set(e.namespace, o), o;
};
function JC(e, t) {
  return Object.keys(e).reduce((n, r) => (n[r] = {
    [t]: e[r]
  }, n), {});
}
function QC(e) {
  return e && e.replace(new RegExp("(?<!\\\\)'", "g"), "\\'");
}
function ZC(e, t) {
  if (typeof e != "string")
    throw new Error("URL must be a string");
  if (!e.trim())
    throw new Error("URL cannot be empty");
  try {
    const n = new URL(e);
    return n.origin + (n.pathname.endsWith("/") ? n.pathname : n.pathname + "/") + (t && n.search ? n.search : "");
  } catch (n) {
    throw new Error(`Connection string ${e} is not a valid URL`);
  }
}
var uy = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Pr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function eS(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var as = { exports: {} }, Mp;
function tS() {
  if (Mp)
    return as.exports;
  Mp = 1;
  var e = typeof Reflect == "object" ? Reflect : null, t = e && typeof e.apply == "function" ? e.apply : function(y, w, x) {
    return Function.prototype.apply.call(y, w, x);
  }, n;
  e && typeof e.ownKeys == "function" ? n = e.ownKeys : Object.getOwnPropertySymbols ? n = function(y) {
    return Object.getOwnPropertyNames(y).concat(Object.getOwnPropertySymbols(y));
  } : n = function(y) {
    return Object.getOwnPropertyNames(y);
  };
  function r(b) {
    console && console.warn && console.warn(b);
  }
  var o = Number.isNaN || function(y) {
    return y !== y;
  };
  function i() {
    i.init.call(this);
  }
  as.exports = i, as.exports.once = S, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var s = 10;
  function a(b) {
    if (typeof b != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof b);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(b) {
      if (typeof b != "number" || b < 0 || o(b))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + b + ".");
      s = b;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(y) {
    if (typeof y != "number" || y < 0 || o(y))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + y + ".");
    return this._maxListeners = y, this;
  };
  function u(b) {
    return b._maxListeners === void 0 ? i.defaultMaxListeners : b._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return u(this);
  }, i.prototype.emit = function(y) {
    for (var w = [], x = 1; x < arguments.length; x++)
      w.push(arguments[x]);
    var P = y === "error", N = this._events;
    if (N !== void 0)
      P = P && N.error === void 0;
    else if (!P)
      return !1;
    if (P) {
      var M;
      if (w.length > 0 && (M = w[0]), M instanceof Error)
        throw M;
      var A = new Error("Unhandled error." + (M ? " (" + M.message + ")" : ""));
      throw A.context = M, A;
    }
    var T = N[y];
    if (T === void 0)
      return !1;
    if (typeof T == "function")
      t(T, this, w);
    else
      for (var D = T.length, j = g(T, D), x = 0; x < D; ++x)
        t(j[x], this, w);
    return !0;
  };
  function l(b, y, w, x) {
    var P, N, M;
    if (a(w), N = b._events, N === void 0 ? (N = b._events = /* @__PURE__ */ Object.create(null), b._eventsCount = 0) : (N.newListener !== void 0 && (b.emit(
      "newListener",
      y,
      w.listener ? w.listener : w
    ), N = b._events), M = N[y]), M === void 0)
      M = N[y] = w, ++b._eventsCount;
    else if (typeof M == "function" ? M = N[y] = x ? [w, M] : [M, w] : x ? M.unshift(w) : M.push(w), P = u(b), P > 0 && M.length > P && !M.warned) {
      M.warned = !0;
      var A = new Error("Possible EventEmitter memory leak detected. " + M.length + " " + String(y) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      A.name = "MaxListenersExceededWarning", A.emitter = b, A.type = y, A.count = M.length, r(A);
    }
    return b;
  }
  i.prototype.addListener = function(y, w) {
    return l(this, y, w, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(y, w) {
    return l(this, y, w, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function p(b, y, w) {
    var x = { fired: !1, wrapFn: void 0, target: b, type: y, listener: w }, P = d.bind(x);
    return P.listener = w, x.wrapFn = P, P;
  }
  i.prototype.once = function(y, w) {
    return a(w), this.on(y, p(this, y, w)), this;
  }, i.prototype.prependOnceListener = function(y, w) {
    return a(w), this.prependListener(y, p(this, y, w)), this;
  }, i.prototype.removeListener = function(y, w) {
    var x, P, N, M, A;
    if (a(w), P = this._events, P === void 0)
      return this;
    if (x = P[y], x === void 0)
      return this;
    if (x === w || x.listener === w)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete P[y], P.removeListener && this.emit("removeListener", y, x.listener || w));
    else if (typeof x != "function") {
      for (N = -1, M = x.length - 1; M >= 0; M--)
        if (x[M] === w || x[M].listener === w) {
          A = x[M].listener, N = M;
          break;
        }
      if (N < 0)
        return this;
      N === 0 ? x.shift() : m(x, N), x.length === 1 && (P[y] = x[0]), P.removeListener !== void 0 && this.emit("removeListener", y, A || w);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(y) {
    var w, x, P;
    if (x = this._events, x === void 0)
      return this;
    if (x.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : x[y] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete x[y]), this;
    if (arguments.length === 0) {
      var N = Object.keys(x), M;
      for (P = 0; P < N.length; ++P)
        M = N[P], M !== "removeListener" && this.removeAllListeners(M);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (w = x[y], typeof w == "function")
      this.removeListener(y, w);
    else if (w !== void 0)
      for (P = w.length - 1; P >= 0; P--)
        this.removeListener(y, w[P]);
    return this;
  };
  function f(b, y, w) {
    var x = b._events;
    if (x === void 0)
      return [];
    var P = x[y];
    return P === void 0 ? [] : typeof P == "function" ? w ? [P.listener || P] : [P] : w ? v(P) : g(P, P.length);
  }
  i.prototype.listeners = function(y) {
    return f(this, y, !0);
  }, i.prototype.rawListeners = function(y) {
    return f(this, y, !1);
  }, i.listenerCount = function(b, y) {
    return typeof b.listenerCount == "function" ? b.listenerCount(y) : h.call(b, y);
  }, i.prototype.listenerCount = h;
  function h(b) {
    var y = this._events;
    if (y !== void 0) {
      var w = y[b];
      if (typeof w == "function")
        return 1;
      if (w !== void 0)
        return w.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function g(b, y) {
    for (var w = new Array(y), x = 0; x < y; ++x)
      w[x] = b[x];
    return w;
  }
  function m(b, y) {
    for (; y + 1 < b.length; y++)
      b[y] = b[y + 1];
    b.pop();
  }
  function v(b) {
    for (var y = new Array(b.length), w = 0; w < y.length; ++w)
      y[w] = b[w].listener || b[w];
    return y;
  }
  function S(b, y) {
    return new Promise(function(w, x) {
      function P(M) {
        b.removeListener(y, N), x(M);
      }
      function N() {
        typeof b.removeListener == "function" && b.removeListener("error", P), w([].slice.call(arguments));
      }
      R(b, y, N, { once: !0 }), y !== "error" && _(b, P, { once: !0 });
    });
  }
  function _(b, y, w) {
    typeof b.on == "function" && R(b, "error", y, w);
  }
  function R(b, y, w, x) {
    if (typeof b.on == "function")
      x.once ? b.once(y, w) : b.on(y, w);
    else if (typeof b.addEventListener == "function")
      b.addEventListener(y, function P(N) {
        x.once && b.removeEventListener(y, P), w(N);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof b);
  }
  return as.exports;
}
var nS = tS();
const zi = /* @__PURE__ */ Pr(nS);
function rS() {
  this.__data__ = [], this.size = 0;
}
function dy(e, t) {
  return e === t || e !== e && t !== t;
}
function Aa(e, t) {
  for (var n = e.length; n--; )
    if (dy(e[n][0], t))
      return n;
  return -1;
}
var oS = Array.prototype, iS = oS.splice;
function sS(e) {
  var t = this.__data__, n = Aa(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : iS.call(t, n, 1), --this.size, !0;
}
function aS(e) {
  var t = this.__data__, n = Aa(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function lS(e) {
  return Aa(this.__data__, e) > -1;
}
function cS(e, t) {
  var n = this.__data__, r = Aa(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function Wn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Wn.prototype.clear = rS;
Wn.prototype.delete = sS;
Wn.prototype.get = aS;
Wn.prototype.has = lS;
Wn.prototype.set = cS;
function uS() {
  this.__data__ = new Wn(), this.size = 0;
}
function dS(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function pS(e) {
  return this.__data__.get(e);
}
function fS(e) {
  return this.__data__.has(e);
}
var hS = typeof global == "object" && global && global.Object === Object && global;
const py = hS;
var mS = typeof self == "object" && self && self.Object === Object && self, gS = py || mS || Function("return this")();
const Tn = gS;
var yS = Tn.Symbol;
const fo = yS;
var fy = Object.prototype, vS = fy.hasOwnProperty, bS = fy.toString, Fo = fo ? fo.toStringTag : void 0;
function CS(e) {
  var t = vS.call(e, Fo), n = e[Fo];
  try {
    e[Fo] = void 0;
    var r = !0;
  } catch (i) {
  }
  var o = bS.call(e);
  return r && (t ? e[Fo] = n : delete e[Fo]), o;
}
var SS = Object.prototype, wS = SS.toString;
function _S(e) {
  return wS.call(e);
}
var xS = "[object Null]", TS = "[object Undefined]", kp = fo ? fo.toStringTag : void 0;
function To(e) {
  return e == null ? e === void 0 ? TS : xS : kp && kp in Object(e) ? CS(e) : _S(e);
}
function _i(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ES = "[object AsyncFunction]", RS = "[object Function]", OS = "[object GeneratorFunction]", PS = "[object Proxy]";
function hy(e) {
  if (!_i(e))
    return !1;
  var t = To(e);
  return t == RS || t == OS || t == ES || t == PS;
}
var IS = Tn["__core-js_shared__"];
const Il = IS;
var Ap = function() {
  var e = /[^.]+$/.exec(Il && Il.keys && Il.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function NS(e) {
  return !!Ap && Ap in e;
}
var MS = Function.prototype, kS = MS.toString;
function Ir(e) {
  if (e != null) {
    try {
      return kS.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var AS = /[\\^$.*+?()[\]{}|]/g, $S = /^\[object .+?Constructor\]$/, LS = Function.prototype, DS = Object.prototype, BS = LS.toString, FS = DS.hasOwnProperty, zS = RegExp(
  "^" + BS.call(FS).replace(AS, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function jS(e) {
  if (!_i(e) || NS(e))
    return !1;
  var t = hy(e) ? zS : $S;
  return t.test(Ir(e));
}
function HS(e, t) {
  return e == null ? void 0 : e[t];
}
function Eo(e, t) {
  var n = HS(e, t);
  return jS(n) ? n : void 0;
}
var WS = Eo(Tn, "Map");
const xi = WS;
var VS = Eo(Object, "create");
const Ti = VS;
function US() {
  this.__data__ = Ti ? Ti(null) : {}, this.size = 0;
}
function qS(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var GS = "__lodash_hash_undefined__", KS = Object.prototype, YS = KS.hasOwnProperty;
function XS(e) {
  var t = this.__data__;
  if (Ti) {
    var n = t[e];
    return n === GS ? void 0 : n;
  }
  return YS.call(t, e) ? t[e] : void 0;
}
var JS = Object.prototype, QS = JS.hasOwnProperty;
function ZS(e) {
  var t = this.__data__;
  return Ti ? t[e] !== void 0 : QS.call(t, e);
}
var ew = "__lodash_hash_undefined__";
function tw(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Ti && t === void 0 ? ew : t, this;
}
function xr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
xr.prototype.clear = US;
xr.prototype.delete = qS;
xr.prototype.get = XS;
xr.prototype.has = ZS;
xr.prototype.set = tw;
function nw() {
  this.size = 0, this.__data__ = {
    hash: new xr(),
    map: new (xi || Wn)(),
    string: new xr()
  };
}
function rw(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function $a(e, t) {
  var n = e.__data__;
  return rw(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function ow(e) {
  var t = $a(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function iw(e) {
  return $a(this, e).get(e);
}
function sw(e) {
  return $a(this, e).has(e);
}
function aw(e, t) {
  var n = $a(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function Nr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Nr.prototype.clear = nw;
Nr.prototype.delete = ow;
Nr.prototype.get = iw;
Nr.prototype.has = sw;
Nr.prototype.set = aw;
var lw = 200;
function cw(e, t) {
  var n = this.__data__;
  if (n instanceof Wn) {
    var r = n.__data__;
    if (!xi || r.length < lw - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Nr(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function ir(e) {
  var t = this.__data__ = new Wn(e);
  this.size = t.size;
}
ir.prototype.clear = uS;
ir.prototype.delete = dS;
ir.prototype.get = pS;
ir.prototype.has = fS;
ir.prototype.set = cw;
var uw = "__lodash_hash_undefined__";
function dw(e) {
  return this.__data__.set(e, uw), this;
}
function pw(e) {
  return this.__data__.has(e);
}
function aa(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Nr(); ++t < n; )
    this.add(e[t]);
}
aa.prototype.add = aa.prototype.push = dw;
aa.prototype.has = pw;
function fw(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function hw(e, t) {
  return e.has(t);
}
var mw = 1, gw = 2;
function my(e, t, n, r, o, i) {
  var s = n & mw, a = e.length, u = t.length;
  if (a != u && !(s && u > a))
    return !1;
  var l = i.get(e), d = i.get(t);
  if (l && d)
    return l == t && d == e;
  var p = -1, f = !0, h = n & gw ? new aa() : void 0;
  for (i.set(e, t), i.set(t, e); ++p < a; ) {
    var g = e[p], m = t[p];
    if (r)
      var v = s ? r(m, g, p, t, e, i) : r(g, m, p, e, t, i);
    if (v !== void 0) {
      if (v)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!fw(t, function(S, _) {
        if (!hw(h, _) && (g === S || o(g, S, n, r, i)))
          return h.push(_);
      })) {
        f = !1;
        break;
      }
    } else if (!(g === m || o(g, m, n, r, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var yw = Tn.Uint8Array;
const $p = yw;
function vw(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
function bw(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Cw = 1, Sw = 2, ww = "[object Boolean]", _w = "[object Date]", xw = "[object Error]", Tw = "[object Map]", Ew = "[object Number]", Rw = "[object RegExp]", Ow = "[object Set]", Pw = "[object String]", Iw = "[object Symbol]", Nw = "[object ArrayBuffer]", Mw = "[object DataView]", Lp = fo ? fo.prototype : void 0, Nl = Lp ? Lp.valueOf : void 0;
function kw(e, t, n, r, o, i, s) {
  switch (n) {
    case Mw:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Nw:
      return !(e.byteLength != t.byteLength || !i(new $p(e), new $p(t)));
    case ww:
    case _w:
    case Ew:
      return dy(+e, +t);
    case xw:
      return e.name == t.name && e.message == t.message;
    case Rw:
    case Pw:
      return e == t + "";
    case Tw:
      var a = vw;
    case Ow:
      var u = r & Cw;
      if (a || (a = bw), e.size != t.size && !u)
        return !1;
      var l = s.get(e);
      if (l)
        return l == t;
      r |= Sw, s.set(e, t);
      var d = my(a(e), a(t), r, o, i, s);
      return s.delete(e), d;
    case Iw:
      if (Nl)
        return Nl.call(e) == Nl.call(t);
  }
  return !1;
}
function Aw(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var $w = Array.isArray;
const la = $w;
function Lw(e, t, n) {
  var r = t(e);
  return la(e) ? r : Aw(r, n(e));
}
function Dw(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, i = []; ++n < r; ) {
    var s = e[n];
    t(s, n, e) && (i[o++] = s);
  }
  return i;
}
function Bw() {
  return [];
}
var Fw = Object.prototype, zw = Fw.propertyIsEnumerable, Dp = Object.getOwnPropertySymbols, jw = Dp ? function(e) {
  return e == null ? [] : (e = Object(e), Dw(Dp(e), function(t) {
    return zw.call(e, t);
  }));
} : Bw;
const Hw = jw;
function Ww(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
function ho(e) {
  return e != null && typeof e == "object";
}
var Vw = "[object Arguments]";
function Bp(e) {
  return ho(e) && To(e) == Vw;
}
var gy = Object.prototype, Uw = gy.hasOwnProperty, qw = gy.propertyIsEnumerable, Gw = Bp(function() {
  return arguments;
}()) ? Bp : function(e) {
  return ho(e) && Uw.call(e, "callee") && !qw.call(e, "callee");
};
const Kw = Gw;
function Yw() {
  return !1;
}
var yy = typeof exports == "object" && exports && !exports.nodeType && exports, Fp = yy && typeof module == "object" && module && !module.nodeType && module, Xw = Fp && Fp.exports === yy, zp = Xw ? Tn.Buffer : void 0, Jw = zp ? zp.isBuffer : void 0, Qw = Jw || Yw;
const vu = Qw;
var Zw = 9007199254740991, e_ = /^(?:0|[1-9]\d*)$/;
function t_(e, t) {
  var n = typeof e;
  return t = t == null ? Zw : t, !!t && (n == "number" || n != "symbol" && e_.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var n_ = 9007199254740991;
function vy(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= n_;
}
var r_ = "[object Arguments]", o_ = "[object Array]", i_ = "[object Boolean]", s_ = "[object Date]", a_ = "[object Error]", l_ = "[object Function]", c_ = "[object Map]", u_ = "[object Number]", d_ = "[object Object]", p_ = "[object RegExp]", f_ = "[object Set]", h_ = "[object String]", m_ = "[object WeakMap]", g_ = "[object ArrayBuffer]", y_ = "[object DataView]", v_ = "[object Float32Array]", b_ = "[object Float64Array]", C_ = "[object Int8Array]", S_ = "[object Int16Array]", w_ = "[object Int32Array]", __ = "[object Uint8Array]", x_ = "[object Uint8ClampedArray]", T_ = "[object Uint16Array]", E_ = "[object Uint32Array]", nt = {};
nt[v_] = nt[b_] = nt[C_] = nt[S_] = nt[w_] = nt[__] = nt[x_] = nt[T_] = nt[E_] = !0;
nt[r_] = nt[o_] = nt[g_] = nt[i_] = nt[y_] = nt[s_] = nt[a_] = nt[l_] = nt[c_] = nt[u_] = nt[d_] = nt[p_] = nt[f_] = nt[h_] = nt[m_] = !1;
function R_(e) {
  return ho(e) && vy(e.length) && !!nt[To(e)];
}
function O_(e) {
  return function(t) {
    return e(t);
  };
}
var by = typeof exports == "object" && exports && !exports.nodeType && exports, hi = by && typeof module == "object" && module && !module.nodeType && module, P_ = hi && hi.exports === by, Ml = P_ && py.process, I_ = function() {
  try {
    var e = hi && hi.require && hi.require("util").types;
    return e || Ml && Ml.binding && Ml.binding("util");
  } catch (t) {
  }
}();
const jp = I_;
var Hp = jp && jp.isTypedArray, N_ = Hp ? O_(Hp) : R_;
const Cy = N_;
var M_ = Object.prototype, k_ = M_.hasOwnProperty;
function A_(e, t) {
  var n = la(e), r = !n && Kw(e), o = !n && !r && vu(e), i = !n && !r && !o && Cy(e), s = n || r || o || i, a = s ? Ww(e.length, String) : [], u = a.length;
  for (var l in e)
    (t || k_.call(e, l)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    t_(l, u))) && a.push(l);
  return a;
}
var $_ = Object.prototype;
function L_(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || $_;
  return e === n;
}
function D_(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var B_ = D_(Object.keys, Object);
const F_ = B_;
var z_ = Object.prototype, j_ = z_.hasOwnProperty;
function H_(e) {
  if (!L_(e))
    return F_(e);
  var t = [];
  for (var n in Object(e))
    j_.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function W_(e) {
  return e != null && vy(e.length) && !hy(e);
}
function V_(e) {
  return W_(e) ? A_(e) : H_(e);
}
function Wp(e) {
  return Lw(e, V_, Hw);
}
var U_ = 1, q_ = Object.prototype, G_ = q_.hasOwnProperty;
function K_(e, t, n, r, o, i) {
  var s = n & U_, a = Wp(e), u = a.length, l = Wp(t), d = l.length;
  if (u != d && !s)
    return !1;
  for (var p = u; p--; ) {
    var f = a[p];
    if (!(s ? f in t : G_.call(t, f)))
      return !1;
  }
  var h = i.get(e), g = i.get(t);
  if (h && g)
    return h == t && g == e;
  var m = !0;
  i.set(e, t), i.set(t, e);
  for (var v = s; ++p < u; ) {
    f = a[p];
    var S = e[f], _ = t[f];
    if (r)
      var R = s ? r(_, S, f, t, e, i) : r(S, _, f, e, t, i);
    if (!(R === void 0 ? S === _ || o(S, _, n, r, i) : R)) {
      m = !1;
      break;
    }
    v || (v = f == "constructor");
  }
  if (m && !v) {
    var b = e.constructor, y = t.constructor;
    b != y && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof y == "function" && y instanceof y) && (m = !1);
  }
  return i.delete(e), i.delete(t), m;
}
var Y_ = Eo(Tn, "DataView");
const bu = Y_;
var X_ = Eo(Tn, "Promise");
const Cu = X_;
var J_ = Eo(Tn, "Set");
const Su = J_;
var Q_ = Eo(Tn, "WeakMap");
const wu = Q_;
var Vp = "[object Map]", Z_ = "[object Object]", Up = "[object Promise]", qp = "[object Set]", Gp = "[object WeakMap]", Kp = "[object DataView]", ex = Ir(bu), tx = Ir(xi), nx = Ir(Cu), rx = Ir(Su), ox = Ir(wu), gr = To;
(bu && gr(new bu(new ArrayBuffer(1))) != Kp || xi && gr(new xi()) != Vp || Cu && gr(Cu.resolve()) != Up || Su && gr(new Su()) != qp || wu && gr(new wu()) != Gp) && (gr = function(e) {
  var t = To(e), n = t == Z_ ? e.constructor : void 0, r = n ? Ir(n) : "";
  if (r)
    switch (r) {
      case ex:
        return Kp;
      case tx:
        return Vp;
      case nx:
        return Up;
      case rx:
        return qp;
      case ox:
        return Gp;
    }
  return t;
});
const Yp = gr;
var ix = 1, Xp = "[object Arguments]", Jp = "[object Array]", ls = "[object Object]", sx = Object.prototype, Qp = sx.hasOwnProperty;
function ax(e, t, n, r, o, i) {
  var s = la(e), a = la(t), u = s ? Jp : Yp(e), l = a ? Jp : Yp(t);
  u = u == Xp ? ls : u, l = l == Xp ? ls : l;
  var d = u == ls, p = l == ls, f = u == l;
  if (f && vu(e)) {
    if (!vu(t))
      return !1;
    s = !0, d = !1;
  }
  if (f && !d)
    return i || (i = new ir()), s || Cy(e) ? my(e, t, n, r, o, i) : kw(e, t, u, n, r, o, i);
  if (!(n & ix)) {
    var h = d && Qp.call(e, "__wrapped__"), g = p && Qp.call(t, "__wrapped__");
    if (h || g) {
      var m = h ? e.value() : e, v = g ? t.value() : t;
      return i || (i = new ir()), o(m, v, n, r, i);
    }
  }
  return f ? (i || (i = new ir()), K_(e, t, n, r, o, i)) : !1;
}
function Sy(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !ho(e) && !ho(t) ? e !== e && t !== t : ax(e, t, n, r, Sy, o);
}
function _u(e, t) {
  return Sy(e, t);
}
const _e = {
  HEADERS: "headers",
  METADATA: "metadata",
  DATA: "data",
  GRAND: "grand",
  FINISH: "finish",
  ERROR: "error",
  TOTAL_ROWS: "totalRows",
  DATA_FINISH: "dataFinish",
  DATABARS: "dataBars",
  RANGE_MIN_MAX: "rangeMinMax"
}, lx = [
  _e.ERROR,
  _e.HEADERS,
  _e.GRAND,
  _e.METADATA,
  _e.DATA,
  _e.DATA_FINISH,
  _e.TOTAL_ROWS,
  _e.DATABARS,
  _e.RANGE_MIN_MAX,
  _e.FINISH
], Ce = {
  ROWS: "rows",
  COLUMNS: "columns",
  MEASURES: "measures",
  SCOPE: "scope"
}, ct = {
  ASC: "asc",
  DESC: "desc"
}, et = {
  SUB_TOTAL: "subTotal",
  GRAND_TOTAL: "grandTotal",
  MEASURE_TOP: "measureTop",
  MEASURE_BOTTOM: "measureBottom",
  CORNER: "corner"
}, Zp = {
  COLOR: "color",
  CONDITION: "condition"
}, $n = {
  DATETIME: "datetime",
  TEXT: "text",
  NUMERIC: "numeric"
}, jr = {
  MEMBER: "member",
  VALUE: "value",
  SUB_TOTAL: "subtotal",
  GRAND_TOTAL: "grandtotal"
}, tr = {
  MEMBER: "member",
  INDEX: "index",
  TITLE: "title",
  NAME: "name",
  AGG: "agg",
  DIM: "dim"
};
class cx {
  constructor(t, n, r, o) {
    I(this, "rowIndex");
    I(this, "colIndex");
    I(this, "node");
    I(this, "parent");
    /**
      @private */
    I(this, "childColCells", []);
    /**
      @private */
    I(this, "childRowCells", []);
    /**
      @private */
    I(this, "indexInParent", -1);
    /**
      @private */
    I(this, "siblingCount", 0);
    this.rowIndex = t, this.colIndex = n, this.node = r, this.parent = o;
  }
  /**
   * Defines if grid cell is child or main one
   *
   * @returns {boolean} - true - is children, false - main one
   */
  isChild() {
    return !this.node;
  }
  /**
   * Defines if node has child row or column nodes or not
   *
   * @returns {boolean} - true - has children, false - does not have
   */
  hasChildren() {
    return !!(this.childColCells.length || this.childRowCells.length);
  }
  /**
   * Defines if node has child column nodes or not
   *
   * @returns {boolean} - true - has column children, false - does not have
   */
  hasColCell() {
    return this.childColCells.length > 0;
  }
  /**
   * Adds column children cell
   *
   * @param {TreeCellMapI} cell - column children
   * @returns {void}
   */
  addColCell(t) {
    this.childColCells.push(t);
  }
  /**
   * Returns list of column children
   *
   * @returns {Array<TreeCellMapI>} - list of column children
   */
  getColCell() {
    return this.childColCells || [];
  }
  /**
   * Defines if node has child row nodes or not
   *
   * @returns {boolean} - true - has row children, false - does not have
   */
  hasRowCell() {
    return this.childRowCells.length > 0;
  }
  /**
   * Adds row children cell
   *
   * @param {TreeCellMapI} cell - row children
   * @returns {void}
   */
  addRowCell(t) {
    this.childRowCells.push(t);
  }
  /**
   * Returns list of row children
   *
   * @returns {Array<TreeCellMapI>} - list of row children
   */
  getRowCell() {
    return this.childRowCells || [];
  }
  /**
   * Returns row index of last merged cell
   *
   * @returns {number} - row index
   */
  getStopRowIndex() {
    return this.hasRowCell() ? this.rowIndex + this.getRowCell().length : this.rowIndex;
  }
  /**
   * Returns column index of last merged cell
   *
   * @returns {number} - column index
   */
  getStopColIndex() {
    return this.hasColCell() ? this.colIndex + this.getColCell().length : this.colIndex;
  }
  /**
   * Save index of node in parent child and total parent child count
   *
   * @param {number} indexInParent - index
   * @param {number} siblingCount - child count
   * @returns {void}
   */
  setIndexInParent(t, n) {
    this.indexInParent = t, this.siblingCount = n;
  }
  /**
   * Returns node index in parent and total parent child count
   *
   * @returns {{ indexInParent: number, siblingCount: number }} - index & count
   */
  getIndexInParent() {
    return {
      indexInParent: this.indexInParent,
      siblingCount: this.siblingCount
    };
  }
  getParenPosition() {
    if (!this.parent)
      return;
    const t = (this.parent || "").match(/\d+/g) || [];
    return [Number(t[0]), Number(t[1])];
  }
}
const ca = ["S&PManager", "Cache"], ua = ["null"];
class Ei {
  constructor(t = "") {
    I(this, "name");
    I(this, "log");
    I(this, "warn");
    I(this, "error");
    I(this, "console");
    this.name = t, this.log = () => {
    }, this.warn = () => {
    }, this.error = () => {
    }, this.console = Ei.createMockConsole(), this.createLogFn();
  }
  setName(t) {
    this.name = t, this.createLogFn();
  }
  getName() {
    return this.name;
  }
  /**
   * Creates real or fake "log" function depending on include/exclude rules
   *
   * @returns {void}
   *
   * @private
   */
  createLogFn() {
    this.log = () => {
    }, this.warn = () => {
    }, this.error = () => {
    };
  }
  /**
   * Defines if logger is excluded from logging
   *
   * @returns {boolean} - true - excluded
   *
   * @private
   */
  isExcludedName() {
    return ua.length && !this.hasNamePartsInList(ua) ? !0 : ca.length ? this.hasNamePartsInList(ca) : !1;
  }
  /**
   * Determinates if included/excluded items contains part of the name
   *
   * @param {Array<string>} array - included/excluded items
   * @returns {boolean} - true - contains
   *
   * @private
   */
  hasNamePartsInList(t) {
    const n = this.name.toLowerCase();
    return t.some((r) => n.includes(r.toLowerCase()));
  }
  /**
   * Creates mock console instance for tests
   *
   * @returns {LoggerI} - logger instance
   */
  static createMockConsole() {
    return {
      log: () => {
      },
      warn: () => {
      },
      error: () => {
      }
    };
  }
  /**
   * Creates mock instance for tests
   *
   * @returns {LoggerI} - logger instance
   */
  static createMock() {
    const t = Ei.createMockConsole();
    return L(C({
      setName: () => {
      },
      getName: () => ""
    }, t), {
      console: t
    });
  }
}
const ux = (e) => new Ei(e), dx = (e = "") => {
  ca.push(e.toLowerCase());
}, px = (e = "") => {
  ua.push(e.toLowerCase());
}, fx = () => {
  ca.length = 0, ua.length = 0;
}, ar = {
  Logger: Ei,
  create: ux,
  excludeLogs: dx,
  includeLogs: px,
  clearIncludeExclude: fx
}, wy = [Date, Error, RegExp, Promise];
function _y(e, t = wy) {
  return t.some((n) => e instanceof n);
}
function ef(e, t = []) {
  let n = !1;
  return t.forEach((r) => {
    e.includes(r) && (n = !0);
  }), n;
}
function xy(e = [], t, n) {
  const r = [];
  return n && e.forEach((o) => {
    r.push(`${o}.$`);
  }), e.length ? e.forEach((o) => {
    r.push(`${o}.${t}`);
  }) : r.push(t), r;
}
function mi(e) {
  return !(e === null || typeof e == "undefined" || typeof e != "object");
}
function hx(e, t) {
  return mi(e) && e ? Array.isArray(e) ? !e.length : _y(e, t) ? !1 : !Object.keys(e).length : e == null;
}
function mx(e = "") {
  const t = e.split(".");
  return t.length > 1 ? (t.pop(), t.join(".")) : t[0];
}
function tf(e, t, n) {
  return e.length ? ef(e, n) : t.length ? !ef(t, n) : !0;
}
function Ty(e, t = [], n = [], r = [], o = {}, i = {}, s = [], a = []) {
  if (!mi(e))
    return {
      commonIncludeKeys: [],
      commonExcludeKeys: []
    };
  const u = s.indexOf(e);
  if (u !== -1)
    return a[u];
  s.push(e);
  const l = Object.keys(e), d = Array.isArray(e);
  let p = [], f = [];
  const h = [], g = [];
  if (l.forEach((m) => {
    const v = e[m], S = xy(r, m, d), _ = r[0] || "&";
    o[_] = o[_] || [], i[_] = i[_] || [], S.forEach((R) => {
      (t || []).includes(R) && (o[_].push(R), p.push(R)), (t || []).forEach((b) => {
        const y = mx(b);
        (`${y}.$` === _ || y === _) && (o[_].includes(b) || o[_].push(b), p.includes(b) || p.push(b));
      }), (n || []).includes(R) && (i[_].push(R), f.push(R));
    }), mi(v) && Ty(
      v,
      t,
      n,
      S,
      o,
      i,
      s,
      a
    );
  }), mi(e)) {
    let m = r[0] || "&";
    Array.isArray(e) && (m = `${m}.$`), o[m] = (o[m] || []).concat(
      h
    ), p = p.concat(h), i[m] = (i[m] || []).concat(
      g
    ), f = p.concat(g);
  }
  return a.push({
    commonIncludeKeys: p,
    commonExcludeKeys: f
  }), {
    commonIncludeKeys: p,
    commonExcludeKeys: f
  };
}
function Ey(e, t, n = /* @__PURE__ */ new WeakMap()) {
  const {
    includeKeys: r,
    includeKeysObj: o,
    excludeKeys: i,
    excludeKeysObj: s,
    parentKeys: a = [],
    excludeEmpty: u,
    referenceClone: l
  } = t || {};
  if (!mi(e) || _y(e, l))
    return e;
  if (n.has(e))
    return n.get(e);
  const d = Object.keys(e), p = Array.isArray(e), f = p ? [] : {};
  n.set(e, f);
  const h = a[0] || "&", g = (o || {})[h] || [], m = (s || {})[h] || [];
  return d.forEach((v) => {
    const S = e[v];
    let _ = [], R = !0;
    if (r || i ? R = tf(r || [], i || [], [v]) : (o || s) && (_ = xy(a, v, p), R = tf(g, m, _)), R) {
      const b = Ey(
        S,
        L(C({}, t), {
          parentKeys: _
        }),
        n
      );
      (!u || !hx(b, l)) && (p ? f.push(b) : f[v] = b);
    }
  }), f;
}
function It(e, t) {
  const u = t || {}, { include: n, exclude: r } = u, o = re(u, ["include", "exclude"]);
  let i, s;
  (n || r) && (i = {}, s = {}, Ty(e, n, r, [], i, s));
  const a = L(C({}, o), {
    includeKeysObj: i,
    excludeKeysObj: s
  });
  return Ey(e, a);
}
It.REFERENCE_CLONE_TYPES = wy;
const kl = (e) => (t) => e.replace(/{{(\w+)}}/g, (n, r) => typeof t[r] != "undefined" ? t[r] : r), Ry = (e, t) => {
  let n, r, o = null;
  const i = (...s) => {
    n ? o = s : (e(...s), n = !0, o = null, r = setTimeout(() => {
      n = !1, o && (e(...o), o = null);
    }, t));
  };
  return i.cancel = () => {
    clearTimeout(r), n = !1;
  }, i;
}, Oy = (e, t) => {
  const n = {};
  return Object.keys(e).forEach((r) => {
    e[r] !== t[r] && (n[r] = t[r]);
  }), Object.keys(t).forEach((r) => {
    typeof n[r] == "undefined" && e[r] !== t[r] && (n[r] = t[r]);
  }), n;
};
function xu(e = !0) {
  let t = {}, n = null;
  return ({ callback: r, indices: o }) => {
    const i = Object.keys(o), s = !e || i.every((u) => {
      const l = o[u];
      return Array.isArray(l) ? l.length > 0 : l >= 0;
    }), a = i.length !== Object.keys(t).length || i.some((u) => {
      const l = t[u], d = o[u];
      return Array.isArray(d) ? l.join(",") !== d.join(",") : l !== d;
    });
    return t = o, s && a && (n = r(o)), n;
  };
}
function nf(e, t, n = 0) {
  for (let r = n; r < e.length; r += 1) {
    const o = e[r];
    if (!!t(o, r, e))
      return r;
  }
  return -1;
}
const Ri = "$*$root$*$";
function gx(e, t, n, r) {
  const o = { value: e };
  return t && (o.children = t), n && (o.data = n), typeof r != "undefined" && (o.index = r), o;
}
function La(e) {
  return !!(e && e.children && e.children.length);
}
function an(e) {
  return e && e.children || [];
}
function Tu(e, t) {
  e && t && Array.isArray(t) && (e.children = t);
}
function yx(e, t) {
  e && (e.level = t);
}
function vx(e) {
  return e && typeof e.level != "undefined" ? e.level || 0 : -1;
}
function Zr(e) {
  if (!e)
    return;
  if (e && !Array.isArray(e) && e.value === Ri)
    return e;
  const t = { value: Ri, children: [] };
  return Array.isArray(e) ? t.children = e : (t.children || [])[0] = e, t;
}
function Py(e, t, n = 0) {
  let r;
  if (!e || !t)
    return r;
  if (t(e, n) && (r = e), La(e)) {
    const o = an(e), i = o.length;
    for (let s = 0; s < i; s += 1) {
      const a = Py(o[s], t, n + 1);
      if (a) {
        r = a;
        break;
      }
    }
  }
  return r;
}
function bx(e, t) {
  if (!e && !t)
    return;
  if (!e && t)
    return Zr(t);
  if (e && !t)
    return Zr(e);
  const n = Zr(e), r = Zr(t), o = n && n.children || [], i = r && r.children || [], s = o.concat(i);
  return Zr(s);
}
const Iy = (e, t = 0) => {
  if (!e || !e.isPart)
    return;
  e.level = t;
  const n = an(e), r = n[n.length - 1];
  return r && Iy(r, t + 1) || e;
}, Ny = (e, t, n = 0) => {
  if (!e || !e.isPart)
    return;
  if (e.level = n, e && t && e.value === t.value && e.level === t.level)
    return e;
  const o = an(e)[0];
  return o && Ny(o, t, n + 1) || e;
};
function Cx(e, t) {
  let n = Iy(e), r = Ny(t, n);
  n && n.children && Array.isArray(n.children) && r && r.children && Array.isArray(r.children) && r.children.length > 0 && (n.children = n.children.concat(r.children), r.isHandled = !0);
  let o = !1;
  for (n = e, r = t; n && n.children && Array.isArray(n.children) && r && r.children && Array.isArray(r.children) && !r.isHandled; ) {
    const i = n.children;
    n = n.children[n.children.length - 1];
    let s = 0;
    for (r.children[0] && !o && (o = !an(r.children[0]).some((a) => a.isPart), s = 1); s < r.children.length; )
      i.push(r.children[s]), s += 1;
    r = r.children[0];
  }
  return e;
}
function My(e, t, n) {
  !e || !t || e.forEach((r) => {
    t(r, n), La(r) && My(an(r), t, r);
  });
}
function ky(e, t = [], n = 0, r = { maxLevel: 0 }) {
  return e.forEach((o) => {
    r.maxLevel < n && (r.maxLevel = n), La(o) ? ky(an(o), t, n + 1, r) : t.push(o);
  }), t;
}
function Da(e, t = {}) {
  if (t || (t = {}), typeof t.callCount != "number" ? t.callCount = 1 : t.callCount += 1, !e)
    return 0;
  let n = t.clearCache || !1;
  !Array.isArray(e) && e.value === Ri && (n = !0);
  let r = 1, o = [];
  return Array.isArray(e) ? (r = 0, o = e) : e.children && (o = an(e)), o && o.length && (!n && !Array.isArray(e) && typeof e.childCount == "number" ? r = e.childCount : (r = 0, o.forEach((i) => {
    r += Da(i, t);
  }), Array.isArray(e) || (e.childCount = r))), r;
}
function Ay(e, t = {}) {
  if (t || (t = {}), typeof t.callCount != "number" ? t.callCount = 1 : t.callCount += 1, !e)
    return 0;
  let n = t.clearCache || !1;
  !Array.isArray(e) && e.value === Ri && (n = !0);
  let r = 0, o = [];
  if (e && !Array.isArray(e) && typeof e.value != "undefined" && (r = 1), Array.isArray(e) ? (r = 0, o = e) : e.children && (o = an(e)), o && o.length)
    if (!n && !Array.isArray(e) && typeof e.childDeep == "number")
      r += e.childDeep;
    else {
      let i = 0;
      o.forEach((s) => {
        const a = Ay(s, t);
        a > i && (i = a);
      }), r += i, Array.isArray(e) || (e.childDeep = i);
    }
  return r;
}
function $y(e = [], t = 0, n) {
  const r = [];
  let o = 0, i = -1, s = -1;
  const a = e.length;
  if (typeof t == "number" && typeof n == "number" && t > n)
    throw new Error('Wrong "getNodesByChildCount" diapason');
  if (typeof t == "number" && t < 0)
    throw new Error('Wrong "from" index for "getNodesByChildCount"');
  for (let u = 0; u < a; u += 1) {
    const l = e[u], d = Da(l);
    if (o + d > t && (i < 0 && (i = o), r.push(l), typeof n == "number" && o + d >= n)) {
      s = o + d;
      break;
    }
    s = o + d, o += d;
  }
  return {
    nodes: r,
    start: i,
    stop: s
  };
}
function Sx(e) {
  e.isMapped !== void 0 && (e.isMapped = void 0), e.minLevel !== void 0 && (e.minLevel = void 0), e.childCount !== void 0 && (e.childCount = void 0), e.childDeep !== void 0 && (e.childDeep = void 0);
}
function Eu(e = [], t = 0, n, r) {
  const { cloneFn: o = It } = r || {}, i = [], { nodes: s, start: a, stop: u } = $y(e, t, n), l = s.length;
  let d, p, f = !0;
  if (a < t) {
    const h = s[0] || {}, g = t - a;
    let m;
    l === 1 && typeof n == "number" && (m = n - a, f = !1), d = o(h, !0);
    const v = Eu(
      an(h),
      g,
      m,
      r
    );
    Tu(d, v);
  }
  if (typeof n == "number" && u > n && f) {
    const h = s[l - 1] || {}, g = 0, m = Da(h) - (u - n);
    p = o(h, !0);
    const v = Eu(
      an(h),
      g,
      m,
      r
    );
    Tu(p, v);
  }
  return s.forEach((h, g) => {
    if (d && g === 0)
      i.push(d);
    else if (p && g === l - 1)
      i.push(p);
    else {
      const m = o(h);
      i.push(m);
    }
  }), i;
}
const se = {
  ROOT: Ri,
  create: gx,
  hasChildren: La,
  getChildren: an,
  setChildren: Tu,
  setLevel: yx,
  getLevel: vx,
  getLastLevelNodes: ky,
  iterateThroughTree: My,
  wrapInRootNode: Zr,
  findNode: Py,
  merge: bx,
  deepMerge: Cx,
  getChildLength: Da,
  getDeepLength: Ay,
  getNodesByChildCount: $y,
  getCutNodesByChildCount: Eu,
  clearNodeCache: Sx
}, bt = {
  FIRST: "first",
  LAST: "last",
  EVEN: "even",
  ODD: "odd"
}, Hr = (e, t) => `${e}-${t}`;
class wx {
  constructor(t, n = !1, r) {
    I(this, "tree");
    I(this, "hasGrandTotals", !1);
    /**
     * Defines if tree will be converted to vertical or horizontal grid
     *
     *
     * @private
     */
    I(this, "isVertical", !1);
    I(this, "deep");
    /**
     * Cache tree nodes by deep levels
     *
     *
     * @private
     */
    I(this, "columns", []);
    /**
     * Cache last levels tree nodes
     *
     *
     * @private
     */
    I(this, "lastLevel", []);
    /**
     * Mapping object between tree<>grid
     *
     *
     * @private
     */
    I(this, "map", {});
    /**
     * Metadata cache object
     *
     *
     * @private
     */
    I(this, "metadataCache", {});
    /**
     * Keep value node if it only one
     *
     *
     * @private
     */
    I(this, "valueNode");
    /**
     * Final 2D array
     *
     *
     * @private
     */
    I(this, "grid");
    this.isVertical = n, this.deep = r, t && (this.tree = t, this.columns = this.cacheLevels(se.getChildren(this.tree)));
  }
  destroy() {
    this.tree = void 0, this.columns = [], this.lastLevel = [], this.map = {}, this.metadataCache = {}, this.valueNode = void 0, this.grid = void 0;
  }
  getMainCellWidth(t, n, r, o, i = { offsetTop: -1, columnsOffset: 0 }) {
    const { columnsOffset: s = 0 } = i, a = this.getItem(t, n), u = a && a.hasChildren() && a.hasColCell();
    let l = Number.NaN, d = !0;
    if (a && u) {
      const p = a.getColCell(), f = r({ index: n + s });
      l = p.reduce((h, g) => {
        const m = r({ index: g.colIndex + s });
        return m || (d = !1), h + m;
      }, f), l -= o, l = Math.ceil(l);
    }
    return d ? l : Number.NaN;
  }
  /**
   * Adds additional tree node to current state
   *
   * @param {TreeNode} tree - new treeNode
   * @returns {void}
   */
  extend(t) {
    t && (this.grid = void 0, this.tree = se.merge(this.tree, t), this.columns = this.cacheLevels(se.getChildren(t), this.columns));
  }
  /**
   * Returns grid (2d list) of tree structure
   *
   * @returns {Array<Array<TreeNode | string>>} - 2d list
   */
  getGrid() {
    if (this.grid)
      return this.grid;
    let t = this.getTreeDeepsLength(), n = this.getTreeChildLength();
    return this.isVertical ? ([t, n] = [n, t], this.map = this.fillMapVertical(se.getChildren(this.tree), n, this.map)) : this.map = this.fillMap(se.getChildren(this.tree), t, this.map), this.grid = Array.from(Array(t)).map(
      (r, o) => Array.from(Array(n)).map((i, s) => {
        const a = Hr(o, s), u = this.map[a];
        if (!u)
          throw new Error(`Key "${a}" does not found in TreeService`);
        return u.node ? u.node : u.parent;
      })
    ), this.grid;
  }
  /**
   * Returns part of current grid according to "from" - "to" position
   *
   * @param {number} from - start rows index for partial grid
   * @param {number} to - stop rows index for partial grid
   * @returns {Array<Array<TreeNode | string>>} - partial grid
   */
  getPartialGrid(t, n) {
    if (!this.isVertical)
      throw new Error('"getPartialGrid" can only be used for "vertical" tree');
    const r = this.getTreeDeepsLength(), o = se.getChildren(this.tree), { nodes: i, start: s, stop: a } = se.getNodesByChildCount(o, t, n);
    this.fillMapVertical(i, r, this.map, {
      parentRowIndex: s,
      parentColIndex: 0,
      prevChildren: 0,
      parentKey: ""
    });
    const u = Math.max(s, t), l = Math.min(a, n), d = Math.max(0, l - t);
    return Array.from(Array(d)).map(
      (p, f) => Array.from(Array(r)).map((h, g) => {
        const m = u + f, v = Hr(m, g), S = this.map[v];
        if (!S)
          throw new Error(`Key "${v}" does not found in TreeService`);
        return S.node ? S.node : S.parent || "";
      })
    );
  }
  /**
   * Returns part of current tree with possible cut nodes according to "from" - "to" position
   *
   * @param {number} from - start rows index for partial grid
   * @param {number} [to] - stop rows index for partial grid
   * @param {object} [options] - additional options
   * @param {Function} [options.cloneFn] - replace default clone function with specific one
   * @returns {Array<TreeNode>} - partial tree
   */
  getPartialTree(t, n, r) {
    const o = se.getChildren(this.tree);
    return se.getCutNodesByChildCount(o, t, n, r);
  }
  /**
   * Returns TreeNode item if exist for appropriate coordinates (rowIndex, columnIndex)
   *
   * @param {number} rowIndex - row index
   * @param {number} columnIndex - column index
   * @returns {TreeNode|undefined} - TreeNode item
   */
  getTreeNode(t, n) {
    const r = this.getItem(t, n);
    if (r && r.node)
      return r.node;
  }
  /**
   * Defines if cell with (rowIndex, columnIndex) coordinate is children cell or main one
   *
   * @param {number} rowIndex - row index of the cell
   * @param {number} columnIndex - column index of the cell
   * @returns {boolean} - true - if children, false if main one
   */
  isChildren(t, n) {
    const r = this.getItem(t, n);
    if (r)
      return r.isChild();
    if (typeof this.deep == "number" && (this.isVertical ? n : t) < this.deep)
      return !0;
    throw new Error(`Item "${t}-${n}" does not found in TreeService`);
  }
  /**
   * Defines if cell with (rowIndex, columnIndex) coordinate has children column/row cells or not
   *
   * @param {number} rowIndex - row index of the cell
   * @param {number} columnIndex - column index of the cell
   * @returns {boolean} - true - has children column/row cells, false - does not have
   */
  hasChildren(t, n) {
    const r = this.getItem(t, n);
    if (r)
      return r.hasChildren();
    throw new Error(`Item "${t}-${n}" does not found in TreeService`);
  }
  /**
   * Updates merge object for the cell if it has children cells
   *
   * @param {number} rowIndex - cell row index
   * @param {number} columnIndex - cell column index
   * @returns {object} - new merge object
   */
  getMainCellSpans(t, n) {
    const r = {}, o = this.getItem(t, n);
    return o && o.hasColCell() && (r.colSpan = o.getColCell().length + 1), o && o.hasRowCell() && (r.rowSpan = o.getRowCell().length + 1), r;
  }
  /**
   * Align start index in case of long merged cell
   *
   * @param {number} startIndex - initial start index
   * @param {boolean} isVertical - defines if it is vertical grid or not
   * @returns {number} - new start index
   */
  alignStartIndex(t, n = !1) {
    let r = 0, o = t;
    if (n && (r = t, o = 0), this.isVertical === n) {
      let i = this.getItem(r, o);
      if (i && i.isChild() && (i = this.getItemByKey(i.parent || "")), i)
        return n ? i.rowIndex : i.colIndex;
    }
    return t;
  }
  /**
   * Align stop index in case of long merged cell
   *
   * @param {number} stopIndex - initial stop index
   * @param {boolean} isVertical - defines if it is vertical grid or not
   * @returns {number} - new stop index
   */
  alignStopIndex(t, n = !1) {
    let r = 0, o = t;
    if (n && (r = t, o = 0), this.isVertical === n) {
      let i = this.getItem(r, o);
      if (i && i.isChild() && (i = this.getItemByKey(i.parent || "")), i)
        return n ? i.getStopRowIndex() : i.getStopColIndex();
    }
    return t;
  }
  /**
   * Returns number of last children for the tree
   *
   * @param {Array<TreeNode> | TreeNode} item - tree node or list of nodes
   * @param {{ callCount: number, clearCache: boolean }} options - options for state
   * @returns {number} - count of last children
   */
  getTreeChildLength(t = se.getChildren(this.tree), n) {
    return se.getChildLength(t, n);
  }
  /**
   * Returns deep level of the tree
   *
   * @param {Array<TreeNode> | TreeNode} item - tree node or list of nodes
   * @param {{ callCount: number, clearCache: boolean }} options - options for inner state
   * @returns {number} - count of last children
   */
  getTreeDeepsLength(t = se.getChildren(this.tree), n) {
    return typeof this.deep != "undefined" && this.deep !== void 0 ? this.deep : se.getDeepLength(t, n);
  }
  /**
   * Returns array of last tree nodes
   *
   * @returns {Array<TreeNode>} - list of tree nodes
   */
  getLastLevelNodes() {
    return this.lastLevel;
  }
  /**
   * Extract 2D array of data base on columnsTreeService
   *
   * @param {TreeServiceI} columnsTreeService - tree service according to which align the data
   * @returns {Array<Array<any>>} - 2D array of data
   */
  extractData(t) {
    if (!t)
      return [];
    const r = t.getLastLevelNodes().map((o) => o.index);
    return this.getLastLevelNodes().map((o) => typeof o.data == "undefined" ? [o.data] : r ? r.map((i) => {
      let s;
      return typeof i != "undefined" && o.data && (s = o.data[i]), s;
    }) : o.data);
  }
  /**
   * Returns cell meta information
   *
   * @param {number} rowIndex - cell row index
   * @param {number} columnIndex - cell column index
   * @param {{ to: number }} [options] - additional configuration options
   * @returns {{levels: Array<string>, siblings: Array<string>}} - meta information
   */
  // eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
  getMetadata(t, n, r) {
    const o = this.getTreeDeepsLength();
    t === 1 / 0 && (t = o && o - 1), n === 1 / 0 && (n = o && o - 1);
    const i = `${t}-${n}`;
    if (this.metadataCache[i])
      return this.metadataCache[i];
    let s = this.getItemByKey(i);
    if (!s)
      throw new Error(`Can not find metadata info for ${i} cell`);
    let a = s ? s.node : void 0;
    if (a || (s = this.getItemByKey(s.parent || "")), !s)
      throw new Error(`Can not find metadata info for parent ${i} cell`);
    a = s ? s.node : void 0;
    const u = this.getItemByKey(`${t + 1}-${n}`), l = u ? u.node : void 0, d = a && a.level || 0, p = this.isVertical ? s.getStopColIndex() : s.getStopRowIndex();
    let { indexInParent: f, siblingCount: h } = s.getIndexInParent(), g = f;
    if (d === 0 && (h = this.getTreeChildLength(), f = this.isVertical ? s.rowIndex : s.colIndex, g = f + (this.isVertical ? s.getRowCell().length : s.getColCell().length)), r) {
      const _ = r.to - r.from;
      h <= _ && g > _ - 1 && (g = _ - 1);
    }
    const m = {
      levels: [],
      siblings: [],
      root: void 0,
      parent: void 0,
      valueNode: this.valueNode,
      nextNode: l
    }, { indexDivergence: v } = a || {};
    if (typeof v == "number") {
      const _ = v === 0 ? bt.EVEN : bt.ODD;
      m.siblings.push(_);
    }
    if (d === 0 && m.levels.push(bt.FIRST), p === o - 1 && m.levels.push(bt.LAST), f === 0 && m.siblings.push(bt.FIRST), g === h - 1 && m.siblings.push(bt.LAST), a && d !== 0) {
      const _ = this.isVertical ? t : 0, R = this.isVertical ? 0 : n;
      m.root = this.getMetadata(_, R, r);
    }
    const S = this.getItemByKey(s.parent || "");
    if (S && d !== 0 && (m.parent = this.getMetadata(S.rowIndex, S.colIndex, r)), r) {
      const _ = this.isVertical ? s.rowIndex : s.colIndex, R = this.isVertical ? s.getStopRowIndex() : s.getStopColIndex();
      let b;
      S && (b = this.isVertical ? S.getStopRowIndex() : S.getStopColIndex()), b !== void 0 && b >= r.to - r.from && R >= r.to - r.from - 1 && !m.siblings.includes(bt.LAST) && m.siblings.push(bt.LAST), _ === 0 && !m.siblings.includes(bt.FIRST) && m.siblings.push(bt.FIRST);
    }
    return this.metadataCache[i] = m, m;
  }
  /**
   * Sets value node when it's single
   *
   * @param {TreeNode} valueNode - values measure node
   * @returns {void}
   */
  setValueNode(t) {
    typeof t == "object" && (this.valueNode = t);
  }
  /**
   * Fills cache object with nodes by appropriate deep level
   *
   * @param {Array<TreeNode>} list - list of nodes to cache
   * @param {Array<Array<TreeNode>>} cache - cache object
   * @param {{level: number }} options - internal recursive state
   * @returns {Array<Array<TreeNode>>} - cache object
   *
   * @private
   */
  cacheLevels(t, n = [], r = { level: 0 }) {
    const { level: o } = r;
    return t.forEach((i) => {
      if (n[o] || (n[o] = []), se.setLevel(i, o), n[o].push(i), se.hasChildren(i)) {
        const s = o + 1;
        this.cacheLevels(se.getChildren(i), n, { level: s });
      } else
        this.lastLevel.push(i);
    }), n;
  }
  /**
   * Fill horizontal grid map according to tree structure
   *
   * @param {Array<TreeNode>} children - list of tree nodes
   * @param {number} rows - deep level rows
   * @param {object} map - map object to fill
   * @param {{parentColIndex: number, prevChildren: number}} initState - state object for
   * recursive calls
   * @returns {object} - map object
   *
   * @private
   */
  fillMap(t, n, r = {}, o) {
    const i = o || {
      parentRowIndex: 0,
      parentColIndex: 0,
      prevChildren: 0,
      parentKey: ""
    }, s = t.length;
    return t.forEach((a, u) => {
      const { parentRowIndex: l, parentColIndex: d, prevChildren: p, parentKey: f } = i, g = se.getLevel(a) + l, m = u + d + p, v = Hr(g, m), S = this.createTreeCellMap({
        rowIndex: g,
        colIndex: m,
        node: a,
        parent: f
      });
      S.setIndexInParent(u, s), r[v] = S;
      let _ = 0, R = 0;
      if (se.hasChildren(a) ? (_ = this.getTreeChildLength(a), typeof a.minLevel == "number" && (R = a.minLevel + 1 - g || 0)) : R = (n || 0) - (g || 0), (_ > 1 || R > 1) && this.fillChildMap(r, v, g, m, R, _), se.hasChildren(a)) {
        const b = L(C({}, i), {
          parentRowIndex: R > 1 ? R - 1 : 0,
          parentColIndex: u + d,
          parentKey: v
        });
        this.fillMap(se.getChildren(a), n, r, b), _ > 1 && (i.prevChildren += _ - 1);
      }
    }), r;
  }
  /**
   * Fill vertical grid map according to tree structure
   *
   * @param {Array<TreeNode>} children - list of tree nodes
   * @param {number} cols - deep level columns
   * @param {TreeCellMapCache} map - map object to fill
   * @param {FillMapState} initState - state object for
   * recursive calls
   * @returns {object} - map object
   *
   * @private
   */
  fillMapVertical(t, n, r = {}, o) {
    const i = o || {
      parentRowIndex: 0,
      parentColIndex: 0,
      prevChildren: 0,
      parentKey: ""
    }, s = t.length;
    return t.forEach((a, u) => {
      if (a.isMapped) {
        i.parentRowIndex += se.getChildLength(a) - 1;
        return;
      }
      a.isMapped = !0;
      const { parentRowIndex: l, prevChildren: d, parentKey: p } = i, f = se.getLevel(a), h = u + l + d, g = Hr(h, f), m = this.createTreeCellMap({
        rowIndex: h,
        colIndex: f,
        node: a,
        parent: p
      });
      m.setIndexInParent(u, s), r[g] = m;
      let v = 0, S = 0;
      if (se.hasChildren(a) ? S = this.getTreeChildLength(a) : v = (n || 0) - (f || 0), (v > 1 || S > 1) && this.fillChildMap(r, g, h, f, S, v), se.hasChildren(a)) {
        const _ = L(C({}, i), {
          parentRowIndex: u + l,
          parentKey: g
        });
        this.fillMapVertical(se.getChildren(a), n, r, _), S > 1 && (i.prevChildren += S - 1);
      }
    }), r;
  }
  /**
   * Fill child items in map according to main cell merged row and col
   *
   * @param {object} map - map object to fill
   * @param {string} mainKey - main cell key in map
   * @param {number} rowStart - main cell row index
   * @param {number} colStart - main cell column index
   * @param {number} row - merged rows count
   * @param {number} col - merged columns count
   * @returns {void}
   *
   * @private
   */
  fillChildMap(t, n, r, o, i, s) {
    const a = t[n], u = Math.max(1, i), l = Math.max(1, s);
    Array.from(Array(u)).forEach((d, p) => {
      Array.from(Array(l)).forEach((f, h) => {
        if (p === 0 && h === 0)
          return;
        const g = r + p, m = o + h, v = Hr(g, m), S = this.createTreeCellMap({
          rowIndex: g,
          colIndex: m,
          parent: n
        });
        t[v] = S, !(p !== 0 && h !== 0) && (h === 0 && a.addRowCell(S), p === 0 && a.addColCell(S));
      });
    });
  }
  /**
   * Creates TreeCellMap instance
   *
   * @param {object} options - instance options
   * @param {number} options.rowIndex - row index of cell map instance
   * @param {number} options.colIndex - row index of cell map instance
   * @param {TreeNode} [options.node] - TreeNode for main cell
   * @param {string} [options.parent] - parent key for child item
   * @returns {TreeCellMap} - TreeCellMap instance
   *
   * @private
   */
  // eslint-disable-next-line class-methods-use-this
  createTreeCellMap({
    rowIndex: t,
    colIndex: n,
    node: r,
    parent: o
  }) {
    return new cx(t, n, r, o);
  }
  /**
   * Returns TreeCellMapI item by key string
   *
   * @param {string} key - map key string
   * @returns {TreeCellMapI|undefined} - TreeCellMapI instance or undefined
   *
   * @private
   */
  getItemByKey(t) {
    return this.map[t];
  }
  /**
   * Returns TreeCellMapI item by (row, col) coordinate
   *
   * @param {number} row - cell row index
   * @param {number} col - cell column index
   * @returns {TreeCellMapI|undefined} - TreeCellMapI instance or undefined
   *
   * @private
   */
  getItem(t, n) {
    const r = Hr(t, n);
    return this.getItemByKey(r);
  }
}
class hr extends wx {
}
class no extends Error {
  constructor(t = "Loading canceled") {
    super(t), this.name = "LoadingCanceledError";
    const n = new.target.prototype;
    Object.setPrototypeOf && Object.setPrototypeOf(this, n);
  }
}
class rf {
  constructor(t = [], n) {
    I(this, "divergence", 0);
    const r = n ? n.getDivergence() : 0, o = se.getLastLevelNodes(t);
    this.divergence = (r + o.length) % 2;
    for (let i = 0; i < o.length; i += 1)
      o[i].indexDivergence = (i + r) % 2;
  }
  getDivergence() {
    return this.divergence;
  }
}
function Ba(e = []) {
  const t = {};
  return e.forEach((n) => {
    const { index: r = 1 / 0 } = n.field || {}, o = `${r}`;
    t[o] = n.jaql.datatype || $n.TEXT;
  }), t;
}
function Ru(e, t) {
  if (e && t === $n.DATETIME)
    try {
      return new Date(e).toISOString();
    } catch (n) {
      return e;
    }
  return e;
}
function of(e) {
  if (e !== null && !_u(e, {}))
    return e;
}
function da(e, t, n = {}) {
  const r = of(e), o = of(t);
  let i = !1;
  if (typeof r == "object" && r !== null && typeof o == "object" && o !== null) {
    i = !0;
    const s = Object.keys(r), a = Object.keys(o);
    s.length !== a.length ? i = !1 : s.forEach((u) => {
      const l = n[u] || "";
      let d = (r || {})[u], p = (o || {})[u];
      if (typeof d == "undefined" || typeof p == "undefined") {
        i = !1;
        return;
      }
      l === $n.DATETIME && (d = Ru(d, l), p = Ru(p, l)), d !== p && (i = !1);
    });
  } else
    i = r === o;
  return i;
}
function Ly(e, t, n = Ru) {
  if (!e || typeof e != "object")
    return e;
  const r = {};
  return Object.keys(e).forEach((o) => {
    const i = t[o], s = (e || {})[o], a = n(s, i);
    r[o] = a;
  }), r;
}
const Bn = (e, t) => {
  let n = e && e.metadata || [];
  return t && (n = n.filter((r) => r.panel === t)), n.sort((r, o) => {
    const i = { index: 1 / 0 }, s = r.field || i, a = o.field || i;
    return s.index - a.index;
  }), n;
}, ji = (e, t, n) => typeof t == "undefined" ? void 0 : Bn(e, n).filter((i) => (i.field || { index: 1 / 0 }).index === t)[0], _x = (e, t) => {
  const n = e.field || { index: 1 / 0 };
  if (e.panel === Ce.MEASURES)
    return !0;
  if (e.panel === Ce.ROWS) {
    const r = Bn(t, Ce.ROWS), i = (r[r.length - 1] || {}).field || { index: 1 / 0 };
    if (r.length && i.index === n.index)
      return !0;
    r.length || console.error("Missing rows panel in jaql!");
  }
  return !1;
};
function xx(e, t) {
  return !e || typeof e.field != "number" ? !1 : e.field !== t;
}
const Tx = (e, t = Ce.ROWS) => {
  const r = Bn(e, t).map((o, i) => {
    const s = se.create(o.jaql.title, void 0, void 0, i), a = St(s, t);
    switch (a.jaqlIndex = o.field ? o.field.index : void 0, t) {
      case Ce.ROWS: {
        a.measurePath = void 0;
        const u = xx(
          o.jaql.sortDetails,
          a.jaqlIndex
        );
        o.jaql.sort && !u ? a.dir = o.jaql.sort : a.dir = null;
        break;
      }
      case Ce.MEASURES:
        a.databars = o.format ? o.format.databars : !1, a.measureJaqlIndex = a.jaqlIndex, Bn(e, Ce.COLUMNS).length || (a.measurePath = void 0, o.jaql.sortDetails && o.jaql.sortDetails.measurePath === null ? a.dir = o.jaql.sortDetails.dir : a.dir = null);
        break;
    }
    return a;
  });
  return se.wrapInRootNode(r);
}, Dy = (e) => {
  (e && e.metadata ? e.metadata : []).forEach((n) => {
    n && n.jaql && n.jaql.sort && n.jaql.sortDetails && n.jaql.sortDetails.sortingLastDimension && (n.jaql.sort = null, delete n.jaql.sortDetails);
  });
}, By = (e) => {
  e && e.jaql && (e.jaql.sort = null, delete e.jaql.sortDetails);
}, Fy = (e) => {
  (e && e.metadata ? e.metadata : []).forEach((n) => By(n));
}, Ex = (e) => (e.metadata || []).reverse().find((t) => !!t.jaql.sortDetails), Rx = (e) => (e.metadata || []).find(
  (t) => !!(t.jaql.sortDetails && t.jaql.sortDetails.isLastApplied)
), Ox = (e) => {
  const t = Rx(e) || Ex(e);
  if (!t)
    return;
  const n = t.field && t.field.index;
  (e.metadata || []).forEach((r) => {
    (r.field && r.field.index) !== n && By(r);
  });
}, zy = (e, t) => {
  e.metadata.forEach((n) => {
    const r = n.field && n.field.index;
    if (t.field === r) {
      n.jaql.sortDetails = n.jaql.sortDetails || t, n.jaql.sortDetails.isLastApplied = !0;
      return;
    }
    n.jaql.sortDetails && n.jaql.sortDetails && delete n.jaql.sortDetails.isLastApplied;
  });
}, Px = (e, t, n) => {
  const { isSingleRowTree: r = !1, formatter: o } = n || {};
  if (!t) {
    console.warn("jaql is undefined or null!");
    return;
  }
  const i = ji(t, e.field);
  if (i && i.panel === Ce.COLUMNS) {
    console.warn('Should not be sorted by "COLUMN" type panels!');
    return;
  }
  if (!i)
    return;
  const s = _x(i, t);
  switch (r ? Fy(t) : s && Dy(t), e.dir) {
    case ct.DESC:
    case null:
      i.jaql.sort = ct.ASC;
      break;
    case ct.ASC:
      i.jaql.sort = ct.DESC;
      break;
    default:
      i.jaql.sort = void 0;
  }
  const a = i.field || { index: 1 / 0 };
  if (i.jaql.sort) {
    let { measurePath: u } = e;
    if (u) {
      const l = Bn(t), d = Ba(l);
      u = Ly(u, d, o);
    }
    i.jaql.sortDetails = {
      field: a.index,
      dir: i.jaql.sort,
      sortingLastDimension: s,
      measurePath: u,
      initialized: !0
    };
  } else
    i.jaql.sortDetails = void 0;
  t && t.metadata && a.index !== void 0 && (t.metadata[a.index] = i), zy(t, e);
}, Ix = (e, t, n) => {
  if (!e)
    return;
  const r = ji(e, t);
  r && (r.format = r.format || {}, r.format.width = n);
}, Nx = (e) => {
  const t = {};
  return e && Bn(e).forEach((r) => {
    const o = r.field || { index: 1 / 0 };
    r.format && typeof r.format.width != "undefined" && typeof o.index != "undefined" && (t[o.index] = r.format.width);
  }), t;
}, Mx = (e, t) => {
  if (typeof t.measureJaqlIndex != "undefined") {
    const n = Bn(e), r = Ba(n), o = n.filter((s) => s.panel === Ce.ROWS).find((s) => {
      const a = s.jaql.sortDetails;
      return !a || !(a.field === t.measureJaqlIndex) ? !1 : !!da(t.measurePath, a.measurePath, r);
    });
    if (o) {
      t.dir = o.jaql.sort ? o.jaql.sort : null;
      return;
    }
    const i = ji(e, t.measureJaqlIndex);
    if (i && i.jaql.sortDetails) {
      const s = i.jaql.sortDetails.measurePath, a = t.measurePath;
      if (da(s, a, r)) {
        t.dir = i.jaql.sort || null;
        return;
      }
    }
  }
  t.dir = null;
};
function kx(e, t, n, r) {
  const { isSingleRowTree: o, formatter: i } = r;
  o && Fy(e), e.metadata.forEach((s) => {
    s.jaql.sortDetails && delete s.jaql.sortDetails.isLastApplied;
  }), t.forEach((s, a) => {
    let u;
    a === t.length - 1 ? (s.selected && Dy(e), u = n.field) : u = s.indexInJaql;
    const l = ji(e, u);
    if (!l) {
      console.warn(new Error("Panel not found"));
      return;
    }
    s.selected && !s.direction && console.warn(new Error("Direction should be defined and equal to 'asc' or 'desc'"));
    const d = Bn(e), p = Ba(d);
    if (!s.direction || !s.selected) {
      const { sortDetails: f } = l.jaql;
      !!(f && n.field === f.field && da(
        n.measurePath,
        f.measurePath,
        p
      )) && (delete l.jaql.sort, delete l.jaql.sortDetails);
    }
    if (s.selected && s.direction) {
      l.jaql.sort = s.direction;
      let { measurePath: f } = n;
      f && (f = Ly(f, p, i)), n.measurePath === void 0 && l.field && // for type checker
      l.panel === "rows" && n.field !== l.field.index && (f = {}), l.jaql.sortDetails = {
        field: n.field,
        dir: s.direction,
        sortingLastDimension: !1,
        // TODO: find out should it be true?
        measurePath: f,
        isLastApplied: !0,
        initialized: !0
      };
    }
  });
}
function Ax(e, t, n, r) {
  return e.jaql.sortDetails ? !1 : n ? ut.isMeasurePathEqual(
    t.measurePath,
    n.measurePath,
    r
  ) : !1;
}
function Ou(e) {
  const t = e && e.dir;
  switch (t) {
    case "asc":
    case "desc":
      return t;
    default:
      return null;
  }
}
function $x(e, t) {
  var f, h;
  const n = e.metadata.filter((g) => g.panel === "rows"), r = ut.getMetadataPanelByIndex(
    e,
    t.field
  ), o = r.jaql.datatype, i = r.jaql.sortDetails, s = ut.getDataTypes(ut.getMetadataPanels(e)), a = [];
  for (let g = 0; g < n.length - 1; g += 1) {
    const m = n[g], v = !!(m.jaql.sortDetails && m.jaql.sortDetails.field === t.field && ut.isMeasurePathEqual(
      t.measurePath,
      m.jaql.sortDetails.measurePath,
      s
    )), S = Ou(m.jaql.sortDetails);
    a.push({
      title: m.jaql.title,
      // `datatype` should correspond to datatype of value column on which
      //   sorting settings was called
      datatype: o,
      selected: v,
      direction: S,
      indexInJaql: (f = m.field) == null ? void 0 : f.index
    });
  }
  const u = n[n.length - 1], l = Ax(
    u,
    t,
    i,
    s
  ), d = Ou(i), p = {
    title: u.jaql.title,
    // `datatype` should correspond to datatype of value column on which
    //   sorting settings was called
    datatype: o,
    selected: l,
    direction: d,
    indexInJaql: (h = r.field) == null ? void 0 : h.index
  };
  return a.push(p), a;
}
function Lx(e, t, n) {
  return e.filter((o) => o.field && t.field === o.field.index).map((o) => {
    const { sortDetails: i } = o.jaql, s = !!(i && ut.isMeasurePathEqual(
      t.measurePath,
      i.measurePath,
      n
    )), a = s ? Ou(i) : null;
    return {
      title: o.jaql.title,
      // TODO: remove `as` type assertion
      datatype: o.jaql.datatype,
      selected: s,
      direction: a
    };
  })[0];
}
const ut = {
  isMeasurePathEqual: da,
  getDataTypes: Ba,
  updatePanelsSortingMetadata: Px,
  getMetadataTree: Tx,
  getMetadataPanels: Bn,
  getMetadataPanelByIndex: ji,
  setResizeWidthToJaql: Ix,
  getResizeWidthFromJaql: Nx,
  markSortedNode: Mx,
  normalizeSingleBranchTreeSortDetails: Ox,
  updateLastAppliedSortingFlag: zy,
  handleComplexSortingSettingsUpdate: kx,
  mapWidgetJaqlToSimpleSortingSettings: Lx,
  mapWidgetJaqlToComplexSortingSettings: $x
};
function jy(e, t) {
  if (!se.hasChildren(e))
    return !1;
  let n = !1;
  t === Ce.COLUMNS && e && e.isPart && (n = !0);
  const r = se.getChildren(e);
  if (r.length > 1 || n)
    return !0;
  const [o] = r;
  return jy(o);
}
function Dx(e) {
  return e == null;
}
const xd = (e, t, n, r, o) => {
  const i = [];
  return e.forEach((s) => {
    if (i.push(s), se.hasChildren(s)) {
      const a = se.getChildren(s), u = xd(
        a,
        t,
        n,
        r,
        o
      );
      se.setChildren(s, u);
      let l = !1;
      if ((o || jy(s, n)) && (n === Ce.COLUMNS ? typeof s.index != "undefined" && s.index > -1 && (l = !0) : n === Ce.ROWS && typeof s.data != "undefined" && (l = !0)), l) {
        const { value: d, index: p, data: f, jaqlIndex: h, measurePath: g } = s;
        let m;
        if (n === Ce.COLUMNS ? m = se.create(d, void 0, void 0, p) : n === Ce.ROWS && (m = se.create(d, void 0, f)), m) {
          const v = St(m, n);
          v.userType = et.SUB_TOTAL, v.jaqlIndex = h, v.measurePath = g, v.master = s, i.push(v);
        }
      }
    }
  }), i;
}, Hy = (e, t) => {
  e.userType === et.SUB_TOTAL && e.master && (e.measurePath = e.master.measurePath);
}, Wy = (e, t, n, r) => {
  const o = e;
  if (n === Ce.COLUMNS && t) {
    const i = St(t);
    if (typeof i.index == "number") {
      const a = ut.getMetadataTree(r, Ce.MEASURES);
      se.getChildren(a).forEach((u, l) => {
        const d = L(C({}, u), {
          index: (i.index || 0) + l
        }), p = St(d, n);
        p.userType = et.GRAND_TOTAL, p.measureJaqlIndex = p.jaqlIndex, o.push(p);
      });
    }
  }
  return o;
}, Vy = (e, t) => {
  e.userType === et.GRAND_TOTAL && (e.measurePath = void 0, e.metadataType === Ce.ROWS && (e.parent = void 0, e.jaqlIndex = 0));
}, Uy = (e, t, n, r) => {
  let o = e;
  if (n === Ce.COLUMNS) {
    const i = ut.getMetadataTree(r, Ce.MEASURES), s = se.getChildLength(i), a = { maxLevel: 0 }, u = se.getLastLevelNodes(o, [], 0, a);
    if (s > 1)
      u.forEach((l) => {
        if (l.userType === et.GRAND_TOTAL)
          return;
        const d = se.getChildren(i), p = [];
        for (let f = 0; f < d.length; f += 1) {
          if (typeof l.maxChilds == "number" && f >= l.maxChilds)
            continue;
          const h = L(C({}, d[f]), {
            index: (l.index || 0) + f,
            measurePath: l.measurePath
          }), g = St(h, Ce.MEASURES);
          g.userType = et.MEASURE_BOTTOM, g.measureJaqlIndex = g.jaqlIndex, p.push(g);
        }
        l.minLevel = a.maxLevel, se.setChildren(l, p);
      });
    else if (s === 1) {
      const l = se.getChildren(i)[0];
      if (l) {
        const d = C({}, l), p = St(d, Ce.MEASURES);
        p.userType = et.MEASURE_TOP, se.setChildren(p, o), o = [p], u.forEach((f) => {
          f.measureJaqlIndex = l.jaqlIndex;
        });
      }
    }
  }
  return o;
}, qy = (e, t) => {
  !se.hasChildren(e) && typeof e.measureJaqlIndex != "undefined" && ut.markSortedNode(t, e);
}, Bx = (e, t, n, r) => {
  let o = {};
  if (t.userType === et.SUB_TOTAL || t.userType === et.GRAND_TOTAL || n.userType === et.SUB_TOTAL || n.userType === et.GRAND_TOTAL || n.parent && n.parent.userType === et.SUB_TOTAL || n.parent && n.parent.userType === et.GRAND_TOTAL)
    return;
  const i = r && r.format && r.format.color || null;
  if (!i)
    return;
  const { value: s, cf: a = -1 } = e;
  if (i.type === Zp.COLOR && i.color && i.color !== "transparent" && (o.backgroundColor = i.color), i.type === Zp.CONDITION && i.conditions && i.conditions.length)
    for (let u = 0, l = i.conditions.length; u < l && !Dx(s); u += 1) {
      const d = i.conditions || [], { color: p } = d[u] || {};
      if (p && a === u) {
        o.backgroundColor = p;
        break;
      }
    }
  Object.keys(o).length > 0 && (e.style = e.style || {}, Object.assign(e.style, o)), o = void 0;
}, Gy = (e, t, n, r) => {
  const o = [], { level: i = 0, measurePath: s = {} } = r || {};
  let a;
  Array.isArray(e) ? a = e : a = se.getChildren(e);
  const l = ut.getMetadataPanels(n, t)[i], d = l ? (l.field || { index: 1 / 0 }).index : void 0;
  return a.forEach((p) => {
    const f = St(p, t);
    if (f.jaqlIndex = d, typeof d != "undefined" && (f.measurePath = L(C({}, s), {
      [d]: f.value
    })), o.push(f), se.hasChildren(f)) {
      const h = se.getChildren(f), g = {
        level: i + 1,
        measurePath: f.measurePath
      }, m = Gy(h, t, n, g);
      se.setChildren(f, m);
    }
  }), o;
}, Ky = (e, t, n) => {
  const { skipFormatEvent: r = !1, onlyFormatEvents: o = !1, iterateFn: i, emitFn: s } = n || {};
  e.forEach((a) => {
    if (i && i(a), (r || !o) && (Hy(a), Vy(a), qy(a, t)), s && (o || !r)) {
      const u = ut.getMetadataPanelByIndex(
        t,
        a.jaqlIndex,
        a.metadataType || ""
      );
      s(a, u, t);
    }
    if (se.hasChildren(a)) {
      const u = se.getChildren(a);
      Ky(u, t, n);
    }
  });
}, Fx = (e, t, n, r) => {
  const { originalData: o, applyIndexDivergence: i, subtotalsForSingleRow: s } = r || {};
  i && i(e);
  let a = xd(e, o, t, n, s);
  return a = Wy(a, o, t, n), a = Uy(a, o, t, n), se.iterateThroughTree(a, (u, l) => {
    u.parent = l;
  }), a;
}, zo = {
  insertSubTotals: xd,
  postProcessSubTotal: Hy,
  insertGrandTotals: Wy,
  postProcessGrandTotal: Vy,
  insertMeasureNodes: Uy,
  postProcessMeasureNode: qy,
  applyColorFormatting: Bx,
  preProcessTree: Gy,
  modifyTree: Fx,
  postProcessTree: Ky
}, St = (e, t) => {
  const n = e;
  return t && (n.metadataType = t), n;
};
function uo(e, t, n) {
  return !t || !t.length ? !1 : t.some((r) => {
    let o = !0;
    return n && n.fields && n.fields.length && n.fields.forEach((i) => {
      e[i] !== void 0 && r[i] === void 0 ? o = !1 : e[i] !== void 0 && r[i] !== void 0 && (Array.isArray(e[i]) ? o = o && e[i].indexOf(r[i]) !== -1 : o = o && e[i] === r[i]);
    }), o;
  });
}
const zx = (e, t = []) => {
  let n = !1;
  return !t || !t.length ? !1 : e.length === 0 ? !0 : (e.forEach((r) => {
    t.includes(r) && (n = !0);
  }), n);
}, sf = (e, t) => {
  let n = !0;
  return !t || !t.length ? n = !1 : e.forEach((r) => {
    if (r.index) {
      const o = t[t.length - 1];
      n = n && uo(r, [o], { fields: [tr.INDEX] });
    }
    if (r.dim && (r.name = r.dim, r.members && (r.member = r.members), n = n && uo(r, t, {
      fields: [tr.NAME, tr.MEMBER]
    })), r.title) {
      const o = t[t.length - 1];
      n = n && uo(r, [o], { fields: [tr.TITLE] });
    }
  }), n;
}, jx = (e, t) => {
  let n = !0;
  return !t || !t.length ? n = !1 : e.forEach((r) => {
    r.index && (n = n && uo(r, t, { fields: [tr.INDEX] })), r.dim && (r.name = r.dim, n = n && uo(r, t, {
      fields: [tr.DIM, tr.AGG]
    })), r.title && (n = n && uo(r, t, { fields: [tr.TITLE] }));
  }), n;
}, Hx = (e, t) => {
  let n = !0;
  if (e.type && n && (n = n && zx(e.type, t.type)), e.rows && e.rows.length && n) {
    const r = t.rows ? t.rows : [];
    n = n && sf(e.rows, r);
  }
  if (e.columns && n) {
    const r = t.columns ? t.columns : [];
    n = n && sf(e.columns, r);
  }
  if (e.values && n) {
    const r = t.measure ? [t.measure] : [];
    n = n && jx(e.values, r);
  }
  return n;
}, Wx = (e, t) => e.metadata.find((n) => n.field && n.field.index === t), Ks = (e, t, n = [], r = []) => {
  if (!t || !e || typeof e.jaqlIndex == "undefined")
    return { dimensionsMeta: n, type: r };
  const o = Wx(t, e.jaqlIndex);
  if (o && o.jaql && e.metadataType !== Ce.MEASURES && n.unshift({
    title: o.jaql.title,
    name: o.jaql.dim,
    member: e.value,
    index: e.jaqlIndex
  }), e && e.userType && (e.userType === et.SUB_TOTAL || e.userType === et.GRAND_TOTAL)) {
    const i = e.userType.toLowerCase();
    r.push(i);
  }
  return e.parent && e.parent.metadataType !== Ce.MEASURES ? Ks(e.parent, t, n, r) : { dimensionsMeta: n, type: r };
}, af = (e) => {
  let t = {};
  if (e) {
    const n = e.jaql, { type: r, datatype: o, table: i, column: s } = n;
    t = re(n, ["type", "datatype", "table", "column"]), e.field && (t.index = e.field.index);
  }
  return t;
}, Ct = {
  CORNER: "corner",
  COLUMNS: "columns",
  ROWS: "rows",
  DATA: "data"
};
function Al(e, t = "", n = "") {
  let r = "";
  return e && (e.levels.length && e.levels.forEach((o) => {
    r += ` ${t}--${n ? `${n}-` : ""}level-${o}`;
  }), e.siblings.length && e.siblings.forEach((o) => {
    r += ` ${t}--${n ? `${n}-` : ""}sibling-${o}`;
  }), e.root && e.root.siblings && e.root.siblings.length && e.root.siblings.forEach((o) => {
    r += ` ${t}--${n ? `${n}-root-` : "root-"}sibling-${o}`;
  }), e.parent && e.parent.siblings && e.parent.siblings.length && e.parent.siblings.forEach((o) => {
    r += ` ${t}--${n ? `${n}-parent-` : "parent-"}sibling-${o}`;
  })), r;
}
function Vx(e, t) {
  const { metadata: n, rowMetadata: r, rowTreeNode: o, columnTreeNode: i, merge: s } = t || {}, a = {
    t: !0,
    r: !0,
    b: !0,
    l: !0
  };
  if (e === Ct.CORNER || e === Ct.COLUMNS)
    return a;
  if (e === Ct.ROWS) {
    const u = s && s.colSpan, l = n && n.nextNode && n.nextNode.userType === et.GRAND_TOTAL;
    n && n.levels.includes(bt.LAST) && !n.siblings.includes(bt.LAST) && !u && !l && (a.b = !1), n && n.levels.includes(bt.FIRST) && n.levels.includes(bt.LAST) && !n.siblings.includes(bt.LAST) && !u && !l && (a.b = !1);
  }
  if (e === Ct.DATA) {
    const u = o && o.userType === et.SUB_TOTAL, l = i && i.userType === et.SUB_TOTAL, d = i && i.userType === et.GRAND_TOTAL, p = r && r.nextNode && r.nextNode.userType === et.GRAND_TOTAL;
    r && r.levels.includes(bt.LAST) && !r.siblings.includes(bt.LAST) && !u && !l && !d && !p && (a.b = !1);
  }
  return a;
}
function $l(e, t = "", n = "") {
  let r = "";
  return e && e.userType && (r = `${t}--${n ? `${n}-` : ""}user-type-${e.userType}`), r;
}
function Ll(e, t = "", n = "") {
  let r = "";
  return e && e.colSpan && (r = `${t}--${n ? `${n}-` : ""}merged-columns`), e && e.rowSpan && (r = ` ${t}--${n ? `${n}-` : ""}merged-rows`), r;
}
function Dl(e) {
  return e && e.colSpan ? e.colSpan - 1 : 0;
}
function lf(e, t) {
  if (e === void 0)
    return e;
  let n = typeof e == "number" ? e : parseInt(e, 10);
  return n -= t || 1, n;
}
function jo(e) {
  const { isDataCell: t, dataNode: n, treeNode: r } = e, o = t ? n : r;
  return o && o.style || {};
}
const Ux = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    (!n.startsWith("border") || n === "borderColor") && (t[n] = e[n]);
  }), t;
}, qx = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    (!n.startsWith("color") && !n.startsWith("padding") && !n.startsWith("border") && !n.startsWith("font") && !n.startsWith("lineHeight") && !n.startsWith("databarColor") || n === "borderColor") && (t[n] = e[n]);
  }), t;
}, Gx = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    (n.startsWith("color") || n.startsWith("padding") || n.startsWith("font") || n.startsWith("lineHeight")) && (t[n] = e[n]);
  }), t;
}, Kx = (e) => {
  const t = {};
  return e.databarColor && (t.backgroundColor = e.databarColor), t;
}, Yx = (e, t, n = 0) => t && e && t.offsetWidth + n >= e.offsetWidth && t.textContent || "", Xx = (e, t, n) => {
  if (!e || !t || !n || n.measureJaqlIndex === void 0)
    return;
  const [r, o] = e[n.measureJaqlIndex] || [];
  if (r == null)
    return;
  const i = t && t.store && t.store.compileRange, s = t && t.store && t.store.compileRangeContext, a = t && t.store && t.store.compileRangeArgs;
  if (!i || !a || !s || !t || !t.value)
    return;
  const u = L(C({}, a), {
    minvalue: r,
    midvalue: r + (o - r) / 2,
    maxvalue: o
  });
  let l, d;
  return u.min === void 0 && (u.maxvalue <= 0 && (d = !0), u.min = u.minDef), u.max === void 0 && (u.minvalue >= 0 && (l = !0), u.max = u.maxDef), d && (u.max = u.maxGray), l && (u.min = u.minGray), i.call(s, u)(t.value);
}, Ho = "text";
class Td {
  constructor(t, n, r) {
    /**
     * Handlers to apply for pivot cells
     *
     * @private
     * */
    I(this, "plugins", []);
    /** @private global plugins config */
    I(this, "globalStyles");
    /** @private */
    I(this, "jaql");
    /**
     * Object to store indexes for data groups
     */
    I(this, "indexHelper");
    /**
     * Cache columns metadata after handling column tree node
     *
     * @private
     * */
    I(this, "columnsMetadata", []);
    I(this, "metadataCache", /* @__PURE__ */ new Map());
    this.plugins = t, this.jaql = n, this.globalStyles = r, this.indexHelper = {
      measuresLevel: this.getMeasuresLevel(),
      columnStartFrom: 0,
      rowStartFrom: 0
    }, this.globalStyles && (this.globalStyles = Ux(this.globalStyles));
  }
  /**
   * Get array of panels by type
   *
   * @param {ListOfPanelTypes} jaqlPanel - type of panels to return measures|columns|rows
   * @returns {Array<any>} row level of measures in column tree
   */
  getJaqlPanels(t) {
    if (!this.jaql)
      throw new Error("No Jaql in Plugin service!");
    return this.jaql.metadata.filter((n) => n.panel === t);
  }
  /**
   * Calculate level of measures in column tree
   *
   * @returns {number} row level of measures in column tree
   */
  getMeasuresLevel() {
    const t = this.getJaqlPanels(Ce.COLUMNS);
    return this.getJaqlPanels(Ce.MEASURES).length > 1 ? t.length : 0;
  }
  /**
   * Get count of row panels
   *
   * @returns {void}
   */
  getRowsColumnLength() {
    return this.getJaqlPanels(Ce.ROWS).length;
  }
  /**
   * Get count of row panels
   *
   * @param {Array<string>} types - array of types from current cell
   * @returns {void}
   */
  // eslint-disable-next-line class-methods-use-this
  getTotalTypes(t) {
    const n = t.filter(
      (r) => r === jr.SUB_TOTAL || r === jr.GRAND_TOTAL
    );
    return n && n.length ? n.filter((r, o, i) => i.indexOf(r) === o) : [];
  }
  /**
   * Calculate measure index and get panel metadata
   *
   * @param {number} index - measure index in row
   * @returns {MeasureMetadata} measure metadata
   */
  getMeasureMetaByIndex(t) {
    const n = this.getJaqlPanels(Ce.MEASURES);
    if (n.length === 1)
      return af(n[0]);
    const r = t % n.length;
    return af(n[r]);
  }
  resetRowStartFrom() {
    this.indexHelper.rowStartFrom = 1;
  }
  applyToColumns(t) {
    t.length !== 0 && (this.indexHelper.columnStartFrom === 0 && (this.indexHelper.columnStartFrom = this.getRowsColumnLength()), this._applyToColumns(t, { row: -1 }));
  }
  /**
   * Apply plugins to columns values and cache metadata for measure handler
   *
   * @param {Array<any>} columnTreeChildren - measure index in row
   * @param {object} indexes - measure index in row
   * @returns {void}
   */
  _applyToColumns(t, n) {
    t.forEach((r, o) => {
      const { dimensionsMeta: i, type: s } = Ks(r, this.jaql);
      s.push(jr.MEMBER);
      let a = n.row >= 0 ? n.row + 1 : 0;
      a >= this.indexHelper.rowStartFrom && (this.indexHelper.rowStartFrom = a + 1), r.metadataType === Ce.MEASURES && (a = this.indexHelper.measuresLevel);
      let u = o === 0 ? 0 : 1;
      u += this.indexHelper.columnStartFrom;
      const l = {
        type: s,
        rowIndex: a,
        colIndex: u,
        index: r.jaqlIndex,
        columns: i
      };
      r.metadataType === Ce.MEASURES && (l.measure = this.getMeasureMetaByIndex(r.index || 0));
      const d = {
        value: r.value || "",
        content: r.content || "",
        contentType: r.contentType || Ho,
        style: r.style || {},
        store: r.store || {},
        state: r.state
      };
      if (this.applyGlobal(d), this.apply(l, d), this.addToMetadata(l, d, l.rowIndex, l.colIndex), Object.assign(r, d), this.indexHelper.columnStartFrom = u, r.children) {
        const p = {
          row: a,
          column: u
        };
        this._applyToColumns(r.children, p);
      } else
        this.columnsMetadata.push({ type: s, metadata: i });
      return !0;
    });
  }
  /**
   * Apply plugins to corner tree headers
   *
   * @param {any} cornerTree - measure index in row
   * @returns {void}
   */
  applyToHeaders(t) {
    !t || !t.children || t.children.length === 0 || t.children.forEach((n) => {
      const { dimensionsMeta: r } = Ks(n, this.jaql), o = {
        type: [jr.MEMBER],
        rowIndex: 0,
        colIndex: n.index || 0,
        index: n.jaqlIndex,
        rows: r
      }, i = {
        value: n.value,
        content: n.content || "",
        contentType: n.contentType || Ho,
        style: n.style ? n.style : {},
        store: n.store || {},
        // eslint-disable-next-line max-lines
        state: n.state
      };
      this.applyGlobal(i), this.apply(o, i), this.addToMetadata(o, i, o.rowIndex, o.colIndex), Object.assign(n, i);
    });
  }
  applyToRows(t) {
    if (t.length === 0)
      return;
    const n = this.getJaqlPanels(Ce.ROWS), r = this.getJaqlPanels(Ce.MEASURES), o = this.getJaqlPanels(Ce.COLUMNS);
    this.indexHelper.rowStartFrom = Td.getRowStartFromForPage(
      n.length,
      r.length,
      o.length
    ), this._applyToRows(t);
  }
  static getRowStartFromForPage(t, n, r) {
    if (t === 0 && r === 0)
      return 0;
    const o = r + (n === 0 ? 0 : 1);
    return o === 0 ? 1 : o;
  }
  /**
   * Apply plugins to rows panels
   *
   * @param {Array<PivotTreeNode>} rowTreeChildren - measure index in row
   * @returns {void}
   */
  _applyToRows(t) {
    t.forEach((n, r) => {
      const { dimensionsMeta: o, type: i } = Ks(n, this.jaql);
      i.push(jr.MEMBER);
      const s = n.level ? n.level : 0, a = r === 0 ? this.indexHelper.rowStartFrom : this.indexHelper.rowStartFrom + 1, u = {
        type: i,
        rowIndex: a,
        colIndex: s,
        index: n.jaqlIndex,
        rows: o
      }, l = {
        value: n.value,
        content: n.content || "",
        contentType: n.contentType || Ho,
        style: n.style || {},
        store: n.store || {},
        state: n.state
      };
      return this.applyGlobal(l), this.apply(u, l), this.addToMetadata(u, l, u.rowIndex, u.colIndex), this.indexHelper.rowStartFrom = a, n.children ? this._applyToRows(n.children) : n.data && n.data.length && this.applyToValues(
        n.data,
        { type: i, metadata: o },
        { rowIndex: a, colIndex: this.getRowsColumnLength() }
      ), Object.assign(n, l), !0;
    });
  }
  /**
   * Apply plugins to value panels
   *
   * @param {Array<any>} values - measure index in row
   * @param {object} rowData - row data
   * @param {Array<string>} rowData.type - row types
   * @param {Array<DimensionMetadata>} rowData.metadata - metadata of current row
   * @param {object} indexes - parent indexes in tree
   * @param {number} indexes.rowIndex - current row index
   * @param {number} indexes.colIndex - colIndex of last row cell to calculate value cell index
   * @returns {void}
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  applyToValues(t, n, r) {
    t.length && t.forEach((o, i) => {
      const s = [jr.VALUE], a = this.columnsMetadata[i];
      if (!a)
        return;
      const u = this.getTotalTypes([...n.type, ...a.type]), l = this.getMeasureMetaByIndex(i), d = {
        type: s.concat(u),
        rows: n.metadata,
        columns: a.metadata,
        measure: l,
        colIndex: i + r.colIndex,
        rowIndex: r.rowIndex,
        index: l && l.index ? l.index : 0
      };
      let p = {
        value: o,
        content: o,
        contentType: Ho,
        style: {},
        store: o && o.store || {},
        state: o && o.state || void 0
      };
      o != null && typeof o == "object" && (p = {
        value: o.value ? o.value : null,
        content: o.content || "",
        contentType: o.contentType || Ho,
        style: o.style || {},
        store: o.store || {},
        state: o.state
      }), this.applyGlobal(p), this.apply(d, p), this.addToMetadata(d, p, d.rowIndex, d.colIndex), t[i] = p;
    });
  }
  /**
   * Add cell metadata to map for click/hover APIs
   *
   * @param {Metadata} metadata - cell metadata
   * @param {CellItem} cellItem - cell content
   * @param {number} rowIndex - cell row index
   * @param {number} colIndex - cell column index
   * @returns {void}
   */
  addToMetadata(t, n, r, o) {
    const i = C({
      cellData: {
        value: n.value,
        content: n.content
      }
    }, t);
    this.metadataCache.set(`${r}-${o}`, i);
  }
  /**
   * Apply global config to cells
   *
   * @param {CellItem} item - cell item to update by plugin
   * @returns {void}
   */
  applyGlobal(t) {
    const { globalStyles: n } = this;
    n && (t.style = C(C({}, t.style), n));
  }
  /**
   * Apply plugins to rows panels
   *
   * @param {Metadata} metadata - cell metadata
   * @param {CellItem} item - cell item to update by plugin
   * @returns {void}
   */
  apply(t, n) {
    this.plugins && this.plugins.length && this.plugins.forEach((r) => {
      if (Hx(r.target, t)) {
        const i = r.handler;
        i(t, n);
      }
    });
  }
}
const Bl = (e, t) => {
  const n = e || { metadata: [], grandTotals: null };
  let { metadata: r } = n;
  return r = r.map((o) => {
    const i = o.field || {}, s = t.find(
      ({ field: u }) => u && u.index === i.index
    ), a = s ? s.format : null;
    return a ? L(C({}, o), { format: a }) : o;
  }), L(C({}, n), { metadata: r });
}, cf = 100, Jx = "dataLoad", Pu = "dataChunkLoaded", Qx = "dataBarChunkLoaded", Zx = "rangeMinMaxChunkLoaded", Iu = "grandChunkLoaded", eT = "dataFinishChunkLoaded", tT = "finishChunkLoaded", Ys = "progressError", uf = "headerCellFormat", nT = "dataCellFormat", Nu = "totalRowsCountLoaded", Mu = "totalColumnsCountLoaded", df = 1e3, rT = 0, oT = {
  throttle: Ry,
  throttleTime: rT,
  PluginService: Td,
  skipInternalColorFormatting: !1,
  subtotalsForSingleRow: !1
};
class Pt {
  // eslint-disable-next-line max-lines-per-function
  constructor(t, n, r, o) {
    /** Logger instance */
    I(this, "logger");
    /**
     *
     *
     * @private
     * EventEmitter instance
     */
    I(this, "events");
    /**
     *
     *
     * @private
     *
     * DataLoadServiceI instance
     */
    I(this, "loadService");
    /**
     *
     *
     * @private
     *
     * configuration options object
     */
    I(this, "options");
    /**
     *
     *
     * @private
     *
     * loaded data chunks group
     */
    I(this, "tempDataChunks", []);
    /**
     *
     * @private
     *
     * last not handled data chunks group index
     */
    I(this, "lastNotHandledChunkIndex", 0);
    /**
     *
     * @private
     *
     * last ready but not handled data chunks group index
     */
    I(this, "lastReadyNotHandledChunkIndex", 0);
    /**
     *
     * @private
     *
     * Current rows nodes
     */
    I(this, "rowsGrand");
    /**
     *
      @private */
    I(this, "rowsTreeService");
    /**
     *
      @private */
    I(this, "columnsTreeService");
    /**
     *
      @private */
    I(this, "cornerTreeService");
    /**
      @private */
    I(this, "pageSize", cf);
    /**
     *
      @private */
    I(this, "isPaginated", !1);
    /**
     *
     * @private
     *
     * number of loaded pages
     */
    I(this, "loadedPagesCount", 0);
    /**
     *
     * @private
     *
     * state for "loadData" method
     */
    I(this, "isLoadInProgress", !1);
    /**
     *
      @private */
    I(this, "loadPromiseResolve");
    /**
     *
      @private */
    I(this, "loadPromiseReject");
    /**
     *
      @private */
    I(this, "loadPromiseCache");
    /**
     *
      @private */
    I(this, "loadAllPromise");
    /**
     *
      @private */
    I(this, "loadAllPromiseResolve");
    /**
     *
      @private */
    I(this, "loadAllPromiseReject");
    /**
     *
     * @private
     *
     * defines if all data is loaded
     */
    I(this, "isWholeDataLoaded", !1);
    /**
     *
     * @private
     *
     * defines that data finish event is happened
     */
    I(this, "hasDataFinishEvent", !1);
    /**
     *
     * @private
     *
     * defines that data handler in progress
     */
    I(this, "isDataHandlerThrottled", !1);
    /**
     *
     * @private
     *
     * throttled data handler
     */
    I(this, "onDataHandlerThrottle");
    /**
     *
     * @private
     *
     * jaql request pure metadata
     */
    I(this, "metadata", []);
    I(this, "dataBars");
    I(this, "rangeMinMax");
    /**
     *
     * @private
     *
     * service for items indexation divergence
     */
    I(this, "divergenceComparator", new rf());
    /**
     *
     * @private
     *
     * service to apply customers plugins
     */
    I(this, "pluginService");
    /**
     *
      @private */
    I(this, "rawJaql");
    /**
     *
     * @private
     *
     * triggered events data storage
     */
    I(this, "triggeredEventsData", {});
    /**
     *
     * @private
     *
     * plugins handlers
     */
    I(this, "callPlugins", []);
    /**
     *
     * @private
     *
     * plugins global styles
     */
    I(this, "globalStyles");
    /**
     *
     * @private
     *
     * actual data columns count
     */
    I(this, "columnsCount");
    /**
     *
     * @private
     *
     * total data columns count
     */
    I(this, "totalColumnsCount");
    /**
     *
     * @private
     *
     * actual data rows count
     */
    I(this, "rowsCount");
    /**
     *
     * @private
     *
     * total data rows count
     */
    I(this, "totalRowsCount");
    /**
     *
     * @private
     *
     * total CVS records count
     */
    I(this, "totalRecordsCount");
    /**
     *
     * @private
     *
     * is rows limit reached
     */
    I(this, "limitReached");
    /**
     * Handler for pivot metadata received event
     *
     * @returns {void}
     */
    I(this, "onMetadataHandler", () => {
      const t = { metadata: this.getMetadata() };
      this.isSingleRowTree() && ut.normalizeSingleBranchTreeSortDetails(t);
    });
    I(this, "onHeadersHandler", (t) => {
      const n = this.getJaql.bind(this), r = this.getRawJaql.bind(this), o = this.applyIndexDivergence.bind(this), i = (d, p, f) => this.emit(uf, d, p, f, this.options), a = Pt.createColumnsTreeServiceBuilder(
        {
          getJaql: n,
          getRawJaql: r,
          pluginService: this.pluginService,
          applyIndexDivergence: o
        },
        {
          emitHeaderCellFormatEvent: i
        }
      )(t);
      this.columnsTreeService = a.columnsTreeService, this.columnsCount = a.columnsCount, this.totalColumnsCount = a.totalColumnsCount, this.emit(Mu, {
        columnsCount: this.columnsCount || 0,
        totalColumnsCount: this.totalColumnsCount || 0
      });
      const u = Pt.createCornerTreeServiceBuilder(
        {
          getJaql: n,
          getRawJaql: r,
          pluginService: this.pluginService,
          columnsTreeService: this.columnsTreeService
        },
        {
          emitHeaderCellFormatEvent: i
        }
      ), { cornerTreeService: l } = u();
      this.cornerTreeService = l;
    });
    I(this, "onDataHandler", (t) => {
      this.tempDataChunks = this.tempDataChunks || [], Array.isArray(t) ? (t || []).forEach((n) => {
        Pt.fillDataChunks(this.tempDataChunks, n, this.pageSize);
      }) : Pt.fillDataChunks(this.tempDataChunks, t, this.pageSize), this.tempDataChunks.length && (this.isDataHandlerThrottled = !0, this.onDataHandlerThrottle());
    });
    I(this, "onGrandHandler", (t) => {
      const r = this.preProcessTree([t], Ce.ROWS)[0], o = "Rows grand total", i = r ? r.data : [], s = se.create(o, void 0, i), a = St(s, Ce.ROWS);
      a.userType = et.GRAND_TOTAL, this.postProcessTree([a]), this.postProcessData([a]), this.rowsGrand = a, this.emit(Iu, se.wrapInRootNode(this.rowsGrand));
    });
    I(this, "onFinishHandler", () => {
      this.emit(tT, {
        totalRows: typeof this.totalRowsCount == "number" ? this.totalRowsCount : this.getTotalItemsCount(),
        // backward compatibility
        totalColumns: typeof this.totalColumnsCount == "number" ? this.totalColumnsCount : this.getLoadedColumnsCount()
        // backward compatibility
      });
    });
    I(this, "onTotalRowsHandler", (t) => {
      const { rowsCount: n, queryRowsCount: r, limitReached: o } = t || {};
      this.totalRowsCount = n, this.totalRecordsCount = r, this.limitReached = o, this.emit(Nu, t);
    });
    I(this, "onDataBarsHandler", (t) => {
      const { data: n = [] } = t;
      let r = 0;
      this.cornerTreeService && (r = this.cornerTreeService.getTreeChildLength()), this.dataBars = [...Array(r), ...n], this.emit(Qx, this.dataBars);
    });
    I(this, "onRangeMinMaxHandler", (t) => {
      const { data: n = [] } = t, r = this.getJaql(), o = ut.getMetadataTree(r, Ce.MEASURES), i = se.getChildren(o), s = [];
      i.forEach((a, u) => {
        s[a.measureJaqlIndex || 0] = n[u];
      }), this.rangeMinMax = s, this.emit(Zx, this.rangeMinMax);
    });
    I(this, "onDataFinishHandler", ({ rowsCount: t } = {}) => {
      if (this.finishRequest(), this.rowsCount = t, this.tempDataChunks.length) {
        const n = this.tempDataChunks[this.tempDataChunks.length - 1];
        n.ready = !0;
      }
      this.onDataHandlerThrottle(), this.checkLoadPromise(), this.emit(eT, {
        limitedRows: this.rowsCount,
        limitedColumns: this.columnsCount
      });
    });
    I(this, "onErrorHandler", (t) => {
      process.env.NODE_ENV !== "production" && this.logger.console.warn(
        `${this.logger.getName()} data loading error "${JSON.stringify(t)}"`
      ), !this.isLoadInProgress && !this.isWholeDataLoaded && !(t instanceof no) && this.emit(Ys, t);
    });
    this.loadService = t, this.events = n || new zi(), this.logger = o || ar.create("DataService"), this.options = C(C({}, oT), r), this.attachEvent(), this.onDataHandlerThrottle = this.options.throttle(() => {
      const i = nf(
        this.tempDataChunks,
        (p) => p.ready && !p.handled,
        this.lastReadyNotHandledChunkIndex
      );
      if (i === -1)
        return;
      this.lastReadyNotHandledChunkIndex = i;
      const s = this.tempDataChunks[i], a = this.preProcessTree(s.list, Ce.ROWS), u = this.modifyTree(a, Ce.ROWS);
      this.postProcessTree(u, { skipFormatEvent: !0 }), this.postProcessData(u, { skipFormatEvent: !0 });
      const l = se.wrapInRootNode(u);
      this.rowsTreeService ? this.rowsTreeService.extend(l) : this.rowsTreeService = new hr(l, !0), this.emit(Pu, this.getLoadedElementsCount()), s.handled = !0;
      const d = nf(
        this.tempDataChunks,
        (p) => !p.handled,
        this.lastNotHandledChunkIndex
      );
      if (d !== -1 ? (this.lastNotHandledChunkIndex = d, this.onDataHandlerThrottle()) : this.isDataHandlerThrottled = !1, this.hasDataFinishEvent && this.tempDataChunks.length) {
        const p = this.tempDataChunks[this.tempDataChunks.length - 1];
        p.ready = !0;
      }
      this.hasDataFinishEvent && d === -1 ? (this.finishRequest(), this.checkLoadPromise()) : this.checkLoadPromise();
    }, this.options.throttleTime);
  }
  destroy() {
    this.detachEvent(), this.rowsGrand = void 0, this.rowsTreeService = void 0, this.columnsTreeService = void 0, this.cornerTreeService = void 0, this.tempDataChunks = [], this.lastNotHandledChunkIndex = 0, this.lastReadyNotHandledChunkIndex = 0, this.events.removeAllListeners();
  }
  /**
   * Subscribe to event notification
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   * @returns {void}
   */
  on(t, n) {
    this.events.on(t, n), this.triggeredEventsData[t] && (this.triggeredEventsData[t].forEach((r) => {
      this.events.emit(t, ...r);
    }), delete this.triggeredEventsData[t]);
  }
  /**
   * Emits event with payload
   *
   * @param {string} eventName - event name to emit
   * @param {Array<any>} payload - event payload
   * @returns {void}
   */
  emit(t, ...n) {
    this.events.listeners(t).length === 0 ? (this.triggeredEventsData[t] = this.triggeredEventsData[t] || [], this.triggeredEventsData[t].push(n)) : this.events.emit(t, ...n);
  }
  /**
   * Unsubscribe from event notification
   *
   * @param {string} eventName - event name to unsubscribe from
   * @param {Function} callback - event handler
   * @returns {void}
   */
  off(t, n) {
    this.events.removeListener(t, n), this.triggeredEventsData[t] && delete this.triggeredEventsData[t];
  }
  /**
   * Initialize start data loading
   *
   * @param {JaqlRequest} [jaql] - JAQL request object
   * @param {object} [options] - additional options
   * @param {number} [options.pageSize=100] - page size to wait
   * @param {boolean} [options.isPaginated=false] - defines which type of treeService to return,
   * partial or paginated
   * @param {Array<JaqlPanel>} [options.metadata] - jaql's metadata
   * @param {boolean} [options.cacheResult=false] - cache result for next call or not
   * @returns {Promise<any>} - promise with initial data to render
   */
  // eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
  loadData(t, n) {
    const {
      pageSize: r = cf,
      isPaginated: o = !1,
      cacheResult: i = !1,
      metadata: s
    } = n || {}, a = this.pageSize === r;
    if (this.clearLoadAllPromise(), t && this.clearCache(), this.pageSize = r, this.isPaginated = o, this.emit(Jx), this.loadPromiseCache && a) {
      const l = Promise.resolve(this.loadPromiseCache);
      return this.loadPromiseCache = void 0, l;
    }
    this.isLoadInProgress = !0, t && (this.metadata = s || [], this.rawJaql = Bl(t, this.metadata), this.initPluginService(this.rawJaql), this.loadService.load(t).then((l) => {
      if (l == null)
        return;
      const d = !("data" in l);
      if (l.dataFinish[0] && d)
        throw {
          error: {
            error: !0,
            details: "metadata undefined."
          }
        };
    }).catch((l) => {
      this.loadPromiseReject && this.loadPromiseReject(l.error);
    }));
    const u = new Promise((l, d) => {
      this.loadPromiseResolve = l, this.loadPromiseReject = d;
    }).then((l) => this.sendInitPage(l)).then((l) => (i && (this.loadPromiseCache = l), this.loadedPagesCount = 1, l)).catch((l) => {
      throw l instanceof no && this.clearLoadPromise(), l;
    });
    return this.checkLoadPromise(), u;
  }
  /**
   * Sets Promise that resolves after all data loaded
   *
   * @returns {Promise<{ loadedRowsCount: number, totalItemsCount: number }>} - promise with
   * loaded items count
   */
  loadAllData() {
    if (this.isWholeDataLoaded) {
      const t = {
        loadedRowsCount: this.getLoadedElementsCount(),
        totalItemsCount: typeof this.totalRowsCount == "number" ? this.totalRowsCount : this.getTotalItemsCount(),
        // backward compatibility
        totalRecordsCount: this.totalRecordsCount,
        limitReached: this.limitReached,
        dataBars: this.dataBars,
        rangeMinMax: this.rangeMinMax
      };
      return this.columnsCount !== 0 && this.totalColumnsCount !== 0 && (t.columnsCount = this.columnsCount, t.totalColumnsCount = this.totalColumnsCount), Promise.resolve(t);
    }
    return this.loadAllPromise || (this.loadAllPromise = new Promise((t, n) => {
      this.loadAllPromiseResolve = t, this.loadAllPromiseReject = n;
    }).then(() => ({
      loadedRowsCount: this.getLoadedElementsCount(),
      totalItemsCount: typeof this.totalRowsCount == "number" ? this.totalRowsCount : this.getTotalItemsCount(),
      // backward compatibility
      totalRecordsCount: this.totalRecordsCount,
      limitReached: this.limitReached,
      dataBars: this.dataBars,
      rangeMinMax: this.rangeMinMax
    })).catch((t) => {
      throw t instanceof no && this.clearLoadAllPromise(), t;
    })), this.loadAllPromise;
  }
  /**
   * public method for selecting page and setting new page size
   *
   * @param {number} selected - page number
   * @param {number} pageSize - set page size (optional)
   * @returns {Promise<{rowsTreeService, columnsTreeService, cornerTreeService, isLastPage}>}
   * - returns private method's call with panel's treeServices
   */
  getSelectedPageData(t, n) {
    return Promise.resolve(this.sendPaginatedPage(t, n));
  }
  /**
   * public method for selecting page by indexes
   *
   * @param {number} from - first row's index
   * @param {number} to - last row's index
   * @param {boolean} lastPage - append grandTotals
   * @returns {Promise<{rowsTreeService, columnsTreeService, cornerTreeService, isLastPage}>}
   * - returns private method's call with panel's treeServices
   */
  getIndexedPageData(t, n, r = !1) {
    return Promise.resolve(this.sendPartialPage(t, n, r));
  }
  /**
   * Returns current jaql request object
   *
   * @returns {JaqlRequest} - jaql request object
   */
  getJaql() {
    return this.loadService.getJaql() || {
      metadata: [],
      grandTotals: null
    };
  }
  /**
   * Defines data structure
   *
   * @returns {boolean} - true - single branch tree
   */
  isSingleRowTree() {
    return this.loadService.isSingleRowTree();
  }
  /**
   * Set cell process handlers
   *
   * @param {Array<PluginConfig>} handlers - object with target and handler
   * @returns {void}
   */
  setPluginHandlers(t) {
    this.callPlugins = t;
  }
  /**
   * Set global styles for all cells
   *
   * @param {GlobalStyles} [styles] - object with target and handler
   * @returns {void}
   */
  setGlobalStyles(t) {
    this.globalStyles = t;
  }
  /**
   * Returns current raw jaql request object
   *
   * @returns {JaqlRequest} - composition of required jaql fields
   * @private
   */
  getRawJaql() {
    return this.rawJaql || this.getJaql();
  }
  /**
   * Returns current jaql request metadata array
   *
   * @returns {Array<JaqlPanel>} - jaql request metadata
   * @private
   */
  getMetadata() {
    return this.metadata.length > 0 ? this.metadata : this.getJaql().metadata;
  }
  /**
   * Pre-process initial tree structure
   *
   * @param {Array<TreeNode>} items - items to normalize
   * @param {string} type - items types to normalize
   * @param {object} options - additional options
   * @param {number} [options.level=0] - tree level, for internal use only
   * @param {object} [options.measurePath={}] - items types to normalize
   * @returns {Array<PivotTreeNode>} - normalized list of items
   */
  preProcessTree(t, n, r) {
    return zo.preProcessTree(t, n, this.getJaql(), r);
  }
  /**
   * Post-process final tree structure with formatting event
   *
   * @param {PivotTreeNode} items - list of PivotTreeNode items
   * @param {object} [options] - additional options
   * @param {boolean} [options.skipFormatEvent] - process tree but skip format event trigger
   * @param {boolean} [options.onlyFormatEvents] - process tree with format event trigger only
   * @param {Function} [options.iterateFn] - iterate function to call for each tree node
   * @returns {void}
   */
  postProcessTree(t, n) {
    const r = (i, s, a) => this.emit(uf, i, s, a, this.options), o = L(C({}, n || {}), { emitFn: r });
    return zo.postProcessTree(t, this.getRawJaql(), o);
  }
  /**
   * Post-process data list with formatting event
   *
   * @param {PivotTreeNode} items - list of PivotTreeNode rows items
   * @param {object} [options] - additional options
   * @param {boolean} [options.skipFormatEvent] - process data list but skip format event trigger
   * @param {boolean} [options.onlyFormatEvents] - process data list with format event
   * trigger only
   * @returns {void}
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  postProcessData(t, n) {
    const { skipFormatEvent: r = !1, onlyFormatEvents: o = !1 } = n || {}, i = this.columnsTreeService ? this.columnsTreeService.getLastLevelNodes() : [], s = se.getLastLevelNodes(t), a = this.getRawJaql();
    r || s.forEach((u) => {
      const l = St(u);
      i.forEach((d) => {
        const p = St(d), f = ut.getMetadataPanelByIndex(
          a,
          p.measureJaqlIndex,
          Ce.MEASURES
        );
        if (typeof l.data != "undefined" && typeof p.index != "undefined") {
          const { data: h = [] } = l, { index: g } = p, m = h[g], v = typeof m == "object" && m !== null && m !== void 0 ? m : { value: m };
          if (h[g] = v, o || !r) {
            const { skipInternalColorFormatting: S = !1 } = this.options;
            S || zo.applyColorFormatting(v, l, p, f), this.emit(
              nT,
              v,
              l,
              p,
              f,
              a,
              this.options
            );
          }
        }
      });
    });
  }
  /**
   * Modify tree structure for subtotals and grand totals and some customization
   *
   * @param {Array<PivotTreeNode>} items - base items to modify
   * @param {string} type - items types to normalize
   * @param {TreeNode} originalData - initial data object
   * @returns {PivotTreeNode | Array<PivotTreeNode>} - normalized list of items
   */
  modifyTree(t, n, r) {
    const o = this.getJaql();
    return zo.modifyTree(t, n, o, {
      originalData: r,
      applyIndexDivergence: this.applyIndexDivergence.bind(this),
      subtotalsForSingleRow: this.options.subtotalsForSingleRow
    });
  }
  /**
   * method calculates divergence by prev indexes
   *
   * @param {Array<PivotTreeNode>} items - data to modify divergence and apply
   * @returns {void}
   * @private
   */
  applyIndexDivergence(t) {
    this.divergenceComparator = new rf(t, this.divergenceComparator);
  }
  /**
   * method creates plugin service instance for pivot
   *
   * @param {JaqlRequest} jaql - data to modify divergence and apply
   * @returns {void}
   * @private
   */
  initPluginService(t) {
    this.pluginService = new this.options.PluginService(this.callPlugins, t, this.globalStyles);
  }
  /**
   * Cancel current loading process
   *
   * @returns {void}
   */
  cancelLoading() {
    const t = new no();
    this.loadPromiseReject && typeof this.loadPromiseReject == "function" && this.loadPromiseReject(t), this.loadAllPromiseReject && typeof this.loadAllPromiseReject == "function" && this.loadAllPromiseReject(t), this.detachEvent();
  }
  /**
   * Returns final page size, excluding grand totals rows for example
   *
   * @returns {number} - page size
   * @private
   */
  getPageSize() {
    return this.pageSize;
  }
  /**
   *
   * Send result for "loadData" function after promise resolve
   *
   * @param {number} loadedCount - count of already loaded rows
   * @returns {{
   *     rowsTreeService: TreeServiceI,
   *     columnsTreeService: TreeServiceI,
   *     corner: TreeNode,
   *     values: TreeNode,
   *     cellsMetadata: Map<string, Metadata>
   * }} - object with initial data
   * @private
   */
  sendInitPage(t) {
    if (this.loadService.hasError() || !this.loadService.hasData())
      return Pt.getEmptyPage();
    let n, r;
    const o = this.getPageSize();
    if (this.rowsTreeService) {
      const a = o > t ? t : o, u = Pt.cloneTreeNode, l = this.rowsTreeService.getPartialTree(0, a, { cloneFn: u });
      this.rowsGrand && l.push(It(this.rowsGrand)), this.postProcessTree(l, {
        onlyFormatEvents: !0,
        iterateFn: se.clearNodeCache
      }), this.postProcessData(l, { onlyFormatEvents: !0 });
      const d = this.rowsTreeService ? this.rowsTreeService.getTreeDeepsLength() : 0, p = se.wrapInRootNode(l);
      this.pluginService && p && p.children && (this.pluginService.applyToRows(p.children), r = this.pluginService.metadataCache), n = new hr(p, !0, d), n.hasGrandTotals = !!this.rowsGrand;
    }
    const i = this.isWholeDataLoaded && o >= t;
    return {
      rowsTreeService: n,
      columnsTreeService: this.columnsTreeService,
      cornerTreeService: this.cornerTreeService,
      isLastPage: i,
      cellsMetadata: r
    };
  }
  /**
   * Sets Page Size and returns Tree Services
   *
   * @param {number} selected - page number -- STARTING FROM 0
   * @param {number} [newPageSize] - set new pageSize
   * @returns {{
   *     rowsTreeService: null,
   *     columnsTreeService: TreeServiceI,
   *     cornerTreeService: TreeServiceI,
   *     isLastPage: boolean
   * }} - returns panel's treeServices
   * @private
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  sendPaginatedPage(t, n) {
    if (this.loadService.hasError() || !this.loadService.hasData())
      return Pt.getEmptyPage();
    n && (this.pageSize = n);
    const r = this.getPageSize(), o = this.getLoadedElementsCount();
    if (t * r >= o)
      throw new Error("Selected page is out of elements range!");
    if (t < 0)
      throw new Error("Selected page must be >= 0");
    let i, s;
    if (this.rowsTreeService) {
      const a = t >= 0 ? t * r : 0, u = (t + 1) * r > o ? o : (t + 1) * r, l = Pt.cloneTreeNode, d = this.rowsTreeService.getPartialTree(a, u, { cloneFn: l });
      this.rowsGrand && d.push(It(this.rowsGrand)), this.postProcessTree(d, {
        onlyFormatEvents: !0,
        iterateFn: se.clearNodeCache
      }), this.postProcessData(d, { onlyFormatEvents: !0 });
      const p = this.rowsTreeService ? this.rowsTreeService.getTreeDeepsLength() : 0, f = se.wrapInRootNode(d);
      this.pluginService && f && f.children && (this.pluginService.applyToRows(f.children), s = this.pluginService.metadataCache), i = new hr(f, !0, p), i.hasGrandTotals = !!this.rowsGrand;
    }
    return {
      rowsTreeService: i,
      columnsTreeService: this.columnsTreeService,
      cornerTreeService: this.cornerTreeService,
      isLastPage: !0,
      cellsMetadata: s
    };
  }
  /**
   * Returns partial tree by indexes
   *
   * @param {number} paramFrom - start index
   * @param {number} paramTo - stop index
   * @param {boolean} lastPage - append grandTotals
   * @returns {{
   *     rowsTreeService: TreeServiceI,
   *     columnsTreeService: TreeServiceI,
   *     cornerTreeService: TreeServiceI,
   *     isLastPage: boolean
   * }} - returns panel's treeServices
   * @private
   */
  sendPartialPage(t, n, r) {
    if (this.loadService.hasError() || !this.loadService.hasData())
      return Pt.getEmptyPage();
    const o = this.getLoadedElementsCount();
    let [i, s] = [Math.min(t, n), Math.max(t, n)];
    i = i >= 0 ? i : 0, s = s >= 0 ? s : 0, s = s < o ? s : o;
    let a, u;
    if (i > o)
      a = void 0;
    else {
      let l;
      if (this.rowsTreeService) {
        const f = Pt.cloneTreeNode;
        l = this.rowsTreeService.getPartialTree(i, s, { cloneFn: f }), r && this.rowsGrand && l.push(It(this.rowsGrand)), this.postProcessTree(l, {
          onlyFormatEvents: !0,
          iterateFn: se.clearNodeCache
        }), this.postProcessData(l, { onlyFormatEvents: !0 });
      }
      const d = this.rowsTreeService ? this.rowsTreeService.getTreeDeepsLength() : 0, p = se.wrapInRootNode(l);
      this.pluginService && p && p.children && (this.pluginService.applyToRows(p.children), u = this.pluginService.metadataCache), a = new hr(p, !0, d), a.hasGrandTotals = !!(r && this.rowsGrand);
    }
    return {
      rowsTreeService: a,
      columnsTreeService: this.columnsTreeService,
      cornerTreeService: this.cornerTreeService,
      isLastPage: !0,
      cellsMetadata: u
    };
  }
  /**
   *
   * Get current state of tree (not recommended to use before 'loadData')
   *
   * @returns {number} loadedCount - current loaded count of children
   * @private
   */
  getLoadedElementsCount() {
    return this.rowsTreeService ? this.rowsTreeService.getTreeChildLength() : 0;
  }
  /**
   * Returns total amount items count handled on back-end side
   *
   * @deprecated
   * @returns {number} - items count
   * @private
   */
  getTotalItemsCount() {
    return this.loadService.getTotalItemsCount();
  }
  /**
   * Getter for pivot table loaded columns number
   *
   * @deprecated
   * @returns {number} loadedCount - current loaded pivot table columns count
   * @private
   */
  getLoadedColumnsCount() {
    return this.columnsTreeService ? this.columnsTreeService.getTreeChildLength() : 0;
  }
  /**
   * Attach events to load service
   * This is a key function implementing the Observer pattern
   * DataService acts as Observer and subscribes its handlers to various
   * data loading events emitted by the load service.
   *
   *
   * @returns {void}
   * @private
   */
  attachEvent() {
    this.loadService.listenerCount(_e.HEADERS) && this.loadService.offAll(_e.HEADERS), this.loadService.on(_e.HEADERS, this.onHeadersHandler), this.loadService.on(_e.METADATA, this.onMetadataHandler), this.loadService.on(_e.DATA, this.onDataHandler), this.loadService.on(_e.GRAND, this.onGrandHandler), this.loadService.on(_e.DATA_FINISH, this.onDataFinishHandler), this.loadService.on(_e.TOTAL_ROWS, this.onTotalRowsHandler), this.loadService.on(_e.DATABARS, this.onDataBarsHandler), this.loadService.on(_e.RANGE_MIN_MAX, this.onRangeMinMaxHandler), this.loadService.on(_e.FINISH, this.onFinishHandler), this.loadService.on(_e.ERROR, this.onErrorHandler);
  }
  /**
   * Dettach events from load service
   *
   * @returns {void}
   * @private
   */
  detachEvent() {
    this.loadService.off(_e.HEADERS, this.onHeadersHandler), this.loadService.off(_e.METADATA, this.onMetadataHandler), this.loadService.off(_e.DATA, this.onDataHandler), this.loadService.off(_e.GRAND, this.onGrandHandler), this.loadService.off(_e.DATA_FINISH, this.onDataFinishHandler), this.loadService.off(_e.TOTAL_ROWS, this.onTotalRowsHandler), this.loadService.off(_e.DATABARS, this.onDataBarsHandler), this.loadService.off(_e.RANGE_MIN_MAX, this.onRangeMinMaxHandler), this.loadService.off(_e.FINISH, this.onFinishHandler), this.loadService.off(_e.ERROR, this.onErrorHandler);
  }
  /**
   * Check for enough data loaded and resolve promise of "loadData" function
   *
   * @returns {void}
   * @private
   */
  checkLoadPromise() {
    if (!this.isLoadInProgress)
      return;
    const t = this.getLoadedElementsCount();
    (t >= this.getPageSize() || this.isWholeDataLoaded) && (this.isLoadInProgress = !1, typeof this.loadPromiseResolve == "function" && (this.loadPromiseResolve(t), this.clearLoadPromise()));
  }
  /**
   * @returns {void}
   * @private
   */
  clearLoadAllPromise() {
    this.loadAllPromise = void 0, this.loadAllPromiseReject = void 0, this.loadAllPromiseResolve = void 0;
  }
  /**
   * @returns {void}
   * @private
   */
  clearLoadPromise() {
    this.loadPromiseReject = void 0, this.loadPromiseResolve = void 0;
  }
  /**
   * Mark finish request
   *
   * @returns {void}
   * @private
   */
  finishRequest() {
    this.logger.log("finishRequest"), this.hasDataFinishEvent = !0, !this.isDataHandlerThrottled && (this.isWholeDataLoaded = !0, this.loadAllPromiseResolve && typeof this.loadAllPromiseResolve == "function" && (this.loadAllPromiseResolve(), this.clearLoadAllPromise()));
  }
  /**
   * Clear internal cache in case new JAQL request send
   *
   * @returns {void}
   * @private
   */
  clearCache() {
    this.rowsGrand = void 0, this.rowsTreeService = void 0, this.columnsTreeService = void 0, this.loadedPagesCount = 0, this.hasDataFinishEvent = !1, this.isWholeDataLoaded = !1, this.isLoadInProgress = !1, this.tempDataChunks = [], this.lastNotHandledChunkIndex = 0, this.lastReadyNotHandledChunkIndex = 0, this.isDataHandlerThrottled = !1;
  }
  static getEmptyPage() {
    return {
      isLastPage: !0
    };
  }
  static fillDataChunks(t, n, r = df, o = df) {
    const s = t.length < 2 ? r : o;
    let a = t[Math.max(0, t.length - 1)], u, l = !a;
    if (!n || typeof n.children == "undefined" && typeof n.value == "undefined" && n.data && !n.data.length) {
      a && (a.ready = !0);
      return;
    }
    if (a) {
      const d = Math.max(0, a.list.length - 1);
      u = a.list[d];
      const p = a.size ? `${a.size}` : "0", h = parseInt(p, 10) + (n.size || 1);
      (a.handled || h > s && !(u.isPart && u.value === n.value)) && (l = !0);
    }
    n && n.isPart && u && (!u.isPart || u.value !== n.value) && (l = !0, u.value !== n.value && (u = void 0)), l && (a && (a.ready = !0), a = {
      list: [],
      size: 0,
      ready: !1,
      handled: !1
    }, t.push(a)), a && (u && u.isPart && n && n.isPart ? (se.deepMerge(u, n), a.size += n.size || 1) : (a.list.push(n), a.size += n.size || 1));
  }
  static cloneTreeNode(t, n) {
    const S = t, {
      children: o,
      isMapped: i,
      minLevel: s,
      childCount: a,
      childDeep: u,
      parent: l,
      master: d,
      data: p,
      state: f,
      style: h,
      store: g
    } = S, m = re(S, [
      "children",
      "isMapped",
      // eslint-disable-line no-unused-vars
      "minLevel",
      // eslint-disable-line no-unused-vars
      "childCount",
      // eslint-disable-line no-unused-vars
      "childDeep",
      // eslint-disable-line no-unused-vars
      // @ts-ignore
      "parent",
      // @ts-ignore
      "master",
      // @ts-ignore
      "data",
      // @ts-ignore
      "state",
      // @ts-ignore
      "style",
      // @ts-ignore
      "store"
    ]), v = It(m);
    return l && (v.parent = l), d && (v.master = d), p && (v.data = It(p)), f && (v.state = It(f)), h && (v.style = It(h)), g && (v.store = It(g)), !n && o && (v.children = o.map((_) => {
      const R = Pt.cloneTreeNode(_);
      return R.parent = v, R;
    })), v;
  }
  /**
   * @typedef {Function} buildColumnsTreeService
   * @param {HeaderTreeNode} originalColumnsTree
   * @returns {BuildColumnsTreeServiceResult}
   */
  /**
   * @typedef {object} BuildColumnsTreeServiceResult
   * @property {TreeNode|undefined} columnsTree
   * @property {TreeService|undefined} columnsTreeService
   * @property {number} columnsCount
   * @property {number} totalColumnsCount
   */
  /**
   * Creates builder function for building columns tree service
   *
   * @param {object} handlers - build handlers
   * @param {Function} handlers.getJaql - jaql getter
   * @param {Function} [handlers.getRawJaql] - raw jaql getter
   * @param {PluginService} [handlers.pluginService] - plugin service
   * @param {Function} [handlers.applyIndexDivergence] - helper for calculation indexes divergence
   * @param {object} [events] - build event emitters
   * @param {Function} events.emitHeaderCellFormatEvent - emits EVENT_HEADER_CELL_FORMAT event
   * @returns {buildColumnsTreeService} - build function
   */
  static createColumnsTreeServiceBuilder(t, n) {
    return (r) => {
      const o = t.getJaql(), i = t.getRawJaql ? t.getRawJaql() : Bl(o, o.metadata || []), s = ut.getMetadataTree(o, Ce.MEASURES), a = se.getChildren(s), { preProcessTree: u, modifyTree: l, postProcessTree: d } = zo;
      let p, f, h = 0, g = 0;
      if (se.hasChildren(r)) {
        r.columnsCount && r.totalColumnsCount && (h = r.columnsCount, g = r.totalColumnsCount);
        const m = u(r, Ce.COLUMNS, o), v = l(m, Ce.COLUMNS, o, {
          originalData: r,
          applyIndexDivergence: t.applyIndexDivergence
        });
        d(v, i, {
          emitFn: n && n.emitHeaderCellFormatEvent
        });
        const S = se.wrapInRootNode(v);
        t.pluginService && S && S.children && t.pluginService.applyToColumns(S.children), p = S, f = new hr(S), a.length === 1 && f.setValueNode(a[0]);
      } else
        se.hasChildren(s) ? (r.columnsCount && r.totalColumnsCount && (h = r.columnsCount, g = r.totalColumnsCount), typeof r.maxChilds == "number" && (h = r.maxChilds, s.children = se.getChildren(s).filter((m, v) => v < r.maxChilds)), t.pluginService && s.children && t.pluginService.applyToColumns(s.children), d(se.getChildren(s), i, {
          emitFn: n && n.emitHeaderCellFormatEvent
        }), p = s, f = new hr(s)) : (t.pluginService && t.pluginService.resetRowStartFrom(), p = void 0, f = void 0, h = 0, g = 0);
      return {
        columnsTree: p,
        columnsTreeService: f,
        columnsCount: h,
        totalColumnsCount: g
      };
    };
  }
  /**
   * @typedef {Function} buildCornerTreeService
   * @param {HeaderTreeNode} originalColumnsTree
   * @returns {BuildCornerTreeServiceResult}
   */
  /**
   * @typedef {object} BuildCornerTreeServiceResult
   * @property {TreeNode|undefined} columnsTree
   * @property {TreeService|undefined} columnsTreeService
   * @property {number} columnsCount
   * @property {number} totalColumnsCount
   */
  /**
   * Creates builder function for building corners tree service
   *
   * @param {object} handlers - build handlers
   * @param {Function} handlers.getJaql - jaql getter
   * @param {Function} [handlers.getRawJaql] - raw jaql getter
   * @param {PluginService} [handlers.pluginService] - plugin service
   * @param {TreeServiceI} [handlers.columnsTreeService] - column tree service
   * @param {object} [events] - build event emitters
   * @param {Function} events.emitHeaderCellFormatEvent - emits EVENT_HEADER_CELL_FORMAT event
   * @returns {buildCornerTreeService} - build function
   */
  static createCornerTreeServiceBuilder(t, n) {
    return () => {
      const r = t.getJaql(), o = t.getRawJaql ? t.getRawJaql() : Bl(r, r.metadata || []), i = ut.getMetadataTree(r, Ce.ROWS);
      let s;
      if (se.hasChildren(i)) {
        se.iterateThroughTree(se.getChildren(i), (u) => {
          u.userType = et.CORNER;
          const l = ut.getMetadataPanelByIndex(
            o,
            u.jaqlIndex,
            u.metadataType || ""
          );
          n && n.emitHeaderCellFormatEvent && n.emitHeaderCellFormatEvent(u, l, o);
        });
        let a;
        t.columnsTreeService && (a = t.columnsTreeService.getTreeDeepsLength()), t.pluginService && t.pluginService.applyToHeaders(i), s = new hr(i, !1, a);
      }
      return { cornerTree: i, cornerTreeService: s };
    };
  }
}
var Fl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var pf;
function iT() {
  return pf || (pf = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = [], o = 0; o < arguments.length; o++) {
          var i = arguments[o];
          if (i) {
            var s = typeof i;
            if (s === "string" || s === "number")
              r.push(i);
            else if (Array.isArray(i)) {
              if (i.length) {
                var a = n.apply(null, i);
                a && r.push(a);
              }
            } else if (s === "object") {
              if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
                r.push(i.toString());
                continue;
              }
              for (var u in i)
                t.call(i, u) && i[u] && r.push(u);
            }
          }
        }
        return r.join(" ");
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(Fl)), Fl.exports;
}
var sT = iT();
const pa = /* @__PURE__ */ Pr(sT);
var aT = function() {
  return Tn.Date.now();
};
const zl = aT;
var lT = /\s/;
function cT(e) {
  for (var t = e.length; t-- && lT.test(e.charAt(t)); )
    ;
  return t;
}
var uT = /^\s+/;
function dT(e) {
  return e && e.slice(0, cT(e) + 1).replace(uT, "");
}
var pT = "[object Symbol]";
function fT(e) {
  return typeof e == "symbol" || ho(e) && To(e) == pT;
}
var ff = 0 / 0, hT = /^[-+]0x[0-9a-f]+$/i, mT = /^0b[01]+$/i, gT = /^0o[0-7]+$/i, yT = parseInt;
function hf(e) {
  if (typeof e == "number")
    return e;
  if (fT(e))
    return ff;
  if (_i(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = _i(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = dT(e);
  var n = mT.test(e);
  return n || gT.test(e) ? yT(e.slice(2), n ? 2 : 8) : hT.test(e) ? ff : +e;
}
var vT = "Expected a function", bT = Math.max, CT = Math.min;
function ST(e, t, n) {
  var r, o, i, s, a, u, l = 0, d = !1, p = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(vT);
  t = hf(t) || 0, _i(n) && (d = !!n.leading, p = "maxWait" in n, i = p ? bT(hf(n.maxWait) || 0, t) : i, f = "trailing" in n ? !!n.trailing : f);
  function h(w) {
    var x = r, P = o;
    return r = o = void 0, l = w, s = e.apply(P, x), s;
  }
  function g(w) {
    return l = w, a = setTimeout(S, t), d ? h(w) : s;
  }
  function m(w) {
    var x = w - u, P = w - l, N = t - x;
    return p ? CT(N, i - P) : N;
  }
  function v(w) {
    var x = w - u, P = w - l;
    return u === void 0 || x >= t || x < 0 || p && P >= i;
  }
  function S() {
    var w = zl();
    if (v(w))
      return _(w);
    a = setTimeout(S, m(w));
  }
  function _(w) {
    return a = void 0, f && r ? h(w) : (r = o = void 0, s);
  }
  function R() {
    a !== void 0 && clearTimeout(a), l = 0, r = u = o = a = void 0;
  }
  function b() {
    return a === void 0 ? s : _(zl());
  }
  function y() {
    var w = zl(), x = v(w);
    if (r = arguments, o = this, u = w, x) {
      if (a === void 0)
        return g(u);
      if (p)
        return clearTimeout(a), a = setTimeout(S, t), h(u);
    }
    return a === void 0 && (a = setTimeout(S, t)), s;
  }
  return y.cancel = R, y.flush = b, y;
}
const oi = "getSize", ku = "change", ii = "dataBars", si = "rangeMinMax";
class wT {
  constructor(t, n) {
    I(this, "events");
    I(this, "colsWidth", {});
    I(this, "rowsHeight", {});
    I(this, "initialFixedWidth", {});
    I(this, "dataBarsCols", []);
    I(this, "dataBarsColsCache");
    I(this, "dataBarsMinMax");
    I(this, "rangeMinMax");
    I(this, "notifyChangeTimer", 0);
    I(this, "notifySizeChangeTimer", 0);
    I(this, "notifyDataBarsChangeTimer", 0);
    I(this, "notifyRangeMinMaxChangeTimer", 0);
    I(this, "logger");
    I(this, "columnWidth", ({ index: t }) => this.initialFixedWidth[t] !== void 0 ? this.initialFixedWidth[t] : this.colsWidth[t] || Number.NaN);
    I(this, "rowHeight", ({ index: t }) => this.rowsHeight[t] || Number.NaN);
    this.events = new zi(), this.events.setMaxListeners(1 / 0), this.logger = ar.create("TableSize"), this.dataBarsMinMax = t, this.rangeMinMax = n;
  }
  updateDataBars(t, n, r) {
    this.dataBarsCols[t] = this.dataBarsCols[t] || [];
    const o = this.dataBarsCols[t];
    o[n] = r, this.dataBarsMinMax && this.notifyDataBarsChange();
  }
  updateDataBarsMinMax(t) {
    this.dataBarsMinMax = t, this.notifyDataBarsChange();
  }
  updateRangeMinMax(t) {
    this.rangeMinMax = t, this.notifyRangeMinMaxChange();
  }
  updateWidth(t, n) {
    this.logger.log("updateWidth", t, n), this.colsWidth[t] = n, this.notifySizesChange();
  }
  updateHeight(t, n) {
    this.logger.log("updateHeight", t, n), this.rowsHeight[t] = n, this.notifySizesChange();
  }
  notifyChange() {
    this.notifyChangeTimer && (clearTimeout(this.notifyChangeTimer), this.notifyChangeTimer = 0), this.notifyChangeTimer = window.setTimeout(() => {
      this.notifyChangeTimer = 0, this.events.emit(oi);
    });
  }
  setFixedWidth(t, n) {
    this.logger.log("setFixedWidth", t, n), this.initialFixedWidth[t] = n, this.notifySizesChange();
  }
  /**
   * Set initial width to columns
   *
   * @param  {Array} predefinedColumnWidth - array with predefine with data for column
   * @returns {void}
   */
  setInitialFixedWidth(t) {
    this.logger.log("setInitialFixedWidth", t), Array.isArray(t) && t.forEach((n) => {
      const [r, o] = n;
      this.initialFixedWidth[r] = o;
    });
  }
  /**
   * Check for initial column width
   *
   * @param  {number} columnIndex - column index
   * @returns {boolean} - true - has initial width
   */
  hasInitialFixedWidth(t) {
    return typeof this.initialFixedWidth[t] != "undefined";
  }
  hasPendingChanges() {
    return !!(this.notifyChangeTimer || this.notifySizeChangeTimer);
  }
  fitWidths(t) {
    const n = [];
    Object.keys(this.colsWidth).forEach((i) => {
      const s = parseInt(i, 10);
      n.push([s, this.columnWidth({ index: s })]);
    });
    const r = n.reduce((i, [, s = 0] = []) => i + s, 0), o = n.map(([i, s]) => {
      const a = Math.floor(t * s / r);
      return [i, a];
    });
    this.setInitialFixedWidth(o), this.notifySizesChange();
  }
  /**
   * @returns {void}
   * @private
   */
  notifySizesChange() {
    this.notifySizeChangeTimer && (clearTimeout(this.notifySizeChangeTimer), this.notifySizeChangeTimer = 0), this.notifySizeChangeTimer = window.setTimeout(() => {
      this.notifySizeChangeTimer = 0;
      const t = {};
      Object.keys(this.colsWidth).forEach((n) => {
        const r = parseInt(n, 10);
        let o = this.colsWidth[r];
        const i = this.initialFixedWidth[r];
        typeof i == "number" && (o = i), t[r] = o;
      }), this.colsWidth = t, this.events.emit(ku, this.colsWidth, this.rowsHeight);
    });
  }
  notifyDataBarsChange() {
    this.notifyDataBarsChangeTimer && (clearTimeout(this.notifyDataBarsChangeTimer), this.notifyDataBarsChangeTimer = 0), this.notifyDataBarsChangeTimer = window.setTimeout(() => {
      this.notifyDataBarsChangeTimer = 0, this.dataBarsColsCache = this.dataBarsCols.map(
        (t) => t.reduce((n, r) => n > r ? n : r, 0)
      ), this.events.emit(ii, {
        colsWidth: this.dataBarsColsCache,
        minMaxs: this.dataBarsMinMax
      });
    });
  }
  notifyRangeMinMaxChange() {
    this.notifyRangeMinMaxChangeTimer && (clearTimeout(this.notifyRangeMinMaxChangeTimer), this.notifyRangeMinMaxChangeTimer = 0), this.notifyRangeMinMaxChangeTimer = window.setTimeout(() => {
      this.notifyRangeMinMaxChangeTimer = 0, this.events.emit(si, {
        // eslint-disable-next-line max-lines
        rangeMinMax: this.rangeMinMax
      });
    });
  }
  getDataBars() {
    if (!(!this.dataBarsMinMax || !this.dataBarsColsCache))
      return {
        colsWidth: this.dataBarsColsCache,
        minMaxs: this.dataBarsMinMax
      };
  }
  getRangeMinMax() {
    if (this.rangeMinMax)
      return {
        rangeMinMax: this.rangeMinMax
      };
  }
  on(t, n) {
    this.events.on(t, n);
  }
  off(t, n) {
    this.events.off(t, n);
  }
}
const co = class co extends E.PureComponent {
  constructor(n) {
    super(n);
    I(this, "height", 0);
    I(this, "width", 0);
    I(this, "content");
    I(this, "tdElement");
    I(this, "cellStyle");
    I(this, "contentStyle");
    I(this, "contentRef", (n) => {
      n && (this.content = n);
    });
    I(this, "tdRef", (n) => {
      n && (this.tdElement = n);
    });
    I(this, "onGetSize", () => {
      const { type: n, rowIndex: r, colIndex: o } = this.props, i = this.tdElement;
      if (!i)
        return;
      let s, a;
      if (n === co.type.COL) {
        if (!this.content)
          return;
        s = i.getBoundingClientRect().width, this.props.tableSize.updateWidth(o, s);
      } else
        a = i.getBoundingClientRect().height, this.props.tableSize.updateHeight(r, a);
    });
    this.contentStyle = {}, this.cellStyle = {};
  }
  componentDidMount() {
    this.props.tableSize.on(oi, this.onGetSize);
  }
  UNSAFE_componentWillReceiveProps(n) {
    n.tableSize !== this.props.tableSize && (this.props.tableSize.off(oi, this.onGetSize), n.tableSize.on(oi, this.onGetSize)), n.width !== this.props.width && (this.contentStyle = {}, this.props.type === co.type.COL && (this.contentStyle.height = 0)), n.height !== this.props.height && (this.cellStyle = {});
  }
  componentWillUnmount() {
    this.props.tableSize.off(oi, this.onGetSize);
  }
  getIndex() {
    return this.props.type === co.type.COL ? this.props.colIndex : this.props.rowIndex;
  }
  render() {
    const { type: n } = this.props, r = this.getIndex(), o = `table-grid__cell-anchor
            table-grid__cell-anchor--${n}
            table-grid__cell-anchor--${n}-${r}
        `.trim();
    return /* @__PURE__ */ O("td", { className: o, style: this.cellStyle, ref: this.tdRef, children: /* @__PURE__ */ O(
      "div",
      {
        ref: this.contentRef,
        className: "table-grid__cell-anchor-content",
        style: this.contentStyle
      }
    ) }, `${n}-${r}`);
  }
};
I(co, "type", {
  ROW: "row",
  COL: "col"
});
let ro = co;
const _T = "multi-grid", xT = "multi-grid--new", mf = "multi-grid--no-rows", TT = "multi-grid--no-columns", gf = "multi-grid--no-corner", ET = "multi-grid--no-fixed-left", cs = "table-grid", RT = "table-grid--data", OT = "table-grid--rows", PT = "table-grid--columns", IT = "table-grid--corner", yf = "table-grid--top", vf = "table-grid--right", bf = "table-grid--bottom", Cf = "table-grid--left", jl = "table-grid--fixed", NT = "table-grid__table table-grid--table-native", MT = "table-grid__colgroup", Sf = "table-grid__column", kT = "table-grid__tbody", Hl = "table-grid__row", Et = "table-grid__cell", AT = "table-grid__cell--selected", $T = "table-grid__cell--drilled", LT = "table-grid__cell--sorted", DT = "table-grid__cell--sorted-inactive", BT = "table-grid__cell--sorted--asc", FT = "table-grid__cell--sorted--desc", zT = "table-grid__cell--default-sorted--asc", jT = "table-grid__cell--default-sorted--desc", HT = "table-grid__cell--fixed-width", WT = "table-grid__cell-corner", VT = "table-grid__content", UT = "table-grid__content__wrapper", us = "table-grid__content__inner", qT = "table-grid__sorting-settings-icon", GT = "table-grid__cell--sort-icon-persistent";
class ai extends E.PureComponent {
  constructor() {
    super(...arguments);
    I(this, "tableStyles");
  }
  UNSAFE_componentWillReceiveProps(n) {
    n.borderColor !== this.props.borderColor && (this.tableStyles = void 0);
  }
  componentDidUpdate() {
    this.props.onGridUpdated && this.props.onGridUpdated();
  }
  getTableStyles() {
    return this.tableStyles === void 0 && (this.props.borderColor ? this.tableStyles = {
      borderColor: this.props.borderColor
    } : this.tableStyles = null), this.tableStyles;
  }
  // eslint-disable-next-line class-methods-use-this
  getColumns(n = 10) {
    return Array.from(Array(n + 1)).map((r, o) => /* @__PURE__ */ O("col", { className: `${Sf} ${Sf}-${o}` }, `col-${o}`));
  }
  getRows(n = 10, r = 10, o, i) {
    const { clone: s, borderWidth: a } = this.props;
    return /* @__PURE__ */ fe(xo, { children: [
      Array.from(Array(n)).map((u, l) => {
        const d = i[l];
        return this.getRow(r, l, d, o);
      }),
      s ? null : /* @__PURE__ */ O("tr", { className: Hl, style: { height: 0 }, children: Array.from(Array(r + 1)).map((u, l) => {
        const d = o[l];
        return /* @__PURE__ */ O(
          ro,
          {
            type: ro.type.COL,
            colIndex: l,
            tableSize: this.props.tableSize,
            width: d,
            borderWidth: a
          },
          `anchor-${l}`
        );
      }) }, "anchor")
    ] });
  }
  getRow(n = 10, r = 0, o, i) {
    const { clone: s, borderWidth: a } = this.props, u = s && typeof o == "number" ? o : "auto";
    return /* @__PURE__ */ fe("tr", { className: `${Hl} ${Hl}-${r}`, style: { height: u }, children: [
      Array.from(Array(n)).map((l, d) => {
        const p = i[d];
        return this.getCell({
          rowHeight: o,
          colWidth: p,
          rowIndex: r,
          colIndex: d
        });
      }),
      s ? null : /* @__PURE__ */ O(
        ro,
        {
          type: ro.type.ROW,
          rowIndex: r,
          tableSize: this.props.tableSize,
          height: o,
          borderWidth: a
        }
      )
    ] }, r);
  }
  getCell(n) {
    const { rowIndex: r, colIndex: o, rowHeight: i, colWidth: s } = n || {}, { clone: a, type: u, cellRenderer: l, borderWidth: d, isMobile: p } = this.props;
    return l({
      rowIndex: r,
      colIndex: o,
      rowHeight: i,
      colWidth: s,
      borderWidth: d,
      clone: a,
      type: u,
      isMobile: p
    });
  }
  render() {
    const { widths: n, heights: r, colsCount: o, rowsCount: i, className: s } = this.props, a = this.getTableStyles() || void 0;
    return /* @__PURE__ */ fe("table", { className: `${NT} ${s}`, style: a, children: [
      /* @__PURE__ */ O("colgroup", { className: MT, children: this.getColumns(o) }),
      /* @__PURE__ */ O("tbody", { className: kT, children: this.getRows(i, o, n, r) })
    ] });
  }
}
I(ai, "defaultProps", {
  clone: !1,
  borderWidth: 1,
  borderColor: ""
});
var Wo = { exports: {} }, Wr = { exports: {} }, wf;
function KT() {
  return wf || (wf = 1, function() {
    var e, t, n, r, o, i;
    typeof performance != "undefined" && performance !== null && performance.now ? Wr.exports = function() {
      return performance.now();
    } : typeof process != "undefined" && process !== null && process.hrtime ? (Wr.exports = function() {
      return (e() - o) / 1e6;
    }, t = process.hrtime, e = function() {
      var s;
      return s = t(), s[0] * 1e9 + s[1];
    }, r = e(), i = process.uptime() * 1e9, o = r - i) : Date.now ? (Wr.exports = function() {
      return Date.now() - n;
    }, n = Date.now()) : (Wr.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - n;
    }, n = (/* @__PURE__ */ new Date()).getTime());
  }.call(uy)), Wr.exports;
}
var _f;
function YT() {
  if (_f)
    return Wo.exports;
  _f = 1;
  for (var e = KT(), t = typeof window == "undefined" ? uy : window, n = ["moz", "webkit"], r = "AnimationFrame", o = t["request" + r], i = t["cancel" + r] || t["cancelRequest" + r], s = 0; !o && s < n.length; s++)
    o = t[n[s] + "Request" + r], i = t[n[s] + "Cancel" + r] || t[n[s] + "CancelRequest" + r];
  if (!o || !i) {
    var a = 0, u = 0, l = [], d = 1e3 / 60;
    o = function(p) {
      if (l.length === 0) {
        var f = e(), h = Math.max(0, d - (f - a));
        a = h + f, setTimeout(function() {
          var g = l.slice(0);
          l.length = 0;
          for (var m = 0; m < g.length; m++)
            if (!g[m].cancelled)
              try {
                g[m].callback(a);
              } catch (v) {
                setTimeout(function() {
                  throw v;
                }, 0);
              }
        }, Math.round(h));
      }
      return l.push({
        handle: ++u,
        callback: p,
        cancelled: !1
      }), u;
    }, i = function(p) {
      for (var f = 0; f < l.length; f++)
        l[f].handle === p && (l[f].cancelled = !0);
    };
  }
  return Wo.exports = function(p) {
    return o.call(t, p);
  }, Wo.exports.cancel = function() {
    i.apply(t, arguments);
  }, Wo.exports.polyfill = function(p) {
    p || (p = t), p.requestAnimationFrame = o, p.cancelAnimationFrame = i;
  }, Wo.exports;
}
var Yy = YT();
const xf = /* @__PURE__ */ Pr(Yy);
var Vo = { exports: {} }, Wl, Tf;
function XT() {
  if (Tf)
    return Wl;
  Tf = 1;
  var e = null, t = ["Webkit", "Moz", "O", "ms"];
  return Wl = function(r) {
    e || (e = document.createElement("div"));
    var o = e.style;
    if (r in o)
      return r;
    for (var i = r.charAt(0).toUpperCase() + r.slice(1), s = t.length; s >= 0; s--) {
      var a = t[s] + i;
      if (a in o)
        return a;
    }
    return !1;
  }, Wl;
}
var Vl, Ef;
function JT() {
  if (Ef)
    return Vl;
  Ef = 1, Vl = r;
  var e = /\s/, t = /(_|-|\.|:)/, n = /([a-z][A-Z]|[A-Z][a-z])/;
  function r(u) {
    return e.test(u) ? u.toLowerCase() : t.test(u) ? (i(u) || u).toLowerCase() : n.test(u) ? a(u).toLowerCase() : u.toLowerCase();
  }
  var o = /[\W_]+(.|$)/g;
  function i(u) {
    return u.replace(o, function(l, d) {
      return d ? " " + d : "";
    });
  }
  var s = /(.)([A-Z]+)/g;
  function a(u) {
    return u.replace(s, function(l, d, p) {
      return d + " " + p.toLowerCase().split("").join(" ");
    });
  }
  return Vl;
}
var Ul, Rf;
function QT() {
  if (Rf)
    return Ul;
  Rf = 1;
  var e = JT();
  Ul = t;
  function t(n) {
    return e(n).replace(/[\W_]+(.|$)/g, function(r, o) {
      return o ? " " + o : "";
    }).trim();
  }
  return Ul;
}
var ql, Of;
function ZT() {
  if (Of)
    return ql;
  Of = 1;
  var e = QT();
  ql = t;
  function t(n) {
    return e(n).replace(/\s(\w)/g, function(r, o) {
      return o.toUpperCase();
    });
  }
  return ql;
}
var Gl, Pf;
function e1() {
  if (Pf)
    return Gl;
  Pf = 1;
  var e = {
    animationIterationCount: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridColumn: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    // SVG-related properties
    fillOpacity: !0,
    stopOpacity: !0,
    strokeDashoffset: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  };
  return Gl = function(t, n) {
    return typeof n == "number" && !e[t] ? n + "px" : n;
  }, Gl;
}
var If;
function t1() {
  if (If)
    return Vo.exports;
  If = 1;
  var e = XT(), t = ZT(), n = { float: "cssFloat" }, r = e1();
  function o(u, l, d) {
    var p = n[l];
    if (typeof p == "undefined" && (p = s(l)), p) {
      if (d === void 0)
        return u.style[p];
      u.style[p] = r(p, d);
    }
  }
  function i(u, l) {
    for (var d in l)
      l.hasOwnProperty(d) && o(u, d, l[d]);
  }
  function s(u) {
    var l = t(u), d = e(l);
    return n[l] = n[u] = n[d] = d, d;
  }
  function a() {
    arguments.length === 2 ? typeof arguments[1] == "string" ? arguments[0].style.cssText = arguments[1] : i(arguments[0], arguments[1]) : o(arguments[0], arguments[1], arguments[2]);
  }
  return Vo.exports = a, Vo.exports.set = a, Vo.exports.get = function(u, l) {
    return Array.isArray(l) ? l.reduce(function(d, p) {
      return d[p] = o(u, p || ""), d;
    }, {}) : o(u, l || "");
  }, Vo.exports;
}
var n1 = t1();
const on = /* @__PURE__ */ Pr(n1);
function Kl(e) {
  const { clientHeight: t } = e, { paddingTop: n, paddingBottom: r } = getComputedStyle(e);
  return t - parseFloat(n || "") - parseFloat(r || "");
}
function Yl(e) {
  const { clientWidth: t } = e, { paddingLeft: n, paddingRight: r } = getComputedStyle(e);
  return t - parseFloat(n || "") - parseFloat(r || "");
}
let Xl = !1;
function r1() {
  if (typeof document != "undefined") {
    let e = document.querySelector(".csdk-pivot-scrollbar-width-checker");
    if (!e) {
      e = document.createElement("div"), e.className = "csdk-pivot-scrollbar-width-checker", on(e, {
        width: 100,
        height: 100,
        position: "absolute",
        top: -9999,
        overflow: "scroll",
        MsOverflowStyle: "scrollbar"
      });
      let t = document.querySelector(".pivot-container");
      t || (t = document.body), t.appendChild(e);
    }
    Xl = e.offsetWidth - e.clientWidth;
  } else
    Xl = 0;
  return Xl || 0;
}
function Nf(e) {
  return typeof e == "string";
}
const Mf = {
  position: "relative",
  overflow: "hidden",
  width: "100%",
  height: "100%"
}, kf = {
  height: "auto"
}, o1 = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: "scroll",
  WebkitOverflowScrolling: "touch"
}, i1 = {
  position: "relative",
  top: void 0,
  left: void 0,
  right: void 0,
  bottom: void 0
}, s1 = {
  position: "absolute",
  height: 6
}, a1 = {
  position: "absolute",
  width: 6
}, l1 = {
  position: "relative",
  display: "block",
  height: "100%"
}, c1 = {
  position: "relative",
  display: "block",
  width: "100%"
}, u1 = {
  userSelect: "none"
}, d1 = {
  userSelect: "auto"
};
function p1(e) {
  const i = e || {}, { style: t, key: n } = i, r = re(i, ["style", "key"]), o = L(C({}, t), {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });
  return /* @__PURE__ */ O("div", C({ style: o }, r), n);
}
function f1(e) {
  const i = e || {}, { style: t, key: n } = i, r = re(i, ["style", "key"]), o = L(C({}, t), {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });
  return /* @__PURE__ */ O("div", C({ style: o }, r), n);
}
function h1(e) {
  const i = e || {}, { style: t, key: n } = i, r = re(i, ["style", "key"]), o = L(C({}, t), {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return /* @__PURE__ */ O("div", C({ style: o }, r), n);
}
function m1(e) {
  const i = e || {}, { style: t, key: n } = i, r = re(i, ["style", "key"]), o = L(C({}, t), {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return /* @__PURE__ */ O("div", C({ style: o }, r), n);
}
class Ed extends E.PureComponent {
  constructor() {
    super(...arguments);
    I(this, "view", document.createElement("div"));
    I(this, "trackHorizontal", document.createElement("div"));
    I(this, "trackVertical", document.createElement("div"));
    I(this, "thumbHorizontal", document.createElement("div"));
    I(this, "thumbVertical", document.createElement("div"));
    I(this, "requestFrame");
    I(this, "prevPageX", 0);
    I(this, "prevPageY", 0);
    I(this, "dragging", !1);
    I(this, "hideTracksTimeout", null);
    I(this, "detectScrollingInterval", null);
    I(this, "trackMouseOver", !1);
    I(this, "viewScrollTop", 0);
    I(this, "lastViewScrollTop", 0);
    I(this, "viewScrollLeft", 0);
    I(this, "lastViewScrollLeft", 0);
    I(this, "scrolling", !1);
    I(this, "handleScroll", (n) => {
      const { onScroll: r } = this.props;
      r && r(n), this.update((o) => {
        const { scrollLeft: i, scrollTop: s } = o;
        this.viewScrollLeft = i, this.viewScrollTop = s;
      }), this.detectScrolling();
    });
    I(this, "handleWindowResize", () => {
      this.update();
    });
    I(this, "handleDrag", (n) => {
      if (this.prevPageX) {
        const { clientX: r } = n, { left: o } = this.trackHorizontal.getBoundingClientRect(), s = this.getThumbHorizontalWidth() - this.prevPageX, a = -o + r - s;
        this.view.scrollLeft = this.getScrollLeftForOffset(a);
      }
      if (this.prevPageY) {
        const { clientY: r } = n, { top: o } = this.trackVertical.getBoundingClientRect(), s = this.getThumbVerticalHeight() - this.prevPageY, a = -o + r - s;
        this.view.scrollTop = this.getScrollTopForOffset(a);
      }
      return !1;
    });
    I(this, "handleDragEnd", () => {
      this.dragging = !1, this.prevPageY = 0, this.prevPageX = 0, this.teardownDragging(), this.handleDragEndAutoHide();
    });
    I(this, "handleHorizontalTrackMouseDown", (n) => {
      n.preventDefault();
      const { target: r, clientX: o } = n;
      if (r instanceof HTMLElement) {
        const { left: i } = r.getBoundingClientRect(), s = this.getThumbHorizontalWidth(), a = Math.abs(i - o) - s / 2;
        this.view.scrollLeft = this.getScrollLeftForOffset(a);
      }
    });
    I(this, "handleVerticalTrackMouseDown", (n) => {
      n.preventDefault();
      const { target: r, clientY: o } = n;
      if (r instanceof HTMLElement) {
        const { top: i } = r.getBoundingClientRect(), s = this.getThumbVerticalHeight(), a = Math.abs(i - o) - s / 2;
        this.view.scrollTop = this.getScrollTopForOffset(a);
      }
    });
    I(this, "handleHorizontalThumbMouseDown", (n) => {
      n.preventDefault(), this.handleDragStart(n);
      const { target: r, clientX: o } = n;
      if (r instanceof HTMLElement) {
        const { offsetWidth: i } = r, { left: s } = r.getBoundingClientRect();
        this.prevPageX = i - (o - s);
      }
    });
    I(this, "handleVerticalThumbMouseDown", (n) => {
      n.preventDefault(), this.handleDragStart(n);
      const { target: r, clientY: o } = n;
      if (r instanceof HTMLElement) {
        const { offsetHeight: i } = r, { top: s } = r.getBoundingClientRect();
        this.prevPageY = i - (o - s);
      }
    });
    I(this, "handleTrackMouseEnter", () => {
      this.trackMouseOver = !0, this.handleTrackMouseEnterAutoHide();
    });
    I(this, "handleTrackMouseLeave", () => {
      this.trackMouseOver = !1, this.handleTrackMouseLeaveAutoHide();
    });
    I(this, "setTrackVerticalRef", (n) => {
      n && (this.trackVertical = n);
    });
    I(this, "setThumbVerticalRef", (n) => {
      n && (this.thumbVertical = n);
    });
    I(this, "setTrackHorizontalRef", (n) => {
      n && (this.trackHorizontal = n);
    });
    I(this, "setThumbHorizontalRef", (n) => {
      n && (this.thumbHorizontal = n);
    });
    I(this, "setViewRef", (n) => {
      n && (this.view = n);
    });
  }
  componentDidMount() {
    this.addListeners(), this.update();
  }
  componentDidUpdate() {
    this.update();
  }
  componentWillUnmount() {
    this.removeListeners(), Yy.cancel(this.requestFrame), this.hideTracksTimeout && clearTimeout(this.hideTracksTimeout), this.detectScrollingInterval && clearInterval(this.detectScrollingInterval);
  }
  /**
   * returns all dimensions
   *
   * @returns {object} - CustomScroll scroll and size params
   * @private
   */
  getMeasurements() {
    const {
      scrollLeft: n = 0,
      scrollTop: r = 0,
      scrollWidth: o = 0,
      scrollHeight: i = 0,
      clientWidth: s = 0,
      clientHeight: a = 0
    } = this.view || {};
    return {
      left: n / (o - s) || 0,
      top: r / (i - a) || 0,
      scrollLeft: n,
      scrollTop: r,
      scrollWidth: o,
      scrollHeight: i,
      clientWidth: s,
      clientHeight: a
    };
  }
  /**
   * calculates horizontal thumb's width
   *
   * @returns {number} - horizontal thumb width
   * @private
   */
  getThumbHorizontalWidth() {
    const { scrollWidth: n, clientWidth: r } = this.view;
    return this.getThumbDimension(n, r, !1);
  }
  /**
   * calculates vertical thumb's height
   *
   * @returns {number} - vertical thumb height
   * @private
   */
  getThumbVerticalHeight() {
    const { scrollHeight: n, clientHeight: r } = this.view;
    return this.getThumbDimension(n, r, !0);
  }
  /**
   * calculates thumb's dimension
   *
   * @param {number} scrollDimension - scroll width | height
   * @param {number} clientDimension - client width | height
   * @param {boolean} isVertical - handle calculations for horizontal or vertical
   * @returns {number} -thumb dimension
   * @private
   */
  getThumbDimension(n, r, o) {
    const { thumbSize: i, thumbMinSize: s } = this.props, a = o ? Kl(this.trackVertical) : Yl(this.trackHorizontal), u = Math.ceil(r / n * a);
    return Math.abs(a - u) <= 2 ? 0 : i || Math.max(u, s);
  }
  /**
   * Calculates scrollLeft by offset arg
   *
   * @param {number} offset - offset to calulate by
   * @returns {number} - scrollLeft by offset
   * @private
   */
  getScrollLeftForOffset(n) {
    const { scrollWidth: r, clientWidth: o } = this.view, i = Yl(this.trackHorizontal), s = this.getThumbHorizontalWidth();
    return n / (i - s) * (r - o);
  }
  /**
   * Calculates scrollTop by offset arg
   *
   * @param {number} offset - offset to calulate by
   * @returns {number} - scrollTop by offset
   * @private
   */
  getScrollTopForOffset(n) {
    const { scrollHeight: r, clientHeight: o } = this.view, i = Kl(this.trackVertical), s = this.getThumbVerticalHeight();
    return n / (i - s) * (r - o);
  }
  /**
   * initial DOM components listeners attach
   *
   * @returns {void}
   * @private
   */
  addListeners() {
    if (typeof document == "undefined" || !this.view)
      return;
    const { view: n, trackHorizontal: r, trackVertical: o, thumbHorizontal: i, thumbVertical: s } = this;
    n.addEventListener("scroll", this.handleScroll), r.addEventListener("mouseenter", this.handleTrackMouseEnter), r.addEventListener("mouseleave", this.handleTrackMouseLeave), r.addEventListener("mousedown", this.handleHorizontalTrackMouseDown), o.addEventListener("mouseenter", this.handleTrackMouseEnter), o.addEventListener("mouseleave", this.handleTrackMouseLeave), o.addEventListener("mousedown", this.handleVerticalTrackMouseDown), i.addEventListener("mousedown", this.handleHorizontalThumbMouseDown), s.addEventListener("mousedown", this.handleVerticalThumbMouseDown), window.addEventListener("resize", this.handleWindowResize);
  }
  /**
   * initial DOM components listeners remove
   *
   * @returns {void}
   * @private
   */
  removeListeners() {
    if (typeof document == "undefined" || !this.view)
      return;
    const { view: n, trackHorizontal: r, trackVertical: o, thumbHorizontal: i, thumbVertical: s } = this;
    n.removeEventListener("scroll", this.handleScroll), r.removeEventListener("mouseenter", this.handleTrackMouseEnter), r.removeEventListener("mouseleave", this.handleTrackMouseLeave), r.removeEventListener("mousedown", this.handleHorizontalTrackMouseDown), o.removeEventListener("mouseenter", this.handleTrackMouseEnter), o.removeEventListener("mouseleave", this.handleTrackMouseLeave), o.removeEventListener("mousedown", this.handleVerticalTrackMouseDown), i.removeEventListener("mousedown", this.handleHorizontalThumbMouseDown), s.removeEventListener("mousedown", this.handleVerticalThumbMouseDown), window.removeEventListener("resize", this.handleWindowResize), this.teardownDragging();
  }
  /**
   * Tracks display during scroll handler
   *
   * @param {boolean} shouldStart - start status | stop status
   * @returns {void}
   * @private
   */
  handleScrollAutoHide(n = !0) {
    const { autoHide: r } = this.props;
    r && (n ? this.showTracks() : this.hideTracks());
  }
  /**
   * Sets listeners on dragging
   *
   * @returns {void}
   * @private
   */
  setupDragging() {
    on(document.body, u1), document.addEventListener("mousemove", this.handleDrag), document.addEventListener("mouseup", this.handleDragEnd), document.onselectstart = () => !1;
  }
  /**
   * Removes listeners on dragging
   *
   * @returns {void}
   * @private
   */
  teardownDragging() {
    on(document.body, d1), document.removeEventListener("mousemove", this.handleDrag), document.removeEventListener("mouseup", this.handleDragEnd), document.onselectstart = void 0;
  }
  /**
   * Sets status 'drag' and setups dragging
   *
   * @param {Event} event - standard drag event
   * @returns {void}
   * @private
   */
  handleDragStart(n) {
    this.dragging = !0, n.stopImmediatePropagation(), this.setupDragging();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  handleDragEndAutoHide() {
    const { autoHide: n } = this.props;
    n && this.hideTracks();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  handleTrackMouseEnterAutoHide() {
    const { autoHide: n } = this.props;
    n && this.showTracks();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  handleTrackMouseLeaveAutoHide() {
    const { autoHide: n } = this.props;
    n && this.hideTracks();
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  showTracks() {
    clearTimeout(this.hideTracksTimeout), on(this.trackHorizontal, { opacity: 1 }), on(this.trackVertical, { opacity: 1 });
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  hideTracks() {
    if (this.dragging || this.trackMouseOver || this.scrolling)
      return;
    const { autoHideTimeout: n } = this.props;
    clearTimeout(this.hideTracksTimeout), this.hideTracksTimeout = setTimeout(() => {
      on(this.trackHorizontal, { opacity: 0 }), on(this.trackVertical, { opacity: 0 });
    }, n);
  }
  /**
   * Tracks last scroll position
   *
   * @returns {void}
   * @private
   */
  detectScrolling() {
    this.scrolling || (this.scrolling = !0, this.handleScrollAutoHide(!0), this.detectScrollingInterval = setInterval(() => {
      this.lastViewScrollLeft === this.viewScrollLeft && this.lastViewScrollTop === this.viewScrollTop && (clearInterval(this.detectScrollingInterval), this.scrolling = !1, this.handleScrollAutoHide(!1)), this.lastViewScrollLeft = this.viewScrollLeft, this.lastViewScrollTop = this.viewScrollTop;
    }, 100));
  }
  /**
   * raf manager for function
   *
   * @param {Function} callback - raf callback
   * @returns {void}
   * @private
   */
  raf(n) {
    this.requestFrame && xf.cancel(this.requestFrame), this.requestFrame = xf(() => {
      this.requestFrame = void 0, n();
    });
  }
  /**
   * CustomScroll recalculation and update
   *
   * @param {Function} callback - raf callback
   * @returns {void}
   * @private
   */
  handleUpdate(n) {
    const { hideTracksWhenNotNeeded: r } = this.props, o = this.getMeasurements(), { scrollLeft: i, clientWidth: s, scrollWidth: a } = o, u = Yl(this.trackHorizontal), l = this.getThumbHorizontalWidth(), d = i / (a - s) * (u - l), p = {
      width: l,
      transform: `translateX(${d}px)`
    }, { scrollTop: f, clientHeight: h, scrollHeight: g } = o, m = Kl(this.trackVertical), v = this.getThumbVerticalHeight(), S = f / (g - h) * (m - v), _ = {
      height: v,
      transform: `translateY(${S}px)`
    };
    if (r) {
      const R = {
        visibility: a > s ? "visible" : "hidden"
      }, b = {
        visibility: g > h ? "visible" : "hidden"
      };
      on(this.trackHorizontal, R), on(this.trackVertical, b);
    }
    on(this.thumbHorizontal, p), on(this.thumbVertical, _), typeof n == "function" && n(o);
  }
  /**
   * CustomScroll recalculation and update with raf wrapper (public)
   *
   * @param {Function} callback - raf callback
   * @returns {void}
   */
  update(n) {
    this.raf(() => this.handleUpdate(n));
  }
  /**
   * Manually set scroll left
   *
   * @param {number} left - manual left
   * @returns {void}
   */
  scrollLeft(n = 0) {
    this.view && (this.view.scrollLeft = n);
  }
  /**
   * Manually set scroll top
   *
   * @param {number} top - manual top
   * @returns {void}
   */
  scrollTop(n = 0) {
    this.view && (this.view.scrollTop = n);
  }
  renderTracks() {
    const {
      renderThumbVertical: n,
      renderThumbHorizontal: r,
      renderTrackHorizontal: o,
      renderTrackVertical: i,
      autoHideDuration: s,
      autoHide: a
    } = this.props, u = {
      transition: `opacity ${s}ms`,
      opacity: 0
    }, l = C(C({}, s1), a && u), d = C(C({}, a1), a && u), p = n({
      style: c1,
      ref: this.setThumbVerticalRef
    }), f = i({
      key: "trackVertical",
      style: d,
      ref: this.setTrackVerticalRef,
      children: p,
      className: "scroll-elem__vertical-track"
    }), h = r({
      style: l1,
      ref: this.setThumbHorizontalRef
    });
    return [o({
      key: "trackHorizontal",
      style: l,
      ref: this.setTrackHorizontalRef,
      children: h,
      className: "scroll-elem__horizontal-track"
    }), f];
  }
  render() {
    const n = r1(), m = this.props, { autoHeight: r, autoHeightMin: o, autoHeightMax: i, style: s, children: a } = m, u = re(m, ["autoHeight", "autoHeightMin", "autoHeightMax", "style", "children"]), l = C(C(C({}, Mf), r && L(C({}, kf), {
      minHeight: o,
      maxHeight: i
    })), s), d = C(C(C({}, Mf), r && L(C({}, kf), {
      minHeight: o,
      maxHeight: i
    })), s);
    typeof d.height == "number" && (d.height -= u.scrollOffset || 0);
    const p = C(L(C({}, o1), {
      // Hide scrollbars by setting a negative margin
      marginRight: n ? -n : 0,
      marginBottom: n ? -n : 0
    }), r && L(C({}, i1), {
      // Add scrollbarWidth to autoHeight in order to compensate negative margins
      minHeight: Nf(o) ? `calc(${o} + ${n}px)` : o + n,
      maxHeight: Nf(i) ? `calc(${i} + ${n}px)` : i + n
    }));
    n || (p.scrollbarWidth = "none");
    const f = u.className || "pivot-scroller", h = `${f}__container`, g = `${f}__view`;
    return /* @__PURE__ */ fe("div", { className: f, style: l, children: [
      /* @__PURE__ */ O("div", { className: h, style: d, children: /* @__PURE__ */ O("div", { className: g, style: p, ref: this.setViewRef, children: a }) }),
      this.renderTracks()
    ] });
  }
}
I(Ed, "defaultProps", {
  renderTrackHorizontal: p1,
  renderTrackVertical: f1,
  renderThumbHorizontal: h1,
  renderThumbVertical: m1,
  thumbMinSize: 30,
  hideTracksWhenNotNeeded: !1,
  autoHide: !1,
  autoHideTimeout: 1e3,
  autoHideDuration: 200,
  autoHeight: !1,
  autoHeightMin: 0,
  autoHeightMax: 200,
  scrollOffset: 0
});
class Xy extends E.PureComponent {
  constructor() {
    super(...arguments);
    I(this, "container");
    I(this, "containerRef", (n) => {
      this.container = n;
    });
    I(this, "onMouseWheel", (n) => {
      if (!this.props.activated)
        return;
      const r = Math.max(-1, Math.min(1, n.wheelDelta || -n.detail)), o = n.wheelDeltaX, i = n.wheelDeltaY;
      this.props.onMouseScroll && this.props.onMouseScroll(n, r, o, i);
    });
  }
  componentDidMount() {
    this.container && (this.container.addEventListener("mousewheel", this.onMouseWheel), this.container.addEventListener("DOMMouseScroll", this.onMouseWheel));
  }
  componentWillUnmount() {
    this.container && (this.container.removeEventListener("mousewheel", this.onMouseWheel), this.container.removeEventListener("DOMMouseScroll", this.onMouseWheel));
  }
  render() {
    const s = this.props, {
      children: n,
      activated: r,
      onMouseScroll: o
    } = s, i = re(s, [
      "children",
      "activated",
      // eslint-disable-line no-unused-vars
      "onMouseScroll"
    ]);
    return /* @__PURE__ */ O("div", L(C({}, i), { ref: this.containerRef, children: n }));
  }
}
I(Xy, "defaultProps", {
  activated: !0
});
function Jl(e) {
  if (!document)
    return e;
  const t = document.createElement("div");
  if (t.getBoundingClientRect) {
    t.style.width = "1px", t.style.height = "1px", t.style.boxSizing = "content-box", t.style.border = `solid ${e}px black`, document.body.appendChild(t);
    const n = t.getBoundingClientRect();
    return document.body.removeChild(t), (n.width - 1) / 2;
  }
  return e;
}
function Af(e) {
  let t = [], n = [];
  return e.cornerTreeService && (t = e.cornerTreeService.getLastLevelNodes()), e.columnsTreeService && (n = e.columnsTreeService.getLastLevelNodes()), [...t, ...n].map((r) => St(r));
}
class Jy extends E.PureComponent {
  constructor(n) {
    super(n);
    I(this, "logger");
    I(this, "data", []);
    I(this, "cellsMetadata", /* @__PURE__ */ new Map());
    I(this, "cornerTable", []);
    I(this, "columnsTable", []);
    I(this, "rowsTable", []);
    I(this, "dataBars", []);
    I(this, "rangeMinMax", []);
    I(this, "fixRowsCount", 0);
    I(this, "fixColsCount", 0);
    I(this, "rowsCount", 0);
    I(this, "colsCount", 0);
    I(this, "scrollContainer");
    I(this, "leftContainer");
    I(this, "topContainer");
    I(this, "rightContainer");
    I(this, "resetScroll");
    I(this, "isMainGridUpdateSkiped", !1);
    I(this, "isFullWidthRefreshed", !1);
    I(this, "isDomReadyTriggered", !1);
    I(this, "domReadyTriggerTime", 0);
    I(this, "measure");
    I(this, "styleObj");
    I(this, "cellDomReadyPromises");
    I(this, "prevDataBars");
    I(this, "prevRangeMinMax");
    /**
     * Notify table about cell 'domready' promise to wait
     *
     * @param {Defer} defer - defer object
     * @returns {void}
     */
    I(this, "addCellDomReadyPromise", (n) => {
      this.cellDomReadyPromises = this.cellDomReadyPromises || [], n && this.cellDomReadyPromises.push(n.promise);
    });
    I(this, "removeCellDomReadyPromise", (n) => {
      this.cellDomReadyPromises = this.cellDomReadyPromises || [], n && (this.cellDomReadyPromises = this.cellDomReadyPromises.filter((r) => r !== n.promise));
    });
    I(this, "onChange", (n, r) => {
      this.setState({
        widths: n,
        heights: r
      }), this.topContainer && this.topContainer.classList.add("active"), this.leftContainer && this.leftContainer.classList.add("active"), this.rightContainer && this.rightContainer.classList.add("active"), this.isMainGridUpdateSkiped && (this.isMainGridUpdateSkiped = !1, this.onMainGridUpdated());
    });
    I(this, "onResize", () => {
      const n = window.devicePixelRatio || 1;
      this.state.zoomRatio !== n && this.setState({
        zoomRatio: n,
        borderWidth: Jl(this.props.borderWidth || 1)
      });
    });
    I(this, "onScroll", (n) => {
      const r = n.target, o = r.scrollTop, i = r.scrollLeft;
      this.leftContainer && (this.leftContainer.scrollTop = o), this.topContainer && (this.topContainer.scrollLeft = i), this.scrollContainer && this.scrollContainer.view && (this.scrollContainer.view.scrollTop = o);
    });
    I(this, "onMouseScroll", (n, r) => {
      let i = 0, s = 0;
      if (this.scrollContainer && this.scrollContainer.view) {
        const { offsetHeight: a, scrollHeight: u } = this.scrollContainer.view;
        i = this.scrollContainer.view.scrollTop, s = i + -r * 40, r > 0 ? s > 0 && n.preventDefault() : s < u - a && n.preventDefault(), this.scrollContainer.view.scrollTop = s;
      }
    });
    I(this, "onMainGridUpdated", () => {
      if (this.state.tableSize.hasPendingChanges()) {
        this.isMainGridUpdateSkiped = !0;
        return;
      }
      if (this.isMainGridUpdateSkiped = !1, this.props.onGridUpdated && this.props.onGridUpdated(), this.props.onInitLoadingFinish && !this.isDomReadyTriggered && this.props.onInitLoadingFinish(), this.props.onTotalSizeChange && this.scrollContainer && this.scrollContainer.view) {
        const r = this.scrollContainer.view.children[0].scrollHeight + this.props.scrollBarsMargin;
        this.props.onTotalSizeChange(r);
      }
      if (this.props.isFullWidth && !this.isDomReadyTriggered && !this.isFullWidthRefreshed) {
        this.isFullWidthRefreshed = !0;
        const { width: n, scrollBarsMargin: r = 0 } = this.props, { tableSize: o } = this.state;
        o.fitWidths(n - r);
        return;
      }
      if (this.props.onDomReady && this.cellDomReadyPromises && !this.isDomReadyTriggered) {
        this.isDomReadyTriggered = !0;
        const { onDomReady: n } = this.props, r = (/* @__PURE__ */ new Date()).getTime();
        Promise.all(this.cellDomReadyPromises).catch((o) => {
          this.logger.warn(`Cell "domready" promise rejected with "${o.message}"`);
        }).then(() => {
          this.domReadyTriggerTime === r && n();
        }), this.domReadyTriggerTime = r;
      }
    });
    // eslint-disable-next-line sonarjs/cognitive-complexity,max-lines-per-function
    I(this, "cellRenderer", (n) => {
      const { type: r, clone: o, rowIndex: i, colIndex: s, isMobile: a, colWidth: u } = n, { borderWidth: l, tableSize: d } = this.state, { columnWidth: p } = d, f = this.props.addCellDomReadyPromise || this.addCellDomReadyPromise, h = this.props.removeCellDomReadyPromise || this.removeCellDomReadyPromise;
      let g = r, m, v = i, S = s, _, R, b, y, w, x, P, N, M, A = 0, T = 0, D, j;
      if (i >= this.fixRowsCount && s >= this.fixColsCount) {
        S -= this.fixColsCount, v -= this.fixRowsCount;
        try {
          R = this.data[v][S];
        } catch ($) {
          throw new Error(`cellRenderer can't find data item for ${i}-${S}`);
        }
        if (j = `${v + this.fixRowsCount}-${S + this.fixColsCount}`, _ = this.cellsMetadata.get(j), this.state.rowsTreeService) {
          y = this.state.rowsTreeService.getMetadata(v, 1 / 0);
          const $ = this.state.rowsTreeService.getLastLevelNodes();
          b = St($[v]);
        }
        if (this.state.columnsTreeService) {
          x = this.state.columnsTreeService.getMetadata(1 / 0, S);
          const $ = this.state.columnsTreeService.getLastLevelNodes();
          w = St($[S]), w && w.metadataType === Ce.MEASURES ? (P = w, w.parent && (w = St(w.parent))) : x && x.valueNode && (P = St(x.valueNode));
        }
      } else
        s >= this.fixColsCount ? (g = Ct.COLUMNS, m = this.state.columnsTreeService, S -= this.fixColsCount, A = this.fixColsCount) : i >= this.fixRowsCount ? (g = Ct.ROWS, m = this.state.rowsTreeService, v -= this.fixRowsCount, T = this.fixRowsCount) : (g = Ct.CORNER, m = this.state.cornerTreeService);
      if (m) {
        const $ = m.getTreeNode(v, S);
        N = $ ? St($) : void 0, M = m.getMetadata(v, S), j = `${v}-${S}`, s >= this.fixColsCount ? j = `${v}-${S + this.fixColsCount}` : i >= this.fixRowsCount && (j = `${v + this.fixRowsCount}-${S}`), _ = this.cellsMetadata.get(j), D = m.getMainCellWidth(
          v,
          S,
          p,
          l,
          { columnsOffset: A, offsetTop: T }
        );
      }
      const F = (N || R || {}).store || {};
      this.addCellDomReadyPromise(F.domReadyDefer || F.domReadyDeffer);
      let z = {}, H = !1, ee = p({ index: s }), X = !1;
      return m && m.isChildren(v, S) ? H = !0 : m && m.hasChildren(v, S) && (z = m.getMainCellSpans(v, S), D && (ee = D)), (this.state.tableSize.hasInitialFixedWidth(s) || o) && (X = !0), X && isNaN(ee) && u && (ee = u), H ? null : /* @__PURE__ */ O(
        R0,
        L(C({
          isDataCell: !!R,
          tdComponent: "td",
          measure: this.measure,
          onSortingMetadataUpdate: this.props.onSortingMetadataUpdate,
          styleObj: this.styleObj,
          onSortingSettingsChanged: this.props.onSortingSettingsChanged,
          getSortingPopupContainer: this.props.getSortingPopupContainer,
          borderWidth: l,
          borderColor: this.props.borderColor,
          dataNode: R,
          cellMetadata: _,
          metadata: M,
          treeNode: N,
          rowIndex: i,
          columnIndex: s,
          tableType: g,
          rowTreeNode: b,
          rowMetadata: y,
          columnTreeNode: w,
          columnMetadata: x,
          measureTreeNode: P,
          parent: this,
          fixedWidth: X,
          tableSize: this.state.tableSize,
          isSelectedMode: this.props.isSelectedMode,
          allowHtml: this.props.allowHtml,
          onCellClick: this.props.onCellClick,
          onCellEnter: this.props.onCellEnter,
          onCellLeave: this.props.onCellLeave
        }, z), {
          colWidth: ee,
          clone: o,
          zoomRatio: this.state.zoomRatio,
          rowHeight: this.props.rowHeight,
          imageColumns: this.props.imageColumns,
          fallbackImageUrl: this.props.fallbackImageUrl,
          addCellDomReadyPromise: f,
          removeCellDomReadyPromise: h,
          isMobile: a
        }),
        j
      );
    });
    I(this, "scrollContainerRef", (n) => {
      n && (this.scrollContainer = n, this.resetScroll && this.scrollContainer && this.scrollContainer.view && (this.resetScroll = !1, this.scrollContainer.view.scrollTop = 0, this.scrollContainer.view.scrollLeft = 0));
    });
    I(this, "leftContainerRef", (n) => {
      n && (this.leftContainer = n);
    });
    I(this, "topContainerRef", (n) => {
      n && (this.topContainer = n);
    });
    I(this, "rightContainerRef", (n) => {
      n && (this.rightContainer = n);
    });
    this.logger = ar.create("PivotTable");
    const r = window.devicePixelRatio || 1;
    this.state = {
      tableSize: this.createTableSize(),
      widths: {},
      heights: {},
      borderWidth: Jl(n.borderWidth || 1),
      isResizeInProgress: !1,
      rowsTreeService: void 0,
      columnsTreeService: void 0,
      cornerTreeService: void 0,
      zoomRatio: r
    }, this.measure = () => {
    }, this.styleObj = {}, this.resetScroll = !1, n.dataBars && n.dataBars.length && this.notifyDataBars(n.dataBars), n.rangeMinMax && n.rangeMinMax.length && this.notifyRangeMinMax(n.rangeMinMax);
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResize), this.props.onGetInitialData && this.props.onGetInitialData(), this.resetScroll && this.scrollContainer && this.scrollContainer.view && (this.resetScroll = !1, this.scrollContainer.view.scrollTop = 0, this.scrollContainer.view.scrollLeft = 0, this.topContainer && this.topContainer.classList.remove("active"), this.leftContainer && this.leftContainer.classList.remove("active"), this.rightContainer && this.rightContainer.classList.remove("active"));
  }
  UNSAFE_componentWillReceiveProps(n) {
    if (n.borderWidth !== this.props.borderWidth) {
      const r = window.devicePixelRatio || 1;
      this.setState({
        borderWidth: Jl(n.borderWidth || 1),
        zoomRatio: r
      });
    }
  }
  componentDidUpdate() {
    this.resetScroll && this.scrollContainer && this.scrollContainer.view && (this.resetScroll = !1, this.scrollContainer.view.scrollTop = 0, this.scrollContainer.view.scrollLeft = 0, this.topContainer && this.topContainer.classList.remove("active"), this.leftContainer && this.leftContainer.classList.remove("active"), this.rightContainer && this.rightContainer.classList.remove("active")), this.props.dataBars !== this.prevDataBars && (this.prevDataBars = this.props.dataBars, this.notifyDataBars(this.props.dataBars)), this.props.rangeMinMax !== this.prevRangeMinMax && (this.prevRangeMinMax = this.props.rangeMinMax, this.notifyRangeMinMax(this.props.rangeMinMax));
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }
  initialize(n, r, o, i) {
    const { cellsMetadata: s = /* @__PURE__ */ new Map() } = i || {};
    s !== null && (this.cellsMetadata = s), this.isDomReadyTriggered = !1, this.isFullWidthRefreshed = !1, this.resetScroll = !0;
    const a = {
      rowsTreeService: n,
      columnsTreeService: r,
      cornerTreeService: o
    };
    this.initTableSize(a);
    const u = this.createTableSize(), l = Af(a);
    if (this.props.onUpdatePredefinedColumnWidth) {
      const d = this.props.onUpdatePredefinedColumnWidth(
        l,
        void 0
      );
      u.setInitialFixedWidth(d);
    }
    this.cellDomReadyPromises = void 0, !n && !r && (this.cellDomReadyPromises = []), this.setState(C({
      tableSize: u
    }, a));
  }
  addMore(n, r) {
    return this.initialize(
      n,
      this.state.columnsTreeService,
      this.state.cornerTreeService,
      {
        isLastPage: r,
        cellsMetadata: null
      }
    );
  }
  notifyDataBars(n) {
    this.dataBars = (n || []).map((r) => {
      if (!r)
        return r;
      const [o, i] = r;
      return [parseFloat(o), parseFloat(i)];
    }), this.state && this.state.tableSize && this.state.tableSize.updateDataBarsMinMax(this.dataBars);
  }
  notifyRangeMinMax(n) {
    this.rangeMinMax = (n || []).map((r) => {
      if (!r)
        return r;
      const [o, i] = r;
      return [parseFloat(o), parseFloat(i)];
    }), this.state && this.state.tableSize && this.state.tableSize.updateRangeMinMax(this.rangeMinMax);
  }
  createTableSize() {
    this.state && this.state.tableSize && this.state.tableSize.off(ku, this.onChange);
    const n = new wT(this.dataBars, this.rangeMinMax);
    return n.on(ku, this.onChange), n;
  }
  hasContent() {
    return !(this.rowsCount === 0 && this.colsCount === 0);
  }
  getDimensions() {
    const n = {
      getTreeChildLength: () => 0,
      getTreeDeepsLength: () => 0
    }, {
      columnsTreeService: r = n,
      cornerTreeService: o = n,
      rowsTreeService: i = n
    } = this.state;
    if (i) {
      let s = r === void 0 ? 0 : r.getTreeChildLength();
      o && (s += o.getTreeChildLength());
      const a = i.getTreeChildLength() + (r === void 0 ? 0 : r.getTreeDeepsLength());
      return {
        height: Array.from({ length: a }, (u, l) => [
          l,
          this.getRowHeight(l)
        ]),
        width: Array.from({ length: s }, (u, l) => [
          l,
          this.getColumnWidth(l)
        ])
      };
    }
    return { height: [], width: [] };
  }
  getColumnWidth(n) {
    return this.state.tableSize.columnWidth({ index: n });
  }
  /**
   * Returns row height from cellMeasurerCache
   *
   * @param {number} rowIndex - column index
   * @returns {number} - column width
   */
  getRowHeight(n) {
    return this.state.tableSize.rowHeight({ index: n });
  }
  initTableSize(n) {
    this.data = [], n.rowsTreeService && (this.data = n.rowsTreeService.extractData(n.columnsTreeService)), this.rowsCount = 0, this.colsCount = 0, this.fixRowsCount = 0, this.fixColsCount = 0, this.cornerTable = [], n.cornerTreeService && (this.cornerTable = n.cornerTreeService.getGrid(), this.fixRowsCount = this.cornerTable.length, this.rowsCount += this.fixRowsCount, this.cornerTable[0] && (this.fixColsCount = this.cornerTable[0].length, this.colsCount += this.fixColsCount)), this.columnsTable = [], n.columnsTreeService && (this.columnsTable = n.columnsTreeService.getGrid(), this.columnsTable[0] && (this.colsCount += this.columnsTable[0].length), n.cornerTreeService || (this.fixRowsCount = this.columnsTable.length, this.rowsCount += this.fixRowsCount)), this.rowsTable = [], n.rowsTreeService && (this.rowsTable = n.rowsTreeService.getGrid(), this.rowsCount += this.rowsTable.length);
  }
  resizeColumnStart() {
    this.setState({ isResizeInProgress: !0 });
  }
  resizeColumn(n, r, o) {
    const [i, s] = n[0];
    this.state.tableSize.setFixedWidth(i, s);
  }
  resizeColumnEnd(n, r) {
    this.setState({ isResizeInProgress: !1 });
    const o = [r, n], i = Af(this.state);
    if (this.props.onUpdatePredefinedColumnWidth) {
      const s = this.props.onUpdatePredefinedColumnWidth(
        i,
        o
      );
      this.state.tableSize.setInitialFixedWidth(s), this.state.tableSize.notifyChange();
    } else
      this.state.tableSize.setFixedWidth(r, n);
  }
  render() {
    const { widths: n, heights: r, borderWidth: o, rowsTreeService: i, columnsTreeService: s, cornerTreeService: a } = this.state, { width: u, height: l, borderColor: d, scrollBarsMargin: p, className: f, isFixedEnabled: h, isMobile: g } = this.props, { rowsCount: m, colsCount: v, fixRowsCount: S, fixColsCount: _ } = this, R = { width: u, height: l }, b = R.height - p, y = R.width - p;
    let w = 0, x = 0;
    n[0] && (w = Array.from(Array(_)).reduce(
      (M, A, T) => M + n[T],
      0
    ), w += o || 1, x = Array.from(Array(S)).reduce(
      (M, A, T) => M + r[T],
      0
    ), x += o || 1), w = Math.ceil(w), x = Math.ceil(x);
    const P = w / y > 0.75 ? ET : "";
    let N = "";
    return S === 0 && _ === 0 ? N += `${mf} ${TT} ${gf}` : _ === 0 && (N += `${mf} ${gf}`), /* @__PURE__ */ fe(
      Xy,
      {
        onMouseScroll: this.onMouseScroll,
        className: `${_T} ${xT} ${P} ${N} ${f}`,
        children: [
          /* @__PURE__ */ O(
            Ed,
            {
              ref: this.scrollContainerRef,
              style: R,
              scrollOffset: p,
              onScroll: this.onScroll,
              children: /* @__PURE__ */ O("div", { className: `${cs} ${RT} ${bf} ${vf}`, children: /* @__PURE__ */ O(
                ai,
                {
                  type: Ct.DATA,
                  rowsCount: m,
                  colsCount: v,
                  widths: n,
                  heights: r,
                  rowsTreeService: i,
                  columnsTreeService: s,
                  cornerTreeService: a,
                  borderWidth: o,
                  borderColor: d,
                  tableSize: this.state.tableSize,
                  cellRenderer: this.cellRenderer,
                  zoomRatio: this.state.zoomRatio,
                  onGridUpdated: this.onMainGridUpdated,
                  isMobile: g
                }
              ) })
            }
          ),
          h ? /* @__PURE__ */ fe(xo, { children: [
            /* @__PURE__ */ O(
              "div",
              {
                ref: this.leftContainerRef,
                className: `${cs} ${jl} ${OT} ${bf} ${Cf}`,
                style: { width: w, height: b },
                children: /* @__PURE__ */ O(
                  ai,
                  {
                    clone: !0,
                    type: Ct.ROWS,
                    rowsCount: m,
                    colsCount: _,
                    widths: n,
                    heights: r,
                    rowsTreeService: i,
                    borderWidth: o,
                    borderColor: d,
                    tableSize: this.state.tableSize,
                    cellRenderer: this.cellRenderer,
                    zoomRatio: this.state.zoomRatio,
                    isMobile: g
                  }
                )
              }
            ),
            /* @__PURE__ */ O(
              "div",
              {
                ref: this.topContainerRef,
                className: `${cs} ${jl} ${PT} ${yf} ${vf}`,
                style: { height: x, width: y },
                children: /* @__PURE__ */ O(
                  ai,
                  {
                    clone: !0,
                    type: Ct.COLUMNS,
                    rowsCount: S,
                    colsCount: v,
                    widths: n,
                    heights: r,
                    columnsTreeService: s,
                    borderWidth: o,
                    borderColor: d,
                    tableSize: this.state.tableSize,
                    cellRenderer: this.cellRenderer,
                    zoomRatio: this.state.zoomRatio,
                    isMobile: g
                  }
                )
              }
            ),
            /* @__PURE__ */ O(
              "div",
              {
                ref: this.rightContainerRef,
                className: `${cs} ${jl} ${IT} ${yf} ${Cf}`,
                style: { width: w, height: x },
                children: /* @__PURE__ */ O(
                  ai,
                  {
                    clone: !0,
                    type: Ct.CORNER,
                    rowsCount: S,
                    colsCount: _,
                    widths: n,
                    heights: r,
                    cornerTreeService: a,
                    borderWidth: o,
                    borderColor: d,
                    tableSize: this.state.tableSize,
                    cellRenderer: this.cellRenderer,
                    zoomRatio: this.state.zoomRatio,
                    isMobile: g
                  }
                )
              }
            )
          ] }) : null
        ]
      }
    );
  }
}
I(Jy, "defaultProps", {
  borderWidth: 1,
  borderColor: "",
  isFullWidth: !1,
  isFixedEnabled: !0
});
function _n(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
var ds = { exports: {} }, ps = { exports: {} }, De = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $f;
function g1() {
  if ($f)
    return De;
  $f = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function R(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case t:
          switch (y = y.type, y) {
            case u:
            case l:
            case r:
            case i:
            case o:
            case p:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case d:
                case g:
                case h:
                case s:
                  return y;
                default:
                  return w;
              }
          }
        case n:
          return w;
      }
    }
  }
  function b(y) {
    return R(y) === l;
  }
  return De.AsyncMode = u, De.ConcurrentMode = l, De.ContextConsumer = a, De.ContextProvider = s, De.Element = t, De.ForwardRef = d, De.Fragment = r, De.Lazy = g, De.Memo = h, De.Portal = n, De.Profiler = i, De.StrictMode = o, De.Suspense = p, De.isAsyncMode = function(y) {
    return b(y) || R(y) === u;
  }, De.isConcurrentMode = b, De.isContextConsumer = function(y) {
    return R(y) === a;
  }, De.isContextProvider = function(y) {
    return R(y) === s;
  }, De.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, De.isForwardRef = function(y) {
    return R(y) === d;
  }, De.isFragment = function(y) {
    return R(y) === r;
  }, De.isLazy = function(y) {
    return R(y) === g;
  }, De.isMemo = function(y) {
    return R(y) === h;
  }, De.isPortal = function(y) {
    return R(y) === n;
  }, De.isProfiler = function(y) {
    return R(y) === i;
  }, De.isStrictMode = function(y) {
    return R(y) === o;
  }, De.isSuspense = function(y) {
    return R(y) === p;
  }, De.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === l || y === i || y === o || y === p || y === f || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === h || y.$$typeof === s || y.$$typeof === a || y.$$typeof === d || y.$$typeof === v || y.$$typeof === S || y.$$typeof === _ || y.$$typeof === m);
  }, De.typeOf = R, De;
}
var Be = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lf;
function y1() {
  return Lf || (Lf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function R(B) {
      return typeof B == "string" || typeof B == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      B === r || B === l || B === i || B === o || B === p || B === f || typeof B == "object" && B !== null && (B.$$typeof === g || B.$$typeof === h || B.$$typeof === s || B.$$typeof === a || B.$$typeof === d || B.$$typeof === v || B.$$typeof === S || B.$$typeof === _ || B.$$typeof === m);
    }
    function b(B) {
      if (typeof B == "object" && B !== null) {
        var oe = B.$$typeof;
        switch (oe) {
          case t:
            var q = B.type;
            switch (q) {
              case u:
              case l:
              case r:
              case i:
              case o:
              case p:
                return q;
              default:
                var pe = q && q.$$typeof;
                switch (pe) {
                  case a:
                  case d:
                  case g:
                  case h:
                  case s:
                    return pe;
                  default:
                    return oe;
                }
            }
          case n:
            return oe;
        }
      }
    }
    var y = u, w = l, x = a, P = s, N = t, M = d, A = r, T = g, D = h, j = n, F = i, z = o, H = p, ee = !1;
    function X(B) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), k(B) || b(B) === u;
    }
    function k(B) {
      return b(B) === l;
    }
    function $(B) {
      return b(B) === a;
    }
    function Y(B) {
      return b(B) === s;
    }
    function K(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function W(B) {
      return b(B) === d;
    }
    function Q(B) {
      return b(B) === r;
    }
    function G(B) {
      return b(B) === g;
    }
    function V(B) {
      return b(B) === h;
    }
    function U(B) {
      return b(B) === n;
    }
    function Z(B) {
      return b(B) === i;
    }
    function te(B) {
      return b(B) === o;
    }
    function ie(B) {
      return b(B) === p;
    }
    Be.AsyncMode = y, Be.ConcurrentMode = w, Be.ContextConsumer = x, Be.ContextProvider = P, Be.Element = N, Be.ForwardRef = M, Be.Fragment = A, Be.Lazy = T, Be.Memo = D, Be.Portal = j, Be.Profiler = F, Be.StrictMode = z, Be.Suspense = H, Be.isAsyncMode = X, Be.isConcurrentMode = k, Be.isContextConsumer = $, Be.isContextProvider = Y, Be.isElement = K, Be.isForwardRef = W, Be.isFragment = Q, Be.isLazy = G, Be.isMemo = V, Be.isPortal = U, Be.isProfiler = Z, Be.isStrictMode = te, Be.isSuspense = ie, Be.isValidElementType = R, Be.typeOf = b;
  }()), Be;
}
var Df;
function Qy() {
  return Df || (Df = 1, process.env.NODE_ENV === "production" ? ps.exports = g1() : ps.exports = y1()), ps.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ql, Bf;
function v1() {
  if (Bf)
    return Ql;
  Bf = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch (d) {
      return !1;
    }
  }
  return Ql = o() ? Object.assign : function(i, s) {
    for (var a, u = r(i), l, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var p in a)
        t.call(a, p) && (u[p] = a[p]);
      if (e) {
        l = e(a);
        for (var f = 0; f < l.length; f++)
          n.call(a, l[f]) && (u[l[f]] = a[l[f]]);
      }
    }
    return u;
  }, Ql;
}
var Zl, Ff;
function Rd() {
  if (Ff)
    return Zl;
  Ff = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Zl = e, Zl;
}
var ec, zf;
function Zy() {
  return zf || (zf = 1, ec = Function.call.bind(Object.prototype.hasOwnProperty)), ec;
}
var tc, jf;
function b1() {
  if (jf)
    return tc;
  jf = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Rd(), n = {}, r = Zy();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console != "undefined" && console.error(s);
      try {
        throw new Error(s);
      } catch (a) {
      }
    };
  }
  function o(i, s, a, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (r(i, d)) {
          var p;
          try {
            if (typeof i[d] != "function") {
              var f = Error(
                (u || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            p = i[d](s, d, u, a, null, t);
          } catch (g) {
            p = g;
          }
          if (p && !(p instanceof Error) && e(
            (u || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + a + " type: " + p.message + (h != null ? h : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, tc = o, tc;
}
var nc, Hf;
function C1() {
  if (Hf)
    return nc;
  Hf = 1;
  var e = Qy(), t = v1(), n = Rd(), r = Zy(), o = b1(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var u = "Warning: " + a;
    typeof console != "undefined" && console.error(u);
    try {
      throw new Error(u);
    } catch (l) {
    }
  });
  function s() {
    return null;
  }
  return nc = function(a, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function p(k) {
      var $ = k && (l && k[l] || k[d]);
      if (typeof $ == "function")
        return $;
    }
    var f = "<<anonymous>>", h = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: _(),
      arrayOf: R,
      element: b(),
      elementType: y(),
      instanceOf: w,
      node: M(),
      objectOf: P,
      oneOf: x,
      oneOfType: N,
      shape: T,
      exact: D
    };
    function g(k, $) {
      return k === $ ? k !== 0 || 1 / k === 1 / $ : k !== k && $ !== $;
    }
    function m(k, $) {
      this.message = k, this.data = $ && typeof $ == "object" ? $ : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(k) {
      if (process.env.NODE_ENV !== "production")
        var $ = {}, Y = 0;
      function K(Q, G, V, U, Z, te, ie) {
        if (U = U || f, te = te || V, ie !== n) {
          if (u) {
            var B = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw B.name = "Invariant Violation", B;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var oe = U + ":" + V;
            !$[oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + U + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), $[oe] = !0, Y++);
          }
        }
        return G[V] == null ? Q ? G[V] === null ? new m("The " + Z + " `" + te + "` is marked as required " + ("in `" + U + "`, but its value is `null`.")) : new m("The " + Z + " `" + te + "` is marked as required in " + ("`" + U + "`, but its value is `undefined`.")) : null : k(G, V, U, Z, te);
      }
      var W = K.bind(null, !1);
      return W.isRequired = K.bind(null, !0), W;
    }
    function S(k) {
      function $(Y, K, W, Q, G, V) {
        var U = Y[K], Z = z(U);
        if (Z !== k) {
          var te = H(U);
          return new m(
            "Invalid " + Q + " `" + G + "` of type " + ("`" + te + "` supplied to `" + W + "`, expected ") + ("`" + k + "`."),
            { expectedType: k }
          );
        }
        return null;
      }
      return v($);
    }
    function _() {
      return v(s);
    }
    function R(k) {
      function $(Y, K, W, Q, G) {
        if (typeof k != "function")
          return new m("Property `" + G + "` of component `" + W + "` has invalid PropType notation inside arrayOf.");
        var V = Y[K];
        if (!Array.isArray(V)) {
          var U = z(V);
          return new m("Invalid " + Q + " `" + G + "` of type " + ("`" + U + "` supplied to `" + W + "`, expected an array."));
        }
        for (var Z = 0; Z < V.length; Z++) {
          var te = k(V, Z, W, Q, G + "[" + Z + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return v($);
    }
    function b() {
      function k($, Y, K, W, Q) {
        var G = $[Y];
        if (!a(G)) {
          var V = z(G);
          return new m("Invalid " + W + " `" + Q + "` of type " + ("`" + V + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(k);
    }
    function y() {
      function k($, Y, K, W, Q) {
        var G = $[Y];
        if (!e.isValidElementType(G)) {
          var V = z(G);
          return new m("Invalid " + W + " `" + Q + "` of type " + ("`" + V + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(k);
    }
    function w(k) {
      function $(Y, K, W, Q, G) {
        if (!(Y[K] instanceof k)) {
          var V = k.name || f, U = X(Y[K]);
          return new m("Invalid " + Q + " `" + G + "` of type " + ("`" + U + "` supplied to `" + W + "`, expected ") + ("instance of `" + V + "`."));
        }
        return null;
      }
      return v($);
    }
    function x(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function $(Y, K, W, Q, G) {
        for (var V = Y[K], U = 0; U < k.length; U++)
          if (g(V, k[U]))
            return null;
        var Z = JSON.stringify(k, function(ie, B) {
          var oe = H(B);
          return oe === "symbol" ? String(B) : B;
        });
        return new m("Invalid " + Q + " `" + G + "` of value `" + String(V) + "` " + ("supplied to `" + W + "`, expected one of " + Z + "."));
      }
      return v($);
    }
    function P(k) {
      function $(Y, K, W, Q, G) {
        if (typeof k != "function")
          return new m("Property `" + G + "` of component `" + W + "` has invalid PropType notation inside objectOf.");
        var V = Y[K], U = z(V);
        if (U !== "object")
          return new m("Invalid " + Q + " `" + G + "` of type " + ("`" + U + "` supplied to `" + W + "`, expected an object."));
        for (var Z in V)
          if (r(V, Z)) {
            var te = k(V, Z, W, Q, G + "." + Z, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return v($);
    }
    function N(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var $ = 0; $ < k.length; $++) {
        var Y = k[$];
        if (typeof Y != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ee(Y) + " at index " + $ + "."
          ), s;
      }
      function K(W, Q, G, V, U) {
        for (var Z = [], te = 0; te < k.length; te++) {
          var ie = k[te], B = ie(W, Q, G, V, U, n);
          if (B == null)
            return null;
          B.data && r(B.data, "expectedType") && Z.push(B.data.expectedType);
        }
        var oe = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new m("Invalid " + V + " `" + U + "` supplied to " + ("`" + G + "`" + oe + "."));
      }
      return v(K);
    }
    function M() {
      function k($, Y, K, W, Q) {
        return j($[Y]) ? null : new m("Invalid " + W + " `" + Q + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return v(k);
    }
    function A(k, $, Y, K, W) {
      return new m(
        (k || "React class") + ": " + $ + " type `" + Y + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + W + "`."
      );
    }
    function T(k) {
      function $(Y, K, W, Q, G) {
        var V = Y[K], U = z(V);
        if (U !== "object")
          return new m("Invalid " + Q + " `" + G + "` of type `" + U + "` " + ("supplied to `" + W + "`, expected `object`."));
        for (var Z in k) {
          var te = k[Z];
          if (typeof te != "function")
            return A(W, Q, G, Z, H(te));
          var ie = te(V, Z, W, Q, G + "." + Z, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return v($);
    }
    function D(k) {
      function $(Y, K, W, Q, G) {
        var V = Y[K], U = z(V);
        if (U !== "object")
          return new m("Invalid " + Q + " `" + G + "` of type `" + U + "` " + ("supplied to `" + W + "`, expected `object`."));
        var Z = t({}, Y[K], k);
        for (var te in Z) {
          var ie = k[te];
          if (r(k, te) && typeof ie != "function")
            return A(W, Q, G, te, H(ie));
          if (!ie)
            return new m(
              "Invalid " + Q + " `" + G + "` key `" + te + "` supplied to `" + W + "`.\nBad object: " + JSON.stringify(Y[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
            );
          var B = ie(V, te, W, Q, G + "." + te, n);
          if (B)
            return B;
        }
        return null;
      }
      return v($);
    }
    function j(k) {
      switch (typeof k) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !k;
        case "object":
          if (Array.isArray(k))
            return k.every(j);
          if (k === null || a(k))
            return !0;
          var $ = p(k);
          if ($) {
            var Y = $.call(k), K;
            if ($ !== k.entries) {
              for (; !(K = Y.next()).done; )
                if (!j(K.value))
                  return !1;
            } else
              for (; !(K = Y.next()).done; ) {
                var W = K.value;
                if (W && !j(W[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function F(k, $) {
      return k === "symbol" ? !0 : $ ? $["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $ instanceof Symbol : !1;
    }
    function z(k) {
      var $ = typeof k;
      return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : F($, k) ? "symbol" : $;
    }
    function H(k) {
      if (typeof k == "undefined" || k === null)
        return "" + k;
      var $ = z(k);
      if ($ === "object") {
        if (k instanceof Date)
          return "date";
        if (k instanceof RegExp)
          return "regexp";
      }
      return $;
    }
    function ee(k) {
      var $ = H(k);
      switch ($) {
        case "array":
        case "object":
          return "an " + $;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + $;
        default:
          return $;
      }
    }
    function X(k) {
      return !k.constructor || !k.constructor.name ? f : k.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, nc;
}
var rc, Wf;
function S1() {
  if (Wf)
    return rc;
  Wf = 1;
  var e = Rd();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, rc = function() {
    function r(s, a, u, l, d, p) {
      if (p !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, rc;
}
var Vf;
function w1() {
  if (Vf)
    return ds.exports;
  if (Vf = 1, process.env.NODE_ENV !== "production") {
    var e = Qy(), t = !0;
    ds.exports = C1()(e.isElement, t);
  } else
    ds.exports = S1()();
  return ds.exports;
}
var _1 = w1();
const c = /* @__PURE__ */ Pr(_1);
function x1(e) {
  return e == null || Object.keys(e).length === 0;
}
function Od(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e;
  return /* @__PURE__ */ O(_C, {
    styles: typeof t == "function" ? (o) => t(x1(o) ? n : o) : t
  });
}
process.env.NODE_ENV !== "production" && (Od.propTypes = {
  defaultTheme: c.object,
  styles: c.oneOfType([c.array, c.string, c.object, c.func])
});
/**
 * @mui/styled-engine v6.4.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function T1(e, t) {
  const n = ty(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function E1(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const Uf = [];
function qf(e) {
  return Uf[0] = e, xC(Uf);
}
var fs = { exports: {} }, qe = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gf;
function R1() {
  if (Gf)
    return qe;
  Gf = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), s = Symbol.for("react.context"), a = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), h = Symbol.for("react.client.reference");
  function g(m) {
    if (typeof m == "object" && m !== null) {
      var v = m.$$typeof;
      switch (v) {
        case e:
          switch (m = m.type, m) {
            case n:
            case o:
            case r:
            case u:
            case l:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case s:
                case a:
                case p:
                case d:
                  return m;
                case i:
                  return m;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return qe.ContextConsumer = i, qe.ContextProvider = s, qe.Element = e, qe.ForwardRef = a, qe.Fragment = n, qe.Lazy = p, qe.Memo = d, qe.Portal = t, qe.Profiler = o, qe.StrictMode = r, qe.Suspense = u, qe.SuspenseList = l, qe.isContextConsumer = function(m) {
    return g(m) === i;
  }, qe.isContextProvider = function(m) {
    return g(m) === s;
  }, qe.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, qe.isForwardRef = function(m) {
    return g(m) === a;
  }, qe.isFragment = function(m) {
    return g(m) === n;
  }, qe.isLazy = function(m) {
    return g(m) === p;
  }, qe.isMemo = function(m) {
    return g(m) === d;
  }, qe.isPortal = function(m) {
    return g(m) === t;
  }, qe.isProfiler = function(m) {
    return g(m) === o;
  }, qe.isStrictMode = function(m) {
    return g(m) === r;
  }, qe.isSuspense = function(m) {
    return g(m) === u;
  }, qe.isSuspenseList = function(m) {
    return g(m) === l;
  }, qe.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === o || m === r || m === u || m === l || m === f || typeof m == "object" && m !== null && (m.$$typeof === p || m.$$typeof === d || m.$$typeof === s || m.$$typeof === i || m.$$typeof === a || m.$$typeof === h || m.getModuleId !== void 0);
  }, qe.typeOf = g, qe;
}
var Ge = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kf;
function O1() {
  return Kf || (Kf = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m) {
      if (typeof m == "object" && m !== null) {
        var v = m.$$typeof;
        switch (v) {
          case t:
            switch (m = m.type, m) {
              case r:
              case i:
              case o:
              case l:
              case d:
                return m;
              default:
                switch (m = m && m.$$typeof, m) {
                  case a:
                  case u:
                  case f:
                  case p:
                    return m;
                  case s:
                    return m;
                  default:
                    return v;
                }
            }
          case n:
            return v;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g = Symbol.for("react.client.reference");
    Ge.ContextConsumer = s, Ge.ContextProvider = a, Ge.Element = t, Ge.ForwardRef = u, Ge.Fragment = r, Ge.Lazy = f, Ge.Memo = p, Ge.Portal = n, Ge.Profiler = i, Ge.StrictMode = o, Ge.Suspense = l, Ge.SuspenseList = d, Ge.isContextConsumer = function(m) {
      return e(m) === s;
    }, Ge.isContextProvider = function(m) {
      return e(m) === a;
    }, Ge.isElement = function(m) {
      return typeof m == "object" && m !== null && m.$$typeof === t;
    }, Ge.isForwardRef = function(m) {
      return e(m) === u;
    }, Ge.isFragment = function(m) {
      return e(m) === r;
    }, Ge.isLazy = function(m) {
      return e(m) === f;
    }, Ge.isMemo = function(m) {
      return e(m) === p;
    }, Ge.isPortal = function(m) {
      return e(m) === n;
    }, Ge.isProfiler = function(m) {
      return e(m) === i;
    }, Ge.isStrictMode = function(m) {
      return e(m) === o;
    }, Ge.isSuspense = function(m) {
      return e(m) === l;
    }, Ge.isSuspenseList = function(m) {
      return e(m) === d;
    }, Ge.isValidElementType = function(m) {
      return typeof m == "string" || typeof m == "function" || m === r || m === i || m === o || m === l || m === d || m === h || typeof m == "object" && m !== null && (m.$$typeof === f || m.$$typeof === p || m.$$typeof === a || m.$$typeof === s || m.$$typeof === u || m.$$typeof === g || m.getModuleId !== void 0);
    }, Ge.typeOf = e;
  }()), Ge;
}
var Yf;
function P1() {
  return Yf || (Yf = 1, process.env.NODE_ENV === "production" ? fs.exports = R1() : fs.exports = O1()), fs.exports;
}
var Tr = P1();
function vn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ev(e) {
  if (/* @__PURE__ */ E.isValidElement(e) || Tr.isValidElementType(e) || !vn(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = ev(e[n]);
  }), t;
}
function xt(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? C({}, e) : e;
  return vn(e) && vn(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ E.isValidElement(t[o]) || Tr.isValidElementType(t[o]) ? r[o] = t[o] : vn(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && vn(e[o]) ? r[o] = xt(e[o], t[o], n) : n.clone ? r[o] = vn(t[o]) ? ev(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const I1 = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => L(C({}, n), {
    [r.key]: r.val
  }), {});
};
function N1(e) {
  const f = e, {
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5
  } = f, o = re(f, [
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    "values",
    "unit",
    "step"
  ]), i = I1(t), s = Object.keys(i);
  function a(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n})`;
  }
  function u(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - r / 100}${n})`;
  }
  function l(h, g) {
    const m = s.indexOf(g);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n}) and (max-width:${(m !== -1 && typeof t[s[m]] == "number" ? t[s[m]] : g) - r / 100}${n})`;
  }
  function d(h) {
    return s.indexOf(h) + 1 < s.length ? l(h, s[s.indexOf(h) + 1]) : a(h);
  }
  function p(h) {
    const g = s.indexOf(h);
    return g === 0 ? a(s[1]) : g === s.length - 1 ? u(s[g]) : l(h, s[s.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return C({
    keys: s,
    values: i,
    up: a,
    down: u,
    between: l,
    only: d,
    not: p,
    unit: n
  }, o);
}
function M1(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, o) => {
    var s, a;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((s = r.match(i)) == null ? void 0 : s[1]) || 0) - +(((a = o.match(i)) == null ? void 0 : a[1]) || 0);
  });
  return n.length ? n.reduce((r, o) => {
    const i = t[o];
    return delete r[o], r[o] = i, r;
  }, C({}, t)) : t;
}
function k1(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function A1(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : _n(18, `(${t})`));
    return null;
  }
  const [, r, o] = n, i = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(o).up(i);
}
function $1(e) {
  const t = (i, s) => i.replace("@media", s ? `@container ${s}` : "@container");
  function n(i, s) {
    i.up = (...a) => t(e.breakpoints.up(...a), s), i.down = (...a) => t(e.breakpoints.down(...a), s), i.between = (...a) => t(e.breakpoints.between(...a), s), i.only = (...a) => t(e.breakpoints.only(...a), s), i.not = (...a) => {
      const u = t(e.breakpoints.not(...a), s);
      return u.includes("not all and") ? u.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : u;
    };
  }
  const r = {}, o = (i) => (n(r, i), r);
  return n(o), L(C({}, e), {
    containerQueries: o
  });
}
const L1 = {
  borderRadius: 4
}, D1 = L1, B1 = process.env.NODE_ENV !== "production" ? c.oneOfType([c.number, c.string, c.object, c.array]) : {}, lr = B1;
function gi(e, t) {
  return t ? xt(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Fa = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Xf = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Fa[e]}px)`
}, F1 = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : Fa[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function Fn(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const i = r.breakpoints || Xf;
    return t.reduce((s, a, u) => (s[i.up(i.keys[u])] = n(t[u]), s), {});
  }
  if (typeof t == "object") {
    const i = r.breakpoints || Xf;
    return Object.keys(t).reduce((s, a) => {
      if (k1(i.keys, a)) {
        const u = A1(r.containerQueries ? r : F1, a);
        u && (s[u] = n(t[a], a));
      } else if (Object.keys(i.values || Fa).includes(a)) {
        const u = i.up(a);
        s[u] = n(t[a], a);
      } else {
        const u = a;
        s[u] = t[u];
      }
      return s;
    }, {});
  }
  return n(t);
}
function z1(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, o) => {
    const i = e.up(o);
    return r[i] = {}, r;
  }, {})) || {};
}
function j1(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function ve(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : _n(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function za(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function fa(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = za(e, n) || r, t && (o = t(o, r, e)), o;
}
function pt(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (s) => {
    if (s[t] == null)
      return null;
    const a = s[t], u = s.theme, l = za(u, r) || {};
    return Fn(s, a, (p) => {
      let f = fa(l, o, p);
      return p === f && typeof p == "string" && (f = fa(l, o, `${t}${p === "default" ? "" : ve(p)}`, p)), n === !1 ? f : {
        [n]: f
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: lr
  } : {}, i.filterProps = [t], i;
}
function H1(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const W1 = {
  m: "margin",
  p: "padding"
}, V1 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Jf = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, U1 = H1((e) => {
  if (e.length > 2)
    if (Jf[e])
      e = Jf[e];
    else
      return [e];
  const [t, n] = e.split(""), r = W1[t], o = V1[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), ja = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Ha = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], q1 = [...ja, ...Ha];
function Hi(e, t, n, r) {
  var i;
  const o = (i = za(e, t, !0)) != null ? i : n;
  return typeof o == "number" || typeof o == "string" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${s}.`), typeof o == "string" ? `calc(${s} * ${o})` : o * s) : Array.isArray(o) ? (s) => {
    if (typeof s == "string")
      return s;
    const a = Math.abs(s);
    process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > o.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${a} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const u = o[a];
    return s >= 0 ? u : typeof u == "number" ? -u : `-${u}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Pd(e) {
  return Hi(e, "spacing", 8, "spacing");
}
function Wi(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function G1(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = Wi(t, n), r), {});
}
function K1(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const o = U1(n), i = G1(o, r), s = e[n];
  return Fn(e, s, i);
}
function tv(e, t) {
  const n = Pd(e.theme);
  return Object.keys(e).map((r) => K1(e, t, r, n)).reduce(gi, {});
}
function st(e) {
  return tv(e, ja);
}
st.propTypes = process.env.NODE_ENV !== "production" ? ja.reduce((e, t) => (e[t] = lr, e), {}) : {};
st.filterProps = ja;
function at(e) {
  return tv(e, Ha);
}
at.propTypes = process.env.NODE_ENV !== "production" ? Ha.reduce((e, t) => (e[t] = lr, e), {}) : {};
at.filterProps = Ha;
process.env.NODE_ENV !== "production" && q1.reduce((e, t) => (e[t] = lr, e), {});
function nv(e = 8, t = Pd({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((i) => {
    const s = t(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return n.mui = !0, n;
}
function Wa(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? gi(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function Xt(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function en(e, t) {
  return pt({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const Y1 = en("border", Xt), X1 = en("borderTop", Xt), J1 = en("borderRight", Xt), Q1 = en("borderBottom", Xt), Z1 = en("borderLeft", Xt), eE = en("borderColor"), tE = en("borderTopColor"), nE = en("borderRightColor"), rE = en("borderBottomColor"), oE = en("borderLeftColor"), iE = en("outline", Xt), sE = en("outlineColor"), Va = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Hi(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Wi(t, r)
    });
    return Fn(e, e.borderRadius, n);
  }
  return null;
};
Va.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: lr
} : {};
Va.filterProps = ["borderRadius"];
Wa(Y1, X1, J1, Q1, Z1, eE, tE, nE, rE, oE, Va, iE, sE);
const Ua = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Hi(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Wi(t, r)
    });
    return Fn(e, e.gap, n);
  }
  return null;
};
Ua.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: lr
} : {};
Ua.filterProps = ["gap"];
const qa = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Hi(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Wi(t, r)
    });
    return Fn(e, e.columnGap, n);
  }
  return null;
};
qa.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: lr
} : {};
qa.filterProps = ["columnGap"];
const Ga = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Hi(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Wi(t, r)
    });
    return Fn(e, e.rowGap, n);
  }
  return null;
};
Ga.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: lr
} : {};
Ga.filterProps = ["rowGap"];
const aE = pt({
  prop: "gridColumn"
}), lE = pt({
  prop: "gridRow"
}), cE = pt({
  prop: "gridAutoFlow"
}), uE = pt({
  prop: "gridAutoColumns"
}), dE = pt({
  prop: "gridAutoRows"
}), pE = pt({
  prop: "gridTemplateColumns"
}), fE = pt({
  prop: "gridTemplateRows"
}), hE = pt({
  prop: "gridTemplateAreas"
}), mE = pt({
  prop: "gridArea"
});
Wa(Ua, qa, Ga, aE, lE, cE, uE, dE, pE, fE, hE, mE);
function po(e, t) {
  return t === "grey" ? t : e;
}
const gE = pt({
  prop: "color",
  themeKey: "palette",
  transform: po
}), yE = pt({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: po
}), vE = pt({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: po
});
Wa(gE, yE, vE);
function jt(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const bE = pt({
  prop: "width",
  transform: jt
}), Id = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, i, s, a, u;
      const r = ((s = (i = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : i.values) == null ? void 0 : s[n]) || Fa[n];
      return r ? ((u = (a = e.theme) == null ? void 0 : a.breakpoints) == null ? void 0 : u.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: jt(n)
      };
    };
    return Fn(e, e.maxWidth, t);
  }
  return null;
};
Id.filterProps = ["maxWidth"];
const CE = pt({
  prop: "minWidth",
  transform: jt
}), SE = pt({
  prop: "height",
  transform: jt
}), wE = pt({
  prop: "maxHeight",
  transform: jt
}), _E = pt({
  prop: "minHeight",
  transform: jt
});
pt({
  prop: "size",
  cssProperty: "width",
  transform: jt
});
pt({
  prop: "size",
  cssProperty: "height",
  transform: jt
});
const xE = pt({
  prop: "boxSizing"
});
Wa(bE, Id, CE, SE, wE, _E, xE);
const TE = {
  // borders
  border: {
    themeKey: "borders",
    transform: Xt
  },
  borderTop: {
    themeKey: "borders",
    transform: Xt
  },
  borderRight: {
    themeKey: "borders",
    transform: Xt
  },
  borderBottom: {
    themeKey: "borders",
    transform: Xt
  },
  borderLeft: {
    themeKey: "borders",
    transform: Xt
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Xt
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Va
  },
  // palette
  color: {
    themeKey: "palette",
    transform: po
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: po
  },
  backgroundColor: {
    themeKey: "palette",
    transform: po
  },
  // spacing
  p: {
    style: at
  },
  pt: {
    style: at
  },
  pr: {
    style: at
  },
  pb: {
    style: at
  },
  pl: {
    style: at
  },
  px: {
    style: at
  },
  py: {
    style: at
  },
  padding: {
    style: at
  },
  paddingTop: {
    style: at
  },
  paddingRight: {
    style: at
  },
  paddingBottom: {
    style: at
  },
  paddingLeft: {
    style: at
  },
  paddingX: {
    style: at
  },
  paddingY: {
    style: at
  },
  paddingInline: {
    style: at
  },
  paddingInlineStart: {
    style: at
  },
  paddingInlineEnd: {
    style: at
  },
  paddingBlock: {
    style: at
  },
  paddingBlockStart: {
    style: at
  },
  paddingBlockEnd: {
    style: at
  },
  m: {
    style: st
  },
  mt: {
    style: st
  },
  mr: {
    style: st
  },
  mb: {
    style: st
  },
  ml: {
    style: st
  },
  mx: {
    style: st
  },
  my: {
    style: st
  },
  margin: {
    style: st
  },
  marginTop: {
    style: st
  },
  marginRight: {
    style: st
  },
  marginBottom: {
    style: st
  },
  marginLeft: {
    style: st
  },
  marginX: {
    style: st
  },
  marginY: {
    style: st
  },
  marginInline: {
    style: st
  },
  marginInlineStart: {
    style: st
  },
  marginInlineEnd: {
    style: st
  },
  marginBlock: {
    style: st
  },
  marginBlockStart: {
    style: st
  },
  marginBlockEnd: {
    style: st
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Ua
  },
  rowGap: {
    style: Ga
  },
  columnGap: {
    style: qa
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: jt
  },
  maxWidth: {
    style: Id
  },
  minWidth: {
    transform: jt
  },
  height: {
    transform: jt
  },
  maxHeight: {
    transform: jt
  },
  minHeight: {
    transform: jt
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, Vi = TE;
function EE(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function RE(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function OE() {
  function e(n, r, o, i) {
    const s = {
      [n]: r,
      theme: o
    }, a = i[n];
    if (!a)
      return {
        [n]: r
      };
    const {
      cssProperty: u = n,
      themeKey: l,
      transform: d,
      style: p
    } = a;
    if (r == null)
      return null;
    if (l === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const f = za(o, l) || {};
    return p ? p(s) : Fn(s, r, (g) => {
      let m = fa(f, d, g);
      return g === m && typeof g == "string" && (m = fa(f, d, `${n}${g === "default" ? "" : ve(g)}`, g)), u === !1 ? m : {
        [u]: m
      };
    });
  }
  function t(n) {
    var a;
    const {
      sx: r,
      theme: o = {}
    } = n || {};
    if (!r)
      return null;
    const i = (a = o.unstable_sxConfig) != null ? a : Vi;
    function s(u) {
      let l = u;
      if (typeof u == "function")
        l = u(o);
      else if (typeof u != "object")
        return u;
      if (!l)
        return null;
      const d = z1(o.breakpoints), p = Object.keys(d);
      let f = d;
      return Object.keys(l).forEach((h) => {
        const g = RE(l[h], o);
        if (g != null)
          if (typeof g == "object")
            if (i[h])
              f = gi(f, e(h, g, o, i));
            else {
              const m = Fn({
                theme: o
              }, g, (v) => ({
                [h]: v
              }));
              EE(m, g) ? f[h] = t({
                sx: g,
                theme: o
              }) : f = gi(f, m);
            }
          else
            f = gi(f, e(h, g, o, i));
      }), M1(o, j1(p, f));
    }
    return Array.isArray(r) ? r.map(s) : s(r);
  }
  return t;
}
const rv = OE();
rv.filterProps = ["sx"];
const mo = rv;
function PE(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let o = n.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function Nd(e = {}, ...t) {
  const d = e, {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {}
  } = d, s = re(d, [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
  ]), a = N1(n), u = nv(o);
  let l = xt({
    breakpoints: a,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: C({
      mode: "light"
    }, r),
    spacing: u,
    shape: C(C({}, D1), i)
  }, s);
  return l = $1(l), l.applyStyles = PE, l = t.reduce((p, f) => xt(p, f), l), l.unstable_sxConfig = C(C({}, Vi), s == null ? void 0 : s.unstable_sxConfig), l.unstable_sx = function(f) {
    return mo({
      sx: f,
      theme: this
    });
  }, l;
}
function IE(e) {
  return Object.keys(e).length === 0;
}
function ov(e = null) {
  const t = E.useContext(ny);
  return !t || IE(t) ? e : t;
}
const NE = Nd();
function iv(e = NE) {
  return ov(e);
}
function sv({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = iv(n), o = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ O(Od, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (sv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: c.object,
  /**
   * @ignore
   */
  styles: c.oneOfType([c.array, c.func, c.number, c.object, c.string, c.bool]),
  /**
   * @ignore
   */
  themeId: c.string
});
const ME = (e) => {
  var r, o;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = (o = (r = e == null ? void 0 : e.theme) == null ? void 0 : r.unstable_sxConfig) != null ? o : Vi;
  return Object.keys(e).forEach((i) => {
    n[i] ? t.systemProps[i] = e[i] : t.otherProps[i] = e[i];
  }), t;
};
function kE(e) {
  const s = e, {
    sx: t
  } = s, n = re(s, [
    "sx"
  ]), {
    systemProps: r,
    otherProps: o
  } = ME(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...a) => {
    const u = t(...a);
    return vn(u) ? C(C({}, r), u) : r;
  } : i = C(C({}, r), t), L(C({}, o), {
    sx: i
  });
}
const Qf = (e) => e, AE = () => {
  let e = Qf;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Qf;
    }
  };
}, $E = AE(), LE = $E;
function av(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = av(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function xe() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = av(e)) && (r && (r += " "), r += t);
  return r;
}
const DE = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Ve(e, t, n = "Mui") {
  const r = DE[t];
  return r ? `${n}-${r}` : `${LE.generate(e)}-${t}`;
}
function Le(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = Ve(e, o, n);
  }), r;
}
function lv(e, t = "") {
  return e.displayName || e.name || t;
}
function Zf(e, t, n) {
  const r = lv(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function BE(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return lv(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Tr.ForwardRef:
          return Zf(e, e.render, "ForwardRef");
        case Tr.Memo:
          return Zf(e, e.type, "memo");
        default:
          return;
      }
  }
}
function cv(e) {
  const o = e, {
    variants: t
  } = o, n = re(o, [
    "variants"
  ]), r = {
    variants: t,
    style: qf(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((i) => {
    typeof i.style != "function" && (i.style = qf(i.style));
  }), r;
}
const FE = Nd();
function oc(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function zE(e) {
  return e ? (t, n) => n[e] : null;
}
function jE(e, t, n) {
  e.theme = UE(e.theme) ? n : e.theme[t] || e.theme;
}
function Xs(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((o) => Xs(e, o));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let o;
    if (n.isProcessed)
      o = n.style;
    else {
      const r = n, {
        variants: i
      } = r;
      o = re(r, [
        "variants"
      ]);
    }
    return uv(e, n.variants, [o]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function uv(e, t, n = []) {
  var o;
  let r;
  e:
    for (let i = 0; i < t.length; i += 1) {
      const s = t[i];
      if (typeof s.props == "function") {
        if (r != null || (r = L(C(C({}, e), e.ownerState), {
          ownerState: e.ownerState
        })), !s.props(r))
          continue;
      } else
        for (const a in s.props)
          if (e[a] !== s.props[a] && ((o = e.ownerState) == null ? void 0 : o[a]) !== s.props[a])
            continue e;
      typeof s.style == "function" ? (r != null || (r = L(C(C({}, e), e.ownerState), {
        ownerState: e.ownerState
      })), n.push(s.style(r))) : n.push(s.style);
    }
  return n;
}
function HE(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = FE,
    rootShouldForwardProp: r = oc,
    slotShouldForwardProp: o = oc
  } = e;
  function i(a) {
    jE(a, t, n);
  }
  return (a, u = {}) => {
    E1(a, (w) => w.filter((x) => x !== mo));
    const y = u, {
      name: l,
      slot: d,
      skipVariantsResolver: p,
      skipSx: f,
      overridesResolver: h = zE(dv(d))
    } = y, g = re(y, [
      "name",
      "slot",
      "skipVariantsResolver",
      "skipSx",
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      "overridesResolver"
    ]), m = p !== void 0 ? p : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), v = f || !1;
    let S = oc;
    d === "Root" || d === "root" ? S = r : d ? S = o : qE(a) && (S = void 0);
    const _ = T1(a, C({
      shouldForwardProp: S,
      label: VE(l, d)
    }, g)), R = (w) => {
      if (w.__emotion_real === w)
        return w;
      if (typeof w == "function")
        return function(P) {
          return Xs(P, w);
        };
      if (vn(w)) {
        const x = cv(w);
        return x.variants ? function(N) {
          return Xs(N, x);
        } : x.style;
      }
      return w;
    }, b = (...w) => {
      const x = [], P = w.map(R), N = [];
      if (x.push(i), l && h && N.push(function(D) {
        var H, ee;
        const F = (ee = (H = D.theme.components) == null ? void 0 : H[l]) == null ? void 0 : ee.styleOverrides;
        if (!F)
          return null;
        const z = {};
        for (const X in F)
          z[X] = Xs(D, F[X]);
        return h(D, z);
      }), l && !m && N.push(function(D) {
        var z, H;
        const j = D.theme, F = (H = (z = j == null ? void 0 : j.components) == null ? void 0 : z[l]) == null ? void 0 : H.variants;
        return F ? uv(D, F) : null;
      }), v || N.push(mo), Array.isArray(P[0])) {
        const T = P.shift(), D = new Array(x.length).fill(""), j = new Array(N.length).fill("");
        let F;
        F = [...D, ...T, ...j], F.raw = [...D, ...T.raw, ...j], x.unshift(F);
      }
      const M = [...x, ...P, ...N], A = _(...M);
      return a.muiName && (A.muiName = a.muiName), process.env.NODE_ENV !== "production" && (A.displayName = WE(l, d, a)), A;
    };
    return _.withConfig && (b.withConfig = _.withConfig), b;
  };
}
function WE(e, t, n) {
  return e ? `${e}${ve(t || "")}` : `Styled(${BE(n)})`;
}
function VE(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${dv(t || "Root")}`), n;
}
function UE(e) {
  for (const t in e)
    return !1;
  return !0;
}
function qE(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function dv(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function Au(e, t) {
  const n = C({}, t);
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const o = r;
      if (o === "components" || o === "slots")
        n[o] = C(C({}, e[o]), n[o]);
      else if (o === "componentsProps" || o === "slotProps") {
        const i = e[o], s = t[o];
        if (!s)
          n[o] = i || {};
        else if (!i)
          n[o] = s;
        else {
          n[o] = C({}, s);
          for (const a in i)
            if (Object.prototype.hasOwnProperty.call(i, a)) {
              const u = a;
              n[o][u] = Au(i[u], s[u]);
            }
        }
      } else
        n[o] === void 0 && (n[o] = e[o]);
    }
  return n;
}
const GE = typeof window != "undefined" ? E.useLayoutEffect : E.useEffect, ln = GE;
function KE(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function Md(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), KE(e, t, n);
}
function YE(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, o) => o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function sr(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return sr(YE(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : _n(9, e));
  let r = e.substring(t + 1, e.length - 1), o;
  if (n === "color") {
    if (r = r.split(" "), o = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : _n(10, o));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: o
  };
}
const XE = (e) => {
  const t = sr(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, li = (e, t) => {
  try {
    return XE(e);
  } catch (n) {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function Ka(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function pv(e) {
  e = sr(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, o = t[2] / 100, i = r * Math.min(o, 1 - o), s = (l, d = (l + n / 30) % 12) => o - i * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  let a = "rgb";
  const u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (a += "a", u.push(t[3])), Ka({
    type: a,
    values: u
  });
}
function $u(e) {
  e = sr(e);
  let t = e.type === "hsl" || e.type === "hsla" ? sr(pv(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : Nn((n + 0.055) / 1.055, 2.4))), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function eh(e, t) {
  const n = $u(e), r = $u(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function dt(e, t) {
  return e = sr(e), t = Md(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Ka(e);
}
function hs(e, t, n) {
  try {
    return dt(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function Ya(e, t) {
  if (e = sr(e), t = Md(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return Ka(e);
}
function Xe(e, t, n) {
  try {
    return Ya(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function Xa(e, t) {
  if (e = sr(e), t = Md(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return Ka(e);
}
function Je(e, t, n) {
  try {
    return Xa(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function JE(e, t = 0.15) {
  return $u(e) > 0.5 ? Ya(e, t) : Xa(e, t);
}
function ms(e, t, n) {
  try {
    return JE(e, t);
  } catch (r) {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function Vn(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function QE(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function fv(e, t, n, r, o) {
  const i = e[t], s = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let a;
  const u = i.type;
  return typeof u == "function" && !QE(u) && (a = "Did you accidentally use a plain function component for an element instead?"), a !== void 0 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${a} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const hv = Vn(c.element, fv);
hv.isRequired = Vn(c.element.isRequired, fv);
const Ui = hv;
function ZE(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function eR(e, t, n, r, o) {
  const i = e[t], s = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let a;
  return typeof i == "function" && !ZE(i) && (a = "Did you accidentally provide a plain function component instead?"), a !== void 0 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${a} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const kd = Vn(c.elementType, eR), tR = "exact-prop: ​";
function Ja(e) {
  return process.env.NODE_ENV === "production" ? e : L(C({}, e), {
    [tR]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function zn(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], s = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const nR = c.oneOfType([c.func, c.object]), un = nR;
function th(...e) {
  return e.reduce((t, n) => n == null ? t : function(...o) {
    t.apply(this, o), n.apply(this, o);
  }, () => {
  });
}
function mv(e, t = 166) {
  let n;
  function r(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function Vt(e) {
  return e && e.ownerDocument || document;
}
function jn(e) {
  return Vt(e).defaultView || window;
}
function nh(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let rh = 0;
function rR(e) {
  const [t, n] = E.useState(e), r = e || t;
  return E.useEffect(() => {
    t == null && (rh += 1, n(`mui-${rh}`));
  }, [t]), r;
}
const oR = C({}, E), oh = oR.useId;
function Oi(e) {
  if (oh !== void 0) {
    const t = oh();
    return e != null ? e : t;
  }
  return rR(e);
}
function Pi({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = E.useRef(e !== void 0), [i, s] = E.useState(t), a = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    E.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: l
    } = E.useRef(t);
    E.useEffect(() => {
      !o && !Object.is(l, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const u = E.useCallback((l) => {
    o || s(l);
  }, []);
  return [a, u];
}
function Ln(e) {
  const t = E.useRef(e);
  return ln(() => {
    t.current = e;
  }), E.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function yt(...e) {
  const t = E.useRef(void 0), n = E.useCallback((r) => {
    const o = e.map((i) => {
      if (i == null)
        return null;
      if (typeof i == "function") {
        const s = i, a = s(r);
        return typeof a == "function" ? a : () => {
          s(null);
        };
      }
      return i.current = r, () => {
        i.current = null;
      };
    });
    return () => {
      o.forEach((i) => i == null ? void 0 : i());
    };
  }, e);
  return E.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
const ih = {};
function gv(e, t) {
  const n = E.useRef(ih);
  return n.current === ih && (n.current = e(t)), n;
}
const iR = [];
function sR(e) {
  E.useEffect(e, iR);
}
class Qa {
  constructor() {
    I(this, "currentId", null);
    I(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    I(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Qa();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function oo() {
  const e = gv(Qa.create).current;
  return sR(e.disposeEffect), e;
}
function ha(e) {
  try {
    return e.matches(":focus-visible");
  } catch (t) {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function yv(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
function aR(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function vv(e, t, n, r) {
  const o = e[t];
  if (o == null || !Number.isInteger(o)) {
    const i = aR(o);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function bv(e, t, ...n) {
  return e[t] === void 0 ? null : vv(e, t, ...n);
}
function Lu() {
  return null;
}
bv.isRequired = vv;
Lu.isRequired = Lu;
const bn = process.env.NODE_ENV === "production" ? Lu : bv;
function Ye(e, t, n = void 0) {
  const r = {};
  for (const o in e) {
    const i = e[o];
    let s = "", a = !0;
    for (let u = 0; u < i.length; u += 1) {
      const l = i[u];
      l && (s += (a === !0 ? "" : " ") + t(l), a = !1, n && n[l] && (s += " " + n[l]));
    }
    r[o] = s;
  }
  return r;
}
function lR(e) {
  return typeof e == "string";
}
function Cv(e, t, n) {
  return e === void 0 || lR(e) ? t : L(C({}, t), {
    ownerState: C(C({}, t.ownerState), n)
  });
}
function Sv(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function sh(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function wv(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const h = xe(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), g = C(C(C({}, n == null ? void 0 : n.style), o == null ? void 0 : o.style), r == null ? void 0 : r.style), m = C(C(C({}, n), o), r);
    return h.length > 0 && (m.className = h), Object.keys(g).length > 0 && (m.style = g), {
      props: m,
      internalRef: void 0
    };
  }
  const s = Sv(C(C({}, o), r)), a = sh(r), u = sh(o), l = t(s), d = xe(l == null ? void 0 : l.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), p = C(C(C(C({}, l == null ? void 0 : l.style), n == null ? void 0 : n.style), o == null ? void 0 : o.style), r == null ? void 0 : r.style), f = C(C(C(C({}, l), n), u), a);
  return d.length > 0 && (f.className = d), Object.keys(p).length > 0 && (f.style = p), {
    props: f,
    internalRef: l.ref
  };
}
function _v(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function xv(e) {
  var f;
  const p = e, {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: o = !1
  } = p, i = re(p, [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
  ]), s = o ? {} : _v(n, r), {
    props: a,
    internalRef: u
  } = wv(L(C({}, i), {
    externalSlotProps: s
  })), l = yt(u, s == null ? void 0 : s.ref, (f = e.additionalProps) == null ? void 0 : f.ref);
  return Cv(t, L(C({}, a), {
    ref: l
  }), r);
}
function Ro(e) {
  var t;
  return parseInt(E.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const Tv = /* @__PURE__ */ E.createContext(null);
process.env.NODE_ENV !== "production" && (Tv.displayName = "ThemeContext");
const Ev = Tv;
function Ad() {
  const e = E.useContext(Ev);
  return process.env.NODE_ENV !== "production" && E.useDebugValue(e), e;
}
const cR = typeof Symbol == "function" && Symbol.for, uR = cR ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function dR(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return C(C({}, e), t);
}
function ma(e) {
  const {
    children: t,
    theme: n
  } = e, r = Ad();
  process.env.NODE_ENV !== "production" && r === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = E.useMemo(() => {
    const i = r === null ? C({}, n) : dR(r, n);
    return i != null && (i[uR] = r !== null), i;
  }, [n, r]);
  return /* @__PURE__ */ O(Ev.Provider, {
    value: o,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (ma.propTypes = {
  /**
   * Your component tree.
   */
  children: c.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: c.oneOfType([c.object, c.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (ma.propTypes = Ja(ma.propTypes));
const Rv = /* @__PURE__ */ E.createContext();
function Ov(n) {
  var r = n, {
    value: e
  } = r, t = re(r, [
    "value"
  ]);
  return /* @__PURE__ */ O(Rv.Provider, C({
    value: e != null ? e : !0
  }, t));
}
process.env.NODE_ENV !== "production" && (Ov.propTypes = {
  children: c.node,
  value: c.bool
});
const qi = () => {
  const e = E.useContext(Rv);
  return e != null ? e : !1;
}, Pv = /* @__PURE__ */ E.createContext(void 0);
function Iv({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ O(Pv.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Iv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: c.node,
  /**
   * @ignore
   */
  value: c.object
});
function pR(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const o = t.components[n];
  return o.defaultProps ? Au(o.defaultProps, r) : !o.styleOverrides && !o.variants ? Au(o, r) : r;
}
function fR({
  props: e,
  name: t
}) {
  const n = E.useContext(Pv);
  return pR({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const ah = {};
function lh(e, t, n, r = !1) {
  return E.useMemo(() => {
    const o = e && t[e] || t;
    if (typeof n == "function") {
      const i = n(o), s = e ? L(C({}, t), {
        [e]: i
      }) : i;
      return r ? () => s : s;
    }
    return e ? L(C({}, t), {
      [e]: n
    }) : C(C({}, t), n);
  }, [e, t, n, r]);
}
function Ii(e) {
  const {
    children: t,
    theme: n,
    themeId: r
  } = e, o = ov(ah), i = Ad() || ah;
  process.env.NODE_ENV !== "production" && (o === null && typeof n == "function" || r && o && !o[r] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = lh(r, o, n), a = lh(r, i, n, !0), u = (r ? s[r] : s).direction === "rtl";
  return /* @__PURE__ */ O(ma, {
    theme: a,
    children: /* @__PURE__ */ O(ny.Provider, {
      value: s,
      children: /* @__PURE__ */ O(Ov, {
        value: u,
        children: /* @__PURE__ */ O(Iv, {
          value: r ? s[r].components : s.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Ii.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: c.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: c.oneOfType([c.func, c.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: c.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Ii.propTypes = Ja(Ii.propTypes));
const ch = {
  theme: void 0
};
function hR(e) {
  let t, n;
  return function(o) {
    let i = t;
    return (i === void 0 || o.theme !== n) && (ch.theme = o.theme, i = cv(e(ch)), t = i, n = o.theme), i;
  };
}
const $d = "mode", Ld = "color-scheme", mR = "data-color-scheme";
function gR(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: n = "light",
    defaultDarkColorScheme: r = "dark",
    modeStorageKey: o = $d,
    colorSchemeStorageKey: i = Ld,
    attribute: s = mR,
    colorSchemeNode: a = "document.documentElement",
    nonce: u
  } = e || {};
  let l = "", d = s;
  if (s === "class" && (d = ".%s"), s === "data" && (d = "[data-%s]"), d.startsWith(".")) {
    const f = d.substring(1);
    l += `${a}.classList.remove('${f}'.replace('%s', light), '${f}'.replace('%s', dark));
      ${a}.classList.add('${f}'.replace('%s', colorScheme));`;
  }
  const p = d.match(/\[([^\]]+)\]/);
  if (p) {
    const [f, h] = p[1].split("=");
    h || (l += `${a}.removeAttribute('${f}'.replace('%s', light));
      ${a}.removeAttribute('${f}'.replace('%s', dark));`), l += `
      ${a}.setAttribute('${f}'.replace('%s', colorScheme), ${h ? `${h}.replace('%s', colorScheme)` : '""'});`;
  } else
    l += `${a}.setAttribute('${d}', colorScheme);`;
  return /* @__PURE__ */ O("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window == "undefined" ? u : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${o}') || '${t}';
  const dark = localStorage.getItem('${i}-dark') || '${r}';
  const light = localStorage.getItem('${i}-light') || '${n}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${l}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function yR() {
}
const vR = ({
  key: e,
  storageWindow: t
}) => (!t && typeof window != "undefined" && (t = window), {
  get(n) {
    if (typeof window == "undefined")
      return;
    if (!t)
      return n;
    let r;
    try {
      r = t.localStorage.getItem(e);
    } catch (o) {
    }
    return r || n;
  },
  set: (n) => {
    if (t)
      try {
        t.localStorage.setItem(e, n);
      } catch (r) {
      }
  },
  subscribe: (n) => {
    if (!t)
      return yR;
    const r = (o) => {
      const i = o.newValue;
      o.key === e && n(i);
    };
    return t.addEventListener("storage", r), () => {
      t.removeEventListener("storage", r);
    };
  }
}), bR = vR;
function ic() {
}
function uh(e) {
  if (typeof window != "undefined" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function Nv(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function CR(e) {
  return Nv(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function SR(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: n,
    defaultDarkColorScheme: r,
    supportedColorSchemes: o = [],
    modeStorageKey: i = $d,
    colorSchemeStorageKey: s = Ld,
    storageWindow: a = typeof window == "undefined" ? void 0 : window,
    storageManager: u = bR,
    noSsr: l = !1
  } = e, d = o.join(","), p = o.length > 1, f = E.useMemo(() => u == null ? void 0 : u({
    key: i,
    storageWindow: a
  }), [u, i, a]), h = E.useMemo(() => u == null ? void 0 : u({
    key: `${s}-light`,
    storageWindow: a
  }), [u, s, a]), g = E.useMemo(() => u == null ? void 0 : u({
    key: `${s}-dark`,
    storageWindow: a
  }), [u, s, a]), [m, v] = E.useState(() => {
    const P = (f == null ? void 0 : f.get(t)) || t, N = (h == null ? void 0 : h.get(n)) || n, M = (g == null ? void 0 : g.get(r)) || r;
    return {
      mode: P,
      systemMode: uh(P),
      lightColorScheme: N,
      darkColorScheme: M
    };
  }), [S, _] = E.useState(l || !p);
  E.useEffect(() => {
    _(!0);
  }, []);
  const R = CR(m), b = E.useCallback((P) => {
    v((N) => {
      if (P === N.mode)
        return N;
      const M = P != null ? P : t;
      return f == null || f.set(M), L(C({}, N), {
        mode: M,
        systemMode: uh(M)
      });
    });
  }, [f, t]), y = E.useCallback((P) => {
    P ? typeof P == "string" ? P && !d.includes(P) ? console.error(`\`${P}\` does not exist in \`theme.colorSchemes\`.`) : v((N) => {
      const M = C({}, N);
      return Nv(N, (A) => {
        A === "light" && (h == null || h.set(P), M.lightColorScheme = P), A === "dark" && (g == null || g.set(P), M.darkColorScheme = P);
      }), M;
    }) : v((N) => {
      const M = C({}, N), A = P.light === null ? n : P.light, T = P.dark === null ? r : P.dark;
      return A && (d.includes(A) ? (M.lightColorScheme = A, h == null || h.set(A)) : console.error(`\`${A}\` does not exist in \`theme.colorSchemes\`.`)), T && (d.includes(T) ? (M.darkColorScheme = T, g == null || g.set(T)) : console.error(`\`${T}\` does not exist in \`theme.colorSchemes\`.`)), M;
    }) : v((N) => (h == null || h.set(n), g == null || g.set(r), L(C({}, N), {
      lightColorScheme: n,
      darkColorScheme: r
    })));
  }, [d, h, g, n, r]), w = E.useCallback((P) => {
    m.mode === "system" && v((N) => {
      const M = P != null && P.matches ? "dark" : "light";
      return N.systemMode === M ? N : L(C({}, N), {
        systemMode: M
      });
    });
  }, [m.mode]), x = E.useRef(w);
  return x.current = w, E.useEffect(() => {
    if (typeof window.matchMedia != "function" || !p)
      return;
    const P = (...M) => x.current(...M), N = window.matchMedia("(prefers-color-scheme: dark)");
    return N.addListener(P), P(N), () => {
      N.removeListener(P);
    };
  }, [p]), E.useEffect(() => {
    if (p) {
      const P = (f == null ? void 0 : f.subscribe((A) => {
        (!A || ["light", "dark", "system"].includes(A)) && b(A || t);
      })) || ic, N = (h == null ? void 0 : h.subscribe((A) => {
        (!A || d.match(A)) && y({
          light: A
        });
      })) || ic, M = (g == null ? void 0 : g.subscribe((A) => {
        (!A || d.match(A)) && y({
          dark: A
        });
      })) || ic;
      return () => {
        P(), N(), M();
      };
    }
  }, [y, b, d, t, a, p, f, h, g]), L(C({}, m), {
    mode: S ? m.mode : void 0,
    systemMode: S ? m.systemMode : void 0,
    colorScheme: S ? R : void 0,
    setMode: b,
    setColorScheme: y
  });
}
const wR = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function _R(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: n = {},
    modeStorageKey: r = $d,
    colorSchemeStorageKey: o = Ld,
    disableTransitionOnChange: i = !1,
    defaultColorScheme: s,
    resolveTheme: a
  } = e, u = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, l = /* @__PURE__ */ E.createContext(void 0);
  process.env.NODE_ENV !== "production" && (l.displayName = "ColorSchemeContext");
  const d = () => E.useContext(l) || u, p = {}, f = {};
  function h(S) {
    var Se, mt, ke, Qe;
    const {
      children: _,
      theme: R,
      modeStorageKey: b = r,
      colorSchemeStorageKey: y = o,
      disableTransitionOnChange: w = i,
      storageManager: x,
      storageWindow: P = typeof window == "undefined" ? void 0 : window,
      documentNode: N = typeof document == "undefined" ? void 0 : document,
      colorSchemeNode: M = typeof document == "undefined" ? void 0 : document.documentElement,
      disableNestedContext: A = !1,
      disableStyleSheetGeneration: T = !1,
      defaultMode: D = "system",
      noSsr: j
    } = S, F = E.useRef(!1), z = Ad(), H = E.useContext(l), ee = !!H && !A, X = E.useMemo(() => R || (typeof n == "function" ? n() : n), [R]), k = X[t], $ = k || X, {
      colorSchemes: Y = p,
      components: K = f,
      cssVarPrefix: W
    } = $, Q = Object.keys(Y).filter((we) => !!Y[we]).join(","), G = E.useMemo(() => Q.split(","), [Q]), V = typeof s == "string" ? s : s.light, U = typeof s == "string" ? s : s.dark, Z = Y[V] && Y[U] ? D : ((mt = (Se = Y[$.defaultColorScheme]) == null ? void 0 : Se.palette) == null ? void 0 : mt.mode) || ((ke = $.palette) == null ? void 0 : ke.mode), {
      mode: te,
      setMode: ie,
      systemMode: B,
      lightColorScheme: oe,
      darkColorScheme: q,
      colorScheme: pe,
      setColorScheme: ge
    } = SR({
      supportedColorSchemes: G,
      defaultLightColorScheme: V,
      defaultDarkColorScheme: U,
      modeStorageKey: b,
      colorSchemeStorageKey: y,
      defaultMode: Z,
      storageManager: x,
      storageWindow: P,
      noSsr: j
    });
    let Ee = te, be = pe;
    ee && (Ee = H.mode, be = H.colorScheme);
    const ye = E.useMemo(() => {
      var Ae;
      const we = be || $.defaultColorScheme, Ne = ((Ae = $.generateThemeVars) == null ? void 0 : Ae.call($)) || $.vars, Ue = L(C({}, $), {
        components: K,
        colorSchemes: Y,
        cssVarPrefix: W,
        vars: Ne
      });
      if (typeof Ue.generateSpacing == "function" && (Ue.spacing = Ue.generateSpacing()), we) {
        const je = Y[we];
        je && typeof je == "object" && Object.keys(je).forEach((ce) => {
          je[ce] && typeof je[ce] == "object" ? Ue[ce] = C(C({}, Ue[ce]), je[ce]) : Ue[ce] = je[ce];
        });
      }
      return a ? a(Ue) : Ue;
    }, [$, be, K, Y, W]), Re = $.colorSchemeSelector;
    ln(() => {
      if (be && M && Re && Re !== "media") {
        const we = Re;
        let Ne = Re;
        if (we === "class" && (Ne = ".%s"), we === "data" && (Ne = "[data-%s]"), we != null && we.startsWith("data-") && !we.includes("%s") && (Ne = `[${we}="%s"]`), Ne.startsWith("."))
          M.classList.remove(...G.map((Ue) => Ne.substring(1).replace("%s", Ue))), M.classList.add(Ne.substring(1).replace("%s", be));
        else {
          const Ue = Ne.replace("%s", be).match(/\[([^\]]+)\]/);
          if (Ue) {
            const [Ae, je] = Ue[1].split("=");
            je || G.forEach((ce) => {
              M.removeAttribute(Ae.replace(be, ce));
            }), M.setAttribute(Ae, je ? je.replace(/"|'/g, "") : "");
          } else
            M.setAttribute(Ne, be);
        }
      }
    }, [be, Re, M, G]), E.useEffect(() => {
      let we;
      if (w && F.current && N) {
        const Ne = N.createElement("style");
        Ne.appendChild(N.createTextNode(wR)), N.head.appendChild(Ne), window.getComputedStyle(N.body), we = setTimeout(() => {
          N.head.removeChild(Ne);
        }, 1);
      }
      return () => {
        clearTimeout(we);
      };
    }, [be, w, N]), E.useEffect(() => (F.current = !0, () => {
      F.current = !1;
    }), []);
    const Me = E.useMemo(() => ({
      allColorSchemes: G,
      colorScheme: be,
      darkColorScheme: q,
      lightColorScheme: oe,
      mode: Ee,
      setColorScheme: ge,
      setMode: process.env.NODE_ENV === "production" ? ie : (we) => {
        ye.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), ie(we);
      },
      systemMode: B
    }), [G, be, q, oe, Ee, ge, ie, B, ye.colorSchemeSelector]);
    let Ie = !0;
    (T || $.cssVariables === !1 || ee && (z == null ? void 0 : z.cssVarPrefix) === W) && (Ie = !1);
    const ae = /* @__PURE__ */ fe(E.Fragment, {
      children: [/* @__PURE__ */ O(Ii, {
        themeId: k ? t : void 0,
        theme: ye,
        children: _
      }), Ie && /* @__PURE__ */ O(Od, {
        styles: ((Qe = ye.generateStyleSheets) == null ? void 0 : Qe.call(ye)) || []
      })]
    });
    return ee ? ae : /* @__PURE__ */ O(l.Provider, {
      value: Me,
      children: ae
    });
  }
  process.env.NODE_ENV !== "production" && (h.propTypes = {
    /**
     * The component tree.
     */
    children: c.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: c.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: c.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: c.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: c.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: c.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: c.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: c.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: c.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: c.bool,
    /**
     * The storage manager to be used for storing the mode and color scheme
     * @default using `window.localStorage`
     */
    storageManager: c.func,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: c.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: c.object
  });
  const g = typeof s == "string" ? s : s.light, m = typeof s == "string" ? s : s.dark;
  return {
    CssVarsProvider: h,
    useColorScheme: d,
    getInitColorSchemeScript: (S) => gR(C({
      colorSchemeStorageKey: o,
      defaultLightColorScheme: g,
      defaultDarkColorScheme: m,
      modeStorageKey: r
    }, S))
  };
}
function xR(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const o = r[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...r.slice(1))})` : `, ${o}`;
  }
  return (r, ...o) => `var(--${e ? `${e}-` : ""}${r}${t(...o)})`;
}
const dh = (e, t, n, r = []) => {
  let o = e;
  t.forEach((i, s) => {
    s === t.length - 1 ? Array.isArray(o) ? o[Number(i)] = n : o && typeof o == "object" && (o[i] = n) : o && typeof o == "object" && (o[i] || (o[i] = r.includes(i) ? [] : {}), o = o[i]);
  });
}, TR = (e, t, n) => {
  function r(o, i = [], s = []) {
    Object.entries(o).forEach(([a, u]) => {
      (!n || n && !n([...i, a])) && u != null && (typeof u == "object" && Object.keys(u).length > 0 ? r(u, [...i, a], Array.isArray(u) ? [...s, a] : s) : t([...i, a], u, s));
    });
  }
  r(e);
}, ER = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function sc(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, o = {}, i = {}, s = {};
  return TR(
    e,
    (a, u, l) => {
      if ((typeof u == "string" || typeof u == "number") && (!r || !r(a, u))) {
        const d = `--${n ? `${n}-` : ""}${a.join("-")}`, p = ER(a, u);
        Object.assign(o, {
          [d]: p
        }), dh(i, a, `var(${d})`, l), dh(s, a, `var(${d}, ${p})`, l);
      }
    },
    (a) => a[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: s
  };
}
function RR(e, t = {}) {
  const {
    getSelector: n = v,
    disableCssColorScheme: r,
    colorSchemeSelector: o
  } = t, R = e, {
    colorSchemes: i = {},
    components: s,
    defaultColorScheme: a = "light"
  } = R, u = re(R, [
    "colorSchemes",
    "components",
    "defaultColorScheme"
  ]), {
    vars: l,
    css: d,
    varsWithDefaults: p
  } = sc(u, t);
  let f = p;
  const h = {}, b = i, {
    [a]: g
  } = b, m = re(b, [
    is(a)
  ]);
  if (Object.entries(m || {}).forEach(([y, w]) => {
    const {
      vars: x,
      css: P,
      varsWithDefaults: N
    } = sc(w, t);
    f = xt(f, N), h[y] = {
      css: P,
      vars: x
    };
  }), g) {
    const {
      css: y,
      vars: w,
      varsWithDefaults: x
    } = sc(g, t);
    f = xt(f, x), h[a] = {
      css: y,
      vars: w
    };
  }
  function v(y, w) {
    var P, N;
    let x = o;
    if (o === "class" && (x = ".%s"), o === "data" && (x = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (x = `[${o}="%s"]`), y) {
      if (x === "media")
        return e.defaultColorScheme === y ? ":root" : {
          [`@media (prefers-color-scheme: ${((N = (P = i[y]) == null ? void 0 : P.palette) == null ? void 0 : N.mode) || y})`]: {
            ":root": w
          }
        };
      if (x)
        return e.defaultColorScheme === y ? `:root, ${x.replace("%s", String(y))}` : x.replace("%s", String(y));
    }
    return ":root";
  }
  return {
    vars: f,
    generateThemeVars: () => {
      let y = C({}, l);
      return Object.entries(h).forEach(([, {
        vars: w
      }]) => {
        y = xt(y, w);
      }), y;
    },
    generateStyleSheets: () => {
      var A, T;
      const y = [], w = e.defaultColorScheme || "light";
      function x(D, j) {
        Object.keys(j).length && y.push(typeof D == "string" ? {
          [D]: C({}, j)
        } : D);
      }
      x(n(void 0, C({}, d)), d);
      const M = h, {
        [w]: P
      } = M, N = re(M, [
        is(w)
      ]);
      if (P) {
        const {
          css: D
        } = P, j = (T = (A = i[w]) == null ? void 0 : A.palette) == null ? void 0 : T.mode, F = C(!r && j ? {
          colorScheme: j
        } : {}, D);
        x(n(w, C({}, F)), F);
      }
      return Object.entries(N).forEach(([D, {
        css: j
      }]) => {
        var H, ee;
        const F = (ee = (H = i[D]) == null ? void 0 : H.palette) == null ? void 0 : ee.mode, z = C(!r && F ? {
          colorScheme: F
        } : {}, j);
        x(n(D, C({}, z)), z);
      }), y;
    }
  };
}
function OR(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const Dn = "$$material";
function PR(n) {
  var r = n, {
    theme: e
  } = r, t = re(r, [
    "theme"
  ]);
  const o = Dn in e ? e[Dn] : void 0;
  return /* @__PURE__ */ O(Ii, L(C({}, t), {
    themeId: o ? Dn : void 0,
    theme: o || e
  }));
}
const IR = {
  black: "#000",
  white: "#fff"
}, Ni = IR, NR = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, MR = NR, kR = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Vr = kR, AR = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Ur = AR, $R = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Uo = $R, LR = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, qr = LR, DR = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Gr = DR, BR = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Kr = BR;
function Mv() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Ni.white,
      default: Ni.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const FR = Mv();
function kv() {
  return {
    text: {
      primary: Ni.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Ni.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const ph = kv();
function fh(e, t, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Xa(e.main, o) : t === "dark" && (e.dark = Ya(e.main, i)));
}
function zR(e = "light") {
  return e === "dark" ? {
    main: qr[200],
    light: qr[50],
    dark: qr[400]
  } : {
    main: qr[700],
    light: qr[400],
    dark: qr[800]
  };
}
function jR(e = "light") {
  return e === "dark" ? {
    main: Vr[200],
    light: Vr[50],
    dark: Vr[400]
  } : {
    main: Vr[500],
    light: Vr[300],
    dark: Vr[700]
  };
}
function HR(e = "light") {
  return e === "dark" ? {
    main: Ur[500],
    light: Ur[300],
    dark: Ur[700]
  } : {
    main: Ur[700],
    light: Ur[400],
    dark: Ur[800]
  };
}
function WR(e = "light") {
  return e === "dark" ? {
    main: Gr[400],
    light: Gr[300],
    dark: Gr[700]
  } : {
    main: Gr[700],
    light: Gr[500],
    dark: Gr[900]
  };
}
function VR(e = "light") {
  return e === "dark" ? {
    main: Kr[400],
    light: Kr[300],
    dark: Kr[700]
  } : {
    main: Kr[800],
    light: Kr[500],
    dark: Kr[900]
  };
}
function UR(e = "light") {
  return e === "dark" ? {
    main: Uo[400],
    light: Uo[300],
    dark: Uo[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Uo[500],
    dark: Uo[900]
  };
}
function Dd(e) {
  const m = e, {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2
  } = m, o = re(m, [
    "mode",
    "contrastThreshold",
    "tonalOffset"
  ]), i = e.primary || zR(t), s = e.secondary || jR(t), a = e.error || HR(t), u = e.info || WR(t), l = e.success || VR(t), d = e.warning || UR(t);
  function p(v) {
    const S = eh(v, ph.text.primary) >= n ? ph.text.primary : FR.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const _ = eh(v, S);
      _ < 3 && console.error([`MUI: The contrast ratio of ${_}:1 for ${S} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return S;
  }
  const f = ({
    color: v,
    name: S,
    mainShade: _ = 500,
    lightShade: R = 300,
    darkShade: b = 700
  }) => {
    if (v = C({}, v), !v.main && v[_] && (v.main = v[_]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${_}\` property.` : _n(11, S ? ` (${S})` : "", _));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${S ? ` (${S})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : _n(12, S ? ` (${S})` : "", JSON.stringify(v.main)));
    return fh(v, "light", R, r), fh(v, "dark", b, r), v.contrastText || (v.contrastText = p(v.main)), v;
  };
  let h;
  return t === "light" ? h = Mv() : t === "dark" && (h = kv()), process.env.NODE_ENV !== "production" && (h || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), xt(C({
    // A collection of common colors.
    common: C({}, Ni),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: f({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: f({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: f({
      color: a,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: f({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: f({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: f({
      color: l,
      name: "success"
    }),
    // The grey colors.
    grey: MR,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: p,
    // Generate a rich color object.
    augmentColor: f,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r
  }, h), o);
}
function qR(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [o, i] = r;
    typeof i == "object" && (t[o] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function GR(e, t) {
  return C({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
function KR(e) {
  return Math.round(e * 1e5) / 1e5;
}
const hh = {
  textTransform: "uppercase"
}, mh = '"Roboto", "Helvetica", "Arial", sans-serif';
function Av(e, t) {
  const v = typeof t == "function" ? t(e) : t, {
    fontFamily: n = mh,
    fontSize: r = 14,
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: a = 700,
    htmlFontSize: u = 16,
    allVariants: l,
    pxToRem: d
  } = v, p = re(v, [
    "fontFamily",
    // The default font size of the Material Specification.
    "fontSize",
    // px
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    "htmlFontSize",
    // Apply the CSS properties to all the variants.
    "allVariants",
    "pxToRem"
  ]);
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof u != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const f = r / 14, h = d || ((S) => `${S / u * f}rem`), g = (S, _, R, b, y) => C(C(C({
    fontFamily: n,
    fontWeight: S,
    fontSize: h(_),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: R
  }, n === mh ? {
    letterSpacing: `${KR(b / _)}em`
  } : {}), y), l), m = {
    h1: g(o, 96, 1.167, -1.5),
    h2: g(o, 60, 1.2, -0.5),
    h3: g(i, 48, 1.167, 0),
    h4: g(i, 34, 1.235, 0.25),
    h5: g(i, 24, 1.334, 0),
    h6: g(s, 20, 1.6, 0.15),
    subtitle1: g(i, 16, 1.75, 0.15),
    subtitle2: g(s, 14, 1.57, 0.1),
    body1: g(i, 16, 1.5, 0.15),
    body2: g(i, 14, 1.43, 0.15),
    button: g(s, 14, 1.75, 0.4, hh),
    caption: g(i, 12, 1.66, 0.4),
    overline: g(i, 12, 2.66, 1, hh),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return xt(C({
    htmlFontSize: u,
    pxToRem: h,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: a
  }, m), p, {
    clone: !1
    // No need to clone deep
  });
}
const YR = 0.2, XR = 0.14, JR = 0.12;
function rt(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${YR})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${XR})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${JR})`].join(",");
}
const QR = ["none", rt(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), rt(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), rt(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), rt(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), rt(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), rt(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), rt(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), rt(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), rt(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), rt(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), rt(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), rt(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), rt(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), rt(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), rt(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), rt(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), rt(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), rt(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), rt(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), rt(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), rt(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), rt(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), rt(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), rt(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], ZR = QR, eO = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, tO = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function gh(e) {
  return `${Math.round(e)}ms`;
}
function nO(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * Nn(t, 0.25) + t / 5) * 10), 3e3);
}
function rO(e) {
  const t = C(C({}, eO), e.easing), n = C(C({}, tO), e.duration);
  return L(C({
    getAutoHeightDuration: nO,
    create: (o = ["all"], i = {}) => {
      const d = i, {
        duration: s = n.standard,
        easing: a = t.easeInOut,
        delay: u = 0
      } = d, l = re(d, [
        "duration",
        "easing",
        "delay"
      ]);
      if (process.env.NODE_ENV !== "production") {
        const p = (h) => typeof h == "string", f = (h) => !Number.isNaN(parseFloat(h));
        !p(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !f(s) && !p(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), p(a) || console.error('MUI: Argument "easing" must be a string.'), !f(u) && !p(u) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(l).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(l).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((p) => `${p} ${typeof s == "string" ? s : gh(s)} ${a} ${typeof u == "string" ? u : gh(u)}`).join(",");
    }
  }, e), {
    easing: t,
    duration: n
  });
}
const oO = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, iO = oO;
function sO(e) {
  return vn(e) || typeof e == "undefined" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function $v(e = {}) {
  const t = C({}, e);
  function n(r) {
    const o = Object.entries(r);
    for (let i = 0; i < o.length; i++) {
      const [s, a] = o[i];
      !sO(a) || s.startsWith("unstable_") ? delete r[s] : vn(a) && (r[s] = C({}, a), n(r[s]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Du(e = {}, ...t) {
  const h = e, {
    breakpoints: n,
    mixins: r = {},
    spacing: o,
    palette: i = {},
    transitions: s = {},
    typography: a = {},
    shape: u
  } = h, l = re(h, [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
  ]);
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : _n(20));
  const d = Dd(i), p = Nd(e);
  let f = xt(p, {
    mixins: GR(p.breakpoints, r),
    palette: d,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: ZR.slice(),
    typography: Av(d, a),
    transitions: rO(s),
    zIndex: C({}, iO)
  });
  if (f = xt(f, l), f = t.reduce((g, m) => xt(g, m), f), process.env.NODE_ENV !== "production") {
    const g = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], m = (v, S) => {
      let _;
      for (_ in v) {
        const R = v[_];
        if (g.includes(_) && Object.keys(R).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const b = Ve("", _);
            console.error([`MUI: The \`${S}\` component increases the CSS specificity of the \`${_}\` internal state.`, "You can not override it like this: ", JSON.stringify(v, null, 2), "", `Instead, you need to use the '&.${b}' syntax:`, JSON.stringify({
              root: {
                [`&.${b}`]: R
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          v[_] = {};
        }
      }
    };
    Object.keys(f.components).forEach((v) => {
      const S = f.components[v].styleOverrides;
      S && v.startsWith("Mui") && m(S, v);
    });
  }
  return f.unstable_sxConfig = C(C({}, Vi), l == null ? void 0 : l.unstable_sxConfig), f.unstable_sx = function(m) {
    return mo({
      sx: m,
      theme: this
    });
  }, f.toRuntimeSource = $v, f;
}
function Bu(e) {
  let t;
  return e < 1 ? t = 5.11916 * Nn(e, 2) : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const aO = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Bu(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function Lv(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function Dv(e) {
  return e === "dark" ? aO : [];
}
function lO(e) {
  const s = e, {
    palette: t = {
      mode: "light"
    },
    opacity: n,
    overlays: r
  } = s, o = re(s, [
    "palette",
    // need to cast to avoid module augmentation test
    "opacity",
    "overlays"
  ]), i = Dd(t);
  return C({
    palette: i,
    opacity: C(C({}, Lv(i.mode)), n),
    overlays: r || Dv(i.mode)
  }, o);
}
function cO(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const uO = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], dO = uO, pO = (e) => (t, n) => {
  const r = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const s = {};
      return dO(e.cssVarPrefix).forEach((a) => {
        s[a] = n[a], delete n[a];
      }), i === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: s
        }
      } : i ? {
        [i.replace("%s", t)]: s,
        [`${r}, ${i.replace("%s", t)}`]: n
      } : {
        [r]: C(C({}, n), s)
      };
    }
    if (i && i !== "media")
      return `${r}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return r;
};
function fO(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function J(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function ci(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : pv(e);
}
function Mn(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = li(ci(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function hO(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const fn = (e) => {
  try {
    return e();
  } catch (t) {
  }
}, mO = (e = "mui") => xR(e);
function ac(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = lO(L(C({}, t), {
      palette: C({
        mode: o
      }, t == null ? void 0 : t.palette)
    }));
    return;
  }
  const a = Du(L(C({}, n), {
    palette: C({
      mode: o
    }, t == null ? void 0 : t.palette)
  })), {
    palette: i
  } = a, s = re(a, [
    "palette"
  ]);
  return e[r] = L(C({}, t), {
    palette: i,
    opacity: C(C({}, Lv(o)), t == null ? void 0 : t.opacity),
    overlays: (t == null ? void 0 : t.overlays) || Dv(o)
  }), s;
}
function gO(e = {}, ...t) {
  const N = e, {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: s = cO,
    colorSchemeSelector: a = n.light && n.dark ? "media" : void 0,
    rootSelector: u = ":root"
  } = N, l = re(N, [
    "colorSchemes",
    "defaultColorScheme",
    "disableCssColorScheme",
    "cssVarPrefix",
    "shouldSkipGeneratingVar",
    "colorSchemeSelector",
    "rootSelector"
  ]), d = Object.keys(n)[0], p = r || (n.light && d !== "light" ? "light" : d), f = mO(i), M = n, {
    [p]: h,
    light: g,
    dark: m
  } = M, v = re(M, [
    is(p),
    "light",
    "dark"
  ]), S = C({}, v);
  let _ = h;
  if ((p === "dark" && !("dark" in n) || p === "light" && !("light" in n)) && (_ = !0), !_)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${p}\` option is either missing or invalid.` : _n(21, p));
  const R = ac(S, _, l, p);
  g && !S.light && ac(S, g, void 0, "light"), m && !S.dark && ac(S, m, void 0, "dark");
  let b = L(C({
    defaultColorScheme: p
  }, R), {
    cssVarPrefix: i,
    colorSchemeSelector: a,
    rootSelector: u,
    getCssVar: f,
    colorSchemes: S,
    font: C(C({}, qR(R.typography)), R.font),
    spacing: hO(l.spacing)
  });
  Object.keys(b.colorSchemes).forEach((A) => {
    const T = b.colorSchemes[A].palette, D = (j) => {
      const F = j.split("-"), z = F[1], H = F[2];
      return f(j, T[z][H]);
    };
    if (T.mode === "light" && (J(T.common, "background", "#fff"), J(T.common, "onBackground", "#000")), T.mode === "dark" && (J(T.common, "background", "#000"), J(T.common, "onBackground", "#fff")), fO(T, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), T.mode === "light") {
      J(T.Alert, "errorColor", Xe(T.error.light, 0.6)), J(T.Alert, "infoColor", Xe(T.info.light, 0.6)), J(T.Alert, "successColor", Xe(T.success.light, 0.6)), J(T.Alert, "warningColor", Xe(T.warning.light, 0.6)), J(T.Alert, "errorFilledBg", D("palette-error-main")), J(T.Alert, "infoFilledBg", D("palette-info-main")), J(T.Alert, "successFilledBg", D("palette-success-main")), J(T.Alert, "warningFilledBg", D("palette-warning-main")), J(T.Alert, "errorFilledColor", fn(() => T.getContrastText(T.error.main))), J(T.Alert, "infoFilledColor", fn(() => T.getContrastText(T.info.main))), J(T.Alert, "successFilledColor", fn(() => T.getContrastText(T.success.main))), J(T.Alert, "warningFilledColor", fn(() => T.getContrastText(T.warning.main))), J(T.Alert, "errorStandardBg", Je(T.error.light, 0.9)), J(T.Alert, "infoStandardBg", Je(T.info.light, 0.9)), J(T.Alert, "successStandardBg", Je(T.success.light, 0.9)), J(T.Alert, "warningStandardBg", Je(T.warning.light, 0.9)), J(T.Alert, "errorIconColor", D("palette-error-main")), J(T.Alert, "infoIconColor", D("palette-info-main")), J(T.Alert, "successIconColor", D("palette-success-main")), J(T.Alert, "warningIconColor", D("palette-warning-main")), J(T.AppBar, "defaultBg", D("palette-grey-100")), J(T.Avatar, "defaultBg", D("palette-grey-400")), J(T.Button, "inheritContainedBg", D("palette-grey-300")), J(T.Button, "inheritContainedHoverBg", D("palette-grey-A100")), J(T.Chip, "defaultBorder", D("palette-grey-400")), J(T.Chip, "defaultAvatarColor", D("palette-grey-700")), J(T.Chip, "defaultIconColor", D("palette-grey-700")), J(T.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), J(T.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), J(T.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), J(T.LinearProgress, "primaryBg", Je(T.primary.main, 0.62)), J(T.LinearProgress, "secondaryBg", Je(T.secondary.main, 0.62)), J(T.LinearProgress, "errorBg", Je(T.error.main, 0.62)), J(T.LinearProgress, "infoBg", Je(T.info.main, 0.62)), J(T.LinearProgress, "successBg", Je(T.success.main, 0.62)), J(T.LinearProgress, "warningBg", Je(T.warning.main, 0.62)), J(T.Skeleton, "bg", `rgba(${D("palette-text-primaryChannel")} / 0.11)`), J(T.Slider, "primaryTrack", Je(T.primary.main, 0.62)), J(T.Slider, "secondaryTrack", Je(T.secondary.main, 0.62)), J(T.Slider, "errorTrack", Je(T.error.main, 0.62)), J(T.Slider, "infoTrack", Je(T.info.main, 0.62)), J(T.Slider, "successTrack", Je(T.success.main, 0.62)), J(T.Slider, "warningTrack", Je(T.warning.main, 0.62));
      const j = ms(T.background.default, 0.8);
      J(T.SnackbarContent, "bg", j), J(T.SnackbarContent, "color", fn(() => T.getContrastText(j))), J(T.SpeedDialAction, "fabHoverBg", ms(T.background.paper, 0.15)), J(T.StepConnector, "border", D("palette-grey-400")), J(T.StepContent, "border", D("palette-grey-400")), J(T.Switch, "defaultColor", D("palette-common-white")), J(T.Switch, "defaultDisabledColor", D("palette-grey-100")), J(T.Switch, "primaryDisabledColor", Je(T.primary.main, 0.62)), J(T.Switch, "secondaryDisabledColor", Je(T.secondary.main, 0.62)), J(T.Switch, "errorDisabledColor", Je(T.error.main, 0.62)), J(T.Switch, "infoDisabledColor", Je(T.info.main, 0.62)), J(T.Switch, "successDisabledColor", Je(T.success.main, 0.62)), J(T.Switch, "warningDisabledColor", Je(T.warning.main, 0.62)), J(T.TableCell, "border", Je(hs(T.divider, 1), 0.88)), J(T.Tooltip, "bg", hs(T.grey[700], 0.92));
    }
    if (T.mode === "dark") {
      J(T.Alert, "errorColor", Je(T.error.light, 0.6)), J(T.Alert, "infoColor", Je(T.info.light, 0.6)), J(T.Alert, "successColor", Je(T.success.light, 0.6)), J(T.Alert, "warningColor", Je(T.warning.light, 0.6)), J(T.Alert, "errorFilledBg", D("palette-error-dark")), J(T.Alert, "infoFilledBg", D("palette-info-dark")), J(T.Alert, "successFilledBg", D("palette-success-dark")), J(T.Alert, "warningFilledBg", D("palette-warning-dark")), J(T.Alert, "errorFilledColor", fn(() => T.getContrastText(T.error.dark))), J(T.Alert, "infoFilledColor", fn(() => T.getContrastText(T.info.dark))), J(T.Alert, "successFilledColor", fn(() => T.getContrastText(T.success.dark))), J(T.Alert, "warningFilledColor", fn(() => T.getContrastText(T.warning.dark))), J(T.Alert, "errorStandardBg", Xe(T.error.light, 0.9)), J(T.Alert, "infoStandardBg", Xe(T.info.light, 0.9)), J(T.Alert, "successStandardBg", Xe(T.success.light, 0.9)), J(T.Alert, "warningStandardBg", Xe(T.warning.light, 0.9)), J(T.Alert, "errorIconColor", D("palette-error-main")), J(T.Alert, "infoIconColor", D("palette-info-main")), J(T.Alert, "successIconColor", D("palette-success-main")), J(T.Alert, "warningIconColor", D("palette-warning-main")), J(T.AppBar, "defaultBg", D("palette-grey-900")), J(T.AppBar, "darkBg", D("palette-background-paper")), J(T.AppBar, "darkColor", D("palette-text-primary")), J(T.Avatar, "defaultBg", D("palette-grey-600")), J(T.Button, "inheritContainedBg", D("palette-grey-800")), J(T.Button, "inheritContainedHoverBg", D("palette-grey-700")), J(T.Chip, "defaultBorder", D("palette-grey-700")), J(T.Chip, "defaultAvatarColor", D("palette-grey-300")), J(T.Chip, "defaultIconColor", D("palette-grey-300")), J(T.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), J(T.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), J(T.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), J(T.LinearProgress, "primaryBg", Xe(T.primary.main, 0.5)), J(T.LinearProgress, "secondaryBg", Xe(T.secondary.main, 0.5)), J(T.LinearProgress, "errorBg", Xe(T.error.main, 0.5)), J(T.LinearProgress, "infoBg", Xe(T.info.main, 0.5)), J(T.LinearProgress, "successBg", Xe(T.success.main, 0.5)), J(T.LinearProgress, "warningBg", Xe(T.warning.main, 0.5)), J(T.Skeleton, "bg", `rgba(${D("palette-text-primaryChannel")} / 0.13)`), J(T.Slider, "primaryTrack", Xe(T.primary.main, 0.5)), J(T.Slider, "secondaryTrack", Xe(T.secondary.main, 0.5)), J(T.Slider, "errorTrack", Xe(T.error.main, 0.5)), J(T.Slider, "infoTrack", Xe(T.info.main, 0.5)), J(T.Slider, "successTrack", Xe(T.success.main, 0.5)), J(T.Slider, "warningTrack", Xe(T.warning.main, 0.5));
      const j = ms(T.background.default, 0.98);
      J(T.SnackbarContent, "bg", j), J(T.SnackbarContent, "color", fn(() => T.getContrastText(j))), J(T.SpeedDialAction, "fabHoverBg", ms(T.background.paper, 0.15)), J(T.StepConnector, "border", D("palette-grey-600")), J(T.StepContent, "border", D("palette-grey-600")), J(T.Switch, "defaultColor", D("palette-grey-300")), J(T.Switch, "defaultDisabledColor", D("palette-grey-600")), J(T.Switch, "primaryDisabledColor", Xe(T.primary.main, 0.55)), J(T.Switch, "secondaryDisabledColor", Xe(T.secondary.main, 0.55)), J(T.Switch, "errorDisabledColor", Xe(T.error.main, 0.55)), J(T.Switch, "infoDisabledColor", Xe(T.info.main, 0.55)), J(T.Switch, "successDisabledColor", Xe(T.success.main, 0.55)), J(T.Switch, "warningDisabledColor", Xe(T.warning.main, 0.55)), J(T.TableCell, "border", Xe(hs(T.divider, 1), 0.68)), J(T.Tooltip, "bg", hs(T.grey[700], 0.92));
    }
    Mn(T.background, "default"), Mn(T.background, "paper"), Mn(T.common, "background"), Mn(T.common, "onBackground"), Mn(T, "divider"), Object.keys(T).forEach((j) => {
      const F = T[j];
      j !== "tonalOffset" && F && typeof F == "object" && (F.main && J(T[j], "mainChannel", li(ci(F.main))), F.light && J(T[j], "lightChannel", li(ci(F.light))), F.dark && J(T[j], "darkChannel", li(ci(F.dark))), F.contrastText && J(T[j], "contrastTextChannel", li(ci(F.contrastText))), j === "text" && (Mn(T[j], "primary"), Mn(T[j], "secondary")), j === "action" && (F.active && Mn(T[j], "active"), F.selected && Mn(T[j], "selected")));
    });
  }), b = t.reduce((A, T) => xt(A, T), b);
  const y = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: s,
    getSelector: pO(b)
  }, {
    vars: w,
    generateThemeVars: x,
    generateStyleSheets: P
  } = RR(b, y);
  return b.vars = w, Object.entries(b.colorSchemes[b.defaultColorScheme]).forEach(([A, T]) => {
    b[A] = T;
  }), b.generateThemeVars = x, b.generateStyleSheets = P, b.generateSpacing = function() {
    return nv(l.spacing, Pd(this));
  }, b.getColorSchemeSelector = OR(a), b.spacing = b.generateSpacing(), b.shouldSkipGeneratingVar = s, b.unstable_sxConfig = C(C({}, Vi), l == null ? void 0 : l.unstable_sxConfig), b.unstable_sx = function(T) {
    return mo({
      sx: T,
      theme: this
    });
  }, b.toRuntimeSource = $v, b;
}
function yh(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = L(C({}, n !== !0 && n), {
    palette: Dd(L(C({}, n === !0 ? {} : n.palette), {
      mode: t
    }))
    // cast type to skip module augmentation test
  }));
}
function cr(e = {}, ...t) {
  const d = e, {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: o = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n == null ? void 0 : n.mode
  } = d, s = re(d, [
    "palette",
    "cssVariables",
    "colorSchemes",
    "defaultColorScheme"
  ]), a = i || "light", u = o == null ? void 0 : o[a], l = C(C({}, o), n ? {
    [a]: L(C({}, typeof u != "boolean" && u), {
      palette: n
    })
  } : void 0);
  if (r === !1) {
    if (!("colorSchemes" in e))
      return Du(e, ...t);
    let p = n;
    "palette" in e || l[a] && (l[a] !== !0 ? p = l[a].palette : a === "dark" && (p = {
      mode: "dark"
    }));
    const f = Du(L(C({}, e), {
      palette: p
    }), ...t);
    return f.defaultColorScheme = a, f.colorSchemes = l, f.palette.mode === "light" && (f.colorSchemes.light = L(C({}, l.light !== !0 && l.light), {
      palette: f.palette
    }), yh(f, "dark", l.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = L(C({}, l.dark !== !0 && l.dark), {
      palette: f.palette
    }), yh(f, "light", l.light)), f;
  }
  return !n && !("light" in l) && a === "light" && (l.light = !0), gO(C(L(C({}, s), {
    colorSchemes: l,
    defaultColorScheme: a
  }), typeof r != "boolean" && r), ...t);
}
const gs = {
  attribute: "data-mui-color-scheme",
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: yO,
  useColorScheme: fF,
  getInitColorSchemeScript: hF
} = _R({
  themeId: Dn,
  // @ts-ignore ignore module augmentation tests
  theme: () => cr({
    cssVariables: !0
  }),
  colorSchemeStorageKey: gs.colorSchemeStorageKey,
  modeStorageKey: gs.modeStorageKey,
  defaultColorScheme: {
    light: gs.defaultLightColorScheme,
    dark: gs.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = L(C({}, e), {
      typography: Av(e.palette, e.typography)
    });
    return t.unstable_sx = function(r) {
      return mo({
        sx: r,
        theme: this
      });
    }, t;
  }
}), vO = yO;
function Oo(n) {
  var r = n, {
    theme: e
  } = r, t = re(r, [
    "theme"
  ]);
  const o = E.useMemo(() => {
    if (typeof e == "function")
      return e;
    const i = Dn in e ? e[Dn] : e;
    return "colorSchemes" in i ? null : "vars" in i ? e : L(C({}, e), {
      vars: null
    });
  }, [e]);
  return o ? /* @__PURE__ */ O(PR, C({
    theme: o
  }, t)) : /* @__PURE__ */ O(vO, C({
    theme: e
  }, t));
}
const bO = cr(), Bd = bO;
function Za() {
  const e = iv(Bd);
  return process.env.NODE_ENV !== "production" && E.useDebugValue(e), e[Dn] || e;
}
function Bv(e) {
  return /* @__PURE__ */ O(sv, L(C({}, e), {
    defaultTheme: Bd,
    themeId: Dn
  }));
}
process.env.NODE_ENV !== "production" && (Bv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: c.oneOfType([c.array, c.func, c.number, c.object, c.string, c.bool])
});
function Fv(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const CO = (e) => Fv(e) && e !== "classes", tn = CO, SO = HE({
  themeId: Dn,
  defaultTheme: Bd,
  rootShouldForwardProp: tn
}), ue = SO;
function wO(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ O(Bv, {
        styles: typeof e == "function" ? (r) => e(C({
          theme: r
        }, n)) : e
      })
    );
  };
}
function _O() {
  return kE;
}
const xO = hR, $e = xO;
function tt(e) {
  return fR(e);
}
function ys(e) {
  return parseInt(e, 10) || 0;
}
const TO = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function EO(e) {
  for (const t in e)
    return !1;
  return !0;
}
function vh(e) {
  return EO(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const zv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const R = t, {
    onChange: r,
    maxRows: o,
    minRows: i = 1,
    style: s,
    value: a
  } = R, u = re(R, [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
  ]), {
    current: l
  } = E.useRef(a != null), d = E.useRef(null), p = yt(n, d), f = E.useRef(null), h = E.useRef(null), g = E.useCallback(() => {
    const b = d.current, y = h.current;
    if (!b || !y)
      return;
    const x = jn(b).getComputedStyle(b);
    if (x.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    y.style.width = x.width, y.value = b.value || t.placeholder || "x", y.value.slice(-1) === `
` && (y.value += " ");
    const P = x.boxSizing, N = ys(x.paddingBottom) + ys(x.paddingTop), M = ys(x.borderBottomWidth) + ys(x.borderTopWidth), A = y.scrollHeight;
    y.value = "x";
    const T = y.scrollHeight;
    let D = A;
    i && (D = Math.max(Number(i) * T, D)), o && (D = Math.min(Number(o) * T, D)), D = Math.max(D, T);
    const j = D + (P === "border-box" ? N + M : 0), F = Math.abs(D - A) <= 1;
    return {
      outerHeightStyle: j,
      overflowing: F
    };
  }, [o, i, t.placeholder]), m = Ln(() => {
    const b = d.current, y = g();
    if (!b || !y || vh(y))
      return !1;
    const w = y.outerHeightStyle;
    return f.current != null && f.current !== w;
  }), v = E.useCallback(() => {
    const b = d.current, y = g();
    if (!b || !y || vh(y))
      return;
    const w = y.outerHeightStyle;
    f.current !== w && (f.current = w, b.style.height = `${w}px`), b.style.overflow = y.overflowing ? "hidden" : "";
  }, [g]), S = E.useRef(-1);
  ln(() => {
    const b = mv(v), y = d == null ? void 0 : d.current;
    if (!y)
      return;
    const w = jn(y);
    w.addEventListener("resize", b);
    let x;
    return typeof ResizeObserver != "undefined" && (x = new ResizeObserver(() => {
      m() && (x.unobserve(y), cancelAnimationFrame(S.current), v(), S.current = requestAnimationFrame(() => {
        x.observe(y);
      }));
    }), x.observe(y)), () => {
      b.clear(), cancelAnimationFrame(S.current), w.removeEventListener("resize", b), x && x.disconnect();
    };
  }, [g, v, m]), ln(() => {
    v();
  });
  const _ = (b) => {
    l || v(), r && r(b);
  };
  return /* @__PURE__ */ fe(E.Fragment, {
    children: [/* @__PURE__ */ O("textarea", C({
      value: a,
      onChange: _,
      ref: p,
      rows: i,
      style: s
    }, u)), /* @__PURE__ */ O("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: h,
      tabIndex: -1,
      style: L(C(C({}, TO.shadow), s), {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (zv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: c.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  onChange: c.func,
  /**
   * @ignore
   */
  placeholder: c.string,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * @ignore
   */
  value: c.oneOfType([c.arrayOf(c.string), c.number, c.string])
});
const RO = zv;
function Fu(e) {
  return typeof e == "string";
}
function Fd({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, o) => (r[o] = e[o], n && typeof e[o] == "undefined" && (r[o] = n[o]), r), {});
}
const jv = /* @__PURE__ */ E.createContext(void 0);
process.env.NODE_ENV !== "production" && (jv.displayName = "FormControlContext");
const Hv = jv;
function el() {
  return E.useContext(Hv);
}
function bh(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function Wv(e, t = !1) {
  return e && (bh(e.value) && e.value !== "" || t && bh(e.defaultValue) && e.defaultValue !== "");
}
function OO(e) {
  return Ve("MuiInputBase", e);
}
const PO = Le("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), go = PO;
var Ch;
const tl = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${ve(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, nl = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, IO = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: o,
    endAdornment: i,
    focused: s,
    formControl: a,
    fullWidth: u,
    hiddenLabel: l,
    multiline: d,
    readOnly: p,
    size: f,
    startAdornment: h,
    type: g
  } = e, m = {
    root: ["root", `color${ve(n)}`, r && "disabled", o && "error", u && "fullWidth", s && "focused", a && "formControl", f && f !== "medium" && `size${ve(f)}`, d && "multiline", h && "adornedStart", i && "adornedEnd", l && "hiddenLabel", p && "readOnly"],
    input: ["input", r && "disabled", g === "search" && "inputTypeSearch", d && "inputMultiline", f === "small" && "inputSizeSmall", l && "inputHiddenLabel", h && "inputAdornedStart", i && "inputAdornedEnd", p && "readOnly"]
  };
  return Ye(m, OO, t);
}, rl = ue("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: tl
})($e(({
  theme: e
}) => L(C({}, e.typography.body1), {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${go.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), ol = ue("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: nl
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = L(C({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  }), {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), r = {
    opacity: "0 !important"
  }, o = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${go.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": o,
      "&:focus::-moz-placeholder": o,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": o
      // Edge
    },
    [`&.${go.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), Sh = wO({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), Vv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var je;
  const r = tt({
    props: t,
    name: "MuiInputBase"
  }), Ae = r, {
    "aria-describedby": o,
    autoComplete: i,
    autoFocus: s,
    className: a,
    color: u,
    components: l = {},
    componentsProps: d = {},
    defaultValue: p,
    disabled: f,
    disableInjectingGlobalStyles: h,
    endAdornment: g,
    error: m,
    fullWidth: v = !1,
    id: S,
    inputComponent: _ = "input",
    inputProps: R = {},
    inputRef: b,
    margin: y,
    maxRows: w,
    minRows: x,
    multiline: P = !1,
    name: N,
    onBlur: M,
    onChange: A,
    onClick: T,
    onFocus: D,
    onKeyDown: j,
    onKeyUp: F,
    placeholder: z,
    readOnly: H,
    renderSuffix: ee,
    rows: X,
    size: k,
    slotProps: $ = {},
    slots: Y = {},
    startAdornment: K,
    type: W = "text",
    value: Q
  } = Ae, G = re(Ae, [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
  ]), V = R.value != null ? R.value : Q, {
    current: U
  } = E.useRef(V != null), Z = E.useRef(), te = E.useCallback((ce) => {
    process.env.NODE_ENV !== "production" && ce && ce.nodeName !== "INPUT" && !ce.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ie = yt(Z, b, R.ref, te), [B, oe] = E.useState(!1), q = el();
  process.env.NODE_ENV !== "production" && E.useEffect(() => {
    if (q)
      return q.registerEffect();
  }, [q]);
  const pe = Fd({
    props: r,
    muiFormControl: q,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  pe.focused = q ? q.focused : B, E.useEffect(() => {
    !q && f && B && (oe(!1), M && M());
  }, [q, f, B, M]);
  const ge = q && q.onFilled, Ee = q && q.onEmpty, be = E.useCallback((ce) => {
    Wv(ce) ? ge && ge() : Ee && Ee();
  }, [ge, Ee]);
  ln(() => {
    U && be({
      value: V
    });
  }, [V, be, U]);
  const ye = (ce) => {
    D && D(ce), R.onFocus && R.onFocus(ce), q && q.onFocus ? q.onFocus(ce) : oe(!0);
  }, Re = (ce) => {
    M && M(ce), R.onBlur && R.onBlur(ce), q && q.onBlur ? q.onBlur(ce) : oe(!1);
  }, Me = (ce, ...Pe) => {
    if (!U) {
      const $t = ce.target || Z.current;
      if ($t == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : _n(1));
      be({
        value: $t.value
      });
    }
    R.onChange && R.onChange(ce, ...Pe), A && A(ce, ...Pe);
  };
  E.useEffect(() => {
    be(Z.current);
  }, []);
  const Ie = (ce) => {
    Z.current && ce.currentTarget === ce.target && Z.current.focus(), T && T(ce);
  };
  let ae = _, Se = R;
  P && ae === "input" && (X ? (process.env.NODE_ENV !== "production" && (x || w) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Se = C({
    type: void 0,
    minRows: X,
    maxRows: X
  }, Se)) : Se = C({
    type: void 0,
    maxRows: w,
    minRows: x
  }, Se), ae = RO);
  const mt = (ce) => {
    be(ce.animationName === "mui-auto-fill-cancel" ? Z.current : {
      value: "x"
    });
  };
  E.useEffect(() => {
    q && q.setAdornedStart(!!K);
  }, [q, K]);
  const ke = L(C({}, r), {
    color: pe.color || "primary",
    disabled: pe.disabled,
    endAdornment: g,
    error: pe.error,
    focused: pe.focused,
    formControl: q,
    fullWidth: v,
    hiddenLabel: pe.hiddenLabel,
    multiline: P,
    size: pe.size,
    startAdornment: K,
    type: W
  }), Qe = IO(ke), we = Y.root || l.Root || rl, Ne = $.root || d.root || {}, Ue = Y.input || l.Input || ol;
  return Se = C(C({}, Se), (je = $.input) != null ? je : d.input), /* @__PURE__ */ fe(E.Fragment, {
    children: [!h && typeof Sh == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (Ch || (Ch = /* @__PURE__ */ O(Sh, {}))), /* @__PURE__ */ fe(we, L(C(C(L(C({}, Ne), {
      ref: n,
      onClick: Ie
    }), G), !Fu(we) && {
      ownerState: C(C({}, ke), Ne.ownerState)
    }), {
      className: xe(Qe.root, Ne.className, a, H && "MuiInputBase-readOnly"),
      children: [K, /* @__PURE__ */ O(Hv.Provider, {
        value: null,
        children: /* @__PURE__ */ O(Ue, L(C(C({
          "aria-invalid": pe.error,
          "aria-describedby": o,
          autoComplete: i,
          autoFocus: s,
          defaultValue: p,
          disabled: pe.disabled,
          id: S,
          onAnimationStart: mt,
          name: N,
          placeholder: z,
          readOnly: H,
          required: pe.required,
          rows: X,
          value: V,
          onKeyDown: j,
          onKeyUp: F,
          type: W
        }, Se), !Fu(Ue) && {
          as: ae,
          ownerState: C(C({}, ke), Se.ownerState)
        }), {
          ref: ie,
          className: xe(Qe.input, Se.className, H && "MuiInputBase-readOnly"),
          onBlur: Re,
          onChange: Me,
          onFocus: ye
        }))
      }), g, ee ? ee(L(C({}, pe), {
        startAdornment: K
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Vv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": c.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: kd,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: un,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: c.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * @ignore
   */
  renderSuffix: c.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The size of the component.
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
const il = Vv, Uv = /* @__PURE__ */ E.createContext({});
process.env.NODE_ENV !== "production" && (Uv.displayName = "ListContext");
const zu = Uv;
class ga {
  constructor() {
    I(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new ga();
  }
  static use() {
    const t = gv(ga.create).current, [n, r] = E.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, E.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = MO(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function NO() {
  return ga.use();
}
function MO() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function ju() {
  return ju = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ju.apply(this, arguments);
}
function qv(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      n[r] = e[r];
    }
  return n;
}
function Hu(e, t) {
  return Hu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Hu(e, t);
}
function Gv(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Hu(e, t);
}
const wh = {
  disabled: !1
};
var kO = process.env.NODE_ENV !== "production" ? c.oneOfType([c.number, c.shape({
  enter: c.number,
  exit: c.number,
  appear: c.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && c.oneOfType([c.string, c.shape({
  enter: c.string,
  exit: c.string,
  active: c.string
}), c.shape({
  enter: c.string,
  enterDone: c.string,
  enterActive: c.string,
  exit: c.string,
  exitDone: c.string,
  exitActive: c.string
})]);
const ya = Ht.createContext(null);
var ui = "unmounted", yr = "exited", vr = "entering", eo = "entered", Wu = "exiting", Un = /* @__PURE__ */ function(e) {
  Gv(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var s = o, a = s && !s.isMounting ? r.enter : r.appear, u;
    return i.appearStatus = null, r.in ? a ? (u = yr, i.appearStatus = vr) : u = eo : r.unmountOnExit || r.mountOnEnter ? u = ui : u = yr, i.state = {
      status: u
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(o, i) {
    var s = o.in;
    return s && i.status === ui ? {
      status: yr
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(o) {
    var i = null;
    if (o !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== vr && s !== eo && (i = vr) : (s === vr || s === eo) && (i = Wu);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var o = this.props.timeout, i, s, a;
    return i = s = a = o, o != null && typeof o != "number" && (i = o.exit, s = o.enter, a = o.appear !== void 0 ? o.appear : s), {
      exit: i,
      enter: s,
      appear: a
    };
  }, n.updateStatus = function(o, i) {
    o === void 0 && (o = !1), i !== null ? (this.cancelNextCallback(), i === vr ? ((this.props.unmountOnExit || this.props.mountOnEnter) && (this.props.nodeRef ? this.props.nodeRef.current : ri.findDOMNode(this)), this.performEnter(o)) : this.performExit()) : this.props.unmountOnExit && this.state.status === yr && this.setState({
      status: ui
    });
  }, n.performEnter = function(o) {
    var i = this, s = this.props.enter, a = this.context ? this.context.isMounting : o, u = this.props.nodeRef ? [a] : [ri.findDOMNode(this), a], l = u[0], d = u[1], p = this.getTimeouts(), f = a ? p.appear : p.enter;
    if (!o && !s || wh.disabled) {
      this.safeSetState({
        status: eo
      }, function() {
        i.props.onEntered(l);
      });
      return;
    }
    this.props.onEnter(l, d), this.safeSetState({
      status: vr
    }, function() {
      i.props.onEntering(l, d), i.onTransitionEnd(f, function() {
        i.safeSetState({
          status: eo
        }, function() {
          i.props.onEntered(l, d);
        });
      });
    });
  }, n.performExit = function() {
    var o = this, i = this.props.exit, s = this.getTimeouts(), a = this.props.nodeRef ? void 0 : ri.findDOMNode(this);
    if (!i || wh.disabled) {
      this.safeSetState({
        status: yr
      }, function() {
        o.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: Wu
    }, function() {
      o.props.onExiting(a), o.onTransitionEnd(s.exit, function() {
        o.safeSetState({
          status: yr
        }, function() {
          o.props.onExited(a);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(o, i) {
    i = this.setNextCallback(i), this.setState(o, i);
  }, n.setNextCallback = function(o) {
    var i = this, s = !0;
    return this.nextCallback = function(a) {
      s && (s = !1, i.nextCallback = null, o(a));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(o, i) {
    this.setNextCallback(i);
    var s = this.props.nodeRef ? this.props.nodeRef.current : ri.findDOMNode(this), a = o == null && !this.props.addEndListener;
    if (!s || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], l = u[0], d = u[1];
      this.props.addEndListener(l, d);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, n.render = function() {
    var o = this.state.status;
    if (o === ui)
      return null;
    var i = this.props, s = i.children, a = qv(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ Ht.createElement(ya.Provider, {
        value: null
      }, typeof s == "function" ? s(o, a) : Ht.cloneElement(Ht.Children.only(s), a))
    );
  }, t;
}(Ht.Component);
Un.contextType = ya;
Un.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: c.shape({
    current: typeof Element == "undefined" ? c.any : function(e, t, n, r, o, i) {
      var s = e[t];
      return c.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: c.oneOfType([c.func.isRequired, c.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: c.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: c.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: c.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: c.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: c.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: c.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = kO;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      o[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: c.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: c.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: c.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: c.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: c.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: c.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: c.func
} : {};
function Yr() {
}
Un.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Yr,
  onEntering: Yr,
  onEntered: Yr,
  onExit: Yr,
  onExiting: Yr,
  onExited: Yr
};
Un.UNMOUNTED = ui;
Un.EXITED = yr;
Un.ENTERING = vr;
Un.ENTERED = eo;
Un.EXITING = Wu;
const Kv = Un;
function AO(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zd(e, t) {
  var n = function(i) {
    return t && fi(i) ? t(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && gC.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function $O(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (r[i] = o, o = []) : o.push(i);
  var s, a = {};
  for (var u in t) {
    if (r[u])
      for (s = 0; s < r[u].length; s++) {
        var l = r[u][s];
        a[r[u][s]] = n(l);
      }
    a[u] = n(u);
  }
  for (s = 0; s < o.length; s++)
    a[o[s]] = n(o[s]);
  return a;
}
function Cr(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function LO(e, t) {
  return zd(e.children, function(n) {
    return qs(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Cr(n, "appear", e),
      enter: Cr(n, "enter", e),
      exit: Cr(n, "exit", e)
    });
  });
}
function DO(e, t, n) {
  var r = zd(e.children), o = $O(t, r);
  return Object.keys(o).forEach(function(i) {
    var s = o[i];
    if (fi(s)) {
      var a = i in t, u = i in r, l = t[i], d = fi(l) && !l.props.in;
      u && (!a || d) ? o[i] = qs(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: Cr(s, "exit", e),
        enter: Cr(s, "enter", e)
      }) : !u && a && !d ? o[i] = qs(s, {
        in: !1
      }) : u && a && fi(l) && (o[i] = qs(s, {
        onExited: n.bind(null, s),
        in: l.props.in,
        exit: Cr(s, "exit", e),
        enter: Cr(s, "enter", e)
      }));
    }
  }), o;
}
var BO = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, FO = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, jd = /* @__PURE__ */ function(e) {
  Gv(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var s = i.handleExited.bind(AO(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var s = i.children, a = i.handleExited, u = i.firstRender;
    return {
      children: u ? LO(o, a) : DO(o, s, a),
      firstRender: !1
    };
  }, n.handleExited = function(o, i) {
    var s = zd(this.props.children);
    o.key in s || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(a) {
      var u = ju({}, a.children);
      return delete u[o.key], {
        children: u
      };
    }));
  }, n.render = function() {
    var o = this.props, i = o.component, s = o.childFactory, a = qv(o, ["component", "childFactory"]), u = this.state.contextValue, l = BO(this.state.children).map(s);
    return delete a.appear, delete a.enter, delete a.exit, i === null ? /* @__PURE__ */ Ht.createElement(ya.Provider, {
      value: u
    }, l) : /* @__PURE__ */ Ht.createElement(ya.Provider, {
      value: u
    }, /* @__PURE__ */ Ht.createElement(i, a, l));
  }, t;
}(Ht.Component);
jd.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: c.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: c.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: c.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: c.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: c.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: c.func
} : {};
jd.defaultProps = FO;
const zO = jd;
function Yv(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: s,
    in: a,
    onExited: u,
    timeout: l
  } = e, [d, p] = E.useState(!1), f = xe(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), h = {
    width: s,
    height: s,
    top: -(s / 2) + i,
    left: -(s / 2) + o
  }, g = xe(n.child, d && n.childLeaving, r && n.childPulsate);
  return !a && !d && p(!0), E.useEffect(() => {
    if (!a && u != null) {
      const m = setTimeout(u, l);
      return () => {
        clearTimeout(m);
      };
    }
  }, [u, a, l]), /* @__PURE__ */ O("span", {
    className: f,
    style: h,
    children: /* @__PURE__ */ O("span", {
      className: g
    })
  });
}
process.env.NODE_ENV !== "production" && (Yv.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object.isRequired,
  className: c.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: c.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: c.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: c.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: c.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: c.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: c.number,
  /**
   * exit delay
   */
  timeout: c.number.isRequired
});
const jO = Le("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Yt = jO, Vu = 550, HO = 80, WO = Fi`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, VO = Fi`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, UO = Fi`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, qO = ue("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), GO = ue(Yv, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${Yt.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${WO};
    animation-duration: ${Vu}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${Yt.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${Yt.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${Yt.childLeaving} {
    opacity: 0;
    animation-name: ${VO};
    animation-duration: ${Vu}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${Yt.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${UO};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, Xv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const b = tt({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: s
  } = b, a = re(b, [
    "center",
    "classes",
    "className"
  ]), [u, l] = E.useState([]), d = E.useRef(0), p = E.useRef(null);
  E.useEffect(() => {
    p.current && (p.current(), p.current = null);
  }, [u]);
  const f = E.useRef(!1), h = oo(), g = E.useRef(null), m = E.useRef(null), v = E.useCallback((y) => {
    const {
      pulsate: w,
      rippleX: x,
      rippleY: P,
      rippleSize: N,
      cb: M
    } = y;
    l((A) => [...A, /* @__PURE__ */ O(GO, {
      classes: {
        ripple: xe(i.ripple, Yt.ripple),
        rippleVisible: xe(i.rippleVisible, Yt.rippleVisible),
        ripplePulsate: xe(i.ripplePulsate, Yt.ripplePulsate),
        child: xe(i.child, Yt.child),
        childLeaving: xe(i.childLeaving, Yt.childLeaving),
        childPulsate: xe(i.childPulsate, Yt.childPulsate)
      },
      timeout: Vu,
      pulsate: w,
      rippleX: x,
      rippleY: P,
      rippleSize: N
    }, d.current)]), d.current += 1, p.current = M;
  }, [i]), S = E.useCallback((y = {}, w = {}, x = () => {
  }) => {
    const {
      pulsate: P = !1,
      center: N = o || w.pulsate,
      fakeElement: M = !1
      // For test purposes
    } = w;
    if ((y == null ? void 0 : y.type) === "mousedown" && f.current) {
      f.current = !1;
      return;
    }
    (y == null ? void 0 : y.type) === "touchstart" && (f.current = !0);
    const A = M ? null : m.current, T = A ? A.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let D, j, F;
    if (N || y === void 0 || y.clientX === 0 && y.clientY === 0 || !y.clientX && !y.touches)
      D = Math.round(T.width / 2), j = Math.round(T.height / 2);
    else {
      const {
        clientX: z,
        clientY: H
      } = y.touches && y.touches.length > 0 ? y.touches[0] : y;
      D = Math.round(z - T.left), j = Math.round(H - T.top);
    }
    if (N)
      F = Math.sqrt((2 * Nn(T.width, 2) + Nn(T.height, 2)) / 3), F % 2 === 0 && (F += 1);
    else {
      const z = Math.max(Math.abs((A ? A.clientWidth : 0) - D), D) * 2 + 2, H = Math.max(Math.abs((A ? A.clientHeight : 0) - j), j) * 2 + 2;
      F = Math.sqrt(Nn(z, 2) + Nn(H, 2));
    }
    y != null && y.touches ? g.current === null && (g.current = () => {
      v({
        pulsate: P,
        rippleX: D,
        rippleY: j,
        rippleSize: F,
        cb: x
      });
    }, h.start(HO, () => {
      g.current && (g.current(), g.current = null);
    })) : v({
      pulsate: P,
      rippleX: D,
      rippleY: j,
      rippleSize: F,
      cb: x
    });
  }, [o, v, h]), _ = E.useCallback(() => {
    S({}, {
      pulsate: !0
    });
  }, [S]), R = E.useCallback((y, w) => {
    if (h.clear(), (y == null ? void 0 : y.type) === "touchend" && g.current) {
      g.current(), g.current = null, h.start(0, () => {
        R(y, w);
      });
      return;
    }
    g.current = null, l((x) => x.length > 0 ? x.slice(1) : x), p.current = w;
  }, [h]);
  return E.useImperativeHandle(n, () => ({
    pulsate: _,
    start: S,
    stop: R
  }), [_, S, R]), /* @__PURE__ */ O(qO, L(C({
    className: xe(Yt.root, i.root, s),
    ref: m
  }, a), {
    children: /* @__PURE__ */ O(zO, {
      component: null,
      exit: !0,
      children: u
    })
  }));
});
process.env.NODE_ENV !== "production" && (Xv.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string
});
const KO = Xv;
function YO(e) {
  return Ve("MuiButtonBase", e);
}
const XO = Le("MuiButtonBase", ["root", "disabled", "focusVisible"]), JO = XO, QO = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: o
  } = e, s = Ye({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, YO, o);
  return n && r && (s.root += ` ${r}`), s;
}, ZO = ue("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${JO.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Jv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiButtonBase"
  }), Ie = r, {
    action: o,
    centerRipple: i = !1,
    children: s,
    className: a,
    component: u = "button",
    disabled: l = !1,
    disableRipple: d = !1,
    disableTouchRipple: p = !1,
    focusRipple: f = !1,
    focusVisibleClassName: h,
    LinkComponent: g = "a",
    onBlur: m,
    onClick: v,
    onContextMenu: S,
    onDragLeave: _,
    onFocus: R,
    onFocusVisible: b,
    onKeyDown: y,
    onKeyUp: w,
    onMouseDown: x,
    onMouseLeave: P,
    onMouseUp: N,
    onTouchEnd: M,
    onTouchMove: A,
    onTouchStart: T,
    tabIndex: D = 0,
    TouchRippleProps: j,
    touchRippleRef: F,
    type: z
  } = Ie, H = re(Ie, [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
  ]), ee = E.useRef(null), X = NO(), k = yt(X.ref, F), [$, Y] = E.useState(!1);
  l && $ && Y(!1), E.useImperativeHandle(o, () => ({
    focusVisible: () => {
      Y(!0), ee.current.focus();
    }
  }), []);
  const K = X.shouldMount && !d && !l;
  E.useEffect(() => {
    $ && f && !d && X.pulsate();
  }, [d, f, $, X]);
  const W = kn(X, "start", x, p), Q = kn(X, "stop", S, p), G = kn(X, "stop", _, p), V = kn(X, "stop", N, p), U = kn(X, "stop", (ae) => {
    $ && ae.preventDefault(), P && P(ae);
  }, p), Z = kn(X, "start", T, p), te = kn(X, "stop", M, p), ie = kn(X, "stop", A, p), B = kn(X, "stop", (ae) => {
    ha(ae.target) || Y(!1), m && m(ae);
  }, !1), oe = Ln((ae) => {
    ee.current || (ee.current = ae.currentTarget), ha(ae.target) && (Y(!0), b && b(ae)), R && R(ae);
  }), q = () => {
    const ae = ee.current;
    return u && u !== "button" && !(ae.tagName === "A" && ae.href);
  }, pe = Ln((ae) => {
    f && !ae.repeat && $ && ae.key === " " && X.stop(ae, () => {
      X.start(ae);
    }), ae.target === ae.currentTarget && q() && ae.key === " " && ae.preventDefault(), y && y(ae), ae.target === ae.currentTarget && q() && ae.key === "Enter" && !l && (ae.preventDefault(), v && v(ae));
  }), ge = Ln((ae) => {
    f && ae.key === " " && $ && !ae.defaultPrevented && X.stop(ae, () => {
      X.pulsate(ae);
    }), w && w(ae), v && ae.target === ae.currentTarget && q() && ae.key === " " && !ae.defaultPrevented && v(ae);
  });
  let Ee = u;
  Ee === "button" && (H.href || H.to) && (Ee = g);
  const be = {};
  Ee === "button" ? (be.type = z === void 0 ? "button" : z, be.disabled = l) : (!H.href && !H.to && (be.role = "button"), l && (be["aria-disabled"] = l));
  const ye = yt(n, ee), Re = L(C({}, r), {
    centerRipple: i,
    component: u,
    disabled: l,
    disableRipple: d,
    disableTouchRipple: p,
    focusRipple: f,
    tabIndex: D,
    focusVisible: $
  }), Me = QO(Re);
  return /* @__PURE__ */ fe(ZO, L(C(C({
    as: Ee,
    className: xe(Me.root, a),
    ownerState: Re,
    onBlur: B,
    onClick: v,
    onContextMenu: Q,
    onFocus: oe,
    onKeyDown: pe,
    onKeyUp: ge,
    onMouseDown: W,
    onMouseLeave: U,
    onMouseUp: V,
    onDragLeave: G,
    onTouchEnd: te,
    onTouchMove: ie,
    onTouchStart: Z,
    ref: ye,
    tabIndex: l ? -1 : D,
    type: z
  }, be), H), {
    children: [s, K ? /* @__PURE__ */ O(KO, C({
      ref: k,
      center: i
    }, j)) : null]
  }));
});
function kn(e, t, n, r = !1) {
  return Ln((o) => (n && n(o), r || e[t](o), !0));
}
process.env.NODE_ENV !== "production" && (Jv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: un,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: kd,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: c.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: c.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  href: c.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: c.elementType,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onContextMenu: c.func,
  /**
   * @ignore
   */
  onDragLeave: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * @ignore
   */
  onMouseDown: c.func,
  /**
   * @ignore
   */
  onMouseLeave: c.func,
  /**
   * @ignore
   */
  onMouseUp: c.func,
  /**
   * @ignore
   */
  onTouchEnd: c.func,
  /**
   * @ignore
   */
  onTouchMove: c.func,
  /**
   * @ignore
   */
  onTouchStart: c.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @default 0
   */
  tabIndex: c.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: c.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: c.oneOfType([c.func, c.shape({
    current: c.shape({
      pulsate: c.func.isRequired,
      start: c.func.isRequired,
      stop: c.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: c.oneOfType([c.oneOf(["button", "reset", "submit"]), c.string])
});
const sl = Jv, eP = Le("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), _h = eP, tP = Le("MuiListItemIcon", ["root", "alignItemsFlexStart"]), xh = tP;
function nP(e) {
  return typeof e.main == "string";
}
function rP(e, t = []) {
  if (!nP(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function cn(e = []) {
  return ([, t]) => t && rP(t, e);
}
function oP(e) {
  return Ve("MuiTypography", e);
}
Le("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const iP = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, sP = _O(), aP = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: o,
    variant: i,
    classes: s
  } = e, a = {
    root: ["root", i, e.align !== "inherit" && `align${ve(t)}`, n && "gutterBottom", r && "noWrap", o && "paragraph"]
  };
  return Ye(a, oP, s);
}, lP = ue("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${ve(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})($e(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, r]) => n !== "inherit" && r && typeof r == "object").map(([n, r]) => ({
      props: {
        variant: n
      },
      style: r
    })), ...Object.entries(e.palette).filter(cn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${ve(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), Th = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Qv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const R = tt({
    props: t,
    name: "MuiTypography"
  }), {
    color: r
  } = R, o = re(R, [
    "color"
  ]), i = !iP[r], s = sP(C(C({}, o), i && {
    color: r
  })), b = s, {
    align: a = "inherit",
    className: u,
    component: l,
    gutterBottom: d = !1,
    noWrap: p = !1,
    paragraph: f = !1,
    variant: h = "body1",
    variantMapping: g = Th
  } = b, m = re(b, [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
  ]), v = L(C({}, s), {
    align: a,
    color: r,
    className: u,
    component: l,
    gutterBottom: d,
    noWrap: p,
    paragraph: f,
    variant: h,
    variantMapping: g
  }), S = l || (f ? "p" : g[h] || Th[h]) || "span", _ = aP(v);
  return /* @__PURE__ */ O(lP, L(C({
    as: S,
    ref: n,
    className: xe(_.root, u)
  }, m), {
    ownerState: v,
    style: C(C({}, a !== "inherit" && {
      "--Typography-textAlign": a
    }), m.style)
  }));
});
process.env.NODE_ENV !== "production" && (Qv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: c.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: c.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: c.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: c.bool,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: c.oneOfType([c.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), c.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: c.object
});
const cP = Qv, uP = Le("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), Eh = uP;
function Ke(e, t) {
  const y = t, {
    className: n,
    elementType: r,
    ownerState: o,
    externalForwardedProps: i,
    internalForwardedProps: s,
    shouldForwardComponentProp: a = !1
  } = y, u = re(y, [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "internalForwardedProps",
    "shouldForwardComponentProp"
  ]), w = i, {
    component: l,
    slots: d = {
      [e]: void 0
    },
    slotProps: p = {
      [e]: void 0
    }
  } = w, f = re(w, [
    "component",
    "slots",
    "slotProps"
  ]), h = d[e] || r, g = _v(p[e], o), x = wv(L(C({
    className: n
  }, u), {
    externalForwardedProps: e === "root" ? f : void 0,
    externalSlotProps: g
  })), {
    props: P
  } = x, N = P, {
    component: m
  } = N, v = re(N, [
    "component"
  ]), {
    internalRef: S
  } = x, _ = yt(S, g == null ? void 0 : g.ref, t.ref), R = e === "root" ? m || l : m, b = Cv(h, L(C(C(C(C(C({}, e === "root" && !l && !d[e] && s), e !== "root" && !d[e] && s), v), R && !a && {
    as: R
  }), R && a && {
    component: R
  }), {
    ref: _
  }), o);
  return [h, b];
}
function dP(e) {
  return Ve("MuiMenuItem", e);
}
const pP = Le("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), qo = pP, fP = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, hP = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: o,
    selected: i,
    classes: s
  } = e, u = Ye({
    root: ["root", n && "dense", t && "disabled", !o && "gutters", r && "divider", i && "selected"]
  }, dP, s);
  return C(C({}, s), u);
}, mP = ue(sl, {
  shouldForwardProp: (e) => tn(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: fP
})($e(({
  theme: e
}) => L(C({}, e.typography.body1), {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${qo.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${qo.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${qo.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : dt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${qo.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${qo.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${_h.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${_h.inset}`]: {
    marginLeft: 52
  },
  [`& .${Eh.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Eh.inset}`]: {
    paddingLeft: 36
  },
  [`& .${xh.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: L(C({
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4
    }, e.typography.body2), {
      [`& .${xh.root} svg`]: {
        fontSize: "1.25rem"
      }
    })
  }]
}))), Zv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiMenuItem"
  }), y = r, {
    autoFocus: o = !1,
    component: i = "li",
    dense: s = !1,
    divider: a = !1,
    disableGutters: u = !1,
    focusVisibleClassName: l,
    role: d = "menuitem",
    tabIndex: p,
    className: f
  } = y, h = re(y, [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
  ]), g = E.useContext(zu), m = E.useMemo(() => ({
    dense: s || g.dense || !1,
    disableGutters: u
  }), [g.dense, s, u]), v = E.useRef(null);
  ln(() => {
    o && (v.current ? v.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const S = L(C({}, r), {
    dense: m.dense,
    divider: a,
    disableGutters: u
  }), _ = hP(r), R = yt(v, n);
  let b;
  return r.disabled || (b = p !== void 0 ? p : -1), /* @__PURE__ */ O(zu.Provider, {
    value: m,
    children: /* @__PURE__ */ O(mP, L(C({
      ref: R,
      role: d,
      tabIndex: b,
      component: i,
      focusVisibleClassName: xe(_.focusVisible, l),
      className: xe(_.root, f)
    }, h), {
      ownerState: S,
      classes: _
    }))
  });
});
process.env.NODE_ENV !== "production" && (Zv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: c.bool,
  /**
   * @ignore
   */
  disabled: c.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: c.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  role: c.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @default 0
   */
  tabIndex: c.number
});
const gP = Zv;
function yP(e) {
  return Ve("MuiList", e);
}
Le("MuiList", ["root", "padding", "dense", "subheader"]);
const vP = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: o
  } = e;
  return Ye({
    root: ["root", !n && "padding", r && "dense", o && "subheader"]
  }, yP, t);
}, bP = ue("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), eb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiList"
  }), g = r, {
    children: o,
    className: i,
    component: s = "ul",
    dense: a = !1,
    disablePadding: u = !1,
    subheader: l
  } = g, d = re(g, [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
  ]), p = E.useMemo(() => ({
    dense: a
  }), [a]), f = L(C({}, r), {
    component: s,
    dense: a,
    disablePadding: u
  }), h = vP(f);
  return /* @__PURE__ */ O(zu.Provider, {
    value: p,
    children: /* @__PURE__ */ fe(bP, L(C({
      as: s,
      className: xe(h.root, i),
      ref: n,
      ownerState: f
    }, d), {
      children: [l, o]
    }))
  });
});
process.env.NODE_ENV !== "production" && (eb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: c.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: c.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const CP = eb;
function SP(e) {
  return Ve("MuiSvgIcon", e);
}
Le("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const wP = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${ve(t)}`, `fontSize${ve(n)}`]
  };
  return Ye(o, SP, r);
}, _P = ue("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${ve(n.color)}`], t[`fontSize${ve(n.fontSize)}`]];
  }
})($e(({
  theme: e
}) => {
  var t, n, r, o, i, s, a, u, l, d, p, f, h, g, m, v, S, _;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (i = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : i.call(t, "fill", {
      duration: (o = (r = ((n = e.vars) != null ? n : e).transitions) == null ? void 0 : r.duration) == null ? void 0 : o.shorter
    }),
    variants: [
      {
        props: (R) => !R.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((a = (s = e.typography) == null ? void 0 : s.pxToRem) == null ? void 0 : a.call(s, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((l = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : l.call(u, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((p = (d = e.typography) == null ? void 0 : d.pxToRem) == null ? void 0 : p.call(d, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries(((f = e.vars) != null ? f : e).palette).filter(([, R]) => R && R.main).map(([R]) => {
        var b, y, w;
        return {
          props: {
            color: R
          },
          style: {
            color: (w = (y = ((b = e.vars) != null ? b : e).palette) == null ? void 0 : y[R]) == null ? void 0 : w.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (m = (g = ((h = e.vars) != null ? h : e).palette) == null ? void 0 : g.action) == null ? void 0 : m.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (_ = (S = ((v = e.vars) != null ? v : e).palette) == null ? void 0 : S.action) == null ? void 0 : _.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), Hd = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiSvgIcon"
  }), _ = r, {
    children: o,
    className: i,
    color: s = "inherit",
    component: a = "svg",
    fontSize: u = "medium",
    htmlColor: l,
    inheritViewBox: d = !1,
    titleAccess: p,
    viewBox: f = "0 0 24 24"
  } = _, h = re(_, [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
  ]), g = /* @__PURE__ */ E.isValidElement(o) && o.type === "svg", m = L(C({}, r), {
    color: s,
    component: a,
    fontSize: u,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: f,
    hasSvgAsChild: g
  }), v = {};
  d || (v.viewBox = f);
  const S = wP(m);
  return /* @__PURE__ */ fe(_P, L(C(C(C({
    as: a,
    className: xe(S.root, i),
    focusable: "false",
    color: l,
    "aria-hidden": p ? void 0 : !0,
    role: p ? "img" : void 0,
    ref: n
  }, v), h), g && o.props), {
    ownerState: m,
    children: [g ? o.props.children : o, p ? /* @__PURE__ */ O("title", {
      children: p
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Hd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: c.oneOfType([c.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: c.oneOfType([c.oneOf(["inherit", "large", "medium", "small"]), c.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: c.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: c.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: c.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: c.string
});
Hd.muiName = "SvgIcon";
const Uu = Hd;
function En(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ O(Uu, L(C({
      "data-testid": `${t}Icon`,
      ref: o
    }, r), {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = Uu.muiName, /* @__PURE__ */ E.memo(/* @__PURE__ */ E.forwardRef(n));
}
function tb(e, t) {
  if (!e)
    return t;
  if (typeof e == "function" || typeof t == "function")
    return (o) => {
      const i = typeof t == "function" ? t(o) : t, s = typeof e == "function" ? e(C(C({}, o), i)) : e, a = xe(o == null ? void 0 : o.className, i == null ? void 0 : i.className, s == null ? void 0 : s.className);
      return C(C(C(C(C({}, i), s), !!a && {
        className: a
      }), (i == null ? void 0 : i.style) && (s == null ? void 0 : s.style) && {
        style: C(C({}, i.style), s.style)
      }), (i == null ? void 0 : i.sx) && (s == null ? void 0 : s.sx) && {
        sx: [...Array.isArray(i.sx) ? i.sx : [i.sx], ...Array.isArray(s.sx) ? s.sx : [s.sx]]
      });
    };
  const n = t, r = xe(n == null ? void 0 : n.className, e == null ? void 0 : e.className);
  return C(C(C(C(C({}, t), e), !!r && {
    className: r
  }), (n == null ? void 0 : n.style) && (e == null ? void 0 : e.style) && {
    style: C(C({}, n.style), e.style)
  }), (n == null ? void 0 : n.sx) && (e == null ? void 0 : e.sx) && {
    sx: [...Array.isArray(n.sx) ? n.sx : [n.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
  });
}
function lc(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function Rh(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function nb(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function Go(e, t, n, r, o, i) {
  let s = !1, a = o(e, t, t ? n : !1);
  for (; a; ) {
    if (a === e.firstChild) {
      if (s)
        return !1;
      s = !0;
    }
    const u = r ? !1 : a.disabled || a.getAttribute("aria-disabled") === "true";
    if (!a.hasAttribute("tabindex") || !nb(a, i) || u)
      a = o(e, a, n);
    else
      return a.focus(), !0;
  }
  return !1;
}
const rb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const R = t, {
    actions: r,
    autoFocus: o = !1,
    autoFocusItem: i = !1,
    children: s,
    className: a,
    disabledItemsFocusable: u = !1,
    disableListWrap: l = !1,
    onKeyDown: d,
    variant: p = "selectedMenu"
  } = R, f = re(R, [
    // private
    // eslint-disable-next-line react/prop-types
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
  ]), h = E.useRef(null), g = E.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  ln(() => {
    o && h.current.focus();
  }, [o]), E.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (b, {
      direction: y
    }) => {
      const w = !h.current.style.width;
      if (b.clientHeight < h.current.clientHeight && w) {
        const x = `${yv(jn(b))}px`;
        h.current.style[y === "rtl" ? "paddingLeft" : "paddingRight"] = x, h.current.style.width = `calc(100% + ${x})`;
      }
      return h.current;
    }
  }), []);
  const m = (b) => {
    const y = h.current, w = b.key;
    if (b.ctrlKey || b.metaKey || b.altKey) {
      d && d(b);
      return;
    }
    const P = Vt(y).activeElement;
    if (w === "ArrowDown")
      b.preventDefault(), Go(y, P, l, u, lc);
    else if (w === "ArrowUp")
      b.preventDefault(), Go(y, P, l, u, Rh);
    else if (w === "Home")
      b.preventDefault(), Go(y, null, l, u, lc);
    else if (w === "End")
      b.preventDefault(), Go(y, null, l, u, Rh);
    else if (w.length === 1) {
      const N = g.current, M = w.toLowerCase(), A = performance.now();
      N.keys.length > 0 && (A - N.lastTime > 500 ? (N.keys = [], N.repeating = !0, N.previousKeyMatched = !0) : N.repeating && M !== N.keys[0] && (N.repeating = !1)), N.lastTime = A, N.keys.push(M);
      const T = P && !N.repeating && nb(P, N);
      N.previousKeyMatched && (T || Go(y, P, !1, u, lc, N)) ? b.preventDefault() : N.previousKeyMatched = !1;
    }
    d && d(b);
  }, v = yt(h, n);
  let S = -1;
  E.Children.forEach(s, (b, y) => {
    if (!/* @__PURE__ */ E.isValidElement(b)) {
      S === y && (S += 1, S >= s.length && (S = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && Tr.isFragment(b) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), b.props.disabled || (p === "selectedMenu" && b.props.selected || S === -1) && (S = y), S === y && (b.props.disabled || b.props.muiSkipListHighlight || b.type.muiSkipListHighlight) && (S += 1, S >= s.length && (S = -1));
  });
  const _ = E.Children.map(s, (b, y) => {
    if (y === S) {
      const w = {};
      return i && (w.autoFocus = !0), b.props.tabIndex === void 0 && p === "selectedMenu" && (w.tabIndex = 0), /* @__PURE__ */ E.cloneElement(b, w);
    }
    return b;
  });
  return /* @__PURE__ */ O(CP, L(C({
    role: "menu",
    ref: v,
    className: a,
    onKeyDown: m,
    tabIndex: o ? 0 : -1
  }, f), {
    children: _
  }));
});
process.env.NODE_ENV !== "production" && (rb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: c.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: c.node,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: c.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: c.bool,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: c.oneOf(["menu", "selectedMenu"])
});
const xP = rb;
function va(e, t) {
  var i, s;
  const {
    timeout: n,
    easing: r,
    style: o = {}
  } = e;
  return {
    duration: (i = o.transitionDuration) != null ? i : typeof n == "number" ? n : n[t.mode] || 0,
    easing: (s = o.transitionTimingFunction) != null ? s : typeof r == "object" ? r[t.mode] : r,
    delay: o.transitionDelay
  };
}
function qu(e) {
  return `scale(${e}, ${Nn(e, 2)})`;
}
const TP = {
  entering: {
    opacity: 1,
    transform: qu(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, cc = typeof navigator != "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), ba = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const F = t, {
    addEndListener: r,
    appear: o = !0,
    children: i,
    easing: s,
    in: a,
    onEnter: u,
    onEntered: l,
    onEntering: d,
    onExit: p,
    onExited: f,
    onExiting: h,
    style: g,
    timeout: m = "auto",
    TransitionComponent: v = Kv
  } = F, S = re(F, [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    // eslint-disable-next-line react/prop-types
    "TransitionComponent"
  ]), _ = oo(), R = E.useRef(), b = Za(), y = E.useRef(null), w = yt(y, Ro(i), n), x = (z) => (H) => {
    if (z) {
      const ee = y.current;
      H === void 0 ? z(ee) : z(ee, H);
    }
  }, P = x(d), N = x((z, H) => {
    const {
      duration: ee,
      delay: X,
      easing: k
    } = va({
      style: g,
      timeout: m,
      easing: s
    }, {
      mode: "enter"
    });
    let $;
    m === "auto" ? ($ = b.transitions.getAutoHeightDuration(z.clientHeight), R.current = $) : $ = ee, z.style.transition = [b.transitions.create("opacity", {
      duration: $,
      delay: X
    }), b.transitions.create("transform", {
      duration: cc ? $ : $ * 0.666,
      delay: X,
      easing: k
    })].join(","), u && u(z, H);
  }), M = x(l), A = x(h), T = x((z) => {
    const {
      duration: H,
      delay: ee,
      easing: X
    } = va({
      style: g,
      timeout: m,
      easing: s
    }, {
      mode: "exit"
    });
    let k;
    m === "auto" ? (k = b.transitions.getAutoHeightDuration(z.clientHeight), R.current = k) : k = H, z.style.transition = [b.transitions.create("opacity", {
      duration: k,
      delay: ee
    }), b.transitions.create("transform", {
      duration: cc ? k : k * 0.666,
      delay: cc ? ee : ee || k * 0.333,
      easing: X
    })].join(","), z.style.opacity = 0, z.style.transform = qu(0.75), p && p(z);
  }), D = x(f);
  return /* @__PURE__ */ O(v, L(C({
    appear: o,
    in: a,
    nodeRef: y,
    onEnter: N,
    onEntered: M,
    onEntering: P,
    onExit: T,
    onExited: D,
    onExiting: A,
    addEndListener: (z) => {
      m === "auto" && _.start(R.current || 0, z), r && r(y.current, z);
    },
    timeout: m === "auto" ? null : m
  }, S), {
    children: (z, X) => {
      var k = X, {
        ownerState: H
      } = k, ee = re(k, [
        "ownerState"
      ]);
      return /* @__PURE__ */ E.cloneElement(i, C({
        style: C(C(C({
          opacity: 0,
          transform: qu(0.75),
          visibility: z === "exited" && !a ? "hidden" : void 0
        }, TP[z]), g), i.props.style),
        ref: w
      }, ee));
    }
  }));
});
process.env.NODE_ENV !== "production" && (ba.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: c.bool,
  /**
   * A single child content element.
   */
  children: Ui.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
ba && (ba.muiSupportAuto = !0);
const ob = ba;
function EP(e) {
  const t = Vt(e);
  return t.body === e ? jn(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function yi(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Oh(e) {
  return parseInt(jn(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function RP(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function Ph(e, t, n, r, o) {
  const i = [t, n, ...r];
  [].forEach.call(e.children, (s) => {
    const a = !i.includes(s), u = !RP(s);
    a && u && yi(s, o);
  });
}
function uc(e, t) {
  let n = -1;
  return e.some((r, o) => t(r) ? (n = o, !0) : !1), n;
}
function OP(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (EP(r)) {
      const s = yv(jn(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${Oh(r) + s}px`;
      const a = Vt(r).querySelectorAll(".mui-fixed");
      [].forEach.call(a, (u) => {
        n.push({
          value: u.style.paddingRight,
          property: "padding-right",
          el: u
        }), u.style.paddingRight = `${Oh(u) + s}px`;
      });
    }
    let i;
    if (r.parentNode instanceof DocumentFragment)
      i = Vt(r).body;
    else {
      const s = r.parentElement, a = jn(r);
      i = (s == null ? void 0 : s.nodeName) === "HTML" && a.getComputedStyle(s).overflowY === "scroll" ? s : r;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: i,
      el: s,
      property: a
    }) => {
      i ? s.style.setProperty(a, i) : s.style.removeProperty(a);
    });
  };
}
function PP(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class IP {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && yi(t.modalRef, !1);
    const o = PP(n);
    Ph(n, t.mount, t.modalRef, o, !0);
    const i = uc(this.containers, (s) => s.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: o
    }), r);
  }
  mount(t, n) {
    const r = uc(this.containers, (i) => i.modals.includes(t)), o = this.containers[r];
    o.restore || (o.restore = OP(o, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const o = uc(this.containers, (s) => s.modals.includes(t)), i = this.containers[o];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(r, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && yi(t.modalRef, n), Ph(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const s = i.modals[i.modals.length - 1];
      s.modalRef && yi(s.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const NP = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function MP(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function kP(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function AP(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || kP(e));
}
function $P(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(NP)).forEach((r, o) => {
    const i = MP(r);
    i === -1 || !AP(r) || (i === 0 ? t.push(r) : n.push({
      documentOrder: o,
      tabIndex: i,
      node: r
    }));
  }), n.sort((r, o) => r.tabIndex === o.tabIndex ? r.documentOrder - o.documentOrder : r.tabIndex - o.tabIndex).map((r) => r.node).concat(t);
}
function LP() {
  return !0;
}
function Ca(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: o = !1,
    getTabbable: i = $P,
    isEnabled: s = LP,
    open: a
  } = e, u = E.useRef(!1), l = E.useRef(null), d = E.useRef(null), p = E.useRef(null), f = E.useRef(null), h = E.useRef(!1), g = E.useRef(null), m = yt(Ro(t), g), v = E.useRef(null);
  E.useEffect(() => {
    !a || !g.current || (h.current = !n);
  }, [n, a]), E.useEffect(() => {
    if (!a || !g.current)
      return;
    const R = Vt(g.current);
    return g.current.contains(R.activeElement) || (g.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), g.current.setAttribute("tabIndex", "-1")), h.current && g.current.focus()), () => {
      o || (p.current && p.current.focus && (u.current = !0, p.current.focus()), p.current = null);
    };
  }, [a]), E.useEffect(() => {
    if (!a || !g.current)
      return;
    const R = Vt(g.current), b = (x) => {
      v.current = x, !(r || !s() || x.key !== "Tab") && R.activeElement === g.current && x.shiftKey && (u.current = !0, d.current && d.current.focus());
    }, y = () => {
      var N, M;
      const x = g.current;
      if (x === null)
        return;
      if (!R.hasFocus() || !s() || u.current) {
        u.current = !1;
        return;
      }
      if (x.contains(R.activeElement) || r && R.activeElement !== l.current && R.activeElement !== d.current)
        return;
      if (R.activeElement !== f.current)
        f.current = null;
      else if (f.current !== null)
        return;
      if (!h.current)
        return;
      let P = [];
      if ((R.activeElement === l.current || R.activeElement === d.current) && (P = i(g.current)), P.length > 0) {
        const A = !!((N = v.current) != null && N.shiftKey && ((M = v.current) == null ? void 0 : M.key) === "Tab"), T = P[0], D = P[P.length - 1];
        typeof T != "string" && typeof D != "string" && (A ? D.focus() : T.focus());
      } else
        x.focus();
    };
    R.addEventListener("focusin", y), R.addEventListener("keydown", b, !0);
    const w = setInterval(() => {
      R.activeElement && R.activeElement.tagName === "BODY" && y();
    }, 50);
    return () => {
      clearInterval(w), R.removeEventListener("focusin", y), R.removeEventListener("keydown", b, !0);
    };
  }, [n, r, o, s, a, i]);
  const S = (R) => {
    p.current === null && (p.current = R.relatedTarget), h.current = !0, f.current = R.target;
    const b = t.props.onFocus;
    b && b(R);
  }, _ = (R) => {
    p.current === null && (p.current = R.relatedTarget), h.current = !0;
  };
  return /* @__PURE__ */ fe(E.Fragment, {
    children: [/* @__PURE__ */ O("div", {
      tabIndex: a ? 0 : -1,
      onFocus: _,
      ref: l,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ E.cloneElement(t, {
      ref: m,
      onFocus: S
    }), /* @__PURE__ */ O("div", {
      tabIndex: a ? 0 : -1,
      onFocus: _,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Ca.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Ui,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: c.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: c.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: c.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: c.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: c.func,
  /**
   * If `true`, focus is locked.
   */
  open: c.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Ca["propTypes"] = Ja(Ca.propTypes));
function DP(e) {
  return typeof e == "function" ? e() : e;
}
const Sa = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    disablePortal: i = !1
  } = t, [s, a] = E.useState(null), u = yt(/* @__PURE__ */ E.isValidElement(r) ? Ro(r) : null, n);
  if (ln(() => {
    i || a(DP(o) || document.body);
  }, [o, i]), ln(() => {
    if (s && !i)
      return nh(n, s), () => {
        nh(n, null);
      };
  }, [n, s, i]), i) {
    if (/* @__PURE__ */ E.isValidElement(r)) {
      const l = {
        ref: u
      };
      return /* @__PURE__ */ E.cloneElement(r, l);
    }
    return r;
  }
  return s && /* @__PURE__ */ TC.createPortal(r, s);
});
process.env.NODE_ENV !== "production" && (Sa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: c.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([zn, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool
});
process.env.NODE_ENV !== "production" && (Sa["propTypes"] = Ja(Sa.propTypes));
const ib = Sa, BP = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, sb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = Za(), o = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, j = t, {
    addEndListener: i,
    appear: s = !0,
    children: a,
    easing: u,
    in: l,
    onEnter: d,
    onEntered: p,
    onEntering: f,
    onExit: h,
    onExited: g,
    onExiting: m,
    style: v,
    timeout: S = o,
    TransitionComponent: _ = Kv
  } = j, R = re(j, [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    // eslint-disable-next-line react/prop-types
    "TransitionComponent"
  ]), b = E.useRef(null), y = yt(b, Ro(a), n), w = (F) => (z) => {
    if (F) {
      const H = b.current;
      z === void 0 ? F(H) : F(H, z);
    }
  }, x = w(f), P = w((F, z) => {
    const H = va({
      style: v,
      timeout: S,
      easing: u
    }, {
      mode: "enter"
    });
    F.style.webkitTransition = r.transitions.create("opacity", H), F.style.transition = r.transitions.create("opacity", H), d && d(F, z);
  }), N = w(p), M = w(m), A = w((F) => {
    const z = va({
      style: v,
      timeout: S,
      easing: u
    }, {
      mode: "exit"
    });
    F.style.webkitTransition = r.transitions.create("opacity", z), F.style.transition = r.transitions.create("opacity", z), h && h(F);
  }), T = w(g);
  return /* @__PURE__ */ O(_, L(C({
    appear: s,
    in: l,
    nodeRef: b,
    onEnter: P,
    onEntered: N,
    onEntering: x,
    onExit: A,
    onExited: T,
    onExiting: M,
    addEndListener: (F) => {
      i && i(b.current, F);
    },
    timeout: S
  }, R), {
    children: (F, ee) => {
      var X = ee, {
        ownerState: z
      } = X, H = re(X, [
        "ownerState"
      ]);
      return /* @__PURE__ */ E.cloneElement(a, C({
        style: C(C(C({
          opacity: 0,
          visibility: F === "exited" && !l ? "hidden" : void 0
        }, BP[F]), v), a.props.style),
        ref: y
      }, H));
    }
  }));
});
process.env.NODE_ENV !== "production" && (sb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: c.bool,
  /**
   * A single child content element.
   */
  children: Ui.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
const FP = sb;
function zP(e) {
  return Ve("MuiBackdrop", e);
}
Le("MuiBackdrop", ["root", "invisible"]);
const jP = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return Ye({
    root: ["root", n && "invisible"]
  }, zP, t);
}, HP = ue("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), ab = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiBackdrop"
  }), N = r, {
    children: o,
    className: i,
    component: s = "div",
    invisible: a = !1,
    open: u,
    components: l = {},
    componentsProps: d = {},
    slotProps: p = {},
    slots: f = {},
    TransitionComponent: h,
    transitionDuration: g
  } = N, m = re(N, [
    "children",
    "className",
    "component",
    "invisible",
    "open",
    "components",
    "componentsProps",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
  ]), v = L(C({}, r), {
    component: s,
    invisible: a
  }), S = jP(v), _ = C({
    transition: h,
    root: l.Root
  }, f), R = C(C({}, d), p), b = {
    slots: _,
    slotProps: R
  }, [y, w] = Ke("root", {
    elementType: HP,
    externalForwardedProps: b,
    className: xe(S.root, i),
    ownerState: v
  }), [x, P] = Ke("transition", {
    elementType: FP,
    externalForwardedProps: b,
    ownerState: v
  });
  return /* @__PURE__ */ O(x, L(C(C({
    in: u,
    timeout: g
  }, m), P), {
    children: /* @__PURE__ */ O(y, L(C({
      "aria-hidden": !0
    }, w), {
      classes: S,
      ref: n,
      children: o
    }))
  }));
});
process.env.NODE_ENV !== "production" && (ab.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    root: c.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: c.bool,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: c.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
const WP = ab;
function VP(e) {
  return typeof e == "function" ? e() : e;
}
function UP(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const Ih = () => {
}, vs = new IP();
function qP(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    closeAfterTransition: o = !1,
    onTransitionEnter: i,
    onTransitionExited: s,
    children: a,
    onClose: u,
    open: l,
    rootRef: d
  } = e, p = E.useRef({}), f = E.useRef(null), h = E.useRef(null), g = yt(h, d), [m, v] = E.useState(!l), S = UP(a);
  let _ = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (_ = !1);
  const R = () => Vt(f.current), b = () => (p.current.modalRef = h.current, p.current.mount = f.current, p.current), y = () => {
    vs.mount(b(), {
      disableScrollLock: r
    }), h.current && (h.current.scrollTop = 0);
  }, w = Ln(() => {
    const F = VP(t) || R().body;
    vs.add(b(), F), h.current && y();
  }), x = () => vs.isTopModal(b()), P = Ln((F) => {
    f.current = F, F && (l && x() ? y() : h.current && yi(h.current, _));
  }), N = E.useCallback(() => {
    vs.remove(b(), _);
  }, [_]);
  E.useEffect(() => () => {
    N();
  }, [N]), E.useEffect(() => {
    l ? w() : (!S || !o) && N();
  }, [l, N, S, o, w]);
  const M = (F) => (z) => {
    var H;
    (H = F.onKeyDown) == null || H.call(F, z), !(z.key !== "Escape" || z.which === 229 || // Wait until IME is settled.
    !x()) && (n || (z.stopPropagation(), u && u(z, "escapeKeyDown")));
  }, A = (F) => (z) => {
    var H;
    (H = F.onClick) == null || H.call(F, z), z.target === z.currentTarget && u && u(z, "backdropClick");
  };
  return {
    getRootProps: (F = {}) => {
      const z = Sv(e);
      delete z.onTransitionEnter, delete z.onTransitionExited;
      const H = C(C({}, z), F);
      return L(C({
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation"
      }, H), {
        onKeyDown: M(H),
        ref: g
      });
    },
    getBackdropProps: (F = {}) => {
      const z = F;
      return L(C({
        "aria-hidden": !0
      }, z), {
        onClick: A(z),
        open: l
      });
    },
    getTransitionProps: () => {
      var H, ee;
      const F = () => {
        v(!1), i && i();
      }, z = () => {
        v(!0), s && s(), o && N();
      };
      return {
        onEnter: th(F, (H = a == null ? void 0 : a.props.onEnter) != null ? H : Ih),
        onExited: th(z, (ee = a == null ? void 0 : a.props.onExited) != null ? ee : Ih)
      };
    },
    rootRef: g,
    portalRef: P,
    isTopModal: x,
    exited: m,
    hasTransition: S
  };
}
function GP(e) {
  return Ve("MuiModal", e);
}
Le("MuiModal", ["root", "hidden", "backdrop"]);
const KP = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return Ye({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, GP, r);
}, YP = ue("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})($e(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), XP = ue(WP, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), lb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    name: "MuiModal",
    props: t
  }), ie = r, {
    BackdropComponent: o = XP,
    BackdropProps: i,
    classes: s,
    className: a,
    closeAfterTransition: u = !1,
    children: l,
    container: d,
    component: p,
    components: f = {},
    componentsProps: h = {},
    disableAutoFocus: g = !1,
    disableEnforceFocus: m = !1,
    disableEscapeKeyDown: v = !1,
    disablePortal: S = !1,
    disableRestoreFocus: _ = !1,
    disableScrollLock: R = !1,
    hideBackdrop: b = !1,
    keepMounted: y = !1,
    onBackdropClick: w,
    onClose: x,
    onTransitionEnter: P,
    onTransitionExited: N,
    open: M,
    slotProps: A = {},
    slots: T = {},
    theme: D
  } = ie, j = re(ie, [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    // eslint-disable-next-line react/prop-types
    "theme"
  ]), F = L(C({}, r), {
    closeAfterTransition: u,
    disableAutoFocus: g,
    disableEnforceFocus: m,
    disableEscapeKeyDown: v,
    disablePortal: S,
    disableRestoreFocus: _,
    disableScrollLock: R,
    hideBackdrop: b,
    keepMounted: y
  }), {
    getRootProps: z,
    getBackdropProps: H,
    getTransitionProps: ee,
    portalRef: X,
    isTopModal: k,
    exited: $,
    hasTransition: Y
  } = qP(L(C({}, F), {
    rootRef: n
  })), K = L(C({}, F), {
    exited: $
  }), W = KP(K), Q = {};
  if (l.props.tabIndex === void 0 && (Q.tabIndex = "-1"), Y) {
    const {
      onEnter: B,
      onExited: oe
    } = ee();
    Q.onEnter = B, Q.onExited = oe;
  }
  const G = {
    slots: C({
      root: f.Root,
      backdrop: f.Backdrop
    }, T),
    slotProps: C(C({}, h), A)
  }, [V, U] = Ke("root", {
    ref: n,
    elementType: YP,
    externalForwardedProps: L(C(C({}, G), j), {
      component: p
    }),
    getSlotProps: z,
    ownerState: K,
    className: xe(a, W == null ? void 0 : W.root, !K.open && K.exited && (W == null ? void 0 : W.hidden))
  }), [Z, te] = Ke("backdrop", {
    ref: i == null ? void 0 : i.ref,
    elementType: o,
    externalForwardedProps: G,
    shouldForwardComponentProp: !0,
    additionalProps: i,
    getSlotProps: (B) => H(L(C({}, B), {
      onClick: (oe) => {
        w && w(oe), B != null && B.onClick && B.onClick(oe);
      }
    })),
    className: xe(i == null ? void 0 : i.className, W == null ? void 0 : W.backdrop),
    ownerState: K
  });
  return !y && !M && (!Y || $) ? null : /* @__PURE__ */ O(ib, {
    ref: X,
    container: d,
    disablePortal: S,
    children: /* @__PURE__ */ fe(V, L(C({}, U), {
      children: [!b && o ? /* @__PURE__ */ O(Z, C({}, te)) : null, /* @__PURE__ */ O(Ca, {
        disableEnforceFocus: m,
        disableAutoFocus: g,
        disableRestoreFocus: _,
        isEnabled: k,
        open: M,
        children: /* @__PURE__ */ E.cloneElement(l, Q)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (lb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: c.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: c.object,
  /**
   * A single child content element.
   */
  children: Ui.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: c.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Backdrop: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([zn, c.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: c.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: c.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: c.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: c.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: c.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: c.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: c.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const JP = lb;
function QP(e) {
  return Ve("MuiPaper", e);
}
Le("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const ZP = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: o
  } = e, i = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return Ye(i, QP, o);
}, eI = ue("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})($e(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), cb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var g;
  const r = tt({
    props: t,
    name: "MuiPaper"
  }), o = Za(), h = r, {
    className: i,
    component: s = "div",
    elevation: a = 1,
    square: u = !1,
    variant: l = "elevation"
  } = h, d = re(h, [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
  ]), p = L(C({}, r), {
    component: s,
    elevation: a,
    square: u,
    variant: l
  }), f = ZP(p);
  return process.env.NODE_ENV !== "production" && o.shadows[a] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${a}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${a}]\` is defined.`].join(`
`)), /* @__PURE__ */ O(eI, L(C({
    as: s,
    ownerState: p,
    className: xe(f.root, i),
    ref: n
  }, d), {
    style: C(C({}, l === "elevation" && C(C({
      "--Paper-shadow": (o.vars || o).shadows[a]
    }, o.vars && {
      "--Paper-overlay": (g = o.vars.overlays) == null ? void 0 : g[a]
    }), !o.vars && o.palette.mode === "dark" && {
      "--Paper-overlay": `linear-gradient(${dt("#fff", Bu(a))}, ${dt("#fff", Bu(a))})`
    })), d.style)
  }));
});
process.env.NODE_ENV !== "production" && (cb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Vn(bn, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: c.bool,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: c.oneOfType([c.oneOf(["elevation", "outlined"]), c.string])
});
const tI = cb;
function nI(e) {
  return Ve("MuiPopover", e);
}
Le("MuiPopover", ["root", "paper"]);
function Nh(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function Mh(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function kh(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function di(e) {
  return typeof e == "function" ? e() : e;
}
const rI = (e) => {
  const {
    classes: t
  } = e;
  return Ye({
    root: ["root"],
    paper: ["paper"]
  }, nI, t);
}, oI = ue(JP, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ub = ue(tI, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), db = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiPopover"
  }), te = r, {
    action: o,
    anchorEl: i,
    anchorOrigin: s = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: a,
    anchorReference: u = "anchorEl",
    children: l,
    className: d,
    container: p,
    elevation: f = 8,
    marginThreshold: h = 16,
    open: g,
    PaperProps: m = {},
    slots: v = {},
    slotProps: S = {},
    transformOrigin: _ = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: R,
    transitionDuration: b = "auto",
    TransitionProps: y = {},
    disableScrollLock: w = !1
  } = te, x = re(te, [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    // TODO: remove in v7
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    // TODO: remove in v7
    "transitionDuration",
    "TransitionProps",
    // TODO: remove in v7
    "disableScrollLock"
  ]), P = E.useRef(), N = L(C({}, r), {
    anchorOrigin: s,
    anchorReference: u,
    elevation: f,
    marginThreshold: h,
    transformOrigin: _,
    TransitionComponent: R,
    transitionDuration: b,
    TransitionProps: y
  }), M = rI(N), A = E.useCallback(() => {
    if (u === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (a || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), a;
    const oe = di(i), q = oe && oe.nodeType === 1 ? oe : Vt(P.current).body, pe = q.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const ge = q.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ge.top === 0 && ge.left === 0 && ge.right === 0 && ge.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: pe.top + Nh(pe, s.vertical),
      left: pe.left + Mh(pe, s.horizontal)
    };
  }, [i, s.horizontal, s.vertical, a, u]), T = E.useCallback((oe) => ({
    vertical: Nh(oe, _.vertical),
    horizontal: Mh(oe, _.horizontal)
  }), [_.horizontal, _.vertical]), D = E.useCallback((oe) => {
    const q = {
      width: oe.offsetWidth,
      height: oe.offsetHeight
    }, pe = T(q);
    if (u === "none")
      return {
        top: null,
        left: null,
        transformOrigin: kh(pe)
      };
    const ge = A();
    let Ee = ge.top - pe.vertical, be = ge.left - pe.horizontal;
    const ye = Ee + q.height, Re = be + q.width, Me = jn(di(i)), Ie = Me.innerHeight - h, ae = Me.innerWidth - h;
    if (h !== null && Ee < h) {
      const Se = Ee - h;
      Ee -= Se, pe.vertical += Se;
    } else if (h !== null && ye > Ie) {
      const Se = ye - Ie;
      Ee -= Se, pe.vertical += Se;
    }
    if (process.env.NODE_ENV !== "production" && q.height > Ie && q.height && Ie && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${q.height - Ie}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), h !== null && be < h) {
      const Se = be - h;
      be -= Se, pe.horizontal += Se;
    } else if (Re > ae) {
      const Se = Re - ae;
      be -= Se, pe.horizontal += Se;
    }
    return {
      top: `${Math.round(Ee)}px`,
      left: `${Math.round(be)}px`,
      transformOrigin: kh(pe)
    };
  }, [i, u, A, T, h]), [j, F] = E.useState(g), z = E.useCallback(() => {
    const oe = P.current;
    if (!oe)
      return;
    const q = D(oe);
    q.top !== null && oe.style.setProperty("top", q.top), q.left !== null && (oe.style.left = q.left), oe.style.transformOrigin = q.transformOrigin, F(!0);
  }, [D]);
  E.useEffect(() => (w && window.addEventListener("scroll", z), () => window.removeEventListener("scroll", z)), [i, w, z]);
  const H = () => {
    z();
  }, ee = () => {
    F(!1);
  };
  E.useEffect(() => {
    g && z();
  }), E.useImperativeHandle(o, () => g ? {
    updatePosition: () => {
      z();
    }
  } : null, [g, z]), E.useEffect(() => {
    if (!g)
      return;
    const oe = mv(() => {
      z();
    }), q = jn(di(i));
    return q.addEventListener("resize", oe), () => {
      oe.clear(), q.removeEventListener("resize", oe);
    };
  }, [i, g, z]);
  let X = b;
  const k = {
    slots: C({
      transition: R
    }, v),
    slotProps: C({
      transition: y,
      paper: m
    }, S)
  }, [$, Y] = Ke("transition", {
    elementType: ob,
    externalForwardedProps: k,
    ownerState: N,
    getSlotProps: (oe) => L(C({}, oe), {
      onEntering: (q, pe) => {
        var ge;
        (ge = oe.onEntering) == null || ge.call(oe, q, pe), H();
      },
      onExited: (q) => {
        var pe;
        (pe = oe.onExited) == null || pe.call(oe, q), ee();
      }
    }),
    additionalProps: {
      appear: !0,
      in: g
    }
  });
  b === "auto" && !$.muiSupportAuto && (X = void 0);
  const K = p || (i ? Vt(di(i)).body : void 0), [W, ie] = Ke("root", {
    ref: n,
    elementType: oI,
    externalForwardedProps: C(C({}, k), x),
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: v.backdrop
      },
      slotProps: {
        backdrop: tb(typeof S.backdrop == "function" ? S.backdrop(N) : S.backdrop, {
          invisible: !0
        })
      },
      container: K,
      open: g
    },
    ownerState: N,
    className: xe(M.root, d)
  }), B = ie, {
    slots: Q,
    slotProps: G
  } = B, V = re(B, [
    "slots",
    "slotProps"
  ]), [U, Z] = Ke("paper", {
    ref: P,
    className: M.paper,
    elementType: ub,
    externalForwardedProps: k,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: f,
      style: j ? void 0 : {
        opacity: 0
      }
    },
    ownerState: N
  });
  return /* @__PURE__ */ O(W, L(C(C({}, V), !Fu(W) && {
    slots: Q,
    slotProps: G,
    disableScrollLock: w
  }), {
    children: /* @__PURE__ */ O($, L(C({}, Y), {
      timeout: X,
      children: /* @__PURE__ */ O(U, L(C({}, Z), {
        children: l
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (db.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: un,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Vn(c.oneOfType([zn, c.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = di(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: c.shape({
    horizontal: c.oneOfType([c.oneOf(["center", "left", "right"]), c.number]).isRequired,
    vertical: c.oneOfType([c.oneOf(["bottom", "center", "top"]), c.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: c.shape({
    left: c.number.isRequired,
    top: c.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: c.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: c.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: c.object,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([zn, c.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: c.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: bn,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: c.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: c.shape({
    component: kd
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    paper: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: c.shape({
    horizontal: c.oneOfType([c.oneOf(["center", "left", "right"]), c.number]).isRequired,
    vertical: c.oneOfType([c.oneOf(["bottom", "center", "top"]), c.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: c.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: c.object
});
const iI = db;
function sI(e) {
  return Ve("MuiMenu", e);
}
Le("MuiMenu", ["root", "paper", "list"]);
const aI = {
  vertical: "top",
  horizontal: "right"
}, lI = {
  vertical: "top",
  horizontal: "left"
}, cI = (e) => {
  const {
    classes: t
  } = e;
  return Ye({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, sI, t);
}, uI = ue(iI, {
  shouldForwardProp: (e) => tn(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), dI = ue(ub, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), pI = ue(xP, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), pb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiMenu"
  }), X = r, {
    autoFocus: o = !0,
    children: i,
    className: s,
    disableAutoFocusItem: a = !1,
    MenuListProps: u = {},
    onClose: l,
    open: d,
    PaperProps: p = {},
    PopoverClasses: f,
    transitionDuration: h = "auto",
    TransitionProps: k = {}
  } = X, $ = k, {
    onEntering: g
  } = $, m = re($, [
    "onEntering"
  ]), Y = X, {
    variant: v = "selectedMenu",
    slots: S = {},
    slotProps: _ = {}
  } = Y, R = re(Y, [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
  ]), b = qi(), y = L(C({}, r), {
    autoFocus: o,
    disableAutoFocusItem: a,
    MenuListProps: u,
    onEntering: g,
    PaperProps: p,
    transitionDuration: h,
    TransitionProps: m,
    variant: v
  }), w = cI(y), x = o && !a && d, P = E.useRef(null), N = (K, W) => {
    P.current && P.current.adjustStyleForScrollbar(K, {
      direction: b ? "rtl" : "ltr"
    }), g && g(K, W);
  }, M = (K) => {
    K.key === "Tab" && (K.preventDefault(), l && l(K, "tabKeyDown"));
  };
  let A = -1;
  E.Children.map(i, (K, W) => {
    /* @__PURE__ */ E.isValidElement(K) && (process.env.NODE_ENV !== "production" && Tr.isFragment(K) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), K.props.disabled || (v === "selectedMenu" && K.props.selected || A === -1) && (A = W));
  });
  const T = {
    slots: S,
    slotProps: C({
      list: u,
      transition: m,
      paper: p
    }, _)
  }, D = xv({
    elementType: S.root,
    externalSlotProps: _.root,
    ownerState: y,
    className: [w.root, s]
  }), [j, F] = Ke("paper", {
    className: w.paper,
    elementType: dI,
    externalForwardedProps: T,
    shouldForwardComponentProp: !0,
    ownerState: y
  }), [z, H] = Ke("list", {
    className: xe(w.list, u.className),
    elementType: pI,
    shouldForwardComponentProp: !0,
    externalForwardedProps: T,
    getSlotProps: (K) => L(C({}, K), {
      onKeyDown: (W) => {
        var Q;
        M(W), (Q = K.onKeyDown) == null || Q.call(K, W);
      }
    }),
    ownerState: y
  }), ee = typeof T.slotProps.transition == "function" ? T.slotProps.transition(y) : T.slotProps.transition;
  return /* @__PURE__ */ O(uI, L(C({
    onClose: l,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: b ? "right" : "left"
    },
    transformOrigin: b ? aI : lI,
    slots: C({
      root: S.root,
      paper: j,
      backdrop: S.backdrop
    }, S.transition && {
      // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
      transition: S.transition
    }),
    slotProps: {
      root: D,
      paper: F,
      backdrop: typeof _.backdrop == "function" ? _.backdrop(y) : _.backdrop,
      transition: L(C({}, ee), {
        onEntering: (...K) => {
          var W;
          N(...K), (W = ee == null ? void 0 : ee.onEntering) == null || W.call(ee, ...K);
        }
      })
    },
    open: d,
    ref: n,
    transitionDuration: h,
    ownerState: y
  }, R), {
    classes: f,
    children: /* @__PURE__ */ O(z, L(C({
      actions: P,
      autoFocus: o && (A === -1 || a),
      autoFocusItem: x,
      variant: v
    }, H), {
      children: i
    }))
  }));
});
process.env.NODE_ENV !== "production" && (pb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: c.oneOfType([zn, c.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: c.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: c.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: c.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: c.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: c.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    list: c.oneOfType([c.func, c.object]),
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    list: c.elementType,
    paper: c.elementType,
    root: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: c.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: c.oneOf(["menu", "selectedMenu"])
});
const fI = pb;
function hI(e) {
  return Ve("MuiNativeSelect", e);
}
const mI = Le("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), Wd = mI, gI = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: s
  } = e, a = {
    select: ["select", n, r && "disabled", o && "multiple", s && "error"],
    icon: ["icon", `icon${ve(n)}`, i && "iconOpen", r && "disabled"]
  };
  return Ye(a, hI, t);
}, fb = ue("select")(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${Wd.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), yI = ue(fb, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: tn,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${Wd.multiple}`]: t.multiple
    }];
  }
})({}), hb = ue("svg")(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${Wd.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), vI = ue(hb, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ve(n.variant)}`], n.open && t.iconOpen];
  }
})({}), mb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const f = t, {
    className: r,
    disabled: o,
    error: i,
    IconComponent: s,
    inputRef: a,
    variant: u = "standard"
  } = f, l = re(f, [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
  ]), d = L(C({}, t), {
    disabled: o,
    variant: u,
    error: i
  }), p = gI(d);
  return /* @__PURE__ */ fe(E.Fragment, {
    children: [/* @__PURE__ */ O(yI, C({
      ownerState: d,
      className: xe(p.select, r),
      disabled: o,
      ref: a || n
    }, l)), t.multiple ? null : /* @__PURE__ */ O(vI, {
      as: s,
      ownerState: d,
      className: p.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (mb.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The CSS class name of the select element.
   */
  className: c.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: c.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: c.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: un,
  /**
   * @ignore
   */
  multiple: c.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: c.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The input value.
   */
  value: c.any,
  /**
   * The variant to use.
   */
  variant: c.oneOf(["standard", "outlined", "filled"])
});
const bI = mb;
function gb(e) {
  return Ve("MuiSelect", e);
}
const Ko = Le("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var Ah;
const CI = ue(fb, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Ko.select}`]: t.select
      },
      {
        [`&.${Ko.select}`]: t[n.variant]
      },
      {
        [`&.${Ko.error}`]: t.error
      },
      {
        [`&.${Ko.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${Ko.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SI = ue(hb, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ve(n.variant)}`], n.open && t.iconOpen];
  }
})({}), wI = ue("input", {
  shouldForwardProp: (e) => Fv(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function $h(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function _I(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const xI = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: s
  } = e, a = {
    select: ["select", n, r && "disabled", o && "multiple", s && "error"],
    icon: ["icon", `icon${ve(n)}`, i && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Ye(a, gb, t);
}, yb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var Lt;
  const $t = t, {
    "aria-describedby": r,
    "aria-label": o,
    autoFocus: i,
    autoWidth: s,
    children: a,
    className: u,
    defaultOpen: l,
    defaultValue: d,
    disabled: p,
    displayEmpty: f,
    error: h = !1,
    IconComponent: g,
    inputRef: m,
    labelId: v,
    MenuProps: S = {},
    multiple: _,
    name: R,
    onBlur: b,
    onChange: y,
    onClose: w,
    onFocus: x,
    onOpen: P,
    open: N,
    readOnly: M,
    renderValue: A,
    required: T,
    SelectDisplayProps: D = {},
    tabIndex: j,
    type: F,
    value: z,
    variant: H = "standard"
  } = $t, ee = re($t, [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "required",
    "SelectDisplayProps",
    "tabIndex",
    // catching `type` from Input which makes no sense for SelectInput
    "type",
    "value",
    "variant"
  ]), [X, k] = Pi({
    controlled: z,
    default: d,
    name: "Select"
  }), [$, Y] = Pi({
    controlled: N,
    default: l,
    name: "Select"
  }), K = E.useRef(null), W = E.useRef(null), [Q, G] = E.useState(null), {
    current: V
  } = E.useRef(N != null), [U, Z] = E.useState(), te = yt(n, m), ie = E.useCallback((le) => {
    W.current = le, le && G(le);
  }, []), B = Q == null ? void 0 : Q.parentNode;
  E.useImperativeHandle(te, () => ({
    focus: () => {
      W.current.focus();
    },
    node: K.current,
    value: X
  }), [X]), E.useEffect(() => {
    l && $ && Q && !V && (Z(s ? null : B.clientWidth), W.current.focus());
  }, [Q, s]), E.useEffect(() => {
    i && W.current.focus();
  }, [i]), E.useEffect(() => {
    if (!v)
      return;
    const le = Vt(W.current).getElementById(v);
    if (le) {
      const de = () => {
        getSelection().isCollapsed && W.current.focus();
      };
      return le.addEventListener("click", de), () => {
        le.removeEventListener("click", de);
      };
    }
  }, [v]);
  const oe = (le, de) => {
    le ? P && P(de) : w && w(de), V || (Z(s ? null : B.clientWidth), Y(le));
  }, q = (le) => {
    le.button === 0 && (le.preventDefault(), W.current.focus(), oe(!0, le));
  }, pe = (le) => {
    oe(!1, le);
  }, ge = E.Children.toArray(a), Ee = (le) => {
    const de = ge.find((Te) => Te.props.value === le.target.value);
    de !== void 0 && (k(de.props.value), y && y(le, de));
  }, be = (le) => (de) => {
    let Te;
    if (de.currentTarget.hasAttribute("tabindex")) {
      if (_) {
        Te = Array.isArray(X) ? X.slice() : [];
        const ot = X.indexOf(le.props.value);
        ot === -1 ? Te.push(le.props.value) : Te.splice(ot, 1);
      } else
        Te = le.props.value;
      if (le.props.onClick && le.props.onClick(de), X !== Te && (k(Te), y)) {
        const ot = de.nativeEvent || de, nn = new ot.constructor(ot.type, ot);
        Object.defineProperty(nn, "target", {
          writable: !0,
          value: {
            value: Te,
            name: R
          }
        }), y(nn, le);
      }
      _ || oe(!1, de);
    }
  }, ye = (le) => {
    M || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(le.key) && (le.preventDefault(), oe(!0, le));
  }, Re = Q !== null && $, Me = (le) => {
    !Re && b && (Object.defineProperty(le, "target", {
      writable: !0,
      value: {
        value: X,
        name: R
      }
    }), b(le));
  };
  delete ee["aria-invalid"];
  let Ie, ae;
  const Se = [];
  let mt = !1, ke = !1;
  (Wv({
    value: X
  }) || f) && (A ? Ie = A(X) : mt = !0);
  const Qe = ge.map((le) => {
    if (!/* @__PURE__ */ E.isValidElement(le))
      return null;
    process.env.NODE_ENV !== "production" && Tr.isFragment(le) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let de;
    if (_) {
      if (!Array.isArray(X))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : _n(2));
      de = X.some((Te) => $h(Te, le.props.value)), de && mt && Se.push(le.props.children);
    } else
      de = $h(X, le.props.value), de && mt && (ae = le.props.children);
    return de && (ke = !0), /* @__PURE__ */ E.cloneElement(le, {
      "aria-selected": de ? "true" : "false",
      onClick: be(le),
      onKeyUp: (Te) => {
        Te.key === " " && Te.preventDefault(), le.props.onKeyUp && le.props.onKeyUp(Te);
      },
      role: "option",
      selected: de,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": le.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && E.useEffect(() => {
    if (!ke && !_ && X !== "") {
      const le = ge.map((de) => de.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${X}\` for the select ${R ? `(name="${R}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${le.filter((de) => de != null).map((de) => `\`${de}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [ke, ge, _, R, X]), mt && (_ ? Se.length === 0 ? Ie = null : Ie = Se.reduce((le, de, Te) => (le.push(de), Te < Se.length - 1 && le.push(", "), le), []) : Ie = ae);
  let we = U;
  !s && V && Q && (we = B.clientWidth);
  let Ne;
  typeof j != "undefined" ? Ne = j : Ne = p ? null : 0;
  const Ue = D.id || (R ? `mui-component-select-${R}` : void 0), Ae = L(C({}, t), {
    variant: H,
    value: X,
    open: Re,
    error: h
  }), je = xI(Ae), ce = C(C({}, S.PaperProps), (Lt = S.slotProps) == null ? void 0 : Lt.paper), Pe = Oi();
  return /* @__PURE__ */ fe(E.Fragment, {
    children: [/* @__PURE__ */ O(CI, L(C({
      as: "div",
      ref: ie,
      tabIndex: Ne,
      role: "combobox",
      "aria-controls": Re ? Pe : void 0,
      "aria-disabled": p ? "true" : void 0,
      "aria-expanded": Re ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": o,
      "aria-labelledby": [v, Ue].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      "aria-required": T ? "true" : void 0,
      "aria-invalid": h ? "true" : void 0,
      onKeyDown: ye,
      onMouseDown: p || M ? null : q,
      onBlur: Me,
      onFocus: x
    }, D), {
      ownerState: Ae,
      className: xe(D.className, je.select, u),
      id: Ue,
      children: _I(Ie) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Ah || (Ah = /* @__PURE__ */ O("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : Ie
    })), /* @__PURE__ */ O(wI, L(C({
      "aria-invalid": h,
      value: Array.isArray(X) ? X.join(",") : X,
      name: R,
      ref: K,
      "aria-hidden": !0,
      onChange: Ee,
      tabIndex: -1,
      disabled: p,
      className: je.nativeInput,
      autoFocus: i,
      required: T
    }, ee), {
      ownerState: Ae
    })), /* @__PURE__ */ O(SI, {
      as: g,
      className: je.icon,
      ownerState: Ae
    }), /* @__PURE__ */ O(fI, L(C({
      id: `menu-${R || ""}`,
      anchorEl: B,
      open: Re,
      onClose: pe,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, S), {
      slotProps: L(C({}, S.slotProps), {
        list: C({
          "aria-labelledby": v,
          role: "listbox",
          "aria-multiselectable": _ ? "true" : void 0,
          disableListWrap: !0,
          id: Pe
        }, S.MenuListProps),
        paper: L(C({}, ce), {
          style: C({
            minWidth: we
          }, ce != null ? ce.style : null)
        })
      }),
      children: Qe
    }))]
  });
});
process.env.NODE_ENV !== "production" && (yb.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": c.string,
  /**
   * @ignore
   */
  "aria-label": c.string,
  /**
   * @ignore
   */
  autoFocus: c.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: c.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The CSS class name of the select element.
   */
  className: c.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: c.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: c.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: c.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: c.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: un,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: c.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: c.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: c.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: c.string,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * @ignore
   */
  readOnly: c.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: c.func,
  /**
   * If `true`, the component is required.
   */
  required: c.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: c.object,
  /**
   * @ignore
   */
  tabIndex: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  type: c.any,
  /**
   * The input value.
   */
  value: c.any,
  /**
   * The variant to use.
   */
  variant: c.oneOf(["standard", "outlined", "filled"])
});
const TI = yb, EI = En(/* @__PURE__ */ O("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function RI(e) {
  return Ve("MuiInput", e);
}
const OI = C(C({}, go), Le("MuiInput", ["root", "underline", "input"])), Yo = OI, PI = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = Ye({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, RI, t);
  return C(C({}, t), o);
}, II = ue(rl, {
  shouldForwardProp: (e) => tn(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...tl(e, t), !n.disableUnderline && t.underline];
  }
})($e(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: r
      }) => r.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => !r.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Yo.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Yo.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Yo.disabled}, .${Yo.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${Yo.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(cn()).map(([r]) => ({
      props: {
        color: r,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    }))]
  };
})), NI = ue(ol, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: nl
})({}), Vd = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var y, w, x, P;
  const r = tt({
    props: t,
    name: "MuiInput"
  }), b = r, {
    disableUnderline: o = !1,
    components: i = {},
    componentsProps: s,
    fullWidth: a = !1,
    inputComponent: u = "input",
    multiline: l = !1,
    slotProps: d,
    slots: p = {},
    type: f = "text"
  } = b, h = re(b, [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
  ]), g = PI(r), v = {
    root: {
      ownerState: {
        disableUnderline: o
      }
    }
  }, S = (d != null ? d : s) ? xt(d != null ? d : s, v) : v, _ = (w = (y = p.root) != null ? y : i.Root) != null ? w : II, R = (P = (x = p.input) != null ? x : i.Input) != null ? P : NI;
  return /* @__PURE__ */ O(il, L(C({
    slots: {
      root: _,
      input: R
    },
    slotProps: S,
    fullWidth: a,
    inputComponent: u,
    multiline: l,
    ref: n,
    type: f
  }, h), {
    classes: g
  }));
});
process.env.NODE_ENV !== "production" && (Vd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: un,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
Vd.muiName = "Input";
const MI = Vd;
function kI(e) {
  return Ve("MuiFilledInput", e);
}
const AI = C(C({}, go), Le("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])), mr = AI, $I = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: r,
    endAdornment: o,
    size: i,
    hiddenLabel: s,
    multiline: a
  } = e, u = {
    root: ["root", !n && "underline", r && "adornedStart", o && "adornedEnd", i === "small" && `size${ve(i)}`, s && "hiddenLabel", a && "multiline"],
    input: ["input"]
  }, l = Ye(u, kI, t);
  return C(C({}, t), l);
}, LI = ue(rl, {
  shouldForwardProp: (e) => tn(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...tl(e, t), !n.disableUnderline && t.underline];
  }
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", o = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : o,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${mr.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${mr.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [{
      props: ({
        ownerState: s
      }) => !s.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${mr.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${mr.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${mr.disabled}, .${mr.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${mr.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(cn()).map(([s]) => {
      var a;
      return {
        props: {
          disableUnderline: !1,
          color: s
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(a = (e.vars || e).palette[s]) == null ? void 0 : a.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: s
      }) => s.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: s
      }) => s.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: s
      }) => s.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: s,
        size: a
      }) => s.multiline && a === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: s
      }) => s.multiline && s.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: s
      }) => s.multiline && s.hiddenLabel && s.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), DI = ue(ol, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: nl
})($e(({
  theme: e
}) => L(C(C({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}), e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}), {
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), Ud = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var w, x, P, N;
  const r = tt({
    props: t,
    name: "MuiFilledInput"
  }), y = r, {
    disableUnderline: o = !1,
    components: i = {},
    componentsProps: s,
    fullWidth: a = !1,
    hiddenLabel: u,
    inputComponent: l = "input",
    multiline: d = !1,
    slotProps: p,
    slots: f = {},
    type: h = "text"
  } = y, g = re(y, [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    // declare here to prevent spreading to DOM
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
  ]), m = L(C({}, r), {
    disableUnderline: o,
    fullWidth: a,
    inputComponent: l,
    multiline: d,
    type: h
  }), v = $I(r), S = {
    root: {
      ownerState: m
    },
    input: {
      ownerState: m
    }
  }, _ = (p != null ? p : s) ? xt(S, p != null ? p : s) : S, R = (x = (w = f.root) != null ? w : i.Root) != null ? x : LI, b = (N = (P = f.input) != null ? P : i.Input) != null ? N : DI;
  return /* @__PURE__ */ O(il, L(C({
    slots: {
      root: R,
      input: b
    },
    slotProps: _,
    fullWidth: a,
    inputComponent: l,
    multiline: d,
    ref: n,
    type: h
  }, g), {
    classes: v
  }));
});
process.env.NODE_ENV !== "production" && (Ud.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: un,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
Ud.muiName = "Input";
const BI = Ud;
var Lh;
const FI = ue("fieldset", {
  shouldForwardProp: tn
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), zI = ue("legend", {
  shouldForwardProp: tn
})($e(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function vb(e) {
  const l = e, {
    children: t,
    classes: n,
    className: r,
    label: o,
    notched: i
  } = l, s = re(l, [
    "children",
    "classes",
    "className",
    "label",
    "notched"
  ]), a = o != null && o !== "", u = L(C({}, e), {
    notched: i,
    withLabel: a
  });
  return /* @__PURE__ */ O(FI, L(C({
    "aria-hidden": !0,
    className: r,
    ownerState: u
  }, s), {
    children: /* @__PURE__ */ O(zI, {
      ownerState: u,
      children: a ? /* @__PURE__ */ O("span", {
        children: o
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Lh || (Lh = /* @__PURE__ */ O("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (vb.propTypes = {
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The label.
   */
  label: c.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: c.bool.isRequired,
  /**
   * @ignore
   */
  style: c.object
});
function jI(e) {
  return Ve("MuiOutlinedInput", e);
}
const HI = C(C({}, go), Le("MuiOutlinedInput", ["root", "notchedOutline", "input"])), hn = HI, WI = (e) => {
  const {
    classes: t
  } = e, r = Ye({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, jI, t);
  return C(C({}, t), r);
}, VI = ue(rl, {
  shouldForwardProp: (e) => tn(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: tl
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${hn.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${hn.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${hn.focused} .${hn.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(cn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${hn.focused} .${hn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${hn.error} .${hn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${hn.disabled} .${hn.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: r
      }) => n.multiline && r === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), UI = ue(vb, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})($e(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), qI = ue(ol, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: nl
})($e(({
  theme: e
}) => L(C(C({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}), e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}), {
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), qd = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var x, P, N, M;
  const r = tt({
    props: t,
    name: "MuiOutlinedInput"
  }), w = r, {
    components: o = {},
    fullWidth: i = !1,
    inputComponent: s = "input",
    label: a,
    multiline: u = !1,
    notched: l,
    slots: d = {},
    slotProps: p = {},
    type: f = "text"
  } = w, h = re(w, [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "slotProps",
    "type"
  ]), g = WI(r), m = el(), v = Fd({
    props: r,
    muiFormControl: m,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), S = L(C({}, r), {
    color: v.color || "primary",
    disabled: v.disabled,
    error: v.error,
    focused: v.focused,
    formControl: m,
    fullWidth: i,
    hiddenLabel: v.hiddenLabel,
    multiline: u,
    size: v.size,
    type: f
  }), _ = (P = (x = d.root) != null ? x : o.Root) != null ? P : VI, R = (M = (N = d.input) != null ? N : o.Input) != null ? M : qI, [b, y] = Ke("notchedOutline", {
    elementType: UI,
    className: g.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: S,
    externalForwardedProps: {
      slots: d,
      slotProps: p
    },
    additionalProps: {
      label: a != null && a !== "" && v.required ? /* @__PURE__ */ fe(E.Fragment, {
        children: [a, " ", "*"]
      }) : a
    }
  });
  return /* @__PURE__ */ O(il, L(C({
    slots: {
      root: _,
      input: R
    },
    slotProps: p,
    renderSuffix: (A) => /* @__PURE__ */ O(b, L(C({}, y), {
      notched: typeof l != "undefined" ? l : !!(A.startAdornment || A.filled || A.focused)
    })),
    fullWidth: i,
    inputComponent: s,
    multiline: u,
    ref: n,
    type: f
  }, h), {
    classes: L(C({}, g), {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (qd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: un,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: c.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: c.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    notchedOutline: c.oneOfType([c.func, c.object]),
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    notchedOutline: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
qd.muiName = "Input";
const GI = qd, KI = (e) => {
  const {
    classes: t
  } = e, r = Ye({
    root: ["root"]
  }, gb, t);
  return C(C({}, t), r);
}, Gd = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => tn(e) && e !== "variant",
  slot: "Root"
}, YI = ue(MI, Gd)(""), XI = ue(GI, Gd)(""), JI = ue(BI, Gd)(""), Kd = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    name: "MuiSelect",
    props: t
  }), k = r, {
    autoWidth: o = !1,
    children: i,
    classes: s = {},
    className: a,
    defaultOpen: u = !1,
    displayEmpty: l = !1,
    IconComponent: d = EI,
    id: p,
    input: f,
    inputProps: h,
    label: g,
    labelId: m,
    MenuProps: v,
    multiple: S = !1,
    native: _ = !1,
    onClose: R,
    onOpen: b,
    open: y,
    renderValue: w,
    SelectDisplayProps: x,
    variant: P = "outlined"
  } = k, N = re(k, [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
  ]), M = _ ? bI : TI, A = el(), T = Fd({
    props: r,
    muiFormControl: A,
    states: ["variant", "error"]
  }), D = T.variant || P, j = L(C({}, r), {
    variant: D,
    classes: s
  }), F = KI(j), $ = F, {
    root: z
  } = $, H = re($, [
    "root"
  ]), ee = f || {
    standard: /* @__PURE__ */ O(YI, {
      ownerState: j
    }),
    outlined: /* @__PURE__ */ O(XI, {
      label: g,
      ownerState: j
    }),
    filled: /* @__PURE__ */ O(JI, {
      ownerState: j
    })
  }[D], X = yt(n, Ro(ee));
  return /* @__PURE__ */ O(E.Fragment, {
    children: /* @__PURE__ */ E.cloneElement(ee, C(C(L(C({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: M,
      inputProps: C(L(C(C({
        children: i,
        error: T.error,
        IconComponent: d,
        variant: D,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: S
      }, _ ? {
        id: p
      } : {
        autoWidth: o,
        defaultOpen: u,
        displayEmpty: l,
        labelId: m,
        MenuProps: v,
        onClose: R,
        onOpen: b,
        open: y,
        renderValue: w,
        SelectDisplayProps: C({
          id: p
        }, x)
      }), h), {
        classes: h ? xt(H, h.classes) : H
      }), f ? f.props.inputProps : {})
    }, (S && _ || l) && D === "outlined" ? {
      notched: !0
    } : {}), {
      ref: X,
      className: xe(ee.props.className, a, F.root)
    }), !f && {
      variant: D
    }), N))
  });
});
process.env.NODE_ENV !== "production" && (Kd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: c.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: c.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: c.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: c.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: c.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: c.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: c.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: c.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: c.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: c.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: c.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: c.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: c.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: c.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: c.oneOfType([c.oneOf([""]), c.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
Kd.muiName = "Select";
const QI = Kd, bb = /* @__PURE__ */ E.createContext();
process.env.NODE_ENV !== "production" && (bb.displayName = "TableContext");
const ZI = bb, Cb = /* @__PURE__ */ E.createContext();
process.env.NODE_ENV !== "production" && (Cb.displayName = "Tablelvl2Context");
const eN = Cb;
function tN(e) {
  return Ve("MuiTableCell", e);
}
const nN = Le("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), rN = nN, oN = (e) => {
  const {
    classes: t,
    variant: n,
    align: r,
    padding: o,
    size: i,
    stickyHeader: s
  } = e, a = {
    root: ["root", n, s && "stickyHeader", r !== "inherit" && `align${ve(r)}`, o !== "normal" && `padding${ve(o)}`, `size${ve(i)}`]
  };
  return Ye(a, tN, t);
}, iN = ue("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${ve(n.size)}`], n.padding !== "normal" && t[`padding${ve(n.padding)}`], n.align !== "inherit" && t[`align${ve(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})($e(({
  theme: e
}) => L(C({}, e.typography.body2), {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? Xa(dt(e.palette.divider, 1), 0.88) : Ya(dt(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (e.vars || e).palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${rN.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (e.vars || e).palette.background.default
    }
  }]
}))), Sb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiTableCell"
  }), w = r, {
    align: o = "inherit",
    className: i,
    component: s,
    padding: a,
    scope: u,
    size: l,
    sortDirection: d,
    variant: p
  } = w, f = re(w, [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
  ]), h = E.useContext(ZI), g = E.useContext(eN), m = g && g.variant === "head";
  let v;
  s ? v = s : v = m ? "th" : "td";
  let S = u;
  v === "td" ? S = void 0 : !S && m && (S = "col");
  const _ = p || g && g.variant, R = L(C({}, r), {
    align: o,
    component: v,
    padding: a || (h && h.padding ? h.padding : "normal"),
    size: l || (h && h.size ? h.size : "medium"),
    sortDirection: d,
    stickyHeader: _ === "head" && h && h.stickyHeader,
    variant: _
  }), b = oN(R);
  let y = null;
  return d && (y = d === "asc" ? "ascending" : "descending"), /* @__PURE__ */ O(iN, C({
    as: v,
    ref: n,
    className: xe(b.root, i),
    "aria-sort": y,
    scope: S,
    ownerState: R
  }, f));
});
process.env.NODE_ENV !== "production" && (Sb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: c.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: c.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: c.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: c.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: c.oneOfType([c.oneOf(["body", "footer", "head"]), c.string])
});
const Gu = Sb;
function sN(e) {
  return Ve("MuiToolbar", e);
}
Le("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const aN = (e) => {
  const {
    classes: t,
    disableGutters: n,
    variant: r
  } = e;
  return Ye({
    root: ["root", !n && "gutters", r]
  }, sN, t);
}, lN = ue("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
  }
})($e(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2),
      [e.breakpoints.up("sm")]: {
        paddingLeft: e.spacing(3),
        paddingRight: e.spacing(3)
      }
    }
  }, {
    props: {
      variant: "dense"
    },
    style: {
      minHeight: 48
    }
  }, {
    props: {
      variant: "regular"
    },
    style: e.mixins.toolbar
  }]
}))), wb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiToolbar"
  }), p = r, {
    className: o,
    component: i = "div",
    disableGutters: s = !1,
    variant: a = "regular"
  } = p, u = re(p, [
    "className",
    "component",
    "disableGutters",
    "variant"
  ]), l = L(C({}, r), {
    component: i,
    disableGutters: s,
    variant: a
  }), d = aN(l);
  return /* @__PURE__ */ O(lN, C({
    as: i,
    className: xe(d.root, o),
    ref: n,
    ownerState: l
  }, u));
});
process.env.NODE_ENV !== "production" && (wb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: c.oneOfType([c.oneOf(["dense", "regular"]), c.string])
});
const cN = wb, uN = En(/* @__PURE__ */ O("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), dN = En(/* @__PURE__ */ O("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function pN(e) {
  return Ve("MuiCircularProgress", e);
}
Le("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Gn = 44, Ku = Fi`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, Yu = Fi`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, fN = typeof Ku != "string" ? er`
        animation: ${Ku} 1.4s linear infinite;
      ` : null, hN = typeof Yu != "string" ? er`
        animation: ${Yu} 1.4s ease-in-out infinite;
      ` : null, mN = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: o
  } = e, i = {
    root: ["root", n, `color${ve(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${ve(n)}`, o && "circleDisableShrink"]
  };
  return Ye(i, pN, t);
}, gN = ue("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${ve(n.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: fN || {
      animation: `${Ku} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(cn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), yN = ue("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), vN = ue("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${ve(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})($e(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: hN || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${Yu} 1.4s ease-in-out infinite`
    }
  }]
}))), _b = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiCircularProgress"
  }), _ = r, {
    className: o,
    color: i = "primary",
    disableShrink: s = !1,
    size: a = 40,
    style: u,
    thickness: l = 3.6,
    value: d = 0,
    variant: p = "indeterminate"
  } = _, f = re(_, [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
  ]), h = L(C({}, r), {
    color: i,
    disableShrink: s,
    size: a,
    thickness: l,
    value: d,
    variant: p
  }), g = mN(h), m = {}, v = {}, S = {};
  if (p === "determinate") {
    const R = 2 * Math.PI * ((Gn - l) / 2);
    m.strokeDasharray = R.toFixed(3), S["aria-valuenow"] = Math.round(d), m.strokeDashoffset = `${((100 - d) / 100 * R).toFixed(3)}px`, v.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ O(gN, L(C(C({
    className: xe(g.root, o),
    style: C(C({
      width: a,
      height: a
    }, v), u),
    ownerState: h,
    ref: n,
    role: "progressbar"
  }, S), f), {
    children: /* @__PURE__ */ O(yN, {
      className: g.svg,
      ownerState: h,
      viewBox: `${Gn / 2} ${Gn / 2} ${Gn} ${Gn}`,
      children: /* @__PURE__ */ O(vN, {
        className: g.circle,
        style: m,
        ownerState: h,
        cx: Gn,
        cy: Gn,
        r: (Gn - l) / 2,
        fill: "none",
        strokeWidth: l
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (_b.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: Vn(c.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: c.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: c.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: c.oneOf(["determinate", "indeterminate"])
});
const bN = _b;
function CN(e) {
  return Ve("MuiIconButton", e);
}
const SN = Le("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), Dh = SN, wN = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: o,
    size: i,
    loading: s
  } = e, a = {
    root: ["root", s && "loading", n && "disabled", r !== "default" && `color${ve(r)}`, o && `edge${ve(o)}`, `size${ve(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return Ye(a, CN, t);
}, _N = ue(sl, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.loading && t.loading, n.color !== "default" && t[`color${ve(n.color)}`], n.edge && t[`edge${ve(n.edge)}`], t[`size${ve(n.size)}`]];
  }
})($e(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), $e(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(cn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(cn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${Dh.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${Dh.loading}`]: {
    color: "transparent"
  }
}))), xN = ue("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), xb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiIconButton"
  }), R = r, {
    edge: o = !1,
    children: i,
    className: s,
    color: a = "default",
    disabled: u = !1,
    disableFocusRipple: l = !1,
    size: d = "medium",
    id: p,
    loading: f = null,
    loadingIndicator: h
  } = R, g = re(R, [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size",
    "id",
    "loading",
    "loadingIndicator"
  ]), m = Oi(p), v = h != null ? h : /* @__PURE__ */ O(bN, {
    "aria-labelledby": m,
    color: "inherit",
    size: 16
  }), S = L(C({}, r), {
    edge: o,
    color: a,
    disabled: u,
    disableFocusRipple: l,
    loading: f,
    loadingIndicator: v,
    size: d
  }), _ = wN(S);
  return /* @__PURE__ */ fe(_N, L(C({
    id: f ? m : p,
    className: xe(_.root, s),
    centerRipple: !0,
    focusRipple: !l,
    disabled: u || f,
    ref: n
  }, g), {
    ownerState: S,
    children: [typeof f == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ O("span", {
      className: _.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ O(xN, {
        className: _.loadingIndicator,
        ownerState: S,
        children: f && v
      })
    }), i]
  }));
});
process.env.NODE_ENV !== "production" && (xb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Vn(c.node, (e) => E.Children.toArray(e.children).some((n) => /* @__PURE__ */ E.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: c.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: c.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: c.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: c.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const bs = xb, Tb = En(/* @__PURE__ */ O("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), Eb = En(/* @__PURE__ */ O("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), Rb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var Y, K, W, Q, G, V, U, Z;
  const $ = t, {
    backIconButtonProps: r,
    count: o,
    disabled: i = !1,
    getItemAriaLabel: s,
    nextIconButtonProps: a,
    onPageChange: u,
    page: l,
    rowsPerPage: d,
    showFirstButton: p,
    showLastButton: f,
    slots: h = {},
    slotProps: g = {}
  } = $, m = re($, [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
  ]), v = qi(), S = (te) => {
    u(te, 0);
  }, _ = (te) => {
    u(te, l - 1);
  }, R = (te) => {
    u(te, l + 1);
  }, b = (te) => {
    u(te, Math.max(0, Math.ceil(o / d) - 1));
  }, y = (Y = h.firstButton) != null ? Y : bs, w = (K = h.lastButton) != null ? K : bs, x = (W = h.nextButton) != null ? W : bs, P = (Q = h.previousButton) != null ? Q : bs, N = (G = h.firstButtonIcon) != null ? G : Eb, M = (V = h.lastButtonIcon) != null ? V : Tb, A = (U = h.nextButtonIcon) != null ? U : dN, T = (Z = h.previousButtonIcon) != null ? Z : uN, D = v ? w : y, j = v ? x : P, F = v ? P : x, z = v ? y : w, H = v ? g.lastButton : g.firstButton, ee = v ? g.nextButton : g.previousButton, X = v ? g.previousButton : g.nextButton, k = v ? g.firstButton : g.lastButton;
  return /* @__PURE__ */ fe("div", L(C({
    ref: n
  }, m), {
    children: [p && /* @__PURE__ */ O(D, L(C({
      onClick: S,
      disabled: i || l === 0,
      "aria-label": s("first", l),
      title: s("first", l)
    }, H), {
      children: v ? /* @__PURE__ */ O(M, C({}, g.lastButtonIcon)) : /* @__PURE__ */ O(N, C({}, g.firstButtonIcon))
    })), /* @__PURE__ */ O(j, L(C({
      onClick: _,
      disabled: i || l === 0,
      color: "inherit",
      "aria-label": s("previous", l),
      title: s("previous", l)
    }, ee != null ? ee : r), {
      children: v ? /* @__PURE__ */ O(A, C({}, g.nextButtonIcon)) : /* @__PURE__ */ O(T, C({}, g.previousButtonIcon))
    })), /* @__PURE__ */ O(F, L(C({
      onClick: R,
      disabled: i || (o !== -1 ? l >= Math.ceil(o / d) - 1 : !1),
      color: "inherit",
      "aria-label": s("next", l),
      title: s("next", l)
    }, X != null ? X : a), {
      children: v ? /* @__PURE__ */ O(T, C({}, g.previousButtonIcon)) : /* @__PURE__ */ O(A, C({}, g.nextButtonIcon))
    })), f && /* @__PURE__ */ O(z, L(C({
      onClick: b,
      disabled: i || l >= Math.ceil(o / d) - 1,
      "aria-label": s("last", l),
      title: s("last", l)
    }, k), {
      children: v ? /* @__PURE__ */ O(N, C({}, g.firstButtonIcon)) : /* @__PURE__ */ O(M, C({}, g.lastButtonIcon))
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (Rb.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: c.object,
  /**
   * The total number of rows.
   */
  count: c.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: c.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: c.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: c.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: c.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: c.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: c.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: c.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: c.shape({
    firstButton: c.object,
    firstButtonIcon: c.object,
    lastButton: c.object,
    lastButtonIcon: c.object,
    nextButton: c.object,
    nextButtonIcon: c.object,
    previousButton: c.object,
    previousButtonIcon: c.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    firstButton: c.elementType,
    firstButtonIcon: c.elementType,
    lastButton: c.elementType,
    lastButtonIcon: c.elementType,
    nextButton: c.elementType,
    nextButtonIcon: c.elementType,
    previousButton: c.elementType,
    previousButtonIcon: c.elementType
  })
});
const TN = Rb;
function EN(e) {
  return Ve("MuiTablePagination", e);
}
const RN = Le("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]), vi = RN;
var Bh;
const ON = ue(Gu, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})($e(({
  theme: e
}) => ({
  overflow: "auto",
  color: (e.vars || e).palette.text.primary,
  fontSize: e.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
}))), PN = ue(cN, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (e, t) => C({
    [`& .${vi.actions}`]: t.actions
  }, t.toolbar)
})($e(({
  theme: e
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${e.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [e.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${vi.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
}))), IN = ue("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})({
  flex: "1 1 100%"
}), NN = ue("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (e, t) => t.selectLabel
})($e(({
  theme: e
}) => L(C({}, e.typography.body2), {
  flexShrink: 0
}))), MN = ue(QI, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (e, t) => C(C({
    [`& .${vi.selectIcon}`]: t.selectIcon,
    [`& .${vi.select}`]: t.select
  }, t.input), t.selectRoot)
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${vi.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), kN = ue(gP, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (e, t) => t.menuItem
})({}), AN = ue("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (e, t) => t.displayedRows
})($e(({
  theme: e
}) => L(C({}, e.typography.body2), {
  flexShrink: 0
})));
function $N({
  from: e,
  to: t,
  count: n
}) {
  return `${e}–${t} of ${n !== -1 ? n : `more than ${t}`}`;
}
function LN(e) {
  return `Go to ${e} page`;
}
const DN = (e) => {
  const {
    classes: t
  } = e;
  return Ye({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, EN, t);
}, Ob = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var oe;
  const r = tt({
    props: t,
    name: "MuiTablePagination"
  }), B = r, {
    ActionsComponent: o = TN,
    backIconButtonProps: i,
    colSpan: s,
    component: a = Gu,
    count: u,
    disabled: l = !1,
    getItemAriaLabel: d = LN,
    labelDisplayedRows: p = $N,
    labelRowsPerPage: f = "Rows per page:",
    nextIconButtonProps: h,
    onPageChange: g,
    onRowsPerPageChange: m,
    page: v,
    rowsPerPage: S,
    rowsPerPageOptions: _ = [10, 25, 50, 100],
    SelectProps: R = {},
    showFirstButton: b = !1,
    showLastButton: y = !1,
    slotProps: w = {},
    slots: x = {}
  } = B, P = re(B, [
    "ActionsComponent",
    "backIconButtonProps",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
  ]), N = r, M = DN(N), A = (oe = w == null ? void 0 : w.select) != null ? oe : R, T = A.native ? "option" : kN;
  let D;
  (a === Gu || a === "td") && (D = s || 1e3);
  const j = Oi(A.id), F = Oi(A.labelId), z = () => u === -1 ? (v + 1) * S : S === -1 ? u : Math.min(u, (v + 1) * S), H = {
    slots: x,
    slotProps: w
  }, [ee, X] = Ke("root", {
    ref: n,
    className: M.root,
    elementType: ON,
    externalForwardedProps: C(L(C({}, H), {
      component: a
    }), P),
    ownerState: N,
    additionalProps: {
      colSpan: D
    }
  }), [k, $] = Ke("toolbar", {
    className: M.toolbar,
    elementType: PN,
    externalForwardedProps: H,
    ownerState: N
  }), [Y, K] = Ke("spacer", {
    className: M.spacer,
    elementType: IN,
    externalForwardedProps: H,
    ownerState: N
  }), [W, Q] = Ke("selectLabel", {
    className: M.selectLabel,
    elementType: NN,
    externalForwardedProps: H,
    ownerState: N,
    additionalProps: {
      id: F
    }
  }), [G, V] = Ke("select", {
    className: M.select,
    elementType: MN,
    externalForwardedProps: H,
    ownerState: N
  }), [U, Z] = Ke("menuItem", {
    className: M.menuItem,
    elementType: T,
    externalForwardedProps: H,
    ownerState: N
  }), [te, ie] = Ke("displayedRows", {
    className: M.displayedRows,
    elementType: AN,
    externalForwardedProps: H,
    ownerState: N
  });
  return /* @__PURE__ */ O(ee, L(C({}, X), {
    children: /* @__PURE__ */ fe(k, L(C({}, $), {
      children: [/* @__PURE__ */ O(Y, C({}, K)), _.length > 1 && /* @__PURE__ */ O(W, L(C({}, Q), {
        children: f
      })), _.length > 1 && /* @__PURE__ */ O(G, L(C(L(C(L(C({
        variant: "standard"
      }, !A.variant && {
        input: Bh || (Bh = /* @__PURE__ */ O(il, {}))
      }), {
        value: S,
        onChange: m,
        id: j,
        labelId: F
      }), A), {
        classes: L(C({}, A.classes), {
          // TODO v5 remove `classes.input`
          root: xe(M.input, M.selectRoot, (A.classes || {}).root),
          select: xe(M.select, (A.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: xe(M.selectIcon, (A.classes || {}).icon)
        }),
        disabled: l
      }), V), {
        children: _.map((q) => /* @__PURE__ */ yC(U, L(C({}, Z), {
          key: q.label ? q.label : q,
          value: q.value ? q.value : q
        }), q.label ? q.label : q))
      })), /* @__PURE__ */ O(te, L(C({}, ie), {
        children: p({
          from: u === 0 ? 0 : v * S + 1,
          to: z(),
          count: u === -1 ? -1 : u,
          page: v
        })
      })), /* @__PURE__ */ O(o, {
        className: M.actions,
        backIconButtonProps: i,
        count: u,
        nextIconButtonProps: h,
        onPageChange: g,
        page: v,
        rowsPerPage: S,
        showFirstButton: b,
        showLastButton: y,
        slotProps: w.actions,
        slots: x.actions,
        getItemAriaLabel: d,
        disabled: l
      })]
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Ob.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: c.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: c.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  colSpan: c.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: bn.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: c.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: c.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: c.node,
  /**
   * Props applied to the next arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: c.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: c.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: c.func,
  /**
   * The zero-based index of the current page.
   */
  page: Vn(bn.isRequired, (e) => {
    const {
      count: t,
      page: n,
      rowsPerPage: r
    } = e;
    if (t === -1)
      return null;
    const o = Math.max(0, Math.ceil(t / r) - 1);
    return n < 0 || n > o ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${o}, but page is ${n}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: bn.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: c.arrayOf(c.oneOfType([c.number, c.shape({
    label: c.string.isRequired,
    value: c.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](https://mui.com/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: c.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: c.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: c.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    actions: c.shape({
      firstButton: c.object,
      firstButtonIcon: c.object,
      lastButton: c.object,
      lastButtonIcon: c.object,
      nextButton: c.object,
      nextButtonIcon: c.object,
      previousButton: c.object,
      previousButtonIcon: c.object
    }),
    displayedRows: c.oneOfType([c.func, c.object]),
    menuItem: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object]),
    select: c.object,
    selectLabel: c.oneOfType([c.func, c.object]),
    spacer: c.oneOfType([c.func, c.object]),
    toolbar: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    actions: c.shape({
      firstButton: c.elementType,
      firstButtonIcon: c.elementType,
      lastButton: c.elementType,
      lastButtonIcon: c.elementType,
      nextButton: c.elementType,
      nextButtonIcon: c.elementType,
      previousButton: c.elementType,
      previousButtonIcon: c.elementType
    }),
    displayedRows: c.elementType,
    menuItem: c.elementType,
    root: c.elementType,
    select: c.elementType,
    selectLabel: c.elementType,
    spacer: c.elementType,
    toolbar: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const BN = Ob, FN = () => {
  var e;
  const t = (e = document.head.querySelector('meta[property="csp-nonce"]')) == null ? void 0 : e.getAttribute("content");
  return t ? oy({
    key: "css",
    nonce: t
  }) : null;
}, Po = ({ children: e }) => {
  const t = wd(() => FN(), []);
  return t ? /* @__PURE__ */ O(ry, { value: t, children: e }) : /* @__PURE__ */ O(xo, { children: e });
};
var dc = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Fh;
function zN() {
  return Fh || (Fh = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (i = o(i, r(a)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var s = "";
        for (var a in i)
          t.call(i, a) && i[a] && (s = o(s, a));
        return s;
      }
      function o(i, s) {
        return s ? i ? i + " " + s : i + s : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(dc)), dc.exports;
}
var jN = zN();
const he = /* @__PURE__ */ Pr(jN);
(function() {
  var e;
  try {
    if (typeof document < "u") {
      var t = document.createElement("style");
      t.nonce = (e = document.head.querySelector("meta[property=csp-nonce]")) == null ? void 0 : e.content, t.appendChild(document.createTextNode('.DEPRECATED_Icon-module__clickable___Wc4h2{cursor:pointer}.DEPRECATED_Icon-module__disabled___WZlIY{pointer-events:none}.CheckableList-module__item___Hs9v4{margin-bottom:12px;cursor:pointer;height:18px;-webkit-user-select:none;user-select:none}.CheckableList-module__item___Hs9v4:last-child{margin-bottom:0}.CheckableList-module__item___Hs9v4 .CheckableList-module__icon___1KLyd{margin-top:-3px}.sis-scope .btn--dark .btn__text{padding:5px 20px}.sis-scope .btn--gray{background:#f4f4f8}.sis-scope .btn--gray:disabled{background:#f4f4f8;opacity:1}.sis-scope .btn--gray:disabled:hover{background:#d1d1d7}.sis-scope .btn--gray:disabled .app-icon,.sis-scope .btn--gray:disabled .btn__text{opacity:.4}.sis-scope .DEPRECATED_Button-module__sharedComponentsButton___wmUpf{line-height:18px}.sis-scope .DEPRECATED_Button-module__sharedComponentsButtonText___CsYPy{padding:5px 20px}.sis-scope .btn.DEPRECATED_Button-module__btnSecondary___Ga6J-{border:1px solid #5b6372;background-color:#fff}.sis-scope .btn.DEPRECATED_Button-module__btnSecondary___Ga6J-:hover{background-color:#f4f4f8}.sis-scope .btn.DEPRECATED_Button-module__btnSecondary___Ga6J-:disabled{background-color:#fff}.sis-scope .btn.DEPRECATED_Button-module__btnSecondary___Ga6J-:disabled:hover{background-color:#fff}.sis-scope .custom-checkbox__icon.app-icon.Checkbox-module__transparent___wi79A{background:transparent!important;color:transparent}.sis-scope .custom-checkbox__input:checked+.custom-checkbox__icon.Checkbox-module__transparent___wi79A{color:#3a4356}.sis-scope .custom-checkbox__text{padding-left:4px}.Checkbox-module__icon___Hm4xR{margin:0 -5px 0 0;cursor:pointer}.Checkbox-module__disabled___sHRTv{pointer-events:none}.Checkbox-module__disabled___sHRTv .custom-checkbox__text{color:#5b637266}.Checkbox-module__disabled___sHRTv .app-icon{opacity:.4}.Checkbox-module__sharedComponentsInputCheckbox___VU8jI{width:28px;height:28px;padding:8px}.Checkbox-module__sharedComponentsInputCheckbox___VU8jI:hover{background-color:#5b63721a;border-radius:50%}@keyframes DEPRECATED_Tooltip-module__rcToolTipZoomIn___0ddOq{0%{opacity:0;transform-origin:50% 50%;transform:scale(0)}to{opacity:1;transform-origin:50% 50%;transform:scale(1)}}@keyframes DEPRECATED_Tooltip-module__rcToolTipZoomOut___kpbOG{0%{opacity:1;transform-origin:50% 50%;transform:scale(1)}to{opacity:0;transform-origin:50% 50%;transform:scale(0)}}.rc-tooltip-inner{padding:6px 12px;min-height:0;border:0;border-radius:4px;pointer-events:none;color:red;font-size:14px}.rc-tooltip-arrow{border-width:0!important;width:8px;height:8px;background-color:#000;z-index:-1;transform:rotate(45deg)}.rc-tooltip-content:before{content:"";position:absolute;width:8px;height:8px;background-color:#000;transform:rotate(45deg)}.DEPRECATED_Tooltip-module__breakLongWord___kWwu0{word-break:break-all}.LazyLoader-module__loader___Cvl1N{display:flex;align-content:center;justify-content:center;align-items:center}.LazyLoader-module__loader___Cvl1N .LazyLoader-module__caption___fA3Vm{margin-top:50%;word-break:break-word;text-align:center}.LazyLoader-module__loader___Cvl1N .LazyLoader-module__caption___fA3Vm span{position:unset}.Popover-module__popover___39yjG .rc-tooltip-inner{pointer-events:auto;overflow:hidden}.Popover-module__popoverMask___4ZLl9{position:fixed;width:100%;height:100%;top:0;bottom:0}.RadioButton-module__sharedComponentsInputRadioButton___fIOZu{width:28px;height:28px;padding:8px}.RadioButton-module__sharedComponentsInputRadioButton___fIOZu:hover{background-color:#5b63721a;border-radius:50%}.sis-scope .custom-radiobtn__text{padding-left:4px}.RadioButton-module__disabled___jMV-0{pointer-events:none}.RadioButton-module__disabled___jMV-0 .custom-radiobtn__text{color:#5b637266}[data-simplebar]{position:relative;flex-direction:column;flex-wrap:wrap;justify-content:flex-start;align-content:flex-start;align-items:flex-start}.simplebar-wrapper{overflow:hidden;width:inherit;height:inherit;max-width:inherit;max-height:inherit}.simplebar-mask{direction:inherit;position:absolute;overflow:hidden;padding:0;margin:0;left:0;top:0;bottom:0;right:0;width:auto!important;height:auto!important;z-index:0}.simplebar-offset{direction:inherit!important;box-sizing:inherit!important;resize:none!important;position:absolute;top:0;left:0;bottom:0;right:0;padding:0;margin:0;-webkit-overflow-scrolling:touch}.simplebar-content-wrapper{direction:inherit;box-sizing:border-box!important;position:relative;display:block;height:100%;width:auto;max-width:100%;max-height:100%;overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.simplebar-content-wrapper::-webkit-scrollbar,.simplebar-hide-scrollbar::-webkit-scrollbar{display:none;width:0;height:0}.simplebar-content:after,.simplebar-content:before{content:" ";display:table}.simplebar-placeholder{max-height:100%;max-width:100%;width:100%;pointer-events:none}.simplebar-height-auto-observer-wrapper{box-sizing:inherit!important;height:100%;width:100%;max-width:1px;position:relative;float:left;max-height:1px;overflow:hidden;z-index:-1;padding:0;margin:0;pointer-events:none;flex-grow:inherit;flex-shrink:0;flex-basis:0}.simplebar-height-auto-observer{box-sizing:inherit;display:block;opacity:0;position:absolute;top:0;left:0;height:1000%;width:1000%;min-height:1px;min-width:1px;overflow:hidden;pointer-events:none;z-index:-1}.simplebar-track{z-index:1;position:absolute;right:0;bottom:0;pointer-events:none;overflow:hidden}[data-simplebar].simplebar-dragging,[data-simplebar].simplebar-dragging .simplebar-content{pointer-events:none;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[data-simplebar].simplebar-dragging .simplebar-track{pointer-events:all}.simplebar-scrollbar{position:absolute;left:0;right:0;min-height:10px}.simplebar-scrollbar:before{position:absolute;content:"";background:#000;border-radius:7px;left:2px;right:2px;opacity:0;transition:opacity .2s .5s linear}.simplebar-scrollbar.simplebar-visible:before{opacity:.5;transition-delay:0s;transition-duration:0s}.simplebar-track.simplebar-vertical{top:0;width:11px}.simplebar-scrollbar:before{top:2px;bottom:2px;left:2px;right:2px}.simplebar-track.simplebar-horizontal{left:0;height:11px}.simplebar-track.simplebar-horizontal .simplebar-scrollbar{right:auto;left:0;top:0;bottom:0;min-height:0;min-width:10px;width:auto}[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical{right:auto;left:0}.simplebar-dummy-scrollbar-size{direction:rtl;position:fixed;opacity:0;visibility:hidden;height:500px;width:500px;overflow-y:hidden;overflow-x:scroll;-ms-overflow-style:scrollbar!important}.simplebar-dummy-scrollbar-size>div{width:200%;height:200%;margin:10px 0}.simplebar-hide-scrollbar{position:fixed;left:0;visibility:hidden;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none}.Confirmation-module__container___45eSd{min-width:245px;max-width:350px;padding:12px 18px;font-size:13px;-webkit-user-select:none;user-select:none}.Confirmation-module__message___4r1SC{margin-top:10px;overflow:hidden;white-space:pre-line;text-overflow:ellipsis}.Confirmation-module__buttons___QYVqm{margin-top:19px;width:100%;text-align:right}.Confirmation-module__button___gJmIL{height:25px;width:auto;background:transparent;outline:none;cursor:pointer;border:none}.Confirmation-module__button___gJmIL:hover{opacity:.7}.Confirmation-module__confirm___DqtMv{color:green;margin-right:20px}.Confirmation-module__cancel___3CIW9{color:red}.Menu-module__container___KGp0N{min-width:128px;position:absolute;cursor:pointer;padding:0;background:#fff;box-shadow:0 0 5px #3a435633;border-radius:4px}.Menu-module__container___KGp0N li{list-style-type:none;line-height:22px;display:flex;justify-content:flex-start;align-items:center;padding:4px 5px;position:relative;transition:background-color .3s eaSe;cursor:pointer}.Menu-module__container___KGp0N li.Menu-module__disabled___xdT-F{opacity:.5;cursor:default}.Menu-module__container___KGp0N li.Menu-module__groupHeader___-d7MT{pointer-events:none;font-style:italic;font-weight:600}.Menu-module__container___KGp0N li.Menu-module__isDrill___6OfQP:hover,.Menu-module__container___KGp0N li.Menu-module__isDrill___6OfQP.fakeHover{background-color:#f4f4f8}.Menu-module__container___KGp0N li:hover:not(.Menu-module__disabled___xdT-F){background-color:#f4f4f8}.Menu-module__container___KGp0N li:hover:not(.Menu-module__disabled___xdT-F):after{opacity:1}.Menu-module__container___KGp0N li.Menu-module__separator___OQ--M{border-top:1px solid #e1e1e1}.Menu-module__container___KGp0N li.Menu-module__noIcon___MYkPf{padding-left:16px;padding-right:16px}.Menu-module__container___KGp0N li.Menu-module__item___nmDUr.Menu-module__checked___6OJEB:after{content:"";display:block;position:absolute;top:0;left:0;height:100%;width:2px;background-color:#3a4356}.Menu-module__container___KGp0N li.Menu-module__radio___OlxcQ{padding-left:8px;padding-right:0;line-height:22px;align-items:stretch}.Menu-module__container___KGp0N li.Menu-module__checkbox___HocC7{padding-left:0;padding-right:0;line-height:22px;align-items:stretch}.Menu-module__container___KGp0N li .Menu-module__icon___ZxKUL{margin:0 10px 0 7px}.Menu-module__container___KGp0N li .Menu-module__itemType___VLiEZ{display:flex;width:100%;margin-right:1px;white-space:nowrap}.Menu-module__container___KGp0N li .Menu-module__itemType___VLiEZ :last-child{margin-left:auto}.Menu-module__container___KGp0N li .Menu-module__nestedType___gayzp{display:flex;width:100%}.Menu-module__container___KGp0N li .Menu-module__nestedType___gayzp .Menu-module__nestedIcon___VyPyZ{position:static!important}.Menu-module__container___KGp0N li .Menu-module__menuItemText___agoSf{flex-grow:1;display:flex;align-items:center}.Menu-module__separateGroup___0J5WE{min-width:fit-content}.Menu-module__itemCheckBox___2DHy4{padding:0 5px 0 16px;width:100%}.Menu-module__itemRadioButton___h2ifs{padding:0 5px 0 8px;width:100%}.Menu-module__scrollbar___li1b-{cursor:default}.Menu-module__scrollbar___li1b->div:first-child{position:relative!important}.Menu-module__itemContainer___m0XPy{display:flex;flex-grow:1}.Menu-module__inlineConfirmation___0JCIX{font-weight:600}.Menu-module__menuItemTooltip___5jA0S{max-width:180px;overflow-wrap:break-word}.Menu-module__menuItemTooltip___5jA0S.rc-tooltip-placement-left{max-width:195px;padding-right:15px}.Menu-module__toggleButtonMenu___qwLCQ{pointer-events:none;position:absolute;top:50%;transform:translateY(-50%);right:10px}.Menu-module__loader___pzNnL{height:25px;position:relative;margin:0 auto;width:90%}.Input-module__component___4OcHW{position:relative;display:flex;align-items:center}.Input-module__component___4OcHW .Input-module__searchIcon___aQP42.Input-module__searchIcon___aQP42{position:absolute;left:8px;z-index:1;opacity:40%}.Input-module__component___4OcHW .Input-module__searchIcon___aQP42.Input-module__searchIcon___aQP42.Input-module__large___BPwgK{top:4px}.Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot{width:15px;height:15px;position:absolute;top:3px;right:4px;border-radius:20px;padding:4px}.Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot:hover{background-color:#d1d1d7}.Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot.Input-module__clearIconHidden___gPP7c{display:none}.Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot.Input-module__large___BPwgK{width:15px;height:15px;top:4px;padding:5px}.Input-module__component___4OcHW .Input-module__passwordVisibilityIcon___mrN83.Input-module__passwordVisibilityIcon___mrN83{width:24px;height:24px;position:absolute;right:8px}.Input-module__component___4OcHW .Input-module__passwordVisibilityIcon___mrN83.Input-module__passwordVisibilityIcon___mrN83.Input-module__large___BPwgK{width:24px;height:24px;top:5px}.Input-module__component___4OcHW .Input-module__customIcon___5KikU{position:absolute;top:3px;right:4px}.Input-module__component___4OcHW .Input-module__customIcon___5KikU.Input-module__isLeft___uqdwf{right:0;left:8px}.Input-module__component___4OcHW .Input-module__customIcon___5KikU.Input-module__large___BPwgK{top:5px}.Input-module__component___4OcHW .Input-module__input___js3cI{border-radius:4px;outline:none;background:#f4f4f8;line-height:28px;height:28px;border:none;text-indent:8px;width:100%}.Input-module__component___4OcHW .Input-module__input___js3cI.Input-module__withLeftIcon___BgCVf{text-indent:32px}.Input-module__component___4OcHW .Input-module__input___js3cI::placeholder{color:#b0b5bf}.Input-module__component___4OcHW .Input-module__input___js3cI:focus{border:1px solid #5b6372}.Input-module__component___4OcHW .Input-module__input___js3cI.Input-module__large___BPwgK{height:34px;line-height:34px}.Input-module__component___4OcHW .Input-module__input___js3cI::-ms-reveal{display:none}.sis-scope .Input-module__component___4OcHW{position:relative;display:flex;align-items:center}.sis-scope .Input-module__component___4OcHW .Input-module__searchIcon___aQP42.Input-module__searchIcon___aQP42{position:absolute;left:8px;z-index:1;opacity:40%}.sis-scope .Input-module__component___4OcHW .Input-module__searchIcon___aQP42.Input-module__searchIcon___aQP42.Input-module__large___BPwgK{top:4px}.sis-scope .Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot{width:15px;height:15px;position:absolute;top:3px;right:4px;border-radius:20px;padding:4px}.sis-scope .Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot:hover{background-color:#d1d1d7}.sis-scope .Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot.Input-module__clearIconHidden___gPP7c{display:none}.sis-scope .Input-module__component___4OcHW .Input-module__clearIcon___ihSot.Input-module__clearIcon___ihSot.Input-module__large___BPwgK{width:15px;height:15px;top:4px;padding:5px}.sis-scope .Input-module__component___4OcHW .Input-module__passwordVisibilityIcon___mrN83.Input-module__passwordVisibilityIcon___mrN83{width:24px;height:24px;position:absolute;right:8px}.sis-scope .Input-module__component___4OcHW .Input-module__passwordVisibilityIcon___mrN83.Input-module__passwordVisibilityIcon___mrN83.Input-module__large___BPwgK{width:24px;height:24px;top:5px}.sis-scope .Input-module__component___4OcHW .Input-module__customIcon___5KikU{position:absolute;top:3px;right:4px}.sis-scope .Input-module__component___4OcHW .Input-module__customIcon___5KikU.Input-module__isLeft___uqdwf{right:0;left:8px}.sis-scope .Input-module__component___4OcHW .Input-module__customIcon___5KikU.Input-module__large___BPwgK{top:5px}.sis-scope .Input-module__component___4OcHW .Input-module__input___js3cI{border-radius:4px;outline:none;background:#f4f4f8;line-height:28px;height:28px;border:none;text-indent:8px;width:100%}.sis-scope .Input-module__component___4OcHW .Input-module__input___js3cI.Input-module__withLeftIcon___BgCVf{text-indent:32px}.sis-scope .Input-module__component___4OcHW .Input-module__input___js3cI::placeholder{color:#b0b5bf}.sis-scope .Input-module__component___4OcHW .Input-module__input___js3cI:focus{border:1px solid #5b6372}.sis-scope .Input-module__component___4OcHW .Input-module__input___js3cI.Input-module__large___BPwgK{height:34px;line-height:34px}.sis-scope .Input-module__component___4OcHW .Input-module__input___js3cI::-ms-reveal{display:none}.Dropdown-module__menu___u8qzp{margin:0;position:initial;box-shadow:none}.Dropdown-module__menu___u8qzp li{padding:0 5px;height:28px}.DropdownButton-module__dropdownButton___oc3-H{display:inline-flex;align-items:center;cursor:pointer;background:#f4f4f8;border-radius:4px;height:28px;min-width:192px}.DropdownButton-module__dropdownButton___oc3-H.DropdownButton-module__inlineVariant___WSkxA{background:none;height:18px;border:none;text-indent:0;min-width:initial}.DropdownButton-module__dropdownButton___oc3-H.DropdownButton-module__inlineVariant___WSkxA.DropdownButton-module__open___bh-yG{border:none}.DropdownButton-module__dropdownButton___oc3-H.DropdownButton-module__open___bh-yG{border:1px solid #5b6372}.DropdownButton-module__dropdownButton___oc3-H.DropdownButton-module__disabled___I9nuu{color:#bdc1c7;background:#f4f4f8;pointer-events:none}.DropdownButton-module__dropdownButton___oc3-H .DropdownButton-module__selectedIcon___hIp5j{flex-shrink:0}.DropdownButton-module__dropdownButton___oc3-H .DropdownButton-module__chosenTitle___AgQJR{margin-left:12px;flex-grow:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.DropdownButton-module__dropdownButton___oc3-H .DropdownButton-module__clickIcon___U2low{flex-shrink:0;margin-right:2px}.DropdownButtonSearch-module__searchInputWrapper___zKFuM div{background:#f4f4f8;border-radius:4px;border:1px solid #5b6372}.DropdownButtonSearch-module__searchInputWrapper___zKFuM div span{margin-left:-6px;z-index:1071!important}.DropdownButtonSearch-module__searchInputWrapper___zKFuM div input{position:relative;z-index:1070;background:transparent;text-indent:0;border:none!important}.rc-tooltip.rc-tooltip-zoom-appear,.rc-tooltip.rc-tooltip-zoom-enter{opacity:0}.rc-tooltip.rc-tooltip-zoom-enter,.rc-tooltip.rc-tooltip-zoom-leave{display:block}.rc-tooltip-zoom-enter,.rc-tooltip-zoom-appear{opacity:0;animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.18,.89,.32,1.28);animation-play-state:paused}.rc-tooltip-zoom-leave{animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.6,-.3,.74,.05);animation-play-state:paused}.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active{animation-name:rcToolTipZoomIn;animation-play-state:running}.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active{animation-name:rcToolTipZoomOut;animation-play-state:running}@keyframes Tooltip-module__rcToolTipZoomIn___Qwshk{0%{opacity:0;transform-origin:50% 50%;transform:scale(0)}to{opacity:1;transform-origin:50% 50%;transform:scale(1)}}@keyframes Tooltip-module__rcToolTipZoomOut___p2GXV{0%{opacity:1;transform-origin:50% 50%;transform:scale(1)}to{opacity:0;transform-origin:50% 50%;transform:scale(0)}}.rc-tooltip{position:absolute;z-index:1070;display:block;visibility:visible;line-height:1.5;font-size:12px;background-color:#0000000d;padding:1px;opacity:.9}.rc-tooltip-hidden{display:none}.rc-tooltip-inner{padding:8px 10px;color:#333;text-align:left;text-decoration:none;background-color:#fff;border-radius:3px;min-height:34px;border:1px solid #b1b1b1}.rc-tooltip-arrow,.rc-tooltip-arrow-inner{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.rc-tooltip-placement-top .rc-tooltip-arrow,.rc-tooltip-placement-topLeft .rc-tooltip-arrow,.rc-tooltip-placement-topRight .rc-tooltip-arrow{transform:translate(-50%,5px);margin-left:-6px;border-width:6px 6px 0;border-top-color:#b1b1b1}.rc-tooltip-placement-top .rc-tooltip-arrow-inner,.rc-tooltip-placement-topLeft .rc-tooltip-arrow-inner,.rc-tooltip-placement-topRight .rc-tooltip-arrow-inner{bottom:1px;margin-left:-6px;border-width:6px 6px 0;border-top-color:#fff}.rc-tooltip-placement-top .rc-tooltip-arrow{left:50%}.rc-tooltip-placement-topLeft .rc-tooltip-arrow{left:15%}.rc-tooltip-placement-topRight .rc-tooltip-arrow{right:15%}.rc-tooltip-placement-right .rc-tooltip-arrow,.rc-tooltip-placement-rightTop .rc-tooltip-arrow,.rc-tooltip-placement-rightBottom .rc-tooltip-arrow{left:-5px;margin-top:-6px;border-width:6px 6px 6px 0;border-right-color:#b1b1b1;transform:translate(calc(-100% + 1px))}.rc-tooltip-placement-right .rc-tooltip-arrow-inner,.rc-tooltip-placement-rightTop .rc-tooltip-arrow-inner,.rc-tooltip-placement-rightBottom .rc-tooltip-arrow-inner{left:1px;margin-top:-6px;border-width:6px 6px 6px 0;border-right-color:#fff}.rc-tooltip-placement-right .rc-tooltip-arrow{top:50%}.rc-tooltip-placement-rightTop .rc-tooltip-arrow{top:15%;margin-top:0}.rc-tooltip-placement-rightBottom .rc-tooltip-arrow{bottom:15%}.rc-tooltip-placement-left .rc-tooltip-arrow,.rc-tooltip-placement-leftTop .rc-tooltip-arrow,.rc-tooltip-placement-leftBottom .rc-tooltip-arrow{right:-5px;margin-top:-6px;border-width:6px 0 6px 6px;border-left-color:#b1b1b1;transform:translate(calc(100% - 1px))}.rc-tooltip-placement-left .rc-tooltip-arrow-inner,.rc-tooltip-placement-leftTop .rc-tooltip-arrow-inner,.rc-tooltip-placement-leftBottom .rc-tooltip-arrow-inner{right:1px;margin-top:-6px;border-width:6px 0 6px 6px;border-left-color:#fff}.rc-tooltip-placement-left .rc-tooltip-arrow{top:50%}.rc-tooltip-placement-leftTop .rc-tooltip-arrow{top:15%;margin-top:0}.rc-tooltip-placement-leftBottom .rc-tooltip-arrow{bottom:15%}.rc-tooltip-placement-bottom .rc-tooltip-arrow,.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,.rc-tooltip-placement-bottomRight .rc-tooltip-arrow{transform:translate(-50%,-5px);margin-left:-6px;border-width:0 6px 6px;border-bottom-color:#b1b1b1}.rc-tooltip-placement-bottom .rc-tooltip-arrow-inner,.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow-inner,.rc-tooltip-placement-bottomRight .rc-tooltip-arrow-inner{top:1px;margin-left:-6px;border-width:0 6px 6px;border-bottom-color:#fff}.rc-tooltip-placement-bottom .rc-tooltip-arrow{left:50%}.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow{left:15%}.rc-tooltip-placement-bottomRight .rc-tooltip-arrow{right:15%}.rc-tooltip{padding:0;background-color:transparent;opacity:1}.rc-tooltip.hide-arrow .rc-tooltip-arrow,.rc-tooltip.hide-arrow .rc-tooltip-content:before{display:none}.rc-tooltip.hide-arrow.rc-tooltip-placement-top,.rc-tooltip.hide-arrow.rc-tooltip-placement-bottom,.rc-tooltip.hide-arrow.rc-tooltip-placement-left,.rc-tooltip.hide-arrow.rc-tooltip-placement-right,.rc-tooltip.hide-arrow .rc-tooltip-inner{padding:0}.rc-tooltip-content{position:relative}.rc-tooltip-inner{padding:6px 12px;min-height:0;border:0;border-radius:4px;box-shadow:0 -1px 5px 1px #3a435633;pointer-events:none;color:#7f899c;font-size:13px}.rc-tooltip-arrow{border-width:0!important;width:8px;height:8px;background-color:#fff;box-shadow:0 -1px 5px 1px #3a435633;z-index:-1;transform:rotate(45deg)}.rc-tooltip-placement-right .rc-tooltip-arrow,.rc-tooltip-placement-rightTop .rc-tooltip-arrow,.rc-tooltip-placement-rightBottom .rc-tooltip-arrow{transform:rotate(45deg)}.rc-tooltip-content:before{content:"";position:absolute;width:8px;height:8px;background-color:#fff;transform:rotate(45deg)}.rc-tooltip-placement-top{padding-bottom:6px}.rc-tooltip-placement-top .rc-tooltip-arrow,.rc-tooltip-placement-top .rc-tooltip-content:before{left:50%;margin-left:-4px;bottom:-4px}.rc-tooltip-placement-bottom{padding-top:6px}.rc-tooltip-placement-bottom .rc-tooltip-arrow,.rc-tooltip-placement-bottom .rc-tooltip-content:before{left:50%;margin-left:-4px;top:-4px}.rc-tooltip-placement-right{padding-left:6px}.rc-tooltip-placement-right .rc-tooltip-arrow,.rc-tooltip-placement-right .rc-tooltip-content:before{top:50%;margin-top:-4px;left:-4px}.rc-tooltip-placement-left{padding-right:6px}.rc-tooltip-placement-left .rc-tooltip-arrow,.rc-tooltip-placement-left .rc-tooltip-content:before{top:50%;margin-top:-4px;right:-4px}.Tooltip-module__breakLongWord___ToaxI{word-break:break-all}.Tooltip-module__semanticText___VRqnW{max-width:432px}.sis-scope.Tooltip-module__tooltip___iGDQF{padding:12px 16px}')), document.head.appendChild(t);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
const gt = {
  StTextColors: {
    active: "rgba(38, 46, 61, 1)",
    content: "rgba(38, 46, 61, 0.8)",
    secondary: "rgba(38, 46, 61, 0.55)",
    link: "rgba(54, 163, 217, 1)",
    accented: "rgba(12, 14, 18, 1)",
    disabled: "rgba(38, 46, 61, 0.3)"
  },
  StTextColorsDark: {
    active: "rgba(235, 239, 247, 1)",
    content: "rgba(235, 239, 247, 0.8)",
    secondary: "rgba(235, 239, 247, 0.55)",
    disabled: "rgba(235, 239, 247, 0.3)",
    accented: "rgba(255, 255, 255, 1)"
  },
  StUiColors: {
    default: "rgba(38, 46, 61, 0.67)",
    additional: "rgba(38, 46, 61, 0.4)",
    guiding: "rgba(38, 46, 61, 0.1)"
  },
  StUiColorsDark: {
    default: "rgba(235, 239, 247, 0.67)",
    additional: "rgba(235, 239, 247, 0.35)",
    guiding: "rgba(235, 239, 247, 0.17)"
  },
  StBackgroundColors: {
    workspace: "#FFFFFF",
    supporting: "#F9F9FB",
    priority: "#F4F4F8",
    themeAgnostic: "rgba(174, 174, 180, 0.3)"
  },
  StBackgroundColorsDark: {
    workspace: "rgba(20, 21, 23, 1)",
    supporting: "rgba(10, 10, 11, 1)",
    priority: "rgba(9, 9, 10, 1)"
  },
  StPrimaryColors: {
    primary: "#FFC805"
  },
  StInteractionColors: {
    defaultHover: "rgba(12, 14, 18, 0.07)",
    guidingHover: "rgba(38, 46, 61, 0.17)",
    linkHovered: "rgba(50, 147, 197, 1)",
    primaryHovered: "rgba(242, 185, 0, 1)"
  },
  StInteractionColorsDark: {
    defaultHover: "rgba(255, 255, 255, 0.15)",
    guidingHover: "rgba(235, 239, 247, 0.17)",
    linkHovered: "rgba(54, 163, 217, 1)"
  },
  StSemanticColors: {
    info: "rgba(52, 150, 200, 1)",
    success: "rgba(34, 195, 195, 1)",
    warning: "rgba(242, 185, 0, 1)",
    error: "rgba(231, 71, 39, 1)",
    infoBG: "rgba(52, 150, 200, 0.1)",
    successBG: "rgba(34, 195, 195, 0.1)",
    warningBG: "rgba(242, 185, 0, 0.1)",
    errorBG: "rgba(231, 71, 39, 0.1)"
  }
}, HN = {
  Shadows: {
    level1: "0px 1px 2px rgba(9, 9, 10, 0.1), 0px 2px 4px rgba(9, 9, 10, 0.1)",
    level2: "drop-shadow(0px 1px 4px rgba(9, 9, 10, 0.1)) drop-shadow(0px 1px 8px rgba(9, 9, 10, 0.15))"
  }
}, WN = cr({
  components: {
    MuiIcon: {
      styleOverrides: {
        root: {
          color: `${gt.StPrimaryColors.primary}`,
          top: 0
        }
      }
    },
    MuiSvgIcon: {
      // styleOverrides: {
      //     root: {
      //         fill: utils.makeASlightlyDifferentColor(
      //             themeService.getDesignSettings().typography.primaryTextColor,
      //             0.9,
      //         ),
      //     },
      // },
    }
  }
}), VN = (e) => {
  const { name: t, sx: n } = e, r = he("app-icon__svg");
  return /* @__PURE__ */ fe(Uu, { classes: { root: r }, sx: n, inheritViewBox: !0, children: [
    /* @__PURE__ */ O("use", { xlinkHref: `#${t}` }),
    /* @__PURE__ */ O("symbol", { id: "general-arrow-big-down", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M7.589 10L7 10.777 11.99 15 17 10.777 16.413 10l-4.422 3.727z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-arrow-left", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M13.878 9.325a.5.5 0 1 0-.76-.65l-2.998 3.5a.5.5 0 0 0 0 .65l2.999 3.5a.5.5 0 1 0 .76-.65l-2.72-3.175 2.72-3.175z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-arrow-long-right", viewBox: "0 0 29 8", children: /* @__PURE__ */ O(
      "path",
      {
        d: "M28.354 4.354a.5.5 0 0 0 0-.708L25.172.464a.5.5 0 1 0-.707.708L27.293 4l-2.828 2.828a.5.5 0 1 0 .707.708l3.182-3.182zM0 4.5h28v-1H0v1z",
        fill: "#3A4356"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-arrow-right", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M13.34 12.5l-2.72-3.175a.5.5 0 1 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-arrow-up", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M12 10.16l-3.174 2.719a.5.5 0 0 1-.65-.76l3.5-2.998a.5.5 0 0 1 .65 0l3.5 2.998a.5.5 0 1 1-.65.76L12 10.159z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-arrow-up-down", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M15.646 14.646a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L12 18.293l3.646-3.647zm0-5.292L12 5.707 8.354 9.354a.5.5 0 1 1-.708-.708l4-4a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-double-arrow-back", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M9.658 12.5l2.72 3.175a.5.5 0 1 1-.76.65l-2.998-3.5a.5.5 0 0 1 0-.65l2.999-3.5a.5.5 0 1 1 .76.65L9.658 12.5zm5.719-3.175l-2.72 3.175 2.72 3.175a.5.5 0 1 1-.76.65l-2.998-3.5a.5.5 0 0 1 0-.65l2.998-3.5a.5.5 0 1 1 .76.65z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-double-arrow-front", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M11.34 12.5L8.62 9.325a.5.5 0 0 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175zm.279-3.175a.5.5 0 0 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.999 3.5a.5.5 0 1 1-.76-.65l2.72-3.175-2.72-3.175z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-double-big-arrow-back", viewBox: "0 0 31 31", children: /* @__PURE__ */ fe("g", { fill: "currentColor", children: [
      /* @__PURE__ */ O("path", { d: "M16 11.825l-3.842 4.297 3.662 4.087a.5.5 0 1 1-.76.65l-3.94-4.412a.5.5 0 0 1 0-.65l4.12-4.622a.5.5 0 1 1 .76.65zm5 0l-3.842 4.297 3.662 4.087a.5.5 0 1 1-.76.65l-3.94-4.412a.5.5 0 0 1 0-.65l4.12-4.622a.5.5 0 1 1 .76.65z" }),
      /* @__PURE__ */ O("path", { d: "M10 11.5a.5.5 0 0 1 1 0v9a.5.5 0 0 1-1 0v-9z" })
    ] }) }),
    /* @__PURE__ */ O("symbol", { id: "general-double-big-arrow-front", viewBox: "0 0 31 31", children: /* @__PURE__ */ fe("g", { fill: "currentColor", children: [
      /* @__PURE__ */ O("path", { d: "M15 20.175l3.842-4.297-3.662-4.087a.5.5 0 1 1 .76-.65l3.94 4.412a.5.5 0 0 1 0 .65l-4.12 4.622a.5.5 0 1 1-.76-.65zm-5 0l3.842-4.297-3.662-4.087a.5.5 0 1 1 .76-.65l3.94 4.412a.5.5 0 0 1 0 .65l-4.12 4.622a.5.5 0 1 1-.76-.65z" }),
      /* @__PURE__ */ O("path", { d: "M21 20.5a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 1 0v9z" })
    ] }) }),
    /* @__PURE__ */ O("symbol", { id: "general-x", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M12 12.293L6.854 7.146a.5.5 0 1 0-.708.708L11.293 13l-5.147 5.146a.5.5 0 0 0 .708.708L12 13.707l5.146 5.147a.5.5 0 0 0 .708-.708L12.707 13l5.147-5.146a.5.5 0 0 0-.708-.708L12 12.293z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "header-doc", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M14 5.562V10h3.698L14 5.562zM18 11h-5V5H7a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8zm1-1v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h7l5 6zm-7 5.84l3.174-2.719a.5.5 0 0 1 .65.76l-3.5 2.998a.5.5 0 0 1-.65 0l-3.5-2.998a.5.5 0 1 1 .65-.76L12 15.841z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-arrow-down", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M12 13.84l3.174-2.719a.5.5 0 0 1 .65.76l-3.5 2.998a.5.5 0 0 1-.65 0l-3.5-2.998a.5.5 0 1 1 .65-.76L12 13.841z"
      }
    ) }),
    /* @__PURE__ */ O("symbol", { id: "general-plus", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
      "path",
      {
        fill: "currentColor",
        d: "M12 12V7.5a.5.5 0 1 0-1 0V12H6.5a.5.5 0 1 0 0 1H11v4.5a.5.5 0 1 0 1 0V13h4.5a.5.5 0 1 0 0-1H12z"
      }
    ) })
  ] });
}, io = Bi((e, t) => {
  const { dataTestId: n, name: r, className: o } = e, i = /* @__PURE__ */ O(VN, C({}, e)), s = he("app-icon", `app-icon--${r}`, o);
  return /* @__PURE__ */ O(Po, { children: /* @__PURE__ */ O(Oo, { theme: WN, children: /* @__PURE__ */ O("span", L(C({ "data-testid": n }, e), { ref: t, className: s, children: i })) }) });
}), UN = cr({
  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: "titleHero" },
          style: {
            fontWeight: 600,
            fontSize: 30,
            lineHeight: "36px",
            letterSpacing: -0.5
          }
        },
        {
          props: { variant: "titleBig" },
          style: {
            fontWeight: 400,
            fontSize: 21,
            lineHeight: "24px",
            letterSpacing: -0.2
          }
        },
        {
          props: { variant: "titleMedium" },
          style: {
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "24px"
          }
        },
        {
          props: { variant: "titleSmall" },
          style: {
            fontWeight: 600,
            fontSize: "15px",
            lineHeight: "20px"
          }
        },
        {
          props: { variant: "subTitle" },
          style: {
            fontWeight: 700,
            fontSize: "13px",
            lineHeight: "16px",
            letterSpacing: "0.2px"
          }
        },
        {
          props: { variant: "bodyLabel" },
          style: {
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "16px",
            letterSpacing: "0.1px"
          }
        },
        {
          props: { variant: "laccent" },
          style: {
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "16px",
            letterSpacing: "0.1px"
          }
        },
        {
          props: { variant: "bodyParagraph" },
          style: {
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "18px"
          }
        },
        {
          props: { variant: "paccent" },
          style: {
            fontWeight: 600,
            fontSize: "13px",
            lineHeight: "18px"
          }
        },
        {
          props: { variant: "bodyUI" },
          style: {
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "20px",
            letterSpacing: "0.3px"
          }
        },
        {
          props: { variant: "overline" },
          style: {
            fontWeight: 400,
            fontSize: "11px",
            lineHeight: "16px",
            letterSpacing: "1.5px"
          }
        },
        {
          props: { variant: "caption" },
          style: {
            fontWeight: 700,
            fontSize: "11px",
            lineHeight: "14px",
            letterSpacing: "0.5px"
          }
        },
        {
          props: { variant: "annotation" },
          style: {
            fontWeight: 400,
            fontSize: "11px",
            lineHeight: "16px",
            letterSpacing: "0.3px"
          }
        },
        {
          props: { variant: "code" },
          style: {
            fontFamily: "Hack",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "20px"
          }
        }
      ],
      styleOverrides: {
        root: {
          display: "inline-block",
          fontFamily: "Open Sans",
          color: gt.StTextColors.content,
          "::first-letter": {
            textTransform: "capitalize"
          }
        }
      }
    }
  }
}), Js = Ht.forwardRef(
  (i, o) => {
    var s = i, { children: e, theme: t = UN, dataTestId: n } = s, r = re(s, ["children", "theme", "dataTestId"]);
    return /* @__PURE__ */ O(Po, { children: /* @__PURE__ */ O(Oo, { theme: t, children: /* @__PURE__ */ O(cP, L(C({ ref: o }, r), { "data-testid": n, children: e })) }) });
  }
);
function qN(e) {
  return Ve("MuiPagination", e);
}
Le("MuiPagination", ["root", "ul", "outlined", "text"]);
function GN(e = {}) {
  const N = e, {
    boundaryCount: t = 1,
    componentName: n = "usePagination",
    count: r = 1,
    defaultPage: o = 1,
    disabled: i = !1,
    hideNextButton: s = !1,
    hidePrevButton: a = !1,
    onChange: u,
    page: l,
    showFirstButton: d = !1,
    showLastButton: p = !1,
    siblingCount: f = 1
  } = N, h = re(N, [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
  ]), [g, m] = Pi({
    controlled: l,
    default: o,
    name: n,
    state: "page"
  }), v = (M, A) => {
    l || m(A), u && u(M, A);
  }, S = (M, A) => {
    const T = A - M + 1;
    return Array.from({
      length: T
    }, (D, j) => M + j);
  }, _ = S(1, Math.min(t, r)), R = S(Math.max(r - t + 1, t + 1), r), b = Math.max(
    Math.min(
      // Natural start
      g - f,
      // Lower boundary when page is high
      r - t - f * 2 - 1
    ),
    // Greater than startPages
    t + 2
  ), y = Math.min(
    Math.max(
      // Natural end
      g + f,
      // Upper boundary when page is low
      t + f * 2 + 2
    ),
    // Less than endPages
    r - t - 1
  ), w = [
    ...d ? ["first"] : [],
    ...a ? [] : ["previous"],
    ..._,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...b > t + 2 ? ["start-ellipsis"] : t + 1 < r - t ? [t + 1] : [],
    // Sibling pages
    ...S(b, y),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...y < r - t - 1 ? ["end-ellipsis"] : r - t > t ? [r - t] : [],
    ...R,
    ...s ? [] : ["next"],
    ...p ? ["last"] : []
  ], x = (M) => {
    switch (M) {
      case "first":
        return 1;
      case "previous":
        return g - 1;
      case "next":
        return g + 1;
      case "last":
        return r;
      default:
        return null;
    }
  }, P = w.map((M) => typeof M == "number" ? {
    onClick: (A) => {
      v(A, M);
    },
    type: "page",
    page: M,
    selected: M === g,
    disabled: i,
    "aria-current": M === g ? "page" : void 0
  } : {
    onClick: (A) => {
      v(A, x(M));
    },
    type: M,
    page: x(M),
    selected: !1,
    disabled: i || !M.includes("ellipsis") && (M === "next" || M === "last" ? g >= r : g <= 1)
  });
  return C({
    items: P
  }, h);
}
function KN(e) {
  return Ve("MuiPaginationItem", e);
}
const YN = Le("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), Tt = YN, XN = En(/* @__PURE__ */ O("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), JN = En(/* @__PURE__ */ O("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), Pb = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[n.variant], t[`size${ve(n.size)}`], n.variant === "text" && t[`text${ve(n.color)}`], n.variant === "outlined" && t[`outlined${ve(n.color)}`], n.shape === "rounded" && t.rounded, n.type === "page" && t.page, (n.type === "start-ellipsis" || n.type === "end-ellipsis") && t.ellipsis, (n.type === "previous" || n.type === "next") && t.previousNext, (n.type === "first" || n.type === "last") && t.firstLast];
}, QN = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    selected: o,
    size: i,
    shape: s,
    type: a,
    variant: u
  } = e, l = {
    root: ["root", `size${ve(i)}`, u, s, n !== "standard" && `color${ve(n)}`, n !== "standard" && `${u}${ve(n)}`, r && "disabled", o && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[a]],
    icon: ["icon"]
  };
  return Ye(l, KN, t);
}, ZN = ue("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: Pb
})($e(({
  theme: e
}) => L(C({}, e.typography.body2), {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${Tt.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: e.typography.pxToRem(15)
    }
  }]
}))), eM = ue(sl, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: Pb
})($e(({
  theme: e
}) => L(C({}, e.typography.body2), {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${Tt.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Tt.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Tt.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : dt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${Tt.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${Tt.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: e.typography.pxToRem(15)
    }
  }, {
    props: {
      shape: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
      [`&.${Tt.selected}`]: {
        [`&.${Tt.disabled}`]: {
          borderColor: (e.vars || e).palette.action.disabledBackground,
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  }, {
    props: {
      variant: "text"
    },
    style: {
      [`&.${Tt.selected}`]: {
        [`&.${Tt.disabled}`]: {
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  }, ...Object.entries(e.palette).filter(cn(["dark", "contrastText"])).map(([t]) => ({
    props: {
      variant: "text",
      color: t
    },
    style: {
      [`&.${Tt.selected}`]: {
        color: (e.vars || e).palette[t].contrastText,
        backgroundColor: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: (e.vars || e).palette[t].dark,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: (e.vars || e).palette[t].main
          }
        },
        [`&.${Tt.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[t].dark
        },
        [`&.${Tt.disabled}`]: {
          color: (e.vars || e).palette.action.disabled
        }
      }
    }
  })), ...Object.entries(e.palette).filter(cn(["light"])).map(([t]) => ({
    props: {
      variant: "outlined",
      color: t
    },
    style: {
      [`&.${Tt.selected}`]: {
        color: (e.vars || e).palette[t].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t].mainChannel} / 0.5)` : dt(e.palette[t].main, 0.5)}`,
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : dt(e.palette[t].main, e.palette.action.activatedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette[t].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Tt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : dt(e.palette[t].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
        }
      }
    }
  }))]
}))), tM = ue("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})($e(({
  theme: e
}) => ({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(22)
    }
  }]
}))), Ib = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var ee, X, k, $;
  const r = tt({
    props: t,
    name: "MuiPaginationItem"
  }), H = r, {
    className: o,
    color: i = "standard",
    component: s,
    components: a = {},
    disabled: u = !1,
    page: l,
    selected: d = !1,
    shape: p = "circular",
    size: f = "medium",
    slots: h = {},
    slotProps: g = {},
    type: m = "page",
    variant: v = "text"
  } = H, S = re(H, [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "slotProps",
    "type",
    "variant"
  ]), _ = L(C({}, r), {
    color: i,
    disabled: u,
    selected: d,
    shape: p,
    size: f,
    type: m,
    variant: v
  }), R = qi(), b = QN(_), y = {
    slots: {
      previous: (ee = h.previous) != null ? ee : a.previous,
      next: (X = h.next) != null ? X : a.next,
      first: (k = h.first) != null ? k : a.first,
      last: ($ = h.last) != null ? $ : a.last
    },
    slotProps: g
  }, [w, x] = Ke("previous", {
    elementType: XN,
    externalForwardedProps: y,
    ownerState: _
  }), [P, N] = Ke("next", {
    elementType: JN,
    externalForwardedProps: y,
    ownerState: _
  }), [M, A] = Ke("first", {
    elementType: Eb,
    externalForwardedProps: y,
    ownerState: _
  }), [T, D] = Ke("last", {
    elementType: Tb,
    externalForwardedProps: y,
    ownerState: _
  }), j = R ? {
    previous: "next",
    next: "previous",
    first: "last",
    last: "first"
  }[m] : m, F = {
    previous: w,
    next: P,
    first: M,
    last: T
  }[j], z = {
    previous: x,
    next: N,
    first: A,
    last: D
  }[j];
  return m === "start-ellipsis" || m === "end-ellipsis" ? /* @__PURE__ */ O(ZN, {
    ref: n,
    ownerState: _,
    className: xe(b.root, o),
    children: "…"
  }) : /* @__PURE__ */ fe(eM, L(C({
    ref: n,
    ownerState: _,
    component: s,
    disabled: u,
    className: xe(b.root, o)
  }, S), {
    children: [m === "page" && l, F ? /* @__PURE__ */ O(tM, L(C({}, z), {
      className: b.icon,
      as: F
    })) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Ib.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "standard"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  components: c.shape({
    first: c.elementType,
    last: c.elementType,
    next: c.elementType,
    previous: c.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * The current page number.
   */
  page: c.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: c.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: c.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    first: c.oneOfType([c.func, c.object]),
    last: c.oneOfType([c.func, c.object]),
    next: c.oneOfType([c.func, c.object]),
    previous: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    first: c.elementType,
    last: c.elementType,
    next: c.elementType,
    previous: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: c.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: c.oneOfType([c.oneOf(["outlined", "text"]), c.string])
});
const Nb = Ib, nM = (e) => {
  const {
    classes: t,
    variant: n
  } = e;
  return Ye({
    root: ["root", n],
    ul: ["ul"]
  }, qN, t);
}, rM = ue("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant]];
  }
})({}), oM = ue("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, t) => t.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function iM(e, t, n) {
  return e === "page" ? `${n ? "" : "Go to "}page ${t}` : `Go to ${e} page`;
}
const Mb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = tt({
    props: t,
    name: "MuiPagination"
  }), M = r, {
    boundaryCount: o = 1,
    className: i,
    color: s = "standard",
    count: a = 1,
    defaultPage: u = 1,
    disabled: l = !1,
    getItemAriaLabel: d = iM,
    hideNextButton: p = !1,
    hidePrevButton: f = !1,
    onChange: h,
    page: g,
    renderItem: m = (A) => /* @__PURE__ */ O(Nb, C({}, A)),
    shape: v = "circular",
    showFirstButton: S = !1,
    showLastButton: _ = !1,
    siblingCount: R = 1,
    size: b = "medium",
    variant: y = "text"
  } = M, w = re(M, [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
  ]), {
    items: x
  } = GN(L(C({}, r), {
    componentName: "Pagination"
  })), P = L(C({}, r), {
    boundaryCount: o,
    color: s,
    count: a,
    defaultPage: u,
    disabled: l,
    getItemAriaLabel: d,
    hideNextButton: p,
    hidePrevButton: f,
    renderItem: m,
    shape: v,
    showFirstButton: S,
    showLastButton: _,
    siblingCount: R,
    size: b,
    variant: y
  }), N = nM(P);
  return /* @__PURE__ */ O(rM, L(C({
    "aria-label": "pagination navigation",
    className: xe(N.root, i),
    ownerState: P,
    ref: n
  }, w), {
    children: /* @__PURE__ */ O(oM, {
      className: N.ul,
      ownerState: P,
      children: x.map((A, T) => /* @__PURE__ */ O("li", {
        children: m(L(C({}, A), {
          color: s,
          "aria-label": d(A.type, A.page, A.selected),
          shape: v,
          size: b,
          variant: y
        }))
      }, T))
    })
  }));
});
process.env.NODE_ENV !== "production" && (Mb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: bn,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "standard"]), c.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: bn,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: bn,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number | null} page The page number to format.
   * @param {boolean} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: c.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: c.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: c.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: c.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: bn,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: c.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: c.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: c.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: c.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: bn,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: c.oneOfType([c.oneOf(["outlined", "text"]), c.string])
});
const sM = Mb;
var aM = function() {
}, kb = typeof window < "u", lM = kb ? Ma : or, Ab = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function cM() {
  var e = Wt(null), t = e[0], n = e[1], r = Wt(Ab), o = r[0], i = r[1], s = wd(function() {
    return new window.ResizeObserver(function(a) {
      if (a[0]) {
        var u = a[0].contentRect, l = u.x, d = u.y, p = u.width, f = u.height, h = u.top, g = u.left, m = u.bottom, v = u.right;
        i({ x: l, y: d, width: p, height: f, top: h, left: g, bottom: m, right: v });
      }
    });
  }, []);
  return lM(function() {
    if (t)
      return s.observe(t), function() {
        s.disconnect();
      };
  }, [t]), [n, o];
}
const uM = kb && typeof window.ResizeObserver < "u" ? cM : function() {
  return [aM, Ab];
}, $b = vC({}), zh = "24px", dM = "24px", pM = cr({
  components: {
    MuiPagination: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "space-around",
          flexGrow: 1,
          ".MuiPagination-ul": {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: zh
          }
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          height: zh,
          minWidth: dM,
          margin: "0 2px",
          "&.Mui-selected": {
            border: `1px solid ${gt.StUiColors.default}`,
            borderRadius: "12px",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: gt.StBackgroundColors.themeAgnostic
              // color: themeService.getDesignSettings().typography.primaryTextColor,
            }
          },
          "&:hover": {
            backgroundColor: gt.StBackgroundColors.themeAgnostic
            // color: themeService.getDesignSettings().typography.primaryTextColor,
          },
          "&.MuiPaginationItem-ellipsis": {
            background: "transparent",
            fontFamily: "Open Sans",
            fontWeight: "400",
            fontSize: "13px",
            lineHeight: "18px",
            paddingTop: "4px"
          },
          "&.MuiPaginationItem-firstLast": {
            display: "none"
          },
          "&.MuiPaginationItem-previousNext": {
            width: "40px"
          }
        }
      }
    }
  }
}), jh = 1, fM = Ht.forwardRef(
  ({ onPageChange: e, count: t, rowsPerPage: n, page: r }, o) => {
    const i = bC($b), s = (a, u) => e(null, u);
    return /* @__PURE__ */ O(Po, { children: /* @__PURE__ */ O(Oo, { theme: pM, children: /* @__PURE__ */ O(
      sM,
      {
        ref: o,
        count: Math.ceil(t / n),
        page: Number(r) + jh,
        siblingCount: i.siblingCount,
        onChange: s,
        showFirstButton: !0,
        showLastButton: !0,
        size: "small",
        boundaryCount: jh,
        renderItem: (a) => /* @__PURE__ */ O(
          Nb,
          L(C({
            components: {
              first: () => /* @__PURE__ */ O(
                io,
                {
                  sx: { color: gt.StUiColors.additional },
                  name: "general-double-arrow-back"
                }
              ),
              last: () => /* @__PURE__ */ O(
                io,
                {
                  sx: { color: gt.StUiColors.additional },
                  name: "general-double-arrow-front"
                }
              ),
              next: () => /* @__PURE__ */ O(
                io,
                {
                  sx: { color: gt.StUiColors.additional },
                  name: "general-arrow-right"
                }
              ),
              previous: () => /* @__PURE__ */ O(
                io,
                {
                  sx: { color: gt.StUiColors.additional },
                  name: "general-arrow-left"
                }
              )
            }
          }, a), {
            page: /* @__PURE__ */ O(Js, { variant: "bodyLabel", dataTestId: `PaginationPage-${a.page}`, children: a.page })
          })
        ),
        "data-testid": "PaginationActionsComponent"
      }
    ) }) });
  }
), hM = "responsive-table-pagination", mn = {
  xs: 0,
  sm: 200,
  md: 439,
  lg: 600,
  xl: 1536
}, mM = (e) => Cs(mn.xs, mn.sm, e) ? "xs" : Cs(mn.sm, mn.md, e) ? "sm" : Cs(mn.md, mn.lg, e) ? "md" : Cs(mn.lg, mn.xl, e) ? "lg" : "xl", Cs = (e, t, n) => n >= e && n < t, gM = cr({
  breakpoints: {
    values: mn
  },
  components: {
    MuiTablePagination: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%"
        },
        toolbar: {
          "&.MuiTablePagination-toolbar": {
            display: "flex",
            flexDirection: "row",
            padding: "0px 20px 0 20px",
            alignItems: "center",
            height: "30px",
            width: "100%"
          },
          ".Mui-selected": {
            margin: 0
          }
        },
        spacer: {
          display: "none"
        },
        displayedRows: {
          whiteSpace: "nowrap"
        },
        selectLabel: {
          order: 4,
          paddingLeft: "20px"
        },
        input: {
          order: 5,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          borderRadius: "4px",
          marginRight: "0"
        },
        select: {
          "&.MuiTablePagination-select": {
            background: "transparent"
          }
        },
        selectIcon: {
          position: "absolute",
          top: "8%"
        },
        menuItem: {
          paddingLeft: "10px",
          "&.MuiTablePagination-menuItem.Mui-selected": {
            position: "relative",
            background: "transparent",
            // '&:hover': {
            //     backgroundColor:
            //         themeService.getDesignSettings().typography.primaryTextColor,
            //     color: themeService.getDesignSettings().typography.primaryTextColor,
            // },
            "&:after": {
              marginLeft: "15px",
              content: '""',
              display: "block",
              position: "absolute",
              width: "24px",
              height: "24px",
              top: "3px",
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.2604 8.58124L10.9174 16.0615L7 12.1442L7.70711 11.4371L10.7898 14.5197L15.4467 8L16.2604 8.58124Z' fill='%235B6372'/%3E%3C/svg%3E%0A")`
            }
          },
          "&.MuiTablePagination-menuItem": {
            fontFamily: "inherit",
            fontWeight: "400",
            fontSize: "13px",
            lineHeight: "18px",
            color: gt.StTextColors.content
          },
          "&:hover": {
            backgroundColor: gt.StBackgroundColors.priority
          }
        },
        actions: {
          marginLeft: 0
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "4px 0px",
          gap: "4px",
          marginTop: "4px",
          background: gt.StBackgroundColors.workspace,
          boxShadow: HN.Shadows.level1,
          borderRadius: "4px"
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
          width: "100%"
        }
      }
    }
  }
}), yM = 1, vM = Ht.forwardRef(
  // eslint-disable-next-line max-lines-per-function
  (g, h) => {
    var m = g, {
      count: e,
      page: t,
      rowsPerPage: n,
      onRowsPerPageChange: r,
      displayedLabelRows: o,
      onPageChange: i,
      labelRowsPerPage: s,
      labelRowsPerPageShort: a = "Rows",
      rowsPerPageOptions: u = [10, 25, 50, 75],
      theme: l = gM,
      dataTestId: d,
      style: p
    } = m, f = re(m, [
      "count",
      "page",
      "rowsPerPage",
      "onRowsPerPageChange",
      "displayedLabelRows",
      "onPageChange",
      "labelRowsPerPage",
      "labelRowsPerPageShort",
      "rowsPerPageOptions",
      "theme",
      "dataTestId",
      "style"
    ]);
    const [v, { width: S }] = uM(), _ = S < mn.lg, R = ({
      from: P,
      to: N,
      count: M
    }) => {
      const A = _ ? `${P}-${N} / ${M}` : `${P}-${N} ${o.conjunction} ${M} ${o.result}`;
      return /* @__PURE__ */ O(Js, { variant: "bodyParagraph", sx: { color: gt.StTextColors.secondary }, children: A });
    }, b = (P, N) => i(N), y = (P) => r(Number(P.target.value)), w = mM(S), x = {
      siblingCount: _ ? 0 : 1
    };
    return /* @__PURE__ */ O(Po, { children: /* @__PURE__ */ O(Oo, { theme: l, children: /* @__PURE__ */ O($b.Provider, { value: x, children: /* @__PURE__ */ O("div", { className: `${hM} ${w}`, ref: v, children: /* @__PURE__ */ O(
      BN,
      {
        ref: h,
        component: "div",
        count: e,
        page: t - yM,
        ActionsComponent: fM,
        onPageChange: b,
        onRowsPerPageChange: y,
        rowsPerPage: n,
        rowsPerPageOptions: u,
        labelDisplayedRows: R,
        slotProps: {
          select: {
            SelectDisplayProps: {
              "data-testid": "TablePaginationSelect"
            },
            IconComponent: (P) => /* @__PURE__ */ O(io, L(C({}, P), { name: "general-arrow-big-down" })),
            renderValue: (P) => /* @__PURE__ */ O(Js, { variant: "bodyParagraph", children: String(P) }),
            MenuProps: {
              sx: {
                ".MuiPaper-root": {
                  fontFamily: p == null ? void 0 : p.fontFamily
                }
              }
            }
          }
        },
        labelRowsPerPage: /* @__PURE__ */ O(Js, { variant: "bodyParagraph", children: _ ? a : s }),
        "data-testid": d
      }
    ) }) }) }) });
  }
), bM = "sisense-pivot__pagination-panel", CM = "sisense-pivot__pagination-panel-wrapper", SM = "sisense-pivot__pagination-panel--showed", wM = "sisense-pivot__pagination-panel--hidden", _M = "sisense-pivot__pagination-panel--desktop", xM = "sisense-pivot__pagination-panel--limits-only", TM = "sisense-pivot__pagination-panel--mobile", EM = "sisense-pivot__pagination-panel--notification-only", RM = "sisense-pivot__pagination-panel-list-wrapper", OM = "sisense-pivot__pagination-panel-notification", pc = {
  isMobile: !1,
  conjunctionLabel: "of",
  resultLabel: "Results",
  rowsPerPageLabel: "Results per page",
  rowsPerPageLabelShort: "Rows",
  notifyRowsLimitLabel: "The Pivot table is limited to {{recordsCount}} records",
  notifyColumnsLimitLabel: "The Pivot table is limited to {{columnsCount}} columns",
  notifyRowsAndColumnsLimitLabel: "The Pivot table is limited to {{recordsCount}} records and {{columnsCount}} columns",
  alertIcon: "<div>!</div>",
  numberFormatter: null,
  onNotificationMoreClick: null
};
class Lb extends E.PureComponent {
  constructor(n) {
    super(n);
    I(this, "logger");
    I(this, "panel");
    I(this, "listFirst");
    I(this, "listLast");
    I(this, "listNumbers");
    I(this, "rowsEl");
    I(this, "totalEl");
    I(this, "notificationEl");
    I(this, "oldSize");
    I(this, "notificationStr");
    I(this, "notificationFallback");
    I(this, "onHeightChangeMemoizer", xu(!1));
    /**
     *  Function-handler to select provided page
     *
     * @param {number} selected - selected page number
     * @param {Event} e - standard DOM event
     * @returns {void}
     * @private
     */
    I(this, "handlePageSelected", (n) => {
      const r = n === 0 ? n : n - 1;
      this.props.activePage !== r && this.notifyOnPageChange(r);
    });
    I(this, "onRowsPerPageChange", (n) => {
      const { onItemsPerPageChange: r } = this.props;
      typeof r != "undefined" && typeof r == "function" && r(n);
    });
    I(this, "onNotificationMoreClick", (n) => {
      const { columnsCount: r, itemsCount: o, limitCount: i } = this.props;
      if (this.props.options) {
        const { onNotificationMoreClick: s } = this.props.options;
        s && s(n, {
          columnsCount: r,
          columnsLimitReached: this.isColumnsLimitReached(this.props),
          rowsCount: o,
          rowsLimitReached: this.isRowsLimitReached(this.props),
          recordsCount: i
        });
      }
    });
    I(this, "panelRef", (n) => {
      n && (this.panel = n);
    });
    const { itemsCount: r, itemsPerPage: o, options: i, style: s } = this.props;
    this.logger = ar.create("PaginationPanel");
    const a = Math.ceil(r / o) || 0, u = L(C(C({}, pc), i), { style: s });
    this.state = {
      pagesCount: a,
      options: u
    };
  }
  componentDidMount() {
    const { activePage: n, disableInitialCallback: r } = this.props;
    this.provideHeightUpdate(), r || this.notifyOnPageChange(n);
  }
  UNSAFE_componentWillReceiveProps(n) {
    let r = null;
    if (n.itemsCount !== this.props.itemsCount || n.itemsPerPage !== this.props.itemsPerPage) {
      r = r || {};
      const s = Math.ceil(n.itemsCount / n.itemsPerPage) || 0;
      r.pagesCount = s;
    }
    if ((n.itemsCount !== this.props.itemsCount || n.itemsPerPage !== this.props.itemsPerPage || n.activePage !== this.props.activePage || n.totalItemsCount !== this.props.totalItemsCount || n.columnsCount !== this.props.columnsCount || n.totalColumnsCount !== this.props.totalColumnsCount || n.limitReached !== this.props.limitReached || n.limitCount !== this.props.limitCount) && (this.notificationStr = void 0), n.options !== this.props.options) {
      r = r || {};
      const s = C(C({}, pc), n.options);
      r.options = s;
    }
    const o = n.options || {}, i = this.props.options || {};
    (n.width !== this.props.width || n.itemsCount !== this.props.itemsCount || n.totalItemsCount !== this.props.totalItemsCount || n.columnsCount !== this.props.columnsCount || n.totalColumnsCount !== this.props.totalColumnsCount || n.limitReached !== this.props.limitReached || n.limitCount !== this.props.limitCount || n.itemsPerPage !== this.props.itemsPerPage || n.activePage !== this.props.activePage || o.isMobile !== i.isMobile) && (this.oldSize = void 0), r && this.setState(r);
  }
  componentDidUpdate() {
    this.provideHeightUpdate();
  }
  getHeight() {
    return this.panel && this.panel.offsetHeight || 0;
  }
  getNotificationStr() {
    const { itemsCount: n, itemsPerPage: r, activePage: o, totalColumnsCount: i, columnsCount: s, limitCount: a } = this.props, { options: u } = this.state, { notifyRowsLimitLabel: l, notifyColumnsLimitLabel: d, notifyRowsAndColumnsLimitLabel: p } = u || {}, f = this.isRowsLimitReached(this.props), h = this.isColumnsLimitReached(this.props);
    let g = () => "";
    f && h ? g = kl(p || "") : f ? g = kl(l || "") : h && (g = kl(d || ""));
    let m = n, v = a;
    if (this.props.options) {
      const S = {
        type: "number",
        separated: !0,
        abbreviations: { k: !0, m: !0 }
      }, { numberFormatter: _ } = this.props.options;
      _ && (m = _(m, S), v = _(v, S));
    }
    return this.notificationStr = g({
      columnsCount: s,
      totalColumnsCount: i,
      rowsCount: m,
      recordsCount: v
    }), this.notificationFallback = /* @__PURE__ */ O("div", {}), i === 0 && s === 0 && (this.notificationFallback = null), {
      notificationStr: this.notificationStr,
      notificationFallback: this.notificationFallback
    };
  }
  isRowsLimitReached(n = this.props) {
    return n.limitReached;
  }
  isColumnsLimitReached(n = this.props) {
    return n.totalColumnsCount > n.columnsCount;
  }
  /**
   * Notify about paginator container height change
   *
   * @returns {void}
   * @private
   */
  provideHeightUpdate() {
    const { onHeightChange: n } = this.props;
    n && this.panel && this.onHeightChangeMemoizer({
      callback: ({ offsetHeight: r }) => {
        n(r);
      },
      indices: {
        offsetHeight: this.getHeight()
      }
    });
  }
  /**
   *  Callback for Parent Components
   *
   * @param {number} selectedItem - selected page number
   * @returns {void}
   * @private
   */
  notifyOnPageChange(n) {
    const { onPageChange: r } = this.props;
    typeof r != "undefined" && typeof r == "function" && r({ selected: n });
  }
  render() {
    const { className: n, activePage: r, itemsPerPage: o, itemsCount: i, totalItemsCount: s } = this.props, { pagesCount: a, options: u } = this.state, {
      isMobile: l,
      alertIcon: d,
      conjunctionLabel: p,
      resultLabel: f,
      rowsPerPageLabel: h,
      rowsPerPageLabelShort: g
    } = u, m = s > i && a === 1, v = r > -1, S = this.isRowsLimitReached(this.props) || this.isColumnsLimitReached(this.props), R = pa(
      n,
      bM,
      !v && !m && !S ? wM : "",
      v ? SM : "",
      l ? TM : _M,
      m ? xM : "",
      S ? EM : ""
    ), { notificationStr: b, notificationFallback: y } = this.getNotificationStr(), w = { width: "100%", height: "" };
    return /* @__PURE__ */ O("div", { className: "sis-scope", children: /* @__PURE__ */ O("div", { className: R, "data-html2canvas-ignore": "true", ref: this.panelRef, children: /* @__PURE__ */ O(Ed, { style: w, autoHeight: !0, children: /* @__PURE__ */ fe("div", { className: CM, children: [
      b ? /* @__PURE__ */ O("div", { className: OM, title: b, children: /* @__PURE__ */ O(
        "div",
        {
          role: "button",
          tabIndex: 0,
          onClick: this.onNotificationMoreClick,
          onKeyPress: this.onNotificationMoreClick,
          dangerouslySetInnerHTML: {
            __html: d
          },
          "aria-label": "alert"
        }
      ) }) : y,
      /* @__PURE__ */ O("div", { className: RM, children: /* @__PURE__ */ O(
        vM,
        {
          count: i,
          page: r + 1,
          rowsPerPage: o,
          displayedLabelRows: {
            conjunction: p,
            result: f
          },
          rowsPerPageOptions: [10, 25, 50, 75],
          labelRowsPerPage: h,
          labelRowsPerPageShort: g,
          dataTestId: "TablePagination",
          onPageChange: this.handlePageSelected,
          onRowsPerPageChange: this.onRowsPerPageChange,
          style: this.props.style
        }
      ) })
    ] }) }) }) });
  }
}
I(Lb, "defaultProps", {
  isAllDataLoaded: !1,
  activePage: 0,
  disableInitialCallback: !0,
  className: "",
  options: C({}, pc),
  onHeightChange: null,
  onPageChange: null
});
const Yd = (e) => {
  switch (e.metadataType) {
    case Ce.MEASURES:
      return ct.ASC;
    default:
      return ct.DESC;
  }
}, Hh = "sisense-pivot", PM = "sisense-pivot__multi-grid", IM = "sisense-pivot__overlay", ft = "#5B6372", rn = "rgba(244, 244, 244, 1)", Kn = "rgba(239, 239, 239, 1)", NM = ty.div`
  &,
  .table-grid {
    background-color: ${(e) => e.backgroundColor};
    font-family: ${(e) => e.fontFamily};
  }

  .table-grid__row > .table-grid__cell {
    color: ${(e) => e.textColor || ft};
  }

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.alternatingRows) && er`
      .table-grid__cell--data.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd:not(
          .table-grid__cell--row-user-type-subTotal
        ):not(.table-grid__cell--row-user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
      .table-grid__cell--rows.table-grid__cell--level-last.table-grid__cell--sibling-odd:not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
      .table-grid--bottom.table-grid--right
        .table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd:not(
          .table-grid__cell--row-user-type-subTotal
        ):not(.table-grid__cell--row-user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
      .table-grid--bottom.table-grid--left
        .table-grid__cell--level-last.table-grid__cell--sibling-odd:not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal):not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.alternatingColumns) && er`
      .table-grid--bottom.table-grid--left .table-grid__column:nth-of-type(even),
      .table-grid--bottom.table-grid--right .table-grid__column:nth-of-type(even) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.columnsHeaders) && er`
      .table-grid--top.table-grid--left
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected),
      .table-grid--top.table-grid--right
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
      .table-grid__cell--corner.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ),
      .table-grid__cell--columns.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.rowMembers) && er`
      .table-grid--bottom.table-grid--left
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected):not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
      .table-grid__cell--rows.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ):not(.table-grid__cell--user-type-subTotal):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.rowMembers) && er`
      .table-grid--bottom.table-grid--left
        .table-grid__cell:not(.table-grid__cell--drilled):not(.table-grid__cell--selected):not(
          .table-grid__cell--user-type-subTotal
        ):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
      .table-grid__cell--rows.table-grid__cell:not(.table-grid__cell--drilled):not(
          .table-grid__cell--selected
        ):not(.table-grid__cell--user-type-subTotal):not(.table-grid__cell--user-type-grandTotal) {
        background-color: ${e.fillColor || rn};
        color: ${e.textColor || ft};
      }
    `;
}}

  ${(e) => {
  var t;
  return ((t = e.fillOptions) == null ? void 0 : t.totals) && er`
      .table-grid--bottom.table-grid--left .table-grid__cell--user-type-subTotal,
      .table-grid--bottom.table-grid--left .table-grid__cell--user-type-grandTotal {
        background-color: ${e.additionalFillColor || Kn};
        color: ${e.textColor || ft};
      }
      .table-grid--bottom.table-grid--right {
        .table-grid__cell--row-user-type-subTotal,
        .table-grid__cell--row-user-type-grandTotal,
        .table-grid__cell--col-user-type-subTotal,
        .table-grid__cell--col-user-type-grandTotal {
          background-color: ${e.additionalFillColor || Kn};
          color: ${e.textColor || ft};
        }
        .table-grid__cell--row-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--row-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even,
        .table-grid__cell--col-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--col-user-type-subTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even,
        .table-grid__cell--col-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
        .table-grid__cell--col-user-type-grandTotal.table-grid__cell.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even {
          background-color: ${e.additionalFillColor || Kn};
          color: ${e.textColor || ft};
        }
        .table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-subTotal,
        .table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-grandTotal,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-subTotal,
        .table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-grandTotal {
          background-color: ${e.additionalFillColor || Kn};
          color: ${e.textColor || ft};
        }
      }
      .table-grid__cell--rows.table-grid__cell--user-type-subTotal,
      .table-grid__cell--rows.table-grid__cell--user-type-grandTotal {
        background-color: ${e.additionalFillColor || Kn};
        color: ${e.textColor || ft};
      }
      .table-grid__cell--data.table-grid__cell--row-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-grandTotal,
      .table-grid__cell--data.table-grid__cell--col-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--col-user-type-grandTotal {
        background-color: ${e.additionalFillColor || Kn};
        color: ${e.textColor || ft};
        &.table-grid__cell {
          &.table-grid__cell--row-level-last.table-grid__cell--row-sibling-odd,
          &.table-grid__cell--row-level-last.table-grid__cell--row-sibling-even {
            background-color: ${e.additionalFillColor || Kn};
            color: ${e.textColor || ft};
          }
        }
      }
      .table-grid__cell--data.table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-subTotal.table-grid__cell--col-user-type-grandTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-subTotal,
      .table-grid__cell--data.table-grid__cell--row-user-type-grandTotal.table-grid__cell--col-user-type-grandTotal {
        background-color: ${e.additionalFillColor || Kn};
        color: ${e.textColor || ft};
      }
    `;
}}

  .MuiTablePagination-root {
    .MuiTypography-root,
    .MuiPaginationItem-root {
      font-family: ${(e) => e.fontFamily};
      color: ${(e) => e.navigationPrimaryColor};
    }
    .Mui-selected {
      border-color: ${(e) => e.navigationSecondaryColor};
    }
    .MuiSvgIcon-root {
      color: ${(e) => e.navigationSecondaryColor};
    }
  }
  .table-grid__cell--selected {
    background-color: ${(e) => e.selectionColor};
  }
`, MM = () => {
  var t;
  const e = (t = document.head.querySelector('meta[property="csp-nonce"]')) == null ? void 0 : t.getAttribute("content");
  return e ? oy({
    key: "css",
    nonce: e
  }) : null;
}, kM = ({ children: e }) => {
  const t = wd(() => MM(), []);
  return t ? /* @__PURE__ */ O(ry, { value: t, children: e }) : /* @__PURE__ */ O(xo, { children: e });
};
class Xu extends E.PureComponent {
  constructor(n) {
    super(n);
    I(this, "logger");
    I(this, "pivotTable");
    I(this, "paginationPanel");
    I(this, "forceNotifyAboutHeightChange", !1);
    I(this, "onEmptyChangeMemoizer", xu());
    I(this, "onTotalHeightChangeMemoizer", xu());
    I(this, "pivotContainer");
    I(this, "childrenReadyStateInitial", {
      pivotDomReady: !1,
      paginationDomReady: !1,
      isDebouncing: !1
    });
    I(this, "childrenReadyState", this.childrenReadyStateInitial);
    I(this, "domReadyEvent", ST(() => this.onDomReadyEvent(), 500));
    I(this, "onPivotDomReady", () => {
      this.childrenReadyState = L(C({}, this.childrenReadyState), {
        pivotDomReady: !0,
        isDebouncing: !0
      }), this.domReadyEvent();
    });
    I(this, "pivotTableRef", (n) => {
      n && (this.pivotTable = n);
    });
    I(this, "paginationPanelRef", (n) => {
      n && (this.paginationPanel = n);
    });
    I(this, "onPaginationHeightChange", (n) => {
      this.setState({
        paginationPanelHeight: n,
        pivotHeight: this.calculatePivotHeight({ paginationPanelHeight: n })
      });
    });
    I(this, "onTableTotalSizeChange", (n) => {
      this.setState({
        pivotTableHeight: n,
        pivotHeight: this.calculatePivotHeight({ pivotTableHeight: n })
      });
    });
    I(this, "onSortingMetadataUpdate", (n, r) => {
      const { measurePath: o, dir: i } = n, s = {
        measurePath: o,
        dir: i || Yd(n),
        field: r ? r.jaqlIndex : n.jaqlIndex
      };
      this.props.onSortingMetadataUpdate && this.props.onSortingMetadataUpdate(s);
    });
    I(this, "setPivotContainerRef", (n) => {
      n && this.pivotContainer !== n && (this.pivotContainer = n, this.forceUpdate());
    });
    this.logger = ar.create("Pivot"), this.state = {
      pivotHeight: n.height
    };
  }
  componentDidMount() {
    const { onEmptyChange: n } = this.props;
    n && this.onEmptyChangeMemoizer({
      callback: ({ isEmpty: r }) => {
        n(r);
      },
      indices: {
        isEmpty: !(this.pivotTable && this.pivotTable.hasContent())
      }
    });
  }
  UNSAFE_componentWillReceiveProps(n) {
    const r = Oy(this.props, n);
    (typeof r.width != "undefined" || typeof r.height != "undefined" || typeof r.isAutoHeight != "undefined" || typeof r.isPaginated != "undefined" || typeof r.itemsCount != "undefined" || typeof r.itemsPerPage != "undefined") && (this.forceNotifyAboutHeightChange = !0, this.setState({
      pivotHeight: this.calculatePivotHeight({
        isAutoHeight: n.isAutoHeight,
        holderHeight: n.height
      })
    }));
  }
  componentDidUpdate() {
    const { onEmptyChange: n, onTotalHeightChange: r, scrollBarsMargin: o = 0 } = this.props;
    if (n && this.onEmptyChangeMemoizer({
      callback: ({ isEmpty: i }) => {
        n(i);
      },
      indices: {
        isEmpty: !(this.pivotTable && this.pivotTable.hasContent())
        // eslint-disable-next-line max-lines
      }
    }), r && this.isPaginationReady()) {
      const { pivotTableHeight: i, paginationPanelHeight: s } = this.state;
      if (this.forceNotifyAboutHeightChange) {
        if (this.forceNotifyAboutHeightChange = !1, typeof i != "undefined" && typeof s != "undefined") {
          const a = i + s + o;
          r(a);
        }
      } else
        this.onTotalHeightChangeMemoizer({
          callback: ({
            tableHeight: a,
            paginationHeight: u
          } = { tableHeight: 0, paginationHeight: 0 }) => {
            const l = a + u + o;
            r(l);
          },
          indices: {
            tableHeight: i,
            paginationHeight: s
          }
        });
    }
  }
  componentWillUnmount() {
    this.pivotTable = void 0, this.paginationPanel = void 0;
  }
  initialize(n, r, o, i) {
    this.pivotTable && this.pivotTable.initialize(
      n,
      r,
      o,
      i
    );
  }
  addMore(n, r = !1) {
    this.pivotTable && n && this.pivotTable.addMore(n, r);
  }
  getDimensions() {
    return this.pivotTable ? this.pivotTable.getDimensions() : { width: [], height: [] };
  }
  /**
   * Defines if pagination panel is already rendered and we know his size
   *
   * @returns {boolean} - true - ready, rendered
   */
  isPaginationReady() {
    const { paginationPanelHeight: n } = this.state, r = typeof n == "number" && n >= 0, o = this.props.isPaginated ? r : !0;
    return this.childrenReadyState = L(C({}, this.childrenReadyState), {
      paginationDomReady: o,
      isDebouncing: !0
    }), this.domReadyEvent(), o;
  }
  /**
   * Calculates PivotTable height according to isAutoHeight and isPaginated rules and so on
   *
   * @param {boolean} options - partial props and state
   * @param {boolean} options.isAutoHeight - isAutoHeight condition
   * @param {number} options.holderHeight - holder height
   * @param {number|null} options.pivotTableHeight - real pivot height
   * @param {number|null} options.paginationPanelHeight - pivot navigator height
   * @returns {number} - final height
   * @private
   */
  calculatePivotHeight({
    isAutoHeight: n = this.props.isAutoHeight,
    holderHeight: r = this.props.height,
    pivotTableHeight: o = this.state.pivotTableHeight || 0,
    paginationPanelHeight: i = this.state.paginationPanelHeight || 0
  }) {
    const { scrollBarsMargin: s = 0 } = this.props, a = r - i, u = a ? a - s : 1;
    return n ? o || u : a;
  }
  /**
   * Triggers onDomReady event when Pivot and Pagination are both rendered
   *
   * @returns {void}
   */
  onDomReadyEvent() {
    if (this.childrenReadyState.pivotDomReady && this.childrenReadyState.paginationDomReady && this.childrenReadyState.isDebouncing) {
      this.domReadyEvent.cancel(), this.childrenReadyState = C({}, this.childrenReadyStateInitial);
      const { onDomReady: n } = this.props;
      n && n();
    }
  }
  render() {
    const H = this.props, {
      className: n,
      fontFamily: r,
      textColor: o,
      backgroundColor: i,
      fillColor: s,
      additionalFillColor: a,
      fillOptions: u,
      navigationPrimaryColor: l,
      navigationSecondaryColor: d,
      selectionColor: p,
      isPaginated: f,
      overlay: h,
      itemsCount: g,
      itemsPerPage: m,
      paginationOptions: v,
      totalItemsCount: S,
      totalRecordsCount: _,
      limitReached: R,
      totalColumnsCount: b,
      columnsCount: y,
      scrollBarsMargin: w = 0,
      rowHeight: x,
      imageColumns: P,
      fallbackImageUrl: N,
      dataBars: M,
      rangeMinMax: A,
      isMobile: T,
      addCellDomReadyPromise: D,
      removeCellDomReadyPromise: j
    } = H, F = re(H, [
      "className",
      "fontFamily",
      "textColor",
      "backgroundColor",
      "fillColor",
      "additionalFillColor",
      "fillOptions",
      "navigationPrimaryColor",
      "navigationSecondaryColor",
      "selectionColor",
      "isPaginated",
      "overlay",
      "itemsCount",
      "itemsPerPage",
      "paginationOptions",
      "totalItemsCount",
      "totalRecordsCount",
      "limitReached",
      "totalColumnsCount",
      "columnsCount",
      "scrollBarsMargin",
      "rowHeight",
      "imageColumns",
      "fallbackImageUrl",
      "dataBars",
      "rangeMinMax",
      "isMobile",
      "addCellDomReadyPromise",
      "removeCellDomReadyPromise"
    ]), { pivotHeight: z } = this.state;
    return /* @__PURE__ */ O(kM, { children: /* @__PURE__ */ O(
      NM,
      {
        fontFamily: r,
        textColor: o,
        backgroundColor: i,
        fillColor: s,
        additionalFillColor: a,
        fillOptions: u,
        navigationPrimaryColor: l,
        navigationSecondaryColor: d,
        selectionColor: p,
        children: /* @__PURE__ */ fe("div", { className: pa(Hh, `${Hh}--new`, n), ref: this.setPivotContainerRef, children: [
          this.pivotContainer && /* @__PURE__ */ O(
            Jy,
            L(C({}, F), {
              className: PM,
              rowHeight: x,
              imageColumns: P,
              fallbackImageUrl: N,
              addCellDomReadyPromise: D,
              removeCellDomReadyPromise: j,
              onSortingMetadataUpdate: this.onSortingMetadataUpdate,
              onSortingSettingsChanged: this.props.onSortingSettingsChanged,
              ref: this.pivotTableRef,
              height: z,
              onTotalSizeChange: this.onTableTotalSizeChange,
              scrollBarsMargin: w,
              dataBars: M,
              rangeMinMax: A,
              isMobile: T,
              onDomReady: this.onPivotDomReady
            })
          ),
          f ? /* @__PURE__ */ O(
            Lb,
            L(C({}, F), {
              ref: this.paginationPanelRef,
              itemsCount: g,
              itemsPerPage: m,
              options: v,
              totalItemsCount: S,
              limitReached: R,
              limitCount: _,
              totalColumnsCount: b,
              columnsCount: y,
              onHeightChange: this.onPaginationHeightChange,
              style: {
                fontFamily: r
              }
            })
          ) : null,
          h ? /* @__PURE__ */ O("div", { className: IM }) : null
        ] })
      }
    ) });
  }
}
I(Xu, "defaultProps", {
  isAutoHeight: !1,
  isFullWidth: !1,
  isFixedEnabled: !0,
  isPaginated: !1,
  overlay: !1,
  itemsCount: 0,
  totalItemsCount: 0,
  totalRecordsCount: 0,
  limitReached: !1,
  totalColumnsCount: 0,
  columnsCount: 0,
  itemsPerPage: 0,
  borderWidth: 1,
  scrollBarsMargin: 9
});
var kt = "top", Qt = "bottom", Zt = "right", At = "left", Xd = "auto", Gi = [kt, Qt, Zt, At], yo = "start", Mi = "end", AM = "clippingParents", Db = "viewport", Xo = "popper", $M = "reference", Wh = /* @__PURE__ */ Gi.reduce(function(e, t) {
  return e.concat([t + "-" + yo, t + "-" + Mi]);
}, []), Bb = /* @__PURE__ */ [].concat(Gi, [Xd]).reduce(function(e, t) {
  return e.concat([t, t + "-" + yo, t + "-" + Mi]);
}, []), LM = "beforeRead", DM = "read", BM = "afterRead", FM = "beforeMain", zM = "main", jM = "afterMain", HM = "beforeWrite", WM = "write", VM = "afterWrite", UM = [LM, DM, BM, FM, zM, jM, HM, WM, VM];
function xn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ut(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Er(e) {
  var t = Ut(e).Element;
  return e instanceof t || e instanceof Element;
}
function Jt(e) {
  var t = Ut(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Jd(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = Ut(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function qM(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !Jt(i) || !xn(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(s) {
      var a = o[s];
      a === !1 ? i.removeAttribute(s) : i.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function GM(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), a = s.reduce(function(u, l) {
        return u[l] = "", u;
      }, {});
      !Jt(o) || !xn(o) || (Object.assign(o.style, a), Object.keys(i).forEach(function(u) {
        o.removeAttribute(u);
      }));
    });
  };
}
const KM = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: qM,
  effect: GM,
  requires: ["computeStyles"]
};
function Sn(e) {
  return e.split("-")[0];
}
var _r = Math.max, wa = Math.min, vo = Math.round;
function Ju() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Fb() {
  return !/^((?!chrome|android).)*safari/i.test(Ju());
}
function bo(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && Jt(e) && (o = e.offsetWidth > 0 && vo(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && vo(r.height) / e.offsetHeight || 1);
  var s = Er(e) ? Ut(e) : window, a = s.visualViewport, u = !Fb() && n, l = (r.left + (u && a ? a.offsetLeft : 0)) / o, d = (r.top + (u && a ? a.offsetTop : 0)) / i, p = r.width / o, f = r.height / i;
  return {
    width: p,
    height: f,
    top: d,
    right: l + p,
    bottom: d + f,
    left: l,
    x: l,
    y: d
  };
}
function Qd(e) {
  var t = bo(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function zb(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Jd(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Hn(e) {
  return Ut(e).getComputedStyle(e);
}
function YM(e) {
  return ["table", "td", "th"].indexOf(xn(e)) >= 0;
}
function ur(e) {
  return ((Er(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function al(e) {
  return xn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Jd(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ur(e)
  );
}
function Vh(e) {
  return !Jt(e) || // https://github.com/popperjs/popper-core/issues/837
  Hn(e).position === "fixed" ? null : e.offsetParent;
}
function XM(e) {
  var t = /firefox/i.test(Ju()), n = /Trident/i.test(Ju());
  if (n && Jt(e)) {
    var r = Hn(e);
    if (r.position === "fixed")
      return null;
  }
  var o = al(e);
  for (Jd(o) && (o = o.host); Jt(o) && ["html", "body"].indexOf(xn(o)) < 0; ) {
    var i = Hn(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Ki(e) {
  for (var t = Ut(e), n = Vh(e); n && YM(n) && Hn(n).position === "static"; )
    n = Vh(n);
  return n && (xn(n) === "html" || xn(n) === "body" && Hn(n).position === "static") ? t : n || XM(e) || t;
}
function Zd(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function bi(e, t, n) {
  return _r(e, wa(t, n));
}
function JM(e, t, n) {
  var r = bi(e, t, n);
  return r > n ? n : r;
}
function jb() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Hb(e) {
  return Object.assign({}, jb(), e);
}
function Wb(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var QM = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Hb(typeof t != "number" ? t : Wb(t, Gi));
};
function ZM(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, a = Sn(n.placement), u = Zd(a), l = [At, Zt].indexOf(a) >= 0, d = l ? "height" : "width";
  if (!(!i || !s)) {
    var p = QM(o.padding, n), f = Qd(i), h = u === "y" ? kt : At, g = u === "y" ? Qt : Zt, m = n.rects.reference[d] + n.rects.reference[u] - s[u] - n.rects.popper[d], v = s[u] - n.rects.reference[u], S = Ki(i), _ = S ? u === "y" ? S.clientHeight || 0 : S.clientWidth || 0 : 0, R = m / 2 - v / 2, b = p[h], y = _ - f[d] - p[g], w = _ / 2 - f[d] / 2 + R, x = bi(b, w, y), P = u;
    n.modifiersData[r] = (t = {}, t[P] = x, t.centerOffset = x - w, t);
  }
}
function ek(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || zb(t.elements.popper, o) && (t.elements.arrow = o));
}
const tk = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ZM,
  effect: ek,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Co(e) {
  return e.split("-")[1];
}
var nk = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function rk(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: vo(n * o) / o || 0,
    y: vo(r * o) / o || 0
  };
}
function Uh(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, s = e.offsets, a = e.position, u = e.gpuAcceleration, l = e.adaptive, d = e.roundOffsets, p = e.isFixed, f = s.x, h = f === void 0 ? 0 : f, g = s.y, m = g === void 0 ? 0 : g, v = typeof d == "function" ? d({
    x: h,
    y: m
  }) : {
    x: h,
    y: m
  };
  h = v.x, m = v.y;
  var S = s.hasOwnProperty("x"), _ = s.hasOwnProperty("y"), R = At, b = kt, y = window;
  if (l) {
    var w = Ki(n), x = "clientHeight", P = "clientWidth";
    if (w === Ut(n) && (w = ur(n), Hn(w).position !== "static" && a === "absolute" && (x = "scrollHeight", P = "scrollWidth")), w = w, o === kt || (o === At || o === Zt) && i === Mi) {
      b = Qt;
      var N = p && w === y && y.visualViewport ? y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        w[x]
      );
      m -= N - r.height, m *= u ? 1 : -1;
    }
    if (o === At || (o === kt || o === Qt) && i === Mi) {
      R = Zt;
      var M = p && w === y && y.visualViewport ? y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        w[P]
      );
      h -= M - r.width, h *= u ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: a
  }, l && nk), T = d === !0 ? rk({
    x: h,
    y: m
  }, Ut(n)) : {
    x: h,
    y: m
  };
  if (h = T.x, m = T.y, u) {
    var D;
    return Object.assign({}, A, (D = {}, D[b] = _ ? "0" : "", D[R] = S ? "0" : "", D.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", D));
  }
  return Object.assign({}, A, (t = {}, t[b] = _ ? m + "px" : "", t[R] = S ? h + "px" : "", t.transform = "", t));
}
function ok(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, s = i === void 0 ? !0 : i, a = n.roundOffsets, u = a === void 0 ? !0 : a, l = {
    placement: Sn(t.placement),
    variation: Co(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Uh(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Uh(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ik = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: ok,
  data: {}
};
var Ss = {
  passive: !0
};
function sk(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, s = r.resize, a = s === void 0 ? !0 : s, u = Ut(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(d) {
    d.addEventListener("scroll", n.update, Ss);
  }), a && u.addEventListener("resize", n.update, Ss), function() {
    i && l.forEach(function(d) {
      d.removeEventListener("scroll", n.update, Ss);
    }), a && u.removeEventListener("resize", n.update, Ss);
  };
}
const ak = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: sk,
  data: {}
};
var lk = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Qs(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return lk[t];
  });
}
var ck = {
  start: "end",
  end: "start"
};
function qh(e) {
  return e.replace(/start|end/g, function(t) {
    return ck[t];
  });
}
function ep(e) {
  var t = Ut(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function tp(e) {
  return bo(ur(e)).left + ep(e).scrollLeft;
}
function uk(e, t) {
  var n = Ut(e), r = ur(e), o = n.visualViewport, i = r.clientWidth, s = r.clientHeight, a = 0, u = 0;
  if (o) {
    i = o.width, s = o.height;
    var l = Fb();
    (l || !l && t === "fixed") && (a = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a + tp(e),
    y: u
  };
}
function dk(e) {
  var t, n = ur(e), r = ep(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = _r(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = _r(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -r.scrollLeft + tp(e), u = -r.scrollTop;
  return Hn(o || n).direction === "rtl" && (a += _r(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: a,
    y: u
  };
}
function np(e) {
  var t = Hn(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Vb(e) {
  return ["html", "body", "#document"].indexOf(xn(e)) >= 0 ? e.ownerDocument.body : Jt(e) && np(e) ? e : Vb(al(e));
}
function Ci(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Vb(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Ut(r), s = o ? [i].concat(i.visualViewport || [], np(r) ? r : []) : r, a = t.concat(s);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Ci(al(s)))
  );
}
function Qu(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function pk(e, t) {
  var n = bo(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Gh(e, t, n) {
  return t === Db ? Qu(uk(e, n)) : Er(t) ? pk(t, n) : Qu(dk(ur(e)));
}
function fk(e) {
  var t = Ci(al(e)), n = ["absolute", "fixed"].indexOf(Hn(e).position) >= 0, r = n && Jt(e) ? Ki(e) : e;
  return Er(r) ? t.filter(function(o) {
    return Er(o) && zb(o, r) && xn(o) !== "body";
  }) : [];
}
function hk(e, t, n, r) {
  var o = t === "clippingParents" ? fk(e) : [].concat(t), i = [].concat(o, [n]), s = i[0], a = i.reduce(function(u, l) {
    var d = Gh(e, l, r);
    return u.top = _r(d.top, u.top), u.right = wa(d.right, u.right), u.bottom = wa(d.bottom, u.bottom), u.left = _r(d.left, u.left), u;
  }, Gh(e, s, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Ub(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Sn(r) : null, i = r ? Co(r) : null, s = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, u;
  switch (o) {
    case kt:
      u = {
        x: s,
        y: t.y - n.height
      };
      break;
    case Qt:
      u = {
        x: s,
        y: t.y + t.height
      };
      break;
    case Zt:
      u = {
        x: t.x + t.width,
        y: a
      };
      break;
    case At:
      u = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var l = o ? Zd(o) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (i) {
      case yo:
        u[l] = u[l] - (t[d] / 2 - n[d] / 2);
        break;
      case Mi:
        u[l] = u[l] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return u;
}
function ki(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, s = i === void 0 ? e.strategy : i, a = n.boundary, u = a === void 0 ? AM : a, l = n.rootBoundary, d = l === void 0 ? Db : l, p = n.elementContext, f = p === void 0 ? Xo : p, h = n.altBoundary, g = h === void 0 ? !1 : h, m = n.padding, v = m === void 0 ? 0 : m, S = Hb(typeof v != "number" ? v : Wb(v, Gi)), _ = f === Xo ? $M : Xo, R = e.rects.popper, b = e.elements[g ? _ : f], y = hk(Er(b) ? b : b.contextElement || ur(e.elements.popper), u, d, s), w = bo(e.elements.reference), x = Ub({
    reference: w,
    element: R,
    strategy: "absolute",
    placement: o
  }), P = Qu(Object.assign({}, R, x)), N = f === Xo ? P : w, M = {
    top: y.top - N.top + S.top,
    bottom: N.bottom - y.bottom + S.bottom,
    left: y.left - N.left + S.left,
    right: N.right - y.right + S.right
  }, A = e.modifiersData.offset;
  if (f === Xo && A) {
    var T = A[o];
    Object.keys(M).forEach(function(D) {
      var j = [Zt, Qt].indexOf(D) >= 0 ? 1 : -1, F = [kt, Qt].indexOf(D) >= 0 ? "y" : "x";
      M[D] += T[F] * j;
    });
  }
  return M;
}
function mk(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, s = n.padding, a = n.flipVariations, u = n.allowedAutoPlacements, l = u === void 0 ? Bb : u, d = Co(r), p = d ? a ? Wh : Wh.filter(function(g) {
    return Co(g) === d;
  }) : Gi, f = p.filter(function(g) {
    return l.indexOf(g) >= 0;
  });
  f.length === 0 && (f = p);
  var h = f.reduce(function(g, m) {
    return g[m] = ki(e, {
      placement: m,
      boundary: o,
      rootBoundary: i,
      padding: s
    })[Sn(m)], g;
  }, {});
  return Object.keys(h).sort(function(g, m) {
    return h[g] - h[m];
  });
}
function gk(e) {
  if (Sn(e) === Xd)
    return [];
  var t = Qs(e);
  return [qh(e), t, qh(t)];
}
function yk(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !0 : s, u = n.fallbackPlacements, l = n.padding, d = n.boundary, p = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, g = h === void 0 ? !0 : h, m = n.allowedAutoPlacements, v = t.options.placement, S = Sn(v), _ = S === v, R = u || (_ || !g ? [Qs(v)] : gk(v)), b = [v].concat(R).reduce(function(W, Q) {
      return W.concat(Sn(Q) === Xd ? mk(t, {
        placement: Q,
        boundary: d,
        rootBoundary: p,
        padding: l,
        flipVariations: g,
        allowedAutoPlacements: m
      }) : Q);
    }, []), y = t.rects.reference, w = t.rects.popper, x = /* @__PURE__ */ new Map(), P = !0, N = b[0], M = 0; M < b.length; M++) {
      var A = b[M], T = Sn(A), D = Co(A) === yo, j = [kt, Qt].indexOf(T) >= 0, F = j ? "width" : "height", z = ki(t, {
        placement: A,
        boundary: d,
        rootBoundary: p,
        altBoundary: f,
        padding: l
      }), H = j ? D ? Zt : At : D ? Qt : kt;
      y[F] > w[F] && (H = Qs(H));
      var ee = Qs(H), X = [];
      if (i && X.push(z[T] <= 0), a && X.push(z[H] <= 0, z[ee] <= 0), X.every(function(W) {
        return W;
      })) {
        N = A, P = !1;
        break;
      }
      x.set(A, X);
    }
    if (P)
      for (var k = g ? 3 : 1, $ = function(Q) {
        var G = b.find(function(V) {
          var U = x.get(V);
          if (U)
            return U.slice(0, Q).every(function(Z) {
              return Z;
            });
        });
        if (G)
          return N = G, "break";
      }, Y = k; Y > 0; Y--) {
        var K = $(Y);
        if (K === "break")
          break;
      }
    t.placement !== N && (t.modifiersData[r]._skip = !0, t.placement = N, t.reset = !0);
  }
}
const vk = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: yk,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Kh(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Yh(e) {
  return [kt, Zt, Qt, At].some(function(t) {
    return e[t] >= 0;
  });
}
function bk(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, s = ki(t, {
    elementContext: "reference"
  }), a = ki(t, {
    altBoundary: !0
  }), u = Kh(s, r), l = Kh(a, o, i), d = Yh(u), p = Yh(l);
  t.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": p
  });
}
const Ck = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: bk
};
function Sk(e, t, n) {
  var r = Sn(e), o = [At, kt].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = i[0], a = i[1];
  return s = s || 0, a = (a || 0) * o, [At, Zt].indexOf(r) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function wk(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, s = Bb.reduce(function(d, p) {
    return d[p] = Sk(p, t.rects, i), d;
  }, {}), a = s[t.placement], u = a.x, l = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = s;
}
const _k = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: wk
};
function xk(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Ub({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Tk = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: xk,
  data: {}
};
function Ek(e) {
  return e === "x" ? "y" : "x";
}
function Rk(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !1 : s, u = n.boundary, l = n.rootBoundary, d = n.altBoundary, p = n.padding, f = n.tether, h = f === void 0 ? !0 : f, g = n.tetherOffset, m = g === void 0 ? 0 : g, v = ki(t, {
    boundary: u,
    rootBoundary: l,
    padding: p,
    altBoundary: d
  }), S = Sn(t.placement), _ = Co(t.placement), R = !_, b = Zd(S), y = Ek(b), w = t.modifiersData.popperOffsets, x = t.rects.reference, P = t.rects.popper, N = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, M = typeof N == "number" ? {
    mainAxis: N,
    altAxis: N
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, N), A = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, T = {
    x: 0,
    y: 0
  };
  if (w) {
    if (i) {
      var D, j = b === "y" ? kt : At, F = b === "y" ? Qt : Zt, z = b === "y" ? "height" : "width", H = w[b], ee = H + v[j], X = H - v[F], k = h ? -P[z] / 2 : 0, $ = _ === yo ? x[z] : P[z], Y = _ === yo ? -P[z] : -x[z], K = t.elements.arrow, W = h && K ? Qd(K) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : jb(), G = Q[j], V = Q[F], U = bi(0, x[z], W[z]), Z = R ? x[z] / 2 - k - U - G - M.mainAxis : $ - U - G - M.mainAxis, te = R ? -x[z] / 2 + k + U + V + M.mainAxis : Y + U + V + M.mainAxis, ie = t.elements.arrow && Ki(t.elements.arrow), B = ie ? b === "y" ? ie.clientTop || 0 : ie.clientLeft || 0 : 0, oe = (D = A == null ? void 0 : A[b]) != null ? D : 0, q = H + Z - oe - B, pe = H + te - oe, ge = bi(h ? wa(ee, q) : ee, H, h ? _r(X, pe) : X);
      w[b] = ge, T[b] = ge - H;
    }
    if (a) {
      var Ee, be = b === "x" ? kt : At, ye = b === "x" ? Qt : Zt, Re = w[y], Me = y === "y" ? "height" : "width", Ie = Re + v[be], ae = Re - v[ye], Se = [kt, At].indexOf(S) !== -1, mt = (Ee = A == null ? void 0 : A[y]) != null ? Ee : 0, ke = Se ? Ie : Re - x[Me] - P[Me] - mt + M.altAxis, Qe = Se ? Re + x[Me] + P[Me] - mt - M.altAxis : ae, we = h && Se ? JM(ke, Re, Qe) : bi(h ? ke : Ie, Re, h ? Qe : ae);
      w[y] = we, T[y] = we - Re;
    }
    t.modifiersData[r] = T;
  }
}
const Ok = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Rk,
  requiresIfExists: ["offset"]
};
function Pk(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Ik(e) {
  return e === Ut(e) || !Jt(e) ? ep(e) : Pk(e);
}
function Nk(e) {
  var t = e.getBoundingClientRect(), n = vo(t.width) / e.offsetWidth || 1, r = vo(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Mk(e, t, n) {
  n === void 0 && (n = !1);
  var r = Jt(t), o = Jt(t) && Nk(t), i = ur(t), s = bo(e, o, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((xn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  np(i)) && (a = Ik(t)), Jt(t) ? (u = bo(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : i && (u.x = tp(i))), {
    x: s.left + a.scrollLeft - u.x,
    y: s.top + a.scrollTop - u.y,
    width: s.width,
    height: s.height
  };
}
function kk(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var u = t.get(a);
        u && o(u);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function Ak(e) {
  var t = kk(e);
  return UM.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function $k(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Lk(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Xh = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Jh() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Dk(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? Xh : o;
  return function(a, u, l) {
    l === void 0 && (l = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Xh, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: u
      },
      attributes: {},
      styles: {}
    }, p = [], f = !1, h = {
      state: d,
      setOptions: function(S) {
        var _ = typeof S == "function" ? S(d.options) : S;
        m(), d.options = Object.assign({}, i, d.options, _), d.scrollParents = {
          reference: Er(a) ? Ci(a) : a.contextElement ? Ci(a.contextElement) : [],
          popper: Ci(u)
        };
        var R = Ak(Lk([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = R.filter(function(b) {
          return b.enabled;
        }), g(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var S = d.elements, _ = S.reference, R = S.popper;
          if (Jh(_, R)) {
            d.rects = {
              reference: Mk(_, Ki(R), d.options.strategy === "fixed"),
              popper: Qd(R)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(M) {
              return d.modifiersData[M.name] = Object.assign({}, M.data);
            });
            for (var b = 0; b < d.orderedModifiers.length; b++) {
              if (d.reset === !0) {
                d.reset = !1, b = -1;
                continue;
              }
              var y = d.orderedModifiers[b], w = y.fn, x = y.options, P = x === void 0 ? {} : x, N = y.name;
              typeof w == "function" && (d = w({
                state: d,
                options: P,
                name: N,
                instance: h
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: $k(function() {
        return new Promise(function(v) {
          h.forceUpdate(), v(d);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!Jh(a, u))
      return h;
    h.setOptions(l).then(function(v) {
      !f && l.onFirstUpdate && l.onFirstUpdate(v);
    });
    function g() {
      d.orderedModifiers.forEach(function(v) {
        var S = v.name, _ = v.options, R = _ === void 0 ? {} : _, b = v.effect;
        if (typeof b == "function") {
          var y = b({
            state: d,
            name: S,
            instance: h,
            options: R
          }), w = function() {
          };
          p.push(y || w);
        }
      });
    }
    function m() {
      p.forEach(function(v) {
        return v();
      }), p = [];
    }
    return h;
  };
}
var Bk = [ak, Tk, ik, KM, _k, vk, Ok, tk, Ck], Fk = /* @__PURE__ */ Dk({
  defaultModifiers: Bk
});
function zk(e) {
  return Ve("MuiPopper", e);
}
Le("MuiPopper", ["root"]);
function jk(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function _a(e) {
  return typeof e == "function" ? e() : e;
}
function ll(e) {
  return e.nodeType !== void 0;
}
function Hk(e) {
  return !ll(e);
}
const Wk = (e) => {
  const {
    classes: t
  } = e;
  return Ye({
    root: ["root"]
  }, zk, t);
}, Vk = {}, Uk = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var z;
  const F = t, {
    anchorEl: r,
    children: o,
    direction: i,
    disablePortal: s,
    modifiers: a,
    open: u,
    placement: l,
    popperOptions: d,
    popperRef: p,
    slotProps: f = {},
    slots: h = {},
    TransitionProps: g,
    ownerState: m
  } = F, v = re(F, [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    // @ts-ignore internal logic
    "ownerState"
  ]), S = E.useRef(null), _ = yt(S, n), R = E.useRef(null), b = yt(R, p), y = E.useRef(b);
  ln(() => {
    y.current = b;
  }, [b]), E.useImperativeHandle(p, () => R.current, []);
  const w = jk(l, i), [x, P] = E.useState(w), [N, M] = E.useState(_a(r));
  E.useEffect(() => {
    R.current && R.current.forceUpdate();
  }), E.useEffect(() => {
    r && M(_a(r));
  }, [r]), ln(() => {
    if (!N || !u)
      return;
    const H = (k) => {
      P(k.placement);
    };
    if (process.env.NODE_ENV !== "production" && N && ll(N) && N.nodeType === 1) {
      const k = N.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && k.top === 0 && k.left === 0 && k.right === 0 && k.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let ee = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: k
      }) => {
        H(k);
      }
    }];
    a != null && (ee = ee.concat(a)), d && d.modifiers != null && (ee = ee.concat(d.modifiers));
    const X = Fk(N, S.current, L(C({
      placement: w
    }, d), {
      modifiers: ee
    }));
    return y.current(X), () => {
      X.destroy(), y.current(null);
    };
  }, [N, s, a, u, d, w]);
  const A = {
    placement: x
  };
  g !== null && (A.TransitionProps = g);
  const T = Wk(t), D = (z = h.root) != null ? z : "div", j = xv({
    elementType: D,
    externalSlotProps: f.root,
    externalForwardedProps: v,
    additionalProps: {
      role: "tooltip",
      ref: _
    },
    ownerState: t,
    className: T.root
  });
  return /* @__PURE__ */ O(D, L(C({}, j), {
    children: typeof o == "function" ? o(A) : o
  }));
}), qb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const M = t, {
    anchorEl: r,
    children: o,
    container: i,
    direction: s = "ltr",
    disablePortal: a = !1,
    keepMounted: u = !1,
    modifiers: l,
    open: d,
    placement: p = "bottom",
    popperOptions: f = Vk,
    popperRef: h,
    style: g,
    transition: m = !1,
    slotProps: v = {},
    slots: S = {}
  } = M, _ = re(M, [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
  ]), [R, b] = E.useState(!0), y = () => {
    b(!1);
  }, w = () => {
    b(!0);
  };
  if (!u && !d && (!m || R))
    return null;
  let x;
  if (i)
    x = i;
  else if (r) {
    const A = _a(r);
    x = A && ll(A) ? Vt(A).body : Vt(null).body;
  }
  const P = !d && u && (!m || R) ? "none" : void 0, N = m ? {
    in: d,
    onEnter: y,
    onExited: w
  } : void 0;
  return /* @__PURE__ */ O(ib, {
    disablePortal: a,
    container: x,
    children: /* @__PURE__ */ O(Uk, L(C({
      anchorEl: r,
      direction: s,
      disablePortal: a,
      modifiers: l,
      ref: n,
      open: m ? !R : d,
      placement: p,
      popperOptions: f,
      popperRef: h,
      slotProps: v,
      slots: S
    }, _), {
      style: C({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: P
      }, g),
      TransitionProps: N,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (qb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Vn(c.oneOfType([zn, c.object, c.func]), (e) => {
    if (e.open) {
      const t = _a(e.anchorEl);
      if (t && ll(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || Hk(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([zn, c.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: c.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: un,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
const qk = qb, Gk = ue(qk, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Gb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var P;
  const r = qi(), x = tt({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: s,
    components: a,
    componentsProps: u,
    container: l,
    disablePortal: d,
    keepMounted: p,
    modifiers: f,
    open: h,
    placement: g,
    popperOptions: m,
    popperRef: v,
    transition: S,
    slots: _,
    slotProps: R
  } = x, b = re(x, [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
  ]), y = (P = _ == null ? void 0 : _.root) != null ? P : a == null ? void 0 : a.Root, w = C({
    anchorEl: i,
    container: l,
    disablePortal: d,
    keepMounted: p,
    modifiers: f,
    open: h,
    placement: g,
    popperOptions: m,
    popperRef: v,
    transition: S
  }, b);
  return /* @__PURE__ */ O(Gk, L(C({
    as: s,
    direction: r ? "rtl" : "ltr",
    slots: {
      root: y
    },
    slotProps: R != null ? R : u
  }, w), {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Gb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: c.oneOfType([zn, c.object, c.func]),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([zn, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: un,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
const Kb = Gb;
function Kk(e) {
  return Ve("MuiTooltip", e);
}
const Yk = Le("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), lt = Yk;
function Xk(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Jk = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: o,
    placement: i
  } = e, s = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", o && "touch", `tooltipPlacement${ve(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Ye(s, Kk, t);
}, Qk = ue(Kb, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})($e(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${lt.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${lt.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${lt.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${lt.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${lt.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${lt.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${lt.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${lt.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), Zk = ue("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${ve(n.placement.split("-")[0])}`]];
  }
})($e(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : dt(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${lt.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${lt.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${lt.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${lt.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${Xk(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${lt.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${lt.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${lt.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${lt.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${lt.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${lt.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${lt.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${lt.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${lt.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${lt.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), eA = ue("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})($e(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : dt(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let ws = !1;
const Qh = new Qa();
let Jo = {
  x: 0,
  y: 0
};
function _s(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const Yb = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var Dr, dr, dn;
  const r = tt({
    props: t,
    name: "MuiTooltip"
  }), Lr = r, {
    arrow: o = !1,
    children: i,
    classes: s,
    components: a = {},
    componentsProps: u = {},
    describeChild: l = !1,
    disableFocusListener: d = !1,
    disableHoverListener: p = !1,
    disableInteractive: f = !1,
    disableTouchListener: h = !1,
    enterDelay: g = 100,
    enterNextDelay: m = 0,
    enterTouchDelay: v = 700,
    followCursor: S = !1,
    id: _,
    leaveDelay: R = 0,
    leaveTouchDelay: b = 1500,
    onClose: y,
    onOpen: w,
    open: x,
    placement: P = "bottom",
    PopperComponent: N,
    PopperProps: M = {},
    slotProps: A = {},
    slots: T = {},
    title: D,
    TransitionComponent: j,
    TransitionProps: F
  } = Lr, z = re(Lr, [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
  ]), H = /* @__PURE__ */ E.isValidElement(i) ? i : /* @__PURE__ */ O("span", {
    children: i
  }), ee = Za(), X = qi(), [k, $] = E.useState(), [Y, K] = E.useState(null), W = E.useRef(!1), Q = f || S, G = oo(), V = oo(), U = oo(), Z = oo(), [te, ie] = Pi({
    controlled: x,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let B = te;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: me
    } = E.useRef(x !== void 0);
    E.useEffect(() => {
      k && k.disabled && !me && D !== "" && k.tagName.toLowerCase() === "button" && console.warn(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [D, k, me]);
  }
  const oe = Oi(_), q = E.useRef(), pe = Ln(() => {
    q.current !== void 0 && (document.body.style.WebkitUserSelect = q.current, q.current = void 0), Z.clear();
  });
  E.useEffect(() => pe, [pe]);
  const ge = (me) => {
    Qh.clear(), ws = !0, ie(!0), w && !B && w(me);
  }, Ee = Ln(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (me) => {
      Qh.start(800 + R, () => {
        ws = !1;
      }), ie(!1), y && B && y(me), G.start(ee.transitions.duration.shortest, () => {
        W.current = !1;
      });
    }
  ), be = (me) => {
    W.current && me.type !== "touchstart" || (k && k.removeAttribute("title"), V.clear(), U.clear(), g || ws && m ? V.start(ws ? m : g, () => {
      ge(me);
    }) : ge(me));
  }, ye = (me) => {
    V.clear(), U.start(R, () => {
      Ee(me);
    });
  }, [, Re] = E.useState(!1), Me = (me) => {
    ha(me.target) || (Re(!1), ye(me));
  }, Ie = (me) => {
    k || $(me.currentTarget), ha(me.target) && (Re(!0), be(me));
  }, ae = (me) => {
    W.current = !0;
    const it = H.props;
    it.onTouchStart && it.onTouchStart(me);
  }, Se = (me) => {
    ae(me), U.clear(), G.clear(), pe(), q.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Z.start(v, () => {
      document.body.style.WebkitUserSelect = q.current, be(me);
    });
  }, mt = (me) => {
    H.props.onTouchEnd && H.props.onTouchEnd(me), pe(), U.start(b, () => {
      Ee(me);
    });
  };
  E.useEffect(() => {
    if (!B)
      return;
    function me(it) {
      it.key === "Escape" && Ee(it);
    }
    return document.addEventListener("keydown", me), () => {
      document.removeEventListener("keydown", me);
    };
  }, [Ee, B]);
  const ke = yt(Ro(H), $, n);
  !D && D !== 0 && (B = !1);
  const Qe = E.useRef(), we = (me) => {
    const it = H.props;
    it.onMouseMove && it.onMouseMove(me), Jo = {
      x: me.clientX,
      y: me.clientY
    }, Qe.current && Qe.current.update();
  }, Ne = {}, Ue = typeof D == "string";
  l ? (Ne.title = !B && Ue && !p ? D : null, Ne["aria-describedby"] = B ? oe : null) : (Ne["aria-label"] = Ue ? D : null, Ne["aria-labelledby"] = B && !Ue ? oe : null);
  const Ae = C(L(C(C(C({}, Ne), z), H.props), {
    className: xe(z.className, H.props.className),
    onTouchStart: ae,
    ref: ke
  }), S ? {
    onMouseMove: we
  } : {});
  process.env.NODE_ENV !== "production" && (Ae["data-mui-internal-clone-element"] = !0, E.useEffect(() => {
    k && !k.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [k]));
  const je = {};
  h || (Ae.onTouchStart = Se, Ae.onTouchEnd = mt), p || (Ae.onMouseOver = _s(be, Ae.onMouseOver), Ae.onMouseLeave = _s(ye, Ae.onMouseLeave), Q || (je.onMouseOver = be, je.onMouseLeave = ye)), d || (Ae.onFocus = _s(Ie, Ae.onFocus), Ae.onBlur = _s(Me, Ae.onBlur), Q || (je.onFocus = Ie, je.onBlur = Me)), process.env.NODE_ENV !== "production" && H.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${H.props.title}\` or the Tooltip component.`].join(`
`));
  const ce = L(C({}, r), {
    isRtl: X,
    arrow: o,
    disableInteractive: Q,
    placement: P,
    PopperComponentProp: N,
    touch: W.current
  }), Pe = typeof A.popper == "function" ? A.popper(ce) : A.popper, $t = E.useMemo(() => {
    var it, Dt;
    let me = [{
      name: "arrow",
      enabled: !!Y,
      options: {
        element: Y,
        padding: 4
      }
    }];
    return (it = M.popperOptions) != null && it.modifiers && (me = me.concat(M.popperOptions.modifiers)), (Dt = Pe == null ? void 0 : Pe.popperOptions) != null && Dt.modifiers && (me = me.concat(Pe.popperOptions.modifiers)), L(C(C({}, M.popperOptions), Pe == null ? void 0 : Pe.popperOptions), {
      modifiers: me
    });
  }, [Y, M.popperOptions, Pe == null ? void 0 : Pe.popperOptions]), Lt = Jk(ce), le = typeof A.transition == "function" ? A.transition(ce) : A.transition, de = {
    slots: C({
      popper: a.Popper,
      transition: (Dr = a.Transition) != null ? Dr : j,
      tooltip: a.Tooltip,
      arrow: a.Arrow
    }, T),
    slotProps: {
      arrow: (dr = A.arrow) != null ? dr : u.arrow,
      popper: C(C({}, M), Pe != null ? Pe : u.popper),
      // resolvedPopperProps can be spread because it's already an object
      tooltip: (dn = A.tooltip) != null ? dn : u.tooltip,
      transition: C(C({}, F), le != null ? le : u.transition)
    }
  }, [Te, ot] = Ke("popper", {
    elementType: Qk,
    externalForwardedProps: de,
    ownerState: ce,
    className: xe(Lt.popper, M == null ? void 0 : M.className)
  }), [nn, Mr] = Ke("transition", {
    elementType: ob,
    externalForwardedProps: de,
    ownerState: ce
  }), [kr, Ar] = Ke("tooltip", {
    elementType: Zk,
    className: Lt.tooltip,
    externalForwardedProps: de,
    ownerState: ce
  }), [$r, No] = Ke("arrow", {
    elementType: eA,
    className: Lt.arrow,
    externalForwardedProps: de,
    ownerState: ce,
    ref: K
  });
  return /* @__PURE__ */ fe(E.Fragment, {
    children: [/* @__PURE__ */ E.cloneElement(H, Ae), /* @__PURE__ */ O(Te, L(C(C({
      as: N != null ? N : Kb,
      placement: P,
      anchorEl: S ? {
        getBoundingClientRect: () => ({
          top: Jo.y,
          left: Jo.x,
          right: Jo.x,
          bottom: Jo.y,
          width: 0,
          height: 0
        })
      } : k,
      popperRef: Qe,
      open: k ? B : !1,
      id: oe,
      transition: !0
    }, je), ot), {
      popperOptions: $t,
      children: ({
        TransitionProps: me
      }) => /* @__PURE__ */ O(nn, L(C(C({
        timeout: ee.transitions.duration.shorter
      }, me), Mr), {
        children: /* @__PURE__ */ fe(kr, L(C({}, Ar), {
          children: [D, o ? /* @__PURE__ */ O($r, C({}, No)) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (Yb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: c.bool,
  /**
   * Tooltip reference element.
   */
  children: Ui.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: c.shape({
    Arrow: c.elementType,
    Popper: c.elementType,
    Tooltip: c.elementType,
    Transition: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: c.shape({
    arrow: c.object,
    popper: c.object,
    tooltip: c.object,
    transition: c.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: c.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: c.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: c.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: c.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: c.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: c.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: c.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: c.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: c.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: c.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: c.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: c.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: c.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: c.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    arrow: c.oneOfType([c.func, c.object]),
    popper: c.oneOfType([c.func, c.object]),
    tooltip: c.oneOfType([c.func, c.object]),
    transition: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    arrow: c.elementType,
    popper: c.elementType,
    tooltip: c.elementType,
    transition: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: c.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: c.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: c.object
});
const tA = Yb, nr = Object.freeze({
  SISENSE_NAMESPACE: "sis-scope",
  TEXT_PRIMARY: "slf-text-primary",
  TEXT_SECONDARY: "slf-text-secondary",
  TEXT_SECONDARY_HOVER: "slf-text-secondary-hov",
  TEXT_HREF: "slf-text-href",
  TEXT_HREF_HOVER: "slf-text-href-hov"
}), nA = cr({
  components: {
    MuiTooltip: {
      styleOverrides: {
        arrow: {
          color: gt.StBackgroundColors.workspace
        },
        tooltip: {
          color: gt.StTextColors.content,
          maxWidth: "432px",
          borderRadius: "4px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          padding: "12px 16px",
          gap: "10px",
          backgroundColor: gt.StBackgroundColors.workspace,
          filter: "drop-shadow(0px 1px 4px rgba(9, 9, 10, 0.1)) drop-shadow(0px 4px 12px rgba(9, 9, 10, 0.2));"
        }
      }
    }
  }
}), rA = "#2c3342", oA = "#f4f4f8", iA = "#dee1e7", sA = "#fff", aA = "Tooltip-module__breakLongWord___ToaxI", lA = "Tooltip-module__semanticText___VRqnW", cA = "Tooltip-module__tooltip___iGDQF", uA = "Tooltip-module__rcToolTipZoomIn___Qwshk", dA = "Tooltip-module__rcToolTipZoomOut___p2GXV", pA = {
  loginDarkColor: rA,
  darkBtnHoverColor: oA,
  greyHoverColor: iA,
  defaultBackgroundColor: sA,
  breakLongWord: aA,
  semanticText: lA,
  tooltip: cA,
  rcToolTipZoomIn: uA,
  rcToolTipZoomOut: dA
}, rp = Bi(
  (s, i) => {
    var a = s, { title: e, children: t, arrow: n, theme: r = nA } = a, o = re(a, ["title", "children", "arrow", "theme"]);
    const { classes: u = {} } = o, l = L(C({}, u), {
      tooltip: he(
        pA.tooltip,
        u.tooltip,
        nr.SISENSE_NAMESPACE
      )
    });
    return /* @__PURE__ */ O(Po, { children: /* @__PURE__ */ O(Oo, { theme: r, children: /* @__PURE__ */ O(tA, L(C({}, o), { title: e, arrow: n, ref: i, classes: l, children: t })) }) });
  }
), fA = "sisense-pivot__resize-control", hA = (e) => typeof e == "undefined" ? !0 : !!e;
class mA extends E.Component {
  constructor() {
    super(...arguments);
    I(this, "resizeControlPosition", 0);
    I(this, "widthAfterResize", 0);
    I(this, "currentElementWidth", 0);
    I(this, "onMouseDown", (n) => {
      n.preventDefault(), this.currentElementWidth = this.props.onResizeStart(), this.resizeControlPosition = n.clientX, window.addEventListener("mouseup", this.onHandleUp), window.addEventListener("mousemove", this.onHandleResize);
    });
    I(this, "onClick", (n) => {
      n.stopPropagation();
    });
    I(this, "onHandleUp", (n) => {
      const { clientX: r } = n;
      if (!this.widthAfterResize) {
        const o = r, i = this.resizeControlPosition - this.currentElementWidth;
        this.widthAfterResize = o - i;
      }
      this.props.onResizeEnd(this.widthAfterResize), window.removeEventListener("mousemove", this.onHandleResize, !1), window.removeEventListener("mouseup", this.onHandleUp, !1);
    });
    I(this, "onHandleResize", (n) => {
      this.resizeElement(n);
    });
  }
  shouldComponentUpdate() {
    return !1;
  }
  /**
   * Handler for resize element
   *
   * @param {any} event - event for resize
   * @returns {void} - return nothing
   * @private
   */
  resizeElement(n) {
    const { onResize: r } = this.props, { movementX: o, clientX: i } = n;
    if (hA(o)) {
      const s = i, a = this.resizeControlPosition - this.currentElementWidth;
      this.widthAfterResize = s - a, r(this.widthAfterResize);
    }
  }
  render() {
    return /* @__PURE__ */ O(
      "div",
      {
        className: fA,
        onMouseDownCapture: this.onMouseDown,
        onClick: this.onClick,
        role: "button",
        "aria-label": "Resize control",
        tabIndex: 0,
        onKeyPress: this.onClick
      }
    );
  }
}
const gA = "sisense-pivot__data-bar", Zh = "sisense-pivot__data-bar--show", em = "sisense-pivot__data-bar--show-active", yA = "sisense-pivot__data-bar-inner", vA = "sisense-pivot__data-bar-bar", bA = (e, t, n) => {
  if (typeof e == "undefined" || e === null || e === "0" || typeof t == "undefined" || t === null || typeof n == "undefined" || n === null)
    return [];
  const r = parseFloat(e);
  let o = 0, i = 0;
  if (t === n)
    return [];
  const s = (r - t) / (n - t) * 100;
  if (t >= 0 && n >= 0)
    o = 0, i = s;
  else if (t < 0 && n < 0)
    o = 100, i = (100 - s) * -1;
  else {
    const a = t * -1 / (n - t) * 100;
    r < 0, o = a, i = s - a;
  }
  return [o, i, r < 0 ? -1 : 1];
};
class CA extends E.Component {
  constructor(n) {
    super(n);
    I(this, "root");
    I(this, "style");
    I(this, "innerStyle");
    I(this, "timerShow");
    I(this, "timerShowInner");
    I(this, "onWidthChange", (n) => {
      const { columnIndex: r, dataNode: o } = this.props, { colsWidth: i, minMaxs: s } = n;
      let a = i[r];
      a += 8;
      const [u, l] = s[r] || [], d = o ? o.value : void 0, [p, f, h] = bA(d, u, l);
      this.style = void 0, this.innerStyle = void 0, this.setState({
        width: a,
        left: p,
        size: f,
        sign: h
      }), !(typeof p == "undefined" && typeof f == "undefined") && (this.root && this.root.classList.add(Zh), this.timerShow && cancelAnimationFrame(this.timerShow), this.timerShow = requestAnimationFrame(() => {
        this.timerShowInner && cancelAnimationFrame(this.timerShowInner), this.timerShowInner = requestAnimationFrame(() => {
          this.root && this.root.classList.add(em);
        });
      }));
    });
    I(this, "rootRef", (n) => {
      n && (this.root = n);
    });
    this.state = {
      width: 0,
      left: 0,
      size: 0
    };
  }
  componentDidMount() {
    if (this.props.tableSize) {
      this.props.tableSize.on(ii, this.onWidthChange);
      const n = this.props.tableSize.getDataBars();
      n && this.onWidthChange(n);
    }
  }
  UNSAFE_componentWillReceiveProps(n) {
    if ((n.tableSize !== this.props.tableSize || n.columnIndex !== this.props.columnIndex || n.dataNode !== this.props.dataNode || n.style !== this.props.style) && (this.style = void 0, this.innerStyle = void 0, this.root && (this.root.classList.remove(Zh), this.root.classList.remove(em))), n.tableSize !== this.props.tableSize && (this.props.tableSize && this.props.tableSize.off(ii, this.onWidthChange), n.tableSize)) {
      n.tableSize.on(ii, this.onWidthChange);
      const r = n.tableSize.getDataBars();
      r && this.onWidthChange(r);
    }
  }
  componentWillUnmount() {
    this.root = void 0, this.props.tableSize && this.props.tableSize.off(ii, this.onWidthChange), this.timerShow && cancelAnimationFrame(this.timerShow), this.timerShowInner && cancelAnimationFrame(this.timerShowInner);
  }
  getStyle() {
    if (!this.style) {
      const { width: n } = this.state;
      if (typeof n == "undefined")
        return this.style = {}, this.style;
      this.style = {
        width: `calc(100% - ${n}px)`
      };
    }
    return this.style;
  }
  getInnerStyle() {
    if (!this.innerStyle) {
      const { style: n } = this.props, { left: r, size: o, sign: i } = this.state;
      if (typeof r == "undefined" || typeof o == "undefined")
        return this.innerStyle = {}, this.innerStyle;
      i === 1 ? this.innerStyle = L(C({}, n), {
        left: `${r}%`,
        width: `${o}%`
      }) : this.innerStyle = L(C({}, n), {
        right: `${100 - r}%`,
        width: `${-1 * o}%`
      });
    }
    return this.innerStyle;
  }
  render() {
    const { dataNode: n } = this.props;
    if (!n || n.value === null)
      return null;
    const r = this.getStyle(), o = this.getInnerStyle();
    return /* @__PURE__ */ O("div", { className: gA, style: r, ref: this.rootRef, children: /* @__PURE__ */ O("div", { className: yA, children: /* @__PURE__ */ O("div", { className: vA, style: o }) }) });
  }
}
class Xb extends E.PureComponent {
  constructor(n) {
    super(n);
    /** content padding */
    I(this, "cellPadding");
    /** ratio of an image */
    I(this, "ratio");
    I(this, "defaultHeight");
    /** container style object */
    I(this, "style", {});
    // @ts-ignore
    I(this, "domReadyDefer");
    I(this, "setDefer", () => {
      const n = {
        promise: Promise.resolve(),
        resolve() {
          return !0;
        },
        reject() {
          return !1;
        }
      }, r = new Promise((o, i) => {
        n.resolve = o, n.reject = i;
      });
      this.domReadyDefer = L(C({}, n), {
        promise: r
      }), this.props.addCellDomReadyPromise && this.props.addCellDomReadyPromise(this.domReadyDefer);
    });
    I(this, "onLoad", (n) => {
      const r = n.currentTarget.naturalWidth, o = n.currentTarget.naturalHeight;
      this.ratio = r / o, this.setImageStyle(), setTimeout(() => {
        this.domReadyDefer && this.domReadyDefer.resolve();
      }, 0);
    });
    I(this, "onError", (n) => {
      const r = (this.props.defaultHeight || this.defaultHeight) - this.cellPadding;
      this.setState({
        imageUrl: this.props.fallbackImageUrl || "",
        imageStyle: {
          position: "absolute",
          top: "0",
          left: "0",
          display: "block",
          width: r,
          height: r
        }
      }), setTimeout(() => {
        this.domReadyDefer && this.domReadyDefer.resolve(n);
      }, 0);
    });
    this.cellPadding = 7, this.ratio = 0, this.defaultHeight = 60, this.setStyle(), this.state = {
      imageUrl: n.imageUrl,
      imageStyle: {
        position: "absolute",
        top: "0",
        left: "0",
        display: "block",
        width: this.getHeight() * this.ratio,
        height: "100%"
      }
    }, this.setDefer();
  }
  UNSAFE_componentWillReceiveProps(n) {
    this.props.rowHeight !== n.rowHeight && (this.setStyle(n), this.setImageStyle(n)), this.props.imageUrl !== n.imageUrl && this.setState({
      imageUrl: n.imageUrl
    });
  }
  componentWillUnmount() {
    this.props.removeCellDomReadyPromise && this.props.removeCellDomReadyPromise(this.domReadyDefer);
  }
  getHeight(n) {
    return ((n ? n.rowHeight : this.props.rowHeight) || this.defaultHeight) - this.cellPadding;
  }
  setStyle(n) {
    this.style = {
      position: "relative",
      display: "block",
      width: "100%",
      height: this.getHeight(n),
      fontSize: 0,
      lineHeight: 0
    };
  }
  setImageStyle(n) {
    const r = this.ratio * this.getHeight(n);
    this.setState({
      imageStyle: {
        position: "absolute",
        top: "0",
        left: "0",
        display: "block",
        width: r,
        height: "100%"
      }
    });
  }
  render() {
    return /* @__PURE__ */ O("div", { style: this.style, children: /* @__PURE__ */ O(
      "img",
      {
        src: this.state.imageUrl,
        alt: "",
        style: this.state.imageStyle,
        onLoad: this.onLoad,
        onError: this.onError
      }
    ) });
  }
}
I(Xb, "defaultProps", {
  rowHeight: 60,
  fallbackImageUrl: ""
});
var Zu = /* @__PURE__ */ ((e) => (e.topLeft = "tl", e.topCenter = "tc", e.topRight = "tr", e.centerLeft = "cl", e.centerCenter = "cc", e.centerRight = "cr", e.bottomLeft = "bl", e.bottomCenter = "bc", e.bottomRight = "br", e))(Zu || {});
const SA = (e) => {
  const {
    children: t,
    prefixCls: n,
    id: r,
    overlayInnerStyle: o,
    bodyClassName: i,
    className: s,
    style: a
  } = e;
  return /* @__PURE__ */ E.createElement("div", {
    className: he(`${n}-content`, s),
    style: a
  }, /* @__PURE__ */ E.createElement("div", {
    className: he(`${n}-inner`, i),
    id: r,
    role: "tooltip",
    style: o
  }, typeof t == "function" ? t() : t));
};
function wn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var ed = { exports: {} }, Fe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tm;
function wA() {
  if (tm)
    return Fe;
  tm = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function m(v) {
    if (typeof v == "object" && v !== null) {
      var S = v.$$typeof;
      switch (S) {
        case e:
          switch (v = v.type, v) {
            case n:
            case o:
            case r:
            case l:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case a:
                case s:
                case u:
                case f:
                case p:
                case i:
                  return v;
                default:
                  return S;
              }
          }
        case t:
          return S;
      }
    }
  }
  return Fe.ContextConsumer = s, Fe.ContextProvider = i, Fe.Element = e, Fe.ForwardRef = u, Fe.Fragment = n, Fe.Lazy = f, Fe.Memo = p, Fe.Portal = t, Fe.Profiler = o, Fe.StrictMode = r, Fe.Suspense = l, Fe.SuspenseList = d, Fe.isAsyncMode = function() {
    return !1;
  }, Fe.isConcurrentMode = function() {
    return !1;
  }, Fe.isContextConsumer = function(v) {
    return m(v) === s;
  }, Fe.isContextProvider = function(v) {
    return m(v) === i;
  }, Fe.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, Fe.isForwardRef = function(v) {
    return m(v) === u;
  }, Fe.isFragment = function(v) {
    return m(v) === n;
  }, Fe.isLazy = function(v) {
    return m(v) === f;
  }, Fe.isMemo = function(v) {
    return m(v) === p;
  }, Fe.isPortal = function(v) {
    return m(v) === t;
  }, Fe.isProfiler = function(v) {
    return m(v) === o;
  }, Fe.isStrictMode = function(v) {
    return m(v) === r;
  }, Fe.isSuspense = function(v) {
    return m(v) === l;
  }, Fe.isSuspenseList = function(v) {
    return m(v) === d;
  }, Fe.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === o || v === r || v === l || v === d || v === h || typeof v == "object" && v !== null && (v.$$typeof === f || v.$$typeof === p || v.$$typeof === i || v.$$typeof === s || v.$$typeof === u || v.$$typeof === g || v.getModuleId !== void 0);
  }, Fe.typeOf = m, Fe;
}
var He = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nm;
function _A() {
  return nm || (nm = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g = !1, m = !1, v = !1, S = !1, _ = !1, R;
    R = Symbol.for("react.module.reference");
    function b(q) {
      return !!(typeof q == "string" || typeof q == "function" || q === n || q === o || _ || q === r || q === l || q === d || S || q === h || g || m || v || typeof q == "object" && q !== null && (q.$$typeof === f || q.$$typeof === p || q.$$typeof === i || q.$$typeof === s || q.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      q.$$typeof === R || q.getModuleId !== void 0));
    }
    function y(q) {
      if (typeof q == "object" && q !== null) {
        var pe = q.$$typeof;
        switch (pe) {
          case e:
            var ge = q.type;
            switch (ge) {
              case n:
              case o:
              case r:
              case l:
              case d:
                return ge;
              default:
                var Ee = ge && ge.$$typeof;
                switch (Ee) {
                  case a:
                  case s:
                  case u:
                  case f:
                  case p:
                  case i:
                    return Ee;
                  default:
                    return pe;
                }
            }
          case t:
            return pe;
        }
      }
    }
    var w = s, x = i, P = e, N = u, M = n, A = f, T = p, D = t, j = o, F = r, z = l, H = d, ee = !1, X = !1;
    function k(q) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function $(q) {
      return X || (X = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Y(q) {
      return y(q) === s;
    }
    function K(q) {
      return y(q) === i;
    }
    function W(q) {
      return typeof q == "object" && q !== null && q.$$typeof === e;
    }
    function Q(q) {
      return y(q) === u;
    }
    function G(q) {
      return y(q) === n;
    }
    function V(q) {
      return y(q) === f;
    }
    function U(q) {
      return y(q) === p;
    }
    function Z(q) {
      return y(q) === t;
    }
    function te(q) {
      return y(q) === o;
    }
    function ie(q) {
      return y(q) === r;
    }
    function B(q) {
      return y(q) === l;
    }
    function oe(q) {
      return y(q) === d;
    }
    He.ContextConsumer = w, He.ContextProvider = x, He.Element = P, He.ForwardRef = N, He.Fragment = M, He.Lazy = A, He.Memo = T, He.Portal = D, He.Profiler = j, He.StrictMode = F, He.Suspense = z, He.SuspenseList = H, He.isAsyncMode = k, He.isConcurrentMode = $, He.isContextConsumer = Y, He.isContextProvider = K, He.isElement = W, He.isForwardRef = Q, He.isFragment = G, He.isLazy = V, He.isMemo = U, He.isPortal = Z, He.isProfiler = te, He.isStrictMode = ie, He.isSuspense = B, He.isSuspenseList = oe, He.isValidElementType = b, He.typeOf = y;
  }()), He;
}
process.env.NODE_ENV === "production" ? ed.exports = wA() : ed.exports = _A();
var fc = ed.exports;
function xA(e, t, n) {
  const r = E.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
const TA = Symbol.for("react.element"), EA = Symbol.for("react.transitional.element"), RA = Symbol.for("react.fragment");
function Jb(e) {
  return (
    // Base object type
    e && typeof e == "object" && // React Element type
    (e.$$typeof === TA || e.$$typeof === EA) && // React Fragment type
    e.type === RA
  );
}
const OA = Number(CC.split(".")[0]), PA = (e, t) => {
  typeof e == "function" ? e(t) : typeof e == "object" && e && "current" in e && (e.current = t);
}, Qb = (...e) => {
  const t = e.filter(Boolean);
  return t.length <= 1 ? t[0] : (n) => {
    e.forEach((r) => {
      PA(r, n);
    });
  };
}, Zb = (...e) => xA(
  () => Qb(...e),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  e,
  (t, n) => t.length !== n.length || t.every((r, o) => r !== n[o])
), op = (e) => {
  var t, n;
  if (!e)
    return !1;
  if (e0(e) && OA >= 19)
    return !0;
  const r = fc.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((t = r.prototype) != null && t.render) && r.$$typeof !== fc.ForwardRef || typeof e == "function" && !((n = e.prototype) != null && n.render) && e.$$typeof !== fc.ForwardRef);
};
function e0(e) {
  return /* @__PURE__ */ fi(e) && !Jb(e);
}
const ip = (e) => {
  if (e && e0(e)) {
    const t = e;
    return t.props.propertyIsEnumerable("ref") ? t.props.ref : t.ref;
  }
  return null;
};
let td = {};
const sp = [], IA = (e) => {
  sp.push(e);
};
function xa(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    const n = sp.reduce((r, o) => o(r != null ? r : "", "warning"), t);
    n && console.error(`Warning: ${n}`);
  }
}
function NA(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    const n = sp.reduce((r, o) => o(r != null ? r : "", "note"), t);
    n && console.warn(`Note: ${n}`);
  }
}
function MA() {
  td = {};
}
function t0(e, t, n) {
  !t && !td[n] && (e(!1, n), td[n] = !0);
}
function cl(e, t) {
  t0(xa, e, t);
}
function kA(e, t) {
  t0(NA, e, t);
}
cl.preMessage = IA;
cl.resetWarned = MA;
cl.noteOnce = kA;
const n0 = /* @__PURE__ */ E.createContext(null);
let AA = !1;
function $A(e) {
  return AA;
}
const rm = process.env.NODE_ENV !== "test" && wn() ? E.useLayoutEffect : E.useEffect, zt = (e, t) => {
  const n = E.useRef(!0);
  rm(() => e(n.current), t), rm(() => (n.current = !1, () => {
    n.current = !0;
  }), []);
}, om = [];
function LA(e, t) {
  const [n] = E.useState(() => {
    if (!wn())
      return null;
    const d = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && d.setAttribute("data-debug", t), d;
  }), r = E.useRef(!1), o = E.useContext(n0), [i, s] = E.useState(om), a = o || (r.current ? void 0 : (d) => {
    s((p) => [d, ...p]);
  });
  function u() {
    n.parentElement || document.body.appendChild(n), r.current = !0;
  }
  function l() {
    var d;
    (d = n.parentElement) == null || d.removeChild(n), r.current = !1;
  }
  return zt(() => (e ? o ? o(u) : u() : l(), l), [e]), zt(() => {
    i.length && (i.forEach((d) => d()), s(om));
  }, [i]), [n, a];
}
function DA(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  let n = t;
  for (; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
const im = "data-rc-order", sm = "data-rc-priority", BA = "rc-util-key", nd = /* @__PURE__ */ new Map();
function r0({
  mark: e
} = {}) {
  return e ? e.startsWith("data-") ? e : `data-${e}` : BA;
}
function ul(e) {
  return e.attachTo ? e.attachTo : document.querySelector("head") || document.body;
}
function FA(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function ap(e) {
  return Array.from((nd.get(e) || e).children).filter((t) => t.tagName === "STYLE");
}
function o0(e, t = {}) {
  if (!wn())
    return null;
  const {
    csp: n,
    prepend: r,
    priority: o = 0
  } = t, i = FA(r), s = i === "prependQueue", a = document.createElement("style");
  a.setAttribute(im, i), s && o && a.setAttribute(sm, `${o}`), n != null && n.nonce && (a.nonce = n == null ? void 0 : n.nonce), a.innerHTML = e;
  const u = ul(t), {
    firstChild: l
  } = u;
  if (r) {
    if (s) {
      const d = (t.styles || ap(u)).filter((p) => {
        if (!["prepend", "prependQueue"].includes(p.getAttribute(im)))
          return !1;
        const f = Number(p.getAttribute(sm) || 0);
        return o >= f;
      });
      if (d.length)
        return u.insertBefore(a, d[d.length - 1].nextSibling), a;
    }
    u.insertBefore(a, l);
  } else
    u.appendChild(a);
  return a;
}
function i0(e, t = {}) {
  let {
    styles: n
  } = t;
  return n || (n = ap(ul(t))), n.find((r) => r.getAttribute(r0(t)) === e);
}
function rd(e, t = {}) {
  const n = i0(e, t);
  n && ul(t).removeChild(n);
}
function zA(e, t) {
  const n = nd.get(e);
  if (!n || !DA(document, n)) {
    const r = o0("", t), {
      parentNode: o
    } = r;
    nd.set(e, o), e.removeChild(r);
  }
}
function s0(e, t, n = {}) {
  var r, o, i;
  const s = ul(n), a = ap(s), u = L(C({}, n), {
    styles: a
  });
  zA(s, u);
  const l = i0(t, u);
  if (l)
    return (r = u.csp) != null && r.nonce && l.nonce !== ((o = u.csp) == null ? void 0 : o.nonce) && (l.nonce = (i = u.csp) == null ? void 0 : i.nonce), l.innerHTML !== e && (l.innerHTML = e), l;
  const d = o0(e, u);
  return d.setAttribute(r0(u), t), d;
}
function jA(e) {
  const t = `rc-scrollbar-measure-${Math.random().toString(36).substring(7)}`, n = document.createElement("div");
  n.id = t;
  const r = n.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  let o, i;
  if (e) {
    const u = getComputedStyle(e);
    r.scrollbarColor = u.scrollbarColor, r.scrollbarWidth = u.scrollbarWidth;
    const l = getComputedStyle(e, "::-webkit-scrollbar"), d = parseInt(l.width, 10), p = parseInt(l.height, 10);
    try {
      const f = d ? `width: ${l.width};` : "", h = p ? `height: ${l.height};` : "";
      s0(`
#${t}::-webkit-scrollbar {
${f}
${h}
}`, t);
    } catch (f) {
      console.error(f), o = d, i = p;
    }
  }
  document.body.appendChild(n);
  const s = e && o && !isNaN(o) ? o : n.offsetWidth - n.clientWidth, a = e && i && !isNaN(i) ? i : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), rd(t), {
    width: s,
    height: a
  };
}
function HA(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : jA(e);
}
function WA() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
const VA = `rc-util-locker-${Date.now()}`;
let am = 0;
function UA(e) {
  const t = !!e, [n] = E.useState(() => (am += 1, `${VA}_${am}`));
  zt(() => {
    if (t) {
      const r = HA(document.body).width, o = WA();
      s0(`
html body {
  overflow-y: hidden;
  ${o ? `width: calc(100% - ${r}px);` : ""}
}`, n);
    } else
      rd(n);
    return () => {
      rd(n);
    };
  }, [t, n]);
}
const lm = (e) => e === !1 ? !1 : !wn() || !e ? null : typeof e == "string" ? document.querySelector(e) : typeof e == "function" ? e() : e, lp = /* @__PURE__ */ E.forwardRef((e, t) => {
  const {
    open: n,
    autoLock: r,
    getContainer: o,
    debug: i,
    autoDestroy: s = !0,
    children: a
  } = e, [u, l] = E.useState(n), d = u || n;
  process.env.NODE_ENV !== "production" && cl(wn() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), E.useEffect(() => {
    (s || n) && l(n);
  }, [n, s]);
  const [p, f] = E.useState(() => lm(o));
  E.useEffect(() => {
    const b = lm(o);
    f(b != null ? b : null);
  });
  const [h, g] = LA(d && !p, i), m = p != null ? p : h;
  UA(r && n && wn() && (m === h || m === document.body));
  let v = null;
  a && op(a) && t && (v = ip(a));
  const S = Zb(v, t);
  if (!d || !wn() || p === void 0)
    return null;
  const _ = m === !1 || $A();
  let R = a;
  return t && (R = /* @__PURE__ */ E.cloneElement(a, {
    ref: S
  })), /* @__PURE__ */ E.createElement(n0.Provider, {
    value: g
  }, _ ? R : /* @__PURE__ */ EC(R, m));
});
process.env.NODE_ENV !== "production" && (lp.displayName = "Portal");
function od(e, t = {}) {
  let n = [];
  return Ht.Children.forEach(e, (r) => {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(od(r)) : Jb(r) && r.props ? n = n.concat(od(r.props.children, t)) : n.push(r));
  }), n;
}
function Ai(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function a0(e) {
  return e && typeof e == "object" && Ai(e.nativeElement) ? e.nativeElement : Ai(e) ? e : null;
}
const id = /* @__PURE__ */ E.createContext(null);
function qA({
  children: e,
  onBatchResize: t
}) {
  const n = E.useRef(0), r = E.useRef([]), o = E.useContext(id), i = E.useCallback((s, a, u) => {
    n.current += 1;
    const l = n.current;
    r.current.push({
      size: s,
      element: a,
      data: u
    }), Promise.resolve().then(() => {
      l === n.current && (t == null || t(r.current), r.current = []);
    }), o == null || o(s, a, u);
  }, [t, o]);
  return /* @__PURE__ */ E.createElement(id.Provider, {
    value: i
  }, e);
}
const rr = /* @__PURE__ */ new Map();
function GA(e) {
  e.forEach((t) => {
    var n;
    const {
      target: r
    } = t;
    (n = rr.get(r)) == null || n.forEach((o) => o(r));
  });
}
let hc;
function l0() {
  return hc || (hc = new ResizeObserver(GA)), hc;
}
function KA(e, t) {
  rr.has(e) || (rr.set(e, /* @__PURE__ */ new Set()), l0().observe(e)), rr.get(e).add(t);
}
function YA(e, t) {
  rr.has(e) && (rr.get(e).delete(t), rr.get(e).size || (l0().unobserve(e), rr.delete(e)));
}
function XA(e, t) {
  const {
    children: n,
    disabled: r
  } = e, o = E.useRef(null), i = E.useContext(id), s = typeof n == "function", a = s ? n(o) : n, u = E.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), l = !s && /* @__PURE__ */ E.isValidElement(a) && op(a), d = l ? ip(a) : null, p = Zb(d, o), f = () => a0(o.current);
  E.useImperativeHandle(t, () => f());
  const h = E.useRef(e);
  h.current = e;
  const g = E.useCallback((m) => {
    const {
      onResize: v,
      data: S
    } = h.current, {
      width: _,
      height: R
    } = m.getBoundingClientRect(), {
      offsetWidth: b,
      offsetHeight: y
    } = m, w = Math.floor(_), x = Math.floor(R);
    if (u.current.width !== w || u.current.height !== x || u.current.offsetWidth !== b || u.current.offsetHeight !== y) {
      const P = {
        width: w,
        height: x,
        offsetWidth: b,
        offsetHeight: y
      };
      u.current = P;
      const N = b === Math.round(_) ? _ : b, M = y === Math.round(R) ? R : y, A = L(C({}, P), {
        offsetWidth: N,
        offsetHeight: M
      });
      i == null || i(A, m, S), v && Promise.resolve().then(() => {
        v(A, m);
      });
    }
  }, []);
  return E.useEffect(() => {
    const m = f();
    return m && !r && KA(m, g), () => YA(m, g);
  }, [o.current, r]), l ? /* @__PURE__ */ E.cloneElement(a, {
    ref: p
  }) : a;
}
const c0 = /* @__PURE__ */ E.forwardRef(XA);
process.env.NODE_ENV !== "production" && (c0.displayName = "SingleObserver");
function sd() {
  return sd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sd.apply(this, arguments);
}
const JA = "rc-observer-key";
function QA(e, t) {
  const {
    children: n
  } = e, r = typeof n == "function" ? [n] : od(n);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? xa(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && xa(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map((o, i) => {
    const s = (o == null ? void 0 : o.key) || `${JA}-${i}`;
    return /* @__PURE__ */ E.createElement(c0, sd({}, e, {
      key: s,
      ref: i === 0 ? t : void 0
    }), o);
  });
}
const dl = /* @__PURE__ */ E.forwardRef(QA);
process.env.NODE_ENV !== "production" && (dl.displayName = "ResizeObserver");
dl.Collection = qA;
function u0(e) {
  var t;
  return (t = e == null ? void 0 : e.getRootNode) == null ? void 0 : t.call(e);
}
function ZA(e) {
  return u0(e) instanceof ShadowRoot;
}
function ad(e) {
  return ZA(e) ? u0(e) : null;
}
function yn(e) {
  const t = E.useRef();
  return t.current = e, E.useCallback((...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function e$() {
  return C({}, E).useId;
}
let cm = 0;
const um = e$(), d0 = um ? (
  // Use React `useId`
  function(e) {
    const t = um();
    return e || (process.env.NODE_ENV === "test" ? "test-id" : t);
  }
) : (
  // Use compatible of `useId`
  function(e) {
    const [t, n] = E.useState("ssr-id");
    return E.useEffect(() => {
      const r = cm;
      cm += 1, n(`rc_unique_${r}`);
    }, []), e || (process.env.NODE_ENV === "test" ? "test-id" : t);
  }
), t$ = () => {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  const e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
}, n$ = /* @__PURE__ */ E.createContext({});
function ld(e) {
  const t = E.useRef(!1), [n, r] = E.useState(e);
  E.useEffect(() => (t.current = !1, () => {
    t.current = !0;
  }), []);
  function o(i, s) {
    s && t.current || r(i);
  }
  return [n, o];
}
function r$(e) {
  const [, t] = E.useReducer((i) => i + 1, 0), n = E.useRef(e), r = yn(() => n.current), o = yn((i) => {
    n.current = typeof i == "function" ? i(n.current) : i, t();
  });
  return [r, o];
}
const An = "none", xs = "appear", Ts = "enter", Es = "leave", dm = "none", sn = "prepare", so = "start", ao = "active", cp = "end", p0 = "prepared";
function pm(e, t) {
  const n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n[`Webkit${e}`] = `webkit${t}`, n[`Moz${e}`] = `moz${t}`, n[`ms${e}`] = `MS${t}`, n[`O${e}`] = `o${t.toLowerCase()}`, n;
}
function o$(e, t) {
  const n = {
    animationend: pm("Animation", "AnimationEnd"),
    transitionend: pm("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
const i$ = o$(wn(), typeof window < "u" ? window : {});
let f0 = {};
wn() && ({
  style: f0
} = document.createElement("div"));
const Rs = {};
function h0(e) {
  if (Rs[e])
    return Rs[e];
  const t = i$[e];
  if (t) {
    const n = Object.keys(t), r = n.length;
    for (let o = 0; o < r; o += 1) {
      const i = n[o];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in f0)
        return Rs[e] = t[i], Rs[e];
    }
  }
  return "";
}
const m0 = h0("animationend"), g0 = h0("transitionend"), s$ = !!(m0 && g0), fm = m0 || "animationend", hm = g0 || "transitionend";
function mm(e, t) {
  if (!e)
    return null;
  if (typeof e == "object") {
    const n = t.replace(/-\w/g, (r) => r[1].toUpperCase());
    return e[n];
  }
  return `${e}-${t}`;
}
const a$ = (e) => {
  const t = _t();
  function n(o) {
    o && (o.removeEventListener(hm, e), o.removeEventListener(fm, e));
  }
  function r(o) {
    t.current && t.current !== o && n(t.current), o && o !== t.current && (o.addEventListener(hm, e), o.addEventListener(fm, e), t.current = o);
  }
  return E.useEffect(() => () => {
    n(t.current);
  }, []), [r, n];
}, y0 = wn() ? Ma : or;
let v0 = (e) => +setTimeout(e, 16), b0 = (e) => clearTimeout(e);
typeof window < "u" && "requestAnimationFrame" in window && (v0 = (e) => window.requestAnimationFrame(e), b0 = (e) => window.cancelAnimationFrame(e));
let gm = 0;
const pl = /* @__PURE__ */ new Map();
function C0(e) {
  pl.delete(e);
}
const Ta = (e, t = 1) => {
  gm += 1;
  const n = gm;
  function r(o) {
    if (o === 0)
      C0(n), e();
    else {
      const i = v0(() => {
        r(o - 1);
      });
      pl.set(n, i);
    }
  }
  return r(t), n;
};
Ta.cancel = (e) => {
  const t = pl.get(e);
  return C0(e), b0(t);
};
process.env.NODE_ENV !== "production" && (Ta.ids = () => pl);
const l$ = () => {
  const e = E.useRef(null);
  function t() {
    Ta.cancel(e.current);
  }
  function n(r, o = 2) {
    t();
    const i = Ta(() => {
      o <= 1 ? r({
        isCanceled: () => i !== e.current
      }) : n(r, o - 1);
    });
    e.current = i;
  }
  return E.useEffect(() => () => {
    t();
  }, []), [n, t];
}, c$ = [sn, so, ao, cp], u$ = [sn, p0], S0 = !1, d$ = !0;
function w0(e) {
  return e === ao || e === cp;
}
const p$ = (e, t, n) => {
  const [r, o] = ld(dm), [i, s] = l$();
  function a() {
    o(sn, !0);
  }
  const u = t ? u$ : c$;
  return y0(() => {
    if (r !== dm && r !== cp) {
      const l = u.indexOf(r), d = u[l + 1], p = n(r);
      p === S0 ? o(d, !0) : d && i((f) => {
        function h() {
          f.isCanceled() || o(d, !0);
        }
        p === !0 ? h() : Promise.resolve(p).then(h);
      });
    }
  }, [e, r]), E.useEffect(() => () => {
    s();
  }, []), [a, r];
};
function f$(e, t, n, {
  motionEnter: r = !0,
  motionAppear: o = !0,
  motionLeave: i = !0,
  motionDeadline: s,
  motionLeaveImmediately: a,
  onAppearPrepare: u,
  onEnterPrepare: l,
  onLeavePrepare: d,
  onAppearStart: p,
  onEnterStart: f,
  onLeaveStart: h,
  onAppearActive: g,
  onEnterActive: m,
  onLeaveActive: v,
  onAppearEnd: S,
  onEnterEnd: _,
  onLeaveEnd: R,
  onVisibleChanged: b
}) {
  const [y, w] = ld(), [x, P] = r$(An), [N, M] = ld(null), A = x(), T = _t(!1), D = _t(null);
  function j() {
    return n();
  }
  const F = _t(!1);
  function z() {
    P(An), M(null, !0);
  }
  const H = yn((V) => {
    const U = x();
    if (U === An)
      return;
    const Z = j();
    if (V && !V.deadline && V.target !== Z)
      return;
    const te = F.current;
    let ie;
    U === xs && te ? ie = S == null ? void 0 : S(Z, V) : U === Ts && te ? ie = _ == null ? void 0 : _(Z, V) : U === Es && te && (ie = R == null ? void 0 : R(Z, V)), te && ie !== !1 && z();
  }), [ee] = a$(H), X = (V) => {
    switch (V) {
      case xs:
        return {
          [sn]: u,
          [so]: p,
          [ao]: g
        };
      case Ts:
        return {
          [sn]: l,
          [so]: f,
          [ao]: m
        };
      case Es:
        return {
          [sn]: d,
          [so]: h,
          [ao]: v
        };
      default:
        return {};
    }
  }, k = E.useMemo(() => X(A), [A]), [$, Y] = p$(A, !e, (V) => {
    var U;
    if (V === sn) {
      const Z = k[sn];
      return Z ? Z(j()) : S0;
    }
    return Y in k && M(((U = k[Y]) == null ? void 0 : U.call(k, j(), null)) || null), Y === ao && A !== An && (ee(j()), s > 0 && (clearTimeout(D.current), D.current = setTimeout(() => {
      H({
        deadline: !0
      });
    }, s))), Y === p0 && z(), d$;
  }), K = w0(Y);
  F.current = K;
  const W = _t(null);
  y0(() => {
    if (T.current && W.current === t)
      return;
    w(t);
    const V = T.current;
    T.current = !0;
    let U;
    !V && t && o && (U = xs), V && t && r && (U = Ts), (V && !t && i || !V && a && !t && i) && (U = Es);
    const Z = X(U);
    U && (e || Z[sn]) ? (P(U), $()) : P(An), W.current = t;
  }, [t]), or(() => {
    (A === xs && !o || // Cancel enter
    A === Ts && !r || // Cancel leave
    A === Es && !i) && P(An);
  }, [o, r, i]), or(() => () => {
    T.current = !1, clearTimeout(D.current);
  }, []);
  const Q = E.useRef(!1);
  or(() => {
    y && (Q.current = !0), y !== void 0 && A === An && ((Q.current || y) && (b == null || b(y)), Q.current = !0);
  }, [y, A]);
  let G = N;
  return k[sn] && Y === so && (G = C({
    transition: "none"
  }, G)), [x, Y, G, y != null ? y : t];
}
function h$(e) {
  let t = e;
  typeof e == "object" && ({
    transitionSupport: t
  } = e);
  function n(o, i) {
    return !!(o.motionName && t && i !== !1);
  }
  const r = /* @__PURE__ */ E.forwardRef((o, i) => {
    const {
      // Default config
      visible: s = !0,
      removeOnLeave: a = !0,
      forceRender: u,
      children: l,
      motionName: d,
      leavedClassName: p,
      eventProps: f
    } = o, {
      motion: h
    } = E.useContext(n$), g = n(o, h), m = _t();
    function v() {
      return a0(m.current);
    }
    const [S, _, R, b] = f$(g, s, v, o), y = S(), w = E.useRef(b);
    b && (w.current = !0);
    const x = E.useMemo(() => {
      const M = {};
      return Object.defineProperties(M, {
        nativeElement: {
          enumerable: !0,
          get: v
        },
        inMotion: {
          enumerable: !0,
          get: () => () => S() !== An
        },
        enableMotion: {
          enumerable: !0,
          get: () => () => g
        }
      }), M;
    }, []);
    E.useImperativeHandle(i, () => x, []);
    let P;
    const N = L(C({}, f), {
      visible: s
    });
    if (!l)
      P = null;
    else if (y === An)
      b ? P = l(C({}, N), m) : !a && w.current && p ? P = l(L(C({}, N), {
        className: p
      }), m) : u || !a && !p ? P = l(L(C({}, N), {
        style: {
          display: "none"
        }
      }), m) : P = null;
    else {
      let M;
      _ === sn ? M = "prepare" : w0(_) ? M = "active" : _ === so && (M = "start");
      const A = mm(d, `${y}-${M}`);
      P = l(L(C({}, N), {
        className: he(mm(d, y), {
          [A]: A && M,
          [d]: typeof d == "string"
        }),
        style: R
      }), m);
    }
    return /* @__PURE__ */ E.isValidElement(P) && op(P) && (ip(P) || (P = /* @__PURE__ */ E.cloneElement(P, {
      ref: m
    }))), P;
  });
  return r.displayName = "CSSMotion", r;
}
const _0 = h$(s$);
function m$(e) {
  const {
    prefixCls: t,
    align: n,
    arrow: r,
    arrowPos: o
  } = e, {
    className: i,
    content: s
  } = r || {}, {
    x: a = 0,
    y: u = 0
  } = o, l = E.useRef(null);
  if (!n || !n.points)
    return null;
  const d = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    const p = n.points[0], f = n.points[1], h = p[0], g = p[1], m = f[0], v = f[1];
    h === m || !["t", "b"].includes(h) ? d.top = u : h === "t" ? d.top = 0 : d.bottom = 0, g === v || !["l", "r"].includes(g) ? d.left = a : g === "l" ? d.left = 0 : d.right = 0;
  }
  return /* @__PURE__ */ E.createElement("div", {
    ref: l,
    className: he(`${t}-arrow`, i),
    style: d
  }, s);
}
function cd() {
  return cd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cd.apply(this, arguments);
}
function g$(e) {
  const {
    prefixCls: t,
    open: n,
    zIndex: r,
    mask: o,
    motion: i
  } = e;
  return o ? /* @__PURE__ */ E.createElement(_0, cd({}, i, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), ({
    className: s
  }) => /* @__PURE__ */ E.createElement("div", {
    style: {
      zIndex: r
    },
    className: he(`${t}-mask`, s)
  })) : null;
}
const x0 = /* @__PURE__ */ E.memo(({
  children: e
}) => e, (e, t) => t.cache);
process.env.NODE_ENV !== "production" && (x0.displayName = "PopupContent");
function ud() {
  return ud = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ud.apply(this, arguments);
}
const T0 = /* @__PURE__ */ E.forwardRef((e, t) => {
  var n;
  const {
    popup: r,
    className: o,
    prefixCls: i,
    style: s,
    target: a,
    onVisibleChanged: u,
    // Open
    open: l,
    keepDom: d,
    fresh: p,
    // Click
    onClick: f,
    // Mask
    mask: h,
    // Arrow
    arrow: g,
    arrowPos: m,
    align: v,
    // Motion
    motion: S,
    maskMotion: _,
    // Portal
    forceRender: R,
    getPopupContainer: b,
    autoDestroy: y,
    portal: w,
    zIndex: x,
    onMouseEnter: P,
    onMouseLeave: N,
    onPointerEnter: M,
    onPointerDownCapture: A,
    ready: T,
    offsetX: D,
    offsetY: j,
    offsetR: F,
    offsetB: z,
    onAlign: H,
    onPrepare: ee,
    stretch: X,
    targetWidth: k,
    targetHeight: $
  } = e, Y = typeof r == "function" ? r() : r, K = l || d, W = (b == null ? void 0 : b.length) > 0, [Q, G] = E.useState(!b || !W);
  if (zt(() => {
    !Q && W && a && G(!0);
  }, [Q, W, a]), !Q)
    return null;
  const V = "auto", U = {
    left: "-1000vw",
    top: "-1000vh",
    right: V,
    bottom: V
  };
  if (T || !l) {
    const {
      points: te
    } = v, ie = v.dynamicInset || ((n = v._experimental) == null ? void 0 : n.dynamicInset), B = ie && te[0][1] === "r", oe = ie && te[0][0] === "b";
    B ? (U.right = F, U.left = V) : (U.left = D, U.right = V), oe ? (U.bottom = z, U.top = V) : (U.top = j, U.bottom = V);
  }
  const Z = {};
  return X && (X.includes("height") && $ ? Z.height = $ : X.includes("minHeight") && $ && (Z.minHeight = $), X.includes("width") && k ? Z.width = k : X.includes("minWidth") && k && (Z.minWidth = k)), l || (Z.pointerEvents = "none"), /* @__PURE__ */ E.createElement(w, {
    open: R || K,
    getContainer: b && (() => b(a)),
    autoDestroy: y
  }, /* @__PURE__ */ E.createElement(g$, {
    prefixCls: i,
    open: l,
    zIndex: x,
    mask: h,
    motion: _
  }), /* @__PURE__ */ E.createElement(dl, {
    onResize: H,
    disabled: !l
  }, (te) => /* @__PURE__ */ E.createElement(_0, ud({
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    removeOnLeave: !1,
    forceRender: R,
    leavedClassName: `${i}-hidden`
  }, S, {
    onAppearPrepare: ee,
    onEnterPrepare: ee,
    visible: l,
    onVisibleChanged: (ie) => {
      var B;
      (B = S == null ? void 0 : S.onVisibleChanged) == null || B.call(S, ie), u(ie);
    }
  }), ({
    className: ie,
    style: B
  }, oe) => {
    const q = he(i, ie, o);
    return /* @__PURE__ */ E.createElement("div", {
      ref: Qb(te, t, oe),
      className: q,
      style: C(L(C(C(C({
        "--arrow-x": `${m.x || 0}px`,
        "--arrow-y": `${m.y || 0}px`
      }, U), Z), B), {
        boxSizing: "border-box",
        zIndex: x
      }), s),
      onMouseEnter: P,
      onMouseLeave: N,
      onPointerEnter: M,
      onClick: f,
      onPointerDownCapture: A
    }, g && /* @__PURE__ */ E.createElement(m$, {
      prefixCls: i,
      arrow: g,
      arrowPos: m,
      align: v
    }), /* @__PURE__ */ E.createElement(x0, {
      cache: !l && !p
    }, Y));
  })));
});
process.env.NODE_ENV !== "production" && (T0.displayName = "Popup");
const ym = /* @__PURE__ */ E.createContext(null);
function vm(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function y$(e, t, n, r) {
  return E.useMemo(() => {
    const o = vm(n != null ? n : t), i = vm(r != null ? r : t), s = new Set(o), a = new Set(i);
    return e && (s.has("hover") && (s.delete("hover"), s.add("click")), a.has("hover") && (a.delete("hover"), a.add("click"))), [s, a];
  }, [e, t, n, r]);
}
const v$ = (e) => {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      const {
        width: t,
        height: n
      } = e.getBBox();
      if (t || n)
        return !0;
    }
    if (e.getBoundingClientRect) {
      const {
        width: t,
        height: n
      } = e.getBoundingClientRect();
      if (t || n)
        return !0;
    }
  }
  return !1;
};
function b$(e = [], t = [], n) {
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function C$(e, t, n, r) {
  var o;
  const {
    points: i
  } = n, s = Object.keys(e);
  for (let a = 0; a < s.length; a += 1) {
    const u = s[a];
    if (b$((o = e[u]) == null ? void 0 : o.points, i, r))
      return `${t}-placement-${u}`;
  }
  return "";
}
function Yi(e) {
  return e.ownerDocument.defaultView;
}
function dd(e) {
  const t = [];
  let n = e == null ? void 0 : e.parentElement;
  const r = ["hidden", "scroll", "clip", "auto"];
  for (; n; ) {
    const {
      overflowX: o,
      overflowY: i,
      overflow: s
    } = Yi(n).getComputedStyle(n);
    [o, i, s].some((a) => r.includes(a)) && t.push(n), n = n.parentElement;
  }
  return t;
}
function $i(e, t = 1) {
  return Number.isNaN(e) ? t : e;
}
function Qo(e) {
  return $i(parseFloat(e), 0);
}
function bm(e, t) {
  const n = C({}, e);
  return (t || []).forEach((r) => {
    if (r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)
      return;
    const {
      overflow: o,
      overflowClipMargin: i,
      borderTopWidth: s,
      borderBottomWidth: a,
      borderLeftWidth: u,
      borderRightWidth: l
    } = Yi(r).getComputedStyle(r), d = r.getBoundingClientRect(), {
      offsetHeight: p,
      clientHeight: f,
      offsetWidth: h,
      clientWidth: g
    } = r, m = Qo(s), v = Qo(a), S = Qo(u), _ = Qo(l), R = $i(Math.round(d.width / h * 1e3) / 1e3), b = $i(Math.round(d.height / p * 1e3) / 1e3), y = (h - g - S - _) * R, w = (p - f - m - v) * b, x = m * b, P = v * b, N = S * R, M = _ * R;
    let A = 0, T = 0;
    if (o === "clip") {
      const H = Qo(i);
      A = H * R, T = H * b;
    }
    const D = d.x + N - A, j = d.y + x - T, F = D + d.width + 2 * A - N - M - y, z = j + d.height + 2 * T - x - P - w;
    n.left = Math.max(n.left, D), n.top = Math.max(n.top, j), n.right = Math.min(n.right, F), n.bottom = Math.min(n.bottom, z);
  }), n;
}
function Cm(e, t = 0) {
  const n = `${t}`, r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function Sm(e, t) {
  const [n, r] = t || [];
  return [Cm(e.width, n), Cm(e.height, r)];
}
function wm(e = "") {
  return [e[0], e[1]];
}
function Xr(e, t) {
  const n = t[0], r = t[1];
  let o, i;
  return n === "t" ? i = e.y : n === "b" ? i = e.y + e.height : i = e.y + e.height / 2, r === "l" ? o = e.x : r === "r" ? o = e.x + e.width : o = e.x + e.width / 2, {
    x: o,
    y: i
  };
}
function Yn(e, t) {
  const n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map((r, o) => o === t ? n[r] || "c" : r).join("");
}
function S$(e, t, n, r, o, i, s) {
  const [a, u] = E.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[r] || {}
  }), l = E.useRef(0), d = E.useMemo(() => t ? dd(t) : [], [t]), p = E.useRef({});
  e || (p.current = {});
  const f = yn(() => {
    var S, _, R, b;
    var m, v;
    if (t && n && e) {
      let y = function(ne, Oe, Ze = Re) {
        const pn = $.x + ne, In = $.y + Oe, El = pn + Z, rs = In + U, cC = Math.max(pn, Ze.left), uC = Math.max(In, Ze.top), dC = Math.min(El, Ze.right), pC = Math.min(rs, Ze.bottom);
        return Math.max(0, (dC - cC) * (pC - uC));
      }, w = function() {
        it = $.y + Te, Dt = it + U, qn = $.x + de, Rn = qn + Z;
      };
      const x = t, P = x.ownerDocument, N = Yi(x), {
        width: M,
        height: A,
        position: T
      } = N.getComputedStyle(x), D = x.style.left, j = x.style.top, F = x.style.right, z = x.style.bottom, H = x.style.overflow, ee = C(C({}, o[r]), i), X = P.createElement("div");
      (m = x.parentElement) == null || m.appendChild(X), X.style.left = `${x.offsetLeft}px`, X.style.top = `${x.offsetTop}px`, X.style.position = T, X.style.height = `${x.offsetHeight}px`, X.style.width = `${x.offsetWidth}px`, x.style.left = "0", x.style.top = "0", x.style.right = "auto", x.style.bottom = "auto", x.style.overflow = "hidden";
      let k;
      if (Array.isArray(n))
        k = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        const ne = n.getBoundingClientRect();
        ne.x = (S = ne.x) != null ? S : ne.left, ne.y = (_ = ne.y) != null ? _ : ne.top, k = {
          x: ne.x,
          y: ne.y,
          width: ne.width,
          height: ne.height
        };
      }
      const $ = x.getBoundingClientRect();
      $.x = (R = $.x) != null ? R : $.left, $.y = (b = $.y) != null ? b : $.top;
      const {
        clientWidth: Y,
        clientHeight: K,
        scrollWidth: W,
        scrollHeight: Q,
        scrollTop: G,
        scrollLeft: V
      } = P.documentElement, U = $.height, Z = $.width, te = k.height, ie = k.width, B = {
        left: 0,
        top: 0,
        right: Y,
        bottom: K
      }, oe = {
        left: -V,
        top: -G,
        right: W - V,
        bottom: Q - G
      };
      let {
        htmlRegion: q
      } = ee;
      const pe = "visible", ge = "visibleFirst";
      q !== "scroll" && q !== ge && (q = pe);
      const Ee = q === ge, be = bm(oe, d), ye = bm(B, d), Re = q === pe ? ye : be, Me = Ee ? ye : Re;
      x.style.left = "auto", x.style.top = "auto", x.style.right = "0", x.style.bottom = "0";
      const Ie = x.getBoundingClientRect();
      x.style.left = D, x.style.top = j, x.style.right = F, x.style.bottom = z, x.style.overflow = H, (v = x.parentElement) == null || v.removeChild(X);
      const ae = $i(Math.round(Z / parseFloat(M) * 1e3) / 1e3), Se = $i(Math.round(U / parseFloat(A) * 1e3) / 1e3);
      if (ae === 0 || Se === 0 || Ai(n) && !v$(n))
        return;
      const {
        offset: mt,
        targetOffset: ke
      } = ee;
      let [Qe, we] = Sm($, mt);
      const [Ne, Ue] = Sm(k, ke);
      k.x -= Ne, k.y -= Ue;
      const [Ae, je] = ee.points || [], ce = wm(je), Pe = wm(Ae), $t = Xr(k, ce), Lt = Xr($, Pe), le = C({}, ee);
      let de = $t.x - Lt.x + Qe, Te = $t.y - Lt.y + we;
      const ot = y(de, Te), nn = y(de, Te, ye), Mr = Xr(k, ["t", "l"]), kr = Xr($, ["t", "l"]), Ar = Xr(k, ["b", "r"]), $r = Xr($, ["b", "r"]), No = ee.overflow || {}, {
        adjustX: Lr,
        adjustY: Dr,
        shiftX: dr,
        shiftY: dn
      } = No, me = (ne) => typeof ne == "boolean" ? ne : ne >= 0;
      let it, Dt, qn, Rn;
      w();
      const On = me(Dr), Xi = Pe[0] === ce[0];
      if (On && Pe[0] === "t" && (Dt > Me.bottom || p.current.bt)) {
        let ne = Te;
        Xi ? ne -= U - te : ne = Mr.y - $r.y - we;
        const Oe = y(de, ne), Ze = y(de, ne, ye);
        Oe > ot || Oe === ot && (!Ee || // Choose recommend one
        Ze >= nn) ? (p.current.bt = !0, Te = ne, we = -we, le.points = [Yn(Pe, 0), Yn(ce, 0)]) : p.current.bt = !1;
      }
      if (On && Pe[0] === "b" && (it < Me.top || p.current.tb)) {
        let ne = Te;
        Xi ? ne += U - te : ne = Ar.y - kr.y - we;
        const Oe = y(de, ne), Ze = y(de, ne, ye);
        Oe > ot || Oe === ot && (!Ee || // Choose recommend one
        Ze >= nn) ? (p.current.tb = !0, Te = ne, we = -we, le.points = [Yn(Pe, 0), Yn(ce, 0)]) : p.current.tb = !1;
      }
      const Ji = me(Lr), Qi = Pe[1] === ce[1];
      if (Ji && Pe[1] === "l" && (Rn > Me.right || p.current.rl)) {
        let ne = de;
        Qi ? ne -= Z - ie : ne = Mr.x - $r.x - Qe;
        const Oe = y(ne, Te), Ze = y(ne, Te, ye);
        Oe > ot || Oe === ot && (!Ee || // Choose recommend one
        Ze >= nn) ? (p.current.rl = !0, de = ne, Qe = -Qe, le.points = [Yn(Pe, 1), Yn(ce, 1)]) : p.current.rl = !1;
      }
      if (Ji && Pe[1] === "r" && (qn < Me.left || p.current.lr)) {
        let ne = de;
        Qi ? ne += Z - ie : ne = Ar.x - kr.x - Qe;
        const Oe = y(ne, Te), Ze = y(ne, Te, ye);
        Oe > ot || Oe === ot && (!Ee || // Choose recommend one
        Ze >= nn) ? (p.current.lr = !0, de = ne, Qe = -Qe, le.points = [Yn(Pe, 1), Yn(ce, 1)]) : p.current.lr = !1;
      }
      w();
      const pr = dr === !0 ? 0 : dr;
      typeof pr == "number" && (qn < ye.left && (de -= qn - ye.left - Qe, k.x + ie < ye.left + pr && (de += k.x - ye.left + ie - pr)), Rn > ye.right && (de -= Rn - ye.right - Qe, k.x > ye.right - pr && (de += k.x - ye.right + pr)));
      const fr = dn === !0 ? 0 : dn;
      typeof fr == "number" && (it < ye.top && (Te -= it - ye.top - we, k.y + te < ye.top + fr && (Te += k.y - ye.top + te - fr)), Dt > ye.bottom && (Te -= Dt - ye.bottom - we, k.y > ye.bottom - fr && (Te += k.y - ye.bottom + fr)));
      const Br = $.x + de, Sl = Br + Z, Mo = $.y + Te, wl = Mo + U, Pn = k.x, _l = Pn + ie, Zi = k.y, xl = Zi + te, ko = Math.max(Br, Pn), es = Math.min(Sl, _l), Ao = (ko + es) / 2 - Br, $o = Math.max(Mo, Zi), ts = Math.min(wl, xl), Tl = ($o + ts) / 2 - Mo;
      s == null || s(t, le);
      let Lo = Ie.right - $.x - (de + $.width), Do = Ie.bottom - $.y - (Te + $.height);
      ae === 1 && (de = Math.round(de), Lo = Math.round(Lo)), Se === 1 && (Te = Math.round(Te), Do = Math.round(Do));
      const ns = {
        ready: !0,
        offsetX: de / ae,
        offsetY: Te / Se,
        offsetR: Lo / ae,
        offsetB: Do / Se,
        arrowX: Ao / ae,
        arrowY: Tl / Se,
        scaleX: ae,
        scaleY: Se,
        align: le
      };
      u(ns);
    }
  }), h = () => {
    l.current += 1;
    const m = l.current;
    Promise.resolve().then(() => {
      l.current === m && f();
    });
  }, g = () => {
    u((m) => L(C({}, m), {
      ready: !1
    }));
  };
  return zt(g, [r]), zt(() => {
    e || g();
  }, [e]), [a.ready, a.offsetX, a.offsetY, a.offsetR, a.offsetB, a.arrowX, a.arrowY, a.scaleX, a.scaleY, a.align, h];
}
function w$(e, t, n, r, o) {
  zt(() => {
    if (e && t && n) {
      let i = function() {
        r(), o();
      };
      const s = t, a = n, u = dd(s), l = dd(a), d = Yi(a), p = /* @__PURE__ */ new Set([d, ...u, ...l]);
      return p.forEach((f) => {
        f.addEventListener("scroll", i, {
          passive: !0
        });
      }), d.addEventListener("resize", i, {
        passive: !0
      }), r(), () => {
        p.forEach((f) => {
          f.removeEventListener("scroll", i), d.removeEventListener("resize", i);
        });
      };
    }
  }, [e, t, n]);
}
function _$(e, t, n, r, o, i, s, a) {
  const u = E.useRef(e);
  u.current = e;
  const l = E.useRef(!1);
  E.useEffect(() => {
    var p, f;
    if (t && r && (!o || i)) {
      const h = () => {
        l.current = !1;
      }, g = (S) => {
        var _, R;
        u.current && !s(((R = (_ = S.composedPath) == null ? void 0 : _.call(S)) == null ? void 0 : R[0]) || S.target) && !l.current && a(!1);
      }, m = Yi(r);
      m.addEventListener("pointerdown", h, !0), m.addEventListener("mousedown", g, !0), m.addEventListener("contextmenu", g, !0);
      const v = ad(n);
      if (v && (v.addEventListener("mousedown", g, !0), v.addEventListener("contextmenu", g, !0)), process.env.NODE_ENV !== "production") {
        const S = (p = n == null ? void 0 : n.getRootNode) == null ? void 0 : p.call(n), _ = (f = r.getRootNode) == null ? void 0 : f.call(r);
        xa(S === _, "trigger element and popup element should in same shadow root.");
      }
      return () => {
        m.removeEventListener("pointerdown", h, !0), m.removeEventListener("mousedown", g, !0), m.removeEventListener("contextmenu", g, !0), v && (v.removeEventListener("mousedown", g, !0), v.removeEventListener("contextmenu", g, !0));
      };
    }
  }, [t, n, r, o, i]);
  function d() {
    l.current = !0;
  }
  return d;
}
function x$(e = lp) {
  const t = /* @__PURE__ */ E.forwardRef((n, r) => {
    const ns = n, {
      prefixCls: o = "rc-trigger-popup",
      children: i,
      action: s = "hover",
      showAction: a,
      hideAction: u,
      popupVisible: l,
      defaultPopupVisible: d,
      onOpenChange: p,
      afterOpenChange: f,
      onPopupVisibleChange: h,
      afterPopupVisibleChange: g,
      mouseEnterDelay: m,
      mouseLeaveDelay: v = 0.1,
      focusDelay: S,
      blurDelay: _,
      mask: R,
      maskClosable: b = !0,
      getPopupContainer: y,
      forceRender: w,
      autoDestroy: x,
      popup: P,
      popupClassName: N,
      popupStyle: M,
      popupPlacement: A,
      builtinPlacements: T = {},
      popupAlign: D,
      zIndex: j,
      stretch: F,
      getPopupClassNameFromAlign: z,
      fresh: H,
      alignPoint: ee,
      onPopupClick: X,
      onPopupAlign: k,
      arrow: $,
      popupMotion: Y,
      maskMotion: K
    } = ns, W = re(ns, [
      "prefixCls",
      "children",
      // Action
      "action",
      "showAction",
      "hideAction",
      // Open
      "popupVisible",
      "defaultPopupVisible",
      "onOpenChange",
      "afterOpenChange",
      "onPopupVisibleChange",
      "afterPopupVisibleChange",
      // Delay
      "mouseEnterDelay",
      "mouseLeaveDelay",
      "focusDelay",
      "blurDelay",
      // Mask
      "mask",
      "maskClosable",
      // Portal
      "getPopupContainer",
      "forceRender",
      "autoDestroy",
      // Popup
      "popup",
      "popupClassName",
      "popupStyle",
      "popupPlacement",
      "builtinPlacements",
      "popupAlign",
      "zIndex",
      "stretch",
      "getPopupClassNameFromAlign",
      "fresh",
      "alignPoint",
      "onPopupClick",
      "onPopupAlign",
      // Arrow
      "arrow",
      // Motion
      "popupMotion",
      "maskMotion"
    ]), Q = x || !1, [G, V] = E.useState(!1);
    zt(() => {
      V(t$());
    }, []);
    const U = E.useRef({}), Z = E.useContext(ym), te = E.useMemo(() => ({
      registerSubPopup: (ne, Oe) => {
        U.current[ne] = Oe, Z == null || Z.registerSubPopup(ne, Oe);
      }
    }), [Z]), ie = d0(), [B, oe] = E.useState(null), q = E.useRef(null), pe = yn((ne) => {
      q.current = ne, Ai(ne) && B !== ne && oe(ne), Z == null || Z.registerSubPopup(ie, ne);
    }), [ge, Ee] = E.useState(null), be = E.useRef(null), ye = yn((ne) => {
      Ai(ne) && ge !== ne && (Ee(ne), be.current = ne);
    }), Re = E.Children.only(i), Me = (Re == null ? void 0 : Re.props) || {}, Ie = {}, ae = yn((ne) => {
      var Oe, Ze;
      const pn = ge;
      return (pn == null ? void 0 : pn.contains(ne)) || ((Oe = ad(pn)) == null ? void 0 : Oe.host) === ne || ne === pn || (B == null ? void 0 : B.contains(ne)) || ((Ze = ad(B)) == null ? void 0 : Ze.host) === ne || ne === B || Object.values(U.current).some((In) => (In == null ? void 0 : In.contains(ne)) || ne === In);
    }), [Se, mt] = E.useState(d || !1), ke = l != null ? l : Se, Qe = yn((ne) => {
      l === void 0 && mt(ne);
    });
    zt(() => {
      mt(l || !1);
    }, [l]);
    const we = E.useRef(ke);
    we.current = ke;
    const Ne = E.useRef([]);
    Ne.current = [];
    const Ue = yn((ne) => {
      var Oe;
      Qe(ne), ((Oe = Ne.current[Ne.current.length - 1]) != null ? Oe : ke) !== ne && (Ne.current.push(ne), p == null || p(ne), h == null || h(ne));
    }), Ae = E.useRef(null), je = () => {
      clearTimeout(Ae.current);
    }, ce = (ne, Oe = 0) => {
      je(), Oe === 0 ? Ue(ne) : Ae.current = setTimeout(() => {
        Ue(ne);
      }, Oe * 1e3);
    };
    E.useEffect(() => je, []);
    const [Pe, $t] = E.useState(!1);
    zt((ne) => {
      (!ne || ke) && $t(!0);
    }, [ke]);
    const [Lt, le] = E.useState(null), [de, Te] = E.useState(null), ot = (ne) => {
      Te([ne.clientX, ne.clientY]);
    }, [nn, Mr, kr, Ar, $r, No, Lr, Dr, dr, dn, me] = S$(ke, B, ee && de !== null ? de : ge, A, T, D, k), [it, Dt] = y$(G, s, a, u), qn = it.has("click"), Rn = Dt.has("click") || Dt.has("contextMenu"), On = yn(() => {
      Pe || me();
    });
    w$(ke, ge, B, On, () => {
      we.current && ee && Rn && ce(!1);
    }), zt(() => {
      On();
    }, [de, A]), zt(() => {
      ke && !(T != null && T[A]) && On();
    }, [JSON.stringify(D)]);
    const Xi = E.useMemo(() => {
      const ne = C$(T, o, dn, ee);
      return he(ne, z == null ? void 0 : z(dn));
    }, [dn, z, T, o, ee]);
    E.useImperativeHandle(r, () => ({
      nativeElement: be.current,
      popupElement: q.current,
      forceAlign: On
    }));
    const [Ji, Qi] = E.useState(0), [pr, fr] = E.useState(0), Br = () => {
      if (F && ge) {
        const ne = ge.getBoundingClientRect();
        Qi(ne.width), fr(ne.height);
      }
    }, Sl = () => {
      Br(), On();
    }, Mo = (ne) => {
      $t(!1), me(), f == null || f(ne), g == null || g(ne);
    }, wl = () => new Promise((ne) => {
      Br(), le(() => ne);
    });
    zt(() => {
      Lt && (me(), Lt(), le(null));
    }, [Lt]);
    function Pn(ne, Oe, Ze, pn) {
      Ie[ne] = (In, ...El) => {
        var rs;
        pn == null || pn(In), ce(Oe, Ze), (rs = Me[ne]) == null || rs.call(Me, In, ...El);
      };
    }
    (qn || Rn) && (Ie.onClick = (ne, ...Oe) => {
      var Ze;
      we.current && Rn ? ce(!1) : !we.current && qn && (ot(ne), ce(!0)), (Ze = Me.onClick) == null || Ze.call(Me, ne, ...Oe);
    });
    const _l = _$(ke, Rn, ge, B, R, b, ae, ce), Zi = it.has("hover"), xl = Dt.has("hover");
    let ko, es;
    Zi && (Pn("onMouseEnter", !0, m, (ne) => {
      ot(ne);
    }), Pn("onPointerEnter", !0, m, (ne) => {
      ot(ne);
    }), ko = (ne) => {
      (ke || Pe) && B != null && B.contains(ne.target) && ce(!0, m);
    }, ee && (Ie.onMouseMove = (ne) => {
      var Oe;
      (Oe = Me.onMouseMove) == null || Oe.call(Me, ne);
    })), xl && (Pn("onMouseLeave", !1, v), Pn("onPointerLeave", !1, v), es = () => {
      ce(!1, v);
    }), it.has("focus") && Pn("onFocus", !0, S), Dt.has("focus") && Pn("onBlur", !1, _), it.has("contextMenu") && (Ie.onContextMenu = (ne, ...Oe) => {
      var Ze;
      we.current && Dt.has("contextMenu") ? ce(!1) : (ot(ne), ce(!0)), ne.preventDefault(), (Ze = Me.onContextMenu) == null || Ze.call(Me, ne, ...Oe);
    });
    const Ao = E.useRef(!1);
    Ao.current || (Ao.current = w || ke || Pe);
    const $o = C(C({}, Me), Ie), ts = {};
    ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"].forEach((ne) => {
      W[ne] && (ts[ne] = (...Oe) => {
        var Ze;
        (Ze = $o[ne]) == null || Ze.call($o, ...Oe), W[ne](...Oe);
      });
    });
    const Tl = {
      x: No,
      y: Lr
    }, Lo = $ ? C({}, $ !== !0 ? $ : {}) : null, Do = /* @__PURE__ */ E.cloneElement(Re, C(C({}, $o), ts));
    return /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement(dl, {
      disabled: !ke,
      ref: ye,
      onResize: Sl
    }, Do), Ao.current && /* @__PURE__ */ E.createElement(ym.Provider, {
      value: te
    }, /* @__PURE__ */ E.createElement(T0, {
      portal: e,
      ref: pe,
      prefixCls: o,
      popup: P,
      className: he(N, Xi),
      style: M,
      target: ge,
      onMouseEnter: ko,
      onMouseLeave: es,
      onPointerEnter: ko,
      zIndex: j,
      open: ke,
      keepDom: Pe,
      fresh: H,
      onClick: X,
      onPointerDownCapture: _l,
      mask: R,
      motion: Y,
      maskMotion: K,
      onVisibleChanged: Mo,
      onPrepare: wl,
      forceRender: w,
      autoDestroy: Q,
      getPopupContainer: y,
      align: dn,
      arrow: Lo,
      arrowPos: Tl,
      ready: nn,
      offsetX: Mr,
      offsetY: kr,
      offsetR: Ar,
      offsetB: $r,
      onAlign: On,
      stretch: F,
      targetWidth: Ji / Dr,
      targetHeight: pr / dr
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const T$ = x$(lp), Jr = {
  shiftX: 64,
  adjustY: 1
}, Qr = {
  adjustX: 1,
  shiftY: !0
}, Kt = [0, 0], E$ = {
  left: {
    points: ["cr", "cl"],
    overflow: Qr,
    offset: [-4, 0],
    targetOffset: Kt
  },
  right: {
    points: ["cl", "cr"],
    overflow: Qr,
    offset: [4, 0],
    targetOffset: Kt
  },
  top: {
    points: ["bc", "tc"],
    overflow: Jr,
    offset: [0, -4],
    targetOffset: Kt
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Jr,
    offset: [0, 4],
    targetOffset: Kt
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: Jr,
    offset: [0, -4],
    targetOffset: Kt
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Qr,
    offset: [-4, 0],
    targetOffset: Kt
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Jr,
    offset: [0, -4],
    targetOffset: Kt
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Qr,
    offset: [4, 0],
    targetOffset: Kt
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Jr,
    offset: [0, 4],
    targetOffset: Kt
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Qr,
    offset: [4, 0],
    targetOffset: Kt
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Jr,
    offset: [0, 4],
    targetOffset: Kt
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Qr,
    offset: [-4, 0],
    targetOffset: Kt
  }
};
function pd() {
  return pd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pd.apply(this, arguments);
}
const R$ = /* @__PURE__ */ E.forwardRef((e, t) => {
  const j = e, {
    overlayClassName: n,
    trigger: r = ["hover"],
    mouseEnterDelay: o = 0,
    mouseLeaveDelay: i = 0.1,
    overlayStyle: s,
    prefixCls: a = "rc-tooltip",
    children: u,
    onVisibleChange: l,
    afterVisibleChange: d,
    motion: p,
    placement: f = "right",
    align: h = {},
    destroyOnHidden: g = !1,
    defaultVisible: m,
    getTooltipContainer: v,
    overlayInnerStyle: S,
    arrowContent: _,
    overlay: R,
    id: b,
    showArrow: y = !0,
    classNames: w,
    styles: x
  } = j, P = re(j, [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "motion",
    "placement",
    "align",
    "destroyOnHidden",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow",
    "classNames",
    "styles"
  ]), N = d0(b), M = _t(null);
  SC(t, () => M.current);
  const A = C({}, P);
  "visible" in e && (A.popupVisible = e.visible);
  const T = () => /* @__PURE__ */ E.createElement(SA, {
    key: "content",
    prefixCls: a,
    id: N,
    bodyClassName: w == null ? void 0 : w.body,
    overlayInnerStyle: C(C({}, S), x == null ? void 0 : x.body)
  }, R), D = () => {
    const F = E.Children.only(u), z = L(C({}, (F == null ? void 0 : F.props) || {}), {
      "aria-describedby": R ? N : null
    });
    return /* @__PURE__ */ E.cloneElement(u, z);
  };
  return /* @__PURE__ */ E.createElement(T$, pd({
    popupClassName: he(n, w == null ? void 0 : w.root),
    prefixCls: a,
    popup: T,
    action: r,
    builtinPlacements: E$,
    popupPlacement: f,
    ref: M,
    popupAlign: h,
    getPopupContainer: v,
    onOpenChange: l,
    afterOpenChange: d,
    popupMotion: p,
    defaultPopupVisible: m,
    autoDestroy: g,
    mouseLeaveDelay: i,
    popupStyle: C(C({}, s), x == null ? void 0 : x.root),
    mouseEnterDelay: o,
    arrow: y
  }, A), D());
}), O$ = "DEPRECATED_Tooltip-module__breakLongWord___kWwu0", P$ = "DEPRECATED_Tooltip-module__rcToolTipZoomIn___0ddOq", I$ = "DEPRECATED_Tooltip-module__rcToolTipZoomOut___kpbOG", mc = {
  breakLongWord: O$,
  rcToolTipZoomIn: P$,
  rcToolTipZoomOut: I$
}, E0 = (e) => {
  const l = e, {
    breakingLongWord: t,
    hideArrow: n = !1,
    overlayClassName: r,
    overlay: o,
    imgOverlay: i = !1,
    semanticText: s
  } = l, a = re(l, [
    "breakingLongWord",
    "hideArrow",
    "overlayClassName",
    "overlay",
    "imgOverlay",
    "semanticText"
  ]), u = he(
    r,
    "slf-default",
    nr.SISENSE_NAMESPACE,
    {
      "hide-arrow": n,
      [mc.breakLongWord]: t,
      [mc.semanticText]: s,
      [mc.semanticText]: s
    }
  );
  return /* @__PURE__ */ O(
    R$,
    L(C({
      destroyOnHidden: !0,
      overlay: typeof o == "string" ? i ? /* @__PURE__ */ O("img", { src: o }) : /* @__PURE__ */ O("div", { dangerouslySetInnerHTML: { __html: o } }) : o
    }, a), {
      overlayClassName: u
    })
  );
}, N$ = "Popover-module__popover___39yjG", M$ = "Popover-module__popoverMask___4ZLl9", _m = {
  popover: N$,
  popoverMask: M$
}, k$ = () => {
}, A$ = 1069, Si = (e) => {
  const {
    bubbleMouseEvents: t = !1,
    level: n = 0,
    mask: r = !0,
    onRequestClose: o = k$,
    visible: i = !1,
    zIndex: s = A$,
    maskClassName: a,
    getTooltipContainer: u
  } = e, l = () => {
    let p = document.body;
    return u && (p = u()), p;
  }, d = (p) => {
    t || (p.preventDefault(), p.stopPropagation());
  };
  return /* @__PURE__ */ fe(xo, { children: [
    i && r && /* @__PURE__ */ O($$, { portalRootEl: l(), children: /* @__PURE__ */ O(
      "div",
      {
        className: he(_m.popoverMask, a),
        style: { zIndex: (s + n).toString() },
        onClick: (p) => o == null ? void 0 : o(p.nativeEvent)
      }
    ) }),
    /* @__PURE__ */ O(
      E0,
      L(C({}, e), {
        overlayClassName: _m.popover,
        hideArrow: !0,
        onClick: d,
        zIndex: s + n + 1,
        align: e.align
      })
    )
  ] });
}, $$ = (e) => ri.createPortal(e.children, e.portalRootEl), L$ = (e) => {
  const { onRequestClose: t, onClick: n, onKeyPress: r, sortingPopup: o, className: i, getTooltipContainer: s } = e;
  return /* @__PURE__ */ O(
    Si,
    {
      bubbleMouseEvents: !0,
      level: 0,
      mask: !0,
      placement: "bottom",
      onVisibleChange: (a) => {
      },
      trigger: ["click"],
      overlay: () => o,
      onRequestClose: t,
      getTooltipContainer: s,
      visible: o !== null,
      align: {
        points: [Zu.topLeft, Zu.bottomRight]
      },
      children: /* @__PURE__ */ O(
        "span",
        {
          role: "button",
          "aria-label": "Show sorting settings pop-up",
          tabIndex: 0,
          onClick: n,
          onKeyPress: r,
          className: i
        }
      )
    }
  );
}, xm = 50, D$ = new RegExp(`<\\/?[\\w\\s="/.':;#-\\/\\?]+>`), gc = {
  TEXT: "text",
  HTML: "html",
  COMPONENT: "component"
};
class R0 extends E.PureComponent {
  constructor(n) {
    super(n);
    I(this, "cellEl");
    I(this, "contentRef");
    I(this, "metadataClassName");
    I(this, "virtualBorderStyle");
    I(this, "cellStyle");
    I(this, "cellContentStyle");
    I(this, "databarStyle");
    I(this, "cachedHtml");
    I(this, "timeoutId");
    I(this, "isMouseInCell");
    I(this, "onCellClick", (n) => {
      const {
        isDataCell: r,
        dataNode: o,
        treeNode: i,
        columnTreeNode: s,
        rowTreeNode: a,
        measureTreeNode: u,
        cellMetadata: l,
        onCellClick: d
      } = this.props;
      let p;
      s ? p = o : i && (p = i), d && d({
        event: n,
        isDataCell: r,
        dataNode: p,
        rowTreeNode: a,
        columnTreeNode: s,
        measureTreeNode: u,
        cellMetadata: l,
        cell: this
      });
    });
    I(this, "onCellEnter", (n) => {
      const { onCellEnter: r, cellMetadata: o } = this.props, i = {
        domEvent: n,
        metadata: o,
        cell: o ? o.cellData : void 0
      };
      this.isMouseInCell || (this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0), n.persist(), this.timeoutId = setTimeout(() => {
        r && r(i), this.timeoutId = void 0, this.isMouseInCell = !0;
      }, 100));
    });
    I(this, "onCellLeave", (n) => {
      const { onCellLeave: r, cellMetadata: o } = this.props, i = {
        domEvent: n,
        metadata: o,
        cell: o ? o.cellData : void 0
      };
      this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0), n.persist(), r && this.isMouseInCell && (r(i), this.isMouseInCell = !1);
    });
    I(this, "onResizeStartHandler", () => {
      const { parent: n } = this.props, { merge: r } = this.state;
      n && n.resizeColumnStart && n.resizeColumnStart();
      const o = this.props.columnIndex + Dl(r);
      let i = 0;
      return n && n.getColumnWidth && (i = n.getColumnWidth(o)), i;
    });
    I(this, "onResizeHandler", (n) => {
      const { parent: r, columnIndex: o } = this.props, { merge: i } = this.state;
      if (r && r.resizeColumn) {
        const s = o + Dl(i), a = Math.max(xm, n), u = [[s, a]], l = { columnIndex: s }, d = { width: !0 };
        r.resizeColumn(u, l, d);
      }
    });
    I(this, "onResizeEndHandler", (n) => {
      const { parent: r, columnIndex: o } = this.props, { merge: i } = this.state;
      if (r && r.resizeColumnEnd) {
        const s = o + Dl(i), a = Math.max(xm, n);
        r.resizeColumnEnd(a, s);
      }
    });
    I(this, "onRangeMinMaxChange", (n, r = this.props) => {
      const { dataNode: o, measureTreeNode: i } = r, s = Xx(n.rangeMinMax, o, i);
      s && (this.cellStyle = void 0, this.setState({ backgroundColor: s }));
    });
    // TODO: use React.ReactComponentElement instead JSX.Element
    I(this, "setSortingPopup", (n) => {
      const r = n !== null;
      this.setState((o) => L(C({}, o), {
        sortIconShouldBeVisible: r,
        sortingPopup: n
      }));
    });
    I(this, "handleSortingIconClick", (n) => {
      n.preventDefault(), n.stopPropagation(), this.props.onSortingSettingsChanged(this.props.treeNode, this.props.metadata, this);
    });
    I(this, "createMarkup", (n) => ((!this.cachedHtml || n !== this.cachedHtml.data) && (this.cachedHtml = {
      data: n,
      html: { __html: n }
    }), this.cachedHtml.html));
    I(this, "onCellRef", (n) => {
      n && (this.cellEl = n);
    });
    this.state = {
      isDrilled: !1,
      isSelected: this.getSelectStatus(),
      sortIconShouldBeVisible: !1,
      sortingPopup: null,
      merge: n.merge ? n.merge : { colSpan: n.colSpan, rowSpan: n.rowSpan },
      isEmbedImage: this.getIsEmbedImageStatus(n),
      toolTipText: "",
      cellPadding: 0
    }, this.contentRef = E.createRef();
  }
  componentDidMount() {
    if (this.props.tableSize) {
      this.props.tableSize.notifyChange(), this.props.tableSize.on(si, this.onRangeMinMaxChange);
      const n = this.props.tableSize.getRangeMinMax();
      n && this.onRangeMinMaxChange(n);
    }
    this.dataBarsCheck(), this.updateCellPadding();
  }
  UNSAFE_componentWillReceiveProps(n) {
    if ((this.props.metadata !== n.metadata || this.props.rowMetadata !== n.rowMetadata || this.props.columnMetadata !== n.columnMetadata || this.props.rowIndex !== n.rowIndex || this.props.columnIndex !== n.columnIndex || this.props.fixedWidth !== n.fixedWidth) && (this.metadataClassName = void 0), (this.props.borderWidth !== n.borderWidth || this.props.borderColor !== n.borderColor || this.props.colWidth !== n.colWidth) && (this.virtualBorderStyle = void 0, this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0), (this.props.isDataCell !== n.isDataCell || this.props.treeNode !== n.treeNode || this.props.dataNode !== n.dataNode || jo(this.props) !== jo(n)) && (this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0, this.setState({
      isSelected: !1,
      backgroundColor: void 0
    })), this.props.tableSize !== n.tableSize && (this.props.tableSize && this.props.tableSize.off(si, this.onRangeMinMaxChange), n.tableSize)) {
      n.tableSize.on(si, this.onRangeMinMaxChange);
      const o = n.tableSize.getRangeMinMax();
      o && this.onRangeMinMaxChange(o, n);
    }
    (this.props.merge !== n.merge || this.props.colSpan !== n.colSpan || this.props.rowSpan !== n.rowSpan) && (this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0, this.setState({
      merge: n.merge ? n.merge : { colSpan: n.colSpan, rowSpan: n.rowSpan }
    }));
    const r = n.isDataCell ? n.dataNode : n.treeNode;
    this.props.isSelectedMode && r && r.state && // @ts-ignore
    !r.state.sliced && this.select("isSelected"), (this.props.imageColumns !== n.imageColumns || this.props.treeNode !== n.treeNode) && this.setState({
      isEmbedImage: this.getIsEmbedImageStatus(n)
    });
  }
  componentDidUpdate() {
    this.props.tableSize && this.props.tableSize.notifyChange(), this.dataBarsCheck(), this.updateTooltip();
  }
  componentWillUnmount() {
    this.metadataClassName = void 0, this.virtualBorderStyle = void 0, this.cellStyle = void 0, this.cellContentStyle = void 0, this.databarStyle = void 0, this.props.tableSize && this.props.tableSize.off(si, this.onRangeMinMaxChange);
  }
  dataBarsCheck() {
    const { tableSize: n, columnIndex: r, rowIndex: o } = this.props;
    if (this.hasDataBars() && this.cellEl && n) {
      let s = 0;
      const a = this.cellEl.querySelector(`.${us}`);
      a && (s = a.offsetWidth), n.updateDataBars(r, o, s);
    }
  }
  updateCellPadding() {
    var r, o, i;
    const n = ((r = this.contentRef.current) == null ? void 0 : r.parentElement) && getComputedStyle((i = (o = this.contentRef) == null ? void 0 : o.current) == null ? void 0 : i.parentElement);
    this.setState(L(C({}, this.state), {
      cellPadding: parseInt((n == null ? void 0 : n.paddingLeft) || "") + parseInt((n == null ? void 0 : n.paddingRight) || "") || 0
    }));
  }
  /**
   * add/remove tooltip text for header cell in case text is hidden/visible
   *
   * @private
   */
  updateTooltip() {
    if (this.props.isDataCell)
      return;
    const { toolTipText: n, cellPadding: r } = this.state, o = Yx(this.cellEl, this.contentRef.current, r);
    n !== o && this.setState(L(C({}, this.state), { toolTipText: o }));
  }
  getSelectStatus() {
    let n;
    return this.props.columnTreeNode ? n = this.props.dataNode : this.props.treeNode && (n = this.props.treeNode), !!(this.props.isSelectedMode && n && n.state && // @ts-ignore
    n.state.selected);
  }
  getIsEmbedImageStatus(n) {
    const { isDataCell: r, tableType: o, imageColumns: i } = n, { columnIndex: s } = this.props;
    return r ? !1 : !!(o === Ct.ROWS && i && i.includes(s));
  }
  /**
   * Mark cell as selected
   *
   * @param {string} key - key of state object
   *
   * @returns {void}
   */
  select(n) {
    const r = {
      [n]: !0
    };
    this.setState((o) => C(C({}, o), r));
  }
  /**
   * Mark cell as unselected
   *
   * @param {string} key - key of state object
   *
   * @returns {void}
   */
  unselect(n) {
    const r = {
      [n]: !1
    };
    this.setState((o) => C(C({}, o), r));
  }
  /**
   * Get cell select status
   *
   * @returns {boolean} - return isSelected value
   */
  isDrilled() {
    return this.state.isDrilled;
  }
  hasDataBars() {
    const { tableType: n, rowTreeNode: r, columnTreeNode: o, measureTreeNode: i } = this.props;
    return !(n !== Ct.DATA || !i || !i.databars || r && (r.userType === et.SUB_TOTAL || r.userType === et.GRAND_TOTAL) || o && (o.userType === et.SUB_TOTAL || o.userType === et.GRAND_TOTAL));
  }
  /**
   * Calculates new className string for cell or use cached one
   *
   * @returns {string} - class names
   * @private
   */
  getClassName() {
    const {
      isDataCell: n,
      rowIndex: r,
      columnIndex: o,
      metadata: i,
      rowMetadata: s,
      columnMetadata: a,
      treeNode: u,
      rowTreeNode: l,
      columnTreeNode: d,
      fixedWidth: p,
      tableType: f = ""
    } = this.props, { merge: h } = this.state;
    if (this.metadataClassName === void 0) {
      const g = `${Et}--row-${r}`, m = `${Et}--col-${o}`;
      let v = "", S = "", _ = "";
      n ? (S = `
                    ${Al(s, Et, "row")}
                    ${Al(a, Et, "col")}
                `.trim(), _ = `
                    ${$l(l, Et, "row")}
                    ${$l(d, Et, "col")}
                `.trim(), v = `
                    ${Ll(h, Et, "row")}
                    ${Ll(h, Et, "col")}
                `.trim()) : (S = Al(i, Et), _ = $l(u, Et), v = Ll(h, Et)), this.metadataClassName = pa(
        Et,
        `${Et}--new`,
        `${Et}--${f}`,
        g,
        m,
        S,
        _,
        v,
        p ? HT : ""
      );
    }
    return this.metadataClassName;
  }
  /**
   * Calculates new cell style object or use cached one
   *
   * @returns {object | undefined} - style object
   * @private
   */
  getCellStyle() {
    if (this.cellStyle === void 0) {
      const {
        treeNode: n,
        rowTreeNode: r,
        columnTreeNode: o,
        metadata: i,
        rowMetadata: s,
        columnMetadata: a,
        tableType: u = ""
      } = this.props, { merge: l, backgroundColor: d } = this.state, p = Vx(u, {
        metadata: i,
        rowMetadata: s,
        columnMetadata: a,
        treeNode: n,
        rowTreeNode: r,
        columnTreeNode: o,
        merge: l
      }), f = jo(this.props);
      this.cellStyle = qx(f), this.cellStyle.borderWidth = this.props.borderWidth, this.cellStyle.borderColor === void 0 && delete this.cellStyle.borderColor, p.b || (this.cellStyle.borderColor && (this.cellStyle.borderTopColor = this.cellStyle.borderColor, this.cellStyle.borderLeftColor = this.cellStyle.borderColor, this.cellStyle.borderRightColor = this.cellStyle.borderColor, delete this.cellStyle.borderColor), this.cellStyle.borderBottomColor = "transparent"), d && !this.cellStyle.backgroundColor && (this.cellStyle.backgroundColor = d);
    }
    return this.cellStyle;
  }
  /**
   * Calculates new cell conent style object or use cached one
   *
   * @returns {object} - style object
   * @private
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  getCellContentStyle() {
    if (this.cellContentStyle === void 0) {
      const { fixedWidth: n, styleObj: r, colWidth: o, rowHeight: i, tableType: s } = this.props, a = jo(this.props);
      this.cellContentStyle = Gx(a), (n || this.state.isEmbedImage) && (r.width !== void 0 || o) && (this.cellContentStyle = this.cellContentStyle || {}, this.cellContentStyle.width = lf(
        r.width || o,
        this.props.borderWidth
      )), i && (s === Ct.ROWS || s === Ct.DATA) && (this.cellContentStyle = this.cellContentStyle || {}, this.cellContentStyle.height = i), !i && this.state.isEmbedImage && (this.cellContentStyle = this.cellContentStyle || {}, this.cellContentStyle.lineHeight = 0), this.state.isEmbedImage && (this.cellContentStyle.borderRight = `solid ${this.props.borderWidth || 1}px transparent`);
    }
    return this.cellContentStyle;
  }
  /**
   * Calculates new cell content style object or use cached one
   *
   * @returns {object} - style object
   * @private
   */
  getDatabarsStyle() {
    if (this.databarStyle === void 0) {
      const n = jo(this.props);
      this.databarStyle = Kx(n);
    }
    return this.databarStyle;
  }
  getContentNode() {
    const { colWidth: n, styleObj: r, isDataCell: o, dataNode: i, treeNode: s, borderWidth: a } = this.props, u = o ? i : s, l = u ? u.content || u.value : "", d = (u || {}).store || {}, p = (u || {}).contentType || gc.TEXT;
    if (typeof l == "string" && (p === gc.HTML || this.props.allowHtml && D$.test(l)))
      return /* @__PURE__ */ O("div", { className: us, dangerouslySetInnerHTML: this.createMarkup(l) });
    if (this.state.isEmbedImage) {
      const { rowHeight: h, fallbackImageUrl: g } = this.props;
      return /* @__PURE__ */ O(
        Xb,
        {
          imageUrl: l,
          fallbackImageUrl: g,
          rowHeight: h,
          addCellDomReadyPromise: this.props.addCellDomReadyPromise,
          removeCellDomReadyPromise: this.props.removeCellDomReadyPromise
        }
      );
    }
    if (p === gc.COMPONENT) {
      const f = d, { domReadyDefer: h } = f, g = re(f, ["domReadyDefer"]);
      return /* @__PURE__ */ O("div", { className: us, children: /* @__PURE__ */ O(
        l,
        L(C({}, g), {
          width: lf(r.width || n, a),
          domReadyDefer: h
        })
      ) });
    }
    return /* @__PURE__ */ O("div", { className: us, children: l });
  }
  // eslint-disable-next-line max-lines-per-function,sonarjs/cognitive-complexity
  render() {
    const { isDataCell: n, treeNode: r, tableType: o, tdComponent: i, isMobile: s } = this.props, { merge: a, toolTipText: u } = this.state, l = this.getCellStyle(), d = this.getCellContentStyle(), p = this.getDatabarsStyle();
    let f = this.getClassName() || "", h = !1;
    if (r) {
      h = typeof r.dir != "undefined", f = h ? `${f} ${LT}` : f, s && (f = `${f} ${DT}`);
      let b = "";
      r.dir ? b = r.dir === ct.ASC ? BT : FT : h && !r.dir && (b = Yd(r) === ct.ASC ? zT : jT), f = `${f} ${b}`;
      const { sortIconShouldBeVisible: y } = this.state;
      y && (f = `${f} ${GT}`);
    }
    const g = o === Ct.CORNER || o === Ct.COLUMNS, m = this.hasDataBars(), v = this.state.isSelected && !n ? AT : "", S = this.state.isDrilled ? $T : "", _ = this.getContentNode();
    let R = null;
    return h && (R = /* @__PURE__ */ O(
      L$,
      {
        onRequestClose: () => this.setSortingPopup(null),
        onClick: this.handleSortingIconClick,
        onKeyPress: this.handleSortingIconClick,
        sortingPopup: this.state.sortingPopup,
        className: qT,
        getTooltipContainer: this.props.getSortingPopupContainer
      }
    )), E.createElement(
      i,
      {
        ref: this.onCellRef,
        onClick: this.onCellClick,
        onContextMenu: this.onCellClick,
        onMouseEnter: this.onCellEnter,
        onMouseLeave: this.onCellLeave,
        className: pa(f, S, v),
        style: l,
        colSpan: a ? a.colSpan : void 0,
        rowSpan: a ? a.rowSpan : void 0
      },
      [
        /* @__PURE__ */ fe("div", { className: WT, children: [
          R,
          g && /* @__PURE__ */ O(
            mA,
            {
              onResizeStart: this.onResizeStartHandler,
              onResize: this.onResizeHandler,
              onResizeEnd: this.onResizeEndHandler
            }
          ),
          m && /* @__PURE__ */ O(
            CA,
            {
              columnIndex: this.props.columnIndex,
              tableSize: this.props.tableSize,
              dataNode: this.props.dataNode,
              style: p
            }
          )
        ] }, "corner"),
        /* @__PURE__ */ O("div", { className: VT, style: d, children: /* @__PURE__ */ O(rp, { placement: "top", title: u, children: /* @__PURE__ */ O("div", { className: UT, ref: this.contentRef, "data-testid": "cell-content", children: _ }) }) }, "content")
      ]
    );
  }
}
I(R0, "defaultProps", {
  isDataCell: !1,
  fixedWidth: !1,
  borderWidth: 1,
  onSortingMetadataUpdate: () => {
  }
});
var O0 = Symbol.for("immer-nothing"), Tm = Symbol.for("immer-draftable"), qt = Symbol.for("immer-state"), B$ = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Nt(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = B$[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var So = Object.getPrototypeOf;
function wo(e) {
  return !!e && !!e[qt];
}
function Rr(e) {
  var t;
  return e ? P0(e) || Array.isArray(e) || !!e[Tm] || !!((t = e.constructor) != null && t[Tm]) || hl(e) || ml(e) : !1;
}
var F$ = Object.prototype.constructor.toString();
function P0(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = So(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === F$;
}
function Ea(e, t) {
  fl(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function fl(e) {
  const t = e[qt];
  return t ? t.type_ : Array.isArray(e) ? 1 : hl(e) ? 2 : ml(e) ? 3 : 0;
}
function fd(e, t) {
  return fl(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function I0(e, t, n) {
  const r = fl(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function z$(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function hl(e) {
  return e instanceof Map;
}
function ml(e) {
  return e instanceof Set;
}
function br(e) {
  return e.copy_ || e.base_;
}
function hd(e, t) {
  if (hl(e))
    return new Map(e);
  if (ml(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = P0(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[qt];
    let o = Reflect.ownKeys(r);
    for (let i = 0; i < o.length; i++) {
      const s = o[i], a = r[s];
      a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (r[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: a.enumerable,
        value: e[s]
      });
    }
    return Object.create(So(e), r);
  } else {
    const r = So(e);
    if (r !== null && n)
      return C({}, e);
    const o = Object.create(r);
    return Object.assign(o, e);
  }
}
function up(e, t = !1) {
  return gl(e) || wo(e) || !Rr(e) || (fl(e) > 1 && (e.set = e.add = e.clear = e.delete = j$), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => up(r, !0))), e;
}
function j$() {
  Nt(2);
}
function gl(e) {
  return Object.isFrozen(e);
}
var H$ = {};
function Or(e) {
  const t = H$[e];
  return t || Nt(0, e), t;
}
var Li;
function N0() {
  return Li;
}
function W$(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Em(e, t) {
  t && (Or("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function md(e) {
  gd(e), e.drafts_.forEach(V$), e.drafts_ = null;
}
function gd(e) {
  e === Li && (Li = e.parent_);
}
function Rm(e) {
  return Li = W$(Li, e);
}
function V$(e) {
  const t = e[qt];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Om(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[qt].modified_ && (md(t), Nt(4)), Rr(e) && (e = Ra(t, e), t.parent_ || Oa(t, e)), t.patches_ && Or("Patches").generateReplacementPatches_(
    n[qt].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Ra(t, n, []), md(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== O0 ? e : void 0;
}
function Ra(e, t, n) {
  if (gl(t))
    return t;
  const r = t[qt];
  if (!r)
    return Ea(
      t,
      (o, i) => Pm(e, r, t, o, i, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return Oa(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const o = r.copy_;
    let i = o, s = !1;
    r.type_ === 3 && (i = new Set(o), o.clear(), s = !0), Ea(
      i,
      (a, u) => Pm(e, r, o, a, u, n, s)
    ), Oa(e, o, !1), n && e.patches_ && Or("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function Pm(e, t, n, r, o, i, s) {
  if (process.env.NODE_ENV !== "production" && o === n && Nt(5), wo(o)) {
    const a = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !fd(t.assigned_, r) ? i.concat(r) : void 0, u = Ra(e, o, a);
    if (I0(n, r, u), wo(u))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    s && n.add(o);
  if (Rr(o) && !gl(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    Ra(e, o), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && Oa(e, o);
  }
}
function Oa(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && up(t, n);
}
function U$(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : N0(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = dp;
  n && (o = [r], i = Di);
  const { revoke: s, proxy: a } = Proxy.revocable(o, i);
  return r.draft_ = a, r.revoke_ = s, a;
}
var dp = {
  get(e, t) {
    if (t === qt)
      return e;
    const n = br(e);
    if (!fd(n, t))
      return q$(e, n, t);
    const r = n[t];
    return e.finalized_ || !Rr(r) ? r : r === yc(e.base_, t) ? (vc(e), e.copy_[t] = vd(r, e)) : r;
  },
  has(e, t) {
    return t in br(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(br(e));
  },
  set(e, t, n) {
    const r = M0(br(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = yc(br(e), t), i = o == null ? void 0 : o[qt];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (z$(n, o) && (n !== void 0 || fd(e.base_, t)))
        return !0;
      vc(e), yd(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return yc(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, vc(e), yd(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = br(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Nt(11);
  },
  getPrototypeOf(e) {
    return So(e.base_);
  },
  setPrototypeOf() {
    Nt(12);
  }
}, Di = {};
Ea(dp, (e, t) => {
  Di[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Di.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Nt(13), Di.set.call(this, e, t, void 0);
};
Di.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Nt(14), dp.set.call(this, e[0], t, n, e[0]);
};
function yc(e, t) {
  const n = e[qt];
  return (n ? br(n) : e)[t];
}
function q$(e, t, n) {
  var o;
  const r = M0(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = r.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function M0(e, t) {
  if (!(t in e))
    return;
  let n = So(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = So(n);
  }
}
function yd(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && yd(e.parent_));
}
function vc(e) {
  e.copy_ || (e.copy_ = hd(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var G$ = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const s = this;
        return function(u = i, ...l) {
          return s.produce(u, (d) => n.call(this, d, ...l));
        };
      }
      typeof n != "function" && Nt(6), r !== void 0 && typeof r != "function" && Nt(7);
      let o;
      if (Rr(t)) {
        const i = Rm(this), s = vd(t, void 0);
        let a = !0;
        try {
          o = n(s), a = !1;
        } finally {
          a ? md(i) : gd(i);
        }
        return Em(i, r), Om(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === O0 && (o = void 0), this.autoFreeze_ && up(o, !0), r) {
          const i = [], s = [];
          Or("Patches").generateReplacementPatches_(t, o, i, s), r(i, s);
        }
        return o;
      } else
        Nt(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (s, ...a) => this.produceWithPatches(s, (u) => t(u, ...a));
      let r, o;
      return [this.produce(t, n, (s, a) => {
        r = s, o = a;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Rr(e) || Nt(8), wo(e) && (e = K$(e));
    const t = Rm(this), n = vd(e, void 0);
    return n[qt].isManual_ = !0, gd(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[qt];
    (!n || !n.isManual_) && Nt(9);
    const { scope_: r } = n;
    return Em(r, t), Om(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = Or("Patches").applyPatches_;
    return wo(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function vd(e, t) {
  const n = hl(e) ? Or("MapSet").proxyMap_(e, t) : ml(e) ? Or("MapSet").proxySet_(e, t) : U$(e, t);
  return (t ? t.scope_ : N0()).drafts_.push(n), n;
}
function K$(e) {
  return wo(e) || Nt(10, e), k0(e);
}
function k0(e) {
  if (!Rr(e) || gl(e))
    return e;
  const t = e[qt];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = hd(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = hd(e, !0);
  return Ea(n, (r, o) => {
    I0(n, r, k0(o));
  }), t && (t.finalized_ = !1), n;
}
var Gt = new G$(), bd = Gt.produce;
Gt.produceWithPatches.bind(
  Gt
);
Gt.setAutoFreeze.bind(Gt);
Gt.setUseStrictShallowCopy.bind(Gt);
Gt.applyPatches.bind(Gt);
Gt.createDraft.bind(Gt);
Gt.finishDraft.bind(Gt);
function Im(e) {
  return `‘${e}’`;
}
function Y$(e) {
  return e[e.length - 1];
}
const X$ = (e) => {
  const { hierarchy: t, prependedText: n } = e, r = _t(null), o = _t(null), i = t.map(Im).join(" → "), [s, a] = Wt(i);
  return Ma(() => {
    if (r.current && o.current) {
      const u = r.current.offsetWidth;
      if (o.current.offsetWidth > u) {
        const d = Im(Y$(t));
        a(d);
      }
    }
  }, [t]), /* @__PURE__ */ fe("div", { className: "header-text", children: [
    /* @__PURE__ */ O("span", { className: "header-text__sort-by", children: n }),
    /* @__PURE__ */ O(rp, { placement: "top", title: s, arrow: !0, children: /* @__PURE__ */ O("span", { ref: r, className: "header-text__hierarchy-container", children: /* @__PURE__ */ O("span", { ref: o, children: s }) }) })
  ] });
}, A0 = (e) => {
  const { onCrossIconClick: t, className: n, prependedText: r, hierarchy: o } = e;
  return /* @__PURE__ */ fe("div", { className: n, children: [
    /* @__PURE__ */ O(X$, { hierarchy: o, prependedText: r }),
    !!t && /* @__PURE__ */ O(io, { onClick: t, name: "general-x", className: "cross-icon" })
  ] });
};
function J$(e) {
  return Ve("PrivateSwitchBase", e);
}
Le("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const Q$ = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: o
  } = e, i = {
    root: ["root", n && "checked", r && "disabled", o && `edge${ve(o)}`],
    input: ["input"]
  };
  return Ye(i, J$, t);
}, Z$ = ue(sl)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), eL = ue("input", {
  shouldForwardProp: tn
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), $0 = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const Q = t, {
    autoFocus: r,
    checked: o,
    checkedIcon: i,
    defaultChecked: s,
    disabled: a,
    disableFocusRipple: u = !1,
    edge: l = !1,
    icon: d,
    id: p,
    inputProps: f,
    inputRef: h,
    name: g,
    onBlur: m,
    onChange: v,
    onFocus: S,
    readOnly: _,
    required: R = !1,
    tabIndex: b,
    type: y,
    value: w,
    slots: x = {},
    slotProps: P = {}
  } = Q, N = re(Q, [
    "autoFocus",
    "checked",
    "checkedIcon",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value",
    "slots",
    "slotProps"
  ]), [M, A] = Pi({
    controlled: o,
    default: !!s,
    name: "SwitchBase",
    state: "checked"
  }), T = el(), D = (G) => {
    S && S(G), T && T.onFocus && T.onFocus(G);
  }, j = (G) => {
    m && m(G), T && T.onBlur && T.onBlur(G);
  }, F = (G) => {
    if (G.nativeEvent.defaultPrevented)
      return;
    const V = G.target.checked;
    A(V), v && v(G, V);
  };
  let z = a;
  T && typeof z == "undefined" && (z = T.disabled);
  const H = y === "checkbox" || y === "radio", ee = L(C({}, t), {
    checked: M,
    disabled: z,
    disableFocusRipple: u,
    edge: l
  }), X = Q$(ee), k = {
    slots: x,
    slotProps: C({
      input: f
    }, P)
  }, [$, Y] = Ke("root", {
    ref: n,
    elementType: Z$,
    className: X.root,
    shouldForwardComponentProp: !0,
    externalForwardedProps: C(L(C({}, k), {
      component: "span"
    }), N),
    getSlotProps: (G) => L(C({}, G), {
      onFocus: (V) => {
        var U;
        (U = G.onFocus) == null || U.call(G, V), D(V);
      },
      onBlur: (V) => {
        var U;
        (U = G.onBlur) == null || U.call(G, V), j(V);
      }
    }),
    ownerState: ee,
    additionalProps: {
      centerRipple: !0,
      focusRipple: !u,
      disabled: z,
      role: void 0,
      tabIndex: null
    }
  }), [K, W] = Ke("input", {
    ref: h,
    elementType: eL,
    className: X.input,
    externalForwardedProps: k,
    getSlotProps: (G) => ({
      onChange: (V) => {
        var U;
        (U = G.onChange) == null || U.call(G, V), F(V);
      }
    }),
    ownerState: ee,
    additionalProps: C({
      autoFocus: r,
      checked: o,
      defaultChecked: s,
      disabled: z,
      id: H ? p : void 0,
      name: g,
      readOnly: _,
      required: R,
      tabIndex: b,
      type: y
    }, y === "checkbox" && w === void 0 ? {} : {
      value: w
    })
  });
  return /* @__PURE__ */ fe($, L(C({}, Y), {
    children: [/* @__PURE__ */ O(K, C({}, W)), M ? i : d]
  }));
});
process.env.NODE_ENV !== "production" && ($0.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: c.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: c.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * @ignore
   */
  defaultChecked: c.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: c.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: c.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: un,
  /*
   * @ignore
   */
  name: c.string,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: c.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    input: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.object,
  /**
   * @ignore
   */
  tabIndex: c.oneOfType([c.number, c.string]),
  /**
   * The input component prop `type`.
   */
  type: c.string.isRequired,
  /**
   * The value of the component.
   */
  value: c.any
});
const tL = $0, nL = En(/* @__PURE__ */ O("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), rL = En(/* @__PURE__ */ O("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), oL = En(/* @__PURE__ */ O("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function iL(e) {
  return Ve("MuiCheckbox", e);
}
const sL = Le("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), bc = sL, aL = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: o
  } = e, i = {
    root: ["root", n && "indeterminate", `color${ve(r)}`, `size${ve(o)}`]
  }, s = Ye(i, iL, t);
  return C(C({}, t), s);
}, lL = ue(tL, {
  shouldForwardProp: (e) => tn(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${ve(n.size)}`], n.color !== "default" && t[`color${ve(n.color)}`]];
  }
})($e(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(cn()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : dt(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(cn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${bc.checked}, &.${bc.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${bc.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), cL = /* @__PURE__ */ O(rL, {}), uL = /* @__PURE__ */ O(nL, {}), dL = /* @__PURE__ */ O(oL, {}), L0 = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var P, N, M;
  const r = tt({
    props: t,
    name: "MuiCheckbox"
  }), x = r, {
    checkedIcon: o = cL,
    color: i = "primary",
    icon: s = uL,
    indeterminate: a = !1,
    indeterminateIcon: u = dL,
    inputProps: l,
    size: d = "medium",
    disableRipple: p = !1,
    className: f,
    slots: h = {},
    slotProps: g = {}
  } = x, m = re(x, [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "disableRipple",
    "className",
    "slots",
    "slotProps"
  ]), v = a ? u : s, S = a ? u : o, _ = L(C({}, r), {
    disableRipple: p,
    color: i,
    indeterminate: a,
    size: d
  }), R = aL(_), b = (P = g.input) != null ? P : l, [y, w] = Ke("root", {
    ref: n,
    elementType: lL,
    className: xe(R.root, f),
    shouldForwardComponentProp: !0,
    externalForwardedProps: C({
      slots: h,
      slotProps: g
    }, m),
    ownerState: _,
    additionalProps: {
      type: "checkbox",
      icon: /* @__PURE__ */ E.cloneElement(v, {
        fontSize: (N = v.props.fontSize) != null ? N : d
      }),
      checkedIcon: /* @__PURE__ */ E.cloneElement(S, {
        fontSize: (M = S.props.fontSize) != null ? M : d
      }),
      disableRipple: p,
      slots: h,
      slotProps: {
        input: tb(typeof b == "function" ? b(_) : b, {
          "data-indeterminate": a
        })
      }
    }
  });
  return /* @__PURE__ */ O(y, L(C({}, w), {
    classes: R
  }));
});
process.env.NODE_ENV !== "production" && (L0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: c.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: c.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: c.node,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: c.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: c.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: c.object,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: c.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: c.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    input: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: c.any
});
const pL = L0, fL = cr({
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          width: "28px",
          height: "28px",
          "&.Mui-disabled": {
            opacity: 0.5
          },
          "&:hover": {
            backgroundColor: gt.StInteractionColors.defaultHover
          },
          "& .MuiSvgIcon-root": {
            fontSize: 14,
            fill: gt.StUiColors.default
          }
        }
      }
    }
  }
}), hL = Bi(
  (o, r) => {
    var i = o, { theme: e = fL, dataTestId: t } = i, n = re(i, ["theme", "dataTestId"]);
    return /* @__PURE__ */ O(Po, { children: /* @__PURE__ */ O(Oo, { theme: e, children: /* @__PURE__ */ O(pL, C({ "data-testid": t, ref: r }, n)) }) });
  }
), mL = "LazyLoader-module__loader___Cvl1N", gL = "LazyLoader-module__caption___fA3Vm", Zo = {
  loader: mL,
  caption: gL
}, yL = (e) => {
  const { className: t = "", caption: n = "", isLoading: r = !1 } = e, o = he(
    Zo["loader-two-dots"],
    {
      [Zo["loader-two-dots--inactive"]]: !r
    },
    t
  ), i = he(Zo.loader, Zo["loader-two-dots-indicator"]), s = he(Zo.caption);
  return /* @__PURE__ */ O("div", { className: o, children: r && /* @__PURE__ */ O("div", { "data-testid": "loader-component", className: i, children: n && /* @__PURE__ */ O("div", { className: s, children: /* @__PURE__ */ O("span", { children: n }) }) }) });
}, vL = "DEPRECATED_Icon-module__clickable___Wc4h2", bL = "DEPRECATED_Icon-module__disabled___WZlIY", Nm = {
  clickable: vL,
  disabled: bL
}, Os = () => {
}, Mt = (e) => {
  const [t, n] = Wt(!1), {
    className: r = "",
    disabled: o = !1,
    name: i,
    hoverSuffix: s = "",
    onClick: a = Os,
    onMouseEnter: u = Os,
    onMouseLeave: l = Os,
    title: d = ""
  } = e, p = (w) => {
    t || n(!0), u(w);
  }, f = (w) => {
    t && n(!1), l(w);
  }, h = { top: "auto" }, g = !o && t && s ? `${i}${s}` : i, m = he("app-icon", `app-icon--${g}`), v = he("app-icon__svg"), S = he(m, r, {
    [Nm.clickable]: a !== Os,
    [Nm.disabled]: o
  }), y = e, { dataTestId: _ } = y, R = re(y, ["dataTestId"]), b = C({ disabled: o, onClick: a }, R);
  return d && !o && (b.title = d), delete b.hoverSuffix, /* @__PURE__ */ O(
    "span",
    L(C({}, b), {
      className: S,
      onMouseEnter: p,
      onMouseLeave: f,
      "data-testid": _,
      children: /* @__PURE__ */ fe("svg", { className: v, style: h, children: [
        /* @__PURE__ */ O("use", { xlinkHref: `#${g}` }),
        /* @__PURE__ */ O("symbol", { id: "general-arrow-down", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
          "path",
          {
            fill: "currentColor",
            d: "M12 13.84l3.174-2.719a.5.5 0 0 1 .65.76l-3.5 2.998a.5.5 0 0 1-.65 0l-3.5-2.998a.5.5 0 1 1 .65-.76L12 13.841z"
          }
        ) }),
        /* @__PURE__ */ O("symbol", { id: "general-vi-small-white", viewBox: "0 0 24 24", children: /* @__PURE__ */ O(
          "path",
          {
            fill: "currentColor",
            d: "M8.354 11.646l-.708.708 3.418 3.417 5.343-7.48-.814-.582-4.657 6.52z"
          }
        ) })
      ] })
    })
  );
}, CL = "Checkbox-module__transparent___wi79A", SL = "Checkbox-module__icon___Hm4xR", wL = "Checkbox-module__disabled___sHRTv", _L = "Checkbox-module__sharedComponentsInputCheckbox___VU8jI", Ps = {
  transparent: CL,
  icon: SL,
  disabled: wL,
  sharedComponentsInputCheckbox: _L
}, xL = (e) => {
  const R = e, {
    className: t,
    disabled: n,
    inline: r,
    text: o,
    textClassName: i,
    title: s,
    transparent: a,
    dataTestId: u,
    iconName: l,
    onDescriptionClick: d,
    inputCheckboxClassName: p
  } = R, f = re(R, [
    "className",
    "disabled",
    "inline",
    "text",
    "textClassName",
    "title",
    "transparent",
    "dataTestId",
    "iconName",
    "onDescriptionClick",
    "inputCheckboxClassName"
  ]), h = C({ disabled: n }, f);
  s && !n && (h.title = s);
  const g = "custom-checkbox", m = he(
    g,
    {
      "custom-checkbox--inline": r,
      [Ps.disabled]: n
    },
    t
  ), v = he(`${g}__icon`, "app-icon app-icon--form-checkbox-mark", {
    [Ps.transparent]: a
  }), S = he(`${g}__text`, i), _ = d ? (b) => {
    d(), b.preventDefault();
  } : void 0;
  return /* @__PURE__ */ O("div", { className: m, children: /* @__PURE__ */ fe("label", { className: `${g}__label`, children: [
    /* @__PURE__ */ fe("div", { className: he(Ps.sharedComponentsInputCheckbox, p), children: [
      /* @__PURE__ */ O(
        "input",
        C({
          type: "checkbox",
          className: `${g}__input`,
          "data-testid": u
        }, h)
      ),
      /* @__PURE__ */ O("span", { className: v, children: /* @__PURE__ */ O("svg", { className: "app-icon__svg", children: /* @__PURE__ */ O("use", { xlinkHref: "#form-checkbox-mark" }) }) })
    ] }),
    l && /* @__PURE__ */ O(
      Mt,
      {
        name: l,
        className: Ps.icon,
        onClick: _
      }
    ),
    /* @__PURE__ */ O("span", { className: S, onClick: _, children: o })
  ] }) });
}, TL = ({
  checked: e,
  onChange: t,
  className: n = "",
  disabled: r = !1,
  inline: o = !1,
  text: i = ""
}) => {
  const s = {
    checked: e,
    disabled: r,
    onChange: t
  }, a = "custom-togglebtn", u = he(
    a,
    {
      [`${a}--inline`]: o
    },
    n
  ), l = `${a}__icon`;
  return /* @__PURE__ */ O("div", { className: u, children: /* @__PURE__ */ fe("label", { className: `${a}__label`, children: [
    /* @__PURE__ */ O("input", C({ type: "checkbox", className: `${a}__input` }, s)),
    /* @__PURE__ */ O("span", { className: l }),
    i && /* @__PURE__ */ O("span", { className: `${a}__text`, children: i })
  ] }) });
}, EL = "RadioButton-module__sharedComponentsInputRadioButton___fIOZu", RL = "RadioButton-module__disabled___jMV-0", Mm = {
  sharedComponentsInputRadioButton: EL,
  disabled: RL
}, OL = ({
  checked: e,
  text: t,
  disabled: n = !1,
  inline: r = !1,
  title: o = "",
  name: i = "",
  value: s,
  onChange: a,
  preventClick: u,
  inputRadioButtonClassName: l,
  className: d,
  textClassName: p,
  dataTestId: f = void 0
}) => {
  const h = C({
    disabled: n,
    name: i,
    value: s
  }, o && !n && { title: o }), g = (v) => {
    if (u) {
      v.preventDefault(), v.stopPropagation();
      return;
    }
    a(v);
  }, m = he(
    "custom-radiobtn",
    {
      "custom-radiobtn--inline": r,
      [Mm.disabled]: n
    },
    d
  );
  return /* @__PURE__ */ O("div", { className: m, children: /* @__PURE__ */ fe("label", { className: "custom-radiobtn__label", children: [
    /* @__PURE__ */ fe(
      "div",
      {
        className: he(
          Mm.sharedComponentsInputRadioButton,
          l,
          {}
        ),
        children: [
          /* @__PURE__ */ O(
            "input",
            C({
              className: "custom-radiobtn__input",
              type: "radio",
              onChange: g,
              checked: e,
              "data-testid": f
            }, h)
          ),
          /* @__PURE__ */ O("span", { className: "custom-radiobtn__icon" })
        ]
      }
    ),
    /* @__PURE__ */ O("span", { className: he("custom-radiobtn__text", p), children: t })
  ] }) });
};
function Pa(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var PL = typeof global == "object" && global && global.Object === Object && global, IL = typeof self == "object" && self && self.Object === Object && self, D0 = PL || IL || Function("return this")(), Cc = function() {
  return D0.Date.now();
}, NL = /\s/;
function ML(e) {
  for (var t = e.length; t-- && NL.test(e.charAt(t)); )
    ;
  return t;
}
var kL = /^\s+/;
function AL(e) {
  return e && e.slice(0, ML(e) + 1).replace(kL, "");
}
var Ia = D0.Symbol, B0 = Object.prototype, $L = B0.hasOwnProperty, LL = B0.toString, ei = Ia ? Ia.toStringTag : void 0;
function DL(e) {
  var t = $L.call(e, ei), n = e[ei];
  try {
    e[ei] = void 0;
    var r = !0;
  } catch (i) {
  }
  var o = LL.call(e);
  return r && (t ? e[ei] = n : delete e[ei]), o;
}
var BL = Object.prototype, FL = BL.toString;
function zL(e) {
  return FL.call(e);
}
var jL = "[object Null]", HL = "[object Undefined]", km = Ia ? Ia.toStringTag : void 0;
function WL(e) {
  return e == null ? e === void 0 ? HL : jL : km && km in Object(e) ? DL(e) : zL(e);
}
function VL(e) {
  return e != null && typeof e == "object";
}
var UL = "[object Symbol]";
function qL(e) {
  return typeof e == "symbol" || VL(e) && WL(e) == UL;
}
var Am = NaN, GL = /^[-+]0x[0-9a-f]+$/i, KL = /^0b[01]+$/i, YL = /^0o[0-7]+$/i, XL = parseInt;
function $m(e) {
  if (typeof e == "number")
    return e;
  if (qL(e))
    return Am;
  if (Pa(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Pa(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = AL(e);
  var n = KL.test(e);
  return n || YL.test(e) ? XL(e.slice(2), n ? 2 : 8) : GL.test(e) ? Am : +e;
}
var JL = "Expected a function", QL = Math.max, ZL = Math.min;
function Zs(e, t, n) {
  var r, o, i, s, a, u, l = 0, d = !1, p = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(JL);
  t = $m(t) || 0, Pa(n) && (d = !!n.leading, p = "maxWait" in n, i = p ? QL($m(n.maxWait) || 0, t) : i, f = "trailing" in n ? !!n.trailing : f);
  function h(w) {
    var x = r, P = o;
    return r = o = void 0, l = w, s = e.apply(P, x), s;
  }
  function g(w) {
    return l = w, a = setTimeout(S, t), d ? h(w) : s;
  }
  function m(w) {
    var x = w - u, P = w - l, N = t - x;
    return p ? ZL(N, i - P) : N;
  }
  function v(w) {
    var x = w - u, P = w - l;
    return u === void 0 || x >= t || x < 0 || p && P >= i;
  }
  function S() {
    var w = Cc();
    if (v(w))
      return _(w);
    a = setTimeout(S, m(w));
  }
  function _(w) {
    return a = void 0, f && r ? h(w) : (r = o = void 0, s);
  }
  function R() {
    a !== void 0 && clearTimeout(a), l = 0, r = u = o = a = void 0;
  }
  function b() {
    return a === void 0 ? s : _(Cc());
  }
  function y() {
    var w = Cc(), x = v(w);
    if (r = arguments, o = this, u = w, x) {
      if (a === void 0)
        return g(u);
      if (p)
        return clearTimeout(a), a = setTimeout(S, t), h(u);
    }
    return a === void 0 && (a = setTimeout(S, t)), s;
  }
  return y.cancel = R, y.flush = b, y;
}
var eD = "Expected a function";
function tD(e, t, n) {
  var r = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(eD);
  return Pa(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), Zs(e, t, {
    leading: r,
    maxWait: t,
    trailing: o
  });
}
var lo = function() {
  return lo = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, lo.apply(this, arguments);
};
function F0(e) {
  return !e || !e.ownerDocument || !e.ownerDocument.defaultView ? window : e.ownerDocument.defaultView;
}
function z0(e) {
  return !e || !e.ownerDocument ? document : e.ownerDocument;
}
var j0 = function(e) {
  var t = {}, n = Array.prototype.reduce.call(e, function(r, o) {
    var i = o.name.match(/data-simplebar-(.+)/);
    if (i) {
      var s = i[1].replace(/\W+(.)/g, function(a, u) {
        return u.toUpperCase();
      });
      switch (o.value) {
        case "true":
          r[s] = !0;
          break;
        case "false":
          r[s] = !1;
          break;
        case void 0:
          r[s] = !0;
          break;
        default:
          r[s] = o.value;
      }
    }
    return r;
  }, t);
  return n;
};
function H0(e, t) {
  var n;
  e && (n = e.classList).add.apply(n, t.split(" "));
}
function W0(e, t) {
  e && t.split(" ").forEach(function(n) {
    e.classList.remove(n);
  });
}
function V0(e) {
  return ".".concat(e.split(" ").join("."));
}
var pp = !!(typeof window < "u" && window.document && window.document.createElement), nD = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  addClasses: H0,
  canUseDOM: pp,
  classNamesToQuery: V0,
  getElementDocument: z0,
  getElementWindow: F0,
  getOptions: j0,
  removeClasses: W0
}), to = null, Lm = null;
pp && window.addEventListener("resize", function() {
  Lm !== window.devicePixelRatio && (Lm = window.devicePixelRatio, to = null);
});
function Dm() {
  if (to === null) {
    if (typeof document > "u")
      return to = 0, to;
    var e = document.body, t = document.createElement("div");
    t.classList.add("simplebar-hide-scrollbar"), e.appendChild(t);
    var n = t.getBoundingClientRect().right;
    e.removeChild(t), to = n;
  }
  return to;
}
var Xn = F0, Sc = z0, rD = j0, Jn = H0, Qn = W0, Rt = V0, ti = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {});
      var r = this;
      if (this.removePreventClickId = null, this.minScrollbarWidth = 20, this.stopScrollDelay = 175, this.isScrolling = !1, this.isMouseEntering = !1, this.isDragging = !1, this.scrollXTicking = !1, this.scrollYTicking = !1, this.wrapperEl = null, this.contentWrapperEl = null, this.contentEl = null, this.offsetEl = null, this.maskEl = null, this.placeholderEl = null, this.heightAutoObserverWrapperEl = null, this.heightAutoObserverEl = null, this.rtlHelpers = null, this.scrollbarWidth = 0, this.resizeObserver = null, this.mutationObserver = null, this.elStyles = null, this.isRtl = null, this.mouseX = 0, this.mouseY = 0, this.onMouseMove = function() {
      }, this.onWindowResize = function() {
      }, this.onStopScrolling = function() {
      }, this.onMouseEntered = function() {
      }, this.onScroll = function() {
        var o = Xn(r.el);
        r.scrollXTicking || (o.requestAnimationFrame(r.scrollX), r.scrollXTicking = !0), r.scrollYTicking || (o.requestAnimationFrame(r.scrollY), r.scrollYTicking = !0), r.isScrolling || (r.isScrolling = !0, Jn(r.el, r.classNames.scrolling)), r.showScrollbar("x"), r.showScrollbar("y"), r.onStopScrolling();
      }, this.scrollX = function() {
        r.axis.x.isOverflowing && r.positionScrollbar("x"), r.scrollXTicking = !1;
      }, this.scrollY = function() {
        r.axis.y.isOverflowing && r.positionScrollbar("y"), r.scrollYTicking = !1;
      }, this._onStopScrolling = function() {
        Qn(r.el, r.classNames.scrolling), r.options.autoHide && (r.hideScrollbar("x"), r.hideScrollbar("y")), r.isScrolling = !1;
      }, this.onMouseEnter = function() {
        r.isMouseEntering || (Jn(r.el, r.classNames.mouseEntered), r.showScrollbar("x"), r.showScrollbar("y"), r.isMouseEntering = !0), r.onMouseEntered();
      }, this._onMouseEntered = function() {
        Qn(r.el, r.classNames.mouseEntered), r.options.autoHide && (r.hideScrollbar("x"), r.hideScrollbar("y")), r.isMouseEntering = !1;
      }, this._onMouseMove = function(o) {
        r.mouseX = o.clientX, r.mouseY = o.clientY, (r.axis.x.isOverflowing || r.axis.x.forceVisible) && r.onMouseMoveForAxis("x"), (r.axis.y.isOverflowing || r.axis.y.forceVisible) && r.onMouseMoveForAxis("y");
      }, this.onMouseLeave = function() {
        r.onMouseMove.cancel(), (r.axis.x.isOverflowing || r.axis.x.forceVisible) && r.onMouseLeaveForAxis("x"), (r.axis.y.isOverflowing || r.axis.y.forceVisible) && r.onMouseLeaveForAxis("y"), r.mouseX = -1, r.mouseY = -1;
      }, this._onWindowResize = function() {
        r.scrollbarWidth = r.getScrollbarWidth(), r.hideNativeScrollbar();
      }, this.onPointerEvent = function(o) {
        if (!(!r.axis.x.track.el || !r.axis.y.track.el || !r.axis.x.scrollbar.el || !r.axis.y.scrollbar.el)) {
          var i, s;
          r.axis.x.track.rect = r.axis.x.track.el.getBoundingClientRect(), r.axis.y.track.rect = r.axis.y.track.el.getBoundingClientRect(), (r.axis.x.isOverflowing || r.axis.x.forceVisible) && (i = r.isWithinBounds(r.axis.x.track.rect)), (r.axis.y.isOverflowing || r.axis.y.forceVisible) && (s = r.isWithinBounds(r.axis.y.track.rect)), (i || s) && (o.stopPropagation(), o.type === "pointerdown" && o.pointerType !== "touch" && (i && (r.axis.x.scrollbar.rect = r.axis.x.scrollbar.el.getBoundingClientRect(), r.isWithinBounds(r.axis.x.scrollbar.rect) ? r.onDragStart(o, "x") : r.onTrackClick(o, "x")), s && (r.axis.y.scrollbar.rect = r.axis.y.scrollbar.el.getBoundingClientRect(), r.isWithinBounds(r.axis.y.scrollbar.rect) ? r.onDragStart(o, "y") : r.onTrackClick(o, "y"))));
        }
      }, this.drag = function(o) {
        var i, s, a, u, l, d, p, f, h, g, m;
        if (!(!r.draggedAxis || !r.contentWrapperEl)) {
          var v, S = r.axis[r.draggedAxis].track, _ = (s = (i = S.rect) === null || i === void 0 ? void 0 : i[r.axis[r.draggedAxis].sizeAttr]) !== null && s !== void 0 ? s : 0, R = r.axis[r.draggedAxis].scrollbar, b = (u = (a = r.contentWrapperEl) === null || a === void 0 ? void 0 : a[r.axis[r.draggedAxis].scrollSizeAttr]) !== null && u !== void 0 ? u : 0, y = parseInt((d = (l = r.elStyles) === null || l === void 0 ? void 0 : l[r.axis[r.draggedAxis].sizeAttr]) !== null && d !== void 0 ? d : "0px", 10);
          o.preventDefault(), o.stopPropagation(), r.draggedAxis === "y" ? v = o.pageY : v = o.pageX;
          var w = v - ((f = (p = S.rect) === null || p === void 0 ? void 0 : p[r.axis[r.draggedAxis].offsetAttr]) !== null && f !== void 0 ? f : 0) - r.axis[r.draggedAxis].dragOffset;
          w = r.draggedAxis === "x" && r.isRtl ? ((g = (h = S.rect) === null || h === void 0 ? void 0 : h[r.axis[r.draggedAxis].sizeAttr]) !== null && g !== void 0 ? g : 0) - R.size - w : w;
          var x = w / (_ - R.size), P = x * (b - y);
          r.draggedAxis === "x" && r.isRtl && (P = !((m = e.getRtlHelpers()) === null || m === void 0) && m.isScrollingToNegative ? -P : P), r.contentWrapperEl[r.axis[r.draggedAxis].scrollOffsetAttr] = P;
        }
      }, this.onEndDrag = function(o) {
        r.isDragging = !1;
        var i = Sc(r.el), s = Xn(r.el);
        o.preventDefault(), o.stopPropagation(), Qn(r.el, r.classNames.dragging), r.onStopScrolling(), i.removeEventListener("mousemove", r.drag, !0), i.removeEventListener("mouseup", r.onEndDrag, !0), r.removePreventClickId = s.setTimeout(function() {
          i.removeEventListener("click", r.preventClick, !0), i.removeEventListener("dblclick", r.preventClick, !0), r.removePreventClickId = null;
        });
      }, this.preventClick = function(o) {
        o.preventDefault(), o.stopPropagation();
      }, this.el = t, this.options = lo(lo({}, e.defaultOptions), n), this.classNames = lo(lo({}, e.defaultOptions.classNames), n.classNames), this.axis = {
        x: {
          scrollOffsetAttr: "scrollLeft",
          sizeAttr: "width",
          scrollSizeAttr: "scrollWidth",
          offsetSizeAttr: "offsetWidth",
          offsetAttr: "left",
          overflowAttr: "overflowX",
          dragOffset: 0,
          isOverflowing: !0,
          forceVisible: !1,
          track: { size: null, el: null, rect: null, isVisible: !1 },
          scrollbar: { size: null, el: null, rect: null, isVisible: !1 }
        },
        y: {
          scrollOffsetAttr: "scrollTop",
          sizeAttr: "height",
          scrollSizeAttr: "scrollHeight",
          offsetSizeAttr: "offsetHeight",
          offsetAttr: "top",
          overflowAttr: "overflowY",
          dragOffset: 0,
          isOverflowing: !0,
          forceVisible: !1,
          track: { size: null, el: null, rect: null, isVisible: !1 },
          scrollbar: { size: null, el: null, rect: null, isVisible: !1 }
        }
      }, typeof this.el != "object" || !this.el.nodeName)
        throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));
      this.onMouseMove = tD(this._onMouseMove, 64), this.onWindowResize = Zs(this._onWindowResize, 64, { leading: !0 }), this.onStopScrolling = Zs(this._onStopScrolling, this.stopScrollDelay), this.onMouseEntered = Zs(this._onMouseEntered, this.stopScrollDelay), this.init();
    }
    return e.getRtlHelpers = function() {
      if (e.rtlHelpers)
        return e.rtlHelpers;
      var t = document.createElement("div");
      t.innerHTML = '<div class="simplebar-dummy-scrollbar-size"><div></div></div>';
      var n = t.firstElementChild, r = n == null ? void 0 : n.firstElementChild;
      if (!r)
        return null;
      document.body.appendChild(n), n.scrollLeft = 0;
      var o = e.getOffset(n), i = e.getOffset(r);
      n.scrollLeft = -999;
      var s = e.getOffset(r);
      return document.body.removeChild(n), e.rtlHelpers = {
        // determines if the scrolling is responding with negative values
        isScrollOriginAtZero: o.left !== i.left,
        // determines if the origin scrollbar position is inverted or not (positioned on left or right)
        isScrollingToNegative: i.left !== s.left
      }, e.rtlHelpers;
    }, e.prototype.getScrollbarWidth = function() {
      try {
        return this.contentWrapperEl && getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style ? 0 : Dm();
      } catch (t) {
        return Dm();
      }
    }, e.getOffset = function(t) {
      var n = t.getBoundingClientRect(), r = Sc(t), o = Xn(t);
      return {
        top: n.top + (o.pageYOffset || r.documentElement.scrollTop),
        left: n.left + (o.pageXOffset || r.documentElement.scrollLeft)
      };
    }, e.prototype.init = function() {
      pp && (this.initDOM(), this.rtlHelpers = e.getRtlHelpers(), this.scrollbarWidth = this.getScrollbarWidth(), this.recalculate(), this.initListeners());
    }, e.prototype.initDOM = function() {
      var t, n;
      this.wrapperEl = this.el.querySelector(Rt(this.classNames.wrapper)), this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector(Rt(this.classNames.contentWrapper)), this.contentEl = this.options.contentNode || this.el.querySelector(Rt(this.classNames.contentEl)), this.offsetEl = this.el.querySelector(Rt(this.classNames.offset)), this.maskEl = this.el.querySelector(Rt(this.classNames.mask)), this.placeholderEl = this.findChild(this.wrapperEl, Rt(this.classNames.placeholder)), this.heightAutoObserverWrapperEl = this.el.querySelector(Rt(this.classNames.heightAutoObserverWrapperEl)), this.heightAutoObserverEl = this.el.querySelector(Rt(this.classNames.heightAutoObserverEl)), this.axis.x.track.el = this.findChild(this.el, "".concat(Rt(this.classNames.track)).concat(Rt(this.classNames.horizontal))), this.axis.y.track.el = this.findChild(this.el, "".concat(Rt(this.classNames.track)).concat(Rt(this.classNames.vertical))), this.axis.x.scrollbar.el = ((t = this.axis.x.track.el) === null || t === void 0 ? void 0 : t.querySelector(Rt(this.classNames.scrollbar))) || null, this.axis.y.scrollbar.el = ((n = this.axis.y.track.el) === null || n === void 0 ? void 0 : n.querySelector(Rt(this.classNames.scrollbar))) || null, this.options.autoHide || (Jn(this.axis.x.scrollbar.el, this.classNames.visible), Jn(this.axis.y.scrollbar.el, this.classNames.visible));
    }, e.prototype.initListeners = function() {
      var t = this, n, r = Xn(this.el);
      if (this.el.addEventListener("mouseenter", this.onMouseEnter), this.el.addEventListener("pointerdown", this.onPointerEvent, !0), this.el.addEventListener("mousemove", this.onMouseMove), this.el.addEventListener("mouseleave", this.onMouseLeave), (n = this.contentWrapperEl) === null || n === void 0 || n.addEventListener("scroll", this.onScroll), r.addEventListener("resize", this.onWindowResize), !!this.contentEl) {
        if (window.ResizeObserver) {
          var o = !1, i = r.ResizeObserver || ResizeObserver;
          this.resizeObserver = new i(function() {
            o && r.requestAnimationFrame(function() {
              t.recalculate();
            });
          }), this.resizeObserver.observe(this.el), this.resizeObserver.observe(this.contentEl), r.requestAnimationFrame(function() {
            o = !0;
          });
        }
        this.mutationObserver = new r.MutationObserver(function() {
          r.requestAnimationFrame(function() {
            t.recalculate();
          });
        }), this.mutationObserver.observe(this.contentEl, {
          childList: !0,
          subtree: !0,
          characterData: !0
        });
      }
    }, e.prototype.recalculate = function() {
      if (!(!this.heightAutoObserverEl || !this.contentEl || !this.contentWrapperEl || !this.wrapperEl || !this.placeholderEl)) {
        var t = Xn(this.el);
        this.elStyles = t.getComputedStyle(this.el), this.isRtl = this.elStyles.direction === "rtl";
        var n = this.contentEl.offsetWidth, r = this.heightAutoObserverEl.offsetHeight <= 1, o = this.heightAutoObserverEl.offsetWidth <= 1 || n > 0, i = this.contentWrapperEl.offsetWidth, s = this.elStyles.overflowX, a = this.elStyles.overflowY;
        this.contentEl.style.padding = "".concat(this.elStyles.paddingTop, " ").concat(this.elStyles.paddingRight, " ").concat(this.elStyles.paddingBottom, " ").concat(this.elStyles.paddingLeft), this.wrapperEl.style.margin = "-".concat(this.elStyles.paddingTop, " -").concat(this.elStyles.paddingRight, " -").concat(this.elStyles.paddingBottom, " -").concat(this.elStyles.paddingLeft);
        var u = this.contentEl.scrollHeight, l = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = r ? "auto" : "100%", this.placeholderEl.style.width = o ? "".concat(n || l, "px") : "auto", this.placeholderEl.style.height = "".concat(u, "px");
        var d = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = n !== 0 && l > n, this.axis.y.isOverflowing = u > d, this.axis.x.isOverflowing = s === "hidden" ? !1 : this.axis.x.isOverflowing, this.axis.y.isOverflowing = a === "hidden" ? !1 : this.axis.y.isOverflowing, this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === !0, this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === !0, this.hideNativeScrollbar();
        var p = this.axis.x.isOverflowing ? this.scrollbarWidth : 0, f = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && l > i - f, this.axis.y.isOverflowing = this.axis.y.isOverflowing && u > d - p, this.axis.x.scrollbar.size = this.getScrollbarSize("x"), this.axis.y.scrollbar.size = this.getScrollbarSize("y"), this.axis.x.scrollbar.el && (this.axis.x.scrollbar.el.style.width = "".concat(this.axis.x.scrollbar.size, "px")), this.axis.y.scrollbar.el && (this.axis.y.scrollbar.el.style.height = "".concat(this.axis.y.scrollbar.size, "px")), this.positionScrollbar("x"), this.positionScrollbar("y"), this.toggleTrackVisibility("x"), this.toggleTrackVisibility("y");
      }
    }, e.prototype.getScrollbarSize = function(t) {
      var n, r;
      if (t === void 0 && (t = "y"), !this.axis[t].isOverflowing || !this.contentEl)
        return 0;
      var o = this.contentEl[this.axis[t].scrollSizeAttr], i = (r = (n = this.axis[t].track.el) === null || n === void 0 ? void 0 : n[this.axis[t].offsetSizeAttr]) !== null && r !== void 0 ? r : 0, s = i / o, a;
      return a = Math.max(~~(s * i), this.options.scrollbarMinSize), this.options.scrollbarMaxSize && (a = Math.min(a, this.options.scrollbarMaxSize)), a;
    }, e.prototype.positionScrollbar = function(t) {
      var n, r, o;
      t === void 0 && (t = "y");
      var i = this.axis[t].scrollbar;
      if (!(!this.axis[t].isOverflowing || !this.contentWrapperEl || !i.el || !this.elStyles)) {
        var s = this.contentWrapperEl[this.axis[t].scrollSizeAttr], a = ((n = this.axis[t].track.el) === null || n === void 0 ? void 0 : n[this.axis[t].offsetSizeAttr]) || 0, u = parseInt(this.elStyles[this.axis[t].sizeAttr], 10), l = this.contentWrapperEl[this.axis[t].scrollOffsetAttr];
        l = t === "x" && this.isRtl && !((r = e.getRtlHelpers()) === null || r === void 0) && r.isScrollOriginAtZero ? -l : l, t === "x" && this.isRtl && (l = !((o = e.getRtlHelpers()) === null || o === void 0) && o.isScrollingToNegative ? l : -l);
        var d = l / (s - u), p = ~~((a - i.size) * d);
        p = t === "x" && this.isRtl ? -p + (a - i.size) : p, i.el.style.transform = t === "x" ? "translate3d(".concat(p, "px, 0, 0)") : "translate3d(0, ".concat(p, "px, 0)");
      }
    }, e.prototype.toggleTrackVisibility = function(t) {
      t === void 0 && (t = "y");
      var n = this.axis[t].track.el, r = this.axis[t].scrollbar.el;
      !n || !r || !this.contentWrapperEl || (this.axis[t].isOverflowing || this.axis[t].forceVisible ? (n.style.visibility = "visible", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "scroll", this.el.classList.add("".concat(this.classNames.scrollable, "-").concat(t))) : (n.style.visibility = "hidden", this.contentWrapperEl.style[this.axis[t].overflowAttr] = "hidden", this.el.classList.remove("".concat(this.classNames.scrollable, "-").concat(t))), this.axis[t].isOverflowing ? r.style.display = "block" : r.style.display = "none");
    }, e.prototype.showScrollbar = function(t) {
      t === void 0 && (t = "y"), this.axis[t].isOverflowing && !this.axis[t].scrollbar.isVisible && (Jn(this.axis[t].scrollbar.el, this.classNames.visible), this.axis[t].scrollbar.isVisible = !0);
    }, e.prototype.hideScrollbar = function(t) {
      t === void 0 && (t = "y"), !this.isDragging && this.axis[t].isOverflowing && this.axis[t].scrollbar.isVisible && (Qn(this.axis[t].scrollbar.el, this.classNames.visible), this.axis[t].scrollbar.isVisible = !1);
    }, e.prototype.hideNativeScrollbar = function() {
      this.offsetEl && (this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px", this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-".concat(this.scrollbarWidth, "px") : "0px");
    }, e.prototype.onMouseMoveForAxis = function(t) {
      t === void 0 && (t = "y");
      var n = this.axis[t];
      !n.track.el || !n.scrollbar.el || (n.track.rect = n.track.el.getBoundingClientRect(), n.scrollbar.rect = n.scrollbar.el.getBoundingClientRect(), this.isWithinBounds(n.track.rect) ? (this.showScrollbar(t), Jn(n.track.el, this.classNames.hover), this.isWithinBounds(n.scrollbar.rect) ? Jn(n.scrollbar.el, this.classNames.hover) : Qn(n.scrollbar.el, this.classNames.hover)) : (Qn(n.track.el, this.classNames.hover), this.options.autoHide && this.hideScrollbar(t)));
    }, e.prototype.onMouseLeaveForAxis = function(t) {
      t === void 0 && (t = "y"), Qn(this.axis[t].track.el, this.classNames.hover), Qn(this.axis[t].scrollbar.el, this.classNames.hover), this.options.autoHide && this.hideScrollbar(t);
    }, e.prototype.onDragStart = function(t, n) {
      var r;
      n === void 0 && (n = "y"), this.isDragging = !0;
      var o = Sc(this.el), i = Xn(this.el), s = this.axis[n].scrollbar, a = n === "y" ? t.pageY : t.pageX;
      this.axis[n].dragOffset = a - (((r = s.rect) === null || r === void 0 ? void 0 : r[this.axis[n].offsetAttr]) || 0), this.draggedAxis = n, Jn(this.el, this.classNames.dragging), o.addEventListener("mousemove", this.drag, !0), o.addEventListener("mouseup", this.onEndDrag, !0), this.removePreventClickId === null ? (o.addEventListener("click", this.preventClick, !0), o.addEventListener("dblclick", this.preventClick, !0)) : (i.clearTimeout(this.removePreventClickId), this.removePreventClickId = null);
    }, e.prototype.onTrackClick = function(t, n) {
      var r = this, o, i, s, a;
      n === void 0 && (n = "y");
      var u = this.axis[n];
      if (!(!this.options.clickOnTrack || !u.scrollbar.el || !this.contentWrapperEl)) {
        t.preventDefault();
        var l = Xn(this.el);
        this.axis[n].scrollbar.rect = u.scrollbar.el.getBoundingClientRect();
        var d = this.axis[n].scrollbar, p = (i = (o = d.rect) === null || o === void 0 ? void 0 : o[this.axis[n].offsetAttr]) !== null && i !== void 0 ? i : 0, f = parseInt((a = (s = this.elStyles) === null || s === void 0 ? void 0 : s[this.axis[n].sizeAttr]) !== null && a !== void 0 ? a : "0px", 10), h = this.contentWrapperEl[this.axis[n].scrollOffsetAttr], g = n === "y" ? this.mouseY - p : this.mouseX - p, m = g < 0 ? -1 : 1, v = m === -1 ? h - f : h + f, S = 40, _ = function() {
          r.contentWrapperEl && (m === -1 ? h > v && (h -= S, r.contentWrapperEl[r.axis[n].scrollOffsetAttr] = h, l.requestAnimationFrame(_)) : h < v && (h += S, r.contentWrapperEl[r.axis[n].scrollOffsetAttr] = h, l.requestAnimationFrame(_)));
        };
        _();
      }
    }, e.prototype.getContentElement = function() {
      return this.contentEl;
    }, e.prototype.getScrollElement = function() {
      return this.contentWrapperEl;
    }, e.prototype.removeListeners = function() {
      var t = Xn(this.el);
      this.el.removeEventListener("mouseenter", this.onMouseEnter), this.el.removeEventListener("pointerdown", this.onPointerEvent, !0), this.el.removeEventListener("mousemove", this.onMouseMove), this.el.removeEventListener("mouseleave", this.onMouseLeave), this.contentWrapperEl && this.contentWrapperEl.removeEventListener("scroll", this.onScroll), t.removeEventListener("resize", this.onWindowResize), this.mutationObserver && this.mutationObserver.disconnect(), this.resizeObserver && this.resizeObserver.disconnect(), this.onMouseMove.cancel(), this.onWindowResize.cancel(), this.onStopScrolling.cancel(), this.onMouseEntered.cancel();
    }, e.prototype.unMount = function() {
      this.removeListeners();
    }, e.prototype.isWithinBounds = function(t) {
      return this.mouseX >= t.left && this.mouseX <= t.left + t.width && this.mouseY >= t.top && this.mouseY <= t.top + t.height;
    }, e.prototype.findChild = function(t, n) {
      var r = t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector;
      return Array.prototype.filter.call(t.children, function(o) {
        return r.call(o, n);
      })[0];
    }, e.rtlHelpers = null, e.defaultOptions = {
      forceVisible: !1,
      clickOnTrack: !0,
      scrollbarMinSize: 25,
      scrollbarMaxSize: 0,
      ariaLabel: "scrollable content",
      tabIndex: 0,
      classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging",
        scrolling: "simplebar-scrolling",
        scrollable: "simplebar-scrollable",
        mouseEntered: "simplebar-mouse-entered"
      },
      scrollableNode: null,
      contentNode: null,
      autoHide: !0
    }, e.getOptions = rD, e.helpers = nD, e;
  }()
), Ft = function() {
  return Ft = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Ft.apply(this, arguments);
};
function oD(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
var U0 = E.forwardRef(function(e, t) {
  var n = e.children, r = e.scrollableNodeProps, o = r === void 0 ? {} : r, i = oD(e, ["children", "scrollableNodeProps"]), s = E.useRef(), a = E.useRef(), u = E.useRef(), l = {}, d = {};
  Object.keys(i).forEach(function(h) {
    Object.prototype.hasOwnProperty.call(ti.defaultOptions, h) ? l[h] = i[h] : d[h] = i[h];
  });
  var p = Ft(Ft({}, ti.defaultOptions.classNames), l.classNames), f = Ft(Ft({}, o), { className: "".concat(p.contentWrapper).concat(o.className ? " ".concat(o.className) : ""), tabIndex: l.tabIndex || ti.defaultOptions.tabIndex, role: "region", "aria-label": l.ariaLabel || ti.defaultOptions.ariaLabel });
  return E.useEffect(function() {
    var h;
    return a.current = f.ref ? f.ref.current : a.current, s.current && (h = new ti(s.current, Ft(Ft(Ft({}, l), a.current && {
      scrollableNode: a.current
    }), u.current && {
      contentNode: u.current
    })), typeof t == "function" ? t(h) : t && (t.current = h)), function() {
      h == null || h.unMount(), h = null, typeof t == "function" && t(null);
    };
  }, []), E.createElement(
    "div",
    Ft({ "data-simplebar": "init", ref: s }, d),
    E.createElement(
      "div",
      { className: p.wrapper },
      E.createElement(
        "div",
        { className: p.heightAutoObserverWrapperEl },
        E.createElement("div", { className: p.heightAutoObserverEl })
      ),
      E.createElement(
        "div",
        { className: p.mask },
        E.createElement("div", { className: p.offset }, typeof n == "function" ? n({
          scrollableNodeRef: a,
          scrollableNodeProps: Ft(Ft({}, f), { ref: a }),
          contentNodeRef: u,
          contentNodeProps: {
            className: p.contentEl,
            ref: u
          }
        }) : E.createElement(
          "div",
          Ft({}, f),
          E.createElement("div", { className: p.contentEl }, n)
        ))
      ),
      E.createElement("div", { className: p.placeholder })
    ),
    E.createElement(
      "div",
      { className: "".concat(p.track, " ").concat(p.horizontal) },
      E.createElement("div", { className: p.scrollbar })
    ),
    E.createElement(
      "div",
      { className: "".concat(p.track, " ").concat(p.vertical) },
      E.createElement("div", { className: p.scrollbar })
    )
  );
});
U0.displayName = "SimpleBar";
const iD = "Confirmation-module__container___45eSd", sD = "Confirmation-module__message___4r1SC", aD = "Confirmation-module__buttons___QYVqm", lD = "Confirmation-module__button___gJmIL", cD = "Confirmation-module__confirm___DqtMv", uD = "Confirmation-module__cancel___3CIW9", Zn = {
  container: iD,
  message: sD,
  buttons: aD,
  button: lD,
  confirm: cD,
  cancel: uD
}, dD = ({
  message: e,
  title: t,
  onCancel: n,
  onConfirm: r
}) => {
  const o = he(Zn.button, Zn.confirm), i = he(Zn.button, Zn.cancel);
  return /* @__PURE__ */ fe("div", { className: Zn.container, children: [
    /* @__PURE__ */ O("div", { className: Zn.title, children: t }),
    /* @__PURE__ */ O("div", { className: he(Zn.message, nr.TEXT_SECONDARY), children: e }),
    /* @__PURE__ */ fe("div", { className: Zn.buttons, children: [
      /* @__PURE__ */ O("button", { className: o, onClick: r, children: "Yes" }),
      /* @__PURE__ */ O("button", { className: i, onClick: n, children: "No" })
    ] })
  ] });
}, pD = "Menu-module__container___KGp0N", fD = "Menu-module__disabled___xdT-F", hD = "Menu-module__groupHeader___-d7MT", mD = "Menu-module__isDrill___6OfQP", gD = "Menu-module__separator___OQ--M", yD = "Menu-module__noIcon___MYkPf", vD = "Menu-module__item___nmDUr", bD = "Menu-module__checked___6OJEB", CD = "Menu-module__radio___OlxcQ", SD = "Menu-module__checkbox___HocC7", wD = "Menu-module__icon___ZxKUL", _D = "Menu-module__itemType___VLiEZ", xD = "Menu-module__nestedType___gayzp", TD = "Menu-module__nestedIcon___VyPyZ", ED = "Menu-module__menuItemText___agoSf", RD = "Menu-module__separateGroup___0J5WE", OD = "Menu-module__itemCheckBox___2DHy4", PD = "Menu-module__itemRadioButton___h2ifs", ID = "Menu-module__scrollbar___li1b-", ND = "Menu-module__itemContainer___m0XPy", MD = "Menu-module__inlineConfirmation___0JCIX", kD = "Menu-module__menuItemTooltip___5jA0S", AD = "Menu-module__toggleButtonMenu___qwLCQ", $D = "Menu-module__loader___pzNnL", ht = {
  container: pD,
  disabled: fD,
  groupHeader: hD,
  isDrill: mD,
  separator: gD,
  noIcon: yD,
  item: vD,
  checked: bD,
  radio: CD,
  checkbox: SD,
  icon: wD,
  itemType: _D,
  nestedType: xD,
  nestedIcon: TD,
  menuItemText: ED,
  separateGroup: RD,
  itemCheckBox: OD,
  itemRadioButton: PD,
  scrollbar: ID,
  itemContainer: ND,
  inlineConfirmation: MD,
  menuItemTooltip: kD,
  toggleButtonMenu: AD,
  loader: $D
}, pi = Object.freeze({
  ITEM: "item",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  TOGGLE: "toggle",
  NESTED: "nested"
}), q0 = class extends ey {
  constructor(t) {
    super(t), this.renderRegularMenuItem = () => {
      const { dataTestId: n, iconName: r, iconClass: o, isDrill: i } = this.props;
      return /* @__PURE__ */ fe("span", { className: ht.itemContainer, children: [
        r && /* @__PURE__ */ O(Mt, { name: r, className: o }),
        /* @__PURE__ */ O(
          "span",
          {
            "data-testid": n,
            className: he(ht.menuItemText, nr.TEXT_PRIMARY),
            children: this.getContent()
          }
        ),
        i && /* @__PURE__ */ O(Mt, { name: "general-arrow-right" })
      ] });
    }, this.renderMenuItem = () => {
      const { tooltip: n, classNameTooltip: r, level: o } = this.props, i = this.renderRegularMenuItem();
      return n ? /* @__PURE__ */ O(
        E0,
        {
          overlay: /* @__PURE__ */ O("div", { children: n }),
          placement: "right",
          overlayClassName: he(r, ht.menuItemTooltip),
          mouseLeaveDelay: 0,
          align: { offset: [o ? 5 : 10, 0] },
          children: i
        }
      ) : i;
    }, this.state = { inInlineConfirmation: !1 };
  }
  getContent() {
    const { type: t, caption: n, subCaption: r, checked: o, selected: i } = this.props;
    switch (t) {
      case pi.RADIO:
        return /* @__PURE__ */ O(
          OL,
          {
            text: n,
            name: n,
            onChange: () => null,
            value: n,
            checked: !!o,
            preventClick: !0
          }
        );
      case pi.CHECKBOX:
        return /* @__PURE__ */ O(
          xL,
          {
            title: n,
            text: n,
            onChange: () => null,
            checked: !!o,
            className: ht.itemCheckBox
          }
        );
      case pi.TOGGLE:
        return /* @__PURE__ */ fe("div", { children: [
          /* @__PURE__ */ O("span", { children: n }),
          /* @__PURE__ */ O(
            TL,
            {
              onChange: () => null,
              className: ht.toggleButtonMenu,
              checked: !!o
            }
          )
        ] });
      case pi.NESTED:
        return /* @__PURE__ */ fe("div", { className: ht.nestedType, children: [
          /* @__PURE__ */ O("div", { children: n }),
          /* @__PURE__ */ O(Mt, { className: ht.nestedIcon, name: "general-double-arrow-front" }),
          /* @__PURE__ */ O("div", { children: r })
        ] });
      default:
        return /* @__PURE__ */ fe("div", { className: ht.itemType, children: [
          n,
          i && /* @__PURE__ */ O(Mt, { name: "general-vi-small-white" })
        ] });
    }
  }
  handleClick(t) {
    t.stopPropagation();
    const { handleClick: n, disabled: r } = this.props;
    r || n();
  }
  render() {
    const { checked: t, className: n, iconName: r, handleOver: o, handleOut: i, disabled: s } = this.props, a = !1, u = he(n, {
      [ht.checked]: t,
      [ht.noIcon]: !r || a,
      [ht.disabled]: s,
      [nr.TEXT_PRIMARY]: t,
      [nr.TEXT_SECONDARY_HOVER]: !t && !s,
      [nr.TEXT_SECONDARY]: s
    });
    return /* @__PURE__ */ O(
      "li",
      {
        "data-menu-item": !0,
        className: u,
        onClick: this.handleClick.bind(this),
        onMouseOver: o,
        onMouseOut: i,
        children: this.renderMenuItem()
      }
    );
  }
};
q0.defaultProps = {
  className: ""
};
let LD = q0;
function DD(e, t) {
  const n = {};
  return e.reduce(function(r, o) {
    const i = t(o);
    return r[i] || (r[i] = []), r[i].push(o), r;
  }, n);
}
const Bm = () => {
}, G0 = class K0 extends ey {
  constructor(t) {
    super(t), this.handleClick = (n) => {
      if (n.subItems || n.actionableComponent) {
        this.clearTimeout(), this.state.activeSubMenu === n.id ? this.closeSubMenu() : this.setState({ activeSubMenu: n.id });
        return;
      } else if (n.confirmation && !n.confirmation.inline) {
        this.clearTimeout(), this.setState({ activeSubMenu: n.id });
        return;
      }
      const { onItemSelected: r } = this.props;
      r(n, n.value);
    }, this.handleOver = (n) => {
      this.clearTimeout(), this.setState({ isHoverSubMenu: !1 });
      const r = n.subItems || n.actionableComponent ? n.id : null;
      this.timeoutIn = window.setTimeout(() => {
        this.setState({
          activeSubMenu: r
        });
      }, 900);
    }, this.handleOut = (n) => {
      (n.subItems || n.actionableComponent) && this.state.activeSubMenu && this.clearTimeout();
    }, this.onSubMenuMouseEnter = () => {
      this.clearTimeout(), this.setState({ isHoverSubMenu: !0 });
    }, this.onSubMenuMouseLeave = () => {
      this.setState({ isHoverSubMenu: !1 });
    }, this.closeSubMenu = () => {
      this.setState({ activeSubMenu: null });
    }, this.onConfirm = (n) => {
      const { onItemSelected: r } = this.props;
      this.closeSubMenu(), r(n);
    }, this.renderMenuItem = (n) => {
      const { onItemSelected: r, onRequestClose: o, level: i, classNameTooltip: s, zIndex: a, className: u } = this.props;
      let l = he(ht[n.type], {
        [ht.isDrill]: n.subItems,
        [ht.separator]: n.separator,
        fakeHover: n.checked,
        [ht.groupHeader]: n.groupTitle
      });
      const d = (f) => {
        const h = he(n.iconClass, ht.icon);
        return /* @__PURE__ */ O(
          LD,
          {
            className: f,
            checked: n.checked,
            dataTestId: n.dataTestId,
            disabled: n.disabled,
            type: n.type,
            caption: n.caption,
            subCaption: n.subCaption,
            tooltip: n.tooltip,
            classNameTooltip: s,
            iconName: n.iconName,
            iconClass: h,
            isDrill: !!n.subItems || !!n.actionableComponent,
            level: i,
            selected: n.selected,
            handleClick: () => this.handleClick(n),
            handleOver: () => this.handleOver(n),
            handleOut: () => this.handleOut(n)
          },
          n.id
        );
      };
      let p = n.subItems;
      if (p) {
        const f = this.state.activeSubMenu === n.id;
        let h = this.handleClick;
        return l = he(l, {
          fakeHover: f && this.state.isHoverSubMenu
        }), n.value !== void 0 && (p = p.map(function(g) {
          return L(C({}, g), {
            checked: g.value === n.value
          });
        }), h = (g) => r(n, g.value)), /* @__PURE__ */ O(
          Si,
          {
            visible: f,
            level: 1,
            mask: !1,
            trigger: [],
            placement: "rightTop",
            align: { offset: [0, 0] },
            overlay: () => /* @__PURE__ */ O(
              K0,
              {
                items: p || [],
                className: u,
                onItemSelected: h,
                onMouseEnter: this.onSubMenuMouseEnter,
                scrollbarProps: {
                  className: n.subItemScrollbarClassName
                },
                level: (i || 0) + 1,
                zIndex: (a || 1) + 1
              }
            ),
            onRequestClose: o,
            zIndex: (a || 1) + 1,
            children: d(l)
          },
          n.id
        );
      } else if (n.actionableComponent) {
        const { componentProps: f } = n.actionableComponent, h = n.actionableComponent.component, g = this.state.activeSubMenu === n.id;
        return /* @__PURE__ */ O(
          Si,
          {
            visible: g,
            level: 1,
            mask: !1,
            trigger: [],
            placement: "rightTop",
            align: { offset: [10, 0] },
            overlay: () => /* @__PURE__ */ O(h, L(C({}, f), { onRequestClose: o })),
            onRequestClose: o,
            children: d(l)
          },
          n.id
        );
      } else if (n.confirmation && !n.confirmation.inline) {
        const f = n.confirmation, h = this.state.activeSubMenu === n.id;
        return /* @__PURE__ */ O(
          Si,
          {
            visible: h,
            level: 1,
            mask: !0,
            trigger: [],
            placement: "rightBottom",
            align: { offset: [10, 0] },
            overlay: () => /* @__PURE__ */ O(
              dD,
              {
                title: f.title,
                message: f.message,
                onCancel: this.closeSubMenu,
                onConfirm: () => this.onConfirm(n)
              }
            ),
            onRequestClose: this.closeSubMenu,
            children: d(l)
          },
          n.id
        );
      }
      return d(l);
    }, this.state = {
      activeSubMenu: null,
      isHoverSubMenu: !1
    }, this.timeoutIn = null;
  }
  componentWillUnmount() {
    this.clearTimeout();
  }
  clearTimeout() {
    this.timeoutIn && (clearTimeout(this.timeoutIn), this.timeoutIn = null);
  }
  getSeparateGroups(t) {
    const n = DD(t, (o) => o.groupId || ""), r = Object.values(n);
    return r.slice(1).forEach((o) => o[0].separator = !0), r;
  }
  render() {
    const h = this.props, {
      items: t,
      className: n,
      onMouseEnter: r,
      scrollbarProps: g
    } = h, m = g, { className: o } = m, i = re(m, ["className"]), {
      width: s,
      isLoading: a
    } = h;
    let u = t.filter((v) => !v.hidden);
    u = u.map((v, S) => (v.separator && !u[S - 1] && (v.separator = !1), v));
    const l = he(ht.container, n), d = he(ht.scrollbar, o), p = s ? { width: `${s}px`, minWidth: "inherit" } : {}, f = a ? ht.loader : "";
    return /* @__PURE__ */ O("div", { className: l, onMouseEnter: r, style: p, children: /* @__PURE__ */ fe(U0, L(C({ className: d }, i), { children: [
      this.getSeparateGroups(u).map((v, S) => /* @__PURE__ */ O("div", { className: ht.separateGroup, children: v.map(this.renderMenuItem) }, S)),
      /* @__PURE__ */ O("div", { className: f, children: /* @__PURE__ */ O(yL, { isLoading: a }) })
    ] })) });
  }
};
G0.defaultProps = {
  onMouseEnter: Bm,
  onRequestClose: Bm,
  scrollbarProps: {},
  level: 0,
  isLoading: !1,
  zIndex: 1
};
let BD = G0;
const FD = "#2c3342", zD = "#f4f4f8", jD = "#dee1e7", HD = "#fff", WD = "Input-module__component___4OcHW", VD = "Input-module__searchIcon___aQP42", UD = "Input-module__large___BPwgK", qD = "Input-module__clearIcon___ihSot", GD = "Input-module__clearIconHidden___gPP7c", KD = "Input-module__passwordVisibilityIcon___mrN83", YD = "Input-module__customIcon___5KikU", XD = "Input-module__isLeft___uqdwf", JD = "Input-module__input___js3cI", QD = "Input-module__withLeftIcon___BgCVf", Ot = {
  loginDarkColor: FD,
  darkBtnHoverColor: zD,
  greyHoverColor: jD,
  defaultBackgroundColor: HD,
  component: WD,
  searchIcon: VD,
  large: UD,
  clearIcon: qD,
  clearIconHidden: GD,
  passwordVisibilityIcon: KD,
  customIcon: YD,
  isLeft: XD,
  input: JD,
  withLeftIcon: QD
}, ZD = (e) => {
  const {
    className: t,
    inputClassName: n,
    onChange: r,
    onClicked: o,
    onBlur: i = () => {
    },
    placeholder: s,
    search: a,
    dataTestId: u,
    defaultValue: l,
    value: d,
    autoFocus: p,
    clearable: f,
    password: h,
    disabled: g = !1,
    size: m,
    icon: v,
    trimInput: S,
    ariaLabel: _ = "input"
  } = e, [R, b] = Wt(l || d || ""), [y, w] = Wt(!1), x = _t(null), { name: P = "", placement: N } = v || {};
  return or(() => {
    b(d || "");
  }, [d]), /* @__PURE__ */ fe("div", { className: he(Ot.component, t), children: [
    a && /* @__PURE__ */ O(
      Mt,
      {
        className: he(Ot.searchIcon, {
          [Ot.large]: m === "large"
        }),
        name: "general-search-small"
      }
    ),
    /* @__PURE__ */ O(
      "input",
      {
        className: he(Ot.input, n, {
          [Ot.withLeftIcon]: a || v && N === "left",
          [Ot.large]: m === "large"
        }),
        placeholder: s,
        disabled: g,
        onChange: (M) => {
          const A = S ? M.target.value.trim() : M.target.value;
          r(A), b(M.target.value);
        },
        onClick: o,
        onBlur: i,
        "data-testid": u,
        defaultValue: l,
        value: d != null ? d : R,
        autoFocus: p,
        type: h && !y ? "password" : "text",
        ref: x,
        "aria-label": _
      }
    ),
    f && !h && !v && /* @__PURE__ */ O(
      Mt,
      {
        className: he(Ot.clearIcon, {
          [Ot.clearIconHidden]: R === "",
          [Ot.large]: m === "large"
        }),
        name: "general-x",
        onClick: () => {
          b(""), r("");
        },
        onMouseDown: (M) => M.preventDefault()
      }
    ),
    h && /* @__PURE__ */ O(
      Mt,
      {
        className: he(Ot.passwordVisibilityIcon, {
          [Ot.large]: m === "large"
        }),
        name: y ? "general-unhide" : "general-show",
        onClick: () => {
          w(!y);
        },
        onMouseDown: (M) => M.preventDefault()
      }
    ),
    v && !f && !h && /* @__PURE__ */ O(
      Mt,
      {
        className: he(Ot.customIcon, {
          [Ot.large]: m === "large",
          [Ot.isLeft]: N === "left"
        }),
        name: P
      }
    )
  ] });
}, e2 = "Dropdown-module__menu___u8qzp", t2 = {
  menu: e2
}, n2 = "#2c3342", r2 = "#f4f4f8", o2 = "#dee1e7", i2 = "#fff", s2 = "DropdownButton-module__dropdownButton___oc3-H", a2 = "DropdownButton-module__inlineVariant___WSkxA", l2 = "DropdownButton-module__open___bh-yG", c2 = "DropdownButton-module__disabled___I9nuu", u2 = "DropdownButton-module__selectedIcon___hIp5j", d2 = "DropdownButton-module__chosenTitle___AgQJR", p2 = "DropdownButton-module__clickIcon___U2low", Sr = {
  loginDarkColor: n2,
  darkBtnHoverColor: r2,
  greyHoverColor: o2,
  defaultBackgroundColor: i2,
  dropdownButton: s2,
  inlineVariant: a2,
  open: l2,
  disabled: c2,
  selectedIcon: u2,
  chosenTitle: d2,
  clickIcon: p2
}, f2 = ({
  selectedItem: e,
  width: t,
  dropDownButtonClasses: n,
  selectedShowIcon: r = !0,
  placeholder: o = ""
}) => {
  const { caption: i, iconName: s } = e || {};
  return /* @__PURE__ */ fe("div", { className: n, title: i, style: t ? { width: t, minWidth: "inherit" } : {}, children: [
    r && s && /* @__PURE__ */ O(Mt, { className: Sr.selectedIcon, name: s }),
    /* @__PURE__ */ O("div", { className: Sr.chosenTitle, children: i || o }),
    /* @__PURE__ */ O("div", { className: Sr.clickIcon, children: /* @__PURE__ */ O(Mt, { name: "general-arrow-down" }) })
  ] });
}, h2 = 136, m2 = "DropdownButtonSearch-module__searchInputWrapper___zKFuM", g2 = {
  searchInputWrapper: m2
}, Fm = () => {
}, y2 = Bi(
  ({
    width: e = h2,
    onClick: t = Fm,
    inputProps: n = { onChange: Fm },
    className: r = ""
  }, o) => {
    const i = he(r || g2.searchInputWrapper);
    return /* @__PURE__ */ O(
      "div",
      {
        ref: o,
        style: { width: e },
        className: i,
        "data-testid": "search_input_container",
        children: /* @__PURE__ */ O(ZD, C({ onClicked: t }, n))
      }
    );
  }
), v2 = (e, t, n, r) => {
  const [o, i] = Wt(L(C({}, n), {
    value: t == null ? void 0 : t.caption
  })), s = (l) => {
    l.stopPropagation();
  }, a = (l) => {
    n == null || n.onChange(l), i(L(C({}, n), { value: l }));
  }, u = wC(() => {
    var l;
    const d = (l = r == null ? void 0 : r.current) == null ? void 0 : l.getElementsByTagName("input")[0];
    d == null || d.select();
  }, [r]);
  return or(() => {
    e ? (i(L(C({}, n), { value: t == null ? void 0 : t.caption })), u()) : n == null || n.onChange("");
  }, [e, n, t == null ? void 0 : t.caption, u]), or(() => {
    e && o.value !== (n == null ? void 0 : n.value) && u();
  }, [o.value, e, n == null ? void 0 : n.value, u]), { handlers: {
    handleOnSearchInputClick: s,
    handleOnSearchInputChange: a
  }, inputProps: o };
}, b2 = ({
  items: e = [],
  selectedShowIcon: t = !0,
  placeholder: n = "",
  disabled: r,
  selectedItemId: o,
  width: i,
  inlineVariant: s,
  classNameDropdown: a,
  classNameButton: u,
  classNameSearch: l,
  searchInputProps: d,
  isOpen: p = !1
}) => {
  const f = e.find((_) => _.id === o), h = _t(null), {
    inputProps: g,
    handlers: { handleOnSearchInputClick: m, handleOnSearchInputChange: v }
  } = v2(p, f, d, h), S = he(
    u,
    Sr.dropdownButton,
    {
      [Sr.disabled]: r,
      [Sr.open]: p,
      [Sr.inlineVariant]: s
    },
    a
  );
  return /* @__PURE__ */ O(xo, { children: d && p && !r ? /* @__PURE__ */ O(
    y2,
    {
      ref: h,
      width: i,
      onClick: m,
      inputProps: L(C({}, g), { onChange: v }),
      className: l
    }
  ) : /* @__PURE__ */ O(
    f2,
    {
      selectedItem: f,
      width: i,
      placeholder: n,
      selectedShowIcon: t,
      dropDownButtonClasses: S
    }
  ) });
}, C2 = (e, t, n) => {
  const [r, o] = Wt(t), i = () => {
    n || o(!r);
  };
  return { handlers: {
    handleOnSelectItem: (s) => {
      e(s), i();
    },
    handleDropdownClick: i
  }, isOpen: r };
}, S2 = () => {
}, w2 = Bi(
  ({
    bubblePopoverMouseEvents: e = !1,
    items: t = [],
    onSelectItem: n = S2,
    popoverOverlayLevel: r = 0,
    selectedShowIcon: o = !0,
    mask: i = !0,
    placeholder: s = "",
    placement: a = "bottomLeft",
    disabled: u = !1,
    selectedItemId: l,
    width: d,
    scrollbarProps: p,
    classNameMenu: f,
    inlineVariant: h,
    classNameDropdown: g,
    classNameButton: m,
    classNameSearch: v,
    classNameTooltip: S,
    zIndex: _,
    searchInputProps: R,
    open: b = !1,
    isLoading: y = !1
  }, w) => {
    const x = h ? 12 : 0, P = t.map((T) => ({
      id: T.id,
      caption: T.caption || T.id,
      type: pi.ITEM,
      iconName: T.iconName,
      iconClass: T.iconClass,
      selected: T.id === l,
      tooltip: T.tooltip,
      disabled: T.disabled
    })), {
      isOpen: N,
      handlers: { handleOnSelectItem: M, handleDropdownClick: A }
    } = C2(n, b, u);
    return /* @__PURE__ */ O("div", { ref: w, "data-testid": "popover_container", children: /* @__PURE__ */ O(
      Si,
      {
        zIndex: _,
        bubbleMouseEvents: e,
        trigger: ["click"],
        visible: N,
        placement: a,
        overlay: () => {
          const T = he(
            t2.menu,
            // SLF.BACK,
            // SLF.TEXT_PRIMARY,
            nr.SISENSE_NAMESPACE,
            f
          );
          return /* @__PURE__ */ O(
            BD,
            {
              items: P,
              onItemSelected: M,
              className: T,
              width: d,
              scrollbarProps: p,
              isLoading: y,
              classNameTooltip: S
            }
          );
        },
        level: r,
        onVisibleChange: A,
        onRequestClose: A,
        align: { offset: [0, x] },
        mask: i,
        children: /* @__PURE__ */ O("div", { children: /* @__PURE__ */ O(
          b2,
          {
            isOpen: N,
            items: t,
            selectedShowIcon: o,
            placeholder: s,
            width: d,
            disabled: u,
            classNameButton: m,
            classNameDropdown: g,
            classNameSearch: v,
            inlineVariant: h,
            searchInputProps: R,
            selectedItemId: l
          }
        ) })
      }
    ) });
  }
), _2 = (e) => {
  const { direction: t, items: n, onChange: r } = e;
  return /* @__PURE__ */ O(
    w2,
    {
      classNameDropdown: "direction-selector",
      classNameMenu: "sis-scope direction-selector__menu",
      items: n,
      selectedItemId: t,
      onSelectItem: (i) => {
        r(i.id);
      },
      mask: !1,
      scrollbarProps: {
        // Custom style to remove bottom padding below the last item
        style: {
          marginBottom: "-8px"
        }
      }
    }
  );
}, x2 = (e) => {
  const { title: t, fieldTypes: n, selected: r, onSettingsItemStateChange: o, subtotalsCaption: i } = e, [s, a] = Wt(r), u = e.direction || ct.ASC, l = () => {
    a(!s), o({
      title: t,
      selected: !s,
      direction: u
    });
  }, p = s === !1 ? null : /* @__PURE__ */ O(
    _2,
    {
      direction: u,
      items: n,
      onChange: (x) => {
        o({
          title: t,
          selected: s,
          direction: x
        });
      }
    }
  ), f = _t(null), h = _t(null), [g, m] = Wt(!1), v = () => {
    const x = f.current, P = h.current;
    x === null || P === null || x.offsetWidth < P.offsetWidth && m(!0);
  }, S = () => {
    const x = f.current, P = h.current;
    x === null || P === null || x.offsetWidth < P.offsetWidth && m(!1);
  }, _ = () => {
    a(!s), o({
      title: t,
      selected: !s,
      direction: u
    });
  }, [R, b] = Wt(!1);
  return /* @__PURE__ */ fe("div", { className: "settings-item", children: [
    /* @__PURE__ */ fe("div", { className: "checkbox-input", children: [
      /* @__PURE__ */ O(
        hL,
        {
          checked: s,
          onChange: l
        }
      ),
      /* @__PURE__ */ fe(
        "div",
        {
          className: "checkbox-input__label",
          tabIndex: 0,
          role: "button",
          "aria-pressed": "false",
          onClick: _,
          onKeyUp: _,
          onMouseEnter: () => b(!0),
          onMouseLeave: () => b(!1),
          children: [
            /* @__PURE__ */ O(rp, { placement: "top", title: t, children: /* @__PURE__ */ O(
              "div",
              {
                ref: f,
                className: "checkbox-input__text-wrapper",
                onMouseEnter: v,
                onMouseLeave: S,
                children: /* @__PURE__ */ O("span", { ref: h, children: t })
              }
            ) }),
            i
          ]
        }
      )
    ] }),
    p
  ] }, t);
};
function Y0(e) {
  const t = {
    [ct.ASC]: {
      [$n.TEXT]: e.ascAZ,
      [$n.NUMERIC]: e.asc19,
      [$n.DATETIME]: e.asc19
    },
    [ct.DESC]: {
      [$n.TEXT]: e.descZA,
      [$n.NUMERIC]: e.desc91,
      [$n.DATETIME]: e.desc91
    }
  };
  return function(r, o) {
    return t[o][r];
  };
}
const wt = (e) => e.getBoundingClientRect(), zm = (e, t) => ({
  get collidedTop() {
    return wt(e).top < wt(t).top;
  },
  get collidedBottom() {
    return wt(e).bottom > wt(t).bottom;
  },
  get collidedLeft() {
    return wt(e).left < wt(t).left;
  },
  get collidedRight() {
    return wt(e).right > wt(t).right;
  },
  get overflowTop() {
    return wt(t).top - wt(e).top;
  },
  get overflowBottom() {
    return wt(e).bottom - wt(t).bottom;
  },
  get overflowLeft() {
    return wt(t).left - wt(e).left;
  },
  get overflowRight() {
    return wt(e).right - wt(t).right;
  }
}), T2 = "CheckableList-module__item___Hs9v4", E2 = "CheckableList-module__icon___1KLyd", wc = {
  item: T2,
  icon: E2
}, R2 = ({ items: e, className: t, onChange: n }) => /* @__PURE__ */ O("div", { className: t, children: e.map((r) => /* @__PURE__ */ fe(
  "div",
  {
    className: wc.item,
    onClick: () => n(r.value),
    "data-testid": r.dataTestId,
    children: [
      /* @__PURE__ */ O("span", { className: wc.name, children: r.name }),
      r.checked && /* @__PURE__ */ O(Mt, { className: wc.icon, name: "general-vi-small-white" })
    ]
  },
  r.value
)) });
function O2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Cd = { exports: {} }, _c = { exports: {} }, ze = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jm;
function P2() {
  if (jm)
    return ze;
  jm = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function R(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case t:
          switch (y = y.type, y) {
            case u:
            case l:
            case r:
            case i:
            case o:
            case p:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case d:
                case g:
                case h:
                case s:
                  return y;
                default:
                  return w;
              }
          }
        case n:
          return w;
      }
    }
  }
  function b(y) {
    return R(y) === l;
  }
  return ze.AsyncMode = u, ze.ConcurrentMode = l, ze.ContextConsumer = a, ze.ContextProvider = s, ze.Element = t, ze.ForwardRef = d, ze.Fragment = r, ze.Lazy = g, ze.Memo = h, ze.Portal = n, ze.Profiler = i, ze.StrictMode = o, ze.Suspense = p, ze.isAsyncMode = function(y) {
    return b(y) || R(y) === u;
  }, ze.isConcurrentMode = b, ze.isContextConsumer = function(y) {
    return R(y) === a;
  }, ze.isContextProvider = function(y) {
    return R(y) === s;
  }, ze.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, ze.isForwardRef = function(y) {
    return R(y) === d;
  }, ze.isFragment = function(y) {
    return R(y) === r;
  }, ze.isLazy = function(y) {
    return R(y) === g;
  }, ze.isMemo = function(y) {
    return R(y) === h;
  }, ze.isPortal = function(y) {
    return R(y) === n;
  }, ze.isProfiler = function(y) {
    return R(y) === i;
  }, ze.isStrictMode = function(y) {
    return R(y) === o;
  }, ze.isSuspense = function(y) {
    return R(y) === p;
  }, ze.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === l || y === i || y === o || y === p || y === f || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === h || y.$$typeof === s || y.$$typeof === a || y.$$typeof === d || y.$$typeof === v || y.$$typeof === S || y.$$typeof === _ || y.$$typeof === m);
  }, ze.typeOf = R, ze;
}
var We = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hm;
function I2() {
  return Hm || (Hm = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function R(B) {
      return typeof B == "string" || typeof B == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      B === r || B === l || B === i || B === o || B === p || B === f || typeof B == "object" && B !== null && (B.$$typeof === g || B.$$typeof === h || B.$$typeof === s || B.$$typeof === a || B.$$typeof === d || B.$$typeof === v || B.$$typeof === S || B.$$typeof === _ || B.$$typeof === m);
    }
    function b(B) {
      if (typeof B == "object" && B !== null) {
        var oe = B.$$typeof;
        switch (oe) {
          case t:
            var q = B.type;
            switch (q) {
              case u:
              case l:
              case r:
              case i:
              case o:
              case p:
                return q;
              default:
                var pe = q && q.$$typeof;
                switch (pe) {
                  case a:
                  case d:
                  case g:
                  case h:
                  case s:
                    return pe;
                  default:
                    return oe;
                }
            }
          case n:
            return oe;
        }
      }
    }
    var y = u, w = l, x = a, P = s, N = t, M = d, A = r, T = g, D = h, j = n, F = i, z = o, H = p, ee = !1;
    function X(B) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), k(B) || b(B) === u;
    }
    function k(B) {
      return b(B) === l;
    }
    function $(B) {
      return b(B) === a;
    }
    function Y(B) {
      return b(B) === s;
    }
    function K(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function W(B) {
      return b(B) === d;
    }
    function Q(B) {
      return b(B) === r;
    }
    function G(B) {
      return b(B) === g;
    }
    function V(B) {
      return b(B) === h;
    }
    function U(B) {
      return b(B) === n;
    }
    function Z(B) {
      return b(B) === i;
    }
    function te(B) {
      return b(B) === o;
    }
    function ie(B) {
      return b(B) === p;
    }
    We.AsyncMode = y, We.ConcurrentMode = w, We.ContextConsumer = x, We.ContextProvider = P, We.Element = N, We.ForwardRef = M, We.Fragment = A, We.Lazy = T, We.Memo = D, We.Portal = j, We.Profiler = F, We.StrictMode = z, We.Suspense = H, We.isAsyncMode = X, We.isConcurrentMode = k, We.isContextConsumer = $, We.isContextProvider = Y, We.isElement = K, We.isForwardRef = W, We.isFragment = Q, We.isLazy = G, We.isMemo = V, We.isPortal = U, We.isProfiler = Z, We.isStrictMode = te, We.isSuspense = ie, We.isValidElementType = R, We.typeOf = b;
  }()), We;
}
var Wm;
function X0() {
  return Wm || (Wm = 1, process.env.NODE_ENV === "production" ? _c.exports = P2() : _c.exports = I2()), _c.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var xc, Vm;
function N2() {
  if (Vm)
    return xc;
  Vm = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch (d) {
      return !1;
    }
  }
  return xc = o() ? Object.assign : function(i, s) {
    for (var a, u = r(i), l, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var p in a)
        t.call(a, p) && (u[p] = a[p]);
      if (e) {
        l = e(a);
        for (var f = 0; f < l.length; f++)
          n.call(a, l[f]) && (u[l[f]] = a[l[f]]);
      }
    }
    return u;
  }, xc;
}
var Tc, Um;
function fp() {
  if (Um)
    return Tc;
  Um = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Tc = e, Tc;
}
var qm, Gm;
function J0() {
  return Gm || (Gm = 1, qm = Function.call.bind(Object.prototype.hasOwnProperty)), qm;
}
var Ec, Km;
function M2() {
  if (Km)
    return Ec;
  Km = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = fp(), n = {}, r = J0();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch (a) {
      }
    };
  }
  function o(i, s, a, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (r(i, d)) {
          var p;
          try {
            if (typeof i[d] != "function") {
              var f = Error(
                (u || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            p = i[d](s, d, u, a, null, t);
          } catch (g) {
            p = g;
          }
          if (p && !(p instanceof Error) && e(
            (u || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + a + " type: " + p.message + (h != null ? h : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ec = o, Ec;
}
var Rc, Ym;
function k2() {
  if (Ym)
    return Rc;
  Ym = 1;
  var e = X0(), t = N2(), n = fp(), r = J0(), o = M2(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var u = "Warning: " + a;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch (l) {
    }
  });
  function s() {
    return null;
  }
  return Rc = function(a, u) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function p(k) {
      var $ = k && (l && k[l] || k[d]);
      if (typeof $ == "function")
        return $;
    }
    var f = "<<anonymous>>", h = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: _(),
      arrayOf: R,
      element: b(),
      elementType: y(),
      instanceOf: w,
      node: M(),
      objectOf: P,
      oneOf: x,
      oneOfType: N,
      shape: T,
      exact: D
    };
    function g(k, $) {
      return k === $ ? k !== 0 || 1 / k === 1 / $ : k !== k && $ !== $;
    }
    function m(k, $) {
      this.message = k, this.data = $ && typeof $ == "object" ? $ : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(k) {
      if (process.env.NODE_ENV !== "production")
        var $ = {}, Y = 0;
      function K(Q, G, V, U, Z, te, ie) {
        if (U = U || f, te = te || V, ie !== n) {
          if (u) {
            var B = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw B.name = "Invariant Violation", B;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var oe = U + ":" + V;
            !$[oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Y < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + U + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), $[oe] = !0, Y++);
          }
        }
        return G[V] == null ? Q ? G[V] === null ? new m("The " + Z + " `" + te + "` is marked as required " + ("in `" + U + "`, but its value is `null`.")) : new m("The " + Z + " `" + te + "` is marked as required in " + ("`" + U + "`, but its value is `undefined`.")) : null : k(G, V, U, Z, te);
      }
      var W = K.bind(null, !1);
      return W.isRequired = K.bind(null, !0), W;
    }
    function S(k) {
      function $(Y, K, W, Q, G, V) {
        var U = Y[K], Z = z(U);
        if (Z !== k) {
          var te = H(U);
          return new m(
            "Invalid " + Q + " `" + G + "` of type " + ("`" + te + "` supplied to `" + W + "`, expected ") + ("`" + k + "`."),
            { expectedType: k }
          );
        }
        return null;
      }
      return v($);
    }
    function _() {
      return v(s);
    }
    function R(k) {
      function $(Y, K, W, Q, G) {
        if (typeof k != "function")
          return new m("Property `" + G + "` of component `" + W + "` has invalid PropType notation inside arrayOf.");
        var V = Y[K];
        if (!Array.isArray(V)) {
          var U = z(V);
          return new m("Invalid " + Q + " `" + G + "` of type " + ("`" + U + "` supplied to `" + W + "`, expected an array."));
        }
        for (var Z = 0; Z < V.length; Z++) {
          var te = k(V, Z, W, Q, G + "[" + Z + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return v($);
    }
    function b() {
      function k($, Y, K, W, Q) {
        var G = $[Y];
        if (!a(G)) {
          var V = z(G);
          return new m("Invalid " + W + " `" + Q + "` of type " + ("`" + V + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(k);
    }
    function y() {
      function k($, Y, K, W, Q) {
        var G = $[Y];
        if (!e.isValidElementType(G)) {
          var V = z(G);
          return new m("Invalid " + W + " `" + Q + "` of type " + ("`" + V + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(k);
    }
    function w(k) {
      function $(Y, K, W, Q, G) {
        if (!(Y[K] instanceof k)) {
          var V = k.name || f, U = X(Y[K]);
          return new m("Invalid " + Q + " `" + G + "` of type " + ("`" + U + "` supplied to `" + W + "`, expected ") + ("instance of `" + V + "`."));
        }
        return null;
      }
      return v($);
    }
    function x(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function $(Y, K, W, Q, G) {
        for (var V = Y[K], U = 0; U < k.length; U++)
          if (g(V, k[U]))
            return null;
        var Z = JSON.stringify(k, function(te, ie) {
          var B = H(ie);
          return B === "symbol" ? String(ie) : ie;
        });
        return new m("Invalid " + Q + " `" + G + "` of value `" + String(V) + "` " + ("supplied to `" + W + "`, expected one of " + Z + "."));
      }
      return v($);
    }
    function P(k) {
      function $(Y, K, W, Q, G) {
        if (typeof k != "function")
          return new m("Property `" + G + "` of component `" + W + "` has invalid PropType notation inside objectOf.");
        var V = Y[K], U = z(V);
        if (U !== "object")
          return new m("Invalid " + Q + " `" + G + "` of type " + ("`" + U + "` supplied to `" + W + "`, expected an object."));
        for (var Z in V)
          if (r(V, Z)) {
            var te = k(V, Z, W, Q, G + "." + Z, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return v($);
    }
    function N(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var $ = 0; $ < k.length; $++) {
        var Y = k[$];
        if (typeof Y != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ee(Y) + " at index " + $ + "."
          ), s;
      }
      function K(W, Q, G, V, U) {
        for (var Z = [], te = 0; te < k.length; te++) {
          var ie = k[te], B = ie(W, Q, G, V, U, n);
          if (B == null)
            return null;
          B.data && r(B.data, "expectedType") && Z.push(B.data.expectedType);
        }
        var oe = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new m("Invalid " + V + " `" + U + "` supplied to " + ("`" + G + "`" + oe + "."));
      }
      return v(K);
    }
    function M() {
      function k($, Y, K, W, Q) {
        return j($[Y]) ? null : new m("Invalid " + W + " `" + Q + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return v(k);
    }
    function A(k, $, Y, K, W) {
      return new m(
        (k || "React class") + ": " + $ + " type `" + Y + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + W + "`."
      );
    }
    function T(k) {
      function $(Y, K, W, Q, G) {
        var V = Y[K], U = z(V);
        if (U !== "object")
          return new m("Invalid " + Q + " `" + G + "` of type `" + U + "` " + ("supplied to `" + W + "`, expected `object`."));
        for (var Z in k) {
          var te = k[Z];
          if (typeof te != "function")
            return A(W, Q, G, Z, H(te));
          var ie = te(V, Z, W, Q, G + "." + Z, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return v($);
    }
    function D(k) {
      function $(Y, K, W, Q, G) {
        var V = Y[K], U = z(V);
        if (U !== "object")
          return new m("Invalid " + Q + " `" + G + "` of type `" + U + "` " + ("supplied to `" + W + "`, expected `object`."));
        var Z = t({}, Y[K], k);
        for (var te in Z) {
          var ie = k[te];
          if (r(k, te) && typeof ie != "function")
            return A(W, Q, G, te, H(ie));
          if (!ie)
            return new m(
              "Invalid " + Q + " `" + G + "` key `" + te + "` supplied to `" + W + "`.\nBad object: " + JSON.stringify(Y[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
            );
          var B = ie(V, te, W, Q, G + "." + te, n);
          if (B)
            return B;
        }
        return null;
      }
      return v($);
    }
    function j(k) {
      switch (typeof k) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !k;
        case "object":
          if (Array.isArray(k))
            return k.every(j);
          if (k === null || a(k))
            return !0;
          var $ = p(k);
          if ($) {
            var Y = $.call(k), K;
            if ($ !== k.entries) {
              for (; !(K = Y.next()).done; )
                if (!j(K.value))
                  return !1;
            } else
              for (; !(K = Y.next()).done; ) {
                var W = K.value;
                if (W && !j(W[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function F(k, $) {
      return k === "symbol" ? !0 : $ ? $["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $ instanceof Symbol : !1;
    }
    function z(k) {
      var $ = typeof k;
      return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : F($, k) ? "symbol" : $;
    }
    function H(k) {
      if (typeof k > "u" || k === null)
        return "" + k;
      var $ = z(k);
      if ($ === "object") {
        if (k instanceof Date)
          return "date";
        if (k instanceof RegExp)
          return "regexp";
      }
      return $;
    }
    function ee(k) {
      var $ = H(k);
      switch ($) {
        case "array":
        case "object":
          return "an " + $;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + $;
        default:
          return $;
      }
    }
    function X(k) {
      return !k.constructor || !k.constructor.name ? f : k.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, Rc;
}
var Oc, Xm;
function A2() {
  if (Xm)
    return Oc;
  Xm = 1;
  var e = fp();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Oc = function() {
    function r(s, a, u, l, d, p) {
      if (p !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Oc;
}
if (process.env.NODE_ENV !== "production") {
  var $2 = X0(), L2 = !0;
  Cd.exports = k2()($2.isElement, L2);
} else
  Cd.exports = A2()();
var D2 = Cd.exports;
const Bt = /* @__PURE__ */ O2(D2), B2 = "DEPRECATED_Button-module__sharedComponentsButton___wmUpf", F2 = "DEPRECATED_Button-module__sharedComponentsButtonText___CsYPy", z2 = "DEPRECATED_Button-module__btnSecondary___Ga6J-", Pc = {
  sharedComponentsButton: B2,
  sharedComponentsButtonText: F2,
  btnSecondary: z2
}, j2 = " ", Na = (e) => {
  const N = e, {
    allowDisabledTitle: t,
    className: n,
    disabled: r,
    hoverSuffix: o,
    iconClassName: i,
    iconName: s,
    transparent: a,
    text: u,
    trailingIconName: l,
    title: d,
    dark: p,
    gray: f,
    secondary: h,
    dataTestId: g,
    ariaLabel: m = "button"
  } = N, v = re(N, [
    "allowDisabledTitle",
    "className",
    "disabled",
    "hoverSuffix",
    "iconClassName",
    "iconName",
    "transparent",
    "text",
    "trailingIconName",
    "title",
    "dark",
    "gray",
    "secondary",
    "dataTestId",
    "ariaLabel"
  ]), S = he(
    "btn",
    {
      "btn--disabled": r,
      "btn--transp": a,
      "btn--dark": p,
      "btn--icon": !u,
      "btn--gray": f,
      [Pc.btnSecondary]: h
    },
    Pc.sharedComponentsButton,
    n
  ), _ = he("btn__icon", i), R = s && /* @__PURE__ */ O(
    Mt,
    {
      className: _,
      name: s,
      disabled: r,
      hoverSuffix: o
    }
  ), b = he("btn__text", Pc.sharedComponentsButtonText), y = u && /* @__PURE__ */ O("span", { className: b, children: u }), w = R && y && j2, x = l && /* @__PURE__ */ O(
    Mt,
    {
      className: _,
      name: l,
      disabled: r,
      hoverSuffix: o
    }
  ), P = C({
    disabled: r,
    title: d && (!r || t) ? d : void 0
  }, v);
  return /* @__PURE__ */ fe("button", L(C({}, P), { className: S, "data-testid": g, "aria-label": m, children: [
    R,
    w,
    y,
    x
  ] }));
};
Na.propTypes = {
  allowDisabledTitle: Bt.bool,
  className: Bt.string,
  disabled: Bt.bool,
  hoverSuffix: Bt.string,
  iconClassName: Bt.string,
  iconName: Bt.string,
  onClick: Bt.func.isRequired,
  text: Bt.string,
  title: Bt.string,
  trailingIconName: Bt.string,
  transparent: Bt.bool,
  dark: Bt.bool,
  gray: Bt.bool
};
Na.defaultProps = {
  allowDisabledTitle: !1
};
const H2 = (e) => {
  const {
    titleOfPopUp: t,
    currentSortingSettings: n,
    onSortingSettingsUpdate: r,
    onCrossIconClick: o,
    messages: i
  } = e, s = Y0(i), [a, u] = Wt(n), l = () => r(a), d = () => {
    const b = bd(a, (y) => {
      y.forEach((w) => {
        w.direction = null, w.selected = !1;
      });
    });
    r(b);
  }, p = (b) => {
    const y = bd(a, (w) => {
      const x = w.findIndex(({ title: P }) => b.title === P);
      x !== -1 && (w[x].selected = b.selected, w[x].direction = b.direction, b.selected || (w[x].direction = null));
    });
    u(y);
  }, f = a.map((b, y) => {
    const { datatype: w, selected: x, direction: P } = b, { title: N } = b, M = y === a.length - 1 ? null : /* @__PURE__ */ O("span", { className: "subtotals-caption", children: i.subtotals }), A = [
      {
        caption: s(w, ct.ASC),
        id: ct.ASC
      },
      {
        caption: s(w, ct.DESC),
        id: ct.DESC
      }
    ];
    return /* @__PURE__ */ O(
      x2,
      {
        title: N,
        fieldTypes: A,
        selected: x,
        direction: P,
        onSettingsItemStateChange: p,
        subtotalsCaption: M
      },
      N
    );
  }), g = n.some((b) => b.selected) ? /* @__PURE__ */ O(Na, { text: i.clearSorting, gray: !0, onClick: d }) : null, m = _t(null), v = _t(null), S = _t(null), [_, R] = Wt({});
  return Ma(
    () => {
      const b = m.current;
      if (b === null)
        return;
      const y = v.current;
      if (y === null)
        return;
      const w = S.current;
      if (w === null)
        return;
      const x = zm(y, b), P = zm(w, b);
      P.collidedBottom || x.collidedTop || P.collidedTop || x.collidedBottom ? R({
        borderTop: "1px #E7E8EA solid",
        paddingTop: "16px"
      }) : R({});
    },
    a.map(({ selected: b }) => b)
  ), /* @__PURE__ */ O("div", { className: "sis-scope", children: /* @__PURE__ */ fe("div", { className: "complex-sorting-settings", children: [
    /* @__PURE__ */ O(
      A0,
      {
        className: "sorting-settings-header",
        prependedText: i.sortBy,
        hierarchy: t,
        onCrossIconClick: o
      }
    ),
    /* @__PURE__ */ fe("div", { ref: m, className: "complex-sorting-settings__body", children: [
      /* @__PURE__ */ O("span", { ref: v, style: { fontWeight: 600 }, children: i.selectToSort }),
      /* @__PURE__ */ O("ul", { ref: S, className: "settings-checkboxes", children: f })
    ] }),
    /* @__PURE__ */ O("div", { className: "complex-sorting-settings__actions", style: _, children: /* @__PURE__ */ fe("div", { className: "sp-buttons", children: [
      /* @__PURE__ */ O(Na, { onClick: l, text: i.apply }),
      g
    ] }) })
  ] }) });
}, W2 = (e) => {
  const {
    titleOfPopUp: t,
    currentSortingSettings: n,
    onSortingSettingsUpdate: r,
    messages: o
  } = e, i = Y0(o), { datatype: s, direction: a } = n, u = (l) => {
    const d = bd(n, (p) => {
      p.selected = !0, p.direction = l;
    });
    r(d);
  };
  return /* @__PURE__ */ O("div", { className: "sis-scope", children: /* @__PURE__ */ fe("div", { className: "simple-sorting-settings", children: [
    /* @__PURE__ */ O(
      A0,
      {
        className: "sorting-settings-header",
        prependedText: `${o.sort} - `,
        hierarchy: t
      }
    ),
    /* @__PURE__ */ O("div", { className: "simple-sorting-settings__actions", children: /* @__PURE__ */ O(
      R2,
      {
        styles: {
          margin: "16px"
        },
        onChange: u,
        items: [
          {
            name: `${o.sort} ${i(s, ct.ASC)}`,
            value: ct.ASC,
            checked: a === ct.ASC,
            dataTestId: "sort-ascending"
          },
          {
            name: `${o.sort} ${i(s, ct.DESC)}`,
            value: ct.DESC,
            checked: a === ct.DESC,
            dataTestId: "sort-descending"
          }
        ]
      }
    ) })
  ] }) });
};
function V2(e) {
  let t = e;
  const n = [];
  for (; t.content && typeof t.content != typeof E.Component ? n.push(t.content) : n.push(t.value), t.parent; )
    t = t.parent;
  return n.reverse();
}
const Jm = "queryStart", Qm = "queryEnd", U2 = "loadingStart", q2 = "loadingFinish", G2 = "sortUpdate", Zm = "sortingSettingsChanged", K2 = "pageChange", Y2 = "emptyChange", X2 = "totalHeightChange", J2 = "domReady", Q2 = "firstPageRendered", Z2 = "totalWidgetRendered", eg = "pivotElementChange", Is = 0, tg = {
  isFirstPageRendered: !1,
  isGrandTotalRowRendered: !1,
  isTotalRowsCountRendered: !1,
  isReceivedRowsCountCalculated: !1
};
class eB {
  /**
   * @param {DataServiceI} dataService - data service instance
   * @param {object} [defaultProps] - default options
   * @param {EventEmitter} [events] - EventEmitter instance
   */
  constructor(t, n, r = new zi()) {
    /**
     * EventEmitter instance
     */
    I(this, "events");
    /**
     * DOM element to insert component
     */
    I(this, "domElem");
    /**
     * Pivot component instance reference
     */
    I(this, "pivot");
    /**
     * DataServiceI instance
     */
    I(this, "dataService");
    /** Active tree service for paginated mod */
    I(this, "currentRowsTreeService");
    /** Load page progress state */
    I(this, "isLoadPageInProgress", !1);
    /** Flag for saving first page render state */
    I(this, "isFirstPageRenderInProgress", !1);
    /** onDataChunkReceived throttle wrapper */
    I(this, "onDataChunkReceivedThrottle");
    /** Loaded total items count */
    I(this, "loadedItemsCount");
    /** Finished total items count */
    I(this, "totalItemsCount", 0);
    /** Finished total CSV records count */
    I(this, "totalRecordsCount", 0);
    /** Total columns count */
    I(this, "totalColumnsCount", 0);
    /** Columns count */
    I(this, "columnsCount", 0);
    /** Rows limit reached or not */
    I(this, "limitReached", !1);
    /** builder appearance state */
    I(this, "appearanceState", C({}, tg));
    /** Current component properties */
    I(this, "props");
    I(this, "pivotElement");
    I(this, "onDataChunkReceived", (t) => {
      this.onDataChunkReceivedThrottle(t);
    });
    I(this, "onGrandChunkReceived", (t) => {
      const { isPaginated: n } = this.props;
      n && this.currentRowsTreeService && !this.currentRowsTreeService.hasGrandTotals && (this.currentRowsTreeService.extend(t), this.currentRowsTreeService.hasGrandTotals = !0, this.pivot && this.pivot.addMore(this.currentRowsTreeService, !0)), this.setAppearanceState({ isGrandTotalRowRendered: !0 });
    });
    I(this, "onTotalRowsChunkReceived", (t) => {
      const { rowsCount: n, queryRowsCount: r, limitReached: o = !1 } = t;
      this.updateProps({
        totalItemsCount: n,
        totalRecordsCount: r,
        limitReached: o
      }), this.setAppearanceState({ isTotalRowsCountRendered: !0 });
    });
    I(this, "onTotalColumnsChunkReceived", (t) => {
      const { columnsCount: n, totalColumnsCount: r } = t;
      this.columnsCount = n, this.totalColumnsCount = r, this.updateProps({ columnsCount: n, totalColumnsCount: r });
    });
    I(this, "onProgressError", (t) => {
      this.emit(Ys, t);
    });
    I(this, "onSortingMetadataUpdate", (t) => {
      const n = this.dataService ? this.dataService.isSingleRowTree() : !1;
      this.emit(G2, t, { isSingleRowTree: n });
    });
    I(this, "handleSortingSettingsChanged", (t, n, r) => {
      if (!t || t.dir === void 0)
        return;
      const o = n && n.valueNode ? St(n.valueNode) : void 0, i = {
        measurePath: t.measurePath,
        dir: t.dir || Yd(t),
        field: o ? o.jaqlIndex : t.jaqlIndex
      }, s = t.metadataType === "rows" && t.jaqlIndex === i.field, a = this.dataService ? this.dataService.isSingleRowTree() : !1, u = s || a, l = V2(t);
      u ? this.showSimpleSortingPopup(i, r, a, l) : this.showComplexSortingPopup(i, r, a, l);
    });
    I(this, "onMoreLoadingFinish", () => {
      this.hideLoading();
    });
    I(this, "onPageChange", (t) => {
      this.emit(K2), this.loadPageData(t.selected);
    });
    I(this, "onItemsPerPageChangeHandler", (t) => {
      this.updateProps({
        activePage: Is,
        itemsPerPage: t
      }), this.props.onItemsPerPageChange && this.props.onItemsPerPageChange(t);
    });
    I(this, "onEmptyChange", (t) => {
      this.emit(Y2, t);
    });
    I(this, "onTotalHeightChangeHandler", (t) => {
      this.emit(X2, t), this.props.onTotalHeightChange && this.props.onTotalHeightChange(t);
    });
    I(this, "onDomReady", () => {
      this.emit(J2);
    });
    I(this, "onGridUpdated", () => {
      this.isFirstPageRenderInProgress && (this.isFirstPageRenderInProgress = !1, this.setAppearanceState({ isFirstPageRendered: !0 })), this.hideLoading();
    });
    this.events = r, t && (this.registerDataServiceListeners(t), this.dataService = t), this.props = C({
      className: "",
      width: 800,
      height: 400,
      isPaginated: !0,
      isAutoHeight: !1,
      itemsCount: 0,
      loadedItemsCount: 0,
      totalItemsCount: 0,
      totalRecordsCount: 0,
      limitReached: !1,
      totalColumnsCount: 0,
      columnsCount: 0,
      itemsPerPage: 25,
      activePage: Is,
      isFullWidth: !1,
      isFixedEnabled: !0,
      isAllDataLoaded: !1,
      getSortingPopupMessages: () => ({
        // default captions
        clearSorting: "Clear sorting",
        selectToSort: "Select column (level) to sort:",
        sortBy: "Sort by",
        sort: "Sort",
        subtotals: "(Subtotals)",
        apply: "Apply",
        cancel: "Cancel",
        ascAZ: "Ascending (A-Z)",
        descZA: "Descending (Z-A)",
        asc19: "Ascending (1-9)",
        desc91: "Descending (9-1)"
      }),
      paginationOptions: void 0,
      onGetInitialData: () => {
      },
      onMoreLoadingFinish: this.onMoreLoadingFinish,
      onPageChange: this.onPageChange,
      onSortingSettingsChanged: this.handleSortingSettingsChanged,
      onSortingMetadataUpdate: this.onSortingMetadataUpdate,
      onEmptyChange: this.onEmptyChange,
      onGridUpdated: this.onGridUpdated,
      onDomReady: this.onDomReady
    }, n), this.onDataChunkReceivedThrottle = Ry((o) => {
      const { activePage: i } = this.props;
      let s = o;
      this.loadedItemsCount && this.loadedItemsCount > o && (s = this.loadedItemsCount), this.updateProps({
        itemsCount: s,
        activePage: i > -1 ? i : 0
      });
    }, 500);
  }
  destroy() {
    if (this.onDataChunkReceivedThrottle.cancel(), this.dataService) {
      const t = this.dataService;
      this.destroyDataServiceListeners(t);
    }
    this.currentRowsTreeService && (this.currentRowsTreeService.destroy(), this.currentRowsTreeService = void 0), this.pivot = void 0, this.pivotElement = void 0;
  }
  on(t, n) {
    this.events.on(t, n);
  }
  off(t, n) {
    this.events.removeListener(t, n);
  }
  emit(t, ...n) {
    const r = [t, ...n];
    this.events.emit(...r);
  }
  /**
   * Render Pivot component into DOM element
   *
   * @param {object} newProps - Pivot 2 props
   * @returns {void}
   */
  render(t) {
    if (this.pivotElement)
      return this.updateProps(t);
    const n = L(C(C({}, this.props), t), {
      // reference: https://stackoverflow.com/a/55823466/2425556
      ref: (r) => this.pivot = r
    });
    this.pivotElement = E.createElement(Xu, this.withHandlers(n), null), this.events.emit(eg, this.pivotElement), this.props = n;
  }
  /**
   * Update data service instance
   *
   * @param {DataServiceI} dataService - new data service instance
   * @returns {void}
   */
  updateDataService(t) {
    if (this.dataService) {
      const n = this.dataService;
      this.destroyDataServiceListeners(n);
    }
    if (this.dataService = t, this.onDataChunkReceivedThrottle.cancel(), this.dataService) {
      const n = this.dataService;
      this.resetAppearanceState(), this.registerDataServiceListeners(n);
    }
  }
  /**
   * Registers data service events handlers
   *
   * @param {DataService} dataService - data service instance
   * @returns {void}
   */
  registerDataServiceListeners(t) {
    t.on(Pu, this.onDataChunkReceived), t.on(Iu, this.onGrandChunkReceived), t.on(Nu, this.onTotalRowsChunkReceived), t.on(Mu, this.onTotalColumnsChunkReceived), t.on(Ys, this.onProgressError);
  }
  /**
   * Destroys data service events handlers
   *
   * @param {DataService} dataService - data service instance
   * @returns {void}
   */
  destroyDataServiceListeners(t) {
    t.off(Pu, this.onDataChunkReceived), t.off(Iu, this.onGrandChunkReceived), t.off(Nu, this.onTotalRowsChunkReceived), t.off(Mu, this.onTotalColumnsChunkReceived), t.off(Ys, this.onProgressError);
  }
  /**
   * returns pivot's configuration
   *
   * @returns {Props} - current props with callbacks and configurations
   */
  getCurrentState() {
    return C({}, this.props);
  }
  /**
   * Start JAQL loading
   *
   * @param {JaqlRequest} jaql - JAQL request to load
   * @returns {void}
   */
  updateJaql(t) {
    this.totalItemsCount = 0, this.totalColumnsCount = 0, this.totalRecordsCount = 0, this.columnsCount = 0, this.limitReached = !1, this.loadedItemsCount = void 0, this.updateProps({
      totalItemsCount: this.totalItemsCount,
      totalColumnsCount: this.totalColumnsCount,
      totalRecordsCount: this.totalRecordsCount,
      columnsCount: this.columnsCount,
      limitReached: this.limitReached
    }), this.loadInitData(t);
  }
  /**
   * Update component width/height
   *
   * @param {object} newProps - component changed properties
   * @returns {void}
   */
  updateProps(t) {
    if (!this.pivotElement)
      return;
    const n = L(C(C({}, this.props), t), {
      // reference: https://stackoverflow.com/a/55823466/2425556
      ref: (o) => this.pivot = o
    }), r = Oy(this.props, n);
    (typeof r.isPaginated != "undefined" || typeof r.itemsPerPage != "undefined") && (this.totalItemsCount = 0, this.totalRecordsCount = 0, this.loadedItemsCount = void 0, this.loadInitData(void 0, n)), this.pivotElement = E.createElement(Xu, this.withHandlers(n), null), this.events.emit(eg, this.pivotElement), this.props = n;
  }
  /**
   * Loading initial page
   *
   * @param {JaqlRequest} [jaql] - JAQL to load, or 'null' if use cached data
   * @param {Props} [props] - Pivot props
   * @returns {void}
   * @private
   */
  loadInitData(t, n = this.props) {
    var a, u;
    if (((u = (a = this.dataService) == null ? void 0 : a.getJaql()) == null ? void 0 : u.queryGuid) === (t == null ? void 0 : t.queryGuid))
      return;
    const { dataService: r } = this, { isPaginated: o, itemsPerPage: i } = n, s = o ? i : void 0;
    if (this.onDataChunkReceivedThrottle.cancel(), !r) {
      this.pivot && this.pivot.initialize(), this.currentRowsTreeService && (this.currentRowsTreeService.destroy(), this.currentRowsTreeService = void 0);
      return;
    }
    this.updateProps({
      itemsCount: 0,
      totalItemsCount: 0,
      totalColumnsCount: 0,
      totalRecordsCount: 0,
      columnsCount: 0,
      activePage: Is,
      isAllDataLoaded: !1,
      limitReached: !1
    }), this.currentRowsTreeService = void 0, this.isLoadPageInProgress = !1, this.isFirstPageRenderInProgress = !1, this.showLoading(), this.events.emit(Jm), r.loadData(t, { pageSize: s, isPaginated: o }).then(
      ({ rowsTreeService: l, columnsTreeService: d, cornerTreeService: p, isLastPage: f, cellsMetadata: h }) => {
        this.events.emit(Qm, { cellsMetadata: h }), this.loadedItemsCount !== null && this.updateProps({
          itemsCount: this.loadedItemsCount,
          totalItemsCount: this.totalItemsCount,
          totalRecordsCount: this.totalRecordsCount,
          limitReached: this.limitReached,
          activePage: Is,
          isAllDataLoaded: !0
        }), this.pivot && (this.isFirstPageRenderInProgress = !0, this.pivot.initialize(l, d, p, {
          isLastPage: f,
          cellsMetadata: h
        }), this.currentRowsTreeService = l);
      }
    ).catch((l) => {
      if (!(l instanceof no))
        throw l;
    }), r.loadAllData().then((l) => {
      this.totalItemsCount = l.totalItemsCount, this.loadedItemsCount = l.loadedRowsCount, this.totalRecordsCount = l.totalRecordsCount, this.limitReached = l.limitReached, l.columnsCount && l.totalColumnsCount && (this.columnsCount = l.columnsCount, this.totalColumnsCount = l.totalColumnsCount);
      const d = C({ isAllDataLoaded: !0 }, l);
      this.updateProps(d), this.setAppearanceState({ isReceivedRowsCountCalculated: !0 });
    }).catch((l) => {
      if (!(l instanceof no))
        throw l;
    });
  }
  /**
   * Load appropriate page in case of paging
   *
   * @param {number} page - page to load
   * @returns {void}
   * @private
   */
  loadPageData(t) {
    if (this.isLoadPageInProgress || !this.props.isPaginated)
      return;
    const { dataService: n } = this;
    if (!n) {
      console.warn("DataService instance not defined");
      return;
    }
    this.isLoadPageInProgress = !0, this.showLoading(), this.events.emit(Jm), n.getSelectedPageData(t, this.props.itemsPerPage).then((r) => {
      const {
        rowsTreeService: o,
        columnsTreeService: i,
        cornerTreeService: s,
        isLastPage: a,
        cellsMetadata: u
      } = r;
      this.events.emit(Qm, r), this.isLoadPageInProgress = !1, this.pivot && (this.pivot.initialize(o, i, s, {
        isLastPage: a,
        cellsMetadata: u
      }), this.currentRowsTreeService = o), this.updateProps({
        activePage: t
      });
    });
  }
  /**
   * Show loading indication
   *
   * @returns {void}
   * @private
   */
  showLoading() {
    this.emit(U2);
  }
  /**
   * Hide loading indication
   *
   * @returns {void}
   * @private
   */
  hideLoading() {
    this.emit(q2);
  }
  showSimpleSortingPopup(t, n, r, o) {
    const i = this.dataService && this.dataService.getJaql();
    if (!i)
      return;
    const s = ut.getMetadataPanels(i), a = ut.getDataTypes(s), u = ut.mapWidgetJaqlToSimpleSortingSettings(
      s,
      t,
      a
    );
    if (u === void 0)
      return;
    const l = (p) => {
      n.setSortingPopup(null), !_u(u, p) && this.emit(Zm, {
        type: "simple",
        settings: [p],
        sortDetails: t,
        isSingleRowTree: r
      });
    }, d = E.createElement(W2, {
      titleOfPopUp: o,
      currentSortingSettings: u,
      onSortingSettingsUpdate: l,
      messages: this.props.getSortingPopupMessages()
    });
    n.setSortingPopup(d);
  }
  showComplexSortingPopup(t, n, r, o) {
    const i = this.dataService && this.dataService.getJaql();
    if (!i)
      return;
    const s = ut.mapWidgetJaqlToComplexSortingSettings(
      i,
      t
    ), a = (l) => {
      n.setSortingPopup(null), !_u(s, l) && this.emit(Zm, {
        type: "complex",
        settings: l,
        sortDetails: t,
        isSingleRowTree: r
      });
    }, u = E.createElement(H2, {
      titleOfPopUp: o,
      currentSortingSettings: s,
      onSortingSettingsUpdate: a,
      onCrossIconClick: () => n.setSortingPopup(null),
      messages: this.props.getSortingPopupMessages()
    });
    n.setSortingPopup(u);
  }
  /**
   * Handles appearance state updating
   *
   * @param {AppearanceState} prevState - prev appearance state
   * @param {AppearanceState} nextState - next appearance state
   * @returns {void}
   */
  onAppearanceStateUpdated(t, n) {
    !t.isFirstPageRendered && n.isFirstPageRendered && this.emit(Q2), !this.isTotallyRendered(t) && this.isTotallyRendered(n) && this.emit(Z2);
  }
  /**
   * Setter for pivot builder appearance state
   *
   * @param {AppearanceState} appearanceState - appearance state properties to update
   * @returns {void}
   */
  setAppearanceState(t = {}) {
    const n = Object.freeze(C({}, this.appearanceState)), r = Object.freeze(C(C({}, this.appearanceState), t));
    this.onAppearanceStateUpdated(n, r), this.appearanceState = r;
  }
  /**
   * Resets pivot builder appearance state
   *
   * @returns {void}
   */
  resetAppearanceState() {
    const t = Object.freeze(C({}, this.appearanceState)), n = Object.freeze(C({}, tg));
    this.onAppearanceStateUpdated(t, n), this.appearanceState = n;
  }
  /**
   * Checks if pivot widget totally rendered
   *
   * @param {AppearanceState} [state] - appearance state
   * @returns {boolean} - is totally rendered flag
   */
  isTotallyRendered(t = this.appearanceState) {
    const n = this.dataService && this.dataService.getJaql() || {
      grandTotals: { rows: void 0 }
    }, r = !!(n.grandTotals && n.grandTotals.rows);
    return t.isFirstPageRendered && t.isTotalRowsCountRendered && t.isReceivedRowsCountCalculated && (!r || t.isGrandTotalRowRendered);
  }
  /**
   * Enables the usage of local handlers alongside prop handlers.
   * This addresses the awkward pivot design that overrides local handlers containing important business logic.
   */
  withHandlers(t) {
    return L(C({}, t), {
      onItemsPerPageChange: this.onItemsPerPageChangeHandler,
      onTotalHeightChange: this.onTotalHeightChangeHandler
    });
  }
}
var Ns = { exports: {} }, Ic, ng;
function Q0() {
  if (ng)
    return Ic;
  ng = 1;
  var e = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, t = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
  ];
  Ic = function(i) {
    var s = i, a = i.indexOf("["), u = i.indexOf("]");
    a != -1 && u != -1 && (i = i.substring(0, a) + i.substring(a, u).replace(/:/g, ";") + i.substring(u, i.length));
    for (var l = e.exec(i || ""), d = {}, p = 14; p--; )
      d[t[p]] = l[p] || "";
    return a != -1 && u != -1 && (d.source = s, d.host = d.host.substring(1, d.host.length - 1).replace(/;/g, ":"), d.authority = d.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), d.ipv6uri = !0), d.pathNames = n(d, d.path), d.queryKey = r(d, d.query), d;
  };
  function n(o, i) {
    var s = /\/{2,9}/g, a = i.replace(s, "/").split("/");
    return (i.substr(0, 1) == "/" || i.length === 0) && a.splice(0, 1), i.substr(i.length - 1, 1) == "/" && a.splice(a.length - 1, 1), a;
  }
  function r(o, i) {
    var s = {};
    return i.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(a, u, l) {
      u && (s[u] = l);
    }), s;
  }
  return Ic;
}
var Ms = { exports: {} }, ks = { exports: {} }, Nc, rg;
function tB() {
  if (rg)
    return Nc;
  rg = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, o = r * 365.25;
  Nc = function(l, d) {
    d = d || {};
    var p = typeof l;
    if (p === "string" && l.length > 0)
      return i(l);
    if (p === "number" && isNaN(l) === !1)
      return d.long ? a(l) : s(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function i(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var p = parseFloat(d[1]), f = (d[2] || "ms").toLowerCase();
        switch (f) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return p * o;
          case "days":
          case "day":
          case "d":
            return p * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return p * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return p * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return p * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return p;
          default:
            return;
        }
      }
    }
  }
  function s(l) {
    return l >= r ? Math.round(l / r) + "d" : l >= n ? Math.round(l / n) + "h" : l >= t ? Math.round(l / t) + "m" : l >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function a(l) {
    return u(l, r, "day") || u(l, n, "hour") || u(l, t, "minute") || u(l, e, "second") || l + " ms";
  }
  function u(l, d, p) {
    if (!(l < d))
      return l < d * 1.5 ? Math.floor(l / d) + " " + p : Math.ceil(l / d) + " " + p + "s";
  }
  return Nc;
}
var og;
function nB() {
  return og || (og = 1, function(e, t) {
    t = e.exports = r.debug = r.default = r, t.coerce = u, t.disable = s, t.enable = i, t.enabled = a, t.humanize = tB(), t.instances = [], t.names = [], t.skips = [], t.formatters = {};
    function n(l) {
      var d = 0, p;
      for (p in l)
        d = (d << 5) - d + l.charCodeAt(p), d |= 0;
      return t.colors[Math.abs(d) % t.colors.length];
    }
    function r(l) {
      var d;
      function p() {
        if (p.enabled) {
          var f = p, h = +/* @__PURE__ */ new Date(), g = h - (d || h);
          f.diff = g, f.prev = d, f.curr = h, d = h;
          for (var m = new Array(arguments.length), v = 0; v < m.length; v++)
            m[v] = arguments[v];
          m[0] = t.coerce(m[0]), typeof m[0] != "string" && m.unshift("%O");
          var S = 0;
          m[0] = m[0].replace(/%([a-zA-Z%])/g, function(R, b) {
            if (R === "%%")
              return R;
            S++;
            var y = t.formatters[b];
            if (typeof y == "function") {
              var w = m[S];
              R = y.call(f, w), m.splice(S, 1), S--;
            }
            return R;
          }), t.formatArgs.call(f, m);
          var _ = p.log || t.log || console.log.bind(console);
          _.apply(f, m);
        }
      }
      return p.namespace = l, p.enabled = t.enabled(l), p.useColors = t.useColors(), p.color = n(l), p.destroy = o, typeof t.init == "function" && t.init(p), t.instances.push(p), p;
    }
    function o() {
      var l = t.instances.indexOf(this);
      return l !== -1 ? (t.instances.splice(l, 1), !0) : !1;
    }
    function i(l) {
      t.save(l), t.names = [], t.skips = [];
      var d, p = (typeof l == "string" ? l : "").split(/[\s,]+/), f = p.length;
      for (d = 0; d < f; d++)
        p[d] && (l = p[d].replace(/\*/g, ".*?"), l[0] === "-" ? t.skips.push(new RegExp("^" + l.substr(1) + "$")) : t.names.push(new RegExp("^" + l + "$")));
      for (d = 0; d < t.instances.length; d++) {
        var h = t.instances[d];
        h.enabled = t.enabled(h.namespace);
      }
    }
    function s() {
      t.enable("");
    }
    function a(l) {
      if (l[l.length - 1] === "*")
        return !0;
      var d, p;
      for (d = 0, p = t.skips.length; d < p; d++)
        if (t.skips[d].test(l))
          return !1;
      for (d = 0, p = t.names.length; d < p; d++)
        if (t.names[d].test(l))
          return !0;
      return !1;
    }
    function u(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }
  }(ks, ks.exports)), ks.exports;
}
var ig;
function yl() {
  return ig || (ig = 1, function(e, t) {
    t = e.exports = nB(), t.log = o, t.formatArgs = r, t.save = i, t.load = s, t.useColors = n, t.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : a(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    t.formatters.j = function(u) {
      try {
        return JSON.stringify(u);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
    function r(u) {
      var l = this.useColors;
      if (u[0] = (l ? "%c" : "") + this.namespace + (l ? " %c" : " ") + u[0] + (l ? "%c " : " ") + "+" + t.humanize(this.diff), !!l) {
        var d = "color: " + this.color;
        u.splice(1, 0, d, "color: inherit");
        var p = 0, f = 0;
        u[0].replace(/%[a-zA-Z%]/g, function(h) {
          h !== "%%" && (p++, h === "%c" && (f = p));
        }), u.splice(f, 0, d);
      }
    }
    function o() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function i(u) {
      try {
        u == null ? t.storage.removeItem("debug") : t.storage.debug = u;
      } catch (l) {
      }
    }
    function s() {
      var u;
      try {
        u = t.storage.debug;
      } catch (l) {
      }
      return !u && typeof process != "undefined" && "env" in process && (u = process.env.DEBUG), u;
    }
    t.enable(s());
    function a() {
      try {
        return window.localStorage;
      } catch (u) {
      }
    }
  }(Ms, Ms.exports)), Ms.exports;
}
var Mc, sg;
function rB() {
  if (sg)
    return Mc;
  sg = 1;
  var e = Q0(), t = yl()("socket.io-client:url");
  Mc = n;
  function n(r, o) {
    var i = r;
    o = o || typeof location != "undefined" && location, r == null && (r = o.protocol + "//" + o.host), typeof r == "string" && (r.charAt(0) === "/" && (r.charAt(1) === "/" ? r = o.protocol + r : r = o.host + r), /^(https?|wss?):\/\//.test(r) || (t("protocol-less url %s", r), typeof o != "undefined" ? r = o.protocol + "//" + r : r = "https://" + r), t("parse %s", r), i = e(r)), i.port || (/^(http|ws)$/.test(i.protocol) ? i.port = "80" : /^(http|ws)s$/.test(i.protocol) && (i.port = "443")), i.path = i.path || "/";
    var s = i.host.indexOf(":") !== -1, a = s ? "[" + i.host + "]" : i.host;
    return i.id = i.protocol + "://" + a + ":" + i.port, i.href = i.protocol + "://" + a + (o && o.port === i.port ? "" : ":" + i.port), i;
  }
  return Mc;
}
var kc = {}, As = { exports: {} }, $s = { exports: {} }, Ac, ag;
function oB() {
  if (ag)
    return Ac;
  ag = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, o = r * 365.25;
  Ac = function(l, d) {
    d = d || {};
    var p = typeof l;
    if (p === "string" && l.length > 0)
      return i(l);
    if (p === "number" && isNaN(l) === !1)
      return d.long ? a(l) : s(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function i(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var p = parseFloat(d[1]), f = (d[2] || "ms").toLowerCase();
        switch (f) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return p * o;
          case "days":
          case "day":
          case "d":
            return p * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return p * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return p * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return p * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return p;
          default:
            return;
        }
      }
    }
  }
  function s(l) {
    return l >= r ? Math.round(l / r) + "d" : l >= n ? Math.round(l / n) + "h" : l >= t ? Math.round(l / t) + "m" : l >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function a(l) {
    return u(l, r, "day") || u(l, n, "hour") || u(l, t, "minute") || u(l, e, "second") || l + " ms";
  }
  function u(l, d, p) {
    if (!(l < d))
      return l < d * 1.5 ? Math.floor(l / d) + " " + p : Math.ceil(l / d) + " " + p + "s";
  }
  return Ac;
}
var lg;
function iB() {
  return lg || (lg = 1, function(e, t) {
    t = e.exports = r.debug = r.default = r, t.coerce = u, t.disable = s, t.enable = i, t.enabled = a, t.humanize = oB(), t.instances = [], t.names = [], t.skips = [], t.formatters = {};
    function n(l) {
      var d = 0, p;
      for (p in l)
        d = (d << 5) - d + l.charCodeAt(p), d |= 0;
      return t.colors[Math.abs(d) % t.colors.length];
    }
    function r(l) {
      var d;
      function p() {
        if (p.enabled) {
          var f = p, h = +/* @__PURE__ */ new Date(), g = h - (d || h);
          f.diff = g, f.prev = d, f.curr = h, d = h;
          for (var m = new Array(arguments.length), v = 0; v < m.length; v++)
            m[v] = arguments[v];
          m[0] = t.coerce(m[0]), typeof m[0] != "string" && m.unshift("%O");
          var S = 0;
          m[0] = m[0].replace(/%([a-zA-Z%])/g, function(R, b) {
            if (R === "%%")
              return R;
            S++;
            var y = t.formatters[b];
            if (typeof y == "function") {
              var w = m[S];
              R = y.call(f, w), m.splice(S, 1), S--;
            }
            return R;
          }), t.formatArgs.call(f, m);
          var _ = p.log || t.log || console.log.bind(console);
          _.apply(f, m);
        }
      }
      return p.namespace = l, p.enabled = t.enabled(l), p.useColors = t.useColors(), p.color = n(l), p.destroy = o, typeof t.init == "function" && t.init(p), t.instances.push(p), p;
    }
    function o() {
      var l = t.instances.indexOf(this);
      return l !== -1 ? (t.instances.splice(l, 1), !0) : !1;
    }
    function i(l) {
      t.save(l), t.names = [], t.skips = [];
      var d, p = (typeof l == "string" ? l : "").split(/[\s,]+/), f = p.length;
      for (d = 0; d < f; d++)
        p[d] && (l = p[d].replace(/\*/g, ".*?"), l[0] === "-" ? t.skips.push(new RegExp("^" + l.substr(1) + "$")) : t.names.push(new RegExp("^" + l + "$")));
      for (d = 0; d < t.instances.length; d++) {
        var h = t.instances[d];
        h.enabled = t.enabled(h.namespace);
      }
    }
    function s() {
      t.enable("");
    }
    function a(l) {
      if (l[l.length - 1] === "*")
        return !0;
      var d, p;
      for (d = 0, p = t.skips.length; d < p; d++)
        if (t.skips[d].test(l))
          return !1;
      for (d = 0, p = t.names.length; d < p; d++)
        if (t.names[d].test(l))
          return !0;
      return !1;
    }
    function u(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }
  }($s, $s.exports)), $s.exports;
}
var cg;
function sB() {
  return cg || (cg = 1, function(e, t) {
    t = e.exports = iB(), t.log = o, t.formatArgs = r, t.save = i, t.load = s, t.useColors = n, t.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : a(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    t.formatters.j = function(u) {
      try {
        return JSON.stringify(u);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
    function r(u) {
      var l = this.useColors;
      if (u[0] = (l ? "%c" : "") + this.namespace + (l ? " %c" : " ") + u[0] + (l ? "%c " : " ") + "+" + t.humanize(this.diff), !!l) {
        var d = "color: " + this.color;
        u.splice(1, 0, d, "color: inherit");
        var p = 0, f = 0;
        u[0].replace(/%[a-zA-Z%]/g, function(h) {
          h !== "%%" && (p++, h === "%c" && (f = p));
        }), u.splice(f, 0, d);
      }
    }
    function o() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function i(u) {
      try {
        u == null ? t.storage.removeItem("debug") : t.storage.debug = u;
      } catch (l) {
      }
    }
    function s() {
      var u;
      try {
        u = t.storage.debug;
      } catch (l) {
      }
      return !u && typeof process != "undefined" && "env" in process && (u = process.env.DEBUG), u;
    }
    t.enable(s());
    function a() {
      try {
        return window.localStorage;
      } catch (u) {
      }
    }
  }(As, As.exports)), As.exports;
}
var $c = { exports: {} }, ug;
function Io() {
  return ug || (ug = 1, function(e) {
    e.exports = t;
    function t(r) {
      if (r)
        return n(r);
    }
    function n(r) {
      for (var o in t.prototype)
        r[o] = t.prototype[o];
      return r;
    }
    t.prototype.on = t.prototype.addEventListener = function(r, o) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + r] = this._callbacks["$" + r] || []).push(o), this;
    }, t.prototype.once = function(r, o) {
      function i() {
        this.off(r, i), o.apply(this, arguments);
      }
      return i.fn = o, this.on(r, i), this;
    }, t.prototype.off = t.prototype.removeListener = t.prototype.removeAllListeners = t.prototype.removeEventListener = function(r, o) {
      if (this._callbacks = this._callbacks || {}, arguments.length == 0)
        return this._callbacks = {}, this;
      var i = this._callbacks["$" + r];
      if (!i)
        return this;
      if (arguments.length == 1)
        return delete this._callbacks["$" + r], this;
      for (var s, a = 0; a < i.length; a++)
        if (s = i[a], s === o || s.fn === o) {
          i.splice(a, 1);
          break;
        }
      return i.length === 0 && delete this._callbacks["$" + r], this;
    }, t.prototype.emit = function(r) {
      this._callbacks = this._callbacks || {};
      for (var o = new Array(arguments.length - 1), i = this._callbacks["$" + r], s = 1; s < arguments.length; s++)
        o[s - 1] = arguments[s];
      if (i) {
        i = i.slice(0);
        for (var s = 0, a = i.length; s < a; ++s)
          i[s].apply(this, o);
      }
      return this;
    }, t.prototype.listeners = function(r) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + r] || [];
    }, t.prototype.hasListeners = function(r) {
      return !!this.listeners(r).length;
    };
  }($c)), $c.exports;
}
var ni = {}, Lc, dg;
function Z0() {
  if (dg)
    return Lc;
  dg = 1;
  var e = {}.toString;
  return Lc = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, Lc;
}
var Dc, pg;
function eC() {
  if (pg)
    return Dc;
  pg = 1, Dc = r;
  var e = typeof Buffer == "function" && typeof Buffer.isBuffer == "function", t = typeof ArrayBuffer == "function", n = function(o) {
    return typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(o) : o.buffer instanceof ArrayBuffer;
  };
  function r(o) {
    return e && Buffer.isBuffer(o) || t && (o instanceof ArrayBuffer || n(o));
  }
  return Dc;
}
var fg;
function aB() {
  if (fg)
    return ni;
  fg = 1;
  var e = Z0(), t = eC(), n = Object.prototype.toString, r = typeof Blob == "function" || typeof Blob != "undefined" && n.call(Blob) === "[object BlobConstructor]", o = typeof File == "function" || typeof File != "undefined" && n.call(File) === "[object FileConstructor]";
  ni.deconstructPacket = function(a) {
    var u = [], l = a.data, d = a;
    return d.data = i(l, u), d.attachments = u.length, { packet: d, buffers: u };
  };
  function i(a, u) {
    if (!a)
      return a;
    if (t(a)) {
      var l = { _placeholder: !0, num: u.length };
      return u.push(a), l;
    } else if (e(a)) {
      for (var d = new Array(a.length), p = 0; p < a.length; p++)
        d[p] = i(a[p], u);
      return d;
    } else if (typeof a == "object" && !(a instanceof Date)) {
      var d = {};
      for (var f in a)
        d[f] = i(a[f], u);
      return d;
    }
    return a;
  }
  ni.reconstructPacket = function(a, u) {
    return a.data = s(a.data, u), a.attachments = void 0, a;
  };
  function s(a, u) {
    if (!a)
      return a;
    if (a && a._placeholder === !0) {
      var l = typeof a.num == "number" && a.num >= 0 && a.num < u.length;
      if (l)
        return u[a.num];
      throw new Error("illegal attachments");
    } else if (e(a))
      for (var d = 0; d < a.length; d++)
        a[d] = s(a[d], u);
    else if (typeof a == "object")
      for (var p in a)
        a[p] = s(a[p], u);
    return a;
  }
  return ni.removeBlobs = function(a, u) {
    function l(f, h, g) {
      if (!f)
        return f;
      if (r && f instanceof Blob || o && f instanceof File) {
        d++;
        var m = new FileReader();
        m.onload = function() {
          g ? g[h] = this.result : p = this.result, --d || u(p);
        }, m.readAsArrayBuffer(f);
      } else if (e(f))
        for (var v = 0; v < f.length; v++)
          l(f[v], v, f);
      else if (typeof f == "object" && !t(f))
        for (var S in f)
          l(f[S], S, f);
    }
    var d = 0, p = a;
    l(p), d || u(p);
  }, ni;
}
var hg;
function hp() {
  return hg || (hg = 1, function(e) {
    var t = sB()("socket.io-parser"), n = Io(), r = aB(), o = Z0(), i = eC();
    e.protocol = 4, e.types = [
      "CONNECT",
      "DISCONNECT",
      "EVENT",
      "ACK",
      "ERROR",
      "BINARY_EVENT",
      "BINARY_ACK"
    ], e.CONNECT = 0, e.DISCONNECT = 1, e.EVENT = 2, e.ACK = 3, e.ERROR = 4, e.BINARY_EVENT = 5, e.BINARY_ACK = 6, e.Encoder = s, e.Decoder = p;
    function s() {
    }
    var a = e.ERROR + '"encode error"';
    s.prototype.encode = function(S, _) {
      if (t("encoding packet %j", S), e.BINARY_EVENT === S.type || e.BINARY_ACK === S.type)
        d(S, _);
      else {
        var R = u(S);
        _([R]);
      }
    };
    function u(S) {
      var _ = "" + S.type;
      if ((e.BINARY_EVENT === S.type || e.BINARY_ACK === S.type) && (_ += S.attachments + "-"), S.nsp && S.nsp !== "/" && (_ += S.nsp + ","), S.id != null && (_ += S.id), S.data != null) {
        var R = l(S.data);
        if (R !== !1)
          _ += R;
        else
          return a;
      }
      return t("encoded %j as %s", S, _), _;
    }
    function l(S) {
      try {
        return JSON.stringify(S);
      } catch (_) {
        return !1;
      }
    }
    function d(S, _) {
      function R(b) {
        var y = r.deconstructPacket(b), w = u(y.packet), x = y.buffers;
        x.unshift(w), _(x);
      }
      r.removeBlobs(S, R);
    }
    function p() {
      this.reconstructor = null;
    }
    n(p.prototype), p.prototype.add = function(S) {
      var _;
      if (typeof S == "string") {
        if (this.reconstructor)
          throw new Error("got plaintext data when reconstructing a packet");
        _ = h(S), e.BINARY_EVENT === _.type || e.BINARY_ACK === _.type ? (this.reconstructor = new m(_), this.reconstructor.reconPack.attachments === 0 && this.emit("decoded", _)) : this.emit("decoded", _);
      } else if (i(S) || S.base64)
        if (this.reconstructor)
          _ = this.reconstructor.takeBinaryData(S), _ && (this.reconstructor = null, this.emit("decoded", _));
        else
          throw new Error("got binary data when not reconstructing a packet");
      else
        throw new Error("Unknown type: " + S);
    };
    function f(S, _) {
      switch (S) {
        case 0:
          return typeof _ == "object";
        case 1:
          return _ === void 0;
        case 4:
          return typeof _ == "string" || typeof _ == "object";
        case 2:
        case 5:
          return o(_) && (typeof _[0] == "string" || typeof _[0] == "number");
        case 3:
        case 6:
          return o(_);
      }
    }
    function h(S) {
      var _ = 0, R = {
        type: Number(S.charAt(0))
      };
      if (e.types[R.type] == null)
        return v("unknown packet type " + R.type);
      if (e.BINARY_EVENT === R.type || e.BINARY_ACK === R.type) {
        for (var b = _ + 1; S.charAt(++_) !== "-" && _ != S.length; )
          ;
        var y = S.substring(b, _);
        if (y != Number(y) || S.charAt(_) !== "-")
          throw new Error("Illegal attachments");
        R.attachments = Number(y);
      }
      if (S.charAt(_ + 1) === "/") {
        for (var b = _ + 1; ++_; ) {
          var w = S.charAt(_);
          if (w === "," || _ === S.length)
            break;
        }
        R.nsp = S.substring(b, _);
      } else
        R.nsp = "/";
      var x = S.charAt(_ + 1);
      if (x !== "" && Number(x) == x) {
        for (var b = _ + 1; ++_; ) {
          var w = S.charAt(_);
          if (w == null || Number(w) != w) {
            --_;
            break;
          }
          if (_ === S.length)
            break;
        }
        R.id = Number(S.substring(b, _ + 1));
      }
      if (S.charAt(++_)) {
        var P = g(S.substr(_));
        if (f(R.type, P))
          R.data = P;
        else
          throw new Error("invalid payload");
      }
      return t("decoded %s as %j", S, R), R;
    }
    function g(S) {
      try {
        return JSON.parse(S);
      } catch (_) {
        return !1;
      }
    }
    p.prototype.destroy = function() {
      this.reconstructor && this.reconstructor.finishedReconstruction();
    };
    function m(S) {
      this.reconPack = S, this.buffers = [];
    }
    m.prototype.takeBinaryData = function(S) {
      if (this.buffers.push(S), this.buffers.length === this.reconPack.attachments) {
        var _ = r.reconstructPacket(this.reconPack, this.buffers);
        return this.finishedReconstruction(), _;
      }
      return null;
    }, m.prototype.finishedReconstruction = function() {
      this.reconPack = null, this.buffers = [];
    };
    function v(S) {
      return {
        type: e.ERROR,
        data: "parser error: " + S
      };
    }
  }(kc)), kc;
}
var Ls = { exports: {} }, Ds = {}, Bs = { exports: {} }, mg;
function lB() {
  if (mg)
    return Bs.exports;
  mg = 1;
  try {
    Bs.exports = typeof XMLHttpRequest != "undefined" && "withCredentials" in new XMLHttpRequest();
  } catch (e) {
    Bs.exports = !1;
  }
  return Bs.exports;
}
var Bc, gg;
function mp() {
  return gg || (gg = 1, Bc = function() {
    return typeof self != "undefined" ? self : typeof window != "undefined" ? window : Function("return this")();
  }()), Bc;
}
var Fc, yg;
function gp() {
  if (yg)
    return Fc;
  yg = 1;
  var e = lB(), t = mp();
  return Fc = function(n) {
    var r = n.xdomain, o = n.xscheme, i = n.enablesXDR;
    try {
      if (typeof XMLHttpRequest != "undefined" && (!r || e))
        return new XMLHttpRequest();
    } catch (s) {
    }
    try {
      if (typeof XDomainRequest != "undefined" && !o && i)
        return new XDomainRequest();
    } catch (s) {
    }
    if (!r)
      try {
        return new t[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
      } catch (s) {
      }
  }, Fc;
}
var Fs = { exports: {} }, zc = {}, jc, vg;
function cB() {
  return vg || (vg = 1, jc = Object.keys || function(t) {
    var n = [], r = Object.prototype.hasOwnProperty;
    for (var o in t)
      r.call(t, o) && n.push(o);
    return n;
  }), jc;
}
var Hc, bg;
function uB() {
  if (bg)
    return Hc;
  bg = 1;
  var e = {}.toString;
  return Hc = Array.isArray || function(t) {
    return e.call(t) == "[object Array]";
  }, Hc;
}
var Wc, Cg;
function tC() {
  if (Cg)
    return Wc;
  Cg = 1;
  var e = uB(), t = Object.prototype.toString, n = typeof Blob == "function" || typeof Blob != "undefined" && t.call(Blob) === "[object BlobConstructor]", r = typeof File == "function" || typeof File != "undefined" && t.call(File) === "[object FileConstructor]";
  Wc = o;
  function o(i) {
    if (!i || typeof i != "object")
      return !1;
    if (e(i)) {
      for (var s = 0, a = i.length; s < a; s++)
        if (o(i[s]))
          return !0;
      return !1;
    }
    if (typeof Buffer == "function" && Buffer.isBuffer && Buffer.isBuffer(i) || typeof ArrayBuffer == "function" && i instanceof ArrayBuffer || n && i instanceof Blob || r && i instanceof File)
      return !0;
    if (i.toJSON && typeof i.toJSON == "function" && arguments.length === 1)
      return o(i.toJSON(), !0);
    for (var u in i)
      if (Object.prototype.hasOwnProperty.call(i, u) && o(i[u]))
        return !0;
    return !1;
  }
  return Wc;
}
var Vc, Sg;
function dB() {
  return Sg || (Sg = 1, Vc = function(e, t, n) {
    var r = e.byteLength;
    if (t = t || 0, n = n || r, e.slice)
      return e.slice(t, n);
    if (t < 0 && (t += r), n < 0 && (n += r), n > r && (n = r), t >= r || t >= n || r === 0)
      return new ArrayBuffer(0);
    for (var o = new Uint8Array(e), i = new Uint8Array(n - t), s = t, a = 0; s < n; s++, a++)
      i[a] = o[s];
    return i.buffer;
  }), Vc;
}
var Uc, wg;
function pB() {
  if (wg)
    return Uc;
  wg = 1, Uc = e;
  function e(n, r, o) {
    var i = !1;
    return o = o || t, s.count = n, n === 0 ? r() : s;
    function s(a, u) {
      if (s.count <= 0)
        throw new Error("after called too many times");
      --s.count, a ? (i = !0, r(a), r = o) : s.count === 0 && !i && r(null, u);
    }
  }
  function t() {
  }
  return Uc;
}
/*! https://mths.be/utf8js v2.1.2 by @mathias */
var qc, _g;
function fB() {
  if (_g)
    return qc;
  _g = 1;
  var e = String.fromCharCode;
  function t(h) {
    for (var g = [], m = 0, v = h.length, S, _; m < v; )
      S = h.charCodeAt(m++), S >= 55296 && S <= 56319 && m < v ? (_ = h.charCodeAt(m++), (_ & 64512) == 56320 ? g.push(((S & 1023) << 10) + (_ & 1023) + 65536) : (g.push(S), m--)) : g.push(S);
    return g;
  }
  function n(h) {
    for (var g = h.length, m = -1, v, S = ""; ++m < g; )
      v = h[m], v > 65535 && (v -= 65536, S += e(v >>> 10 & 1023 | 55296), v = 56320 | v & 1023), S += e(v);
    return S;
  }
  function r(h, g) {
    if (h >= 55296 && h <= 57343) {
      if (g)
        throw Error(
          "Lone surrogate U+" + h.toString(16).toUpperCase() + " is not a scalar value"
        );
      return !1;
    }
    return !0;
  }
  function o(h, g) {
    return e(h >> g & 63 | 128);
  }
  function i(h, g) {
    if (!(h & 4294967168))
      return e(h);
    var m = "";
    return h & 4294965248 ? h & 4294901760 ? h & 4292870144 || (m = e(h >> 18 & 7 | 240), m += o(h, 12), m += o(h, 6)) : (r(h, g) || (h = 65533), m = e(h >> 12 & 15 | 224), m += o(h, 6)) : m = e(h >> 6 & 31 | 192), m += e(h & 63 | 128), m;
  }
  function s(h, g) {
    g = g || {};
    for (var m = g.strict !== !1, v = t(h), S = v.length, _ = -1, R, b = ""; ++_ < S; )
      R = v[_], b += i(R, m);
    return b;
  }
  function a() {
    if (p >= d)
      throw Error("Invalid byte index");
    var h = l[p] & 255;
    if (p++, (h & 192) == 128)
      return h & 63;
    throw Error("Invalid continuation byte");
  }
  function u(h) {
    var g, m, v, S, _;
    if (p > d)
      throw Error("Invalid byte index");
    if (p == d)
      return !1;
    if (g = l[p] & 255, p++, !(g & 128))
      return g;
    if ((g & 224) == 192) {
      if (m = a(), _ = (g & 31) << 6 | m, _ >= 128)
        return _;
      throw Error("Invalid continuation byte");
    }
    if ((g & 240) == 224) {
      if (m = a(), v = a(), _ = (g & 15) << 12 | m << 6 | v, _ >= 2048)
        return r(_, h) ? _ : 65533;
      throw Error("Invalid continuation byte");
    }
    if ((g & 248) == 240 && (m = a(), v = a(), S = a(), _ = (g & 7) << 18 | m << 12 | v << 6 | S, _ >= 65536 && _ <= 1114111))
      return _;
    throw Error("Invalid UTF-8 detected");
  }
  var l, d, p;
  function f(h, g) {
    g = g || {};
    var m = g.strict !== !1;
    l = t(h), d = l.length, p = 0;
    for (var v = [], S; (S = u(m)) !== !1; )
      v.push(S);
    return n(v);
  }
  return qc = {
    version: "2.1.2",
    encode: s,
    decode: f
  }, qc;
}
var zs = {}, xg;
function hB() {
  return xg || (xg = 1, function(e) {
    zs.encode = function(t) {
      var n = new Uint8Array(t), r, o = n.length, i = "";
      for (r = 0; r < o; r += 3)
        i += e[n[r] >> 2], i += e[(n[r] & 3) << 4 | n[r + 1] >> 4], i += e[(n[r + 1] & 15) << 2 | n[r + 2] >> 6], i += e[n[r + 2] & 63];
      return o % 3 === 2 ? i = i.substring(0, i.length - 1) + "=" : o % 3 === 1 && (i = i.substring(0, i.length - 2) + "=="), i;
    }, zs.decode = function(t) {
      var n = t.length * 0.75, r = t.length, o, i = 0, s, a, u, l;
      t[t.length - 1] === "=" && (n--, t[t.length - 2] === "=" && n--);
      var d = new ArrayBuffer(n), p = new Uint8Array(d);
      for (o = 0; o < r; o += 4)
        s = e.indexOf(t[o]), a = e.indexOf(t[o + 1]), u = e.indexOf(t[o + 2]), l = e.indexOf(t[o + 3]), p[i++] = s << 2 | a >> 4, p[i++] = (a & 15) << 4 | u >> 2, p[i++] = (u & 3) << 6 | l & 63;
      return d;
    };
  }("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")), zs;
}
var Gc, Tg;
function mB() {
  if (Tg)
    return Gc;
  Tg = 1;
  var e = typeof e != "undefined" ? e : typeof WebKitBlobBuilder != "undefined" ? WebKitBlobBuilder : typeof MSBlobBuilder != "undefined" ? MSBlobBuilder : typeof MozBlobBuilder != "undefined" ? MozBlobBuilder : !1, t = function() {
    try {
      var a = new Blob(["hi"]);
      return a.size === 2;
    } catch (u) {
      return !1;
    }
  }(), n = t && function() {
    try {
      var a = new Blob([new Uint8Array([1, 2])]);
      return a.size === 2;
    } catch (u) {
      return !1;
    }
  }(), r = e && e.prototype.append && e.prototype.getBlob;
  function o(a) {
    return a.map(function(u) {
      if (u.buffer instanceof ArrayBuffer) {
        var l = u.buffer;
        if (u.byteLength !== l.byteLength) {
          var d = new Uint8Array(u.byteLength);
          d.set(new Uint8Array(l, u.byteOffset, u.byteLength)), l = d.buffer;
        }
        return l;
      }
      return u;
    });
  }
  function i(a, u) {
    u = u || {};
    var l = new e();
    return o(a).forEach(function(d) {
      l.append(d);
    }), u.type ? l.getBlob(u.type) : l.getBlob();
  }
  function s(a, u) {
    return new Blob(o(a), u || {});
  }
  return typeof Blob != "undefined" && (i.prototype = Blob.prototype, s.prototype = Blob.prototype), Gc = function() {
    return t ? n ? Blob : s : r ? i : void 0;
  }(), Gc;
}
var Eg;
function _o() {
  return Eg || (Eg = 1, function(e) {
    var t = cB(), n = tC(), r = dB(), o = pB(), i = fB(), s;
    typeof ArrayBuffer != "undefined" && (s = hB());
    var a = typeof navigator != "undefined" && /Android/i.test(navigator.userAgent), u = typeof navigator != "undefined" && /PhantomJS/i.test(navigator.userAgent), l = a || u;
    e.protocol = 3;
    var d = e.packets = {
      open: 0,
      close: 1,
      ping: 2,
      pong: 3,
      message: 4,
      upgrade: 5,
      noop: 6
    }, p = t(d), f = { type: "error", data: "parser error" }, h = mB();
    e.encodePacket = function(b, y, w, x) {
      typeof y == "function" && (x = y, y = !1), typeof w == "function" && (x = w, w = null);
      var P = b.data === void 0 ? void 0 : b.data.buffer || b.data;
      if (typeof ArrayBuffer != "undefined" && P instanceof ArrayBuffer)
        return m(b, y, x);
      if (typeof h != "undefined" && P instanceof h)
        return S(b, y, x);
      if (P && P.base64)
        return g(b, x);
      var N = d[b.type];
      return b.data !== void 0 && (N += w ? i.encode(String(b.data), { strict: !1 }) : String(b.data)), x("" + N);
    };
    function g(b, y) {
      var w = "b" + e.packets[b.type] + b.data.data;
      return y(w);
    }
    function m(b, y, w) {
      if (!y)
        return e.encodeBase64Packet(b, w);
      var x = b.data, P = new Uint8Array(x), N = new Uint8Array(1 + x.byteLength);
      N[0] = d[b.type];
      for (var M = 0; M < P.length; M++)
        N[M + 1] = P[M];
      return w(N.buffer);
    }
    function v(b, y, w) {
      if (!y)
        return e.encodeBase64Packet(b, w);
      var x = new FileReader();
      return x.onload = function() {
        e.encodePacket({ type: b.type, data: x.result }, y, !0, w);
      }, x.readAsArrayBuffer(b.data);
    }
    function S(b, y, w) {
      if (!y)
        return e.encodeBase64Packet(b, w);
      if (l)
        return v(b, y, w);
      var x = new Uint8Array(1);
      x[0] = d[b.type];
      var P = new h([x.buffer, b.data]);
      return w(P);
    }
    e.encodeBase64Packet = function(b, y) {
      var w = "b" + e.packets[b.type];
      if (typeof h != "undefined" && b.data instanceof h) {
        var x = new FileReader();
        return x.onload = function() {
          var T = x.result.split(",")[1];
          y(w + T);
        }, x.readAsDataURL(b.data);
      }
      var P;
      try {
        P = String.fromCharCode.apply(null, new Uint8Array(b.data));
      } catch (T) {
        for (var N = new Uint8Array(b.data), M = new Array(N.length), A = 0; A < N.length; A++)
          M[A] = N[A];
        P = String.fromCharCode.apply(null, M);
      }
      return w += btoa(P), y(w);
    }, e.decodePacket = function(b, y, w) {
      if (b === void 0)
        return f;
      if (typeof b == "string") {
        if (b.charAt(0) === "b")
          return e.decodeBase64Packet(b.substr(1), y);
        if (w && (b = _(b), b === !1))
          return f;
        var P = b.charAt(0);
        return Number(P) != P || !p[P] ? f : b.length > 1 ? { type: p[P], data: b.substring(1) } : { type: p[P] };
      }
      var x = new Uint8Array(b), P = x[0], N = r(b, 1);
      return h && y === "blob" && (N = new h([N])), { type: p[P], data: N };
    };
    function _(b) {
      try {
        b = i.decode(b, { strict: !1 });
      } catch (y) {
        return !1;
      }
      return b;
    }
    e.decodeBase64Packet = function(b, y) {
      var w = p[b.charAt(0)];
      if (!s)
        return { type: w, data: { base64: !0, data: b.substr(1) } };
      var x = s.decode(b.substr(1));
      return y === "blob" && h && (x = new h([x])), { type: w, data: x };
    }, e.encodePayload = function(b, y, w) {
      typeof y == "function" && (w = y, y = null);
      var x = n(b);
      if (y && x)
        return h && !l ? e.encodePayloadAsBlob(b, w) : e.encodePayloadAsArrayBuffer(b, w);
      if (!b.length)
        return w("0:");
      function P(M) {
        return M.length + ":" + M;
      }
      function N(M, A) {
        e.encodePacket(M, x ? y : !1, !1, function(T) {
          A(null, P(T));
        });
      }
      R(b, N, function(M, A) {
        return w(A.join(""));
      });
    };
    function R(b, y, w) {
      for (var x = new Array(b.length), P = o(b.length, w), N = function(A, T, D) {
        y(T, function(j, F) {
          x[A] = F, D(j, x);
        });
      }, M = 0; M < b.length; M++)
        N(M, b[M], P);
    }
    e.decodePayload = function(b, y, w) {
      if (typeof b != "string")
        return e.decodePayloadAsBinary(b, y, w);
      typeof y == "function" && (w = y, y = null);
      var x;
      if (b === "")
        return w(f, 0, 1);
      for (var P = "", N, M, A = 0, T = b.length; A < T; A++) {
        var D = b.charAt(A);
        if (D !== ":") {
          P += D;
          continue;
        }
        if (P === "" || P != (N = Number(P)) || (M = b.substr(A + 1, N), P != M.length))
          return w(f, 0, 1);
        if (M.length) {
          if (x = e.decodePacket(M, y, !1), f.type === x.type && f.data === x.data)
            return w(f, 0, 1);
          var j = w(x, A + N, T);
          if (j === !1)
            return;
        }
        A += N, P = "";
      }
      if (P !== "")
        return w(f, 0, 1);
    }, e.encodePayloadAsArrayBuffer = function(b, y) {
      if (!b.length)
        return y(new ArrayBuffer(0));
      function w(x, P) {
        e.encodePacket(x, !0, !0, function(N) {
          return P(null, N);
        });
      }
      R(b, w, function(x, P) {
        var N = P.reduce(function(T, D) {
          var j;
          return typeof D == "string" ? j = D.length : j = D.byteLength, T + j.toString().length + j + 2;
        }, 0), M = new Uint8Array(N), A = 0;
        return P.forEach(function(T) {
          var D = typeof T == "string", j = T;
          if (D) {
            for (var H = new Uint8Array(T.length), F = 0; F < T.length; F++)
              H[F] = T.charCodeAt(F);
            j = H.buffer;
          }
          D ? M[A++] = 0 : M[A++] = 1;
          for (var z = j.byteLength.toString(), F = 0; F < z.length; F++)
            M[A++] = parseInt(z[F]);
          M[A++] = 255;
          for (var H = new Uint8Array(j), F = 0; F < H.length; F++)
            M[A++] = H[F];
        }), y(M.buffer);
      });
    }, e.encodePayloadAsBlob = function(b, y) {
      function w(x, P) {
        e.encodePacket(x, !0, !0, function(N) {
          var M = new Uint8Array(1);
          if (M[0] = 1, typeof N == "string") {
            for (var A = new Uint8Array(N.length), T = 0; T < N.length; T++)
              A[T] = N.charCodeAt(T);
            N = A.buffer, M[0] = 0;
          }
          for (var D = N instanceof ArrayBuffer ? N.byteLength : N.size, j = D.toString(), F = new Uint8Array(j.length + 1), T = 0; T < j.length; T++)
            F[T] = parseInt(j[T]);
          if (F[j.length] = 255, h) {
            var z = new h([M.buffer, F.buffer, N]);
            P(null, z);
          }
        });
      }
      R(b, w, function(x, P) {
        return y(new h(P));
      });
    }, e.decodePayloadAsBinary = function(b, y, w) {
      typeof y == "function" && (w = y, y = null);
      for (var x = b, P = []; x.byteLength > 0; ) {
        for (var N = new Uint8Array(x), M = N[0] === 0, A = "", T = 1; N[T] !== 255; T++) {
          if (A.length > 310)
            return w(f, 0, 1);
          A += N[T];
        }
        x = r(x, 2 + A.length), A = parseInt(A);
        var D = r(x, 0, A);
        if (M)
          try {
            D = String.fromCharCode.apply(null, new Uint8Array(D));
          } catch (z) {
            var j = new Uint8Array(D);
            D = "";
            for (var T = 0; T < j.length; T++)
              D += String.fromCharCode(j[T]);
          }
        P.push(D), x = r(x, A);
      }
      var F = P.length;
      P.forEach(function(z, H) {
        w(e.decodePacket(z, y, !0), H, F);
      });
    };
  }(zc)), zc;
}
var Kc, Rg;
function yp() {
  if (Rg)
    return Kc;
  Rg = 1;
  var e = _o(), t = Io();
  Kc = n;
  function n(r) {
    this.path = r.path, this.hostname = r.hostname, this.port = r.port, this.secure = r.secure, this.query = r.query, this.timestampParam = r.timestampParam, this.timestampRequests = r.timestampRequests, this.readyState = "", this.agent = r.agent || !1, this.socket = r.socket, this.enablesXDR = r.enablesXDR, this.withCredentials = r.withCredentials, this.pfx = r.pfx, this.key = r.key, this.passphrase = r.passphrase, this.cert = r.cert, this.ca = r.ca, this.ciphers = r.ciphers, this.rejectUnauthorized = r.rejectUnauthorized, this.forceNode = r.forceNode, this.isReactNative = r.isReactNative, this.extraHeaders = r.extraHeaders, this.localAddress = r.localAddress;
  }
  return t(n.prototype), n.prototype.onError = function(r, o) {
    var i = new Error(r);
    return i.type = "TransportError", i.description = o, this.emit("error", i), this;
  }, n.prototype.open = function() {
    return (this.readyState === "closed" || this.readyState === "") && (this.readyState = "opening", this.doOpen()), this;
  }, n.prototype.close = function() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }, n.prototype.send = function(r) {
    if (this.readyState === "open")
      this.write(r);
    else
      throw new Error("Transport not open");
  }, n.prototype.onOpen = function() {
    this.readyState = "open", this.writable = !0, this.emit("open");
  }, n.prototype.onData = function(r) {
    var o = e.decodePacket(r, this.socket.binaryType);
    this.onPacket(o);
  }, n.prototype.onPacket = function(r) {
    this.emit("packet", r);
  }, n.prototype.onClose = function() {
    this.readyState = "closed", this.emit("close");
  }, Kc;
}
var js = {}, Og;
function vl() {
  return Og || (Og = 1, js.encode = function(e) {
    var t = "";
    for (var n in e)
      e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
    return t;
  }, js.decode = function(e) {
    for (var t = {}, n = e.split("&"), r = 0, o = n.length; r < o; r++) {
      var i = n[r].split("=");
      t[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
    }
    return t;
  }), js;
}
var Yc, Pg;
function bl() {
  return Pg || (Pg = 1, Yc = function(e, t) {
    var n = function() {
    };
    n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }), Yc;
}
var Xc, Ig;
function nC() {
  if (Ig)
    return Xc;
  Ig = 1;
  var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), t = 64, n = {}, r = 0, o = 0, i;
  function s(l) {
    var d = "";
    do
      d = e[l % t] + d, l = Math.floor(l / t);
    while (l > 0);
    return d;
  }
  function a(l) {
    var d = 0;
    for (o = 0; o < l.length; o++)
      d = d * t + n[l.charAt(o)];
    return d;
  }
  function u() {
    var l = s(+/* @__PURE__ */ new Date());
    return l !== i ? (r = 0, i = l) : l + "." + s(r++);
  }
  for (; o < t; o++)
    n[e[o]] = o;
  return u.encode = s, u.decode = a, Xc = u, Xc;
}
var Hs = { exports: {} }, Ws = { exports: {} }, Jc, Ng;
function gB() {
  if (Ng)
    return Jc;
  Ng = 1;
  var e = 1e3, t = e * 60, n = t * 60, r = n * 24, o = r * 365.25;
  Jc = function(l, d) {
    d = d || {};
    var p = typeof l;
    if (p === "string" && l.length > 0)
      return i(l);
    if (p === "number" && isNaN(l) === !1)
      return d.long ? a(l) : s(l);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(l)
    );
  };
  function i(l) {
    if (l = String(l), !(l.length > 100)) {
      var d = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        l
      );
      if (d) {
        var p = parseFloat(d[1]), f = (d[2] || "ms").toLowerCase();
        switch (f) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return p * o;
          case "days":
          case "day":
          case "d":
            return p * r;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return p * n;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return p * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return p * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return p;
          default:
            return;
        }
      }
    }
  }
  function s(l) {
    return l >= r ? Math.round(l / r) + "d" : l >= n ? Math.round(l / n) + "h" : l >= t ? Math.round(l / t) + "m" : l >= e ? Math.round(l / e) + "s" : l + "ms";
  }
  function a(l) {
    return u(l, r, "day") || u(l, n, "hour") || u(l, t, "minute") || u(l, e, "second") || l + " ms";
  }
  function u(l, d, p) {
    if (!(l < d))
      return l < d * 1.5 ? Math.floor(l / d) + " " + p : Math.ceil(l / d) + " " + p + "s";
  }
  return Jc;
}
var Mg;
function yB() {
  return Mg || (Mg = 1, function(e, t) {
    t = e.exports = r.debug = r.default = r, t.coerce = u, t.disable = s, t.enable = i, t.enabled = a, t.humanize = gB(), t.instances = [], t.names = [], t.skips = [], t.formatters = {};
    function n(l) {
      var d = 0, p;
      for (p in l)
        d = (d << 5) - d + l.charCodeAt(p), d |= 0;
      return t.colors[Math.abs(d) % t.colors.length];
    }
    function r(l) {
      var d;
      function p() {
        if (p.enabled) {
          var f = p, h = +/* @__PURE__ */ new Date(), g = h - (d || h);
          f.diff = g, f.prev = d, f.curr = h, d = h;
          for (var m = new Array(arguments.length), v = 0; v < m.length; v++)
            m[v] = arguments[v];
          m[0] = t.coerce(m[0]), typeof m[0] != "string" && m.unshift("%O");
          var S = 0;
          m[0] = m[0].replace(/%([a-zA-Z%])/g, function(R, b) {
            if (R === "%%")
              return R;
            S++;
            var y = t.formatters[b];
            if (typeof y == "function") {
              var w = m[S];
              R = y.call(f, w), m.splice(S, 1), S--;
            }
            return R;
          }), t.formatArgs.call(f, m);
          var _ = p.log || t.log || console.log.bind(console);
          _.apply(f, m);
        }
      }
      return p.namespace = l, p.enabled = t.enabled(l), p.useColors = t.useColors(), p.color = n(l), p.destroy = o, typeof t.init == "function" && t.init(p), t.instances.push(p), p;
    }
    function o() {
      var l = t.instances.indexOf(this);
      return l !== -1 ? (t.instances.splice(l, 1), !0) : !1;
    }
    function i(l) {
      t.save(l), t.names = [], t.skips = [];
      var d, p = (typeof l == "string" ? l : "").split(/[\s,]+/), f = p.length;
      for (d = 0; d < f; d++)
        p[d] && (l = p[d].replace(/\*/g, ".*?"), l[0] === "-" ? t.skips.push(new RegExp("^" + l.substr(1) + "$")) : t.names.push(new RegExp("^" + l + "$")));
      for (d = 0; d < t.instances.length; d++) {
        var h = t.instances[d];
        h.enabled = t.enabled(h.namespace);
      }
    }
    function s() {
      t.enable("");
    }
    function a(l) {
      if (l[l.length - 1] === "*")
        return !0;
      var d, p;
      for (d = 0, p = t.skips.length; d < p; d++)
        if (t.skips[d].test(l))
          return !1;
      for (d = 0, p = t.names.length; d < p; d++)
        if (t.names[d].test(l))
          return !0;
      return !1;
    }
    function u(l) {
      return l instanceof Error ? l.stack || l.message : l;
    }
  }(Ws, Ws.exports)), Ws.exports;
}
var kg;
function Cl() {
  return kg || (kg = 1, function(e, t) {
    t = e.exports = yB(), t.log = o, t.formatArgs = r, t.save = i, t.load = s, t.useColors = n, t.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : a(), t.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function n() {
      return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    t.formatters.j = function(u) {
      try {
        return JSON.stringify(u);
      } catch (l) {
        return "[UnexpectedJSONParseError]: " + l.message;
      }
    };
    function r(u) {
      var l = this.useColors;
      if (u[0] = (l ? "%c" : "") + this.namespace + (l ? " %c" : " ") + u[0] + (l ? "%c " : " ") + "+" + t.humanize(this.diff), !!l) {
        var d = "color: " + this.color;
        u.splice(1, 0, d, "color: inherit");
        var p = 0, f = 0;
        u[0].replace(/%[a-zA-Z%]/g, function(h) {
          h !== "%%" && (p++, h === "%c" && (f = p));
        }), u.splice(f, 0, d);
      }
    }
    function o() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function i(u) {
      try {
        u == null ? t.storage.removeItem("debug") : t.storage.debug = u;
      } catch (l) {
      }
    }
    function s() {
      var u;
      try {
        u = t.storage.debug;
      } catch (l) {
      }
      return !u && typeof process != "undefined" && "env" in process && (u = process.env.DEBUG), u;
    }
    t.enable(s());
    function a() {
      try {
        return window.localStorage;
      } catch (u) {
      }
    }
  }(Hs, Hs.exports)), Hs.exports;
}
var Qc, Ag;
function rC() {
  if (Ag)
    return Qc;
  Ag = 1;
  var e = yp(), t = vl(), n = _o(), r = bl(), o = nC(), i = Cl()("engine.io-client:polling");
  Qc = a;
  var s = function() {
    var u = gp(), l = new u({ xdomain: !1 });
    return l.responseType != null;
  }();
  function a(u) {
    var l = u && u.forceBase64;
    (!s || l) && (this.supportsBinary = !1), e.call(this, u);
  }
  return r(a, e), a.prototype.name = "polling", a.prototype.doOpen = function() {
    this.poll();
  }, a.prototype.pause = function(u) {
    var l = this;
    this.readyState = "pausing";
    function d() {
      i("paused"), l.readyState = "paused", u();
    }
    if (this.polling || !this.writable) {
      var p = 0;
      this.polling && (i("we are currently polling - waiting to pause"), p++, this.once("pollComplete", function() {
        i("pre-pause polling complete"), --p || d();
      })), this.writable || (i("we are currently writing - waiting to pause"), p++, this.once("drain", function() {
        i("pre-pause writing complete"), --p || d();
      }));
    } else
      d();
  }, a.prototype.poll = function() {
    i("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
  }, a.prototype.onData = function(u) {
    var l = this;
    i("polling got data %s", u);
    var d = function(p, f, h) {
      if (l.readyState === "opening" && p.type === "open" && l.onOpen(), p.type === "close")
        return l.onClose(), !1;
      l.onPacket(p);
    };
    n.decodePayload(u, this.socket.binaryType, d), this.readyState !== "closed" && (this.polling = !1, this.emit("pollComplete"), this.readyState === "open" ? this.poll() : i('ignoring poll - transport state "%s"', this.readyState));
  }, a.prototype.doClose = function() {
    var u = this;
    function l() {
      i("writing close packet"), u.write([{ type: "close" }]);
    }
    this.readyState === "open" ? (i("transport open - closing"), l()) : (i("transport not open - deferring close"), this.once("open", l));
  }, a.prototype.write = function(u) {
    var l = this;
    this.writable = !1;
    var d = function() {
      l.writable = !0, l.emit("drain");
    };
    n.encodePayload(u, this.supportsBinary, function(p) {
      l.doWrite(p, d);
    });
  }, a.prototype.uri = function() {
    var u = this.query || {}, l = this.secure ? "https" : "http", d = "";
    this.timestampRequests !== !1 && (u[this.timestampParam] = o()), !this.supportsBinary && !u.sid && (u.b64 = 1), u = t.encode(u), this.port && (l === "https" && Number(this.port) !== 443 || l === "http" && Number(this.port) !== 80) && (d = ":" + this.port), u.length && (u = "?" + u);
    var p = this.hostname.indexOf(":") !== -1;
    return l + "://" + (p ? "[" + this.hostname + "]" : this.hostname) + d + this.path + u;
  }, Qc;
}
var $g;
function vB() {
  if ($g)
    return Fs.exports;
  $g = 1;
  var e = gp(), t = rC(), n = Io(), r = bl(), o = Cl()("engine.io-client:polling-xhr"), i = mp();
  Fs.exports = a, Fs.exports.Request = u;
  function s() {
  }
  function a(p) {
    if (t.call(this, p), this.requestTimeout = p.requestTimeout, this.extraHeaders = p.extraHeaders, typeof location != "undefined") {
      var f = location.protocol === "https:", h = location.port;
      h || (h = f ? 443 : 80), this.xd = typeof location != "undefined" && p.hostname !== location.hostname || h !== p.port, this.xs = p.secure !== f;
    }
  }
  r(a, t), a.prototype.supportsBinary = !0, a.prototype.request = function(p) {
    return p = p || {}, p.uri = this.uri(), p.xd = this.xd, p.xs = this.xs, p.agent = this.agent || !1, p.supportsBinary = this.supportsBinary, p.enablesXDR = this.enablesXDR, p.withCredentials = this.withCredentials, p.pfx = this.pfx, p.key = this.key, p.passphrase = this.passphrase, p.cert = this.cert, p.ca = this.ca, p.ciphers = this.ciphers, p.rejectUnauthorized = this.rejectUnauthorized, p.requestTimeout = this.requestTimeout, p.extraHeaders = this.extraHeaders, new u(p);
  }, a.prototype.doWrite = function(p, f) {
    var h = typeof p != "string" && p !== void 0, g = this.request({ method: "POST", data: p, isBinary: h }), m = this;
    g.on("success", f), g.on("error", function(v) {
      m.onError("xhr post error", v);
    }), this.sendXhr = g;
  }, a.prototype.doPoll = function() {
    o("xhr poll");
    var p = this.request(), f = this;
    p.on("data", function(h) {
      f.onData(h);
    }), p.on("error", function(h) {
      f.onError("xhr poll error", h);
    }), this.pollXhr = p;
  };
  function u(p) {
    this.method = p.method || "GET", this.uri = p.uri, this.xd = !!p.xd, this.xs = !!p.xs, this.async = p.async !== !1, this.data = p.data !== void 0 ? p.data : null, this.agent = p.agent, this.isBinary = p.isBinary, this.supportsBinary = p.supportsBinary, this.enablesXDR = p.enablesXDR, this.withCredentials = p.withCredentials, this.requestTimeout = p.requestTimeout, this.pfx = p.pfx, this.key = p.key, this.passphrase = p.passphrase, this.cert = p.cert, this.ca = p.ca, this.ciphers = p.ciphers, this.rejectUnauthorized = p.rejectUnauthorized, this.extraHeaders = p.extraHeaders, this.create();
  }
  if (n(u.prototype), u.prototype.create = function() {
    var p = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
    p.pfx = this.pfx, p.key = this.key, p.passphrase = this.passphrase, p.cert = this.cert, p.ca = this.ca, p.ciphers = this.ciphers, p.rejectUnauthorized = this.rejectUnauthorized;
    var f = this.xhr = new e(p), h = this;
    try {
      o("xhr open %s: %s", this.method, this.uri), f.open(this.method, this.uri, this.async);
      try {
        if (this.extraHeaders) {
          f.setDisableHeaderCheck && f.setDisableHeaderCheck(!0);
          for (var g in this.extraHeaders)
            this.extraHeaders.hasOwnProperty(g) && f.setRequestHeader(g, this.extraHeaders[g]);
        }
      } catch (m) {
      }
      if (this.method === "POST")
        try {
          this.isBinary ? f.setRequestHeader("Content-type", "application/octet-stream") : f.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch (m) {
        }
      try {
        f.setRequestHeader("Accept", "*/*");
      } catch (m) {
      }
      "withCredentials" in f && (f.withCredentials = this.withCredentials), this.requestTimeout && (f.timeout = this.requestTimeout), this.hasXDR() ? (f.onload = function() {
        h.onLoad();
      }, f.onerror = function() {
        h.onError(f.responseText);
      }) : f.onreadystatechange = function() {
        if (f.readyState === 2)
          try {
            var m = f.getResponseHeader("Content-Type");
            (h.supportsBinary && m === "application/octet-stream" || m === "application/octet-stream; charset=UTF-8") && (f.responseType = "arraybuffer");
          } catch (v) {
          }
        f.readyState === 4 && (f.status === 200 || f.status === 1223 ? h.onLoad() : setTimeout(function() {
          h.onError(typeof f.status == "number" ? f.status : 0);
        }, 0));
      }, o("xhr data %s", this.data), f.send(this.data);
    } catch (m) {
      setTimeout(function() {
        h.onError(m);
      }, 0);
      return;
    }
    typeof document != "undefined" && (this.index = u.requestsCount++, u.requests[this.index] = this);
  }, u.prototype.onSuccess = function() {
    this.emit("success"), this.cleanup();
  }, u.prototype.onData = function(p) {
    this.emit("data", p), this.onSuccess();
  }, u.prototype.onError = function(p) {
    this.emit("error", p), this.cleanup(!0);
  }, u.prototype.cleanup = function(p) {
    if (!(typeof this.xhr == "undefined" || this.xhr === null)) {
      if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = s : this.xhr.onreadystatechange = s, p)
        try {
          this.xhr.abort();
        } catch (f) {
        }
      typeof document != "undefined" && delete u.requests[this.index], this.xhr = null;
    }
  }, u.prototype.onLoad = function() {
    var p;
    try {
      var f;
      try {
        f = this.xhr.getResponseHeader("Content-Type");
      } catch (h) {
      }
      f === "application/octet-stream" || f === "application/octet-stream; charset=UTF-8" ? p = this.xhr.response || this.xhr.responseText : p = this.xhr.responseText;
    } catch (h) {
      this.onError(h);
    }
    p != null && this.onData(p);
  }, u.prototype.hasXDR = function() {
    return typeof XDomainRequest != "undefined" && !this.xs && this.enablesXDR;
  }, u.prototype.abort = function() {
    this.cleanup();
  }, u.requestsCount = 0, u.requests = {}, typeof document != "undefined") {
    if (typeof attachEvent == "function")
      attachEvent("onunload", d);
    else if (typeof addEventListener == "function") {
      var l = "onpagehide" in i ? "pagehide" : "unload";
      addEventListener(l, d, !1);
    }
  }
  function d() {
    for (var p in u.requests)
      u.requests.hasOwnProperty(p) && u.requests[p].abort();
  }
  return Fs.exports;
}
var Zc, Lg;
function bB() {
  if (Lg)
    return Zc;
  Lg = 1;
  var e = rC(), t = bl(), n = mp();
  Zc = a;
  var r = /\n/g, o = /\\n/g, i;
  function s() {
  }
  function a(u) {
    e.call(this, u), this.query = this.query || {}, i || (i = n.___eio = n.___eio || []), this.index = i.length;
    var l = this;
    i.push(function(d) {
      l.onData(d);
    }), this.query.j = this.index, typeof addEventListener == "function" && addEventListener("beforeunload", function() {
      l.script && (l.script.onerror = s);
    }, !1);
  }
  return t(a, e), a.prototype.supportsBinary = !1, a.prototype.doClose = function() {
    this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), e.prototype.doClose.call(this);
  }, a.prototype.doPoll = function() {
    var u = this, l = document.createElement("script");
    this.script && (this.script.parentNode.removeChild(this.script), this.script = null), l.async = !0, l.src = this.uri(), l.onerror = function(f) {
      u.onError("jsonp poll error", f);
    };
    var d = document.getElementsByTagName("script")[0];
    d ? d.parentNode.insertBefore(l, d) : (document.head || document.body).appendChild(l), this.script = l;
    var p = typeof navigator != "undefined" && /gecko/i.test(navigator.userAgent);
    p && setTimeout(function() {
      var f = document.createElement("iframe");
      document.body.appendChild(f), document.body.removeChild(f);
    }, 100);
  }, a.prototype.doWrite = function(u, l) {
    var d = this;
    if (!this.form) {
      var p = document.createElement("form"), f = document.createElement("textarea"), h = this.iframeId = "eio_iframe_" + this.index, g;
      p.className = "socketio", p.style.position = "absolute", p.style.top = "-1000px", p.style.left = "-1000px", p.target = h, p.method = "POST", p.setAttribute("accept-charset", "utf-8"), f.name = "d", p.appendChild(f), document.body.appendChild(p), this.form = p, this.area = f;
    }
    this.form.action = this.uri();
    function m() {
      v(), l();
    }
    function v() {
      if (d.iframe)
        try {
          d.form.removeChild(d.iframe);
        } catch (_) {
          d.onError("jsonp polling iframe removal error", _);
        }
      try {
        var S = '<iframe src="javascript:0" name="' + d.iframeId + '">';
        g = document.createElement(S);
      } catch (_) {
        g = document.createElement("iframe"), g.name = d.iframeId, g.src = "javascript:0";
      }
      g.id = d.iframeId, d.form.appendChild(g), d.iframe = g;
    }
    v(), u = u.replace(o, `\\
`), this.area.value = u.replace(r, "\\n");
    try {
      this.form.submit();
    } catch (S) {
    }
    this.iframe.attachEvent ? this.iframe.onreadystatechange = function() {
      d.iframe.readyState === "complete" && m();
    } : this.iframe.onload = m;
  }, Zc;
}
const CB = {}, SB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CB
}, Symbol.toStringTag, { value: "Module" })), wB = /* @__PURE__ */ eS(SB);
var eu, Dg;
function _B() {
  if (Dg)
    return eu;
  Dg = 1;
  var e = yp(), t = _o(), n = vl(), r = bl(), o = nC(), i = Cl()("engine.io-client:websocket"), s, a;
  if (typeof WebSocket != "undefined" ? s = WebSocket : typeof self != "undefined" && (s = self.WebSocket || self.MozWebSocket), typeof window == "undefined")
    try {
      a = wB;
    } catch (d) {
    }
  var u = s || a;
  eu = l;
  function l(d) {
    var p = d && d.forceBase64;
    p && (this.supportsBinary = !1), this.perMessageDeflate = d.perMessageDeflate, this.usingBrowserWebSocket = s && !d.forceNode, this.protocols = d.protocols, this.usingBrowserWebSocket || (u = a), e.call(this, d);
  }
  return r(l, e), l.prototype.name = "websocket", l.prototype.supportsBinary = !0, l.prototype.doOpen = function() {
    if (this.check()) {
      var d = this.uri(), p = this.protocols, f = {};
      this.isReactNative || (f.agent = this.agent, f.perMessageDeflate = this.perMessageDeflate, f.pfx = this.pfx, f.key = this.key, f.passphrase = this.passphrase, f.cert = this.cert, f.ca = this.ca, f.ciphers = this.ciphers, f.rejectUnauthorized = this.rejectUnauthorized), this.extraHeaders && (f.headers = this.extraHeaders), this.localAddress && (f.localAddress = this.localAddress);
      try {
        this.ws = this.usingBrowserWebSocket && !this.isReactNative ? p ? new u(d, p) : new u(d) : new u(d, p, f);
      } catch (h) {
        return this.emit("error", h);
      }
      this.ws.binaryType === void 0 && (this.supportsBinary = !1), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = !0, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
    }
  }, l.prototype.addEventListeners = function() {
    var d = this;
    this.ws.onopen = function() {
      d.onOpen();
    }, this.ws.onclose = function() {
      d.onClose();
    }, this.ws.onmessage = function(p) {
      d.onData(p.data);
    }, this.ws.onerror = function(p) {
      d.onError("websocket error", p);
    };
  }, l.prototype.write = function(d) {
    var p = this;
    this.writable = !1;
    for (var f = d.length, h = 0, g = f; h < g; h++)
      (function(v) {
        t.encodePacket(v, p.supportsBinary, function(S) {
          if (!p.usingBrowserWebSocket) {
            var _ = {};
            if (v.options && (_.compress = v.options.compress), p.perMessageDeflate) {
              var R = typeof S == "string" ? Buffer.byteLength(S) : S.length;
              R < p.perMessageDeflate.threshold && (_.compress = !1);
            }
          }
          try {
            p.usingBrowserWebSocket ? p.ws.send(S) : p.ws.send(S, _);
          } catch (b) {
            i("websocket closed before onclose event");
          }
          --f || m();
        });
      })(d[h]);
    function m() {
      p.emit("flush"), setTimeout(function() {
        p.writable = !0, p.emit("drain");
      }, 0);
    }
  }, l.prototype.onClose = function() {
    e.prototype.onClose.call(this);
  }, l.prototype.doClose = function() {
    typeof this.ws != "undefined" && this.ws.close();
  }, l.prototype.uri = function() {
    var d = this.query || {}, p = this.secure ? "wss" : "ws", f = "";
    this.port && (p === "wss" && Number(this.port) !== 443 || p === "ws" && Number(this.port) !== 80) && (f = ":" + this.port), this.timestampRequests && (d[this.timestampParam] = o()), this.supportsBinary || (d.b64 = 1), d = n.encode(d), d.length && (d = "?" + d);
    var h = this.hostname.indexOf(":") !== -1;
    return p + "://" + (h ? "[" + this.hostname + "]" : this.hostname) + f + this.path + d;
  }, l.prototype.check = function() {
    return !!u && !("__initialize" in u && this.name === l.prototype.name);
  }, eu;
}
var Bg;
function Fg() {
  if (Bg)
    return Ds;
  Bg = 1;
  var e = gp(), t = vB(), n = bB(), r = _B();
  Ds.polling = o, Ds.websocket = r;
  function o(i) {
    var s, a = !1, u = !1, l = i.jsonp !== !1;
    if (typeof location != "undefined") {
      var d = location.protocol === "https:", p = location.port;
      p || (p = d ? 443 : 80), a = i.hostname !== location.hostname || p !== i.port, u = i.secure !== d;
    }
    if (i.xdomain = a, i.xscheme = u, s = new e(i), "open" in s && !i.forceJSONP)
      return new t(i);
    if (!l)
      throw new Error("JSONP disabled");
    return new n(i);
  }
  return Ds;
}
var tu, zg;
function oC() {
  if (zg)
    return tu;
  zg = 1;
  var e = [].indexOf;
  return tu = function(t, n) {
    if (e)
      return t.indexOf(n);
    for (var r = 0; r < t.length; ++r)
      if (t[r] === n)
        return r;
    return -1;
  }, tu;
}
var nu, jg;
function xB() {
  if (jg)
    return nu;
  jg = 1;
  var e = Fg(), t = Io(), n = Cl()("engine.io-client:socket"), r = oC(), o = _o(), i = Q0(), s = vl();
  nu = a;
  function a(l, d) {
    if (!(this instanceof a))
      return new a(l, d);
    d = d || {}, l && typeof l == "object" && (d = l, l = null), l ? (l = i(l), d.hostname = l.host, d.secure = l.protocol === "https" || l.protocol === "wss", d.port = l.port, l.query && (d.query = l.query)) : d.host && (d.hostname = i(d.host).host), this.secure = d.secure != null ? d.secure : typeof location != "undefined" && location.protocol === "https:", d.hostname && !d.port && (d.port = this.secure ? "443" : "80"), this.agent = d.agent || !1, this.hostname = d.hostname || (typeof location != "undefined" ? location.hostname : "localhost"), this.port = d.port || (typeof location != "undefined" && location.port ? location.port : this.secure ? 443 : 80), this.query = d.query || {}, typeof this.query == "string" && (this.query = s.decode(this.query)), this.upgrade = d.upgrade !== !1, this.path = (d.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!d.forceJSONP, this.jsonp = d.jsonp !== !1, this.forceBase64 = !!d.forceBase64, this.enablesXDR = !!d.enablesXDR, this.withCredentials = d.withCredentials !== !1, this.timestampParam = d.timestampParam || "t", this.timestampRequests = d.timestampRequests, this.transports = d.transports || ["polling", "websocket"], this.transportOptions = d.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = d.policyPort || 843, this.rememberUpgrade = d.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = d.onlyBinaryUpgrades, this.perMessageDeflate = d.perMessageDeflate !== !1 ? d.perMessageDeflate || {} : !1, this.perMessageDeflate === !0 && (this.perMessageDeflate = {}), this.perMessageDeflate && this.perMessageDeflate.threshold == null && (this.perMessageDeflate.threshold = 1024), this.pfx = d.pfx || void 0, this.key = d.key || void 0, this.passphrase = d.passphrase || void 0, this.cert = d.cert || void 0, this.ca = d.ca || void 0, this.ciphers = d.ciphers || void 0, this.rejectUnauthorized = d.rejectUnauthorized === void 0 ? !0 : d.rejectUnauthorized, this.forceNode = !!d.forceNode, this.isReactNative = typeof navigator != "undefined" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", (typeof self == "undefined" || this.isReactNative) && (d.extraHeaders && Object.keys(d.extraHeaders).length > 0 && (this.extraHeaders = d.extraHeaders), d.localAddress && (this.localAddress = d.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, this.open();
  }
  a.priorWebsocketSuccess = !1, t(a.prototype), a.protocol = o.protocol, a.Socket = a, a.Transport = yp(), a.transports = Fg(), a.parser = _o(), a.prototype.createTransport = function(l) {
    n('creating transport "%s"', l);
    var d = u(this.query);
    d.EIO = o.protocol, d.transport = l;
    var p = this.transportOptions[l] || {};
    this.id && (d.sid = this.id);
    var f = new e[l]({
      query: d,
      socket: this,
      agent: p.agent || this.agent,
      hostname: p.hostname || this.hostname,
      port: p.port || this.port,
      secure: p.secure || this.secure,
      path: p.path || this.path,
      forceJSONP: p.forceJSONP || this.forceJSONP,
      jsonp: p.jsonp || this.jsonp,
      forceBase64: p.forceBase64 || this.forceBase64,
      enablesXDR: p.enablesXDR || this.enablesXDR,
      withCredentials: p.withCredentials || this.withCredentials,
      timestampRequests: p.timestampRequests || this.timestampRequests,
      timestampParam: p.timestampParam || this.timestampParam,
      policyPort: p.policyPort || this.policyPort,
      pfx: p.pfx || this.pfx,
      key: p.key || this.key,
      passphrase: p.passphrase || this.passphrase,
      cert: p.cert || this.cert,
      ca: p.ca || this.ca,
      ciphers: p.ciphers || this.ciphers,
      rejectUnauthorized: p.rejectUnauthorized || this.rejectUnauthorized,
      perMessageDeflate: p.perMessageDeflate || this.perMessageDeflate,
      extraHeaders: p.extraHeaders || this.extraHeaders,
      forceNode: p.forceNode || this.forceNode,
      localAddress: p.localAddress || this.localAddress,
      requestTimeout: p.requestTimeout || this.requestTimeout,
      protocols: p.protocols || void 0,
      isReactNative: this.isReactNative
    });
    return f;
  };
  function u(l) {
    var d = {};
    for (var p in l)
      l.hasOwnProperty(p) && (d[p] = l[p]);
    return d;
  }
  return a.prototype.open = function() {
    var l;
    if (this.rememberUpgrade && a.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
      l = "websocket";
    else if (this.transports.length === 0) {
      var d = this;
      setTimeout(function() {
        d.emit("error", "No transports available");
      }, 0);
      return;
    } else
      l = this.transports[0];
    this.readyState = "opening";
    try {
      l = this.createTransport(l);
    } catch (p) {
      this.transports.shift(), this.open();
      return;
    }
    l.open(), this.setTransport(l);
  }, a.prototype.setTransport = function(l) {
    n("setting transport %s", l.name);
    var d = this;
    this.transport && (n("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = l, l.on("drain", function() {
      d.onDrain();
    }).on("packet", function(p) {
      d.onPacket(p);
    }).on("error", function(p) {
      d.onError(p);
    }).on("close", function() {
      d.onClose("transport close");
    });
  }, a.prototype.probe = function(l) {
    n('probing transport "%s"', l);
    var d = this.createTransport(l, { probe: 1 }), p = !1, f = this;
    a.priorWebsocketSuccess = !1;
    function h() {
      if (f.onlyBinaryUpgrades) {
        var b = !this.supportsBinary && f.transport.supportsBinary;
        p = p || b;
      }
      p || (n('probe transport "%s" opened', l), d.send([{ type: "ping", data: "probe" }]), d.once("packet", function(y) {
        if (!p)
          if (y.type === "pong" && y.data === "probe") {
            if (n('probe transport "%s" pong', l), f.upgrading = !0, f.emit("upgrading", d), !d)
              return;
            a.priorWebsocketSuccess = d.name === "websocket", n('pausing current transport "%s"', f.transport.name), f.transport.pause(function() {
              p || f.readyState !== "closed" && (n("changing transport and sending upgrade packet"), R(), f.setTransport(d), d.send([{ type: "upgrade" }]), f.emit("upgrade", d), d = null, f.upgrading = !1, f.flush());
            });
          } else {
            n('probe transport "%s" failed', l);
            var w = new Error("probe error");
            w.transport = d.name, f.emit("upgradeError", w);
          }
      }));
    }
    function g() {
      p || (p = !0, R(), d.close(), d = null);
    }
    function m(b) {
      var y = new Error("probe error: " + b);
      y.transport = d.name, g(), n('probe transport "%s" failed because of error: %s', l, b), f.emit("upgradeError", y);
    }
    function v() {
      m("transport closed");
    }
    function S() {
      m("socket closed");
    }
    function _(b) {
      d && b.name !== d.name && (n('"%s" works - aborting "%s"', b.name, d.name), g());
    }
    function R() {
      d.removeListener("open", h), d.removeListener("error", m), d.removeListener("close", v), f.removeListener("close", S), f.removeListener("upgrading", _);
    }
    d.once("open", h), d.once("error", m), d.once("close", v), this.once("close", S), this.once("upgrading", _), d.open();
  }, a.prototype.onOpen = function() {
    if (n("socket open"), this.readyState = "open", a.priorWebsocketSuccess = this.transport.name === "websocket", this.emit("open"), this.flush(), this.readyState === "open" && this.upgrade && this.transport.pause) {
      n("starting upgrade probes");
      for (var l = 0, d = this.upgrades.length; l < d; l++)
        this.probe(this.upgrades[l]);
    }
  }, a.prototype.onPacket = function(l) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (n('socket receive: type "%s", data "%s"', l.type, l.data), this.emit("packet", l), this.emit("heartbeat"), l.type) {
        case "open":
          this.onHandshake(JSON.parse(l.data));
          break;
        case "pong":
          this.setPing(), this.emit("pong");
          break;
        case "error":
          var d = new Error("server error");
          d.code = l.data, this.onError(d);
          break;
        case "message":
          this.emit("data", l.data), this.emit("message", l.data);
          break;
      }
    else
      n('packet received with socket readyState "%s"', this.readyState);
  }, a.prototype.onHandshake = function(l) {
    this.emit("handshake", l), this.id = l.sid, this.transport.query.sid = l.sid, this.upgrades = this.filterUpgrades(l.upgrades), this.pingInterval = l.pingInterval, this.pingTimeout = l.pingTimeout, this.onOpen(), this.readyState !== "closed" && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
  }, a.prototype.onHeartbeat = function(l) {
    clearTimeout(this.pingTimeoutTimer);
    var d = this;
    d.pingTimeoutTimer = setTimeout(function() {
      d.readyState !== "closed" && d.onClose("ping timeout");
    }, l || d.pingInterval + d.pingTimeout);
  }, a.prototype.setPing = function() {
    var l = this;
    clearTimeout(l.pingIntervalTimer), l.pingIntervalTimer = setTimeout(function() {
      n("writing ping packet - expecting pong within %sms", l.pingTimeout), l.ping(), l.onHeartbeat(l.pingTimeout);
    }, l.pingInterval);
  }, a.prototype.ping = function() {
    var l = this;
    this.sendPacket("ping", function() {
      l.emit("ping");
    });
  }, a.prototype.onDrain = function() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emit("drain") : this.flush();
  }, a.prototype.flush = function() {
    this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length && (n("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
  }, a.prototype.write = a.prototype.send = function(l, d, p) {
    return this.sendPacket("message", l, d, p), this;
  }, a.prototype.sendPacket = function(l, d, p, f) {
    if (typeof d == "function" && (f = d, d = void 0), typeof p == "function" && (f = p, p = null), !(this.readyState === "closing" || this.readyState === "closed")) {
      p = p || {}, p.compress = p.compress !== !1;
      var h = {
        type: l,
        data: d,
        options: p
      };
      this.emit("packetCreate", h), this.writeBuffer.push(h), f && this.once("flush", f), this.flush();
    }
  }, a.prototype.close = function() {
    if (this.readyState === "opening" || this.readyState === "open") {
      this.readyState = "closing";
      var l = this;
      this.writeBuffer.length ? this.once("drain", function() {
        this.upgrading ? f() : d();
      }) : this.upgrading ? f() : d();
    }
    function d() {
      l.onClose("forced close"), n("socket closing - telling transport to close"), l.transport.close();
    }
    function p() {
      l.removeListener("upgrade", p), l.removeListener("upgradeError", p), d();
    }
    function f() {
      l.once("upgrade", p), l.once("upgradeError", p);
    }
    return this;
  }, a.prototype.onError = function(l) {
    n("socket error %j", l), a.priorWebsocketSuccess = !1, this.emit("error", l), this.onClose("transport error", l);
  }, a.prototype.onClose = function(l, d) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      n('socket close with reason: "%s"', l);
      var p = this;
      clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", l, d), p.writeBuffer = [], p.prevBufferLen = 0;
    }
  }, a.prototype.filterUpgrades = function(l) {
    for (var d = [], p = 0, f = l.length; p < f; p++)
      ~r(this.transports, l[p]) && d.push(l[p]);
    return d;
  }, nu;
}
var Hg;
function TB() {
  return Hg || (Hg = 1, Ls.exports = xB(), Ls.exports.parser = _o()), Ls.exports;
}
var ru = { exports: {} }, ou, Wg;
function EB() {
  if (Wg)
    return ou;
  Wg = 1, ou = e;
  function e(t, n) {
    var r = [];
    n = n || 0;
    for (var o = n || 0; o < t.length; o++)
      r[o - n] = t[o];
    return r;
  }
  return ou;
}
var iu, Vg;
function iC() {
  if (Vg)
    return iu;
  Vg = 1, iu = e;
  function e(t, n, r) {
    return t.on(n, r), {
      destroy: function() {
        t.removeListener(n, r);
      }
    };
  }
  return iu;
}
var su, Ug;
function sC() {
  if (Ug)
    return su;
  Ug = 1;
  var e = [].slice;
  return su = function(t, n) {
    if (typeof n == "string" && (n = t[n]), typeof n != "function")
      throw new Error("bind() requires a function");
    var r = e.call(arguments, 2);
    return function() {
      return n.apply(t, r.concat(e.call(arguments)));
    };
  }, su;
}
var qg;
function aC() {
  return qg || (qg = 1, function(e, t) {
    var n = hp(), r = Io(), o = EB(), i = iC(), s = sC(), a = yl()("socket.io-client:socket"), u = vl(), l = tC();
    e.exports = f;
    var d = {
      connect: 1,
      connect_error: 1,
      connect_timeout: 1,
      connecting: 1,
      disconnect: 1,
      error: 1,
      reconnect: 1,
      reconnect_attempt: 1,
      reconnect_failed: 1,
      reconnect_error: 1,
      reconnecting: 1,
      ping: 1,
      pong: 1
    }, p = r.prototype.emit;
    function f(h, g, m) {
      this.io = h, this.nsp = g, this.json = this, this.ids = 0, this.acks = {}, this.receiveBuffer = [], this.sendBuffer = [], this.connected = !1, this.disconnected = !0, this.flags = {}, m && m.query && (this.query = m.query), this.io.autoConnect && this.open();
    }
    r(f.prototype), f.prototype.subEvents = function() {
      if (!this.subs) {
        var h = this.io;
        this.subs = [
          i(h, "open", s(this, "onopen")),
          i(h, "packet", s(this, "onpacket")),
          i(h, "close", s(this, "onclose"))
        ];
      }
    }, f.prototype.open = f.prototype.connect = function() {
      return this.connected ? this : (this.subEvents(), this.io.reconnecting || this.io.open(), this.io.readyState === "open" && this.onopen(), this.emit("connecting"), this);
    }, f.prototype.send = function() {
      var h = o(arguments);
      return h.unshift("message"), this.emit.apply(this, h), this;
    }, f.prototype.emit = function(h) {
      if (d.hasOwnProperty(h))
        return p.apply(this, arguments), this;
      var g = o(arguments), m = {
        type: (this.flags.binary !== void 0 ? this.flags.binary : l(g)) ? n.BINARY_EVENT : n.EVENT,
        data: g
      };
      return m.options = {}, m.options.compress = !this.flags || this.flags.compress !== !1, typeof g[g.length - 1] == "function" && (a("emitting packet with ack id %d", this.ids), this.acks[this.ids] = g.pop(), m.id = this.ids++), this.connected ? this.packet(m) : this.sendBuffer.push(m), this.flags = {}, this;
    }, f.prototype.packet = function(h) {
      h.nsp = this.nsp, this.io.packet(h);
    }, f.prototype.onopen = function() {
      if (a("transport is open - connecting"), this.nsp !== "/")
        if (this.query) {
          var h = typeof this.query == "object" ? u.encode(this.query) : this.query;
          a("sending connect packet with query %s", h), this.packet({ type: n.CONNECT, query: h });
        } else
          this.packet({ type: n.CONNECT });
    }, f.prototype.onclose = function(h) {
      a("close (%s)", h), this.connected = !1, this.disconnected = !0, delete this.id, this.emit("disconnect", h);
    }, f.prototype.onpacket = function(h) {
      var g = h.nsp === this.nsp, m = h.type === n.ERROR && h.nsp === "/";
      if (!(!g && !m))
        switch (h.type) {
          case n.CONNECT:
            this.onconnect();
            break;
          case n.EVENT:
            this.onevent(h);
            break;
          case n.BINARY_EVENT:
            this.onevent(h);
            break;
          case n.ACK:
            this.onack(h);
            break;
          case n.BINARY_ACK:
            this.onack(h);
            break;
          case n.DISCONNECT:
            this.ondisconnect();
            break;
          case n.ERROR:
            this.emit("error", h.data);
            break;
        }
    }, f.prototype.onevent = function(h) {
      var g = h.data || [];
      a("emitting event %j", g), h.id != null && (a("attaching ack callback to event"), g.push(this.ack(h.id))), this.connected ? p.apply(this, g) : this.receiveBuffer.push(g);
    }, f.prototype.ack = function(h) {
      var g = this, m = !1;
      return function() {
        if (!m) {
          m = !0;
          var v = o(arguments);
          a("sending ack %j", v), g.packet({
            type: l(v) ? n.BINARY_ACK : n.ACK,
            id: h,
            data: v
          });
        }
      };
    }, f.prototype.onack = function(h) {
      var g = this.acks[h.id];
      typeof g == "function" ? (a("calling ack %s with %j", h.id, h.data), g.apply(this, h.data), delete this.acks[h.id]) : a("bad ack %s", h.id);
    }, f.prototype.onconnect = function() {
      this.connected = !0, this.disconnected = !1, this.emitBuffered(), this.emit("connect");
    }, f.prototype.emitBuffered = function() {
      var h;
      for (h = 0; h < this.receiveBuffer.length; h++)
        p.apply(this, this.receiveBuffer[h]);
      for (this.receiveBuffer = [], h = 0; h < this.sendBuffer.length; h++)
        this.packet(this.sendBuffer[h]);
      this.sendBuffer = [];
    }, f.prototype.ondisconnect = function() {
      a("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
    }, f.prototype.destroy = function() {
      if (this.subs) {
        for (var h = 0; h < this.subs.length; h++)
          this.subs[h].destroy();
        this.subs = null;
      }
      this.io.destroy(this);
    }, f.prototype.close = f.prototype.disconnect = function() {
      return this.connected && (a("performing disconnect (%s)", this.nsp), this.packet({ type: n.DISCONNECT })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
    }, f.prototype.compress = function(h) {
      return this.flags.compress = h, this;
    }, f.prototype.binary = function(h) {
      return this.flags.binary = h, this;
    };
  }(ru)), ru.exports;
}
var au, Gg;
function RB() {
  if (Gg)
    return au;
  Gg = 1, au = e;
  function e(t) {
    t = t || {}, this.ms = t.min || 100, this.max = t.max || 1e4, this.factor = t.factor || 2, this.jitter = t.jitter > 0 && t.jitter <= 1 ? t.jitter : 0, this.attempts = 0;
  }
  return e.prototype.duration = function() {
    var t = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
      var n = Math.random(), r = Math.floor(n * this.jitter * t);
      t = Math.floor(n * 10) & 1 ? t + r : t - r;
    }
    return Math.min(t, this.max) | 0;
  }, e.prototype.reset = function() {
    this.attempts = 0;
  }, e.prototype.setMin = function(t) {
    this.ms = t;
  }, e.prototype.setMax = function(t) {
    this.max = t;
  }, e.prototype.setJitter = function(t) {
    this.jitter = t;
  }, au;
}
var lu, Kg;
function Yg() {
  if (Kg)
    return lu;
  Kg = 1;
  var e = TB(), t = aC(), n = Io(), r = hp(), o = iC(), i = sC(), s = yl()("socket.io-client:manager"), a = oC(), u = RB(), l = Object.prototype.hasOwnProperty;
  lu = d;
  function d(p, f) {
    if (!(this instanceof d))
      return new d(p, f);
    p && typeof p == "object" && (f = p, p = void 0), f = f || {}, f.path = f.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = f, this.reconnection(f.reconnection !== !1), this.reconnectionAttempts(f.reconnectionAttempts || 1 / 0), this.reconnectionDelay(f.reconnectionDelay || 1e3), this.reconnectionDelayMax(f.reconnectionDelayMax || 5e3), this.randomizationFactor(f.randomizationFactor || 0.5), this.backoff = new u({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(f.timeout == null ? 2e4 : f.timeout), this.readyState = "closed", this.uri = p, this.connecting = [], this.lastPing = null, this.encoding = !1, this.packetBuffer = [];
    var h = f.parser || r;
    this.encoder = new h.Encoder(), this.decoder = new h.Decoder(), this.autoConnect = f.autoConnect !== !1, this.autoConnect && this.open();
  }
  return d.prototype.emitAll = function() {
    this.emit.apply(this, arguments);
    for (var p in this.nsps)
      l.call(this.nsps, p) && this.nsps[p].emit.apply(this.nsps[p], arguments);
  }, d.prototype.updateSocketIds = function() {
    for (var p in this.nsps)
      l.call(this.nsps, p) && (this.nsps[p].id = this.generateId(p));
  }, d.prototype.generateId = function(p) {
    return (p === "/" ? "" : p + "#") + this.engine.id;
  }, n(d.prototype), d.prototype.reconnection = function(p) {
    return arguments.length ? (this._reconnection = !!p, this) : this._reconnection;
  }, d.prototype.reconnectionAttempts = function(p) {
    return arguments.length ? (this._reconnectionAttempts = p, this) : this._reconnectionAttempts;
  }, d.prototype.reconnectionDelay = function(p) {
    return arguments.length ? (this._reconnectionDelay = p, this.backoff && this.backoff.setMin(p), this) : this._reconnectionDelay;
  }, d.prototype.randomizationFactor = function(p) {
    return arguments.length ? (this._randomizationFactor = p, this.backoff && this.backoff.setJitter(p), this) : this._randomizationFactor;
  }, d.prototype.reconnectionDelayMax = function(p) {
    return arguments.length ? (this._reconnectionDelayMax = p, this.backoff && this.backoff.setMax(p), this) : this._reconnectionDelayMax;
  }, d.prototype.timeout = function(p) {
    return arguments.length ? (this._timeout = p, this) : this._timeout;
  }, d.prototype.maybeReconnectOnOpen = function() {
    !this.reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }, d.prototype.open = d.prototype.connect = function(p, f) {
    if (s("readyState %s", this.readyState), ~this.readyState.indexOf("open"))
      return this;
    s("opening %s", this.uri), this.engine = e(this.uri, this.opts);
    var h = this.engine, g = this;
    this.readyState = "opening", this.skipReconnect = !1;
    var m = o(h, "open", function() {
      g.onopen(), p && p();
    }), v = o(h, "error", function(R) {
      if (s("connect_error"), g.cleanup(), g.readyState = "closed", g.emitAll("connect_error", R), p) {
        var b = new Error("Connection error");
        b.data = R, p(b);
      } else
        g.maybeReconnectOnOpen();
    });
    if (this._timeout !== !1) {
      var S = this._timeout;
      s("connect attempt will timeout after %d", S), S === 0 && m.destroy();
      var _ = setTimeout(function() {
        s("connect attempt timed out after %d", S), m.destroy(), h.close(), h.emit("error", "timeout"), g.emitAll("connect_timeout", S);
      }, S);
      this.subs.push({
        destroy: function() {
          clearTimeout(_);
        }
      });
    }
    return this.subs.push(m), this.subs.push(v), this;
  }, d.prototype.onopen = function() {
    s("open"), this.cleanup(), this.readyState = "open", this.emit("open");
    var p = this.engine;
    this.subs.push(o(p, "data", i(this, "ondata"))), this.subs.push(o(p, "ping", i(this, "onping"))), this.subs.push(o(p, "pong", i(this, "onpong"))), this.subs.push(o(p, "error", i(this, "onerror"))), this.subs.push(o(p, "close", i(this, "onclose"))), this.subs.push(o(this.decoder, "decoded", i(this, "ondecoded")));
  }, d.prototype.onping = function() {
    this.lastPing = /* @__PURE__ */ new Date(), this.emitAll("ping");
  }, d.prototype.onpong = function() {
    this.emitAll("pong", /* @__PURE__ */ new Date() - this.lastPing);
  }, d.prototype.ondata = function(p) {
    this.decoder.add(p);
  }, d.prototype.ondecoded = function(p) {
    this.emit("packet", p);
  }, d.prototype.onerror = function(p) {
    s("error", p), this.emitAll("error", p);
  }, d.prototype.socket = function(p, f) {
    var h = this.nsps[p];
    if (!h) {
      h = new t(this, p, f), this.nsps[p] = h;
      var g = this;
      h.on("connecting", m), h.on("connect", function() {
        h.id = g.generateId(p);
      }), this.autoConnect && m();
    }
    function m() {
      ~a(g.connecting, h) || g.connecting.push(h);
    }
    return h;
  }, d.prototype.destroy = function(p) {
    var f = a(this.connecting, p);
    ~f && this.connecting.splice(f, 1), !this.connecting.length && this.close();
  }, d.prototype.packet = function(p) {
    s("writing packet %j", p);
    var f = this;
    p.query && p.type === 0 && (p.nsp += "?" + p.query), f.encoding ? f.packetBuffer.push(p) : (f.encoding = !0, this.encoder.encode(p, function(h) {
      for (var g = 0; g < h.length; g++)
        f.engine.write(h[g], p.options);
      f.encoding = !1, f.processPacketQueue();
    }));
  }, d.prototype.processPacketQueue = function() {
    if (this.packetBuffer.length > 0 && !this.encoding) {
      var p = this.packetBuffer.shift();
      this.packet(p);
    }
  }, d.prototype.cleanup = function() {
    s("cleanup");
    for (var p = this.subs.length, f = 0; f < p; f++) {
      var h = this.subs.shift();
      h.destroy();
    }
    this.packetBuffer = [], this.encoding = !1, this.lastPing = null, this.decoder.destroy();
  }, d.prototype.close = d.prototype.disconnect = function() {
    s("disconnect"), this.skipReconnect = !0, this.reconnecting = !1, this.readyState === "opening" && this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
  }, d.prototype.onclose = function(p) {
    s("onclose"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", p), this._reconnection && !this.skipReconnect && this.reconnect();
  }, d.prototype.reconnect = function() {
    if (this.reconnecting || this.skipReconnect)
      return this;
    var p = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      s("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = !1;
    else {
      var f = this.backoff.duration();
      s("will wait %dms before reconnect attempt", f), this.reconnecting = !0;
      var h = setTimeout(function() {
        p.skipReconnect || (s("attempting reconnect"), p.emitAll("reconnect_attempt", p.backoff.attempts), p.emitAll("reconnecting", p.backoff.attempts), !p.skipReconnect && p.open(function(g) {
          g ? (s("reconnect attempt error"), p.reconnecting = !1, p.reconnect(), p.emitAll("reconnect_error", g.data)) : (s("reconnect success"), p.onreconnect());
        }));
      }, f);
      this.subs.push({
        destroy: function() {
          clearTimeout(h);
        }
      });
    }
  }, d.prototype.onreconnect = function() {
    var p = this.backoff.attempts;
    this.reconnecting = !1, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", p);
  }, lu;
}
var Xg;
function OB() {
  return Xg || (Xg = 1, function(e, t) {
    var n = rB(), r = hp(), o = Yg(), i = yl()("socket.io-client");
    e.exports = t = a;
    var s = t.managers = {};
    function a(u, l) {
      typeof u == "object" && (l = u, u = void 0), l = l || {};
      var d = n(u), p = d.source, f = d.id, h = d.path, g = s[f] && h in s[f].nsps, m = l.forceNew || l["force new connection"] || l.multiplex === !1 || g, v;
      return m ? (i("ignoring socket cache for %s", p), v = o(p, l)) : (s[f] || (i("new io instance for %s", p), s[f] = o(p, l)), v = s[f]), d.query && !l.query && (l.query = d.query), v.socket(d.path, l);
    }
    t.protocol = r.protocol, t.connect = a, t.Manager = Yg(), t.Socket = aC();
  }(Ns, Ns.exports)), Ns.exports;
}
var PB = OB();
const IB = /* @__PURE__ */ Pr(PB);
function NB(e = document.cookie) {
  const t = "XSRF-TOKEN", n = e.match(new RegExp(`(^| )${t}=([^;]+)`));
  return n !== null && n[2] ? n[2] : null;
}
function MB() {
  const e = NB(), t = {};
  return e && (t["X-XSRF-TOKEN"] = e), t;
}
class vp {
  constructor(t, n) {
    /**
      @private */
    I(this, "socket");
    I(this, "isRegistered", !1);
    I(this, "isListening", !1);
    /**
      @private */
    I(this, "onMessageCallback");
    typeof t == "string" ? (this.socket = vp.createNewSocket(t, n), this.subcribeOnSocketReadiness()) : this.socket = t;
  }
  /**
   * Subscribes on socket readiness events
   */
  subcribeOnSocketReadiness() {
    this.socket.on("register", () => {
      this.isRegistered = !0;
    }), this.socket.on("listen", () => {
      this.isListening = !0;
    });
  }
  /**
   * Checks if socket is ready for sending messages or not
   *
   * @returns {boolean} - true - ready
   */
  isReady() {
    return this.isRegistered && this.isListening;
  }
  /**
   * Attach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  on(t, n) {
    this.socket.on(t, n);
  }
  /**
   * Detach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  off(t, n) {
    this.socket.off(t, n);
  }
  /**
   * Send message via socket
   *
   * @param {string} event - message name
   * @param {Array<any>} args - arguments
   * @param {Array<any>} args.0 - message data
   * @returns {void}
   */
  send(t, ...n) {
    const r = n[0];
    this.socket.emit(t, JSON.stringify(r));
  }
  /**
   * Specific message handler
   *
   * @param {string} type - message type
   * @param {string} subType - message subtype (query ID)
   * @param {Function} callback - handler function
   * @returns {Function} - unsubscribe function
   */
  onMessage(t, n, r) {
    this.onMessageCallback = r;
    const o = t || "", i = n || "", s = i ? `${o}-${i}` : o, a = (u) => {
      let l = null;
      try {
        l = JSON.parse(u);
      } catch (d) {
        throw new Error("Error parsing response message");
      }
      r(o, l);
    };
    return this.on(s, a), () => {
      this.off(s, a);
    };
  }
  /**
   * Emulate receiving message from socket
   *
   * @param {string} event - message type
   * @param {any} data - message data
   * @returns {void}
   */
  trigger(t, n) {
    this.onMessageCallback && this.onMessageCallback(t, n);
  }
  static createNewSocket(t, n) {
    const r = IB.connect(t, {
      path: "/gateway",
      transports: ["websocket"],
      reconnection: !0,
      query: n
    });
    return r.on("connect_error", (o) => {
      console.log(`connect_error due to ${o.message}`);
    }), r.on("csrf", () => {
      r.emit("csrf", MB());
    }), r.on("listen", () => {
      r.emit("register", {});
    }), r.on("register", () => {
      r.emit('{"eventName": "_registerEvent", "data": "pivot2"}');
    }), r.on("error", (o) => {
      console.warn(`"SisenseSocket" socket error "${o}"`);
    }), r;
  }
}
const Vs = {
  INCLUDE: [
    "metadata.$.jaql",
    "metadata.$.field",
    "metadata.$.panel",
    "metadata.$.hierarchies",
    "metadata.$.format",
    "metadata.$.disabled",
    "metadata.$.distinctTotals"
  ],
  EXCLUDE: [
    "metadata.$.jaql.title",
    "metadata.$.format.mask",
    "metadata.$.format.width",
    "queryGuid",
    "widget",
    "dashboard",
    "grandTotals.title"
  ]
};
class kB {
  constructor(t) {
    /** Logger instance */
    I(this, "logger");
    /**
     *
     * @private
     *
     * EventEmitter instance
     */
    I(this, "events");
    /**
     * @private
     *
     * jaql request object
     */
    I(this, "jaql");
    /**
     * @private
     *
     * cache object
     */
    I(this, "data");
    /**
     * @private
     *
     * state for "load" method
     */
    I(this, "isLoadInProgress", !1);
    /**
      @private */
    I(this, "loadPromiseResolve");
    /**
     *
     * @private
     */
    I(this, "loadPromiseReject");
    /**
     * @private
     *
     * info about amount of data which already loaded from cache
     */
    I(this, "loadFromCacheState");
    /**
      @private */
    I(this, "loadFromCacheInitialTimer");
    /**
      @private */
    I(this, "loadFromCacheTimer");
    /**
     * @private
     *
     * defines initial pivot data structure
     */
    I(this, "isSingleBranchTree", !1);
    /**
     * @private
     *
     * items count loaded on client side
     */
    I(this, "loadedItemsCount", 0);
    /**
     * @private
     *
     * total items count on back-end side
     */
    I(this, "totalItemsCount", 0);
    /**
     * @private
     *
     * defines if amount of data was limited on back-end or not
     */
    I(this, "isLimited", !1);
    /**
     * @private
     *
     * detects if finish event was received
     */
    I(this, "isFinishEventReceived", !1);
    this.events = t || new zi(), this.logger = ar.create("AbstractDataLoadService");
  }
  /**
   * Destroys data load service
   *
   * @returns {void}
   */
  destroy() {
    this.data = void 0, this.events.removeAllListeners();
  }
  /**
   * Return copy of load service
   *
   * @returns {DataLoadService} - cloned instance
   */
  clone() {
    const t = this.logger.getName();
    throw new Error(`"${t}.clone" should be overridden in subclass`);
  }
  /**
   * Start data loading according to JAQL request
   *
   * @param {JaqlRequest} jaql - JAQL request
   * @returns {Promise<any>} - whole data loading promise
   */
  load(t) {
    if (!t)
      throw new Error(`${this.logger.getName()} "jaql" is not defined for "load" method`);
    const n = !!this.data, r = this.jaql;
    this.jaql = t, n && r && (this.jaql.queryGuid = r.queryGuid), this.isLoadInProgress = !0;
    const o = new Promise((i, s) => {
      this.loadPromiseResolve = i, this.loadPromiseReject = s;
    });
    this.loadFromCacheInitialTimer && clearTimeout(this.loadFromCacheInitialTimer);
    try {
      n ? this.loadFromCache() : this.loadFromServer();
    } catch (i) {
      this.notifyAboutDataError(i);
    }
    return o;
  }
  /**
   * Clear data cache
   *
   * @returns {void}
   */
  clear() {
    this.data = void 0;
  }
  /**
   * Returns current jaql request object
   *
   * @returns {JaqlRequest} - jaql request object
   */
  getJaql() {
    return this.jaql;
  }
  /**
   * Defines data structure
   *
   * @returns {boolean} - true - single branch tree
   */
  isSingleRowTree() {
    return this.isSingleBranchTree;
  }
  /**
   * Returns total amount items count handled on back-end side
   *
   * @returns {number} - items count
   */
  getTotalItemsCount() {
    return this.totalItemsCount;
  }
  /**
   * Defines if new jaql has only formatting changes or it requires new data loading from server
   *
   * @param {JaqlRequest} jaql - jaql request object
   * @returns {boolean} - true - only formatting changes, can use cached data
   */
  isFormattingChanges(t) {
    const n = It(this.jaql, {
      include: Vs.INCLUDE,
      exclude: Vs.EXCLUDE,
      excludeEmpty: !0
    }), r = It(t, {
      include: Vs.INCLUDE,
      exclude: Vs.EXCLUDE,
      excludeEmpty: !0
    });
    return [...(n == null ? void 0 : n.metadata) || [], ...(r == null ? void 0 : r.metadata) || []].forEach(
      (o) => {
        o && o.panel === Ce.SCOPE && delete o.field;
      }
    ), JSON.stringify(n) === JSON.stringify(r);
  }
  /**
   * Defines if service have some data
   *
   * @returns {boolean} - true - has some data
   */
  hasData() {
    return !!(this.data && this.data[_e.DATA]);
  }
  /**
   * Defines if service have some error
   *
   * @returns {boolean} - true - has some error
   */
  hasError() {
    return this.data ? !!this.data[_e.ERROR] : !1;
  }
  /**
   * Start data loading from the server
   *
   * @returns {void}
   * @private
   */
  loadFromServer() {
    const t = this.logger.getName();
    throw new Error(`"${t}.loadFromServer" should be overridden in subclass`);
  }
  /**
   * Method for canceling the processing of query already sent
   *
   * @returns {Promise<void>} - waiting promise
   */
  cancelQuery() {
    const t = this.logger.getName(), n = new Error(`"${t}.cancelQuery" should be overridden in subclass.`);
    return Promise.reject(n);
  }
  /**
   * Method for detection if cancel query is still needed
   *
   * @returns {boolean} - is cancel query needed
   */
  isCancelQueryNeeded() {
    return !this.isFinishEventReceived;
  }
  /**
   * Start data loading from the cache
   *
   * @returns {Promise<void>} - waiting promise
   * @private
   */
  loadFromCache() {
    return Promise.resolve().then(() => (this.loadFromCacheInitialTimer && clearTimeout(this.loadFromCacheInitialTimer), new Promise((t) => {
      this.loadFromCacheInitialTimer = setTimeout(t);
    }))).then(
      () => new Promise((t) => {
        this.loadFromCacheTimer && clearImmediate(this.loadFromCacheTimer), this.loadFromCacheState = void 0, this.loadMessageFromCache(() => {
          this.loadFromCacheState = void 0, this.loadFromCacheTimer && clearImmediate(this.loadFromCacheTimer), t();
        });
      })
    );
  }
  /**
   * Starts loading data from cache queue
   *
   * @param {Function} onFinish - on finish callback
   * @returns {void}
   * @private
   */
  loadMessageFromCache(t) {
    this.loadFromCacheState = this.loadFromCacheState || {};
    const n = this.loadFromCacheState;
    let r = "", o = 0;
    if (lx.forEach((i) => {
      if (r)
        return;
      n[i] = n[i] || 0, n[i] < ((this.data || {})[i] || []).length && (r = i, o = n[i]);
    }), r) {
      const i = ((this.data || {})[r] || [])[o];
      this.notifyAboutDataChunk(r || "", i, !0), n[r] = o + 1, this.loadMessageFromCache(t);
    } else
      t && t();
  }
  /**
   * Cache appropriate message
   *
   * @param {string} type - message type
   * @param {any} data - message payload
   * @returns {void}
   * @private
   */
  cacheData(t, n) {
    this.data = this.data || {};
    const r = this.data;
    r && (r[t] = r[t] || [], r[t].push(n || !0));
  }
  /*
   *
   * @private
   */
  /**
   * Notify outside about data chunk with saving to inner cache, applying chunk formatting with
   * saving initial messages queue
   *
   * @param {string} type - data chunk type
   * @param {any} chunk - data chunk data
   * @param {boolean} isFromCache - mark data which already was cached
   * @returns {void}
   * @private
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  notifyAboutDataChunk(t, n, r = !1) {
    this.logger.log("notifyAboutDataChunk", t, n, r);
    const o = n && n.data && t === _e.DATA ? n.data : n;
    if (r || this.cacheData(t, n), !r && this.loadFromCacheState)
      return;
    t === _e.METADATA && (this.isSingleBranchTree = !!(o && o.isSingleBranchTree)), t === _e.ERROR && this.notifyAboutDataError(o), t === _e.DATA_FINISH && (this.loadedItemsCount = o ? o.rowsCount : 0, this.notifyAboutDataLoaded(this.data)), t === _e.TOTAL_ROWS && (this.totalItemsCount = o ? o.rowsCount : 0, this.totalItemsCount !== this.loadedItemsCount && (this.isLimited = !0)), t === _e.FINISH && (this.isFinishEventReceived = !0);
    const i = It(o);
    this.events.emit(t, i);
  }
  /**
   * Resolve "load" method with appropriate data information
   *
   * @param {any} data - data to resolve with
   * @returns {void}
   * @private
   */
  notifyAboutDataLoaded(t) {
    this.isLoadInProgress && (this.isLoadInProgress = !1, typeof this.loadPromiseResolve == "function" && (this.loadPromiseResolve(t), this.logger.log("notifyAboutDataLoaded")), this.loadPromiseReject = void 0, this.loadPromiseResolve = void 0);
  }
  /**
   * Reject "load" method with appropriate data information
   *
   * @param {any} data - data to reject with
   * @returns {void}
   * @private
   */
  notifyAboutDataError(t) {
    this.isLoadInProgress && (this.isLoadInProgress = !1, typeof this.loadPromiseReject == "function" && (this.loadPromiseReject(t), this.logger.log("notifyAboutDataError")), this.loadPromiseReject = void 0, this.loadPromiseResolve = void 0);
  }
  /**
   * Subscribe to event notification
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   * @returns {void}
   */
  on(t, n) {
    this.events.on(t, n);
  }
  /**
   * Unsubscribe from event notification
   *
   * @param {string} eventName - event name to unsubscribe
   * @param {Function} callback - event handler
   * @returns {void}
   */
  off(t, n) {
    this.events.removeListener(t, n);
  }
  /**
   * Unsubscribe from all event notifications
   *
   * @param {string} eventName - event name to unsubscribe
   * @returns {void}
   */
  offAll(t) {
    this.events.removeAllListeners(t);
  }
  listenerCount(t) {
    return this.events.listenerCount(t);
  }
  /**
   * Trigger event notification
   *
   * @param {string} eventName - event name to subscribe
   * @param {Array<any>} rest - arguments will be passed to event handler
   * @returns {void}
   */
  emit(t, ...n) {
    this.events.emit(t, ...n);
  }
}
class bp extends kB {
  constructor(n, r, o) {
    super(r);
    /**
     * @private
     *
     * Active WebSocket connection instance
     */
    I(this, "socket");
    /**
     * @private
     *
     * WebSocket initialization delay promise
     */
    I(this, "initPromise");
    /**
     *
     * @private
     *
     * WebSocket initialization ready flag
     */
    I(this, "isInitInProgress", !1);
    /**
     *
     * @private
     *
     * onMessage remove listeners callback
     */
    I(this, "onMessageCancel");
    I(this, "onSocketError", (n) => {
      this.emit("error", {
        error: !0,
        type: 500,
        details: `Socket error: ${n.message}`
      });
    });
    I(this, "onSocketDisconnect", () => {
      this.emit("error", {
        error: !0,
        type: 500,
        details: "Socket disconnected"
      });
    });
    if (this.logger = o || ar.create("DataLoadService"), !n)
      throw new Error(`${this.logger.getName()} "socket" not defined.`);
    this.socket = n, this.socket.on("error", this.onSocketError), this.socket.on("disconnect", this.onSocketDisconnect), this.on(_e.ERROR, (i) => {
      const s = JSON.stringify(i, null, 4);
      process.env.NODE_ENV !== "production" && this.logger.console.warn(`${this.logger.getName()} error message: 
${s}`);
    });
  }
  destroy() {
    super.destroy(), this.onMessageCancel && (this.onMessageCancel(), this.onMessageCancel = void 0), this.socket.off("error", this.onSocketError), this.socket.off("disconnect", this.onSocketDisconnect);
  }
  /**
   * Return copy of load service
   *
   * @returns {DataLoadService} - cloned instance
   */
  clone() {
    const n = It(this.data);
    n[_e.HEADERS] || (n[_e.HEADERS] = [{}]);
    const r = new bp(this.socket);
    return r.data = n, r.jaql = this.jaql, r.isFinishEventReceived = this.isFinishEventReceived, r.isSingleBranchTree = this.isSingleBranchTree, r.loadedItemsCount = this.loadedItemsCount, r.totalItemsCount = this.totalItemsCount, r.isLimited = this.isLimited, r;
  }
  /**
   * Start data loading from the server
   *
   * @returns {void}
   * @private
   */
  loadFromServer() {
    this.waitForSocketReady().then(() => {
      this.onMessageCancel && this.onMessageCancel(), this.onMessageCancel = this.socket.onMessage(void 0, void 0, (n, r) => {
        this.logger.log("handleMessage", n, r), this.notifyAboutDataChunk(n, r);
      }), this.socket.send("pivot", this.jaql);
    });
  }
  /**
   * Method for canceling the processing of query already sent
   *
   * @returns {Promise<void>} - waiting promise
   */
  cancelQuery() {
    return this.isCancelQueryNeeded() ? this.waitForSocketReady().then(() => {
      this.socket.send("pivot/cancel-query", {
        // eslint-disable-next-line promise/always-return
        queryGuid: this.jaql && this.jaql.queryGuid
      });
    }) : Promise.resolve();
  }
  /**
   *  Wait for socket connection
   *
   * @returns {Promise<void>} - wait promise
   * @private
   */
  waitForSocketReady() {
    return this.socket.isReady() ? Promise.resolve() : this.isInitInProgress && this.initPromise ? this.initPromise : (this.isInitInProgress = !0, this.initPromise = new Promise((n, r) => {
      this.socket.on("open", () => {
        this.socket && this.socket.isReady() ? n() : r(new Error("Can not open WebSocket connection"));
      });
    }), this.initPromise);
  }
}
let Us;
const AB = new Uint8Array(16);
function $B() {
  if (!Us && (Us = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Us))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Us(AB);
}
const vt = [];
for (let e = 0; e < 256; ++e)
  vt.push((e + 256).toString(16).slice(1));
function LB(e, t = 0) {
  return vt[e[t + 0]] + vt[e[t + 1]] + vt[e[t + 2]] + vt[e[t + 3]] + "-" + vt[e[t + 4]] + vt[e[t + 5]] + "-" + vt[e[t + 6]] + vt[e[t + 7]] + "-" + vt[e[t + 8]] + vt[e[t + 9]] + "-" + vt[e[t + 10]] + vt[e[t + 11]] + vt[e[t + 12]] + vt[e[t + 13]] + vt[e[t + 14]] + vt[e[t + 15]];
}
const DB = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Jg = {
  randomUUID: DB
};
function BB(e, t, n) {
  if (Jg.randomUUID && !t && !e)
    return Jg.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || $B)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let o = 0; o < 16; ++o)
      t[n + o] = r[o];
    return t;
  }
  return LB(r);
}
class lC extends bp {
  constructor(n, r, o = {}) {
    super(n, r);
    /**
     * @private
     */
    I(this, "options");
    /**
     * @private
     */
    I(this, "registrationWaitTimer");
    /**
     * @private
     *
     * onMessage remove listeners callback
     */
    I(this, "onMessageCancels", []);
    this.options = o, this.logger = ar.create("SisenseDataLoadService");
  }
  destroy() {
    super.destroy(), this.onMessageCancels.length && (this.onMessageCancels.forEach((n) => {
      n && n();
    }), this.onMessageCancels.length = 0);
  }
  /**
   * Start data loading from the server
   *
   * @returns {void}
   * @private
   */
  loadFromServer() {
    this.waitForSocketReady().then(() => {
      const n = C({
        queryGuid: BB()
      }, this.jaql), { queryGuid: r } = n;
      this.onMessageCancels.length && (this.onMessageCancels.forEach((o) => {
        o && o();
      }), this.onMessageCancels.length = 0), Object.values(_e).forEach((o) => {
        const i = this.socket.onMessage(o, r, (s, a) => {
          this.logger.log("handleMessage", s, a), this.notifyAboutDataChunk(s, a);
        });
        this.onMessageCancels.push(i);
      }), this.socket.send("pivot", n);
    });
  }
  /**
   * Wait for socket connection and registration
   *
   * @returns {Promise<*>} - wait promise
   * @private
   */
  waitForSocketReady() {
    return this.socket.isReady() ? Promise.resolve() : new Promise((n) => {
      const { socketRegisterCheckInterval: r = 100 } = this.options;
      this.registrationWaitTimer && clearInterval(this.registrationWaitTimer);
      const o = () => {
        this.socket.isReady() && (clearInterval(this.registrationWaitTimer), n());
      };
      this.registrationWaitTimer = setInterval(o, r);
    });
  }
}
const FB = {
  errors: {
    measure: {
      unsupportedType: "Unsupported measure type",
      dimensionalCalculatedMeasure: {
        noContext: "DimensionalCalculatedMeasure must have 'context' property"
      },
      dimensionalBaseMeasure: {
        noAttributeDimExpression: "DimensionalBaseMeasure must have 'attribute'/'dim'/'expression' property",
        noAggAggregation: "DimensionalBaseMeasure must have 'agg' or 'aggregation' property"
      },
      notAFormula: "Jaql is not a formula"
    },
    dataModelConfig: {
      noName: "'name' must be specified in config for DataModel",
      noMetadata: "'metadata' must be specified in config for DataModel"
    },
    filter: {
      unsupportedType: "Unsupported filter type: {{filterType}}",
      unsupportedDatetimeLevel: 'Filters do not support the next "datetime" levels: Hours, MinutesRoundTo30, MinutesRoundTo15, Minutes, Seconds',
      membersFilterNullMember: "MembersFilter of {{attributeId}} - member cannot be null",
      unsupportedConditionFilter: "Jaql contains unsupported condition filter: {{filter}}",
      formulaFiltersNotSupported: "Formula-based filter not supported yet: {{filter}}"
    },
    unsupportedDimensionalElement: "Unsupported dimensional element type"
  }
}, zB = {
  errors: {
    measure: {
      unsupportedType: "Непідтримуваний тип measure",
      dimensionalCalculatedMeasure: {
        noContext: "DimensionalCalculatedMeasure має мати властивість 'context'"
      },
      dimensionalBaseMeasure: {
        noAttributeDimExpression: "DimensionalBaseMeasure має мати властивість 'attribute'/'dim'/'expression'",
        noAggAggregation: "DimensionalBaseMeasure має мати властивість 'agg' або 'aggregation'"
      },
      notAFormula: "Jaql не формула"
    },
    dataModelConfig: {
      noName: "'name' має бути вказано в конфігурації для DataModel",
      noMetadata: "'metadata' має бути вказано в конфігурації для DataModel"
    },
    filter: {
      unsupportedType: "Непідтримуваний тип фільтра: {{filterType}}",
      unsupportedDatetimeLevel: 'Фільтри не підтримують наступні рівні "datetime": Hours, MinutesRoundTo30, MinutesRoundTo15, Minutes, Seconds',
      membersFilterNullMember: "MembersFilter у {{attributeId}} - member не може бути нульовим",
      unsupportedConditionFilter: "Jaql містить непідтримуваний condition фільтр: {{filter}}",
      formulaFiltersNotSupported: "Фільтри, що містять формули наразі не підтримуються: {{filter}}"
    },
    unsupportedDimensionalElement: "Непідтримуваний тип елемента"
  }
}, jB = "sdkData", HB = {
  en: FB,
  uk: zB
};
function WB() {
  return cy({
    resource: HB,
    language: "en",
    namespace: jB
  });
}
WB();
var cu;
(function(e) {
  e[e.None = 0] = "None", e[e.Ascending = 1] = "Ascending", e[e.Descending = 2] = "Descending";
})(cu = cu || (cu = {}));
var uu;
(function(e) {
  e.TEXT = "text", e.NUMERIC = "numeric", e.DATETIME = "datetime";
})(uu = uu || (uu = {}));
var du;
(function(e) {
  e.ASC = "asc", e.DESC = "desc";
})(du = du || (du = {}));
var pu;
(function(e) {
  e.PRE = "pre", e.POST = "post";
})(pu = pu || (pu = {}));
function Sd(e, t = []) {
  try {
    return e == null ? String(e) : typeof e == "string" ? `'${QC(e)}'` : typeof e == "number" || typeof e == "boolean" ? String(e) : e instanceof Date ? `new Date('${e.toISOString()}')` : Array.isArray(e) ? `[${e.map((n) => Sd(n, t)).join(", ")}]` : typeof e == "object" && e !== null ? "composeCode" in e ? e.composeCode : `{ ${Object.entries(e).filter(([r]) => !t.includes(r)).map(([r, o]) => `${/[^a-zA-Z0-9_$]/.test(r) ? `'${r}'` : r}: ${Sd(o, t)}`).join(", ")} }` : JSON.stringify(e);
  } catch (n) {
    return console.error(n, JSON.stringify(e, null, 2)), JSON.stringify(e);
  }
}
function VB(e) {
  let t = e.length;
  for (; t > 0 && e[t - 1] === void 0; )
    t--;
  return e.slice(0, t);
}
function UB(e, t) {
  return function(n) {
    return function(...r) {
      const o = VB(r), i = o.length, s = o.map((l) => Sd(l, ["guid"])).filter((l, d) => !(["", "{  }", "{}", "undefined", "null"].includes(l) && d === i - 1)).join(", "), a = `${e}.${t != null ? t : n.name}(${s})`, u = n(...r);
      return u.composeCode = a, u;
    };
  };
}
function Qg(e, t) {
  return UB("filterFactory.logic", t)(e);
}
const wr = (e) => {
  if (Array.isArray(e)) {
    const [t, ...n] = e;
    return n.length === 0 ? wr(t) : {
      operator: "AND",
      left: wr(t),
      right: wr(n)
    };
  }
  return e;
};
var fu;
(function(e) {
  e.and = Qg((t, n) => ({
    operator: "AND",
    left: wr(t),
    right: wr(n)
  }), "and"), e.or = Qg((t, n) => ({
    operator: "OR",
    left: wr(t),
    right: wr(n)
  }), "or");
})(fu = fu || (fu = {}));
var ea;
(function(e) {
  e.INCLUDE_ALL = "INCLUDE_ALL", e.ADVANCED = "ADVANCED", e.INVALID = "INVALID", e.CONDITION = "CONDITION", e.SPECIFIC_ITEMS = "SPECIFIC_ITEMS";
})(ea = ea || (ea = {}));
var ta;
(function(e) {
  e.PERIOD = "PERIOD", e.DATE_RANGE = "DATE_RANGE";
})(ta = ta || (ta = {}));
var na;
(function(e) {
  e.NUMERIC_RANGE = "NUMERIC_RANGE";
})(na = na || (na = {}));
var hu;
(function(e) {
  e.YEARS = "years", e.QUARTERS = "quarters", e.MONTHS = "months", e.WEEKS = "weeks", e.DAYS = "days", e.HOURS = "hours", e.MINUTES = "minutes";
})(hu = hu || (hu = {}));
var mu;
(function(e) {
  e.DATE_TIME = "datetime", e.NUMERIC = "numeric", e.TEXT = "text";
})(mu = mu || (mu = {}));
Object.assign(Object.assign(Object.assign({}, ea), ta), na);
var gu;
(function(e) {
  e.IS = "members", e.IS_NOT = "exclude", e.IS_WITHIN = "isWithin", e.TOP = "top", e.BOTTOM = "bottom", e.AFTER = "after", e.BEFORE = "before", e.STARTS_WITH = "startsWith", e.DOESNT_START_WITH = "doesntStartWith", e.ENDS_WITH = "endsWith", e.DOESNT_END_WITH = "doesntEndWith", e.CONTAINS = "contains", e.DOESNT_CONTAIN = "doesntContain", e.EQUALS = "equals", e.DOESNT_EQUAL = "doesntEqual", e.IS_EMPTY = "isEmpty", e.IS_NOT_EMPTY = "isNotEmpty", e.GREATER_THAN = "fromNotEqual", e.GREATER_THAN_OR_EQUAL = "from", e.LESS_THAN = "toNotEqual", e.LESS_THAN_OR_EQUAL = "to", e.BETWEEN = "between", e.IS_NOT_BETWEEN = "isNotBetween", e.MULTIPLE_CONDITION = "multipleCondition", e.NONE = "none";
})(gu = gu || (gu = {}));
const Zg = {
  table: { columns: [], rows: [] }
};
class qB {
  /**
   * @param socket - socket instance
   */
  constructor(t) {
    /**
     * DataLoadServiceI instance
     */
    I(this, "dataLoadService");
    /**
     * SocketI instance
     */
    I(this, "socket");
    this.socket = t;
  }
  destroy() {
  }
  prepareRequest(t) {
    return Promise.resolve(t);
  }
  prepareLoadService(t, n = !1) {
    return this.dataLoadService && (n || this.dataLoadService.isFormattingChanges(t)) ? this.dataLoadService : new lC(this.socket);
  }
  prepareDataService(t) {
    const n = new Pt(t);
    return {
      loadData: (r, o, i) => {
        if (!n)
          throw new Error('No DataService defined during "prepareDataService"');
        return n.loadData(r, { pageSize: o, isPaginated: i });
      }
    };
  }
  loadInitData(t, n = !0, r = 100, o = !1) {
    return Ol(this, null, function* () {
      const i = n ? r : void 0;
      try {
        const s = yield this.prepareRequest(t);
        this.dataLoadService = this.prepareLoadService(s, o);
        const { loadData: a } = this.prepareDataService(this.dataLoadService), { rowsTreeService: u, columnsTreeService: l, cornerTreeService: d, isLastPage: p } = yield a(
          o ? void 0 : s,
          i,
          n
        );
        return this.transformTreeStructuresToResultData({
          rowsTreeService: u,
          columnsTreeService: l,
          cornerTreeService: d,
          isLastPage: p
        });
      } catch (s) {
        console.error('Error during loading initial page"', s);
      }
      return Zg;
    });
  }
  buildColumnsHelper(t, n, r, o) {
    var s;
    const i = `${r}${r === "" ? "" : " | "}${(s = o.value) == null ? void 0 : s.toString()}`;
    o.children ? o.children.forEach((a) => {
      this.buildColumnsHelper(t, n, i, a);
    }) : n.push({ name: i, type: t });
  }
  /**
   * Transforms Pivot Grid to Columns of Table structure
   *
   * @param columnType - type of column
   * @param grid - pivot grid
   * @returns An array of columns
   */
  transformGridToColumns(t, n) {
    if (!n || n.length === 0)
      return [];
    const r = [];
    return n == null || n[0].forEach((o) => {
      typeof o != "string" && this.buildColumnsHelper(t, r, "", o);
    }), r || [];
  }
  // eslint-disable-next-line sonarjs/cognitive-complexity,max-lines-per-function
  transformTreeStructuresToResultData(t) {
    const { rowsTreeService: n, columnsTreeService: r, cornerTreeService: o } = t;
    if (!n && !r && !o)
      return Zg;
    const i = o ? o.getGrid() : [], s = r ? r.getGrid() : [], a = n ? n.getGrid() : [], u = this.transformGridToColumns("string", i), l = this.transformGridToColumns("number", s), d = [...u, ...l], p = n ? n.extractData(r) : [], f = a.length, h = d.length, g = [];
    let m = 0, v = 0;
    return Array.from(Array(f)).map((S, _) => {
      const R = [];
      Array.from(Array(h)).map((b, y) => {
        var P, N;
        let w;
        if (y < u.length) {
          m = _, v = y;
          try {
            w = a[m][v];
          } catch (M) {
            throw new Error(`Can't find data item for ${m}-${v}`);
          }
        } else {
          m = _, v = y - u.length;
          try {
            w = p[m][v];
          } catch (M) {
            throw new Error(`Can't find data item for ${m}-${v}`);
          }
        }
        let x;
        if (typeof w == "string") {
          const M = w.split("-");
          if (M.length === 2) {
            const A = Number(M[0]), T = Number(M[1]);
            w = a[A][T], x = ((P = w.value) == null ? void 0 : P.toString()) || "";
          } else
            x = "";
        } else
          x = ((N = w.value) == null ? void 0 : N.toString()) || "";
        R.push({ data: x, text: x });
      }), g.push(R);
    }), {
      table: {
        columns: d,
        rows: g
      },
      grids: {
        corner: i,
        rows: a,
        columns: s,
        values: p
      }
    };
  }
}
const GB = {
  errorPrefix: "[request-error]",
  errors: {
    networkError: "Network error. Check browser console for further details.",
    authFailed: "Failed to authenticate.",
    ssoNotEnabled: "SSO is not enabled on target instance, please choose another authentication method.",
    ssoNoLoginUrl: "Can not fetch login URL on target instance. Check SSO settings.",
    passwordAuthFailed: "$t(errorPrefix) Username and password authentication was not successful. Check credentials.",
    tokenAuthFailed: "$t(errorPrefix) Token authentication was not successful. Check credentials.",
    responseError_onlyStatus: "$t(errorPrefix) Status: {{status}}",
    responseError_withStatusText: "$t(errorPrefix) Status: {{status}} - {{statusText}}"
  }
}, KB = {
  errorPrefix: "[request-error]",
  errors: {
    networkError: "Помилка мережі. Можливо ви забули додати свій домен до «CORS Allowed Origins» в панелі адміністратора Sisense -> Security Settings.",
    authFailed: "Автентифікація не вдалася.",
    ssoNotEnabled: "SSO не ввімкнено на цьому сервері, будь ласка, виберіть інший метод аутентифікації",
    ssoNoLoginUrl: "Неможливо отримати loginUrl з сервера. Перевірте налаштування SSO.",
    passwordAuthFailed: "$t(errorPrefix) Помилка автентифікації за допомогою імені користувача та пароля. Перевірте дані для входу.",
    tokenAuthFailed: "$t(errorPrefix) Помилка автентифікації за допомогою токена. Перевірте дані для входу.",
    responseError_onlyStatus: "$t(errorPrefix) Статус: {{status}}",
    responseError_withStatusText: "$t(errorPrefix) Статус: {{status}} - {{statusText}}"
  }
}, YB = "sdkRestClient", XB = {
  en: GB,
  uk: KB
};
function JB() {
  return cy({
    resource: XB,
    language: "en",
    namespace: YB
  });
}
JB();
function QB(e) {
  return e.type === "bearer";
}
function ZB(e) {
  return e.type === "sso";
}
function eF(e) {
  return e.type === "wat";
}
class tF {
  constructor() {
    /** @private */
    I(this, "events");
    /** @private */
    I(this, "ready", !0);
    /** @private */
    I(this, "onMessageCallback");
    this.events = new zi(), this.ready = !0;
  }
  /**
   * Checks if socket is ready for sending messages or not
   *
   * @returns {boolean} - true - ready
   */
  isReady() {
    return this.ready;
  }
  /**
   * Attach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  on(t, n) {
    this.events.on(t, n);
  }
  /**
   * Detach event handler
   *
   * @param {string} event - event name
   * @param {Function} cb - handler function
   * @returns {void}
   */
  off(t, n) {
    this.events.removeListener(t, n);
  }
  /**
   * Send message via socket
   *
   * @param {string} event - message name
   * @param {Array<any>} args - arguments
   * @param {Array<any>} args.0 - message data
   * @returns {void}
   */
  send(t, ...n) {
    const r = t || n;
    this.ready = !!r || !0;
  }
  /**
   * Specific message handler
   *
   * @param {string} type - message type
   * @param {string} subType - message subtype (query ID)
   * @param {Function} callback - handler function
   * @returns {Function} - unsubscribe function
   */
  onMessage(t, n, r) {
    this.onMessageCallback = r;
    const o = () => {
    };
    return this.on("message", o), () => {
      this.off("message", o);
    };
  }
  /**
   * Emulate receiving message from socket
   *
   * @param {string} event - message type
   * @param {any} data - message data
   * @returns {Promise} - waiting promise
   */
  trigger(t, n) {
    return new Promise((r) => {
      setTimeout(() => {
        this.onMessageCallback && this.onMessageCallback(t, n), r();
      }, 10);
    });
  }
}
const nF = "pivot2";
class rF {
  constructor(t, n, r = !1) {
    I(this, "_socket");
    I(this, "_url");
    I(this, "_auth");
    /**
     * Boolean flag to indicate if the socket should be mocked or not (for testing).
     *
     * @internal
     */
    I(this, "_mockSocket");
    this._url = t, this._auth = n, this._mockSocket = r;
  }
  getQueryOptionsSso(t) {
    return {};
  }
  getQueryOptionsBearer(t) {
    const n = t.bearer;
    if (!n)
      throw new Error("Missing bearer token");
    return {
      token: n
    };
  }
  getQueryOptionsWat(t) {
    const n = new Headers();
    t.applyHeaders(n);
    const r = n.get("Authorization"), o = n.get("Initialiser");
    if (!r || !o)
      throw new Error("Missing auth header");
    return {
      authorization: r,
      initialiser: o
    };
  }
  get socket() {
    if (!this._socket) {
      if (this._mockSocket)
        return this._socket = new tF(), this._socket;
      const t = this._auth, n = this._url;
      let r = {};
      QB(t) ? r = this.getQueryOptionsBearer(t) : eF(t) ? r = this.getQueryOptionsWat(t) : ZB(t) && (r = this.getQueryOptionsSso(t)), this._socket = new vp(n + nF, r);
    }
    return this._socket;
  }
}
class gF {
  constructor(t, n, r = !1) {
    /**
     * Builder to create on demand a web socket to the Sisense instance
     * Required by the pivot table service
     */
    I(this, "socketBuilder");
    this.socketBuilder = new rF(ZC(t), n, r);
  }
  queryData(t, n, r, o) {
    return Ol(this, null, function* () {
      return new qB(this.socketBuilder.socket).loadInitData(t, n, r, o);
    });
  }
  prepareDataService() {
    const t = new lC(this.socketBuilder.socket);
    return new Pt(t);
  }
  preparePivotBuilder() {
    const t = this.prepareDataService();
    return new eB(t);
  }
}
export {
  nT as EVENT_DATA_CELL_FORMAT,
  uf as EVENT_HEADER_CELL_FORMAT,
  eg as EVENT_PIVOT_ELEMENT_CHANGE,
  Qm as EVENT_QUERY_END,
  Jm as EVENT_QUERY_START,
  Zm as EVENT_SORTING_SETTINGS_CHANGED,
  Ce as PanelType,
  eB as PivotBuilder,
  gF as PivotClient,
  qB as PivotDataBuilder,
  rF as SocketBuilder,
  et as UserType,
  It as cloneObject,
  ar as debug,
  ut as jaqlProcessor
};
//# sourceMappingURL=index.js.map
(function(){var e;"use strict";try{if(typeof document!="undefined"){var i=document.createElement("style");i.nonce=(e=document.head.querySelector("meta[property=csp-nonce]"))==null?void 0:e.content,i.appendChild(document.createTextNode('.multi-grid{position:relative;display:block;overflow:hidden}.table-grid{position:relative;direction:ltr;will-change:transform;-webkit-overflow-scrolling:touch;background:#fff;user-select:text;-webkit-touch-callout:text;overflow-x:hidden;overflow-y:hidden}.table-grid,.table-grid *{box-sizing:border-box}.table-grid--top.table-grid--left,.table-grid--top.table-grid--right,.table-grid--bottom.table-grid--left,.table-grid--bottom.table-grid--right{position:absolute}.table-grid--top.table-grid--left,.table-grid--top.table-grid--right,.table-grid--bottom.table-grid--left{overflow-x:hidden;overflow-y:hidden}.table-grid__table{position:relative;display:table;table-layout:fixed;border-spacing:0;border-collapse:collapse}.table-grid__tbody{border-style:inherit;border-color:inherit;border-width:inherit;display:table-row-group}.table-grid__colgroup{display:table-column-group}.table-grid__column{display:table-column}.table-grid__row{border-style:inherit;border-color:inherit;border-width:inherit;display:table-row}.table-grid__cell{position:static!important;display:table-cell;vertical-align:top;box-sizing:border-box;white-space:nowrap;font-size:0;line-height:0;max-width:100%;margin:0;padding:0;border:solid 0 black;border-color:inherit;border-top-color:transparent;border-left-color:transparent}.table-grid__cell--row-0{border-top-color:inherit}.table-grid__cell--col-0,.table-grid__cell--columns{border-left-color:inherit}.table-grid__cell--fixed-width{white-space:normal}.table-grid__cell--fixed-width .table-grid__content{text-overflow:ellipsis}.table-grid__cell--fixed-width .table-grid__content__inner{display:inline;margin-right:0}.table-grid__cell-corner{border-style:inherit;border-color:inherit;border-width:inherit;position:relative;top:0;left:0;border-width:0}.table-grid__content{display:inline-block;font-size:15px;line-height:16px;position:relative;z-index:1}.table-grid__content__wrapper{display:inline;position:relative;z-index:1}.table-grid__content__inner{display:inline;position:relative;margin-right:1px;z-index:1}.table-grid__cell-corner{position:relative}.table-grid__cell-anchor{border-width:0;line-height:0;font-size:0;margin:0;padding:0}.table-grid__cell-anchor-content{width:0;height:0;line-height:0;font-size:0;overflow:hidden}.table-grid__cell--sorted .table-grid__content__inner{margin-right:16px}.table-grid__cell--sorted.table-grid__cell--fixed-width .table-grid__content__inner{margin-right:15px}.table-grid__cell--sorted .table-grid__icon--sorted,.table-grid__cell--sorted .table-grid__sorting-settings-icon{z-index:2;top:4px;right:3px;outline:none;display:inline-block;position:absolute;width:16px;height:12px}.table-grid__cell--sorted .table-grid__icon--sorted:after,.table-grid__cell--sorted .table-grid__sorting-settings-icon:after{display:inline-block;position:absolute;left:20%;top:25%;font-size:15px}.table-grid__cell--sorted .table-grid__icon--sorted:hover,.table-grid__cell--sorted .table-grid__sorting-settings-icon:hover{cursor:pointer}.table-grid--data{left:0!important;overflow-x:visible!important;overflow-y:visible!important}.multi-grid--no-fixed-left .table-grid--fixed.table-grid--rows,.multi-grid--no-fixed-left .table-grid--fixed.table-grid--corner,.multi-grid--no-rows .table-grid--fixed.table-grid--rows,.multi-grid--no-columns .table-grid--fixed.table-grid--columns,.multi-grid--no-corner .table-grid--fixed.table-grid--corner{opacity:0;visibility:hidden}.table-grid--fixed{position:absolute;display:block;opacity:0;transition:opacity 0s ease;background:#fff;overflow:hidden;z-index:10}.table-grid--fixed.active{opacity:1}.table-grid--fixed.table-grid--rows{top:0;left:0;bottom:0}.table-grid--fixed.table-grid--columns{top:0;left:0;right:0}.table-grid--fixed.table-grid--corner{top:0;left:0}.sis-scope .sisense-pivot__pagination-panel .MuiTablePagination-root{background-color:initial;overflow:initial}.sis-scope .sisense-pivot__pagination-panel .MuiTablePagination-root .MuiTablePagination-select{background-color:initial}.sis-scope .sisense-pivot__pagination-panel .MuiTablePagination-root .MuiTablePagination-toolbar{min-height:0}.sis-scope .sisense-pivot__pagination-panel{display:block;transition:opacity .3s ease}.sis-scope .sisense-pivot__pagination-panel--hidden{display:none}.sis-scope .sisense-pivot__pagination-panel .sisense-pivot__pagination-panel-list-wrapper,.sis-scope .sisense-pivot__pagination-panel .sisense-pivot__pagination-panel-total-wrapper,.sis-scope .sisense-pivot__pagination-panel .sisense-pivot__pagination-panel-notification{visibility:hidden;opacity:0}.sis-scope .sisense-pivot__pagination-panel-wrapper{display:flex;justify-content:space-between;align-items:center}.sis-scope .sisense-pivot__pagination-panel-list-wrapper{flex:1}.sis-scope .sisense-pivot__pagination-panel-list{display:flex;align-items:center;margin:0;padding:0;list-style:none}.sis-scope .sisense-pivot__pagination-panel-notification{display:flex;align-items:center;overflow:hidden;white-space:nowrap;cursor:pointer}.sis-scope .sisense-pivot__pagination-panel-notification-more{outline:none;margin-left:5px;margin-right:5px}.sis-scope .sisense-pivot__pagination-panel-total-wrapper{display:flex;overflow:hidden;white-space:nowrap;justify-content:flex-end}.sis-scope .sisense-pivot__pagination-panel-rows-count{padding-left:10px;margin-right:10px;border-left:1px solid #d8d8d8;pointer-events:none;overflow:hidden;text-overflow:ellipsis}.sis-scope .sisense-pivot__pagination-panel--showed .sisense-pivot__pagination-panel-list-wrapper,.sis-scope .sisense-pivot__pagination-panel--showed .sisense-pivot__pagination-panel-total-wrapper,.sis-scope .sisense-pivot__pagination-panel--notification-only .sisense-pivot__pagination-panel-notification,.sis-scope .sisense-pivot__pagination-panel--limits-only .sisense-pivot__pagination-panel-total-wrapper{visibility:visible;opacity:1}.sis-scope .sisense-pivot__pagination-panel--limits-only .sisense-pivot__pagination-panel-rows-count{border-left:none}.sis-scope .pivot-scroller,.sis-scope .pivot-scroller__container{height:40px}.sisense-pivot__resize-control{position:absolute;top:0;right:0;width:4px;height:50px;margin-left:-4px;cursor:col-resize;z-index:4}.sisense-pivot__data-bar{position:absolute;top:8px;left:0;width:50%;height:10px;padding:0 8px;opacity:0}.sisense-pivot__data-bar--show{opacity:0;transition:opacity .3s ease}.sisense-pivot__data-bar--show-active{opacity:1}.sisense-pivot__data-bar-inner{position:relative;height:100%;overflow:hidden}.sisense-pivot__data-bar-bar{position:absolute;top:0;height:100%;min-width:8px;background:green}.sisense-pivot{position:relative;height:100%;-webkit-text-size-adjust:none}.sisense-pivot .table-grid__content{overflow:hidden;max-width:100%}.sisense-pivot>.scroll-elem__horizontal-track,.sisense-pivot>.scroll-elem__vertical-track{z-index:5;opacity:0;transition:opacity .3s ease}.sisense-pivot ::-webkit-scrollbar{display:none}.sisense-pivot .scroll-elem__horizontal-track,.sisense-pivot .scroll-elem__vertical-track{opacity:0;transition:opacity .3s ease}.sisense-pivot:hover .scroll-elem__horizontal-track,.sisense-pivot:hover .scroll-elem__vertical-track{opacity:1}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__border-bottom{display:block}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-last:not(.table-grid__cell--sibling-last):not(.table-grid__cell--merged-columns){border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-first.table-grid__cell--level-last:not(.table-grid__cell--merged-columns):not(.table-grid__cell--sibling-last){border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-first.table-grid__cell--level-last.table-grid__cell--user-type-grandTotal{border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--left .table-grid__cell--level-first.table-grid__cell--level-last.table-grid__cell--user-type-grandTotal .table-grid__cell-virtual-border{position:absolute;bottom:100%;left:0;display:block;width:2000px;height:1px;border-style:inherit;border-bottom-color:inherit;border-width:0}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__border-bottom{display:block}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__cell--row-level-last:not(.table-grid__cell--row-sibling-last):not(.table-grid__cell--row-user-type-subTotal):not(.table-grid__cell--col-user-type-subTotal):not(.table-grid__cell--col-user-type-grandTotal){border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__cell--row-user-type-grandTotal{border-bottom-color:transparent}.sisense-pivot--merged-last-level-rows .table-grid--bottom.table-grid--right .table-grid__cell--row-user-type-grandTotal .table-grid__cell-virtual-border{position:absolute;bottom:100%;left:0;display:block;width:2000px;height:1px;border-style:inherit;border-bottom-color:inherit;border-width:0}.sisense-pivot__multi-grid--resize-in-progress{cursor:col-resize}.sisense-pivot__overlay{position:absolute;inset:0;z-index:1000000}@media print{div#root{margin:0!important;padding:0!important}.print-preview div.print-layout{margin:0!important;padding:0!important;background:none}.print-preview.print-layout div.print-layout__page{margin:0!important;padding:0!important;box-shadow:none;page-break-inside:avoid;page-break-after:always}}.print-preview.print-layout.print-layout__with-footer .page-footer{visibility:visible}.print-preview.print-layout .print-layout__page{display:flex;flex-flow:column;padding:0}.print-preview.print-layout .page-footer{flex-shrink:0;display:flex;flex-flow:column;justify-content:center;visibility:hidden;height:16px;clear:both;box-sizing:border-box;padding-top:10px;text-align:center}.print-preview.print-layout .page-footer>span,.print-preview.print-layout .page-footer div{flex-shrink:0;font-size:10px}.print-preview [contenteditable]:empty:before{content:attr(placeholder);display:block}.print-preview .title::-ms-clear{display:none}.print-preview .page-header{overflow:initial;height:40px;flex-shrink:0}.print-preview .page-header.page-header__content--show .page-header__title-container,.print-preview .page-header.page-header__content--show .page-header__header-divider,.print-preview .page-header.page-header__content--show .page-header__title{display:block}.print-preview .page-header .page-header__content,.print-preview .page-header .page-header__title-container,.print-preview .page-header .page-header__header-divider,.print-preview .page-header .page-header__title{display:none}.print-preview .page-header .page-header__content{height:34px;display:flex;flex-flow:row wrap;position:relative;z-index:3}.print-preview .page-header .page-header__content .page-header__title{text-overflow:ellipsis;overflow:hidden;word-wrap:normal;word-break:keep-all;white-space:nowrap;flex-grow:0;flex-shrink:0;order:1;background:rgba(0,0,0,0);border:none;outline:0;cursor:text;margin-right:10px;padding-left:5px;-webkit-user-select:text;user-select:text}.print-preview .page-header .page-header__content.page-header__title-container--focused .page-header__rename-controls{display:block}.print-preview .page-header .page-header__content.page-header__title-container--focused .page-header__editors{display:flex;align-items:center}.print-preview .page-header .page-header__content.page-header__title-container--focused .page-header__title{text-overflow:ellipsis;overflow:hidden;word-wrap:normal;word-break:keep-all;white-space:nowrap;flex-grow:0;flex-shrink:0;order:1;background:rgba(0,0,0,0);border:none;outline:0;cursor:text;margin-right:10px;padding-left:5px;-webkit-user-select:text;user-select:text}.print-preview .page-header .page-header__content .page-header__title-container,.print-preview .page-header .page-header__content .page-header__rename-controls{float:left}.print-preview .page-header .page-header__content .page-header__title-container{text-overflow:ellipsis;overflow:hidden;word-wrap:normal;word-break:keep-all;white-space:nowrap;font-size:16px;height:26px;width:100%;display:flex;flex-flow:row;justify-content:flex-start}.print-preview .page-header .page-header__content .page-header__rename-controls{display:none;flex-basis:32px;flex-grow:0;flex-shrink:0;order:1}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action{float:left;cursor:pointer;vertical-align:middle;width:16px;height:16px}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--ok:after{content:"V";color:#adff2f}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--ok:hover:after{content:"V";color:green}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--cancel:after{content:"X";color:orchid}.print-preview .page-header .page-header__content .page-header__rename-controls .page-header__rename-controls__action--cancel:hover:after{content:"X";color:red}.print-preview .page-header .page-header__content .page-header__header-divider{margin-top:6px;bottom:5px;border:1px solid #e5e5e5;position:relative;width:100%}.print-preview .page-header .page-header__content .page-header__editors{padding-left:10px;padding-right:10px;display:none;position:relative;width:275px;height:34px;background-color:#fff;border:solid 1px #e5e5e5}.print-preview .page-header .page-header__content .page-header__editors .page-header__vertical-line{margin-left:10px;border-left:1px solid #e5e5e5;height:16px}.print-preview .page-header .page-header__content .page-header__editors div{background:none;border:none;margin-left:15px}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__left-text,.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__center-text,.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__end-text{width:17px;height:16px}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__left-text:after{content:"L"}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__center-text:after{content:"C"}.print-preview .page-header .page-header__content .page-header__editors .page-header__editors__end-text:after{content:"R"}.sis-scope .sorting-settings-header{flex-shrink:0;background-color:#f4f4f8;width:100%;height:42px;padding:10px 10px 10px 16px;border-top-left-radius:4px;border-top-right-radius:4px;display:flex;flex-direction:row;justify-content:space-between;font-size:15px}.sis-scope .header-text{display:flex;flex-flow:row nowrap;width:calc(100% - 24px)}.sis-scope .header-text__sort-by{font-weight:700;flex-shrink:0}.sis-scope .header-text__hierarchy-container{flex-grow:1;text-overflow:ellipsis;padding:0 .5em;display:inline-block;overflow:hidden;white-space:nowrap;vertical-align:top}.sis-scope .cross-icon{position:relative;top:-2px;color:#5b6372;border-radius:50%;min-width:24px}.sis-scope .cross-icon:hover{cursor:pointer;background-color:#d1d1d7}.sis-scope .direction-selector{margin-top:.2em;margin-left:2.4em;font-weight:400;min-width:152px;width:152px}.sis-scope.direction-selector__menu{background-color:#fff!important}.sis-scope .settings-item+.settings-item{margin-top:.9em}.sis-scope .checkbox-input{display:flex;align-items:center;padding-right:8px}.sis-scope .checkbox-input .wrapper-of-input-highlighted{background-color:#5b63721a;border-radius:50%}.sis-scope .checkbox-input .subtotals-caption{margin-left:.2em}.sis-scope .checkbox-input .custom-checkbox{width:28px;height:28px}.sis-scope .checkbox-input .custom-checkbox__label{cursor:pointer}.sis-scope .checkbox-input .checkbox-input__text-wrapper{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sis-scope .checkbox-input .checkbox-input__label{display:flex;align-items:center;height:28px;cursor:pointer;max-width:calc(100% - 28px)}.sis-scope .simple-sorting-settings{width:200px;box-shadow:0 0 5px #3a435633;border-radius:4px;display:flex;flex-direction:column;background-color:#fff}.sis-scope .simple-sorting-settings .header-text{width:100%}.sis-scope .simple-sorting-settings__actions{padding:10px 0;display:flex;flex-direction:column;align-items:flex-start}.sis-scope .simple-sorting-settings__actions>div{width:100%}.sis-scope .simple-sorting-settings__actions>div>div{width:100%;border-radius:0;padding:5px 16px;margin:0;height:auto;cursor:pointer}.sis-scope .simple-sorting-settings__actions>div>div:hover{background:rgba(91,99,114,.1)}.sis-scope .complex-sorting-settings{box-shadow:0 0 5px #3a435633;border-radius:4px;width:320px;height:100%;display:flex;justify-content:space-between;flex-direction:column;max-height:386px;background-color:#fff}.sis-scope .complex-sorting-settings__body{overflow:auto;flex-grow:1;padding:17px 17px 14px}.sis-scope .complex-sorting-settings__actions{flex-shrink:0;display:flex;align-items:center;justify-content:space-between;padding:8px 16px 14px}.sis-scope .complex-sorting-settings__actions .sp-buttons{margin:0 0 0 auto}.sis-scope .complex-sorting-settings__actions .sp-buttons button{min-width:74px}.sis-scope .complex-sorting-settings__actions .sp-buttons>button:first-child+button{margin-left:10px}.sis-scope .complex-sorting-settings .settings-checkboxes{margin-left:-3px;margin-top:15px}body .prism-widget-preview .sisense-pivot__pagination-panel-wrapper,div#idk .prism-widget-preview .sisense-pivot__pagination-panel-wrapper{padding-bottom:0}body .sisense-pivot__pagination-panel-list-wrapper,body .sisense-pivot__pagination-panel-rows-count,div#idk .sisense-pivot__pagination-panel-list-wrapper,div#idk .sisense-pivot__pagination-panel-rows-count{color:#acacac}body .sisense-pivot__pagination-panel-notification-more,div#idk .sisense-pivot__pagination-panel-notification-more{color:#1faff3}body .sisense-pivot__pagination-panel-notification-more:hover,div#idk .sisense-pivot__pagination-panel-notification-more:hover{cursor:pointer;text-decoration:underline}body .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel-page{margin:0}body .sisense-pivot__pagination-panel-page:hover,div#idk .sisense-pivot__pagination-panel-page:hover{text-decoration:none}body .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page{margin-right:6px}body .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:first-child,div#idk .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:first-child{margin-left:6px}body .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:not(.sisense-pivot__pagination-panel-page--disabled):hover,div#idk .sisense-pivot__pagination-panel-list--number .sisense-pivot__pagination-panel-page:not(.sisense-pivot__pagination-panel-page--disabled):hover{color:#272a34;text-decoration:underline}body .sisense-pivot__pagination-panel-page--active,div#idk .sisense-pivot__pagination-panel-page--active{font-weight:400;color:#272a34}body .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled{opacity:.5}body .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{display:block;width:16px;height:16px;text-indent:20px;overflow:hidden;background-repeat:no-repeat}body .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABSUlEQVR42u2VsYrCQBCGc1pZiYVwYuBAbJLKPQvL7D1EHiRNQgJJwMrOUhBbGzux8Bm0tfVhblZWCMNOdptEjPkgxQfzj0ncXy3rE7B75U7z5TK+cZl3JNwg/Mvv4+nCVnh1YcuZ8XVxGLt+AeM7+MTrYDLvq9yELryovcv+LjKEvfYl/EC42ZIfZz4q8Zbm9f8BHJQznP8V5VpE60T7niHsr1jiLVWu5XvKhvD8N2fmbVVuFBbtEwXCXl1Y/gaeisPYtci+dyhveUuCIOiVeem/dJ7nmyzLjoQbhe9hGNoKry5sweC6OIzdZMEOrmsURX2Va/F9vwu3vIfrIkLY618Ct39QufGSJElGlLc0sv8P4LCc4bCsKNciWifa9wxhr39JmqZLlWuJ43gIz3+D0FblRmHRPlEg7NWF5dd2Kg5j1yL73qG8gfwDYL8rrp3YiQAAAAAASUVORK5CYII=);background-position:0 -32px}body .sisense-pivot__pagination-panel-page--first:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--first:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 0}body .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABSUlEQVR42u2VsYrCQBCGc1pZiYVwYuBAbJLKPQvL7D1EHiRNQgJJwMrOUhBbGzux8Bm0tfVhblZWCMNOdptEjPkgxQfzj0ncXy3rE7B75U7z5TK+cZl3JNwg/Mvv4+nCVnh1YcuZ8XVxGLt+AeM7+MTrYDLvq9yELryovcv+LjKEvfYl/EC42ZIfZz4q8Zbm9f8BHJQznP8V5VpE60T7niHsr1jiLVWu5XvKhvD8N2fmbVVuFBbtEwXCXl1Y/gaeisPYtci+dyhveUuCIOiVeem/dJ7nmyzLjoQbhe9hGNoKry5sweC6OIzdZMEOrmsURX2Va/F9vwu3vIfrIkLY618Ct39QufGSJElGlLc0sv8P4LCc4bCsKNciWifa9wxhr39JmqZLlWuJ43gIz3+D0FblRmHRPlEg7NWF5dd2Kg5j1yL73qG8gfwDYL8rrp3YiQAAAAAASUVORK5CYII=);background-position:0 -48px}body .sisense-pivot__pagination-panel-page--last:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--last:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 -16px}body .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABBklEQVR42mNgGAXEAC4tQ7u94up6iqRrFVTi1zS0P65p4DCBZL28kmoiGgaOJ9UNHTrIcTajpoH9ZTU920py/U2xARR7gfJApE40joKRDpiAqe+JjIalLtkmaBpYeYMMUdCyMCfbEHUtKydNI/vnSvrmNmQboqJrZgkyRFraTJj+BlDkBUoDkfJoHAWjABn4+Phw1dbW7i0pKSG9YklLS+Ovq6s7XlNTM4EczSJAm08CNZPXPgDafBmomfz2AaUGUOwFygORKtE4CkbbB8DE86S8vJz8iqWqqsobZEhFRQX57QOgZidgXngOdAn57YPKykpLkCHZ2dnC9DeAIi9QGoiUR+MIAgDRRntRFUnDLQAAAABJRU5ErkJggg==);background-position:0 -32px}body .sisense-pivot__pagination-panel-page--previous:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--previous:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 0}body .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAABACAYAAAATffeWAAABBklEQVR42mNgGAXEAC4tQ7u94up6iqRrFVTi1zS0P65p4DCBZL28kmoiGgaOJ9UNHTrIcTajpoH9ZTU920py/U2xARR7gfJApE40joKRDpiAqe+JjIalLtkmaBpYeYMMUdCyMCfbEHUtKydNI/vnSvrmNmQboqJrZgkyRFraTJj+BlDkBUoDkfJoHAWjABn4+Phw1dbW7i0pKSG9YklLS+Ovq6s7XlNTM4EczSJAm08CNZPXPgDafBmomfz2AaUGUOwFygORKtE4CkbbB8DE86S8vJz8iqWqqsobZEhFRQX57QOgZidgXngOdAn57YPKykpLkCHZ2dnC9DeAIi9QGoiUR+MIAgDRRntRFUnDLQAAAABJRU5ErkJggg==);background-position:0 -48px}body .sisense-pivot__pagination-panel-page--next:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel-page--next:not(.sisense-pivot__pagination-panel-page--disabled):hover .sisense-pivot__pagination-panel-button{background-position:0 -16px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-wrapper,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-wrapper{padding:8px 0}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:last-child .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:last-child .sisense-pivot__pagination-panel-page{margin-left:10px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:first-child .sisense-pivot__pagination-panel-page,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-list-wrapper:first-child .sisense-pivot__pagination-panel-page{margin-right:10px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous.sisense-pivot__pagination-panel-page--disabled,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next.sisense-pivot__pagination-panel-page--disabled{opacity:.2}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{text-indent:30px;width:24px;height:24px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 0}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 -24px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 0}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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);background-position:0 -24px}@media only screen and (-webkit-min-device-pixel-ratio: 1.5),only screen and (min--moz-device-pixel-ratio: 1.5),only screen and (min-device-pixel-ratio: 1.5){body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button{background-size:24px 96px}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--first:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--last:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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)}body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,body .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--previous:hover .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next .sisense-pivot__pagination-panel-button,div#idk .sisense-pivot__pagination-panel--mobile .sisense-pivot__pagination-panel-page--next:hover .sisense-pivot__pagination-panel-button{background-image:url(data:image/png;base64,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)}}body .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add{opacity:0;transform:translateY(5px);transition:opacity .3s,transform .3s}body .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add-active,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.bottom.show-add-active{opacity:1;transform:translate(0)}body .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add{opacity:0;transform:translateY(-5px);transition:opacity .3s,transform .3s}body .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add-active,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.top.show-add-active{opacity:1;transform:translate(0)}body .narration-tooltip--pivot2-notification.narration-tooltip.show-remove,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.show-remove{visibility:visible;opacity:1;transition:opacity .3s}body .narration-tooltip--pivot2-notification.narration-tooltip.show-remove-active,div#idk .narration-tooltip--pivot2-notification.narration-tooltip.show-remove-active{opacity:0}body .narration-tooltip--pivot2-notification .narration-tooltip-host,div#idk .narration-tooltip--pivot2-notification .narration-tooltip-host{width:450px}body .narration-tooltip--pivot2-notification .narration-text,div#idk .narration-tooltip--pivot2-notification .narration-text{padding:7px 13px}body .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,body .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon,div#idk .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,div#idk .new-widget-modal .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon{display:none}body .pivot-container,div#idk .pivot-container{position:relative;height:100%;border-style:solid;border-width:8px;border-bottom-width:3px;z-index:1}body .sisense-pivot .table-grid--top.table-grid--left .table-grid__cell--level-first,body .sisense-pivot .table-grid--top.table-grid--right .table-grid__cell--level-first,body .sisense-pivot .table-grid--bottom.table-grid--left .table-grid__cell--level-first,div#idk .sisense-pivot .table-grid--top.table-grid--left .table-grid__cell--level-first,div#idk .sisense-pivot .table-grid--top.table-grid--right .table-grid__cell--level-first,div#idk .sisense-pivot .table-grid--bottom.table-grid--left .table-grid__cell--level-first,body .sisense-pivot .table-grid__cell--corner.table-grid__cell--level-first,body .sisense-pivot .table-grid__cell--columns.table-grid__cell--level-first,body .sisense-pivot .table-grid__cell--rows.table-grid__cell--level-first,div#idk .sisense-pivot .table-grid__cell--corner.table-grid__cell--level-first,div#idk .sisense-pivot .table-grid__cell--columns.table-grid__cell--level-first,div#idk .sisense-pivot .table-grid__cell--rows.table-grid__cell--level-first{font-weight:600}body .sisense-pivot .scroll-elem__horizontal-track,div#idk .sisense-pivot .scroll-elem__horizontal-track{margin-top:2px}body .sisense-pivot .scroll-elem__vertical-track,div#idk .sisense-pivot .scroll-elem__vertical-track{margin-left:2px;z-index:10000}body .sisense-pivot__multi-grid .table-grid,div#idk .sisense-pivot__multi-grid .table-grid{z-index:1}body .sisense-pivot__multi-grid .table-grid__cell,div#idk .sisense-pivot__multi-grid .table-grid__cell{text-align:left;transition:background-color ease .3s;font-weight:400}body .sisense-pivot__multi-grid .table-grid__cell.table-grid__cell--data,div#idk .sisense-pivot__multi-grid .table-grid__cell.table-grid__cell--data{text-align:right}body .sisense-pivot__multi-grid .table-grid__content,div#idk .sisense-pivot__multi-grid .table-grid__content{font-size:13px;line-height:normal;padding:3px 8px 4px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__content,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__content{padding-right:25px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon{display:block}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after,body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after{display:block;top:0;left:0;background-repeat:no-repeat;background-position:center}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted{top:4px;right:7px;width:16px;height:16px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__icon--sorted:after{width:16px;height:16px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon{top:1px;right:1px;width:22px;height:22px}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:hover{background-color:#f2f2f2;border-radius:50%}body .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted .table-grid__sorting-settings-icon:after{width:20px;height:20px;top:1px;left:1px}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent .table-grid__sorting-settings-icon{background-color:#f2f2f2;border-radius:50%}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--asc .table-grid__sorting-settings-icon:after,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--desc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--asc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--default-sorted--desc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOSA3SDVWOEgxOVY3WiIgZmlsbD0iIzVCNjM3MiIvPg0KPHBhdGggZD0iTTE3IDEwSDdWMTFIMTdWMTBaIiBmaWxsPSIjNUI2MzcyIi8+DQo8cGF0aCBkPSJNOSAxM0gxNVYxNEg5VjEzWiIgZmlsbD0iIzVCNjM3MiIvPg0KPHBhdGggZD0iTTEzIDE2SDExVjE3SDEzVjE2WiIgZmlsbD0iIzVCNjM3MiIvPg0KPC9zdmc+DQo=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAABVVVVgYHVaY3NYYHBbYnFbZHJcZHJbY3JbY3L///8+n+SvAAAACXRSTlMAAxgfIEZrwN7K99ocAAAAAWJLR0QKaND0VgAAADFJREFUGNNjYKApmAkBhJSZO3DCVTF3tiAkNDIzFOAcUU5WAYRZnMgGoHNmYpehHgAAbUUKxkfTjB4AAAAASUVORK5CYII=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sort-icon-persistent.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAABVVVVgYHVYYHBbYnFbY3FbZHJcZHJbY3JbY3JbY3L///8jVOI/AAAACnRSTlMAAxggRmprwN7fVBJwpAAAAAFiS0dECx/XxMAAAAAySURBVBjTY2CgKVgFAYSUcTEgqeJClUHlwFWJcLEIwCU0siIV4BzmrskMCBvNDWjiMQDhxAw5ye8LaQAAAABJRU5ErkJggg==)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc:hover .table-grid__sorting-settings-icon:after,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc:hover .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc:hover .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc:hover .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOSA3SDVWOEgxOVY3WiIgZmlsbD0iIzVCNjM3MiIvPg0KPHBhdGggZD0iTTE3IDEwSDdWMTFIMTdWMTBaIiBmaWxsPSIjNUI2MzcyIi8+DQo8cGF0aCBkPSJNOSAxM0gxNVYxNEg5VjEzWiIgZmlsbD0iIzVCNjM3MiIvPg0KPHBhdGggZD0iTTEzIDE2SDExVjE3SDEzVjE2WiIgZmlsbD0iIzVCNjM3MiIvPg0KPC9zdmc+DQo=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAABVVVVgYHVaY3NYYHBbYnFbZHJcZHJbY3JbY3L///8+n+SvAAAACXRSTlMAAxgfIEZrwN7K99ocAAAAAWJLR0QKaND0VgAAADFJREFUGNNjYKApmAkBhJSZO3DCVTF3tiAkNDIzFOAcUU5WAYRZnMgGoHNmYpehHgAAbUUKxkfTjB4AAAAASUVORK5CYII=)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc .table-grid__sorting-settings-icon:after{content:"";background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAABVVVVgYHVYYHBbYnFbY3FbZHJcZHJbY3JbY3JbY3L///8jVOI/AAAACnRSTlMAAxggRmprwN7fVBJwpAAAAAFiS0dECx/XxMAAAAAySURBVBjTY2CgKVgFAYSUcTEgqeJClUHlwFWJcLEIwCU0siIV4BzmrskMCBvNDWjiMQDhxAw5ye8LaQAAAABJRU5ErkJggg==)}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--default-sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon{display:none}body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,body .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--asc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__icon--sorted:hover,div#idk .sisense-pivot__multi-grid .table-grid__cell--sorted.table-grid__cell--sorted--desc.table-grid__cell--sorted-inactive .table-grid__sorting-settings-icon:hover{background-color:inherit;border-radius:inherit;pointer-events:none}body .sisense-pivot__multi-grid .table-grid__cell--user-type-measureTop,div#idk .sisense-pivot__multi-grid .table-grid__cell--user-type-measureTop{text-align:center}@supports (-ms-ime-align: auto){body .sisense-pivot__multi-grid .scroll-elem>div:first-child,div#idk .sisense-pivot__multi-grid .scroll-elem>div:first-child{overflow:auto!important}}body .sisense-pivot__multi-grid .sisense-pivot__data-bar,div#idk .sisense-pivot__multi-grid .sisense-pivot__data-bar{padding:0 8px}body .sisense-pivot__multi-grid .sisense-pivot__data-bar-bar,div#idk .sisense-pivot__multi-grid .sisense-pivot__data-bar-bar{background:#34cee6}body .sisense-css-module .pivot-container,div#idk .sisense-css-module .pivot-container{overflow:hidden}body .sisense-css-module .pivot-container ::-webkit-scrollbar,div#idk .sisense-css-module .pivot-container ::-webkit-scrollbar{width:initial;height:initial}body .print-layout .table-grid__cell--sorted .table-grid__cell-corner,div#idk .print-layout .table-grid__cell--sorted .table-grid__cell-corner{display:none}body .print-layout .sisense-pivot--sorting-by-subtotals .table-grid__cell--sorted .table-grid__cell-corner,div#idk .print-layout .sisense-pivot--sorting-by-subtotals .table-grid__cell--sorted .table-grid__cell-corner{display:block}body .print-layout .table-grid__cell--sorted .table-grid__content,div#idk .print-layout .table-grid__cell--sorted .table-grid__content{padding:2px 8px 3px}body .print-layout .table-grid__content__wrapper,div#idk .print-layout .table-grid__content__wrapper{overflow:hidden;width:100%;text-overflow:ellipsis;position:relative;display:block;min-width:8px}body .widget-to-image .scroll-elem__horizontal-track,body .widget-to-image .scroll-elem__vertical-track,div#idk .widget-to-image .scroll-elem__horizontal-track,div#idk .widget-to-image .scroll-elem__vertical-track{display:none}body .widget-to-image .table-grid__content__wrapper,div#idk .widget-to-image .table-grid__content__wrapper{text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical}.subtotals-menu__host{width:254px;height:346px;background-color:#fff;border-radius:4px;box-shadow:0 0 5px #3a435633}.subtotals-menu__host .menu-item-host .menu-content{width:100%;max-width:100%;min-width:100%;border:none;box-shadow:none}.subtotals-menu__host .menu-item-host .menu-content .menu-item{width:100%;max-width:100%;min-width:100%;margin:1px 0;height:auto;min-height:29px}.subtotals-menu__host .menu-item-host .menu-content .menu-item .mi-icon{margin-left:12px}.subtotals-menu__host .menu-item-host .menu-content .menu-item .mi-caption__auto{margin-left:16px}.subtotals-menu__host .menu-item-host .menu-content .menu-item .menu-item-container{flex-flow:row wrap}.subtotals-menu__host .menu-item-host .menu-content .menu-item .break{flex-basis:100%;width:0px;height:0px;overflow:hidden}.subtotals-menu__host .menu-item-host .menu-content .menu-item.mi-separator{min-height:1px;margin:6px 0}.subtotals-menu__host .menu-item-host .menu-content .menu-item .mi-checker{margin:0 15px 0 0}.subtotals-menu__host .subtotals-menu__item-distinct{display:flex;justify-content:space-between;margin:7px 15px 7px 21px}.subtotals-menu__header{display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:42px;background-color:#f4f4f8;border-radius:4px 4px 0 0;font-size:13px;font-weight:600;padding:12px 13px 12px 16px;line-height:18px;margin-bottom:7px}.subtotals-menu__header-tooltip .info{margin-left:0}.subtotals-menu__header-tooltip .info:hover{background-color:#dee1e7;border-radius:50%}.subtotals-menu__actions{margin-top:6px;padding:16px;display:flex;justify-content:flex-end;border-top:1px solid #edeef1}.subtotals-menu__actions button.btn{margin-left:8px}.totals-tooltip-host{width:433px;height:200px}.totals-tooltip__container{font-size:13px;margin:4px 8px;line-height:19px}:export{loginDarkColor:#2c3342;darkBtnHoverColor:#f4f4f8;greyHoverColor:#dee1e7;defaultBackgroundColor:#fff}:where(.sis-scope) html,:where(.sis-scope) body,:where(.sis-scope) applet,:where(.sis-scope) object,:where(.sis-scope) iframe,:where(.sis-scope) h1,:where(.sis-scope) h2,:where(.sis-scope) h3,:where(.sis-scope) h4,:where(.sis-scope) h5,:where(.sis-scope) h6,:where(.sis-scope) p,:where(.sis-scope) blockquote,:where(.sis-scope) pre,:where(.sis-scope) a,:where(.sis-scope) abbr,:where(.sis-scope) acronym,:where(.sis-scope) address,:where(.sis-scope) big,:where(.sis-scope) cite,:where(.sis-scope) code,:where(.sis-scope) del,:where(.sis-scope) dfn,:where(.sis-scope) em,:where(.sis-scope) img,:where(.sis-scope) ins,:where(.sis-scope) kbd,:where(.sis-scope) q,:where(.sis-scope) s,:where(.sis-scope) samp,:where(.sis-scope) small,:where(.sis-scope) strike,:where(.sis-scope) strong,:where(.sis-scope) sub,:where(.sis-scope) sup,:where(.sis-scope) tt,:where(.sis-scope) var,:where(.sis-scope) b,:where(.sis-scope) u,:where(.sis-scope) i,:where(.sis-scope) center,:where(.sis-scope) dl,:where(.sis-scope) dt,:where(.sis-scope) dd,:where(.sis-scope) ol,:where(.sis-scope) ul,:where(.sis-scope) li,:where(.sis-scope) fieldset,:where(.sis-scope) form,:where(.sis-scope) label,:where(.sis-scope) legend,:where(.sis-scope) table,:where(.sis-scope) caption,:where(.sis-scope) article,:where(.sis-scope) aside,:where(.sis-scope) canvas,:where(.sis-scope) details,:where(.sis-scope) embed,:where(.sis-scope) figure,:where(.sis-scope) figcaption,:where(.sis-scope) footer,:where(.sis-scope) header,:where(.sis-scope) hgroup,:where(.sis-scope) menu,:where(.sis-scope) nav,:where(.sis-scope) output,:where(.sis-scope) ruby,:where(.sis-scope) section,:where(.sis-scope) summary,:where(.sis-scope) time,:where(.sis-scope) mark,:where(.sis-scope) audio,:where(.sis-scope) video{margin:0;padding:0;vertical-align:baseline;border:0;outline:none}:where(.sis-scope) article,:where(.sis-scope) aside,:where(.sis-scope) details,:where(.sis-scope) figcaption,:where(.sis-scope) figure,:where(.sis-scope) footer,:where(.sis-scope) header,:where(.sis-scope) hgroup,:where(.sis-scope) menu,:where(.sis-scope) nav,:where(.sis-scope) section{display:block}:where(.sis-scope) body{margin:0}:where(.sis-scope) ol,:where(.sis-scope) ul{list-style:none}:where(.sis-scope) blockquote,:where(.sis-scope) q{quotes:none}:where(.sis-scope) blockquote:before,:where(.sis-scope) blockquote:after{content:none}:where(.sis-scope) q:before,:where(.sis-scope) q:after{content:none}:where(.sis-scope) table{border-spacing:0;border-collapse:collapse}:where(.sis-scope) textarea,:where(.sis-scope) select{outline:none}.sis-scope{font-size:13px;line-height:normal;cursor:default;padding:0;margin:0;background:inherit;font-family:Open Sans;color:#5b6372}.sis-scope .btn{background-color:#ffcb05;color:#3a4356}.sis-scope *,.sis-scope *:before,.sis-scope *:after{box-sizing:border-box}.sis-scope ::-webkit-input-placeholder{opacity:1}.sis-scope ::-moz-placeholder{opacity:1}.sis-scope ::-ms-placeholder{opacity:1}.sis-scope ::placeholder{opacity:1}.sis-scope .app-icon{position:relative;display:inline-block;vertical-align:middle;width:24px;height:24px;box-sizing:content-box;text-align:left}.sis-scope .app-icon:after{content:"";position:absolute;top:0;left:0;display:block;width:100%;height:100%}.sis-scope .app-icon__svg{position:relative;display:block;width:100%;height:100%}.sis-scope .app-icon--build-failed .app-icon__svg,.sis-scope .app-icon--build-stopped .app-icon__svg,.sis-scope .app-icon--build-exlamation-mark-error-cancel .app-icon__svg,.sis-scope .app-icon--general-relationship-error .app-icon__svg,.sis-scope .app-icon--placeholder-mark-x .app-icon__svg{fill:#fa5656}.sis-scope .app-icon--placeholder-mark-info .app-icon__svg,.sis-scope .app-icon--build-vi-apply-aprrove .app-icon__svg,.sis-scope .app-icon--general-status-running .app-icon__svg{fill:#35d7be}.sis-scope .app-icon--general-x-sign .app-icon__svg,.sis-scope .app-icon--general-vi-sign .app-icon__svg{fill:transparent}.sis-scope .app-icon--general-status-pending,.sis-scope .app-icon--general-status-running{color:#d1d1d7}.sis-scope .app-icon--general-relationship-tool-tip{width:36px}.sis-scope .app-icon--header-pulse{width:28px}.sis-scope .app-icon--general-update,.sis-scope .app-icon--popup-interval-selected,.sis-scope .app-icon--popup-week-selected,.sis-scope .app-icon--popup-disable-selected{width:50px;height:50px}.sis-scope .app-icon--general-yellow-round-add{width:27px;height:27px}.sis-scope .app-icon--general-sampling-sample-big,.sis-scope .app-icon--general-sampling-top-big,.sis-scope .app-icon--general-sampling-bottom-big{width:35px;height:35px}.sis-scope .app-icon--general-drag-edit-relation,.sis-scope .app-icon--general-drag-new-relation,.sis-scope .app-icon--general-drag{width:36px;height:36px}.sis-scope .app-icon--popup-public-selected{width:49px;height:42px}.sis-scope .app-icon--header-git,.sis-scope .app-icon--general-git-add-branch,.sis-scope .app-icon--header-git .app-icon__svg,.sis-scope .app-icon--general-git-add-branch .app-icon__svg{fill:none}.sis-scope .app-icon--header-git,.sis-scope .app-icon--header-alarm,.sis-scope .app-icon--header-user,.sis-scope .app-icon--header-user-filled{width:30px;height:30px}.sis-scope .app-icon--general-git-add-branch{width:18px;height:18px}.sis-scope .app-icon--popup-lshare-selected,.sis-scope .app-icon--popup-lock-selected,.sis-scope .app-icon--hint-question-mark,.sis-scope .app-icon--hint-x{width:42px;height:42px}.sis-scope .app-icon--resource-guide,.sis-scope .app-icon--resource-help,.sis-scope .app-icon--resource-learn{width:26px;height:37px}.sis-scope .app-icon--schema-arrow-close-left,.sis-scope .app-icon--schema-arrow-close-right,.sis-scope .app-icon--schema-version-history,.sis-scope .app-icon--schema-compass{width:26px;height:26px}.sis-scope .app-icon--wizard-add-folder,.sis-scope .app-icon--wizard-connect,.sis-scope .app-icon--wizard-database,.sis-scope .app-icon--wizard-files,.sis-scope .app-icon--wizard-new-page,.sis-scope .app-icon--wizard-recent,.sis-scope .app-icon--wizard-recent-circle,.sis-scope .app-icon--wizard-rest,.sis-scope .app-icon--wizard-view,.sis-scope .app-icon--wizard-web,.sis-scope .app-icon--wizard-certified{width:35px;height:35px}.sis-scope .app-icon--nodes-delete,.sis-scope .app-icon--nodes-rename,.sis-scope .app-icon--nodes-edit,.sis-scope .app-icon--nodes-more,.sis-scope .app-icon--nodes-preview,.sis-scope .app-icon--nodes-ignored,.sis-scope .app-icon--nodes-accumulated,.sis-scope .app-icon--nodes-accumulated-2{width:37px;height:37px}.sis-scope .app-icon--placeholder-database,.sis-scope .app-icon--placeholder-database-x,.sis-scope .app-icon--placeholder-connection,.sis-scope .app-icon--placeholder-git-graph,.sis-scope .app-icon--placeholder-parameters,.sis-scope .app-icon--placeholder-search-x,.sis-scope .app-icon--placeholder-search,.sis-scope .app-icon--placeholder-table,.sis-scope .app-icon--placeholder-table-x,.sis-scope .app-icon--placeholder-table-init,.sis-scope .app-icon--placeholder-tools,.sis-scope .app-icon--placeholder-preview,.sis-scope .app-icon--placeholder-database-plus-black-white,.sis-scope .app-icon--placeholder-preview-inspect-black-white,.sis-scope .app-icon--placeholder-preview-plus-black-white,.sis-scope .app-icon--placeholder-generate-token,.sis-scope .app-icon--placeholder-key,.sis-scope .app-icon--placeholder-presentation{width:110px;height:110px}.sis-scope .app-icon--placeholder-filter{width:110px;height:130px}.sis-scope .app-icon--placeholder-sheet{width:89px;height:93px}.sis-scope .app-icon--placeholder-mark-info,.sis-scope .app-icon--placeholder-mark-exclamation,.sis-scope .app-icon--placeholder-mark-vi,.sis-scope .app-icon--placeholder-mark-x{width:66px;height:66px}.sis-scope .app-icon--placeholder-place-file,.sis-scope .app-icon--placeholder-place-text-add{width:120px;height:70px}.sis-scope .app-icon--illustration-build-succeeded,.sis-scope .app-icon--illustration-build-failed{width:225px;height:210px}.sis-scope .app-icon--homepages-video,.sis-scope .app-icon--homepages-tutorials,.sis-scope .app-icon--homepages-documentation,.sis-scope .app-icon--homepages-sample{width:65px;height:56px}.sis-scope .app-icon--homepages-play{width:61px;height:61px}.sis-scope .app-icon--widget-area-chart,.sis-scope .app-icon--widget-area-map,.sis-scope .app-icon--widget-bar-chart,.sis-scope .app-icon--widget-box-whisker-plot,.sis-scope .app-icon--widget-calendar-heatmap,.sis-scope .app-icon--widget-column-char,.sis-scope .app-icon--widget-indicator,.sis-scope .app-icon--widget-line-chart,.sis-scope .app-icon--widget-pie-chart,.sis-scope .app-icon--widget-pivot,.sis-scope .app-icon--widget-polar-chart,.sis-scope .app-icon--widget-scatter-chart,.sis-scope .app-icon--widget-scatter-map,.sis-scope .app-icon--widget-sunburst,.sis-scope .app-icon--widget-table,.sis-scope .app-icon--widget-treemap,.sis-scope .app-icon--widget-no-sort{width:26px;height:26px}.sis-scope .app-icon--buildpanel-replace-all,.sis-scope .app-icon--buildpanel-by-table,.sis-scope .app-icon--buildpanel-changes-only{width:64px;height:64px}.sis-scope .app-icon--ai-group-similar-big{width:88px;height:83px}.sis-scope :export{loginDarkColor:#2c3342;darkBtnHoverColor:#f4f4f8;greyHoverColor:#dee1e7;defaultBackgroundColor:#fff}.sis-scope .btn{opacity:1;font-family:inherit;font-style:normal;font-size:13px;line-height:24px;display:inline-block;box-sizing:border-box;margin:0;padding:0;cursor:pointer;transition:all .3s ease;vertical-align:middle;text-decoration:none;border:0;border-radius:4px;outline:none;white-space:nowrap;appearance:none}.sis-scope .btn .btn__icon{display:inline-block;padding-left:9px}.sis-scope .btn .btn__icon+.btn__text{vertical-align:middle;margin-left:-3px;padding-left:0;padding-right:13px;max-width:calc(100% - 24px)}.sis-scope .btn:hover{text-decoration:none;opacity:1}.sis-scope .btn:focus{outline:none}.sis-scope .btn::-moz-focus-inner{border:0}.sis-scope .btn.btn--disabled,.sis-scope .btn[disabled=disabled]{cursor:default;opacity:.4}.sis-scope .btn__text{position:relative;display:inline-block;vertical-align:top;padding:2px 20px;max-width:100%}.sis-scope .btn__icon{display:inline-block;padding:0}.sis-scope .btn--warning,.sis-scope .btn--warning:hover{opacity:1}.sis-scope .btn--warning.btn--disabled,.sis-scope .btn--warning[disabled=disabled]{opacity:.4}.sis-scope .btn--danger{background:#edeef1;opacity:1}.sis-scope .btn--danger:hover{color:#fff;background:#fa5656;opacity:1}.sis-scope .btn--danger.btn--disabled,.sis-scope .btn--danger[disabled=disabled]{color:#5b6372;background:#edeef1;opacity:.6}.sis-scope .btn--transp{color:#9ea2ab;background:none;opacity:1;line-height:1}.sis-scope .btn--transp:hover{background:none;opacity:1}.sis-scope .btn--transp.btn--disabled,.sis-scope .btn--transp[disabled=disabled]{background:none;opacity:.4}.sis-scope .btn--transp .btn__icon{padding-left:0}.sis-scope .btn--transp .btn__text,.sis-scope .btn--transp .btn__icon+.btn__text{padding-left:0;padding-right:0}.sis-scope .btn--gray,.sis-scope .btn--smart,.sis-scope .btn--gray:hover,.sis-scope .btn--smart:hover{opacity:1}.sis-scope .btn--gray.btn--disabled,.sis-scope .btn--gray[disabled=disabled],.sis-scope .btn--smart.btn--disabled,.sis-scope .btn--smart[disabled=disabled]{opacity:.6}.sis-scope .btn--white{background:#fff;opacity:1}.sis-scope .btn--white:hover{background:rgb(242.00006,185.0001725345,0);opacity:1}.sis-scope .btn--white.btn--disabled,.sis-scope .btn--white[disabled=disabled]{background:#fff;opacity:.6}.sis-scope .btn--icon .btn__text{display:none}.sis-scope .btn--icon .btn__icon{padding-left:5px;padding-right:5px}.sis-scope .btn--icon.btn--transp .btn__icon,.sis-scope .btn--icon.btn--dark .btn__icon{padding-left:0;padding-right:0}.sis-scope .btn--limited .btn__text{white-space:normal}.sis-scope .btns-holder{display:flex;align-items:center}.sis-scope .btns-holder>*{margin:0 5px}.sis-scope .btns-holder>*:first-child{margin-left:0}.sis-scope .btns-holder>*:last-child{margin-right:0}.sis-scope .btns-holder .btn--offset-ml{margin-left:15px}.sis-scope .btns-holder .btn:not(.btn--transp)+.btn--transp{margin-left:15px}.sis-scope .btns-holder .btn--transp+.btn:not(.btn--transp){margin-left:15px}.sis-scope .btn-icon-link{display:inline-block;vertical-align:middle;margin:0;padding:0;background:none;border:none;outline:none;font-family:inherit;font-size:inherit;font-weight:inherit;font-style:inherit;color:inherit;cursor:pointer}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn,.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--warning{opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--danger{color:#fff;background:#fa5656;opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--transp{background:none;opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--gray,.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--smart{opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.btn--white{background:rgb(242.00006,185.0001725345,0);opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.confirm-btn{opacity:1}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.confirm-btn.confirm-btn--apply{color:#fff;background:#35d7be;border-color:#35d7be}.sis-scope .btn-icon-link:hover .btn-icon-link__icon.confirm-btn.confirm-btn--cancel{color:#fff;background:#fa5656;border-color:#fa5656}.sis-scope .btn-icon-link.btn-icon-link--disabled,.sis-scope .btn-icon-link[disabled=disabled],.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon{cursor:default}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn,.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--warning,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--warning{opacity:.4}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--danger,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--danger{color:#5b6372;background:#edeef1;opacity:.6}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--transp,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--transp{background:none;opacity:.4}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--gray,.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--smart,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--gray,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--smart{opacity:.6}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.btn--white,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.btn--white{background:#fff;opacity:.6}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.confirm-btn,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.confirm-btn{opacity:.4}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.confirm-btn.confirm-btn--apply,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.confirm-btn.confirm-btn--apply{color:#35d7be;background:rgba(53,215,190,0);border-color:#35d7be}.sis-scope .btn-icon-link.btn-icon-link--disabled .btn-icon-link__icon.confirm-btn.confirm-btn--cancel,.sis-scope .btn-icon-link[disabled=disabled] .btn-icon-link__icon.confirm-btn.confirm-btn--cancel{color:#fa5656;background:rgba(250,86,86,0);border-color:#fa5656}.sis-scope .btn-icon-link__icon{width:28px;margin-right:5px;border-radius:50%}.sis-scope .btn-icon-link__icon .btn__icon{vertical-align:top;padding:1px 0}.sis-scope .btn-icon-link__icon .btn__icon.app-icon--general-plus{padding-left:2px}.sis-scope .btn-icon-link__text{display:inline-block;vertical-align:middle}.sis-scope .btn--more:hover .btn__text{margin-left:-9px}.sis-scope .btn--more:hover .btn__icon{width:10px}.sis-scope .btn--more.btn--danger:hover .btn__icon,.sis-scope .btn--more.btn--danger:hover .btn__icon:before{border-color:#fff}.sis-scope .btn--more.btn--more-open .btn__text{margin-left:-9px}.sis-scope .btn--more.btn--more-open .btn__icon{width:10px}.sis-scope .btn--more .btn__text{position:relative;margin-left:0;padding-right:5px;transition:margin-left .3s linear}.sis-scope .btn--more .btn__icon{position:relative;top:2px;width:1px;height:9px;margin:0 10px 0 0;padding:0;border:solid 1px #3a4356;border-width:1px 0 1px 0;transition:width .3s linear,border-color .3s}.sis-scope .btn--more .btn__icon:before{content:"";position:absolute;left:0;top:3px;width:100%;height:1px;border-bottom:solid 1px #3a4356;transition:border-color .3s}.sis-scope .confirm-btns{display:flex;font-size:0}.sis-scope .confirm-btns .confirm-btn{opacity:1;padding:0;width:17px;height:17px;margin:0 4px;font-size:0;line-height:15px;text-align:center;border:solid 1px transparent;border-radius:50%}.sis-scope .confirm-btns .confirm-btn.confirm-btn--apply{color:#35d7be;background:rgba(53,215,190,0);border-color:#35d7be}.sis-scope .confirm-btns .confirm-btn.confirm-btn--cancel{color:#fa5656;background:rgba(250,86,86,0);border-color:#fa5656}.sis-scope .confirm-btns .confirm-btn:hover{opacity:1}.sis-scope .confirm-btns .confirm-btn:hover.confirm-btn--apply{color:#fff;background:#35d7be;border-color:#35d7be}.sis-scope .confirm-btns .confirm-btn:hover.confirm-btn--cancel{color:#fff;background:#fa5656;border-color:#fa5656}.sis-scope .confirm-btns .confirm-btn.btn--disabled,.sis-scope .confirm-btns .confirm-btn[disabled=disabled]{cursor:default;opacity:.4}.sis-scope .confirm-btns .confirm-btn.btn--disabled.confirm-btn--apply,.sis-scope .confirm-btns .confirm-btn[disabled=disabled].confirm-btn--apply{color:#35d7be;background:rgba(53,215,190,0);border-color:#35d7be}.sis-scope .confirm-btns .confirm-btn.btn--disabled.confirm-btn--cancel,.sis-scope .confirm-btns .confirm-btn[disabled=disabled].confirm-btn--cancel{color:#fa5656;background:rgba(250,86,86,0);border-color:#fa5656}.sis-scope .confirm-btns .confirm-btn .btn__icon{width:9px;height:9px;margin:3px;padding:0}.sis-scope .btn--dark{background:none;color:#5b6372;border-radius:4px;padding:0;transition:unset;line-height:1}.sis-scope .btn--dark .btn__text{padding:0}.sis-scope .btn--dark.btn--icon{display:flex;align-items:center;justify-content:center;height:28px;width:28px;padding:0;border-radius:50%}.sis-scope .btn--dark.btn--icon.btn--small{height:24px;width:24px}.sis-scope .btn--dark:hover{background-color:#f4f4f8;color:inherit}.sis-scope .btn--dark:hover.btn--on-grey{background-color:#dee1e7}.sis-scope .btn--dark:hover.btn--no-hover{background:none}.sis-scope .btn--dark.btn--disabled,.sis-scope .btn--dark[disabled=disabled]{cursor:default;background:none;opacity:.4}')),document.head.appendChild(i)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
